var _defineProperty = require("G:\\Anshu Doc\\OpenGrowth\\gcp\\opengrowth-master-repo-1\\app\\node_modules\\@babel\\runtime/helpers/defineProperty");

var _get = require("G:\\Anshu Doc\\OpenGrowth\\gcp\\opengrowth-master-repo-1\\app\\node_modules\\@babel\\runtime/helpers/get");

var _assertThisInitialized = require("G:\\Anshu Doc\\OpenGrowth\\gcp\\opengrowth-master-repo-1\\app\\node_modules\\@babel\\runtime/helpers/assertThisInitialized");

var _construct = require("G:\\Anshu Doc\\OpenGrowth\\gcp\\opengrowth-master-repo-1\\app\\node_modules\\@babel\\runtime/helpers/construct");

var _regeneratorRuntime = require("G:\\Anshu Doc\\OpenGrowth\\gcp\\opengrowth-master-repo-1\\app\\node_modules\\@babel\\runtime/regenerator");

var _slicedToArray = require("G:\\Anshu Doc\\OpenGrowth\\gcp\\opengrowth-master-repo-1\\app\\node_modules\\@babel\\runtime/helpers/slicedToArray");

var _toConsumableArray = require("G:\\Anshu Doc\\OpenGrowth\\gcp\\opengrowth-master-repo-1\\app\\node_modules\\@babel\\runtime/helpers/toConsumableArray");

var _classCallCheck = require("G:\\Anshu Doc\\OpenGrowth\\gcp\\opengrowth-master-repo-1\\app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("G:\\Anshu Doc\\OpenGrowth\\gcp\\opengrowth-master-repo-1\\app\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("G:\\Anshu Doc\\OpenGrowth\\gcp\\opengrowth-master-repo-1\\app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("G:\\Anshu Doc\\OpenGrowth\\gcp\\opengrowth-master-repo-1\\app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("G:\\Anshu Doc\\OpenGrowth\\gcp\\opengrowth-master-repo-1\\app\\node_modules\\@babel\\runtime/helpers/inherits");

var _wrapNativeSuper = require("G:\\Anshu Doc\\OpenGrowth\\gcp\\opengrowth-master-repo-1\\app\\node_modules\\@babel\\runtime/helpers/wrapNativeSuper");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/*!
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md.
 */
!function (e) {
  var t = e.en = e.en || {};
  t.dictionary = Object.assign(t.dictionary || {}, {
    "%0 of %1": "%0 of %1",
    Aquamarine: "Aquamarine",
    Black: "Black",
    "Block quote": "Block quote",
    Blue: "Blue",
    Bold: "Bold",
    "Break text": "Break text",
    "Bulleted List": "Bulleted List",
    Cancel: "Cancel",
    "Cannot upload file:": "Cannot upload file:",
    "Centered image": "Centered image",
    "Change image text alternative": "Change image text alternative",
    "Choose heading": "Choose heading",
    Column: "Column",
    "Could not insert image at the current position.": "Could not insert image at the current position.",
    "Could not obtain resized image URL.": "Could not obtain resized image URL.",
    "Decrease indent": "Decrease indent",
    "Delete column": "Delete column",
    "Delete row": "Delete row",
    "Dim grey": "Dim grey",
    Downloadable: "Downloadable",
    "Dropdown toolbar": "Dropdown toolbar",
    "Edit block": "Edit block",
    "Edit link": "Edit link",
    "Editor toolbar": "Editor toolbar",
    "Enter image caption": "Enter image caption",
    "Full size image": "Full size image",
    Green: "Green",
    Grey: "Grey",
    "Header column": "Header column",
    "Header row": "Header row",
    Heading: "Heading",
    "Heading 1": "Heading 1",
    "Heading 2": "Heading 2",
    "Heading 3": "Heading 3",
    "Heading 4": "Heading 4",
    "Heading 5": "Heading 5",
    "Heading 6": "Heading 6",
    "Image toolbar": "Image toolbar",
    "image widget": "image widget",
    "In line": "In line",
    "Increase indent": "Increase indent",
    "Insert column left": "Insert column left",
    "Insert column right": "Insert column right",
    "Insert image": "Insert image",
    "Insert image or file": "Insert image or file",
    "Insert media": "Insert media",
    "Insert paragraph after block": "Insert paragraph after block",
    "Insert paragraph before block": "Insert paragraph before block",
    "Insert row above": "Insert row above",
    "Insert row below": "Insert row below",
    "Insert table": "Insert table",
    "Inserting image failed": "Inserting image failed",
    Italic: "Italic",
    "Left aligned image": "Left aligned image",
    "Light blue": "Light blue",
    "Light green": "Light green",
    "Light grey": "Light grey",
    Link: "Link",
    "Link URL": "Link URL",
    "Media URL": "Media URL",
    "media widget": "media widget",
    "Merge cell down": "Merge cell down",
    "Merge cell left": "Merge cell left",
    "Merge cell right": "Merge cell right",
    "Merge cell up": "Merge cell up",
    "Merge cells": "Merge cells",
    Next: "Next",
    "Numbered List": "Numbered List",
    "Open in a new tab": "Open in a new tab",
    "Open link in new tab": "Open link in new tab",
    Orange: "Orange",
    Paragraph: "Paragraph",
    "Paste the media URL in the input.": "Paste the media URL in the input.",
    Previous: "Previous",
    Purple: "Purple",
    Red: "Red",
    Redo: "Redo",
    "Rich Text Editor": "Rich Text Editor",
    "Rich Text Editor, %0": "Rich Text Editor, %0",
    "Right aligned image": "Right aligned image",
    Row: "Row",
    Save: "Save",
    "Select all": "Select all",
    "Select column": "Select column",
    "Select row": "Select row",
    "Selecting resized image failed": "Selecting resized image failed",
    "Show more items": "Show more items",
    "Side image": "Side image",
    Source: "Source",
    "Split cell horizontally": "Split cell horizontally",
    "Split cell vertically": "Split cell vertically",
    "Table toolbar": "Table toolbar",
    "Text alternative": "Text alternative",
    "The URL must not be empty.": "The URL must not be empty.",
    "This link has no URL": "This link has no URL",
    "This media URL is not supported.": "This media URL is not supported.",
    "Tip: Paste the URL into the content to embed faster.": "Tip: Paste the URL into the content to embed faster.",
    "Toggle caption off": "Toggle caption off",
    "Toggle caption on": "Toggle caption on",
    Turquoise: "Turquoise",
    Undo: "Undo",
    Unlink: "Unlink",
    "Upload failed": "Upload failed",
    "Upload in progress": "Upload in progress",
    White: "White",
    "Widget toolbar": "Widget toolbar",
    "Wrap text": "Wrap text",
    Yellow: "Yellow"
  });
}(window.CKEDITOR_TRANSLATIONS || (window.CKEDITOR_TRANSLATIONS = {})), function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.ClassicEditor = t() : e.ClassicEditor = t();
}(window, function () {
  return function (e) {
    var t = {};

    function i(n) {
      if (t[n]) return t[n].exports;
      var o = t[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(o.exports, o, o.exports, i), o.l = !0, o.exports;
    }

    return i.m = e, i.c = t, i.d = function (e, t, n) {
      i.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: n
      });
    }, i.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, i.t = function (e, t) {
      if (1 & t && (e = i(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var n = Object.create(null);
      if (i.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) {
        i.d(n, o, function (t) {
          return e[t];
        }.bind(null, o));
      }
      return n;
    }, i.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return i.d(t, "a", t), t;
    }, i.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, i.p = "", i(i.s = 110);
  }([function (e, t, i) {
    "use strict";

    i.d(t, "a", function () {
      return n;
    }), i.d(t, "b", function () {
      return o;
    });

    var n =
    /*#__PURE__*/
    function (_Error) {
      _inherits(n, _Error);

      function n(e, t, i) {
        var _this;

        _classCallCheck(this, n);

        _this = _possibleConstructorReturn(this, _getPrototypeOf(n).call(this, "".concat(e).concat(i ? " " + JSON.stringify(i) : "").concat(r(e)))), _this.name = "CKEditorError", _this.context = t, _this.data = i;
        return _this;
      }

      _createClass(n, [{
        key: "is",
        value: function is(e) {
          return "CKEditorError" === e;
        }
      }], [{
        key: "rethrowUnexpectedError",
        value: function rethrowUnexpectedError(e, t) {
          if (e.is && e.is("CKEditorError")) throw e;
          var i = new n(e.message, t);
          throw i.stack = e.stack, i;
        }
      }]);

      return n;
    }(_wrapNativeSuper(Error));

    function o(e, t) {
      var _console;

      (_console = console).warn.apply(_console, _toConsumableArray(s(e, t)));
    }

    function r(e) {
      return "\nRead more: https://ckeditor.com/docs/ckeditor5/latest/framework/guides/support/error-codes.html#error-" + e;
    }

    function s(e, t) {
      var i = r(e);
      return t ? [e, t, i] : [e, i];
    }
  }, function (e, t, i) {
    "use strict";

    var n,
        o = function o() {
      return void 0 === n && (n = Boolean(window && document && document.all && !window.atob)), n;
    },
        r = function () {
      var e = {};
      return function (t) {
        if (void 0 === e[t]) {
          var i = document.querySelector(t);
          if (window.HTMLIFrameElement && i instanceof window.HTMLIFrameElement) try {
            i = i.contentDocument.head;
          } catch (e) {
            i = null;
          }
          e[t] = i;
        }

        return e[t];
      };
    }(),
        s = [];

    function a(e) {
      for (var t = -1, i = 0; i < s.length; i++) {
        if (s[i].identifier === e) {
          t = i;
          break;
        }
      }

      return t;
    }

    function c(e, t) {
      for (var i = {}, n = [], o = 0; o < e.length; o++) {
        var r = e[o],
            c = t.base ? r[0] + t.base : r[0],
            l = i[c] || 0,
            d = "".concat(c, " ").concat(l);
        i[c] = l + 1;
        var h = a(d),
            u = {
          css: r[1],
          media: r[2],
          sourceMap: r[3]
        };
        -1 !== h ? (s[h].references++, s[h].updater(u)) : s.push({
          identifier: d,
          updater: p(u, t),
          references: 1
        }), n.push(d);
      }

      return n;
    }

    function l(e) {
      var t = document.createElement("style"),
          n = e.attributes || {};

      if (void 0 === n.nonce) {
        var o = i.nc;
        o && (n.nonce = o);
      }

      if (Object.keys(n).forEach(function (e) {
        t.setAttribute(e, n[e]);
      }), "function" == typeof e.insert) e.insert(t);else {
        var s = r(e.insert || "head");
        if (!s) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
        s.appendChild(t);
      }
      return t;
    }

    var d,
        h = (d = [], function (e, t) {
      return d[e] = t, d.filter(Boolean).join("\n");
    });

    function u(e, t, i, n) {
      var o = i ? "" : n.media ? "@media ".concat(n.media, " {").concat(n.css, "}") : n.css;
      if (e.styleSheet) e.styleSheet.cssText = h(t, o);else {
        var r = document.createTextNode(o),
            s = e.childNodes;
        s[t] && e.removeChild(s[t]), s.length ? e.insertBefore(r, s[t]) : e.appendChild(r);
      }
    }

    function g(e, t, i) {
      var n = i.css,
          o = i.media,
          r = i.sourceMap;
      if (o ? e.setAttribute("media", o) : e.removeAttribute("media"), r && "undefined" != typeof btoa && (n += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(r)))), " */")), e.styleSheet) e.styleSheet.cssText = n;else {
        for (; e.firstChild;) {
          e.removeChild(e.firstChild);
        }

        e.appendChild(document.createTextNode(n));
      }
    }

    var m = null,
        f = 0;

    function p(e, t) {
      var i, n, o;

      if (t.singleton) {
        var r = f++;
        i = m || (m = l(t)), n = u.bind(null, i, r, !1), o = u.bind(null, i, r, !0);
      } else i = l(t), n = g.bind(null, i, t), o = function o() {
        !function (e) {
          if (null === e.parentNode) return !1;
          e.parentNode.removeChild(e);
        }(i);
      };

      return n(e), function (t) {
        if (t) {
          if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap) return;
          n(e = t);
        } else o();
      };
    }

    e.exports = function (e, t) {
      (t = t || {}).singleton || "boolean" == typeof t.singleton || (t.singleton = o());
      var i = c(e = e || [], t);
      return function (e) {
        if (e = e || [], "[object Array]" === Object.prototype.toString.call(e)) {
          for (var n = 0; n < i.length; n++) {
            var o = a(i[n]);
            s[o].references--;
          }

          for (var r = c(e, t), l = 0; l < i.length; l++) {
            var d = a(i[l]);
            0 === s[d].references && (s[d].updater(), s.splice(d, 1));
          }

          i = r;
        }
      };
    };
  },, function (e, t, i) {
    "use strict";

    var n = i(8),
        o = "object" == typeof self && self && self.Object === Object && self,
        r = n.a || o || Function("return this")();
    t.a = r;
  }, function (e, t, i) {
    "use strict";

    (function (e) {
      var n = i(3),
          o = i(14),
          r = "object" == typeof exports && exports && !exports.nodeType && exports,
          s = r && "object" == typeof e && e && !e.nodeType && e,
          a = s && s.exports === r ? n.a.Buffer : void 0,
          c = (a ? a.isBuffer : void 0) || o.a;
      t.a = c;
    }).call(this, i(10)(e));
  }, function (e, t, i) {
    "use strict";

    (function (e) {
      var n = i(8),
          o = "object" == typeof exports && exports && !exports.nodeType && exports,
          r = o && "object" == typeof e && e && !e.nodeType && e,
          s = r && r.exports === o && n.a.process,
          a = function () {
        try {
          var e = r && r.require && r.require("util").types;

          return e || s && s.binding && s.binding("util");
        } catch (e) {}
      }();

      t.a = a;
    }).call(this, i(10)(e));
  }, function (e, t, i) {
    "use strict";

    (function (e) {
      var t = i(0);
      var n = "object" == typeof window ? window : e;
      if (n.CKEDITOR_VERSION) throw new t.a("ckeditor-duplicated-modules", null);
      n.CKEDITOR_VERSION = "29.0.0";
    }).call(this, i(12));
  }, function (e, t, i) {
    var n = i(1),
        o = i(76);
    "string" == typeof (o = o.__esModule ? o.default : o) && (o = [[e.i, o, ""]]);
    var r = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": !0
      },
      insert: "head",
      singleton: !0
    };
    n(o, r);
    e.exports = o.locals || {};
  }, function (e, t, i) {
    "use strict";

    (function (e) {
      var i = "object" == typeof e && e && e.Object === Object && e;
      t.a = i;
    }).call(this, i(12));
  }, function (e, t, i) {
    "use strict";

    (function (e) {
      var n = i(3),
          o = "object" == typeof exports && exports && !exports.nodeType && exports,
          r = o && "object" == typeof e && e && !e.nodeType && e,
          s = r && r.exports === o ? n.a.Buffer : void 0,
          a = s ? s.allocUnsafe : void 0;

      t.a = function (e, t) {
        if (t) return e.slice();
        var i = e.length,
            n = a ? a(i) : new e.constructor(i);
        return e.copy(n), n;
      };
    }).call(this, i(10)(e));
  }, function (e, t) {
    e.exports = function (e) {
      if (!e.webpackPolyfill) {
        var t = Object.create(e);
        t.children || (t.children = []), Object.defineProperty(t, "loaded", {
          enumerable: !0,
          get: function get() {
            return t.l;
          }
        }), Object.defineProperty(t, "id", {
          enumerable: !0,
          get: function get() {
            return t.i;
          }
        }), Object.defineProperty(t, "exports", {
          enumerable: !0
        }), t.webpackPolyfill = 1;
      }

      return t;
    };
  }, function (e, t, i) {
    var n = i(1),
        o = i(77);
    "string" == typeof (o = o.__esModule ? o.default : o) && (o = [[e.i, o, ""]]);
    var r = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": !0
      },
      insert: "head",
      singleton: !0
    };
    n(o, r);
    e.exports = o.locals || {};
  }, function (e, t) {
    var i;

    i = function () {
      return this;
    }();

    try {
      i = i || new Function("return this")();
    } catch (e) {
      "object" == typeof window && (i = window);
    }

    e.exports = i;
  }, function (e, t, i) {
    var n = i(1),
        o = i(71);
    "string" == typeof (o = o.__esModule ? o.default : o) && (o = [[e.i, o, ""]]);
    var r = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": !0
      },
      insert: "head",
      singleton: !0
    };
    n(o, r);
    e.exports = o.locals || {};
  }, function (e, t, i) {
    "use strict";

    t.a = function () {
      return !1;
    };
  }, function (e, t, i) {
    var n = i(1),
        o = i(16);
    "string" == typeof (o = o.__esModule ? o.default : o) && (o = [[e.i, o, ""]]);
    var r = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": !0
      },
      insert: "head",
      singleton: !0
    };
    n(o, r);
    e.exports = o.locals || {};
  }, function (e, t) {
    e.exports = ".ck-hidden{display:none!important}.ck.ck-reset,.ck.ck-reset_all,.ck.ck-reset_all *{box-sizing:border-box;width:auto;height:auto;position:static}:root{--ck-z-default:1;--ck-z-modal:calc(var(--ck-z-default) + 999)}.ck-transitions-disabled,.ck-transitions-disabled *{transition:none!important}:root{--ck-color-base-foreground:#fafafa;--ck-color-base-background:#fff;--ck-color-base-border:#c4c4c4;--ck-color-base-action:#61b045;--ck-color-base-focus:#6cb5f9;--ck-color-base-text:#333;--ck-color-base-active:#198cf0;--ck-color-base-active-focus:#0e7fe1;--ck-color-base-error:#db3700;--ck-color-focus-border-coordinates:208,79%,51%;--ck-color-focus-border:hsl(var(--ck-color-focus-border-coordinates));--ck-color-focus-outer-shadow:#bcdefb;--ck-color-focus-disabled-shadow:rgba(119,186,248,0.3);--ck-color-focus-error-shadow:rgba(255,64,31,0.3);--ck-color-text:var(--ck-color-base-text);--ck-color-shadow-drop:rgba(0,0,0,0.15);--ck-color-shadow-drop-active:rgba(0,0,0,0.2);--ck-color-shadow-inner:rgba(0,0,0,0.1);--ck-color-button-default-background:transparent;--ck-color-button-default-hover-background:#e6e6e6;--ck-color-button-default-active-background:#d9d9d9;--ck-color-button-default-active-shadow:#bfbfbf;--ck-color-button-default-disabled-background:transparent;--ck-color-button-on-background:#dedede;--ck-color-button-on-hover-background:#c4c4c4;--ck-color-button-on-active-background:#bababa;--ck-color-button-on-active-shadow:#a1a1a1;--ck-color-button-on-disabled-background:#dedede;--ck-color-button-action-background:var(--ck-color-base-action);--ck-color-button-action-hover-background:#579e3d;--ck-color-button-action-active-background:#53973b;--ck-color-button-action-active-shadow:#498433;--ck-color-button-action-disabled-background:#7ec365;--ck-color-button-action-text:var(--ck-color-base-background);--ck-color-button-save:#008a00;--ck-color-button-cancel:#db3700;--ck-color-switch-button-off-background:#b0b0b0;--ck-color-switch-button-off-hover-background:#a3a3a3;--ck-color-switch-button-on-background:var(--ck-color-button-action-background);--ck-color-switch-button-on-hover-background:#579e3d;--ck-color-switch-button-inner-background:var(--ck-color-base-background);--ck-color-switch-button-inner-shadow:rgba(0,0,0,0.1);--ck-color-dropdown-panel-background:var(--ck-color-base-background);--ck-color-dropdown-panel-border:var(--ck-color-base-border);--ck-color-input-background:var(--ck-color-base-background);--ck-color-input-border:#c7c7c7;--ck-color-input-error-border:var(--ck-color-base-error);--ck-color-input-text:var(--ck-color-base-text);--ck-color-input-disabled-background:#f2f2f2;--ck-color-input-disabled-border:#c7c7c7;--ck-color-input-disabled-text:#757575;--ck-color-list-background:var(--ck-color-base-background);--ck-color-list-button-hover-background:var(--ck-color-button-default-hover-background);--ck-color-list-button-on-background:var(--ck-color-base-active);--ck-color-list-button-on-background-focus:var(--ck-color-base-active-focus);--ck-color-list-button-on-text:var(--ck-color-base-background);--ck-color-panel-background:var(--ck-color-base-background);--ck-color-panel-border:var(--ck-color-base-border);--ck-color-toolbar-background:var(--ck-color-base-foreground);--ck-color-toolbar-border:var(--ck-color-base-border);--ck-color-tooltip-background:var(--ck-color-base-text);--ck-color-tooltip-text:var(--ck-color-base-background);--ck-color-engine-placeholder-text:#707070;--ck-color-upload-bar-background:#6cb5f9;--ck-color-link-default:#0000f0;--ck-color-link-selected-background:rgba(31,177,255,0.1);--ck-color-link-fake-selection:rgba(31,177,255,0.3);--ck-disabled-opacity:.5;--ck-focus-outer-shadow-geometry:0 0 0 3px;--ck-focus-outer-shadow:var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-outer-shadow);--ck-focus-disabled-outer-shadow:var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-disabled-shadow);--ck-focus-error-outer-shadow:var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-error-shadow);--ck-focus-ring:1px solid var(--ck-color-focus-border);--ck-font-size-base:13px;--ck-line-height-base:1.84615;--ck-font-face:Helvetica,Arial,Tahoma,Verdana,Sans-Serif;--ck-font-size-tiny:0.7em;--ck-font-size-small:0.75em;--ck-font-size-normal:1em;--ck-font-size-big:1.4em;--ck-font-size-large:1.8em;--ck-ui-component-min-height:2.3em}.ck.ck-reset,.ck.ck-reset_all,.ck.ck-reset_all *{margin:0;padding:0;border:0;background:transparent;text-decoration:none;vertical-align:middle;transition:none;word-wrap:break-word}.ck.ck-reset_all,.ck.ck-reset_all *{border-collapse:collapse;font:normal normal normal var(--ck-font-size-base)/var(--ck-line-height-base) var(--ck-font-face);color:var(--ck-color-text);text-align:left;white-space:nowrap;cursor:auto;float:none}.ck.ck-reset_all .ck-rtl *{text-align:right}.ck.ck-reset_all iframe{vertical-align:inherit}.ck.ck-reset_all textarea{white-space:pre-wrap}.ck.ck-reset_all input[type=password],.ck.ck-reset_all input[type=text],.ck.ck-reset_all textarea{cursor:text}.ck.ck-reset_all input[type=password][disabled],.ck.ck-reset_all input[type=text][disabled],.ck.ck-reset_all textarea[disabled]{cursor:default}.ck.ck-reset_all fieldset{padding:10px;border:2px groove #dfdee3}.ck.ck-reset_all button::-moz-focus-inner{padding:0;border:0}.ck[dir=rtl],.ck[dir=rtl] .ck{text-align:right}:root{--ck-border-radius:2px;--ck-inner-shadow:2px 2px 3px var(--ck-color-shadow-inner) inset;--ck-drop-shadow:0 1px 2px 1px var(--ck-color-shadow-drop);--ck-drop-shadow-active:0 3px 6px 1px var(--ck-color-shadow-drop-active);--ck-spacing-unit:0.6em;--ck-spacing-large:calc(var(--ck-spacing-unit)*1.5);--ck-spacing-standard:var(--ck-spacing-unit);--ck-spacing-medium:calc(var(--ck-spacing-unit)*0.8);--ck-spacing-small:calc(var(--ck-spacing-unit)*0.5);--ck-spacing-tiny:calc(var(--ck-spacing-unit)*0.3);--ck-spacing-extra-tiny:calc(var(--ck-spacing-unit)*0.16)}";
  }, function (e, t, i) {
    var n = i(1),
        o = i(18);
    "string" == typeof (o = o.__esModule ? o.default : o) && (o = [[e.i, o, ""]]);
    var r = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": !0
      },
      insert: "head",
      singleton: !0
    };
    n(o, r);
    e.exports = o.locals || {};
  }, function (e, t) {
    e.exports = ".ck.ck-icon{vertical-align:middle}:root{--ck-icon-size:calc(var(--ck-line-height-base)*var(--ck-font-size-normal))}.ck.ck-icon{width:var(--ck-icon-size);height:var(--ck-icon-size);font-size:.8333350694em;will-change:transform}.ck.ck-icon,.ck.ck-icon *{color:inherit;cursor:inherit}.ck.ck-icon :not([fill]){fill:currentColor}";
  }, function (e, t, i) {
    var n = i(1),
        o = i(20);
    "string" == typeof (o = o.__esModule ? o.default : o) && (o = [[e.i, o, ""]]);
    var r = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": !0
      },
      insert: "head",
      singleton: !0
    };
    n(o, r);
    e.exports = o.locals || {};
  }, function (e, t) {
    e.exports = '.ck.ck-tooltip,.ck.ck-tooltip .ck-tooltip__text:after{position:absolute;pointer-events:none;-webkit-backface-visibility:hidden}.ck.ck-tooltip{visibility:hidden;opacity:0;display:none;z-index:var(--ck-z-modal)}.ck.ck-tooltip .ck-tooltip__text{display:inline-block}.ck.ck-tooltip .ck-tooltip__text:after{content:"";width:0;height:0}:root{--ck-tooltip-arrow-size:5px}.ck.ck-tooltip{left:50%;top:0;transition:opacity .2s ease-in-out .2s}.ck.ck-tooltip .ck-tooltip__text{border-radius:0}.ck-rounded-corners .ck.ck-tooltip .ck-tooltip__text,.ck.ck-tooltip .ck-tooltip__text.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-tooltip .ck-tooltip__text{font-size:.9em;line-height:1.5;color:var(--ck-color-tooltip-text);padding:var(--ck-spacing-small) var(--ck-spacing-medium);background:var(--ck-color-tooltip-background);position:relative;left:-50%}.ck.ck-tooltip .ck-tooltip__text:after{transition:opacity .2s ease-in-out .2s;border-style:solid;left:50%}.ck.ck-tooltip.ck-tooltip_s,.ck.ck-tooltip.ck-tooltip_se,.ck.ck-tooltip.ck-tooltip_sw{bottom:calc(var(--ck-tooltip-arrow-size)*-1);transform:translateY(100%)}.ck.ck-tooltip.ck-tooltip_s .ck-tooltip__text:after,.ck.ck-tooltip.ck-tooltip_se .ck-tooltip__text:after,.ck.ck-tooltip.ck-tooltip_sw .ck-tooltip__text:after{top:calc(var(--ck-tooltip-arrow-size)*-1 + 1px);transform:translateX(-50%);border-left-color:transparent;border-bottom-color:var(--ck-color-tooltip-background);border-right-color:transparent;border-top-color:transparent;border-left-width:var(--ck-tooltip-arrow-size);border-bottom-width:var(--ck-tooltip-arrow-size);border-right-width:var(--ck-tooltip-arrow-size);border-top-width:0}.ck.ck-tooltip.ck-tooltip_sw{right:50%;left:auto}.ck.ck-tooltip.ck-tooltip_sw .ck-tooltip__text{left:auto;right:calc(var(--ck-tooltip-arrow-size)*-2)}.ck.ck-tooltip.ck-tooltip_sw .ck-tooltip__text:after{left:auto;right:0}.ck.ck-tooltip.ck-tooltip_se{left:50%;right:auto}.ck.ck-tooltip.ck-tooltip_se .ck-tooltip__text{right:auto;left:calc(var(--ck-tooltip-arrow-size)*-2)}.ck.ck-tooltip.ck-tooltip_se .ck-tooltip__text:after{right:auto;left:0;transform:translateX(50%)}.ck.ck-tooltip.ck-tooltip_n{top:calc(var(--ck-tooltip-arrow-size)*-1);transform:translateY(-100%)}.ck.ck-tooltip.ck-tooltip_n .ck-tooltip__text:after{bottom:calc(var(--ck-tooltip-arrow-size)*-1);transform:translateX(-50%);border-left-color:transparent;border-bottom-color:transparent;border-right-color:transparent;border-top-color:var(--ck-color-tooltip-background);border-left-width:var(--ck-tooltip-arrow-size);border-bottom-width:0;border-right-width:var(--ck-tooltip-arrow-size);border-top-width:var(--ck-tooltip-arrow-size)}.ck.ck-tooltip.ck-tooltip_e{left:calc(100% + var(--ck-tooltip-arrow-size));top:50%}.ck.ck-tooltip.ck-tooltip_e .ck-tooltip__text{left:0;transform:translateY(-50%)}.ck.ck-tooltip.ck-tooltip_e .ck-tooltip__text:after{left:calc(var(--ck-tooltip-arrow-size)*-1);top:calc(50% - var(--ck-tooltip-arrow-size)*1);border-left-color:transparent;border-bottom-color:transparent;border-right-color:var(--ck-color-tooltip-background);border-top-color:transparent;border-left-width:0;border-bottom-width:var(--ck-tooltip-arrow-size);border-right-width:var(--ck-tooltip-arrow-size);border-top-width:var(--ck-tooltip-arrow-size)}.ck.ck-tooltip.ck-tooltip_w{right:calc(100% + var(--ck-tooltip-arrow-size));left:auto;top:50%}.ck.ck-tooltip.ck-tooltip_w .ck-tooltip__text{left:0;transform:translateY(-50%)}.ck.ck-tooltip.ck-tooltip_w .ck-tooltip__text:after{left:100%;top:calc(50% - var(--ck-tooltip-arrow-size)*1);border-left-color:var(--ck-color-tooltip-background);border-bottom-color:transparent;border-right-color:transparent;border-top-color:transparent;border-left-width:var(--ck-tooltip-arrow-size);border-bottom-width:var(--ck-tooltip-arrow-size);border-right-width:0;border-top-width:var(--ck-tooltip-arrow-size)}';
  }, function (e, t, i) {
    var n = i(1),
        o = i(22);
    "string" == typeof (o = o.__esModule ? o.default : o) && (o = [[e.i, o, ""]]);
    var r = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": !0
      },
      insert: "head",
      singleton: !0
    };
    n(o, r);
    e.exports = o.locals || {};
  }, function (e, t) {
    e.exports = ".ck.ck-button,a.ck.ck-button{-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none}.ck.ck-button .ck-tooltip,a.ck.ck-button .ck-tooltip{display:block}@media (hover:none){.ck.ck-button .ck-tooltip,a.ck.ck-button .ck-tooltip{display:none}}.ck.ck-button,a.ck.ck-button{position:relative;display:inline-flex;align-items:center;justify-content:left}.ck.ck-button .ck-button__label,a.ck.ck-button .ck-button__label{display:none}.ck.ck-button.ck-button_with-text .ck-button__label,a.ck.ck-button.ck-button_with-text .ck-button__label{display:inline-block}.ck.ck-button:not(.ck-button_with-text),a.ck.ck-button:not(.ck-button_with-text){justify-content:center}.ck.ck-button:hover .ck-tooltip,a.ck.ck-button:hover .ck-tooltip{visibility:visible;opacity:1}.ck.ck-button:focus:not(:hover) .ck-tooltip,a.ck.ck-button:focus:not(:hover) .ck-tooltip{display:none}.ck.ck-button,a.ck.ck-button{background:var(--ck-color-button-default-background)}.ck.ck-button:not(.ck-disabled):hover,a.ck.ck-button:not(.ck-disabled):hover{background:var(--ck-color-button-default-hover-background)}.ck.ck-button:not(.ck-disabled):active,a.ck.ck-button:not(.ck-disabled):active{background:var(--ck-color-button-default-active-background);box-shadow:inset 0 2px 2px var(--ck-color-button-default-active-shadow)}.ck.ck-button.ck-disabled,a.ck.ck-button.ck-disabled{background:var(--ck-color-button-default-disabled-background)}.ck.ck-button,a.ck.ck-button{border-radius:0}.ck-rounded-corners .ck.ck-button,.ck-rounded-corners a.ck.ck-button,.ck.ck-button.ck-rounded-corners,a.ck.ck-button.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-button,a.ck.ck-button{white-space:nowrap;cursor:default;vertical-align:middle;padding:var(--ck-spacing-tiny);text-align:center;min-width:var(--ck-ui-component-min-height);min-height:var(--ck-ui-component-min-height);line-height:1;font-size:inherit;border:1px solid transparent;transition:box-shadow .2s ease-in-out,border .2s ease-in-out;-webkit-appearance:none}.ck.ck-button:active,.ck.ck-button:focus,a.ck.ck-button:active,a.ck.ck-button:focus{outline:none;border:var(--ck-focus-ring);box-shadow:var(--ck-focus-outer-shadow),0 0}.ck.ck-button .ck-button__icon use,.ck.ck-button .ck-button__icon use *,a.ck.ck-button .ck-button__icon use,a.ck.ck-button .ck-button__icon use *{color:inherit}.ck.ck-button .ck-button__label,a.ck.ck-button .ck-button__label{font-size:inherit;font-weight:inherit;color:inherit;cursor:inherit;vertical-align:middle}[dir=ltr] .ck.ck-button .ck-button__label,[dir=ltr] a.ck.ck-button .ck-button__label{text-align:left}[dir=rtl] .ck.ck-button .ck-button__label,[dir=rtl] a.ck.ck-button .ck-button__label{text-align:right}.ck.ck-button .ck-button__keystroke,a.ck.ck-button .ck-button__keystroke{color:inherit}[dir=ltr] .ck.ck-button .ck-button__keystroke,[dir=ltr] a.ck.ck-button .ck-button__keystroke{margin-left:var(--ck-spacing-large)}[dir=rtl] .ck.ck-button .ck-button__keystroke,[dir=rtl] a.ck.ck-button .ck-button__keystroke{margin-right:var(--ck-spacing-large)}.ck.ck-button .ck-button__keystroke,a.ck.ck-button .ck-button__keystroke{font-weight:700;opacity:.7}.ck.ck-button.ck-disabled:active,.ck.ck-button.ck-disabled:focus,a.ck.ck-button.ck-disabled:active,a.ck.ck-button.ck-disabled:focus{box-shadow:var(--ck-focus-disabled-outer-shadow),0 0}.ck.ck-button.ck-disabled .ck-button__icon,a.ck.ck-button.ck-disabled .ck-button__icon{opacity:var(--ck-disabled-opacity)}.ck.ck-button.ck-disabled .ck-button__label,a.ck.ck-button.ck-disabled .ck-button__label{opacity:var(--ck-disabled-opacity)}.ck.ck-button.ck-disabled .ck-button__keystroke,a.ck.ck-button.ck-disabled .ck-button__keystroke{opacity:.3}.ck.ck-button.ck-button_with-text,a.ck.ck-button.ck-button_with-text{padding:var(--ck-spacing-tiny) var(--ck-spacing-standard)}[dir=ltr] .ck.ck-button.ck-button_with-text .ck-button__icon,[dir=ltr] a.ck.ck-button.ck-button_with-text .ck-button__icon{margin-left:calc(var(--ck-spacing-small)*-1);margin-right:var(--ck-spacing-small)}[dir=rtl] .ck.ck-button.ck-button_with-text .ck-button__icon,[dir=rtl] a.ck.ck-button.ck-button_with-text .ck-button__icon{margin-right:calc(var(--ck-spacing-small)*-1);margin-left:var(--ck-spacing-small)}.ck.ck-button.ck-button_with-keystroke .ck-button__label,a.ck.ck-button.ck-button_with-keystroke .ck-button__label{flex-grow:1}.ck.ck-button.ck-on,a.ck.ck-button.ck-on{background:var(--ck-color-button-on-background)}.ck.ck-button.ck-on:not(.ck-disabled):hover,a.ck.ck-button.ck-on:not(.ck-disabled):hover{background:var(--ck-color-button-on-hover-background)}.ck.ck-button.ck-on:not(.ck-disabled):active,a.ck.ck-button.ck-on:not(.ck-disabled):active{background:var(--ck-color-button-on-active-background);box-shadow:inset 0 2px 2px var(--ck-color-button-on-active-shadow)}.ck.ck-button.ck-on.ck-disabled,a.ck.ck-button.ck-on.ck-disabled{background:var(--ck-color-button-on-disabled-background)}.ck.ck-button.ck-button-save,a.ck.ck-button.ck-button-save{color:var(--ck-color-button-save)}.ck.ck-button.ck-button-cancel,a.ck.ck-button.ck-button-cancel{color:var(--ck-color-button-cancel)}.ck.ck-button-action,a.ck.ck-button-action{background:var(--ck-color-button-action-background)}.ck.ck-button-action:not(.ck-disabled):hover,a.ck.ck-button-action:not(.ck-disabled):hover{background:var(--ck-color-button-action-hover-background)}.ck.ck-button-action:not(.ck-disabled):active,a.ck.ck-button-action:not(.ck-disabled):active{background:var(--ck-color-button-action-active-background);box-shadow:inset 0 2px 2px var(--ck-color-button-action-active-shadow)}.ck.ck-button-action.ck-disabled,a.ck.ck-button-action.ck-disabled{background:var(--ck-color-button-action-disabled-background)}.ck.ck-button-action,a.ck.ck-button-action{color:var(--ck-color-button-action-text)}.ck.ck-button-bold,a.ck.ck-button-bold{font-weight:700}";
  }, function (e, t, i) {
    var n = i(1),
        o = i(24);
    "string" == typeof (o = o.__esModule ? o.default : o) && (o = [[e.i, o, ""]]);
    var r = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": !0
      },
      insert: "head",
      singleton: !0
    };
    n(o, r);
    e.exports = o.locals || {};
  }, function (e, t) {
    e.exports = ".ck.ck-button.ck-switchbutton .ck-button__toggle,.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner{display:block}:root{--ck-switch-button-toggle-width:2.6153846154em;--ck-switch-button-toggle-inner-size:1.0769230769em;--ck-switch-button-toggle-spacing:1px;--ck-switch-button-translation:calc(var(--ck-switch-button-toggle-width) - var(--ck-switch-button-toggle-inner-size) - var(--ck-switch-button-toggle-spacing)*2)}[dir=ltr] .ck.ck-button.ck-switchbutton .ck-button__label{margin-right:calc(var(--ck-spacing-large)*2)}[dir=rtl] .ck.ck-button.ck-switchbutton .ck-button__label{margin-left:calc(var(--ck-spacing-large)*2)}.ck.ck-button.ck-switchbutton .ck-button__toggle{border-radius:0}.ck-rounded-corners .ck.ck-button.ck-switchbutton .ck-button__toggle,.ck.ck-button.ck-switchbutton .ck-button__toggle.ck-rounded-corners{border-radius:var(--ck-border-radius)}[dir=ltr] .ck.ck-button.ck-switchbutton .ck-button__toggle{margin-left:auto}[dir=rtl] .ck.ck-button.ck-switchbutton .ck-button__toggle{margin-right:auto}.ck.ck-button.ck-switchbutton .ck-button__toggle{transition:background .4s ease;width:var(--ck-switch-button-toggle-width);background:var(--ck-color-switch-button-off-background)}.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner{border-radius:0}.ck-rounded-corners .ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner,.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner.ck-rounded-corners{border-radius:var(--ck-border-radius);border-radius:calc(var(--ck-border-radius)*0.5)}.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner{margin:var(--ck-switch-button-toggle-spacing);width:var(--ck-switch-button-toggle-inner-size);height:var(--ck-switch-button-toggle-inner-size);background:var(--ck-color-switch-button-inner-background);transition:all .3s ease}.ck.ck-button.ck-switchbutton .ck-button__toggle:hover{background:var(--ck-color-switch-button-off-hover-background)}.ck.ck-button.ck-switchbutton .ck-button__toggle:hover .ck-button__toggle__inner{box-shadow:0 0 0 5px var(--ck-color-switch-button-inner-shadow)}.ck.ck-button.ck-switchbutton.ck-disabled .ck-button__toggle{opacity:var(--ck-disabled-opacity)}.ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle{background:var(--ck-color-switch-button-on-background)}.ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle:hover{background:var(--ck-color-switch-button-on-hover-background)}[dir=ltr] .ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle .ck-button__toggle__inner{transform:translateX(var(--ck-switch-button-translation))}[dir=rtl] .ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle .ck-button__toggle__inner{transform:translateX(calc(var(--ck-switch-button-translation)*-1))}";
  }, function (e, t, i) {
    var n = i(1),
        o = i(26);
    "string" == typeof (o = o.__esModule ? o.default : o) && (o = [[e.i, o, ""]]);
    var r = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": !0
      },
      insert: "head",
      singleton: !0
    };
    n(o, r);
    e.exports = o.locals || {};
  }, function (e, t) {
    e.exports = ".ck.ck-color-grid{display:grid}:root{--ck-color-grid-tile-size:24px;--ck-color-color-grid-check-icon:#000}.ck.ck-color-grid{grid-gap:5px;padding:8px}.ck.ck-color-grid__tile{width:var(--ck-color-grid-tile-size);height:var(--ck-color-grid-tile-size);min-width:var(--ck-color-grid-tile-size);min-height:var(--ck-color-grid-tile-size);padding:0;transition:box-shadow .2s ease;border:0}.ck.ck-color-grid__tile.ck-disabled{cursor:unset;transition:unset}.ck.ck-color-grid__tile.ck-color-table__color-tile_bordered{box-shadow:0 0 0 1px var(--ck-color-base-border)}.ck.ck-color-grid__tile .ck.ck-icon{display:none;color:var(--ck-color-color-grid-check-icon)}.ck.ck-color-grid__tile.ck-on{box-shadow:inset 0 0 0 1px var(--ck-color-base-background),0 0 0 2px var(--ck-color-base-text)}.ck.ck-color-grid__tile.ck-on .ck.ck-icon{display:block}.ck.ck-color-grid__tile.ck-on,.ck.ck-color-grid__tile:focus:not(.ck-disabled),.ck.ck-color-grid__tile:hover:not(.ck-disabled){border:0}.ck.ck-color-grid__tile:focus:not(.ck-disabled),.ck.ck-color-grid__tile:hover:not(.ck-disabled){box-shadow:inset 0 0 0 1px var(--ck-color-base-background),0 0 0 2px var(--ck-color-focus-border)}.ck.ck-color-grid__label{padding:0 var(--ck-spacing-standard)}";
  }, function (e, t, i) {
    var n = i(1),
        o = i(28);
    "string" == typeof (o = o.__esModule ? o.default : o) && (o = [[e.i, o, ""]]);
    var r = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": !0
      },
      insert: "head",
      singleton: !0
    };
    n(o, r);
    e.exports = o.locals || {};
  }, function (e, t) {
    e.exports = '.ck.ck-splitbutton{font-size:inherit}.ck.ck-splitbutton .ck-splitbutton__action:focus{z-index:calc(var(--ck-z-default) + 1)}.ck.ck-splitbutton.ck-splitbutton_open>.ck-button .ck-tooltip{display:none}:root{--ck-color-split-button-hover-background:#ebebeb;--ck-color-split-button-hover-border:#b3b3b3}[dir=ltr] .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__action,[dir=ltr] .ck.ck-splitbutton:hover>.ck-splitbutton__action{border-top-right-radius:unset;border-bottom-right-radius:unset}[dir=rtl] .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__action,[dir=rtl] .ck.ck-splitbutton:hover>.ck-splitbutton__action{border-top-left-radius:unset;border-bottom-left-radius:unset}.ck.ck-splitbutton>.ck-splitbutton__arrow{min-width:unset}[dir=ltr] .ck.ck-splitbutton>.ck-splitbutton__arrow{border-top-left-radius:unset;border-bottom-left-radius:unset}[dir=rtl] .ck.ck-splitbutton>.ck-splitbutton__arrow{border-top-right-radius:unset;border-bottom-right-radius:unset}.ck.ck-splitbutton>.ck-splitbutton__arrow svg{width:var(--ck-dropdown-arrow-size)}.ck.ck-splitbutton.ck-splitbutton_open>.ck-button:not(.ck-on):not(.ck-disabled):not(:hover),.ck.ck-splitbutton:hover>.ck-button:not(.ck-on):not(.ck-disabled):not(:hover){background:var(--ck-color-split-button-hover-background)}.ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled):after,.ck.ck-splitbutton:hover>.ck-splitbutton__arrow:not(.ck-disabled):after{content:"";position:absolute;width:1px;height:100%;background-color:var(--ck-color-split-button-hover-border)}[dir=ltr] .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled):after,[dir=ltr] .ck.ck-splitbutton:hover>.ck-splitbutton__arrow:not(.ck-disabled):after{left:-1px}[dir=rtl] .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled):after,[dir=rtl] .ck.ck-splitbutton:hover>.ck-splitbutton__arrow:not(.ck-disabled):after{right:-1px}.ck.ck-splitbutton.ck-splitbutton_open{border-radius:0}.ck-rounded-corners .ck.ck-splitbutton.ck-splitbutton_open,.ck.ck-splitbutton.ck-splitbutton_open.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck-rounded-corners .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__action,.ck.ck-splitbutton.ck-splitbutton_open.ck-rounded-corners>.ck-splitbutton__action{border-bottom-left-radius:0}.ck-rounded-corners .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__arrow,.ck.ck-splitbutton.ck-splitbutton_open.ck-rounded-corners>.ck-splitbutton__arrow{border-bottom-right-radius:0}';
  }, function (e, t, i) {
    var n = i(1),
        o = i(30);
    "string" == typeof (o = o.__esModule ? o.default : o) && (o = [[e.i, o, ""]]);
    var r = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": !0
      },
      insert: "head",
      singleton: !0
    };
    n(o, r);
    e.exports = o.locals || {};
  }, function (e, t) {
    e.exports = ":root{--ck-dropdown-max-width:75vw}.ck.ck-dropdown{display:inline-block;position:relative}.ck.ck-dropdown .ck-dropdown__arrow{pointer-events:none;z-index:var(--ck-z-default)}.ck.ck-dropdown .ck-button.ck-dropdown__button{width:100%}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-on .ck-tooltip{display:none}.ck.ck-dropdown .ck-dropdown__panel{-webkit-backface-visibility:hidden;display:none;z-index:var(--ck-z-modal);max-width:var(--ck-dropdown-max-width);position:absolute}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel-visible{display:inline-block}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_n,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_ne,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nme,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nmw,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nw{bottom:100%}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_s,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_se,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_sme,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_smw,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_sw{top:100%;bottom:auto}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_ne,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_se{left:0}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nw,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_sw{right:0}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_n,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_s{left:50%;transform:translateX(-50%)}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nmw,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_smw{left:75%;transform:translateX(-75%)}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nme,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_sme{left:25%;transform:translateX(-25%)}.ck.ck-toolbar .ck-dropdown__panel{z-index:calc(var(--ck-z-modal) + 1)}:root{--ck-dropdown-arrow-size:calc(var(--ck-icon-size)*0.5)}.ck.ck-dropdown{font-size:inherit}.ck.ck-dropdown .ck-dropdown__arrow{width:var(--ck-dropdown-arrow-size)}[dir=ltr] .ck.ck-dropdown .ck-dropdown__arrow{right:var(--ck-spacing-standard);margin-left:var(--ck-spacing-standard)}[dir=rtl] .ck.ck-dropdown .ck-dropdown__arrow{left:var(--ck-spacing-standard);margin-right:var(--ck-spacing-small)}.ck.ck-dropdown.ck-disabled .ck-dropdown__arrow{opacity:var(--ck-disabled-opacity)}[dir=ltr] .ck.ck-dropdown .ck-button.ck-dropdown__button:not(.ck-button_with-text){padding-left:var(--ck-spacing-small)}[dir=rtl] .ck.ck-dropdown .ck-button.ck-dropdown__button:not(.ck-button_with-text){padding-right:var(--ck-spacing-small)}.ck.ck-dropdown .ck-button.ck-dropdown__button .ck-button__label{width:7em;overflow:hidden;text-overflow:ellipsis}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-disabled .ck-button__label{opacity:var(--ck-disabled-opacity)}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-on{border-bottom-left-radius:0;border-bottom-right-radius:0}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-dropdown__button_label-width_auto .ck-button__label{width:auto}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-off:active,.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-on:active{box-shadow:none}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-off:active:focus,.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-on:active:focus{box-shadow:var(--ck-focus-outer-shadow),0 0}.ck.ck-dropdown__panel{border-radius:0}.ck-rounded-corners .ck.ck-dropdown__panel,.ck.ck-dropdown__panel.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-dropdown__panel{box-shadow:var(--ck-drop-shadow),0 0;background:var(--ck-color-dropdown-panel-background);border:1px solid var(--ck-color-dropdown-panel-border);bottom:0;min-width:100%}.ck.ck-dropdown__panel.ck-dropdown__panel_se{border-top-left-radius:0}.ck.ck-dropdown__panel.ck-dropdown__panel_sw{border-top-right-radius:0}.ck.ck-dropdown__panel.ck-dropdown__panel_ne{border-bottom-left-radius:0}.ck.ck-dropdown__panel.ck-dropdown__panel_nw{border-bottom-right-radius:0}";
  }, function (e, t, i) {
    var n = i(1),
        o = i(32);
    "string" == typeof (o = o.__esModule ? o.default : o) && (o = [[e.i, o, ""]]);
    var r = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": !0
      },
      insert: "head",
      singleton: !0
    };
    n(o, r);
    e.exports = o.locals || {};
  }, function (e, t) {
    e.exports = ".ck.ck-toolbar{-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none;display:flex;flex-flow:row nowrap;align-items:center}.ck.ck-toolbar>.ck-toolbar__items{display:flex;flex-flow:row wrap;align-items:center;flex-grow:1}.ck.ck-toolbar .ck.ck-toolbar__separator{display:inline-block}.ck.ck-toolbar .ck.ck-toolbar__separator:first-child,.ck.ck-toolbar .ck.ck-toolbar__separator:last-child{display:none}.ck.ck-toolbar .ck-toolbar__line-break{flex-basis:100%}.ck.ck-toolbar.ck-toolbar_grouping>.ck-toolbar__items{flex-wrap:nowrap}.ck.ck-toolbar.ck-toolbar_vertical>.ck-toolbar__items{flex-direction:column}.ck.ck-toolbar.ck-toolbar_floating>.ck-toolbar__items{flex-wrap:nowrap}.ck.ck-toolbar>.ck.ck-toolbar__grouped-dropdown>.ck-dropdown__button .ck-dropdown__arrow{display:none}.ck.ck-toolbar{border-radius:0}.ck-rounded-corners .ck.ck-toolbar,.ck.ck-toolbar.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-toolbar{background:var(--ck-color-toolbar-background);padding:0 var(--ck-spacing-small);border:1px solid var(--ck-color-toolbar-border)}.ck.ck-toolbar .ck.ck-toolbar__separator{align-self:stretch;width:1px;min-width:1px;background:var(--ck-color-toolbar-border);margin-top:var(--ck-spacing-small);margin-bottom:var(--ck-spacing-small)}.ck.ck-toolbar .ck-toolbar__line-break{height:0}.ck.ck-toolbar>.ck-toolbar__items>:not(.ck-toolbar__line-break){margin-right:var(--ck-spacing-small)}.ck.ck-toolbar>.ck-toolbar__items:empty+.ck.ck-toolbar__separator{display:none}.ck.ck-toolbar>.ck-toolbar__items>:not(.ck-toolbar__line-break),.ck.ck-toolbar>.ck.ck-toolbar__grouped-dropdown{margin-top:var(--ck-spacing-small);margin-bottom:var(--ck-spacing-small)}.ck.ck-toolbar.ck-toolbar_vertical{padding:0}.ck.ck-toolbar.ck-toolbar_vertical>.ck-toolbar__items>.ck{width:100%;margin:0;border-radius:0;border:0}.ck.ck-toolbar.ck-toolbar_compact{padding:0}.ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>*{margin:0}.ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>:not(:first-child):not(:last-child){border-radius:0}.ck.ck-toolbar>.ck.ck-toolbar__grouped-dropdown>.ck.ck-button.ck-dropdown__button{padding-left:var(--ck-spacing-tiny)}.ck-toolbar-container .ck.ck-toolbar{border:0}.ck.ck-toolbar[dir=rtl]>.ck-toolbar__items>.ck,[dir=rtl] .ck.ck-toolbar>.ck-toolbar__items>.ck{margin-right:0}.ck.ck-toolbar[dir=rtl]:not(.ck-toolbar_compact)>.ck-toolbar__items>.ck,[dir=rtl] .ck.ck-toolbar:not(.ck-toolbar_compact)>.ck-toolbar__items>.ck{margin-left:var(--ck-spacing-small)}.ck.ck-toolbar[dir=rtl]>.ck-toolbar__items>.ck:last-child,[dir=rtl] .ck.ck-toolbar>.ck-toolbar__items>.ck:last-child{margin-left:0}.ck.ck-toolbar[dir=rtl].ck-toolbar_compact>.ck-toolbar__items>.ck:first-child,[dir=rtl] .ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>.ck:first-child{border-top-left-radius:0;border-bottom-left-radius:0}.ck.ck-toolbar[dir=rtl].ck-toolbar_compact>.ck-toolbar__items>.ck:last-child,[dir=rtl] .ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>.ck:last-child{border-top-right-radius:0;border-bottom-right-radius:0}.ck.ck-toolbar[dir=rtl]>.ck.ck-toolbar__separator,[dir=rtl] .ck.ck-toolbar>.ck.ck-toolbar__separator{margin-left:var(--ck-spacing-small)}.ck.ck-toolbar[dir=rtl].ck-toolbar_grouping>.ck-toolbar__items:not(:empty):not(:only-child),[dir=rtl] .ck.ck-toolbar.ck-toolbar_grouping>.ck-toolbar__items:not(:empty):not(:only-child){margin-left:var(--ck-spacing-small)}.ck.ck-toolbar[dir=ltr]>.ck-toolbar__items>.ck:last-child,[dir=ltr] .ck.ck-toolbar>.ck-toolbar__items>.ck:last-child{margin-right:0}.ck.ck-toolbar[dir=ltr].ck-toolbar_compact>.ck-toolbar__items>.ck:first-child,[dir=ltr] .ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>.ck:first-child{border-top-right-radius:0;border-bottom-right-radius:0}.ck.ck-toolbar[dir=ltr].ck-toolbar_compact>.ck-toolbar__items>.ck:last-child,[dir=ltr] .ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>.ck:last-child{border-top-left-radius:0;border-bottom-left-radius:0}.ck.ck-toolbar[dir=ltr]>.ck.ck-toolbar__separator,[dir=ltr] .ck.ck-toolbar>.ck.ck-toolbar__separator{margin-right:var(--ck-spacing-small)}.ck.ck-toolbar[dir=ltr].ck-toolbar_grouping>.ck-toolbar__items:not(:empty):not(:only-child),[dir=ltr] .ck.ck-toolbar.ck-toolbar_grouping>.ck-toolbar__items:not(:empty):not(:only-child){margin-right:var(--ck-spacing-small)}";
  }, function (e, t, i) {
    var n = i(1),
        o = i(34);
    "string" == typeof (o = o.__esModule ? o.default : o) && (o = [[e.i, o, ""]]);
    var r = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": !0
      },
      insert: "head",
      singleton: !0
    };
    n(o, r);
    e.exports = o.locals || {};
  }, function (e, t) {
    e.exports = ".ck.ck-list{-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none;display:flex;flex-direction:column}.ck.ck-list .ck-list__item,.ck.ck-list .ck-list__separator{display:block}.ck.ck-list .ck-list__item>:focus{position:relative;z-index:var(--ck-z-default)}.ck.ck-list{border-radius:0}.ck-rounded-corners .ck.ck-list,.ck.ck-list.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-list{list-style-type:none;background:var(--ck-color-list-background)}.ck.ck-list__item{cursor:default;min-width:12em}.ck.ck-list__item .ck-button{min-height:unset;width:100%;text-align:left;border-radius:0;padding:calc(var(--ck-line-height-base)*0.2*var(--ck-font-size-base)) calc(var(--ck-line-height-base)*0.4*var(--ck-font-size-base))}.ck.ck-list__item .ck-button .ck-button__label{line-height:calc(var(--ck-line-height-base)*1.2*var(--ck-font-size-base))}.ck.ck-list__item .ck-button:active{box-shadow:none}.ck.ck-list__item .ck-button.ck-on{background:var(--ck-color-list-button-on-background);color:var(--ck-color-list-button-on-text)}.ck.ck-list__item .ck-button.ck-on:active{box-shadow:none}.ck.ck-list__item .ck-button.ck-on:hover:not(.ck-disabled){background:var(--ck-color-list-button-on-background-focus)}.ck.ck-list__item .ck-button.ck-on:focus:not(.ck-disabled){border-color:var(--ck-color-base-background)}.ck.ck-list__item .ck-button:hover:not(.ck-disabled){background:var(--ck-color-list-button-hover-background)}.ck.ck-list__item .ck-switchbutton.ck-on{background:var(--ck-color-list-background);color:inherit}.ck.ck-list__item .ck-switchbutton.ck-on:hover:not(.ck-disabled){background:var(--ck-color-list-button-hover-background);color:inherit}.ck.ck-list__separator{height:1px;width:100%;background:var(--ck-color-base-border)}";
  }, function (e, t, i) {
    var n = i(1),
        o = i(36);
    "string" == typeof (o = o.__esModule ? o.default : o) && (o = [[e.i, o, ""]]);
    var r = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": !0
      },
      insert: "head",
      singleton: !0
    };
    n(o, r);
    e.exports = o.locals || {};
  }, function (e, t) {
    e.exports = ":root{--ck-toolbar-dropdown-max-width:60vw}.ck.ck-toolbar-dropdown>.ck-dropdown__panel{width:max-content;max-width:var(--ck-toolbar-dropdown-max-width)}.ck.ck-toolbar-dropdown>.ck-dropdown__panel .ck-button:focus{z-index:calc(var(--ck-z-default) + 1)}.ck.ck-toolbar-dropdown .ck-toolbar{border:0}";
  }, function (e, t, i) {
    var n = i(1),
        o = i(38);
    "string" == typeof (o = o.__esModule ? o.default : o) && (o = [[e.i, o, ""]]);
    var r = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": !0
      },
      insert: "head",
      singleton: !0
    };
    n(o, r);
    e.exports = o.locals || {};
  }, function (e, t) {
    e.exports = ".ck.ck-dropdown .ck-dropdown__panel .ck-list{border-radius:0}.ck-rounded-corners .ck.ck-dropdown .ck-dropdown__panel .ck-list,.ck.ck-dropdown .ck-dropdown__panel .ck-list.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0}.ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:first-child .ck-button{border-radius:0}.ck-rounded-corners .ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:first-child .ck-button,.ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:first-child .ck-button.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0;border-bottom-left-radius:0;border-bottom-right-radius:0}.ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:last-child .ck-button{border-radius:0}.ck-rounded-corners .ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:last-child .ck-button,.ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:last-child .ck-button.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0;border-top-right-radius:0}";
  }, function (e, t, i) {
    var n = i(1),
        o = i(40);
    "string" == typeof (o = o.__esModule ? o.default : o) && (o = [[e.i, o, ""]]);
    var r = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": !0
      },
      insert: "head",
      singleton: !0
    };
    n(o, r);
    e.exports = o.locals || {};
  }, function (e, t) {
    e.exports = ":root{--ck-color-editable-blur-selection:#d9d9d9}.ck.ck-editor__editable:not(.ck-editor__nested-editable){border-radius:0}.ck-rounded-corners .ck.ck-editor__editable:not(.ck-editor__nested-editable),.ck.ck-editor__editable:not(.ck-editor__nested-editable).ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-editor__editable:not(.ck-editor__nested-editable).ck-focused{outline:none;border:var(--ck-focus-ring);box-shadow:var(--ck-inner-shadow),0 0}.ck.ck-editor__editable_inline{overflow:auto;padding:0 var(--ck-spacing-standard);border:1px solid transparent}.ck.ck-editor__editable_inline[dir=ltr]{text-align:left}.ck.ck-editor__editable_inline[dir=rtl]{text-align:right}.ck.ck-editor__editable_inline>:first-child{margin-top:var(--ck-spacing-large)}.ck.ck-editor__editable_inline>:last-child{margin-bottom:var(--ck-spacing-large)}.ck.ck-editor__editable_inline.ck-blurred ::selection{background:var(--ck-color-editable-blur-selection)}.ck.ck-balloon-panel.ck-toolbar-container[class*=arrow_n]:after{border-bottom-color:var(--ck-color-base-foreground)}.ck.ck-balloon-panel.ck-toolbar-container[class*=arrow_s]:after{border-top-color:var(--ck-color-base-foreground)}";
  }, function (e, t, i) {
    var n = i(1),
        o = i(42);
    "string" == typeof (o = o.__esModule ? o.default : o) && (o = [[e.i, o, ""]]);
    var r = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": !0
      },
      insert: "head",
      singleton: !0
    };
    n(o, r);
    e.exports = o.locals || {};
  }, function (e, t) {
    e.exports = ".ck.ck-label{display:block}.ck.ck-voice-label{display:none}.ck.ck-label{font-weight:700}";
  }, function (e, t, i) {
    var n = i(1),
        o = i(44);
    "string" == typeof (o = o.__esModule ? o.default : o) && (o = [[e.i, o, ""]]);
    var r = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": !0
      },
      insert: "head",
      singleton: !0
    };
    n(o, r);
    e.exports = o.locals || {};
  }, function (e, t) {
    e.exports = ".ck.ck-form__header{display:flex;flex-direction:row;flex-wrap:nowrap;align-items:center;justify-content:space-between}:root{--ck-form-header-height:38px}.ck.ck-form__header{padding:var(--ck-spacing-small) var(--ck-spacing-large);height:var(--ck-form-header-height);line-height:var(--ck-form-header-height);border-bottom:1px solid var(--ck-color-base-border)}.ck.ck-form__header .ck-form__header__label{font-weight:700}";
  }, function (e, t, i) {
    var n = i(1),
        o = i(46);
    "string" == typeof (o = o.__esModule ? o.default : o) && (o = [[e.i, o, ""]]);
    var r = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": !0
      },
      insert: "head",
      singleton: !0
    };
    n(o, r);
    e.exports = o.locals || {};
  }, function (e, t) {
    e.exports = ":root{--ck-input-text-width:18em}.ck.ck-input-text{border-radius:0}.ck-rounded-corners .ck.ck-input-text,.ck.ck-input-text.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-input-text{background:var(--ck-color-input-background);border:1px solid var(--ck-color-input-border);padding:var(--ck-spacing-extra-tiny) var(--ck-spacing-medium);min-width:var(--ck-input-text-width);min-height:var(--ck-ui-component-min-height);transition:box-shadow .1s ease-in-out,border .1s ease-in-out}.ck.ck-input-text:focus{outline:none;border:var(--ck-focus-ring);box-shadow:var(--ck-focus-outer-shadow),0 0}.ck.ck-input-text[readonly]{border:1px solid var(--ck-color-input-disabled-border);background:var(--ck-color-input-disabled-background);color:var(--ck-color-input-disabled-text)}.ck.ck-input-text[readonly]:focus{box-shadow:var(--ck-focus-disabled-outer-shadow),0 0}.ck.ck-input-text.ck-error{border-color:var(--ck-color-input-error-border);animation:ck-text-input-shake .3s ease both}.ck.ck-input-text.ck-error:focus{box-shadow:var(--ck-focus-error-outer-shadow),0 0}@keyframes ck-text-input-shake{20%{transform:translateX(-2px)}40%{transform:translateX(2px)}60%{transform:translateX(-1px)}80%{transform:translateX(1px)}}";
  }, function (e, t, i) {
    var n = i(1),
        o = i(48);
    "string" == typeof (o = o.__esModule ? o.default : o) && (o = [[e.i, o, ""]]);
    var r = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": !0
      },
      insert: "head",
      singleton: !0
    };
    n(o, r);
    e.exports = o.locals || {};
  }, function (e, t) {
    e.exports = ".ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper{display:flex;position:relative}.ck.ck-labeled-field-view .ck.ck-label{display:block;position:absolute}:root{--ck-labeled-field-view-transition:.1s cubic-bezier(0,0,0.24,0.95);--ck-labeled-field-empty-unfocused-max-width:100% - 2 * var(--ck-spacing-medium);--ck-color-labeled-field-label-background:var(--ck-color-base-background)}.ck.ck-labeled-field-view{border-radius:0}.ck-rounded-corners .ck.ck-labeled-field-view,.ck.ck-labeled-field-view.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper{width:100%}.ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{top:0}[dir=ltr] .ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{left:0}[dir=rtl] .ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{right:0}.ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{pointer-events:none;transform-origin:0 0;transform:translate(var(--ck-spacing-medium),-6px) scale(.75);background:var(--ck-color-labeled-field-label-background);padding:0 calc(var(--ck-font-size-tiny)*0.5);line-height:normal;font-weight:400;text-overflow:ellipsis;overflow:hidden;max-width:100%;transition:transform var(--ck-labeled-field-view-transition),padding var(--ck-labeled-field-view-transition),background var(--ck-labeled-field-view-transition)}.ck.ck-labeled-field-view.ck-error .ck-input:not([readonly])+.ck.ck-label,.ck.ck-labeled-field-view.ck-error>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{color:var(--ck-color-base-error)}.ck.ck-labeled-field-view .ck-labeled-field-view__status{font-size:var(--ck-font-size-small);margin-top:var(--ck-spacing-small);white-space:normal}.ck.ck-labeled-field-view .ck-labeled-field-view__status.ck-labeled-field-view__status_error{color:var(--ck-color-base-error)}.ck.ck-labeled-field-view.ck-disabled>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label,.ck.ck-labeled-field-view.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused)>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{color:var(--ck-color-input-disabled-text)}[dir=ltr] .ck.ck-labeled-field-view.ck-disabled>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label,[dir=ltr] .ck.ck-labeled-field-view.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder)>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{transform:translate(var(--ck-spacing-medium),calc(var(--ck-font-size-base)*0.6)) scale(1)}[dir=rtl] .ck.ck-labeled-field-view.ck-disabled>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label,[dir=rtl] .ck.ck-labeled-field-view.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder)>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{transform:translate(calc(var(--ck-spacing-medium)*-1),calc(var(--ck-font-size-base)*0.6)) scale(1)}.ck.ck-labeled-field-view.ck-disabled>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label,.ck.ck-labeled-field-view.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder)>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{max-width:calc(var(--ck-labeled-field-empty-unfocused-max-width));background:transparent;padding:0}.ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck-dropdown>.ck.ck-button{background:transparent}.ck.ck-labeled-field-view.ck-labeled-field-view_empty>.ck.ck-labeled-field-view__input-wrapper>.ck-dropdown>.ck-button>.ck-button__label{opacity:0}.ck.ck-labeled-field-view.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder)>.ck.ck-labeled-field-view__input-wrapper>.ck-dropdown+.ck-label{max-width:calc(var(--ck-labeled-field-empty-unfocused-max-width) - var(--ck-dropdown-arrow-size) - var(--ck-spacing-standard))}";
  }, function (e, t, i) {
    var n = i(1),
        o = i(50);
    "string" == typeof (o = o.__esModule ? o.default : o) && (o = [[e.i, o, ""]]);
    var r = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": !0
      },
      insert: "head",
      singleton: !0
    };
    n(o, r);
    e.exports = o.locals || {};
  }, function (e, t) {
    e.exports = ':root{--ck-balloon-panel-arrow-z-index:calc(var(--ck-z-default) - 3)}.ck.ck-balloon-panel{display:none;position:absolute;z-index:var(--ck-z-modal)}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:after,.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:before{content:"";position:absolute}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:before{z-index:var(--ck-balloon-panel-arrow-z-index)}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:after{z-index:calc(var(--ck-balloon-panel-arrow-z-index) + 1)}.ck.ck-balloon-panel[class*=arrow_n]:before{z-index:var(--ck-balloon-panel-arrow-z-index)}.ck.ck-balloon-panel[class*=arrow_n]:after{z-index:calc(var(--ck-balloon-panel-arrow-z-index) + 1)}.ck.ck-balloon-panel[class*=arrow_s]:before{z-index:var(--ck-balloon-panel-arrow-z-index)}.ck.ck-balloon-panel[class*=arrow_s]:after{z-index:calc(var(--ck-balloon-panel-arrow-z-index) + 1)}.ck.ck-balloon-panel.ck-balloon-panel_visible{display:block}:root{--ck-balloon-arrow-offset:2px;--ck-balloon-arrow-height:10px;--ck-balloon-arrow-half-width:8px;--ck-balloon-arrow-drop-shadow:0 2px 2px var(--ck-color-shadow-drop)}.ck.ck-balloon-panel{border-radius:0}.ck-rounded-corners .ck.ck-balloon-panel,.ck.ck-balloon-panel.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-balloon-panel{box-shadow:var(--ck-drop-shadow),0 0;min-height:15px;background:var(--ck-color-panel-background);border:1px solid var(--ck-color-panel-border)}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:after,.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:before{width:0;height:0;border-style:solid}.ck.ck-balloon-panel[class*=arrow_n]:after,.ck.ck-balloon-panel[class*=arrow_n]:before{border-left-width:var(--ck-balloon-arrow-half-width);border-bottom-width:var(--ck-balloon-arrow-height);border-right-width:var(--ck-balloon-arrow-half-width);border-top-width:0}.ck.ck-balloon-panel[class*=arrow_n]:before{border-bottom-color:var(--ck-color-panel-border)}.ck.ck-balloon-panel[class*=arrow_n]:after,.ck.ck-balloon-panel[class*=arrow_n]:before{border-left-color:transparent;border-right-color:transparent;border-top-color:transparent}.ck.ck-balloon-panel[class*=arrow_n]:after{border-bottom-color:var(--ck-color-panel-background);margin-top:var(--ck-balloon-arrow-offset)}.ck.ck-balloon-panel[class*=arrow_s]:after,.ck.ck-balloon-panel[class*=arrow_s]:before{border-left-width:var(--ck-balloon-arrow-half-width);border-bottom-width:0;border-right-width:var(--ck-balloon-arrow-half-width);border-top-width:var(--ck-balloon-arrow-height)}.ck.ck-balloon-panel[class*=arrow_s]:before{border-top-color:var(--ck-color-panel-border);filter:drop-shadow(var(--ck-balloon-arrow-drop-shadow))}.ck.ck-balloon-panel[class*=arrow_s]:after,.ck.ck-balloon-panel[class*=arrow_s]:before{border-left-color:transparent;border-bottom-color:transparent;border-right-color:transparent}.ck.ck-balloon-panel[class*=arrow_s]:after{border-top-color:var(--ck-color-panel-background);margin-bottom:var(--ck-balloon-arrow-offset)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_n:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_n:before{left:50%;margin-left:calc(var(--ck-balloon-arrow-half-width)*-1);top:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_nw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_nw:before{left:calc(var(--ck-balloon-arrow-half-width)*2);top:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_ne:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_ne:before{right:calc(var(--ck-balloon-arrow-half-width)*2);top:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_s:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_s:before{left:50%;margin-left:calc(var(--ck-balloon-arrow-half-width)*-1);bottom:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_sw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_sw:before{left:calc(var(--ck-balloon-arrow-half-width)*2);bottom:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_se:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_se:before{right:calc(var(--ck-balloon-arrow-half-width)*2);bottom:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_sme:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_sme:before{right:25%;margin-right:calc(var(--ck-balloon-arrow-half-width)*2);bottom:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_smw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_smw:before{left:25%;margin-left:calc(var(--ck-balloon-arrow-half-width)*2);bottom:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_nme:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_nme:before{right:25%;margin-right:calc(var(--ck-balloon-arrow-half-width)*2);top:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_nmw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_nmw:before{left:25%;margin-left:calc(var(--ck-balloon-arrow-half-width)*2);top:calc(var(--ck-balloon-arrow-height)*-1)}';
  }, function (e, t, i) {
    var n = i(1),
        o = i(52);
    "string" == typeof (o = o.__esModule ? o.default : o) && (o = [[e.i, o, ""]]);
    var r = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": !0
      },
      insert: "head",
      singleton: !0
    };
    n(o, r);
    e.exports = o.locals || {};
  }, function (e, t) {
    e.exports = ".ck .ck-balloon-rotator__navigation{display:flex;align-items:center;justify-content:center}.ck .ck-balloon-rotator__content .ck-toolbar{justify-content:center}.ck .ck-balloon-rotator__navigation{background:var(--ck-color-toolbar-background);border-bottom:1px solid var(--ck-color-toolbar-border);padding:0 var(--ck-spacing-small)}.ck .ck-balloon-rotator__navigation>*{margin-right:var(--ck-spacing-small);margin-top:var(--ck-spacing-small);margin-bottom:var(--ck-spacing-small)}.ck .ck-balloon-rotator__navigation .ck-balloon-rotator__counter{margin-right:var(--ck-spacing-standard);margin-left:var(--ck-spacing-small)}.ck .ck-balloon-rotator__content .ck.ck-annotation-wrapper{box-shadow:none}";
  }, function (e, t, i) {
    var n = i(1),
        o = i(54);
    "string" == typeof (o = o.__esModule ? o.default : o) && (o = [[e.i, o, ""]]);
    var r = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": !0
      },
      insert: "head",
      singleton: !0
    };
    n(o, r);
    e.exports = o.locals || {};
  }, function (e, t) {
    e.exports = ".ck .ck-fake-panel{position:absolute;z-index:calc(var(--ck-z-modal) - 1)}.ck .ck-fake-panel div{position:absolute}.ck .ck-fake-panel div:first-child{z-index:2}.ck .ck-fake-panel div:nth-child(2){z-index:1}:root{--ck-balloon-fake-panel-offset-horizontal:6px;--ck-balloon-fake-panel-offset-vertical:6px}.ck .ck-fake-panel div{box-shadow:var(--ck-drop-shadow),0 0;min-height:15px;background:var(--ck-color-panel-background);border:1px solid var(--ck-color-panel-border);border-radius:var(--ck-border-radius);width:100%;height:100%}.ck .ck-fake-panel div:first-child{margin-left:var(--ck-balloon-fake-panel-offset-horizontal);margin-top:var(--ck-balloon-fake-panel-offset-vertical)}.ck .ck-fake-panel div:nth-child(2){margin-left:calc(var(--ck-balloon-fake-panel-offset-horizontal)*2);margin-top:calc(var(--ck-balloon-fake-panel-offset-vertical)*2)}.ck .ck-fake-panel div:nth-child(3){margin-left:calc(var(--ck-balloon-fake-panel-offset-horizontal)*3);margin-top:calc(var(--ck-balloon-fake-panel-offset-vertical)*3)}.ck .ck-balloon-panel_arrow_s+.ck-fake-panel,.ck .ck-balloon-panel_arrow_se+.ck-fake-panel,.ck .ck-balloon-panel_arrow_sw+.ck-fake-panel{--ck-balloon-fake-panel-offset-vertical:-6px}";
  }, function (e, t, i) {
    var n = i(1),
        o = i(56);
    "string" == typeof (o = o.__esModule ? o.default : o) && (o = [[e.i, o, ""]]);
    var r = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": !0
      },
      insert: "head",
      singleton: !0
    };
    n(o, r);
    e.exports = o.locals || {};
  }, function (e, t) {
    e.exports = ".ck.ck-sticky-panel .ck-sticky-panel__content_sticky{z-index:var(--ck-z-modal);position:fixed;top:0}.ck.ck-sticky-panel .ck-sticky-panel__content_sticky_bottom-limit{top:auto;position:absolute}.ck.ck-sticky-panel .ck-sticky-panel__content_sticky{box-shadow:var(--ck-drop-shadow),0 0;border-width:0 1px 1px;border-top-left-radius:0;border-top-right-radius:0}";
  }, function (e, t, i) {
    var n = i(1),
        o = i(58);
    "string" == typeof (o = o.__esModule ? o.default : o) && (o = [[e.i, o, ""]]);
    var r = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": !0
      },
      insert: "head",
      singleton: !0
    };
    n(o, r);
    e.exports = o.locals || {};
  }, function (e, t) {
    e.exports = ".ck.ck-block-toolbar-button{position:absolute;z-index:var(--ck-z-default)}:root{--ck-color-block-toolbar-button:var(--ck-color-text);--ck-block-toolbar-button-size:var(--ck-font-size-normal)}.ck.ck-block-toolbar-button{color:var(--ck-color-block-toolbar-button);font-size:var(--ck-block-toolbar-size)}";
  }, function (e, t, i) {
    var n = i(1),
        o = i(60);
    "string" == typeof (o = o.__esModule ? o.default : o) && (o = [[e.i, o, ""]]);
    var r = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": !0
      },
      insert: "head",
      singleton: !0
    };
    n(o, r);
    e.exports = o.locals || {};
  }, function (e, t) {
    e.exports = ".ck.ck-placeholder,.ck .ck-placeholder{position:relative}.ck.ck-placeholder:before,.ck .ck-placeholder:before{position:absolute;left:0;right:0;content:attr(data-placeholder);pointer-events:none}.ck.ck-read-only .ck-placeholder:before{display:none}.ck.ck-placeholder:before,.ck .ck-placeholder:before{cursor:text;color:var(--ck-color-engine-placeholder-text)}";
  }, function (e, t, i) {
    var n = i(1),
        o = i(62);
    "string" == typeof (o = o.__esModule ? o.default : o) && (o = [[e.i, o, ""]]);
    var r = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": !0
      },
      insert: "head",
      singleton: !0
    };
    n(o, r);
    e.exports = o.locals || {};
  }, function (e, t) {
    e.exports = ".ck.ck-editor{position:relative}.ck.ck-editor .ck-editor__top .ck-sticky-panel .ck-toolbar{z-index:var(--ck-z-modal)}.ck.ck-editor__top .ck-sticky-panel .ck-toolbar{border-radius:0}.ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-toolbar,.ck.ck-editor__top .ck-sticky-panel .ck-toolbar.ck-rounded-corners{border-radius:var(--ck-border-radius);border-bottom-left-radius:0;border-bottom-right-radius:0}.ck.ck-editor__top .ck-sticky-panel .ck-toolbar{border-bottom-width:0}.ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content_sticky .ck-toolbar{border-bottom-width:1px;border-radius:0}.ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content_sticky .ck-toolbar,.ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content_sticky .ck-toolbar.ck-rounded-corners{border-radius:var(--ck-border-radius);border-radius:0}.ck.ck-editor__main>.ck-editor__editable{background:var(--ck-color-base-background);border-radius:0}.ck-rounded-corners .ck.ck-editor__main>.ck-editor__editable,.ck.ck-editor__main>.ck-editor__editable.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0;border-top-right-radius:0}.ck.ck-editor__main>.ck-editor__editable:not(.ck-focused){border-color:var(--ck-color-base-border)}";
  }, function (e, t, i) {
    var n = i(1),
        o = i(64);
    "string" == typeof (o = o.__esModule ? o.default : o) && (o = [[e.i, o, ""]]);
    var r = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": !0
      },
      insert: "head",
      singleton: !0
    };
    n(o, r);
    e.exports = o.locals || {};
  }, function (e, t) {
    e.exports = '.ck .ck-widget .ck-widget__type-around__button{display:block;position:absolute;overflow:hidden;z-index:var(--ck-z-default)}.ck .ck-widget .ck-widget__type-around__button svg{position:absolute;top:50%;left:50%;z-index:calc(var(--ck-z-default) + 2)}.ck .ck-widget .ck-widget__type-around__button.ck-widget__type-around__button_before{top:calc(var(--ck-widget-outline-thickness)*-0.5);left:min(10%,30px);transform:translateY(-50%)}.ck .ck-widget .ck-widget__type-around__button.ck-widget__type-around__button_after{bottom:calc(var(--ck-widget-outline-thickness)*-0.5);right:min(10%,30px);transform:translateY(50%)}.ck .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button:after,.ck .ck-widget>.ck-widget__type-around>.ck-widget__type-around__button:hover:after{content:"";display:block;position:absolute;top:1px;left:1px;z-index:calc(var(--ck-z-default) + 1)}.ck .ck-widget>.ck-widget__type-around>.ck-widget__type-around__fake-caret{display:none;position:absolute;left:0;right:0}.ck .ck-widget:hover>.ck-widget__type-around>.ck-widget__type-around__fake-caret{left:calc(var(--ck-widget-outline-thickness)*-1);right:calc(var(--ck-widget-outline-thickness)*-1)}.ck .ck-widget.ck-widget_type-around_show-fake-caret_before>.ck-widget__type-around>.ck-widget__type-around__fake-caret{top:calc(var(--ck-widget-outline-thickness)*-1 - 1px);display:block}.ck .ck-widget.ck-widget_type-around_show-fake-caret_after>.ck-widget__type-around>.ck-widget__type-around__fake-caret{bottom:calc(var(--ck-widget-outline-thickness)*-1 - 1px);display:block}.ck.ck-editor__editable.ck-read-only .ck-widget__type-around,.ck.ck-editor__editable.ck-restricted-editing_mode_restricted .ck-widget__type-around,.ck.ck-editor__editable.ck-widget__type-around_disabled .ck-widget__type-around{display:none}:root{--ck-widget-type-around-button-size:20px;--ck-color-widget-type-around-button-active:var(--ck-color-focus-border);--ck-color-widget-type-around-button-hover:var(--ck-color-widget-hover-border);--ck-color-widget-type-around-button-blurred-editable:var(--ck-color-widget-blurred-border);--ck-color-widget-type-around-button-radar-start-alpha:0;--ck-color-widget-type-around-button-radar-end-alpha:.3;--ck-color-widget-type-around-button-icon:var(--ck-color-base-background)}.ck .ck-widget .ck-widget__type-around__button{width:var(--ck-widget-type-around-button-size);height:var(--ck-widget-type-around-button-size);background:var(--ck-color-widget-type-around-button);border-radius:100px;transition:opacity var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),background var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve);opacity:0;pointer-events:none}.ck .ck-widget .ck-widget__type-around__button svg{width:10px;height:8px;transform:translate(-50%,-50%);transition:transform .5s ease;margin-top:1px}.ck .ck-widget .ck-widget__type-around__button svg *{stroke-dasharray:10;stroke-dashoffset:0;fill:none;stroke:var(--ck-color-widget-type-around-button-icon);stroke-width:1.5px;stroke-linecap:round;stroke-linejoin:round}.ck .ck-widget .ck-widget__type-around__button svg line{stroke-dasharray:7}.ck .ck-widget .ck-widget__type-around__button:hover{animation:ck-widget-type-around-button-sonar 1s ease infinite}.ck .ck-widget .ck-widget__type-around__button:hover svg polyline{animation:ck-widget-type-around-arrow-dash 2s linear}.ck .ck-widget .ck-widget__type-around__button:hover svg line{animation:ck-widget-type-around-arrow-tip-dash 2s linear}.ck .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button,.ck .ck-widget:hover>.ck-widget__type-around>.ck-widget__type-around__button{opacity:1;pointer-events:auto}.ck .ck-widget:not(.ck-widget_selected)>.ck-widget__type-around>.ck-widget__type-around__button{background:var(--ck-color-widget-type-around-button-hover)}.ck .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button,.ck .ck-widget>.ck-widget__type-around>.ck-widget__type-around__button:hover{background:var(--ck-color-widget-type-around-button-active)}.ck .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button:after,.ck .ck-widget>.ck-widget__type-around>.ck-widget__type-around__button:hover:after{width:calc(var(--ck-widget-type-around-button-size) - 2px);height:calc(var(--ck-widget-type-around-button-size) - 2px);border-radius:100px;background:linear-gradient(135deg,hsla(0,0%,100%,0),hsla(0,0%,100%,.3))}.ck .ck-widget.ck-widget_with-selection-handle>.ck-widget__type-around>.ck-widget__type-around__button_before{margin-left:20px}.ck .ck-widget .ck-widget__type-around__fake-caret{pointer-events:none;height:1px;animation:ck-widget-type-around-fake-caret-pulse 1s linear infinite normal forwards;outline:1px solid hsla(0,0%,100%,.5);background:var(--ck-color-base-text)}.ck .ck-widget.ck-widget_selected.ck-widget_type-around_show-fake-caret_after,.ck .ck-widget.ck-widget_selected.ck-widget_type-around_show-fake-caret_before{outline-color:transparent}.ck .ck-widget.ck-widget_type-around_show-fake-caret_after.ck-widget_selected:hover,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before.ck-widget_selected:hover{outline-color:var(--ck-color-widget-hover-border)}.ck .ck-widget.ck-widget_type-around_show-fake-caret_after>.ck-widget__type-around>.ck-widget__type-around__button,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before>.ck-widget__type-around>.ck-widget__type-around__button{opacity:0;pointer-events:none}.ck .ck-widget.ck-widget_type-around_show-fake-caret_after.ck-widget_with-selection-handle.ck-widget_selected:hover>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_type-around_show-fake-caret_after.ck-widget_with-selection-handle.ck-widget_selected>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before.ck-widget_with-selection-handle.ck-widget_selected:hover>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before.ck-widget_with-selection-handle.ck-widget_selected>.ck-widget__selection-handle{opacity:0}.ck .ck-widget.ck-widget_type-around_show-fake-caret_after.ck-widget_selected.ck-widget_with-resizer>.ck-widget__resizer,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before.ck-widget_selected.ck-widget_with-resizer>.ck-widget__resizer{opacity:0}.ck[dir=rtl] .ck-widget.ck-widget_with-selection-handle .ck-widget__type-around>.ck-widget__type-around__button_before{margin-left:0;margin-right:20px}.ck-editor__nested-editable.ck-editor__editable_selected .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button,.ck-editor__nested-editable.ck-editor__editable_selected .ck-widget:hover>.ck-widget__type-around>.ck-widget__type-around__button{opacity:0;pointer-events:none}.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button:not(:hover){background:var(--ck-color-widget-type-around-button-blurred-editable)}.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button:not(:hover) svg *{stroke:#999}@keyframes ck-widget-type-around-arrow-dash{0%{stroke-dashoffset:10}20%,to{stroke-dashoffset:0}}@keyframes ck-widget-type-around-arrow-tip-dash{0%,20%{stroke-dashoffset:7}40%,to{stroke-dashoffset:0}}@keyframes ck-widget-type-around-button-sonar{0%{box-shadow:0 0 0 0 hsla(var(--ck-color-focus-border-coordinates),var(--ck-color-widget-type-around-button-radar-start-alpha))}50%{box-shadow:0 0 0 5px hsla(var(--ck-color-focus-border-coordinates),var(--ck-color-widget-type-around-button-radar-end-alpha))}to{box-shadow:0 0 0 5px hsla(var(--ck-color-focus-border-coordinates),var(--ck-color-widget-type-around-button-radar-start-alpha))}}@keyframes ck-widget-type-around-fake-caret-pulse{0%{opacity:1}49%{opacity:1}50%{opacity:0}99%{opacity:0}to{opacity:1}}';
  }, function (e, t, i) {
    var n = i(1),
        o = i(66);
    "string" == typeof (o = o.__esModule ? o.default : o) && (o = [[e.i, o, ""]]);
    var r = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": !0
      },
      insert: "head",
      singleton: !0
    };
    n(o, r);
    e.exports = o.locals || {};
  }, function (e, t) {
    e.exports = ":root{--ck-color-resizer:var(--ck-color-focus-border);--ck-color-resizer-tooltip-background:#262626;--ck-color-resizer-tooltip-text:#f2f2f2;--ck-resizer-border-radius:var(--ck-border-radius);--ck-resizer-tooltip-offset:10px;--ck-resizer-tooltip-height:calc(var(--ck-spacing-small)*2 + 10px)}.ck .ck-widget,.ck .ck-widget.ck-widget_with-selection-handle{position:relative}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle{position:absolute}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle .ck-icon{display:block}.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_with-selection-handle:hover>.ck-widget__selection-handle{visibility:visible}.ck .ck-size-view{background:var(--ck-color-resizer-tooltip-background);color:var(--ck-color-resizer-tooltip-text);border:1px solid var(--ck-color-resizer-tooltip-text);border-radius:var(--ck-resizer-border-radius);font-size:var(--ck-font-size-tiny);display:block;padding:0 var(--ck-spacing-small);height:var(--ck-resizer-tooltip-height);line-height:var(--ck-resizer-tooltip-height)}.ck .ck-size-view.ck-orientation-above-center,.ck .ck-size-view.ck-orientation-bottom-left,.ck .ck-size-view.ck-orientation-bottom-right,.ck .ck-size-view.ck-orientation-top-left,.ck .ck-size-view.ck-orientation-top-right{position:absolute}.ck .ck-size-view.ck-orientation-top-left{top:var(--ck-resizer-tooltip-offset);left:var(--ck-resizer-tooltip-offset)}.ck .ck-size-view.ck-orientation-top-right{top:var(--ck-resizer-tooltip-offset);right:var(--ck-resizer-tooltip-offset)}.ck .ck-size-view.ck-orientation-bottom-right{bottom:var(--ck-resizer-tooltip-offset);right:var(--ck-resizer-tooltip-offset)}.ck .ck-size-view.ck-orientation-bottom-left{bottom:var(--ck-resizer-tooltip-offset);left:var(--ck-resizer-tooltip-offset)}.ck .ck-size-view.ck-orientation-above-center{top:calc(var(--ck-resizer-tooltip-height)*-1);left:50%;transform:translate(-50%)}:root{--ck-widget-outline-thickness:3px;--ck-widget-handler-icon-size:16px;--ck-widget-handler-animation-duration:200ms;--ck-widget-handler-animation-curve:ease;--ck-color-widget-blurred-border:#dedede;--ck-color-widget-hover-border:#ffc83d;--ck-color-widget-editable-focus-background:var(--ck-color-base-background);--ck-color-widget-drag-handler-icon-color:var(--ck-color-base-background)}.ck .ck-widget{outline-width:var(--ck-widget-outline-thickness);outline-style:solid;outline-color:transparent;transition:outline-color var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve)}.ck .ck-widget.ck-widget_selected,.ck .ck-widget.ck-widget_selected:hover{outline:var(--ck-widget-outline-thickness) solid var(--ck-color-focus-border)}.ck .ck-widget:hover{outline-color:var(--ck-color-widget-hover-border)}.ck .ck-editor__nested-editable{border:1px solid transparent}.ck .ck-editor__nested-editable.ck-editor__nested-editable_focused,.ck .ck-editor__nested-editable:focus{outline:none;border:var(--ck-focus-ring);box-shadow:var(--ck-inner-shadow),0 0;background-color:var(--ck-color-widget-editable-focus-background)}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle{padding:4px;box-sizing:border-box;background-color:transparent;opacity:0;transition:background-color var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),visibility var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),opacity var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve);border-radius:var(--ck-border-radius) var(--ck-border-radius) 0 0;transform:translateY(-100%);left:calc(0px - var(--ck-widget-outline-thickness));top:0}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle .ck-icon{width:var(--ck-widget-handler-icon-size);height:var(--ck-widget-handler-icon-size);color:var(--ck-color-widget-drag-handler-icon-color)}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle .ck-icon .ck-icon__selected-indicator{opacity:0;transition:opacity .3s var(--ck-widget-handler-animation-curve)}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle:hover .ck-icon .ck-icon__selected-indicator{opacity:1}.ck .ck-widget.ck-widget_with-selection-handle:hover>.ck-widget__selection-handle{opacity:1;background-color:var(--ck-color-widget-hover-border)}.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected:hover>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected>.ck-widget__selection-handle{opacity:1;background-color:var(--ck-color-focus-border)}.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected:hover>.ck-widget__selection-handle .ck-icon .ck-icon__selected-indicator,.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected>.ck-widget__selection-handle .ck-icon .ck-icon__selected-indicator{opacity:1}.ck[dir=rtl] .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle{left:auto;right:calc(0px - var(--ck-widget-outline-thickness))}.ck.ck-editor__editable.ck-read-only .ck-widget{transition:none}.ck.ck-editor__editable.ck-read-only .ck-widget:not(.ck-widget_selected){--ck-widget-outline-thickness:0px}.ck.ck-editor__editable.ck-read-only .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle,.ck.ck-editor__editable.ck-read-only .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle:hover{background:var(--ck-color-widget-blurred-border)}.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected,.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected:hover{outline-color:var(--ck-color-widget-blurred-border)}.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected.ck-widget_with-selection-handle>.ck-widget__selection-handle,.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected.ck-widget_with-selection-handle>.ck-widget__selection-handle:hover,.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected:hover.ck-widget_with-selection-handle>.ck-widget__selection-handle,.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected:hover.ck-widget_with-selection-handle>.ck-widget__selection-handle:hover{background:var(--ck-color-widget-blurred-border)}.ck.ck-editor__editable>.ck-widget.ck-widget_with-selection-handle:first-child,.ck.ck-editor__editable blockquote>.ck-widget.ck-widget_with-selection-handle:first-child{margin-top:calc(1em + var(--ck-widget-handler-icon-size))}";
  }, function (e, t, i) {
    var n = i(1),
        o = i(68);
    "string" == typeof (o = o.__esModule ? o.default : o) && (o = [[e.i, o, ""]]);
    var r = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": !0
      },
      insert: "head",
      singleton: !0
    };
    n(o, r);
    e.exports = o.locals || {};
  }, function (e, t) {
    e.exports = '.ck.ck-editor__editable .ck.ck-clipboard-drop-target-position{display:inline;position:relative;pointer-events:none}.ck.ck-editor__editable .ck.ck-clipboard-drop-target-position span{position:absolute;width:0}.ck.ck-editor__editable .ck-widget:-webkit-drag>.ck-widget__selection-handle,.ck.ck-editor__editable .ck-widget:-webkit-drag>.ck-widget__type-around{display:none}:root{--ck-clipboard-drop-target-dot-width:12px;--ck-clipboard-drop-target-dot-height:8px;--ck-clipboard-drop-target-color:var(--ck-color-focus-border)}.ck.ck-editor__editable .ck.ck-clipboard-drop-target-position span{bottom:calc(var(--ck-clipboard-drop-target-dot-height)*-0.5);top:calc(var(--ck-clipboard-drop-target-dot-height)*-0.5);border:1px solid var(--ck-clipboard-drop-target-color);background:var(--ck-clipboard-drop-target-color);margin-left:-1px}.ck.ck-editor__editable .ck.ck-clipboard-drop-target-position span:after{content:"";width:0;height:0;display:block;position:absolute;left:50%;top:calc(var(--ck-clipboard-drop-target-dot-height)*-0.5);transform:translateX(-50%);border-left:calc(var(--ck-clipboard-drop-target-dot-width)*0.5) solid transparent;border-bottom:0 solid transparent;border-right:calc(var(--ck-clipboard-drop-target-dot-width)*0.5) solid transparent;border-top:calc(var(--ck-clipboard-drop-target-dot-height)) solid var(--ck-clipboard-drop-target-color)}.ck.ck-editor__editable .ck-widget.ck-clipboard-drop-target-range{outline:var(--ck-widget-outline-thickness) solid var(--ck-clipboard-drop-target-color)!important}.ck.ck-editor__editable .ck-widget:-webkit-drag{zoom:.6;outline:none!important}';
  }, function (e, t, i) {
    var n = i(1),
        o = i(70);
    "string" == typeof (o = o.__esModule ? o.default : o) && (o = [[e.i, o, ""]]);
    var r = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": !0
      },
      insert: "head",
      singleton: !0
    };
    n(o, r);
    e.exports = o.locals || {};
  }, function (e, t) {
    e.exports = ".ck-content blockquote{overflow:hidden;padding-right:1.5em;padding-left:1.5em;margin-left:0;margin-right:0;font-style:italic;border-left:5px solid #ccc}.ck-content[dir=rtl] blockquote{border-left:0;border-right:5px solid #ccc}";
  }, function (e, t) {
    e.exports = ".ck.ck-heading_heading1{font-size:20px}.ck.ck-heading_heading2{font-size:17px}.ck.ck-heading_heading3{font-size:14px}.ck[class*=ck-heading_heading]{font-weight:700}.ck.ck-dropdown.ck-heading-dropdown .ck-dropdown__button .ck-button__label{width:8em}.ck.ck-dropdown.ck-heading-dropdown .ck-dropdown__panel .ck-list__item{min-width:18em}";
  }, function (e, t, i) {
    var n = i(1),
        o = i(73);
    "string" == typeof (o = o.__esModule ? o.default : o) && (o = [[e.i, o, ""]]);
    var r = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": !0
      },
      insert: "head",
      singleton: !0
    };
    n(o, r);
    e.exports = o.locals || {};
  }, function (e, t) {
    e.exports = ".ck .ck-widget_with-resizer{position:relative}.ck .ck-widget__resizer{display:none;position:absolute;pointer-events:none;left:0;top:0}.ck-focused .ck-widget_with-resizer.ck-widget_selected>.ck-widget__resizer{display:block}.ck .ck-widget__resizer__handle{position:absolute;pointer-events:all}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-bottom-right,.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-top-left{cursor:nwse-resize}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-bottom-left,.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-top-right{cursor:nesw-resize}:root{--ck-resizer-size:10px;--ck-resizer-offset:calc(var(--ck-resizer-size)/-2 - 2px);--ck-resizer-border-width:1px}.ck .ck-widget__resizer{outline:1px solid var(--ck-color-resizer)}.ck .ck-widget__resizer__handle{width:var(--ck-resizer-size);height:var(--ck-resizer-size);background:var(--ck-color-focus-border);border:var(--ck-resizer-border-width) solid #fff;border-radius:var(--ck-resizer-border-radius)}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-top-left{top:var(--ck-resizer-offset);left:var(--ck-resizer-offset)}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-top-right{top:var(--ck-resizer-offset);right:var(--ck-resizer-offset)}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-bottom-right{bottom:var(--ck-resizer-offset);right:var(--ck-resizer-offset)}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-bottom-left{bottom:var(--ck-resizer-offset);left:var(--ck-resizer-offset)}";
  }, function (e, t, i) {
    var n = i(1),
        o = i(75);
    "string" == typeof (o = o.__esModule ? o.default : o) && (o = [[e.i, o, ""]]);
    var r = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": !0
      },
      insert: "head",
      singleton: !0
    };
    n(o, r);
    e.exports = o.locals || {};
  }, function (e, t) {
    e.exports = ".ck.ck-text-alternative-form{display:flex;flex-direction:row;flex-wrap:nowrap}.ck.ck-text-alternative-form .ck-labeled-field-view{display:inline-block}.ck.ck-text-alternative-form .ck-label{display:none}@media screen and (max-width:600px){.ck.ck-text-alternative-form{flex-wrap:wrap}.ck.ck-text-alternative-form .ck-labeled-field-view{flex-basis:100%}.ck.ck-text-alternative-form .ck-button{flex-basis:50%}}";
  }, function (e, t) {
    e.exports = '.ck-vertical-form .ck-button:after{content:"";width:0;position:absolute;right:-1px;top:var(--ck-spacing-small);bottom:var(--ck-spacing-small);z-index:1}@media screen and (max-width:600px){.ck.ck-responsive-form .ck-button:after{content:"";width:0;position:absolute;right:-1px;top:var(--ck-spacing-small);bottom:var(--ck-spacing-small);z-index:1}}.ck-vertical-form>.ck-button:nth-last-child(2):after{border-right:1px solid var(--ck-color-base-border)}.ck.ck-responsive-form{padding:var(--ck-spacing-large)}.ck.ck-responsive-form:focus{outline:none}[dir=ltr] .ck.ck-responsive-form>:not(:first-child),[dir=rtl] .ck.ck-responsive-form>:not(:last-child){margin-left:var(--ck-spacing-standard)}@media screen and (max-width:600px){.ck.ck-responsive-form{padding:0;width:calc(var(--ck-input-text-width)*0.8)}.ck.ck-responsive-form .ck-labeled-field-view{margin:var(--ck-spacing-large) var(--ck-spacing-large) 0}.ck.ck-responsive-form .ck-labeled-field-view .ck-input-text{min-width:0;width:100%}.ck.ck-responsive-form .ck-labeled-field-view .ck-labeled-field-view__error{white-space:normal}.ck.ck-responsive-form>.ck-button:last-child,.ck.ck-responsive-form>.ck-button:nth-last-child(2){padding:var(--ck-spacing-standard);margin-top:var(--ck-spacing-large);border-radius:0;border:0;border-top:1px solid var(--ck-color-base-border)}[dir=ltr] .ck.ck-responsive-form>.ck-button:last-child,[dir=ltr] .ck.ck-responsive-form>.ck-button:nth-last-child(2),[dir=rtl] .ck.ck-responsive-form>.ck-button:last-child,[dir=rtl] .ck.ck-responsive-form>.ck-button:nth-last-child(2){margin-left:0}.ck.ck-responsive-form>.ck-button:nth-last-child(2):after,[dir=rtl] .ck.ck-responsive-form>.ck-button:last-child:last-of-type,[dir=rtl] .ck.ck-responsive-form>.ck-button:nth-last-child(2):last-of-type{border-right:1px solid var(--ck-color-base-border)}}';
  }, function (e, t) {
    e.exports = ".ck-content .image{display:table;clear:both;text-align:center;margin:.9em auto;min-width:50px}.ck-content .image img{display:block;margin:0 auto;max-width:100%;min-width:100%}.ck-content .image-inline{display:inline-flex;max-width:100%;align-items:flex-start}.ck-content .image-inline img{flex-grow:1;flex-shrink:1;max-width:100%}.ck.ck-editor__editable .image>figcaption.ck-placeholder:before{padding-left:inherit;padding-right:inherit;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ck.ck-editor__editable .image-inline.ck-widget_selected,.ck.ck-editor__editable .image.ck-widget_selected{z-index:1}.ck.ck-editor__editable .image-inline.ck-widget_selected ::selection{display:none}.ck.ck-editor__editable td .image-inline img,.ck.ck-editor__editable th .image-inline img{max-width:none}";
  }, function (e, t, i) {
    var n = i(1),
        o = i(79);
    "string" == typeof (o = o.__esModule ? o.default : o) && (o = [[e.i, o, ""]]);
    var r = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": !0
      },
      insert: "head",
      singleton: !0
    };
    n(o, r);
    e.exports = o.locals || {};
  }, function (e, t) {
    e.exports = ":root{--ck-color-image-caption-background:#f7f7f7;--ck-color-image-caption-text:#333;--ck-color-image-caption-highligted-background:#fd0}.ck-content .image>figcaption{display:table-caption;caption-side:bottom;word-break:break-word;color:var(--ck-color-image-caption-text);background-color:var(--ck-color-image-caption-background);padding:.6em;font-size:.75em;outline-offset:-1px}.ck.ck-editor__editable .image>figcaption.image__caption_highlighted{animation:ck-image-caption-highlight .6s ease-out}@keyframes ck-image-caption-highlight{0%{background-color:var(--ck-color-image-caption-highligted-background)}to{background-color:var(--ck-color-image-caption-background)}}";
  }, function (e, t, i) {
    var n = i(1),
        o = i(81);
    "string" == typeof (o = o.__esModule ? o.default : o) && (o = [[e.i, o, ""]]);
    var r = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": !0
      },
      insert: "head",
      singleton: !0
    };
    n(o, r);
    e.exports = o.locals || {};
  }, function (e, t) {
    e.exports = ":root{--ck-image-style-spacing:1.5em;--ck-inline-image-style-spacing:calc(var(--ck-image-style-spacing)/2)}.ck-content .image-style-block-align-left,.ck-content .image-style-block-align-right{max-width:calc(100% - var(--ck-image-style-spacing))}.ck-content .image-style-align-left,.ck-content .image-style-align-right{clear:none}.ck-content .image-style-side{float:right;margin-left:var(--ck-image-style-spacing);max-width:50%}.ck-content .image-style-align-left{float:left;margin-right:var(--ck-image-style-spacing)}.ck-content .image-style-align-center{margin-left:auto;margin-right:auto}.ck-content .image-style-align-right{float:right;margin-left:var(--ck-image-style-spacing)}.ck-content .image-style-block-align-right{margin-right:0;margin-left:auto}.ck-content .image-style-block-align-left{margin-left:0;margin-right:auto}.ck-content p+.image-style-align-left,.ck-content p+.image-style-align-right,.ck-content p+.image-style-side{margin-top:0}.ck-content .image-inline.image-style-align-left,.ck-content .image-inline.image-style-align-right{margin-top:var(--ck-inline-image-style-spacing);margin-bottom:var(--ck-inline-image-style-spacing)}.ck-content .image-inline.image-style-align-left{margin-right:var(--ck-inline-image-style-spacing)}.ck-content .image-inline.image-style-align-right{margin-left:var(--ck-inline-image-style-spacing)}.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open>.ck-splitbutton__action:not(.ck-disabled),.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled),.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled):not(:hover),.ck.ck-splitbutton.ck-splitbutton_flatten:hover>.ck-splitbutton__action:not(.ck-disabled),.ck.ck-splitbutton.ck-splitbutton_flatten:hover>.ck-splitbutton__arrow:not(.ck-disabled),.ck.ck-splitbutton.ck-splitbutton_flatten:hover>.ck-splitbutton__arrow:not(.ck-disabled):not(:hover){background-color:var(--ck-color-button-on-background)}.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open>.ck-splitbutton__action:not(.ck-disabled):after,.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled):after,.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled):not(:hover):after,.ck.ck-splitbutton.ck-splitbutton_flatten:hover>.ck-splitbutton__action:not(.ck-disabled):after,.ck.ck-splitbutton.ck-splitbutton_flatten:hover>.ck-splitbutton__arrow:not(.ck-disabled):after,.ck.ck-splitbutton.ck-splitbutton_flatten:hover>.ck-splitbutton__arrow:not(.ck-disabled):not(:hover):after{display:none}.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open:hover>.ck-splitbutton__action:not(.ck-disabled),.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open:hover>.ck-splitbutton__arrow:not(.ck-disabled),.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open:hover>.ck-splitbutton__arrow:not(.ck-disabled):not(:hover){background-color:var(--ck-color-button-on-hover-background)}";
  }, function (e, t, i) {
    var n = i(1),
        o = i(83);
    "string" == typeof (o = o.__esModule ? o.default : o) && (o = [[e.i, o, ""]]);
    var r = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": !0
      },
      insert: "head",
      singleton: !0
    };
    n(o, r);
    e.exports = o.locals || {};
  }, function (e, t) {
    e.exports = ".ck.ck-editor__editable .image,.ck.ck-editor__editable .image-inline{position:relative}.ck.ck-editor__editable .image-inline .ck-progress-bar,.ck.ck-editor__editable .image .ck-progress-bar{position:absolute;top:0;left:0}.ck.ck-editor__editable .image-inline.ck-appear,.ck.ck-editor__editable .image.ck-appear{animation:fadeIn .7s}.ck.ck-editor__editable .image-inline .ck-progress-bar,.ck.ck-editor__editable .image .ck-progress-bar{height:2px;width:0;background:var(--ck-color-upload-bar-background);transition:width .1s}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}";
  }, function (e, t, i) {
    var n = i(1),
        o = i(85);
    "string" == typeof (o = o.__esModule ? o.default : o) && (o = [[e.i, o, ""]]);
    var r = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": !0
      },
      insert: "head",
      singleton: !0
    };
    n(o, r);
    e.exports = o.locals || {};
  }, function (e, t) {
    e.exports = '.ck-image-upload-complete-icon{display:block;position:absolute;top:min(var(--ck-spacing-medium),6%);right:min(var(--ck-spacing-medium),6%);border-radius:50%;z-index:1}.ck-image-upload-complete-icon:after{content:"";position:absolute}:root{--ck-color-image-upload-icon:#fff;--ck-color-image-upload-icon-background:#008a00;--ck-image-upload-icon-size:20;--ck-image-upload-icon-width:2px;--ck-image-upload-icon-is-visible:clamp(0px,100% - 50px,1px)}.ck-image-upload-complete-icon{opacity:0;background:var(--ck-color-image-upload-icon-background);animation-name:ck-upload-complete-icon-show,ck-upload-complete-icon-hide;animation-fill-mode:forwards,forwards;animation-duration:.5s,.5s;font-size:calc(1px*var(--ck-image-upload-icon-size));animation-delay:0ms,3s;overflow:hidden;width:calc(var(--ck-image-upload-icon-is-visible)*var(--ck-image-upload-icon-size));height:calc(var(--ck-image-upload-icon-is-visible)*var(--ck-image-upload-icon-size))}.ck-image-upload-complete-icon:after{left:25%;top:50%;opacity:0;height:0;width:0;transform:scaleX(-1) rotate(135deg);transform-origin:left top;border-top:var(--ck-image-upload-icon-width) solid var(--ck-color-image-upload-icon);border-right:var(--ck-image-upload-icon-width) solid var(--ck-color-image-upload-icon);animation-name:ck-upload-complete-icon-check;animation-duration:.5s;animation-delay:.5s;animation-fill-mode:forwards;box-sizing:border-box}@keyframes ck-upload-complete-icon-show{0%{opacity:0}to{opacity:1}}@keyframes ck-upload-complete-icon-hide{0%{opacity:1}to{opacity:0}}@keyframes ck-upload-complete-icon-check{0%{opacity:1;width:0;height:0}33%{width:.3em;height:0}to{opacity:1;width:.3em;height:.45em}}';
  }, function (e, t, i) {
    var n = i(1),
        o = i(87);
    "string" == typeof (o = o.__esModule ? o.default : o) && (o = [[e.i, o, ""]]);
    var r = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": !0
      },
      insert: "head",
      singleton: !0
    };
    n(o, r);
    e.exports = o.locals || {};
  }, function (e, t) {
    e.exports = '.ck .ck-upload-placeholder-loader{position:absolute;display:flex;align-items:center;justify-content:center;top:0;left:0}.ck .ck-upload-placeholder-loader:before{content:"";position:relative}:root{--ck-color-upload-placeholder-loader:#b3b3b3;--ck-upload-placeholder-loader-size:32px}.ck .ck-image-upload-placeholder{width:100%;margin:0}.ck .ck-upload-placeholder-loader{width:100%;height:100%}.ck .ck-upload-placeholder-loader:before{width:var(--ck-upload-placeholder-loader-size);height:var(--ck-upload-placeholder-loader-size);border-radius:50%;border-top:3px solid var(--ck-color-upload-placeholder-loader);border-right:2px solid transparent;animation:ck-upload-placeholder-loader 1s linear infinite}@keyframes ck-upload-placeholder-loader{to{transform:rotate(1turn)}}';
  }, function (e, t, i) {
    var n = i(1),
        o = i(89);
    "string" == typeof (o = o.__esModule ? o.default : o) && (o = [[e.i, o, ""]]);
    var r = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": !0
      },
      insert: "head",
      singleton: !0
    };
    n(o, r);
    e.exports = o.locals || {};
  }, function (e, t) {
    e.exports = ".ck .ck-link_selected{background:var(--ck-color-link-selected-background)}.ck .ck-link_selected span.image-inline{outline:var(--ck-widget-outline-thickness) solid var(--ck-color-link-selected-background)}.ck .ck-fake-link-selection{background:var(--ck-color-link-fake-selection)}.ck .ck-fake-link-selection_collapsed{height:100%;border-right:1px solid var(--ck-color-base-text);margin-right:-1px;outline:1px solid hsla(0,0%,100%,.5)}";
  }, function (e, t, i) {
    var n = i(1),
        o = i(91);
    "string" == typeof (o = o.__esModule ? o.default : o) && (o = [[e.i, o, ""]]);
    var r = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": !0
      },
      insert: "head",
      singleton: !0
    };
    n(o, r);
    e.exports = o.locals || {};
  }, function (e, t) {
    e.exports = ".ck.ck-link-form{display:flex}.ck.ck-link-form .ck-label{display:none}@media screen and (max-width:600px){.ck.ck-link-form{flex-wrap:wrap}.ck.ck-link-form .ck-labeled-field-view{flex-basis:100%}.ck.ck-link-form .ck-button{flex-basis:50%}}.ck.ck-link-form_layout-vertical{display:block}.ck.ck-link-form_layout-vertical .ck-button.ck-button-cancel,.ck.ck-link-form_layout-vertical .ck-button.ck-button-save{margin-top:var(--ck-spacing-medium)}.ck.ck-link-form_layout-vertical{padding:0;min-width:var(--ck-input-text-width)}.ck.ck-link-form_layout-vertical .ck-labeled-field-view{margin:var(--ck-spacing-large) var(--ck-spacing-large) var(--ck-spacing-small)}.ck.ck-link-form_layout-vertical .ck-labeled-field-view .ck-input-text{min-width:0;width:100%}.ck.ck-link-form_layout-vertical .ck-button{padding:var(--ck-spacing-standard);margin:0;border-radius:0;border:0;border-top:1px solid var(--ck-color-base-border);width:50%}[dir=ltr] .ck.ck-link-form_layout-vertical .ck-button,[dir=rtl] .ck.ck-link-form_layout-vertical .ck-button{margin-left:0}[dir=rtl] .ck.ck-link-form_layout-vertical .ck-button:last-of-type{border-right:1px solid var(--ck-color-base-border)}.ck.ck-link-form_layout-vertical .ck.ck-list{margin:var(--ck-spacing-standard) var(--ck-spacing-large)}.ck.ck-link-form_layout-vertical .ck.ck-list .ck-button.ck-switchbutton{border:0;padding:0;width:100%}.ck.ck-link-form_layout-vertical .ck.ck-list .ck-button.ck-switchbutton:hover{background:none}";
  }, function (e, t, i) {
    var n = i(1),
        o = i(93);
    "string" == typeof (o = o.__esModule ? o.default : o) && (o = [[e.i, o, ""]]);
    var r = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": !0
      },
      insert: "head",
      singleton: !0
    };
    n(o, r);
    e.exports = o.locals || {};
  }, function (e, t) {
    e.exports = ".ck.ck-link-actions{display:flex;flex-direction:row;flex-wrap:nowrap}.ck.ck-link-actions .ck-link-actions__preview{display:inline-block}.ck.ck-link-actions .ck-link-actions__preview .ck-button__label{overflow:hidden}@media screen and (max-width:600px){.ck.ck-link-actions{flex-wrap:wrap}.ck.ck-link-actions .ck-link-actions__preview{flex-basis:100%}.ck.ck-link-actions .ck-button:not(.ck-link-actions__preview){flex-basis:50%}}.ck.ck-link-actions .ck-button.ck-link-actions__preview{padding-left:0;padding-right:0}.ck.ck-link-actions .ck-button.ck-link-actions__preview .ck-button__label{padding:0 var(--ck-spacing-medium);color:var(--ck-color-link-default);text-overflow:ellipsis;cursor:pointer;max-width:var(--ck-input-text-width);min-width:3em;text-align:center}.ck.ck-link-actions .ck-button.ck-link-actions__preview .ck-button__label:hover{text-decoration:underline}.ck.ck-link-actions .ck-button.ck-link-actions__preview,.ck.ck-link-actions .ck-button.ck-link-actions__preview:active,.ck.ck-link-actions .ck-button.ck-link-actions__preview:focus,.ck.ck-link-actions .ck-button.ck-link-actions__preview:hover{background:none}.ck.ck-link-actions .ck-button.ck-link-actions__preview:active{box-shadow:none}.ck.ck-link-actions .ck-button.ck-link-actions__preview:focus .ck-button__label{text-decoration:underline}[dir=ltr] .ck.ck-link-actions .ck-button:not(:first-child),[dir=rtl] .ck.ck-link-actions .ck-button:not(:last-child){margin-left:var(--ck-spacing-standard)}@media screen and (max-width:600px){.ck.ck-link-actions .ck-button.ck-link-actions__preview{margin:var(--ck-spacing-standard) var(--ck-spacing-standard) 0}.ck.ck-link-actions .ck-button.ck-link-actions__preview .ck-button__label{min-width:0;max-width:100%}[dir=ltr] .ck.ck-link-actions .ck-button:not(.ck-link-actions__preview),[dir=rtl] .ck.ck-link-actions .ck-button:not(.ck-link-actions__preview){margin-left:0}}";
  }, function (e, t, i) {
    var n = i(1),
        o = i(95);
    "string" == typeof (o = o.__esModule ? o.default : o) && (o = [[e.i, o, ""]]);
    var r = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": !0
      },
      insert: "head",
      singleton: !0
    };
    n(o, r);
    e.exports = o.locals || {};
  }, function (e, t) {
    e.exports = '.ck-media__wrapper .ck-media__placeholder{display:flex;flex-direction:column;align-items:center}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url .ck-tooltip{display:block}@media (hover:none){.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url .ck-tooltip{display:none}}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url{max-width:100%;position:relative}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url:hover .ck-tooltip{visibility:visible;opacity:1}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url .ck-media__placeholder__url__text{overflow:hidden;display:block}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="goo.gl/maps"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="google.com/maps"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="maps.app.goo.gl"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="maps.google.com"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck-media__placeholder__icon *{display:none}.ck-editor__editable:not(.ck-read-only) .ck-media__wrapper>:not(.ck-media__placeholder),.ck-editor__editable:not(.ck-read-only) .ck-widget:not(.ck-widget_selected) .ck-media__placeholder{pointer-events:none}:root{--ck-media-embed-placeholder-icon-size:3em;--ck-color-media-embed-placeholder-url-text:#757575;--ck-color-media-embed-placeholder-url-text-hover:var(--ck-color-base-text)}.ck-media__wrapper{margin:0 auto}.ck-media__wrapper .ck-media__placeholder{padding:calc(var(--ck-spacing-standard)*3);background:var(--ck-color-base-foreground)}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__icon{min-width:var(--ck-media-embed-placeholder-icon-size);height:var(--ck-media-embed-placeholder-icon-size);margin-bottom:var(--ck-spacing-large);background-position:50%;background-size:cover}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__icon .ck-icon{width:100%;height:100%}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url__text{color:var(--ck-color-media-embed-placeholder-url-text);white-space:nowrap;text-align:center;font-style:italic;text-overflow:ellipsis}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url__text:hover{color:var(--ck-color-media-embed-placeholder-url-text-hover);cursor:pointer;text-decoration:underline}.ck-media__wrapper[data-oembed-url*="open.spotify.com"]{max-width:300px;max-height:380px}.ck-media__wrapper[data-oembed-url*="goo.gl/maps"] .ck-media__placeholder__icon,.ck-media__wrapper[data-oembed-url*="google.com/maps"] .ck-media__placeholder__icon,.ck-media__wrapper[data-oembed-url*="maps.app.goo.gl"] .ck-media__placeholder__icon,.ck-media__wrapper[data-oembed-url*="maps.google.com"] .ck-media__placeholder__icon{background-image:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNTAuMzc4IiBoZWlnaHQ9IjI1NC4xNjciIHZpZXdCb3g9IjAgMCA2Ni4yNDYgNjcuMjQ4Ij48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTcyLjUzMSAtMjE4LjQ1NSkgc2NhbGUoLjk4MDEyKSI+PHJlY3Qgcnk9IjUuMjM4IiByeD0iNS4yMzgiIHk9IjIzMS4zOTkiIHg9IjE3Ni4wMzEiIGhlaWdodD0iNjAuMDk5IiB3aWR0aD0iNjAuMDk5IiBmaWxsPSIjMzRhNjY4IiBwYWludC1vcmRlcj0ibWFya2VycyBzdHJva2UgZmlsbCIvPjxwYXRoIGQ9Ik0yMDYuNDc3IDI2MC45bC0yOC45ODcgMjguOTg3YTUuMjE4IDUuMjE4IDAgMDAzLjc4IDEuNjFoNDkuNjIxYzEuNjk0IDAgMy4xOS0uNzk4IDQuMTQ2LTIuMDM3eiIgZmlsbD0iIzVjODhjNSIvPjxwYXRoIGQ9Ik0yMjYuNzQyIDIyMi45ODhjLTkuMjY2IDAtMTYuNzc3IDcuMTctMTYuNzc3IDE2LjAxNC4wMDcgMi43NjIuNjYzIDUuNDc0IDIuMDkzIDcuODc1LjQzLjcwMy44MyAxLjQwOCAxLjE5IDIuMTA3LjMzMy41MDIuNjUgMS4wMDUuOTUgMS41MDguMzQzLjQ3Ny42NzMuOTU3Ljk4OCAxLjQ0IDEuMzEgMS43NjkgMi41IDMuNTAyIDMuNjM3IDUuMTY4Ljc5MyAxLjI3NSAxLjY4MyAyLjY0IDIuNDY2IDMuOTkgMi4zNjMgNC4wOTQgNC4wMDcgOC4wOTIgNC42IDEzLjkxNHYuMDEyYy4xODIuNDEyLjUxNi42NjYuODc5LjY2Ny40MDMtLjAwMS43NjgtLjMxNC45My0uNzk5LjYwMy01Ljc1NiAyLjIzOC05LjcyOSA0LjU4NS0xMy43OTQuNzgyLTEuMzUgMS42NzMtMi43MTUgMi40NjUtMy45OSAxLjEzNy0xLjY2NiAyLjMyOC0zLjQgMy42MzgtNS4xNjkuMzE1LS40ODIuNjQ1LS45NjIuOTg4LTEuNDM5LjMtLjUwMy42MTctMS4wMDYuOTUtMS41MDguMzU5LS43Ljc2LTEuNDA0IDEuMTktMi4xMDcgMS40MjYtMi40MDIgMi01LjExNCAyLjAwNC03Ljg3NSAwLTguODQ0LTcuNTExLTE2LjAxNC0xNi43NzYtMTYuMDE0eiIgZmlsbD0iI2RkNGIzZSIgcGFpbnQtb3JkZXI9Im1hcmtlcnMgc3Ryb2tlIGZpbGwiLz48ZWxsaXBzZSByeT0iNS41NjQiIHJ4PSI1LjgyOCIgY3k9IjIzOS4wMDIiIGN4PSIyMjYuNzQyIiBmaWxsPSIjODAyZDI3IiBwYWludC1vcmRlcj0ibWFya2VycyBzdHJva2UgZmlsbCIvPjxwYXRoIGQ9Ik0xOTAuMzAxIDIzNy4yODNjLTQuNjcgMC04LjQ1NyAzLjg1My04LjQ1NyA4LjYwNnMzLjc4NiA4LjYwNyA4LjQ1NyA4LjYwN2MzLjA0MyAwIDQuODA2LS45NTggNi4zMzctMi41MTYgMS41My0xLjU1NyAyLjA4Ny0zLjkxMyAyLjA4Ny02LjI5IDAtLjM2Mi0uMDIzLS43MjItLjA2NC0xLjA3OWgtOC4yNTd2My4wNDNoNC44NWMtLjE5Ny43NTktLjUzMSAxLjQ1LTEuMDU4IDEuOTg2LS45NDIuOTU4LTIuMDI4IDEuNTQ4LTMuOTAxIDEuNTQ4LTIuODc2IDAtNS4yMDgtMi4zNzItNS4yMDgtNS4yOTkgMC0yLjkyNiAyLjMzMi01LjI5OSA1LjIwOC01LjI5OSAxLjM5OSAwIDIuNjE4LjQwNyAzLjU4NCAxLjI5M2wyLjM4MS0yLjM4YzAtLjAwMi0uMDAzLS4wMDQtLjAwNC0uMDA1LTEuNTg4LTEuNTI0LTMuNjItMi4yMTUtNS45NTUtMi4yMTV6bTQuNDMgNS42NmwuMDAzLjAwNnYtLjAwM3oiIGZpbGw9IiNmZmYiIHBhaW50LW9yZGVyPSJtYXJrZXJzIHN0cm9rZSBmaWxsIi8+PHBhdGggZD0iTTIxNS4xODQgMjUxLjkyOWwtNy45OCA3Ljk3OSAyOC40NzcgMjguNDc1YTUuMjMzIDUuMjMzIDAgMDAuNDQ5LTIuMTIzdi0zMS4xNjVjLS40NjkuNjc1LS45MzQgMS4zNDktMS4zODIgMi4wMDUtLjc5MiAxLjI3NS0xLjY4MiAyLjY0LTIuNDY1IDMuOTktMi4zNDcgNC4wNjUtMy45ODIgOC4wMzgtNC41ODUgMTMuNzk0LS4xNjIuNDg1LS41MjcuNzk4LS45My43OTktLjM2My0uMDAxLS42OTctLjI1NS0uODc5LS42Njd2LS4wMTJjLS41OTMtNS44MjItMi4yMzctOS44Mi00LjYtMTMuOTE0LS43ODMtMS4zNS0xLjY3My0yLjcxNS0yLjQ2Ni0zLjk5LTEuMTM3LTEuNjY2LTIuMzI3LTMuNC0zLjYzNy01LjE2OWwtLjAwMi0uMDAzeiIgZmlsbD0iI2MzYzNjMyIvPjxwYXRoIGQ9Ik0yMTIuOTgzIDI0OC40OTVsLTM2Ljk1MiAzNi45NTN2LjgxMmE1LjIyNyA1LjIyNyAwIDAwNS4yMzggNS4yMzhoMS4wMTVsMzUuNjY2LTM1LjY2NmExMzYuMjc1IDEzNi4yNzUgMCAwMC0yLjc2NC0zLjkgMzcuNTc1IDM3LjU3NSAwIDAwLS45ODktMS40NCAzNS4xMjcgMzUuMTI3IDAgMDAtLjk1LTEuNTA4Yy0uMDgzLS4xNjItLjE3Ni0uMzI2LS4yNjQtLjQ4OXoiIGZpbGw9IiNmZGRjNGYiIHBhaW50LW9yZGVyPSJtYXJrZXJzIHN0cm9rZSBmaWxsIi8+PHBhdGggZD0iTTIxMS45OTggMjYxLjA4M2wtNi4xNTIgNi4xNTEgMjQuMjY0IDI0LjI2NGguNzgxYTUuMjI3IDUuMjI3IDAgMDA1LjIzOS01LjIzOHYtMS4wNDV6IiBmaWxsPSIjZmZmIiBwYWludC1vcmRlcj0ibWFya2VycyBzdHJva2UgZmlsbCIvPjwvZz48L3N2Zz4=)}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder{background:#4268b3}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder .ck-media__placeholder__icon{background-image:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAyNCIgaGVpZ2h0PSIxMDI0IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Ik05NjcuNDg0IDBINTYuNTE3QzI1LjMwNCAwIDAgMjUuMzA0IDAgNTYuNTE3djkxMC45NjZDMCA5OTguNjk0IDI1LjI5NyAxMDI0IDU2LjUyMiAxMDI0SDU0N1Y2MjhINDE0VjQ3M2gxMzNWMzU5LjAyOWMwLTEzMi4yNjIgODAuNzczLTIwNC4yODIgMTk4Ljc1Ni0yMDQuMjgyIDU2LjUxMyAwIDEwNS4wODYgNC4yMDggMTE5LjI0NCA2LjA4OVYyOTlsLTgxLjYxNi4wMzdjLTYzLjk5MyAwLTc2LjM4NCAzMC40OTItNzYuMzg0IDc1LjIzNlY0NzNoMTUzLjQ4N2wtMTkuOTg2IDE1NUg3MDd2Mzk2aDI2MC40ODRjMzEuMjEzIDAgNTYuNTE2LTI1LjMwMyA1Ni41MTYtNTYuNTE2VjU2LjUxNUMxMDI0IDI1LjMwMyA5OTguNjk3IDAgOTY3LjQ4NCAwIiBmaWxsPSIjRkZGRkZFIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=)}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder .ck-media__placeholder__url__text{color:#cdf}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder .ck-media__placeholder__url__text:hover{color:#fff}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder{background:linear-gradient(-135deg,#1400c7,#b800b1,#f50000)}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder .ck-media__placeholder__icon{background-image:url(data:image/svg+xml;base64,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)}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder .ck-media__placeholder__url__text{color:#ffe0fe}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder .ck-media__placeholder__url__text:hover{color:#fff}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder{background:linear-gradient(90deg,#71c6f4,#0d70a5)}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder .ck-media__placeholder__icon{background-image:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0MDAgNDAwIj48cGF0aCBkPSJNNDAwIDIwMGMwIDExMC41LTg5LjUgMjAwLTIwMCAyMDBTMCAzMTAuNSAwIDIwMCA4OS41IDAgMjAwIDBzMjAwIDg5LjUgMjAwIDIwMHpNMTYzLjQgMzA1LjVjODguNyAwIDEzNy4yLTczLjUgMTM3LjItMTM3LjIgMC0yLjEgMC00LjItLjEtNi4yIDkuNC02LjggMTcuNi0xNS4zIDI0LjEtMjUtOC42IDMuOC0xNy45IDYuNC0yNy43IDcuNiAxMC02IDE3LjYtMTUuNCAyMS4yLTI2LjctOS4zIDUuNS0xOS42IDkuNS0zMC42IDExLjctOC44LTkuNC0yMS4zLTE1LjItMzUuMi0xNS4yLTI2LjYgMC00OC4yIDIxLjYtNDguMiA0OC4yIDAgMy44LjQgNy41IDEuMyAxMS00MC4xLTItNzUuNi0yMS4yLTk5LjQtNTAuNC00LjEgNy4xLTYuNSAxNS40LTYuNSAyNC4yIDAgMTYuNyA4LjUgMzEuNSAyMS41IDQwLjEtNy45LS4yLTE1LjMtMi40LTIxLjgtNnYuNmMwIDIzLjQgMTYuNiA0Mi44IDM4LjcgNDcuMy00IDEuMS04LjMgMS43LTEyLjcgMS43LTMuMSAwLTYuMS0uMy05LjEtLjkgNi4xIDE5LjIgMjMuOSAzMy4xIDQ1IDMzLjUtMTYuNSAxMi45LTM3LjMgMjAuNi01OS45IDIwLjYtMy45IDAtNy43LS4yLTExLjUtLjcgMjEuMSAxMy44IDQ2LjUgMjEuOCA3My43IDIxLjgiIGZpbGw9IiNmZmYiLz48L3N2Zz4=)}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder .ck-media__placeholder__url__text{color:#b8e6ff}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder .ck-media__placeholder__url__text:hover{color:#fff}';
  }, function (e, t, i) {
    var n = i(1),
        o = i(97);
    "string" == typeof (o = o.__esModule ? o.default : o) && (o = [[e.i, o, ""]]);
    var r = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": !0
      },
      insert: "head",
      singleton: !0
    };
    n(o, r);
    e.exports = o.locals || {};
  }, function (e, t) {
    e.exports = ".ck.ck-media-form{display:flex;align-items:flex-start;flex-direction:row;flex-wrap:nowrap}.ck.ck-media-form .ck-labeled-field-view{display:inline-block}.ck.ck-media-form .ck-label{display:none}@media screen and (max-width:600px){.ck.ck-media-form{flex-wrap:wrap}.ck.ck-media-form .ck-labeled-field-view{flex-basis:100%}.ck.ck-media-form .ck-button{flex-basis:50%}}";
  }, function (e, t, i) {
    var n = i(1),
        o = i(99);
    "string" == typeof (o = o.__esModule ? o.default : o) && (o = [[e.i, o, ""]]);
    var r = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": !0
      },
      insert: "head",
      singleton: !0
    };
    n(o, r);
    e.exports = o.locals || {};
  }, function (e, t) {
    e.exports = ".ck-content .media{clear:both;margin:.9em 0;display:block;min-width:15em}";
  }, function (e, t, i) {
    var n = i(1),
        o = i(101);
    "string" == typeof (o = o.__esModule ? o.default : o) && (o = [[e.i, o, ""]]);
    var r = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": !0
      },
      insert: "head",
      singleton: !0
    };
    n(o, r);
    e.exports = o.locals || {};
  }, function (e, t) {
    e.exports = ":root{--ck-color-table-focused-cell-background:rgba(158,207,250,0.3)}.ck-widget.table td.ck-editor__nested-editable.ck-editor__nested-editable_focused,.ck-widget.table td.ck-editor__nested-editable:focus,.ck-widget.table th.ck-editor__nested-editable.ck-editor__nested-editable_focused,.ck-widget.table th.ck-editor__nested-editable:focus{background:var(--ck-color-table-focused-cell-background);border-style:none;outline:1px solid var(--ck-color-focus-border);outline-offset:-1px}";
  }, function (e, t, i) {
    var n = i(1),
        o = i(103);
    "string" == typeof (o = o.__esModule ? o.default : o) && (o = [[e.i, o, ""]]);
    var r = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": !0
      },
      insert: "head",
      singleton: !0
    };
    n(o, r);
    e.exports = o.locals || {};
  }, function (e, t) {
    e.exports = ".ck .ck-insert-table-dropdown__grid{display:flex;flex-direction:row;flex-wrap:wrap}:root{--ck-insert-table-dropdown-padding:10px;--ck-insert-table-dropdown-box-height:11px;--ck-insert-table-dropdown-box-width:12px;--ck-insert-table-dropdown-box-margin:1px}.ck .ck-insert-table-dropdown__grid{width:calc(var(--ck-insert-table-dropdown-box-width)*10 + var(--ck-insert-table-dropdown-box-margin)*20 + var(--ck-insert-table-dropdown-padding)*2);padding:var(--ck-insert-table-dropdown-padding) var(--ck-insert-table-dropdown-padding) 0}.ck .ck-insert-table-dropdown__label{text-align:center}.ck .ck-insert-table-dropdown-grid-box{width:var(--ck-insert-table-dropdown-box-width);height:var(--ck-insert-table-dropdown-box-height);margin:var(--ck-insert-table-dropdown-box-margin);border:1px solid var(--ck-color-base-border);border-radius:1px}.ck .ck-insert-table-dropdown-grid-box.ck-on{border-color:var(--ck-color-focus-border);background:var(--ck-color-focus-outer-shadow)}";
  }, function (e, t, i) {
    var n = i(1),
        o = i(105);
    "string" == typeof (o = o.__esModule ? o.default : o) && (o = [[e.i, o, ""]]);
    var r = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": !0
      },
      insert: "head",
      singleton: !0
    };
    n(o, r);
    e.exports = o.locals || {};
  }, function (e, t) {
    e.exports = ':root{--ck-table-selected-cell-background:rgba(158,207,250,0.3)}.ck.ck-editor__editable .table table td.ck-editor__editable_selected,.ck.ck-editor__editable .table table th.ck-editor__editable_selected{position:relative;caret-color:transparent;outline:unset;box-shadow:unset}.ck.ck-editor__editable .table table td.ck-editor__editable_selected:after,.ck.ck-editor__editable .table table th.ck-editor__editable_selected:after{content:"";pointer-events:none;background-color:var(--ck-table-selected-cell-background);position:absolute;top:0;left:0;right:0;bottom:0}.ck.ck-editor__editable .table table td.ck-editor__editable_selected ::selection,.ck.ck-editor__editable .table table td.ck-editor__editable_selected:focus,.ck.ck-editor__editable .table table th.ck-editor__editable_selected ::selection,.ck.ck-editor__editable .table table th.ck-editor__editable_selected:focus{background-color:transparent}.ck.ck-editor__editable .table table td.ck-editor__editable_selected .ck-widget_selected,.ck.ck-editor__editable .table table th.ck-editor__editable_selected .ck-widget_selected{outline:unset}';
  }, function (e, t, i) {
    var n = i(1),
        o = i(107);
    "string" == typeof (o = o.__esModule ? o.default : o) && (o = [[e.i, o, ""]]);
    var r = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": !0
      },
      insert: "head",
      singleton: !0
    };
    n(o, r);
    e.exports = o.locals || {};
  }, function (e, t) {
    e.exports = ".ck-content .table{margin:.9em auto;display:table}.ck-content .table table{border-collapse:collapse;border-spacing:0;width:100%;height:100%;border:1px double #b3b3b3}.ck-content .table table td,.ck-content .table table th{min-width:2em;padding:.4em;border:1px solid #bfbfbf}.ck-content .table table th{font-weight:700;background:hsla(0,0%,0%,5%)}.ck-content[dir=rtl] .table th{text-align:right}.ck-content[dir=ltr] .table th{text-align:left}.ck-editor__editable .ck-table-bogus-paragraph{display:inline-block;width:100%}";
  }, function (e, t, i) {
    var n = i(1),
        o = i(109);
    "string" == typeof (o = o.__esModule ? o.default : o) && (o = [[e.i, o, ""]]);
    var r = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": !0
      },
      insert: "head",
      singleton: !0
    };
    n(o, r);
    e.exports = o.locals || {};
  }, function (e, t) {
    e.exports = '.ck-source-editing-area{display:inline-grid;width:100%;font-family:monospace}.ck-source-editing-area:after,.ck-source-editing-area textarea{grid-area:1/1;padding:var(--ck-spacing-large);margin:0;border:1px solid transparent;line-height:var(--ck-line-height-base);font-size:var(--ck-font-size-normal);white-space:pre-wrap}.ck-source-editing-area:after{content:attr(data-value) " ";visibility:hidden}.ck-source-editing-area textarea{resize:none;outline:none;overflow:hidden;border-color:var(--ck-color-base-border);border-radius:0}.ck-rounded-corners .ck-source-editing-area textarea,.ck-source-editing-area textarea.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0;border-top-right-radius:0}.ck-source-editing-area textarea:not([readonly]):focus{outline:none;border:var(--ck-focus-ring);box-shadow:var(--ck-inner-shadow),0 0}';
  }, function (e, t, i) {
    "use strict";

    var _marked =
    /*#__PURE__*/
    _regeneratorRuntime.mark(mc),
        _marked2 =
    /*#__PURE__*/
    _regeneratorRuntime.mark(fc),
        _marked3 =
    /*#__PURE__*/
    _regeneratorRuntime.mark(xh);

    i.r(t), i.d(t, "default", function () {
      return Mw;
    });

    var n = function n() {
      return function e() {
        e.called = !0;
      };
    };

    var o = function o(e, t) {
      _classCallCheck(this, o);

      this.source = e, this.name = t, this.path = [], this.stop = n(), this.off = n();
    };

    var r = new Array(256).fill().map(function (e, t) {
      return ("0" + t.toString(16)).slice(-2);
    });

    function s() {
      var e = 4294967296 * Math.random() >>> 0,
          t = 4294967296 * Math.random() >>> 0,
          i = 4294967296 * Math.random() >>> 0,
          n = 4294967296 * Math.random() >>> 0;
      return "e" + r[e >> 0 & 255] + r[e >> 8 & 255] + r[e >> 16 & 255] + r[e >> 24 & 255] + r[t >> 0 & 255] + r[t >> 8 & 255] + r[t >> 16 & 255] + r[t >> 24 & 255] + r[i >> 0 & 255] + r[i >> 8 & 255] + r[i >> 16 & 255] + r[i >> 24 & 255] + r[n >> 0 & 255] + r[n >> 8 & 255] + r[n >> 16 & 255] + r[n >> 24 & 255];
    }

    var a = {
      get: function get(e) {
        return "number" != typeof e ? this[e] || this.normal : e;
      },
      highest: 1e5,
      high: 1e3,
      normal: 0,
      low: -1e3,
      lowest: -1e5
    },
        c = (i(6), i(0));
    var l = Symbol("listeningTo"),
        d = Symbol("emitterId");
    var h = {
      on: function on(e, t) {
        var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        this.listenTo(this, e, t, i);
      },
      once: function once(e, t, i) {
        var n = !1;
        this.listenTo(this, e, function (e) {
          for (var _len = arguments.length, i = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            i[_key - 1] = arguments[_key];
          }

          n || (n = !0, e.off(), t.call.apply(t, [this, e].concat(i)));
        }, i);
      },
      off: function off(e, t) {
        this.stopListening(this, e, t);
      },
      listenTo: function listenTo(e, t, i) {
        var n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        var o, r;
        this[l] || (this[l] = {});
        var s = this[l];
        g(e) || u(e);
        var a = g(e);
        (o = s[a]) || (o = s[a] = {
          emitter: e,
          callbacks: {}
        }), (r = o.callbacks[t]) || (r = o.callbacks[t] = []), r.push(i), function (e, t, i, n, o) {
          t._addEventListener ? t._addEventListener(i, n, o) : e._addEventListener.call(t, i, n, o);
        }(this, e, t, i, n);
      },
      stopListening: function stopListening(e, t, i) {
        var n = this[l];
        var o = e && g(e);
        var r = n && o && n[o],
            s = r && t && r.callbacks[t];
        if (!(!n || e && !r || t && !s)) if (i) {
          b(this, e, t, i);
          -1 !== s.indexOf(i) && (1 === s.length ? delete r.callbacks[t] : b(this, e, t, i));
        } else if (s) {
          for (; i = s.pop();) {
            b(this, e, t, i);
          }

          delete r.callbacks[t];
        } else if (r) {
          for (t in r.callbacks) {
            this.stopListening(e, t);
          }

          delete n[o];
        } else {
          for (o in n) {
            this.stopListening(n[o].emitter);
          }

          delete this[l];
        }
      },
      fire: function fire(e) {
        try {
          var _i2 = e instanceof o ? e : new o(this, e),
              _n2 = _i2.name;

          var _r2 = function e(t, i) {
            var n;
            if (!t._events || !(n = t._events[i]) || !n.callbacks.length) return i.indexOf(":") > -1 ? e(t, i.substr(0, i.lastIndexOf(":"))) : null;
            return n.callbacks;
          }(this, _n2);

          for (var _len2 = arguments.length, t = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            t[_key2 - 1] = arguments[_key2];
          }

          if (_i2.path.push(this), _r2) {
            var _e2 = [_i2].concat(t);

            _r2 = Array.from(_r2);

            for (var _t2 = 0; _t2 < _r2.length && (_r2[_t2].callback.apply(this, _e2), _i2.off.called && (delete _i2.off.called, this._removeEventListener(_n2, _r2[_t2].callback)), !_i2.stop.called); _t2++) {
              ;
            }
          }

          if (this._delegations) {
            var _e3 = this._delegations.get(_n2),
                _o2 = this._delegations.get("*");

            _e3 && p(_e3, _i2, t), _o2 && p(_o2, _i2, t);
          }

          return _i2.return;
        } catch (e) {
          c.a.rethrowUnexpectedError(e, this);
        }
      },
      delegate: function delegate() {
        var _this2 = this;

        for (var _len3 = arguments.length, e = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          e[_key3] = arguments[_key3];
        }

        return {
          to: function to(t, i) {
            _this2._delegations || (_this2._delegations = new Map()), e.forEach(function (e) {
              var n = _this2._delegations.get(e);

              n ? n.set(t, i) : _this2._delegations.set(e, new Map([[t, i]]));
            });
          }
        };
      },
      stopDelegating: function stopDelegating(e, t) {
        if (this._delegations) if (e) {
          if (t) {
            var _i3 = this._delegations.get(e);

            _i3 && _i3.delete(t);
          } else this._delegations.delete(e);
        } else this._delegations.clear();
      },
      _addEventListener: function _addEventListener(e, t, i) {
        !function (e, t) {
          var i = m(e);
          if (i[t]) return;
          var n = t,
              o = null;
          var r = [];

          for (; "" !== n && !i[n];) {
            i[n] = {
              callbacks: [],
              childEvents: []
            }, r.push(i[n]), o && i[n].childEvents.push(o), o = n, n = n.substr(0, n.lastIndexOf(":"));
          }

          if ("" !== n) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = r[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var _e4 = _step.value;
                _e4.callbacks = i[n].callbacks.slice();
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }

            i[n].childEvents.push(o);
          }
        }(this, e);
        var n = f(this, e),
            o = a.get(i.priority),
            r = {
          callback: t,
          priority: o
        };
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = n[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var _e5 = _step2.value;

            var _t3 = !1;

            for (var _i4 = 0; _i4 < _e5.length; _i4++) {
              if (_e5[_i4].priority < o) {
                _e5.splice(_i4, 0, r), _t3 = !0;
                break;
              }
            }

            _t3 || _e5.push(r);
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      },
      _removeEventListener: function _removeEventListener(e, t) {
        var i = f(this, e);
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = i[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var _e6 = _step3.value;

            for (var _i5 = 0; _i5 < _e6.length; _i5++) {
              _e6[_i5].callback == t && (_e6.splice(_i5, 1), _i5--);
            }
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }
      }
    };

    function u(e, t) {
      e[d] || (e[d] = t || s());
    }

    function g(e) {
      return e[d];
    }

    function m(e) {
      return e._events || Object.defineProperty(e, "_events", {
        value: {}
      }), e._events;
    }

    function f(e, t) {
      var i = m(e)[t];
      if (!i) return [];
      var n = [i.callbacks];

      for (var _t4 = 0; _t4 < i.childEvents.length; _t4++) {
        var _o3 = f(e, i.childEvents[_t4]);

        n = n.concat(_o3);
      }

      return n;
    }

    function p(e, t, i) {
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = e[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var _ref3 = _step4.value;

          var _ref2 = _slicedToArray(_ref3, 2);

          var _n3 = _ref2[0];
          var _r3 = _ref2[1];
          _r3 ? "function" == typeof _r3 && (_r3 = _r3(t.name)) : _r3 = t.name;

          var _e7 = new o(t.source, _r3);

          _e7.path = _toConsumableArray(t.path), _n3.fire.apply(_n3, [_e7].concat(_toConsumableArray(i)));
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }
    }

    function b(e, t, i, n) {
      t._removeEventListener ? t._removeEventListener(i, n) : e._removeEventListener.call(t, i, n);
    }

    var w = function w(e) {
      var t = typeof e;
      return null != e && ("object" == t || "function" == t);
    },
        k = i(3),
        _ = k.a.Symbol,
        v = Object.prototype,
        y = v.hasOwnProperty,
        x = v.toString,
        A = _ ? _.toStringTag : void 0;

    var C = function C(e) {
      var t = y.call(e, A),
          i = e[A];

      try {
        e[A] = void 0;
        var n = !0;
      } catch (e) {}

      var o = x.call(e);
      return n && (t ? e[A] = i : delete e[A]), o;
    },
        T = Object.prototype.toString;

    var E = function E(e) {
      return T.call(e);
    },
        S = _ ? _.toStringTag : void 0;

    var I = function I(e) {
      return null == e ? void 0 === e ? "[object Undefined]" : "[object Null]" : S && S in Object(e) ? C(e) : E(e);
    };

    var P,
        M = function M(e) {
      if (!w(e)) return !1;
      var t = I(e);
      return "[object Function]" == t || "[object GeneratorFunction]" == t || "[object AsyncFunction]" == t || "[object Proxy]" == t;
    },
        N = k.a["__core-js_shared__"],
        R = (P = /[^.]+$/.exec(N && N.keys && N.keys.IE_PROTO || "")) ? "Symbol(src)_1." + P : "";

    var O = function O(e) {
      return !!R && R in e;
    },
        z = Function.prototype.toString;

    var D = function D(e) {
      if (null != e) {
        try {
          return z.call(e);
        } catch (e) {}

        try {
          return e + "";
        } catch (e) {}
      }

      return "";
    },
        L = /^\[object .+?Constructor\]$/,
        V = Function.prototype,
        j = Object.prototype,
        B = V.toString,
        F = j.hasOwnProperty,
        H = RegExp("^" + B.call(F).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");

    var U = function U(e) {
      return !(!w(e) || O(e)) && (M(e) ? H : L).test(D(e));
    };

    var W = function W(e, t) {
      return null == e ? void 0 : e[t];
    };

    var q = function q(e, t) {
      var i = W(e, t);
      return U(i) ? i : void 0;
    },
        $ = function () {
      try {
        var e = q(Object, "defineProperty");
        return e({}, "", {}), e;
      } catch (e) {}
    }();

    var Y = function Y(e, t, i) {
      "__proto__" == t && $ ? $(e, t, {
        configurable: !0,
        enumerable: !0,
        value: i,
        writable: !0
      }) : e[t] = i;
    };

    var G = function G(e, t) {
      return e === t || e != e && t != t;
    },
        K = Object.prototype.hasOwnProperty;

    var Q = function Q(e, t, i) {
      var n = e[t];
      K.call(e, t) && G(n, i) && (void 0 !== i || t in e) || Y(e, t, i);
    };

    var J = function J(e, t, i, n) {
      var o = !i;
      i || (i = {});

      for (var r = -1, s = t.length; ++r < s;) {
        var a = t[r],
            c = n ? n(i[a], e[a], a, i, e) : void 0;
        void 0 === c && (c = e[a]), o ? Y(i, a, c) : Q(i, a, c);
      }

      return i;
    };

    var Z = function Z(e) {
      return e;
    };

    var X = function X(e, t, i) {
      switch (i.length) {
        case 0:
          return e.call(t);

        case 1:
          return e.call(t, i[0]);

        case 2:
          return e.call(t, i[0], i[1]);

        case 3:
          return e.call(t, i[0], i[1], i[2]);
      }

      return e.apply(t, i);
    },
        ee = Math.max;

    var te = function te(e, t, i) {
      return t = ee(void 0 === t ? e.length - 1 : t, 0), function () {
        for (var n = arguments, o = -1, r = ee(n.length - t, 0), s = Array(r); ++o < r;) {
          s[o] = n[t + o];
        }

        o = -1;

        for (var a = Array(t + 1); ++o < t;) {
          a[o] = n[o];
        }

        return a[t] = i(s), X(e, this, a);
      };
    };

    var ie = function ie(e) {
      return function () {
        return e;
      };
    },
        ne = $ ? function (e, t) {
      return $(e, "toString", {
        configurable: !0,
        enumerable: !1,
        value: ie(t),
        writable: !0
      });
    } : Z,
        oe = Date.now;

    var re = function (e) {
      var t = 0,
          i = 0;
      return function () {
        var n = oe(),
            o = 16 - (n - i);

        if (i = n, o > 0) {
          if (++t >= 800) return arguments[0];
        } else t = 0;

        return e.apply(void 0, arguments);
      };
    }(ne);

    var se = function se(e, t) {
      return re(te(e, t, Z), e + "");
    };

    var ae = function ae(e) {
      return "number" == typeof e && e > -1 && e % 1 == 0 && e <= 9007199254740991;
    };

    var ce = function ce(e) {
      return null != e && ae(e.length) && !M(e);
    },
        le = /^(?:0|[1-9]\d*)$/;

    var de = function de(e, t) {
      var i = typeof e;
      return !!(t = null == t ? 9007199254740991 : t) && ("number" == i || "symbol" != i && le.test(e)) && e > -1 && e % 1 == 0 && e < t;
    };

    var he = function he(e, t, i) {
      if (!w(i)) return !1;
      var n = typeof t;
      return !!("number" == n ? ce(i) && de(t, i.length) : "string" == n && t in i) && G(i[t], e);
    };

    var ue = function ue(e) {
      return se(function (t, i) {
        var n = -1,
            o = i.length,
            r = o > 1 ? i[o - 1] : void 0,
            s = o > 2 ? i[2] : void 0;

        for (r = e.length > 3 && "function" == typeof r ? (o--, r) : void 0, s && he(i[0], i[1], s) && (r = o < 3 ? void 0 : r, o = 1), t = Object(t); ++n < o;) {
          var a = i[n];
          a && e(t, a, n, r);
        }

        return t;
      });
    };

    var ge = function ge(e, t) {
      for (var i = -1, n = Array(e); ++i < e;) {
        n[i] = t(i);
      }

      return n;
    };

    var me = function me(e) {
      return null != e && "object" == typeof e;
    };

    var fe = function fe(e) {
      return me(e) && "[object Arguments]" == I(e);
    },
        pe = Object.prototype,
        be = pe.hasOwnProperty,
        we = pe.propertyIsEnumerable,
        ke = fe(function () {
      return arguments;
    }()) ? fe : function (e) {
      return me(e) && be.call(e, "callee") && !we.call(e, "callee");
    },
        _e = Array.isArray,
        ve = i(4),
        ye = {};

    ye["[object Float32Array]"] = ye["[object Float64Array]"] = ye["[object Int8Array]"] = ye["[object Int16Array]"] = ye["[object Int32Array]"] = ye["[object Uint8Array]"] = ye["[object Uint8ClampedArray]"] = ye["[object Uint16Array]"] = ye["[object Uint32Array]"] = !0, ye["[object Arguments]"] = ye["[object Array]"] = ye["[object ArrayBuffer]"] = ye["[object Boolean]"] = ye["[object DataView]"] = ye["[object Date]"] = ye["[object Error]"] = ye["[object Function]"] = ye["[object Map]"] = ye["[object Number]"] = ye["[object Object]"] = ye["[object RegExp]"] = ye["[object Set]"] = ye["[object String]"] = ye["[object WeakMap]"] = !1;

    var xe = function xe(e) {
      return me(e) && ae(e.length) && !!ye[I(e)];
    };

    var Ae = function Ae(e) {
      return function (t) {
        return e(t);
      };
    },
        Ce = i(5),
        Te = Ce.a && Ce.a.isTypedArray,
        Ee = Te ? Ae(Te) : xe,
        Se = Object.prototype.hasOwnProperty;

    var Ie = function Ie(e, t) {
      var i = _e(e),
          n = !i && ke(e),
          o = !i && !n && Object(ve.a)(e),
          r = !i && !n && !o && Ee(e),
          s = i || n || o || r,
          a = s ? ge(e.length, String) : [],
          c = a.length;

      for (var l in e) {
        !t && !Se.call(e, l) || s && ("length" == l || o && ("offset" == l || "parent" == l) || r && ("buffer" == l || "byteLength" == l || "byteOffset" == l) || de(l, c)) || a.push(l);
      }

      return a;
    },
        Pe = Object.prototype;

    var Me = function Me(e) {
      var t = e && e.constructor;
      return e === ("function" == typeof t && t.prototype || Pe);
    };

    var Ne = function Ne(e) {
      var t = [];
      if (null != e) for (var i in Object(e)) {
        t.push(i);
      }
      return t;
    },
        Re = Object.prototype.hasOwnProperty;

    var Oe = function Oe(e) {
      if (!w(e)) return Ne(e);
      var t = Me(e),
          i = [];

      for (var n in e) {
        ("constructor" != n || !t && Re.call(e, n)) && i.push(n);
      }

      return i;
    };

    var ze = function ze(e) {
      return ce(e) ? Ie(e, !0) : Oe(e);
    },
        De = ue(function (e, t) {
      J(t, ze(t), e);
    });

    var Le = Symbol("observableProperties"),
        Ve = Symbol("boundObservables"),
        je = Symbol("boundProperties"),
        Be = Symbol("decoratedMethods"),
        Fe = Symbol("decoratedOriginal"),
        He = {
      set: function set(e, t) {
        var _this3 = this;

        if (w(e)) return void Object.keys(e).forEach(function (t) {
          _this3.set(t, e[t]);
        }, this);
        We(this);
        var i = this[Le];
        if (e in this && !i.has(e)) throw new c.a("observable-set-cannot-override", this);
        Object.defineProperty(this, e, {
          enumerable: !0,
          configurable: !0,
          get: function get() {
            return i.get(e);
          },
          set: function set(t) {
            var n = i.get(e);
            var o = this.fire("set:" + e, e, t, n);
            void 0 === o && (o = t), n === o && i.has(e) || (i.set(e, o), this.fire("change:" + e, e, o, n));
          }
        }), this[e] = t;
      },
      bind: function bind() {
        var _this4 = this;

        for (var _len4 = arguments.length, e = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
          e[_key4] = arguments[_key4];
        }

        if (!e.length || !Ye(e)) throw new c.a("observable-bind-wrong-properties", this);
        if (new Set(e).size !== e.length) throw new c.a("observable-bind-duplicate-properties", this);
        We(this);
        var t = this[je];
        e.forEach(function (e) {
          if (t.has(e)) throw new c.a("observable-bind-rebind", _this4);
        });
        var i = new Map();
        return e.forEach(function (e) {
          var n = {
            property: e,
            to: []
          };
          t.set(e, n), i.set(e, n);
        }), {
          to: qe,
          toMany: $e,
          _observable: this,
          _bindProperties: e,
          _to: [],
          _bindings: i
        };
      },
      unbind: function unbind() {
        var _this5 = this;

        if (!this[Le]) return;
        var t = this[je],
            i = this[Ve];

        for (var _len5 = arguments.length, e = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
          e[_key5] = arguments[_key5];
        }

        if (e.length) {
          if (!Ye(e)) throw new c.a("observable-unbind-wrong-properties", this);
          e.forEach(function (e) {
            var n = t.get(e);
            if (!n) return;
            var o, r, s, a;
            n.to.forEach(function (e) {
              o = e[0], r = e[1], s = i.get(o), a = s[r], a.delete(n), a.size || delete s[r], Object.keys(s).length || (i.delete(o), _this5.stopListening(o, "change"));
            }), t.delete(e);
          });
        } else i.forEach(function (e, t) {
          _this5.stopListening(t, "change");
        }), i.clear(), t.clear();
      },
      decorate: function decorate(e) {
        var _this6 = this;

        var t = this[e];
        if (!t) throw new c.a("observablemixin-cannot-decorate-undefined", this, {
          object: this,
          methodName: e
        });
        this.on(e, function (e, i) {
          e.return = t.apply(_this6, i);
        }), this[e] = function () {
          for (var _len6 = arguments.length, t = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
            t[_key6] = arguments[_key6];
          }

          return this.fire(e, t);
        }, this[e][Fe] = t, this[Be] || (this[Be] = []), this[Be].push(e);
      }
    };
    De(He, h), He.stopListening = function (e, t, i) {
      if (!e && this[Be]) {
        var _iteratorNormalCompletion5 = true;
        var _didIteratorError5 = false;
        var _iteratorError5 = undefined;

        try {
          for (var _iterator5 = this[Be][Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
            var _e8 = _step5.value;
            this[_e8] = this[_e8][Fe];
          }
        } catch (err) {
          _didIteratorError5 = true;
          _iteratorError5 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
              _iterator5.return();
            }
          } finally {
            if (_didIteratorError5) {
              throw _iteratorError5;
            }
          }
        }

        delete this[Be];
      }

      h.stopListening.call(this, e, t, i);
    };
    var Ue = He;

    function We(e) {
      e[Le] || (Object.defineProperty(e, Le, {
        value: new Map()
      }), Object.defineProperty(e, Ve, {
        value: new Map()
      }), Object.defineProperty(e, je, {
        value: new Map()
      }));
    }

    function qe() {
      var _this7 = this;

      var t = function () {
        for (var _len7 = arguments.length, e = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
          e[_key7] = arguments[_key7];
        }

        if (!e.length) throw new c.a("observable-bind-to-parse-error", null);
        var t = {
          to: []
        };
        var i;
        "function" == typeof e[e.length - 1] && (t.callback = e.pop());
        return e.forEach(function (e) {
          if ("string" == typeof e) i.properties.push(e);else {
            if ("object" != typeof e) throw new c.a("observable-bind-to-parse-error", null);
            i = {
              observable: e,
              properties: []
            }, t.to.push(i);
          }
        }), t;
      }.apply(void 0, arguments),
          i = Array.from(this._bindings.keys()),
          n = i.length;

      if (!t.callback && t.to.length > 1) throw new c.a("observable-bind-to-no-callback", this);
      if (n > 1 && t.callback) throw new c.a("observable-bind-to-extra-callback", this);
      var o;
      t.to.forEach(function (e) {
        if (e.properties.length && e.properties.length !== n) throw new c.a("observable-bind-to-properties-length", _this7);
        e.properties.length || (e.properties = _this7._bindProperties);
      }), this._to = t.to, t.callback && (this._bindings.get(i[0]).callback = t.callback), o = this._observable, this._to.forEach(function (e) {
        var t = o[Ve];
        var i;
        t.get(e.observable) || o.listenTo(e.observable, "change", function (n, r) {
          i = t.get(e.observable)[r], i && i.forEach(function (e) {
            Ge(o, e.property);
          });
        });
      }), function (e) {
        var t;

        e._bindings.forEach(function (i, n) {
          e._to.forEach(function (o) {
            t = o.properties[i.callback ? 0 : e._bindProperties.indexOf(n)], i.to.push([o.observable, t]), function (e, t, i, n) {
              var o = e[Ve],
                  r = o.get(i),
                  s = r || {};
              s[n] || (s[n] = new Set());
              s[n].add(t), r || o.set(i, s);
            }(e._observable, i, o.observable, t);
          });
        });
      }(this), this._bindProperties.forEach(function (e) {
        Ge(_this7._observable, e);
      });
    }

    function $e(e, t, i) {
      if (this._bindings.size > 1) throw new c.a("observable-bind-to-many-not-one-binding", this);
      this.to.apply(this, _toConsumableArray(function (e, t) {
        var i = e.map(function (e) {
          return [e, t];
        });
        return Array.prototype.concat.apply([], i);
      }(e, t)).concat([i]));
    }

    function Ye(e) {
      return e.every(function (e) {
        return "string" == typeof e;
      });
    }

    function Ge(e, t) {
      var i = e[je].get(t);
      var n;
      i.callback ? n = i.callback.apply(e, i.to.map(function (e) {
        return e[0][e[1]];
      })) : (n = i.to[0], n = n[0][n[1]]), Object.prototype.hasOwnProperty.call(e, t) ? e[t] = n : e.set(t, n);
    }

    function Ke(e) {
      for (var _len8 = arguments.length, t = new Array(_len8 > 1 ? _len8 - 1 : 0), _key8 = 1; _key8 < _len8; _key8++) {
        t[_key8 - 1] = arguments[_key8];
      }

      t.forEach(function (t) {
        Object.getOwnPropertyNames(t).concat(Object.getOwnPropertySymbols(t)).forEach(function (i) {
          if (i in e.prototype) return;
          var n = Object.getOwnPropertyDescriptor(t, i);
          n.enumerable = !1, Object.defineProperty(e.prototype, i, n);
        });
      });
    }

    var Qe =
    /*#__PURE__*/
    function () {
      function Qe(e) {
        _classCallCheck(this, Qe);

        this.editor = e, this.set("isEnabled", !0), this._disableStack = new Set();
      }

      _createClass(Qe, [{
        key: "forceDisabled",
        value: function forceDisabled(e) {
          this._disableStack.add(e), 1 == this._disableStack.size && (this.on("set:isEnabled", Je, {
            priority: "highest"
          }), this.isEnabled = !1);
        }
      }, {
        key: "clearForceDisabled",
        value: function clearForceDisabled(e) {
          this._disableStack.delete(e), 0 == this._disableStack.size && (this.off("set:isEnabled", Je), this.isEnabled = !0);
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.stopListening();
        }
      }], [{
        key: "isContextPlugin",
        get: function get() {
          return !1;
        }
      }]);

      return Qe;
    }();

    function Je(e) {
      e.return = !1, e.stop();
    }

    Ke(Qe, Ue);

    var Ze =
    /*#__PURE__*/
    function () {
      function Ze(e) {
        var _this8 = this;

        _classCallCheck(this, Ze);

        this.editor = e, this.set("value", void 0), this.set("isEnabled", !1), this._disableStack = new Set(), this.decorate("execute"), this.listenTo(this.editor.model.document, "change", function () {
          _this8.refresh();
        }), this.on("execute", function (e) {
          _this8.isEnabled || e.stop();
        }, {
          priority: "high"
        }), this.listenTo(e, "change:isReadOnly", function (e, t, i) {
          i ? _this8.forceDisabled("readOnlyMode") : _this8.clearForceDisabled("readOnlyMode");
        });
      }

      _createClass(Ze, [{
        key: "refresh",
        value: function refresh() {
          this.isEnabled = !0;
        }
      }, {
        key: "forceDisabled",
        value: function forceDisabled(e) {
          this._disableStack.add(e), 1 == this._disableStack.size && (this.on("set:isEnabled", Xe, {
            priority: "highest"
          }), this.isEnabled = !1);
        }
      }, {
        key: "clearForceDisabled",
        value: function clearForceDisabled(e) {
          this._disableStack.delete(e), 0 == this._disableStack.size && (this.off("set:isEnabled", Xe), this.refresh());
        }
      }, {
        key: "execute",
        value: function execute() {}
      }, {
        key: "destroy",
        value: function destroy() {
          this.stopListening();
        }
      }]);

      return Ze;
    }();

    function Xe(e) {
      e.return = !1, e.stop();
    }

    Ke(Ze, Ue);

    var et =
    /*#__PURE__*/
    function (_Ze) {
      _inherits(et, _Ze);

      function et(e) {
        var _this9;

        _classCallCheck(this, et);

        _this9 = _possibleConstructorReturn(this, _getPrototypeOf(et).call(this, e)), _this9._childCommands = [];
        return _this9;
      }

      _createClass(et, [{
        key: "refresh",
        value: function refresh() {}
      }, {
        key: "execute",
        value: function execute() {
          var t = this._getFirstEnabledCommand();

          for (var _len9 = arguments.length, e = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
            e[_key9] = arguments[_key9];
          }

          return null != t && t.execute(e);
        }
      }, {
        key: "registerChildCommand",
        value: function registerChildCommand(e) {
          var _this10 = this;

          this._childCommands.push(e), e.on("change:isEnabled", function () {
            return _this10._checkEnabled();
          }), this._checkEnabled();
        }
      }, {
        key: "_checkEnabled",
        value: function _checkEnabled() {
          this.isEnabled = !!this._getFirstEnabledCommand();
        }
      }, {
        key: "_getFirstEnabledCommand",
        value: function _getFirstEnabledCommand() {
          return this._childCommands.find(function (e) {
            return e.isEnabled;
          });
        }
      }]);

      return et;
    }(Ze);

    var tt = function tt(e, t) {
      return function (i) {
        return e(t(i));
      };
    },
        it = tt(Object.getPrototypeOf, Object),
        nt = Function.prototype,
        ot = Object.prototype,
        rt = nt.toString,
        st = ot.hasOwnProperty,
        at = rt.call(Object);

    var ct = function ct(e) {
      if (!me(e) || "[object Object]" != I(e)) return !1;
      var t = it(e);
      if (null === t) return !0;
      var i = st.call(t, "constructor") && t.constructor;
      return "function" == typeof i && i instanceof i && rt.call(i) == at;
    };

    var lt = function lt() {
      this.__data__ = [], this.size = 0;
    };

    var dt = function dt(e, t) {
      for (var i = e.length; i--;) {
        if (G(e[i][0], t)) return i;
      }

      return -1;
    },
        ht = Array.prototype.splice;

    var ut = function ut(e) {
      var t = this.__data__,
          i = dt(t, e);
      return !(i < 0) && (i == t.length - 1 ? t.pop() : ht.call(t, i, 1), --this.size, !0);
    };

    var gt = function gt(e) {
      var t = this.__data__,
          i = dt(t, e);
      return i < 0 ? void 0 : t[i][1];
    };

    var mt = function mt(e) {
      return dt(this.__data__, e) > -1;
    };

    var ft = function ft(e, t) {
      var i = this.__data__,
          n = dt(i, e);
      return n < 0 ? (++this.size, i.push([e, t])) : i[n][1] = t, this;
    };

    function pt(e) {
      var t = -1,
          i = null == e ? 0 : e.length;

      for (this.clear(); ++t < i;) {
        var n = e[t];
        this.set(n[0], n[1]);
      }
    }

    pt.prototype.clear = lt, pt.prototype.delete = ut, pt.prototype.get = gt, pt.prototype.has = mt, pt.prototype.set = ft;
    var bt = pt;

    var wt = function wt() {
      this.__data__ = new bt(), this.size = 0;
    };

    var kt = function kt(e) {
      var t = this.__data__,
          i = t.delete(e);
      return this.size = t.size, i;
    };

    var _t = function _t(e) {
      return this.__data__.get(e);
    };

    var vt = function vt(e) {
      return this.__data__.has(e);
    },
        yt = q(k.a, "Map"),
        xt = q(Object, "create");

    var At = function At() {
      this.__data__ = xt ? xt(null) : {}, this.size = 0;
    };

    var Ct = function Ct(e) {
      var t = this.has(e) && delete this.__data__[e];
      return this.size -= t ? 1 : 0, t;
    },
        Tt = Object.prototype.hasOwnProperty;

    var Et = function Et(e) {
      var t = this.__data__;

      if (xt) {
        var i = t[e];
        return "__lodash_hash_undefined__" === i ? void 0 : i;
      }

      return Tt.call(t, e) ? t[e] : void 0;
    },
        St = Object.prototype.hasOwnProperty;

    var It = function It(e) {
      var t = this.__data__;
      return xt ? void 0 !== t[e] : St.call(t, e);
    };

    var Pt = function Pt(e, t) {
      var i = this.__data__;
      return this.size += this.has(e) ? 0 : 1, i[e] = xt && void 0 === t ? "__lodash_hash_undefined__" : t, this;
    };

    function Mt(e) {
      var t = -1,
          i = null == e ? 0 : e.length;

      for (this.clear(); ++t < i;) {
        var n = e[t];
        this.set(n[0], n[1]);
      }
    }

    Mt.prototype.clear = At, Mt.prototype.delete = Ct, Mt.prototype.get = Et, Mt.prototype.has = It, Mt.prototype.set = Pt;
    var Nt = Mt;

    var Rt = function Rt() {
      this.size = 0, this.__data__ = {
        hash: new Nt(),
        map: new (yt || bt)(),
        string: new Nt()
      };
    };

    var Ot = function Ot(e) {
      var t = typeof e;
      return "string" == t || "number" == t || "symbol" == t || "boolean" == t ? "__proto__" !== e : null === e;
    };

    var zt = function zt(e, t) {
      var i = e.__data__;
      return Ot(t) ? i["string" == typeof t ? "string" : "hash"] : i.map;
    };

    var Dt = function Dt(e) {
      var t = zt(this, e).delete(e);
      return this.size -= t ? 1 : 0, t;
    };

    var Lt = function Lt(e) {
      return zt(this, e).get(e);
    };

    var Vt = function Vt(e) {
      return zt(this, e).has(e);
    };

    var jt = function jt(e, t) {
      var i = zt(this, e),
          n = i.size;
      return i.set(e, t), this.size += i.size == n ? 0 : 1, this;
    };

    function Bt(e) {
      var t = -1,
          i = null == e ? 0 : e.length;

      for (this.clear(); ++t < i;) {
        var n = e[t];
        this.set(n[0], n[1]);
      }
    }

    Bt.prototype.clear = Rt, Bt.prototype.delete = Dt, Bt.prototype.get = Lt, Bt.prototype.has = Vt, Bt.prototype.set = jt;
    var Ft = Bt;

    var Ht = function Ht(e, t) {
      var i = this.__data__;

      if (i instanceof bt) {
        var n = i.__data__;
        if (!yt || n.length < 199) return n.push([e, t]), this.size = ++i.size, this;
        i = this.__data__ = new Ft(n);
      }

      return i.set(e, t), this.size = i.size, this;
    };

    function Ut(e) {
      var t = this.__data__ = new bt(e);
      this.size = t.size;
    }

    Ut.prototype.clear = wt, Ut.prototype.delete = kt, Ut.prototype.get = _t, Ut.prototype.has = vt, Ut.prototype.set = Ht;
    var Wt = Ut;

    var qt = function qt(e, t) {
      for (var i = -1, n = null == e ? 0 : e.length; ++i < n && !1 !== t(e[i], i, e);) {
        ;
      }

      return e;
    },
        $t = tt(Object.keys, Object),
        Yt = Object.prototype.hasOwnProperty;

    var Gt = function Gt(e) {
      if (!Me(e)) return $t(e);
      var t = [];

      for (var i in Object(e)) {
        Yt.call(e, i) && "constructor" != i && t.push(i);
      }

      return t;
    };

    var Kt = function Kt(e) {
      return ce(e) ? Ie(e) : Gt(e);
    };

    var Qt = function Qt(e, t) {
      return e && J(t, Kt(t), e);
    };

    var Jt = function Jt(e, t) {
      return e && J(t, ze(t), e);
    },
        Zt = i(9);

    var Xt = function Xt(e, t) {
      var i = -1,
          n = e.length;

      for (t || (t = Array(n)); ++i < n;) {
        t[i] = e[i];
      }

      return t;
    };

    var ei = function ei(e, t) {
      for (var i = -1, n = null == e ? 0 : e.length, o = 0, r = []; ++i < n;) {
        var s = e[i];
        t(s, i, e) && (r[o++] = s);
      }

      return r;
    };

    var ti = function ti() {
      return [];
    },
        ii = Object.prototype.propertyIsEnumerable,
        ni = Object.getOwnPropertySymbols,
        oi = ni ? function (e) {
      return null == e ? [] : (e = Object(e), ei(ni(e), function (t) {
        return ii.call(e, t);
      }));
    } : ti;

    var ri = function ri(e, t) {
      return J(e, oi(e), t);
    };

    var si = function si(e, t) {
      for (var i = -1, n = t.length, o = e.length; ++i < n;) {
        e[o + i] = t[i];
      }

      return e;
    },
        ai = Object.getOwnPropertySymbols ? function (e) {
      for (var t = []; e;) {
        si(t, oi(e)), e = it(e);
      }

      return t;
    } : ti;

    var ci = function ci(e, t) {
      return J(e, ai(e), t);
    };

    var li = function li(e, t, i) {
      var n = t(e);
      return _e(e) ? n : si(n, i(e));
    };

    var di = function di(e) {
      return li(e, Kt, oi);
    };

    var hi = function hi(e) {
      return li(e, ze, ai);
    },
        ui = q(k.a, "DataView"),
        gi = q(k.a, "Promise"),
        mi = q(k.a, "Set"),
        fi = q(k.a, "WeakMap"),
        pi = D(ui),
        bi = D(yt),
        wi = D(gi),
        ki = D(mi),
        _i = D(fi),
        vi = I;

    (ui && "[object DataView]" != vi(new ui(new ArrayBuffer(1))) || yt && "[object Map]" != vi(new yt()) || gi && "[object Promise]" != vi(gi.resolve()) || mi && "[object Set]" != vi(new mi()) || fi && "[object WeakMap]" != vi(new fi())) && (vi = function vi(e) {
      var t = I(e),
          i = "[object Object]" == t ? e.constructor : void 0,
          n = i ? D(i) : "";
      if (n) switch (n) {
        case pi:
          return "[object DataView]";

        case bi:
          return "[object Map]";

        case wi:
          return "[object Promise]";

        case ki:
          return "[object Set]";

        case _i:
          return "[object WeakMap]";
      }
      return t;
    });
    var yi = vi,
        xi = Object.prototype.hasOwnProperty;

    var Ai = function Ai(e) {
      var t = e.length,
          i = new e.constructor(t);
      return t && "string" == typeof e[0] && xi.call(e, "index") && (i.index = e.index, i.input = e.input), i;
    },
        Ci = k.a.Uint8Array;

    var Ti = function Ti(e) {
      var t = new e.constructor(e.byteLength);
      return new Ci(t).set(new Ci(e)), t;
    };

    var Ei = function Ei(e, t) {
      var i = t ? Ti(e.buffer) : e.buffer;
      return new e.constructor(i, e.byteOffset, e.byteLength);
    },
        Si = /\w*$/;

    var Ii = function Ii(e) {
      var t = new e.constructor(e.source, Si.exec(e));
      return t.lastIndex = e.lastIndex, t;
    },
        Pi = _ ? _.prototype : void 0,
        Mi = Pi ? Pi.valueOf : void 0;

    var Ni = function Ni(e) {
      return Mi ? Object(Mi.call(e)) : {};
    };

    var Ri = function Ri(e, t) {
      var i = t ? Ti(e.buffer) : e.buffer;
      return new e.constructor(i, e.byteOffset, e.length);
    };

    var Oi = function Oi(e, t, i) {
      var n = e.constructor;

      switch (t) {
        case "[object ArrayBuffer]":
          return Ti(e);

        case "[object Boolean]":
        case "[object Date]":
          return new n(+e);

        case "[object DataView]":
          return Ei(e, i);

        case "[object Float32Array]":
        case "[object Float64Array]":
        case "[object Int8Array]":
        case "[object Int16Array]":
        case "[object Int32Array]":
        case "[object Uint8Array]":
        case "[object Uint8ClampedArray]":
        case "[object Uint16Array]":
        case "[object Uint32Array]":
          return Ri(e, i);

        case "[object Map]":
          return new n();

        case "[object Number]":
        case "[object String]":
          return new n(e);

        case "[object RegExp]":
          return Ii(e);

        case "[object Set]":
          return new n();

        case "[object Symbol]":
          return Ni(e);
      }
    },
        zi = Object.create,
        Di = function () {
      function e() {}

      return function (t) {
        if (!w(t)) return {};
        if (zi) return zi(t);
        e.prototype = t;
        var i = new e();
        return e.prototype = void 0, i;
      };
    }();

    var Li = function Li(e) {
      return "function" != typeof e.constructor || Me(e) ? {} : Di(it(e));
    };

    var Vi = function Vi(e) {
      return me(e) && "[object Map]" == yi(e);
    },
        ji = Ce.a && Ce.a.isMap,
        Bi = ji ? Ae(ji) : Vi;

    var Fi = function Fi(e) {
      return me(e) && "[object Set]" == yi(e);
    },
        Hi = Ce.a && Ce.a.isSet,
        Ui = Hi ? Ae(Hi) : Fi,
        Wi = {};

    Wi["[object Arguments]"] = Wi["[object Array]"] = Wi["[object ArrayBuffer]"] = Wi["[object DataView]"] = Wi["[object Boolean]"] = Wi["[object Date]"] = Wi["[object Float32Array]"] = Wi["[object Float64Array]"] = Wi["[object Int8Array]"] = Wi["[object Int16Array]"] = Wi["[object Int32Array]"] = Wi["[object Map]"] = Wi["[object Number]"] = Wi["[object Object]"] = Wi["[object RegExp]"] = Wi["[object Set]"] = Wi["[object String]"] = Wi["[object Symbol]"] = Wi["[object Uint8Array]"] = Wi["[object Uint8ClampedArray]"] = Wi["[object Uint16Array]"] = Wi["[object Uint32Array]"] = !0, Wi["[object Error]"] = Wi["[object Function]"] = Wi["[object WeakMap]"] = !1;

    var qi = function e(t, i, n, o, r, s) {
      var a,
          c = 1 & i,
          l = 2 & i,
          d = 4 & i;
      if (n && (a = r ? n(t, o, r, s) : n(t)), void 0 !== a) return a;
      if (!w(t)) return t;

      var h = _e(t);

      if (h) {
        if (a = Ai(t), !c) return Xt(t, a);
      } else {
        var u = yi(t),
            g = "[object Function]" == u || "[object GeneratorFunction]" == u;
        if (Object(ve.a)(t)) return Object(Zt.a)(t, c);

        if ("[object Object]" == u || "[object Arguments]" == u || g && !r) {
          if (a = l || g ? {} : Li(t), !c) return l ? ci(t, Jt(a, t)) : ri(t, Qt(a, t));
        } else {
          if (!Wi[u]) return r ? t : {};
          a = Oi(t, u, c);
        }
      }

      s || (s = new Wt());
      var m = s.get(t);
      if (m) return m;
      s.set(t, a), Ui(t) ? t.forEach(function (o) {
        a.add(e(o, i, n, o, t, s));
      }) : Bi(t) && t.forEach(function (o, r) {
        a.set(r, e(o, i, n, r, t, s));
      });
      var f = h ? void 0 : (d ? l ? hi : di : l ? ze : Kt)(t);
      return qt(f || t, function (o, r) {
        f && (o = t[r = o]), Q(a, r, e(o, i, n, r, t, s));
      }), a;
    };

    var $i = function $i(e, t) {
      return qi(e, 5, t = "function" == typeof t ? t : void 0);
    };

    var Yi = function Yi(e) {
      return me(e) && 1 === e.nodeType && !ct(e);
    };

    var Gi =
    /*#__PURE__*/
    function () {
      function Gi(e, t) {
        _classCallCheck(this, Gi);

        this._config = {}, t && this.define(Ki(t)), e && this._setObjectToTarget(this._config, e);
      }

      _createClass(Gi, [{
        key: "set",
        value: function set(e, t) {
          this._setToTarget(this._config, e, t);
        }
      }, {
        key: "define",
        value: function define(e, t) {
          this._setToTarget(this._config, e, t, !0);
        }
      }, {
        key: "get",
        value: function get(e) {
          return this._getFromSource(this._config, e);
        }
      }, {
        key: "names",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function names() {
          var _i6, _Object$keys, _e9;

          return _regeneratorRuntime.wrap(function names$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _i6 = 0, _Object$keys = Object.keys(this._config);

                case 1:
                  if (!(_i6 < _Object$keys.length)) {
                    _context.next = 8;
                    break;
                  }

                  _e9 = _Object$keys[_i6];
                  _context.next = 5;
                  return _e9;

                case 5:
                  _i6++;
                  _context.next = 1;
                  break;

                case 8:
                case "end":
                  return _context.stop();
              }
            }
          }, names, this);
        })
      }, {
        key: "_setToTarget",
        value: function _setToTarget(e, t, i) {
          var n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
          if (ct(t)) return void this._setObjectToTarget(e, t, n);
          var o = t.split(".");
          t = o.pop();
          var _iteratorNormalCompletion6 = true;
          var _didIteratorError6 = false;
          var _iteratorError6 = undefined;

          try {
            for (var _iterator6 = o[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
              var _t5 = _step6.value;
              ct(e[_t5]) || (e[_t5] = {}), e = e[_t5];
            }
          } catch (err) {
            _didIteratorError6 = true;
            _iteratorError6 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion6 && _iterator6.return != null) {
                _iterator6.return();
              }
            } finally {
              if (_didIteratorError6) {
                throw _iteratorError6;
              }
            }
          }

          if (ct(i)) return ct(e[t]) || (e[t] = {}), e = e[t], void this._setObjectToTarget(e, i, n);
          n && void 0 !== e[t] || (e[t] = i);
        }
      }, {
        key: "_getFromSource",
        value: function _getFromSource(e, t) {
          var i = t.split(".");
          t = i.pop();
          var _iteratorNormalCompletion7 = true;
          var _didIteratorError7 = false;
          var _iteratorError7 = undefined;

          try {
            for (var _iterator7 = i[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
              var _t6 = _step7.value;

              if (!ct(e[_t6])) {
                e = null;
                break;
              }

              e = e[_t6];
            }
          } catch (err) {
            _didIteratorError7 = true;
            _iteratorError7 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion7 && _iterator7.return != null) {
                _iterator7.return();
              }
            } finally {
              if (_didIteratorError7) {
                throw _iteratorError7;
              }
            }
          }

          return e ? Ki(e[t]) : void 0;
        }
      }, {
        key: "_setObjectToTarget",
        value: function _setObjectToTarget(e, t, i) {
          var _this11 = this;

          Object.keys(t).forEach(function (n) {
            _this11._setToTarget(e, n, t[n], i);
          });
        }
      }]);

      return Gi;
    }();

    function Ki(e) {
      return $i(e, Qi);
    }

    function Qi(e) {
      return Yi(e) ? e : void 0;
    }

    function Ji(e) {
      return !(!e || !e[Symbol.iterator]);
    }

    var Zi =
    /*#__PURE__*/
    function () {
      function Zi() {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        _classCallCheck(this, Zi);

        var i = Ji(e);

        if (i || (t = e), this._items = [], this._itemMap = new Map(), this._idProperty = t.idProperty || "id", this._bindToExternalToInternalMap = new WeakMap(), this._bindToInternalToExternalMap = new WeakMap(), this._skippedIndexesFromExternal = [], i) {
          var _iteratorNormalCompletion8 = true;
          var _didIteratorError8 = false;
          var _iteratorError8 = undefined;

          try {
            for (var _iterator8 = e[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
              var _t7 = _step8.value;
              this._items.push(_t7), this._itemMap.set(this._getItemIdBeforeAdding(_t7), _t7);
            }
          } catch (err) {
            _didIteratorError8 = true;
            _iteratorError8 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion8 && _iterator8.return != null) {
                _iterator8.return();
              }
            } finally {
              if (_didIteratorError8) {
                throw _iteratorError8;
              }
            }
          }
        }
      }

      _createClass(Zi, [{
        key: "add",
        value: function add(e, t) {
          return this.addMany([e], t);
        }
      }, {
        key: "addMany",
        value: function addMany(e, t) {
          if (void 0 === t) t = this._items.length;else if (t > this._items.length || t < 0) throw new c.a("collection-add-item-invalid-index", this);

          for (var _i7 = 0; _i7 < e.length; _i7++) {
            var _n4 = e[_i7],
                _o4 = this._getItemIdBeforeAdding(_n4),
                _r4 = t + _i7;

            this._items.splice(_r4, 0, _n4), this._itemMap.set(_o4, _n4), this.fire("add", _n4, _r4);
          }

          return this.fire("change", {
            added: e,
            removed: [],
            index: t
          }), this;
        }
      }, {
        key: "get",
        value: function get(e) {
          var t;
          if ("string" == typeof e) t = this._itemMap.get(e);else {
            if ("number" != typeof e) throw new c.a("collection-get-invalid-arg", this);
            t = this._items[e];
          }
          return t || null;
        }
      }, {
        key: "has",
        value: function has(e) {
          if ("string" == typeof e) return this._itemMap.has(e);
          {
            var _t8 = e[this._idProperty];
            return this._itemMap.has(_t8);
          }
        }
      }, {
        key: "getIndex",
        value: function getIndex(e) {
          var t;
          return t = "string" == typeof e ? this._itemMap.get(e) : e, this._items.indexOf(t);
        }
      }, {
        key: "remove",
        value: function remove(e) {
          var _this$_remove = this._remove(e),
              _this$_remove2 = _slicedToArray(_this$_remove, 2),
              t = _this$_remove2[0],
              i = _this$_remove2[1];

          return this.fire("change", {
            added: [],
            removed: [t],
            index: i
          }), t;
        }
      }, {
        key: "map",
        value: function map(e, t) {
          return this._items.map(e, t);
        }
      }, {
        key: "find",
        value: function find(e, t) {
          return this._items.find(e, t);
        }
      }, {
        key: "filter",
        value: function filter(e, t) {
          return this._items.filter(e, t);
        }
      }, {
        key: "clear",
        value: function clear() {
          this._bindToCollection && (this.stopListening(this._bindToCollection), this._bindToCollection = null);
          var e = Array.from(this._items);

          for (; this.length;) {
            this._remove(0);
          }

          this.fire("change", {
            added: [],
            removed: e,
            index: 0
          });
        }
      }, {
        key: "bindTo",
        value: function bindTo(e) {
          var _this12 = this;

          if (this._bindToCollection) throw new c.a("collection-bind-to-rebind", this);
          return this._bindToCollection = e, {
            as: function as(e) {
              _this12._setUpBindToBinding(function (t) {
                return new e(t);
              });
            },
            using: function using(e) {
              "function" == typeof e ? _this12._setUpBindToBinding(function (t) {
                return e(t);
              }) : _this12._setUpBindToBinding(function (t) {
                return t[e];
              });
            }
          };
        }
      }, {
        key: "_setUpBindToBinding",
        value: function _setUpBindToBinding(e) {
          var _this13 = this;

          var t = this._bindToCollection,
              i = function i(_i9, n, o) {
            var r = t._bindToCollection == _this13,
                s = t._bindToInternalToExternalMap.get(n);

            if (r && s) _this13._bindToExternalToInternalMap.set(n, s), _this13._bindToInternalToExternalMap.set(s, n);else {
              var _i8 = e(n);

              if (!_i8) return void _this13._skippedIndexesFromExternal.push(o);
              var _r5 = o;
              var _iteratorNormalCompletion9 = true;
              var _didIteratorError9 = false;
              var _iteratorError9 = undefined;

              try {
                for (var _iterator9 = _this13._skippedIndexesFromExternal[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
                  var _e11 = _step9.value;
                  o > _e11 && _r5--;
                }
              } catch (err) {
                _didIteratorError9 = true;
                _iteratorError9 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion9 && _iterator9.return != null) {
                    _iterator9.return();
                  }
                } finally {
                  if (_didIteratorError9) {
                    throw _iteratorError9;
                  }
                }
              }

              var _iteratorNormalCompletion10 = true;
              var _didIteratorError10 = false;
              var _iteratorError10 = undefined;

              try {
                for (var _iterator10 = t._skippedIndexesFromExternal[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
                  var _e12 = _step10.value;
                  _r5 >= _e12 && _r5++;
                }
              } catch (err) {
                _didIteratorError10 = true;
                _iteratorError10 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion10 && _iterator10.return != null) {
                    _iterator10.return();
                  }
                } finally {
                  if (_didIteratorError10) {
                    throw _iteratorError10;
                  }
                }
              }

              _this13._bindToExternalToInternalMap.set(n, _i8), _this13._bindToInternalToExternalMap.set(_i8, n), _this13.add(_i8, _r5);

              for (var _e10 = 0; _e10 < t._skippedIndexesFromExternal.length; _e10++) {
                _r5 <= t._skippedIndexesFromExternal[_e10] && t._skippedIndexesFromExternal[_e10]++;
              }
            }
          };

          var _iteratorNormalCompletion11 = true;
          var _didIteratorError11 = false;
          var _iteratorError11 = undefined;

          try {
            for (var _iterator11 = t[Symbol.iterator](), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
              var _e13 = _step11.value;
              i(0, _e13, t.getIndex(_e13));
            }
          } catch (err) {
            _didIteratorError11 = true;
            _iteratorError11 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion11 && _iterator11.return != null) {
                _iterator11.return();
              }
            } finally {
              if (_didIteratorError11) {
                throw _iteratorError11;
              }
            }
          }

          this.listenTo(t, "add", i), this.listenTo(t, "remove", function (e, t, i) {
            var n = _this13._bindToExternalToInternalMap.get(t);

            n && _this13.remove(n), _this13._skippedIndexesFromExternal = _this13._skippedIndexesFromExternal.reduce(function (e, t) {
              return i < t && e.push(t - 1), i > t && e.push(t), e;
            }, []);
          });
        }
      }, {
        key: "_getItemIdBeforeAdding",
        value: function _getItemIdBeforeAdding(e) {
          var t = this._idProperty;
          var i;

          if (t in e) {
            if (i = e[t], "string" != typeof i) throw new c.a("collection-add-invalid-id", this);
            if (this.get(i)) throw new c.a("collection-add-item-already-exists", this);
          } else e[t] = i = s();

          return i;
        }
      }, {
        key: "_remove",
        value: function _remove(e) {
          var t,
              i,
              n,
              o = !1;
          var r = this._idProperty;
          if ("string" == typeof e ? (i = e, n = this._itemMap.get(i), o = !n, n && (t = this._items.indexOf(n))) : "number" == typeof e ? (t = e, n = this._items[t], o = !n, n && (i = n[r])) : (n = e, i = n[r], t = this._items.indexOf(n), o = -1 == t || !this._itemMap.get(i)), o) throw new c.a("collection-remove-404", this);
          this._items.splice(t, 1), this._itemMap.delete(i);

          var s = this._bindToInternalToExternalMap.get(n);

          return this._bindToInternalToExternalMap.delete(n), this._bindToExternalToInternalMap.delete(s), this.fire("remove", n, t), [n, t];
        }
      }, {
        key: Symbol.iterator,
        value: function value() {
          return this._items[Symbol.iterator]();
        }
      }, {
        key: "length",
        get: function get() {
          return this._items.length;
        }
      }, {
        key: "first",
        get: function get() {
          return this._items[0] || null;
        }
      }, {
        key: "last",
        get: function get() {
          return this._items[this.length - 1] || null;
        }
      }]);

      return Zi;
    }();

    Ke(Zi, h);

    var Xi =
    /*#__PURE__*/
    function () {
      function Xi(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

        _classCallCheck(this, Xi);

        this._context = e, this._plugins = new Map(), this._availablePlugins = new Map();
        var _iteratorNormalCompletion12 = true;
        var _didIteratorError12 = false;
        var _iteratorError12 = undefined;

        try {
          for (var _iterator12 = t[Symbol.iterator](), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
            var _e14 = _step12.value;
            _e14.pluginName && this._availablePlugins.set(_e14.pluginName, _e14);
          }
        } catch (err) {
          _didIteratorError12 = true;
          _iteratorError12 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion12 && _iterator12.return != null) {
              _iterator12.return();
            }
          } finally {
            if (_didIteratorError12) {
              throw _iteratorError12;
            }
          }
        }

        this._contextPlugins = new Map();
        var _iteratorNormalCompletion13 = true;
        var _didIteratorError13 = false;
        var _iteratorError13 = undefined;

        try {
          for (var _iterator13 = i[Symbol.iterator](), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
            var _ref6 = _step13.value;

            var _ref5 = _slicedToArray(_ref6, 2);

            var _e15 = _ref5[0];
            var _t9 = _ref5[1];
            this._contextPlugins.set(_e15, _t9), this._contextPlugins.set(_t9, _e15), _e15.pluginName && this._availablePlugins.set(_e15.pluginName, _e15);
          }
        } catch (err) {
          _didIteratorError13 = true;
          _iteratorError13 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion13 && _iterator13.return != null) {
              _iterator13.return();
            }
          } finally {
            if (_didIteratorError13) {
              throw _iteratorError13;
            }
          }
        }
      }

      _createClass(Xi, [{
        key: Symbol.iterator,
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function value() {
          var _iteratorNormalCompletion14, _didIteratorError14, _iteratorError14, _iterator14, _step14, _e16;

          return _regeneratorRuntime.wrap(function value$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _iteratorNormalCompletion14 = true;
                  _didIteratorError14 = false;
                  _iteratorError14 = undefined;
                  _context2.prev = 3;
                  _iterator14 = this._plugins[Symbol.iterator]();

                case 5:
                  if (_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done) {
                    _context2.next = 14;
                    break;
                  }

                  _e16 = _step14.value;
                  _context2.t0 = "function" == typeof _e16[0];

                  if (!_context2.t0) {
                    _context2.next = 11;
                    break;
                  }

                  _context2.next = 11;
                  return _e16;

                case 11:
                  _iteratorNormalCompletion14 = true;
                  _context2.next = 5;
                  break;

                case 14:
                  _context2.next = 20;
                  break;

                case 16:
                  _context2.prev = 16;
                  _context2.t1 = _context2["catch"](3);
                  _didIteratorError14 = true;
                  _iteratorError14 = _context2.t1;

                case 20:
                  _context2.prev = 20;
                  _context2.prev = 21;

                  if (!_iteratorNormalCompletion14 && _iterator14.return != null) {
                    _iterator14.return();
                  }

                case 23:
                  _context2.prev = 23;

                  if (!_didIteratorError14) {
                    _context2.next = 26;
                    break;
                  }

                  throw _iteratorError14;

                case 26:
                  return _context2.finish(23);

                case 27:
                  return _context2.finish(20);

                case 28:
                case "end":
                  return _context2.stop();
              }
            }
          }, value, this, [[3, 16, 20, 28], [21,, 23, 27]]);
        })
      }, {
        key: "get",
        value: function get(e) {
          var t = this._plugins.get(e);

          if (!t) {
            var _t10 = e;
            throw "function" == typeof e && (_t10 = e.pluginName || e.name), new c.a("plugincollection-plugin-not-loaded", this._context, {
              plugin: _t10
            });
          }

          return t;
        }
      }, {
        key: "has",
        value: function has(e) {
          return this._plugins.has(e);
        }
      }, {
        key: "init",
        value: function init(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
          var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
          var n = this,
              o = this._context;
          !function e(t) {
            var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Set();
            t.forEach(function (t) {
              a(t) && (i.has(t) || (i.add(t), t.pluginName && !n._availablePlugins.has(t.pluginName) && n._availablePlugins.set(t.pluginName, t), t.requires && e(t.requires, i)));
            });
          }(e), u(e);

          var r = _toConsumableArray(function e(t) {
            var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Set();
            return t.map(function (e) {
              return a(e) ? e : n._availablePlugins.get(e);
            }).reduce(function (t, n) {
              return i.has(n) ? t : (i.add(n), n.requires && (u(n.requires, n), e(n.requires, i).forEach(function (e) {
                return t.add(e);
              })), t.add(n));
            }, new Set());
          }(e.filter(function (e) {
            return !d(e, t);
          })));

          !function (e, t) {
            var _iteratorNormalCompletion15 = true;
            var _didIteratorError15 = false;
            var _iteratorError15 = undefined;

            try {
              for (var _iterator15 = t[Symbol.iterator](), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
                var _i10 = _step15.value;
                if ("function" != typeof _i10) throw new c.a("plugincollection-replace-plugin-invalid-type", null, {
                  pluginItem: _i10
                });
                var _t11 = _i10.pluginName;
                if (!_t11) throw new c.a("plugincollection-replace-plugin-missing-name", null, {
                  pluginItem: _i10
                });
                if (_i10.requires && _i10.requires.length) throw new c.a("plugincollection-plugin-for-replacing-cannot-have-dependencies", null, {
                  pluginName: _t11
                });

                var _o5 = n._availablePlugins.get(_t11);

                if (!_o5) throw new c.a("plugincollection-plugin-for-replacing-not-exist", null, {
                  pluginName: _t11
                });

                var _r6 = e.indexOf(_o5);

                if (-1 === _r6) {
                  if (n._contextPlugins.has(_o5)) return;
                  throw new c.a("plugincollection-plugin-for-replacing-not-loaded", null, {
                    pluginName: _t11
                  });
                }

                if (_o5.requires && _o5.requires.length) throw new c.a("plugincollection-replaced-plugin-cannot-have-dependencies", null, {
                  pluginName: _t11
                });
                e.splice(_r6, 1, _i10), n._availablePlugins.set(_t11, _i10);
              }
            } catch (err) {
              _didIteratorError15 = true;
              _iteratorError15 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion15 && _iterator15.return != null) {
                  _iterator15.return();
                }
              } finally {
                if (_didIteratorError15) {
                  throw _iteratorError15;
                }
              }
            }
          }(r, i);

          var s = function (e) {
            return e.map(function (e) {
              var t = n._contextPlugins.get(e) || new e(o);
              return n._add(e, t), t;
            });
          }(r);

          return g(s, "init").then(function () {
            return g(s, "afterInit");
          }).then(function () {
            return s;
          });

          function a(e) {
            return "function" == typeof e;
          }

          function l(e) {
            return a(e) && e.isContextPlugin;
          }

          function d(e, t) {
            return t.some(function (t) {
              return t === e || h(e) === t || h(t) === e;
            });
          }

          function h(e) {
            return a(e) ? e.pluginName || e.name : e;
          }

          function u(e) {
            var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            e.map(function (e) {
              return a(e) ? e : n._availablePlugins.get(e) || e;
            }).forEach(function (e) {
              !function (e, t) {
                if (a(e)) return;
                if (t) throw new c.a("plugincollection-soft-required", o, {
                  missingPlugin: e,
                  requiredBy: h(t)
                });
                throw new c.a("plugincollection-plugin-not-found", o, {
                  plugin: e
                });
              }(e, i), function (e, t) {
                if (!l(t)) return;
                if (l(e)) return;
                throw new c.a("plugincollection-context-required", o, {
                  plugin: h(e),
                  requiredBy: h(t)
                });
              }(e, i), function (e, i) {
                if (!i) return;
                if (!d(e, t)) return;
                throw new c.a("plugincollection-required", o, {
                  plugin: h(e),
                  requiredBy: h(i)
                });
              }(e, i);
            });
          }

          function g(e, t) {
            return e.reduce(function (e, i) {
              return i[t] ? n._contextPlugins.has(i) ? e : e.then(i[t].bind(i)) : e;
            }, Promise.resolve());
          }
        }
      }, {
        key: "destroy",
        value: function destroy() {
          var e = [];
          var _iteratorNormalCompletion16 = true;
          var _didIteratorError16 = false;
          var _iteratorError16 = undefined;

          try {
            for (var _iterator16 = this[Symbol.iterator](), _step16; !(_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done); _iteratorNormalCompletion16 = true) {
              var _ref9 = _step16.value;

              var _ref8 = _slicedToArray(_ref9, 2);

              var _t12 = _ref8[1];
              "function" != typeof _t12.destroy || this._contextPlugins.has(_t12) || e.push(_t12.destroy());
            }
          } catch (err) {
            _didIteratorError16 = true;
            _iteratorError16 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion16 && _iterator16.return != null) {
                _iterator16.return();
              }
            } finally {
              if (_didIteratorError16) {
                throw _iteratorError16;
              }
            }
          }

          return Promise.all(e);
        }
      }, {
        key: "_add",
        value: function _add(e, t) {
          this._plugins.set(e, t);

          var i = e.pluginName;

          if (i) {
            if (this._plugins.has(i)) throw new c.a("plugincollection-plugin-name-conflict", null, {
              pluginName: i,
              plugin1: this._plugins.get(i).constructor,
              plugin2: e
            });

            this._plugins.set(i, t);
          }
        }
      }]);

      return Xi;
    }();

    function en(e) {
      return Array.isArray(e) ? e : [e];
    }

    function tn(e, t) {
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      if ("number" != typeof i) throw new c.a("translation-service-quantity-not-a-number", null, {
        quantity: i
      });
      var n = Object.keys(window.CKEDITOR_TRANSLATIONS).length;
      1 === n && (e = Object.keys(window.CKEDITOR_TRANSLATIONS)[0]);
      var o = t.id || t.string;
      if (0 === n || !function (e, t) {
        return !!window.CKEDITOR_TRANSLATIONS[e] && !!window.CKEDITOR_TRANSLATIONS[e].dictionary[t];
      }(e, o)) return 1 !== i ? t.plural : t.string;

      var r = window.CKEDITOR_TRANSLATIONS[e].dictionary,
          s = window.CKEDITOR_TRANSLATIONS[e].getPluralForm || function (e) {
        return 1 === e ? 0 : 1;
      };

      if ("string" == typeof r[o]) return r[o];
      var a = Number(s(i));
      return r[o][a];
    }

    Ke(Xi, h), window.CKEDITOR_TRANSLATIONS || (window.CKEDITOR_TRANSLATIONS = {});
    var nn = ["ar", "ara", "fa", "per", "fas", "he", "heb", "ku", "kur", "ug", "uig"];

    function on(e) {
      return nn.includes(e) ? "rtl" : "ltr";
    }

    var rn =
    /*#__PURE__*/
    function () {
      function rn() {
        var _this14 = this;

        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, rn);

        this.uiLanguage = e.uiLanguage || "en", this.contentLanguage = e.contentLanguage || this.uiLanguage, this.uiLanguageDirection = on(this.uiLanguage), this.contentLanguageDirection = on(this.contentLanguage), this.t = function (e, t) {
          return _this14._t(e, t);
        };
      }

      _createClass(rn, [{
        key: "_t",
        value: function _t(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
          t = en(t), "string" == typeof e && (e = {
            string: e
          });
          var i = !!e.plural ? t[0] : 1;
          return function (e, t) {
            return e.replace(/%(\d+)/g, function (e, i) {
              return i < t.length ? t[i] : e;
            });
          }(tn(this.uiLanguage, e, i), t);
        }
      }, {
        key: "language",
        get: function get() {
          return console.warn("locale-deprecated-language-property: The Locale#language property has been deprecated and will be removed in the near future. Please use #uiLanguage and #contentLanguage properties instead."), this.uiLanguage;
        }
      }]);

      return rn;
    }();

    var sn =
    /*#__PURE__*/
    function () {
      function sn(e) {
        _classCallCheck(this, sn);

        this.config = new Gi(e, this.constructor.defaultConfig);
        var t = this.constructor.builtinPlugins;
        this.config.define("plugins", t), this.plugins = new Xi(this, t);
        var i = this.config.get("language") || {};
        this.locale = new rn({
          uiLanguage: "string" == typeof i ? i : i.ui,
          contentLanguage: this.config.get("language.content")
        }), this.t = this.locale.t, this.editors = new Zi(), this._contextOwner = null;
      }

      _createClass(sn, [{
        key: "initPlugins",
        value: function initPlugins() {
          var e = this.config.get("plugins") || [],
              t = this.config.get("substitutePlugins") || [];
          var _iteratorNormalCompletion17 = true;
          var _didIteratorError17 = false;
          var _iteratorError17 = undefined;

          try {
            for (var _iterator17 = e.concat(t)[Symbol.iterator](), _step17; !(_iteratorNormalCompletion17 = (_step17 = _iterator17.next()).done); _iteratorNormalCompletion17 = true) {
              var _i11 = _step17.value;
              if ("function" != typeof _i11) throw new c.a("context-initplugins-constructor-only", null, {
                Plugin: _i11
              });
              if (!0 !== _i11.isContextPlugin) throw new c.a("context-initplugins-invalid-plugin", null, {
                Plugin: _i11
              });
            }
          } catch (err) {
            _didIteratorError17 = true;
            _iteratorError17 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion17 && _iterator17.return != null) {
                _iterator17.return();
              }
            } finally {
              if (_didIteratorError17) {
                throw _iteratorError17;
              }
            }
          }

          return this.plugins.init(e, [], t);
        }
      }, {
        key: "destroy",
        value: function destroy() {
          var _this15 = this;

          return Promise.all(Array.from(this.editors, function (e) {
            return e.destroy();
          })).then(function () {
            return _this15.plugins.destroy();
          });
        }
      }, {
        key: "_addEditor",
        value: function _addEditor(e, t) {
          if (this._contextOwner) throw new c.a("context-addeditor-private-context");
          this.editors.add(e), t && (this._contextOwner = e);
        }
      }, {
        key: "_removeEditor",
        value: function _removeEditor(e) {
          return this.editors.has(e) && this.editors.remove(e), this._contextOwner === e ? this.destroy() : Promise.resolve();
        }
      }, {
        key: "_getEditorConfig",
        value: function _getEditorConfig() {
          var e = {};
          var _iteratorNormalCompletion18 = true;
          var _didIteratorError18 = false;
          var _iteratorError18 = undefined;

          try {
            for (var _iterator18 = this.config.names()[Symbol.iterator](), _step18; !(_iteratorNormalCompletion18 = (_step18 = _iterator18.next()).done); _iteratorNormalCompletion18 = true) {
              var _t13 = _step18.value;
              ["plugins", "removePlugins", "extraPlugins"].includes(_t13) || (e[_t13] = this.config.get(_t13));
            }
          } catch (err) {
            _didIteratorError18 = true;
            _iteratorError18 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion18 && _iterator18.return != null) {
                _iterator18.return();
              }
            } finally {
              if (_didIteratorError18) {
                throw _iteratorError18;
              }
            }
          }

          return e;
        }
      }], [{
        key: "create",
        value: function create(e) {
          var _this16 = this;

          return new Promise(function (t) {
            var i = new _this16(e);
            t(i.initPlugins().then(function () {
              return i;
            }));
          });
        }
      }]);

      return sn;
    }();

    var an =
    /*#__PURE__*/
    function () {
      function an(e) {
        _classCallCheck(this, an);

        this.context = e;
      }

      _createClass(an, [{
        key: "destroy",
        value: function destroy() {
          this.stopListening();
        }
      }], [{
        key: "isContextPlugin",
        get: function get() {
          return !0;
        }
      }]);

      return an;
    }();

    function cn(e, t) {
      var i = Math.min(e.length, t.length);

      for (var _n5 = 0; _n5 < i; _n5++) {
        if (e[_n5] != t[_n5]) return _n5;
      }

      return e.length == t.length ? "same" : e.length < t.length ? "prefix" : "extension";
    }

    Ke(an, Ue);

    var ln = function ln(e) {
      return qi(e, 4);
    };

    var dn =
    /*#__PURE__*/
    function () {
      function dn(e) {
        _classCallCheck(this, dn);

        this.document = e, this.parent = null;
      }

      _createClass(dn, [{
        key: "isAttached",
        value: function isAttached() {
          return this.root.is("rootElement");
        }
      }, {
        key: "getPath",
        value: function getPath() {
          var e = [];
          var t = this;

          for (; t.parent;) {
            e.unshift(t.index), t = t.parent;
          }

          return e;
        }
      }, {
        key: "getAncestors",
        value: function getAncestors() {
          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            includeSelf: !1,
            parentFirst: !1
          };
          var t = [];
          var i = e.includeSelf ? this : this.parent;

          for (; i;) {
            t[e.parentFirst ? "push" : "unshift"](i), i = i.parent;
          }

          return t;
        }
      }, {
        key: "getCommonAncestor",
        value: function getCommonAncestor(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var i = this.getAncestors(t),
              n = e.getAncestors(t);
          var o = 0;

          for (; i[o] == n[o] && i[o];) {
            o++;
          }

          return 0 === o ? null : i[o - 1];
        }
      }, {
        key: "isBefore",
        value: function isBefore(e) {
          if (this == e) return !1;
          if (this.root !== e.root) return !1;
          var t = this.getPath(),
              i = e.getPath(),
              n = cn(t, i);

          switch (n) {
            case "prefix":
              return !0;

            case "extension":
              return !1;

            default:
              return t[n] < i[n];
          }
        }
      }, {
        key: "isAfter",
        value: function isAfter(e) {
          return this != e && this.root === e.root && !this.isBefore(e);
        }
      }, {
        key: "_remove",
        value: function _remove() {
          this.parent._removeChildren(this.index);
        }
      }, {
        key: "_fireChange",
        value: function _fireChange(e, t) {
          this.fire("change:" + e, t), this.parent && this.parent._fireChange(e, t);
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var e = ln(this);
          return delete e.parent, e;
        }
      }, {
        key: "is",
        value: function is(e) {
          return "node" === e || "view:node" === e;
        }
      }, {
        key: "index",
        get: function get() {
          var e;
          if (!this.parent) return null;
          if (-1 == (e = this.parent.getChildIndex(this))) throw new c.a("view-node-not-found-in-parent", this);
          return e;
        }
      }, {
        key: "nextSibling",
        get: function get() {
          var e = this.index;
          return null !== e && this.parent.getChild(e + 1) || null;
        }
      }, {
        key: "previousSibling",
        get: function get() {
          var e = this.index;
          return null !== e && this.parent.getChild(e - 1) || null;
        }
      }, {
        key: "root",
        get: function get() {
          var e = this;

          for (; e.parent;) {
            e = e.parent;
          }

          return e;
        }
      }]);

      return dn;
    }();

    Ke(dn, h);

    var hn =
    /*#__PURE__*/
    function (_dn) {
      _inherits(hn, _dn);

      function hn(e, t) {
        var _this17;

        _classCallCheck(this, hn);

        _this17 = _possibleConstructorReturn(this, _getPrototypeOf(hn).call(this, e)), _this17._textData = t;
        return _this17;
      }

      _createClass(hn, [{
        key: "is",
        value: function is(e) {
          return "$text" === e || "view:$text" === e || "text" === e || "view:text" === e || "node" === e || "view:node" === e;
        }
      }, {
        key: "isSimilar",
        value: function isSimilar(e) {
          return e instanceof hn && (this === e || this.data === e.data);
        }
      }, {
        key: "_clone",
        value: function _clone() {
          return new hn(this.document, this.data);
        }
      }, {
        key: "data",
        get: function get() {
          return this._textData;
        }
      }, {
        key: "_data",
        get: function get() {
          return this.data;
        },
        set: function set(e) {
          this._fireChange("text", this), this._textData = e;
        }
      }]);

      return hn;
    }(dn);

    var un =
    /*#__PURE__*/
    function () {
      function un(e, t, i) {
        _classCallCheck(this, un);

        if (this.textNode = e, t < 0 || t > e.data.length) throw new c.a("view-textproxy-wrong-offsetintext", this);
        if (i < 0 || t + i > e.data.length) throw new c.a("view-textproxy-wrong-length", this);
        this.data = e.data.substring(t, t + i), this.offsetInText = t;
      }

      _createClass(un, [{
        key: "is",
        value: function is(e) {
          return "$textProxy" === e || "view:$textProxy" === e || "textProxy" === e || "view:textProxy" === e;
        }
      }, {
        key: "getAncestors",
        value: function getAncestors() {
          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            includeSelf: !1,
            parentFirst: !1
          };
          var t = [];
          var i = e.includeSelf ? this.textNode : this.parent;

          for (; null !== i;) {
            t[e.parentFirst ? "push" : "unshift"](i), i = i.parent;
          }

          return t;
        }
      }, {
        key: "offsetSize",
        get: function get() {
          return this.data.length;
        }
      }, {
        key: "isPartial",
        get: function get() {
          return this.data.length !== this.textNode.data.length;
        }
      }, {
        key: "parent",
        get: function get() {
          return this.textNode.parent;
        }
      }, {
        key: "root",
        get: function get() {
          return this.textNode.root;
        }
      }, {
        key: "document",
        get: function get() {
          return this.textNode.document;
        }
      }]);

      return un;
    }();

    function gn(e) {
      return Ji(e) ? new Map(e) : function (e) {
        var t = new Map();

        for (var _i12 in e) {
          t.set(_i12, e[_i12]);
        }

        return t;
      }(e);
    }

    var mn =
    /*#__PURE__*/
    function () {
      function mn() {
        _classCallCheck(this, mn);

        this._patterns = [], this.add.apply(this, arguments);
      }

      _createClass(mn, [{
        key: "add",
        value: function add() {
          for (var _len10 = arguments.length, e = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
            e[_key10] = arguments[_key10];
          }

          for (var _i13 = 0, _e17 = e; _i13 < _e17.length; _i13++) {
            var _t14 = _e17[_i13];
            ("string" == typeof _t14 || _t14 instanceof RegExp) && (_t14 = {
              name: _t14
            }), this._patterns.push(_t14);
          }
        }
      }, {
        key: "match",
        value: function match() {
          for (var _len11 = arguments.length, e = new Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
            e[_key11] = arguments[_key11];
          }

          for (var _i14 = 0, _e18 = e; _i14 < _e18.length; _i14++) {
            var _t15 = _e18[_i14];
            var _iteratorNormalCompletion19 = true;
            var _didIteratorError19 = false;
            var _iteratorError19 = undefined;

            try {
              for (var _iterator19 = this._patterns[Symbol.iterator](), _step19; !(_iteratorNormalCompletion19 = (_step19 = _iterator19.next()).done); _iteratorNormalCompletion19 = true) {
                var _e19 = _step19.value;

                var _i15 = fn(_t15, _e19);

                if (_i15) return {
                  element: _t15,
                  pattern: _e19,
                  match: _i15
                };
              }
            } catch (err) {
              _didIteratorError19 = true;
              _iteratorError19 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion19 && _iterator19.return != null) {
                  _iterator19.return();
                }
              } finally {
                if (_didIteratorError19) {
                  throw _iteratorError19;
                }
              }
            }
          }

          return null;
        }
      }, {
        key: "matchAll",
        value: function matchAll() {
          var t = [];

          for (var _len12 = arguments.length, e = new Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
            e[_key12] = arguments[_key12];
          }

          for (var _i16 = 0, _e20 = e; _i16 < _e20.length; _i16++) {
            var _i17 = _e20[_i16];
            var _iteratorNormalCompletion20 = true;
            var _didIteratorError20 = false;
            var _iteratorError20 = undefined;

            try {
              for (var _iterator20 = this._patterns[Symbol.iterator](), _step20; !(_iteratorNormalCompletion20 = (_step20 = _iterator20.next()).done); _iteratorNormalCompletion20 = true) {
                var _e21 = _step20.value;

                var _n6 = fn(_i17, _e21);

                _n6 && t.push({
                  element: _i17,
                  pattern: _e21,
                  match: _n6
                });
              }
            } catch (err) {
              _didIteratorError20 = true;
              _iteratorError20 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion20 && _iterator20.return != null) {
                  _iterator20.return();
                }
              } finally {
                if (_didIteratorError20) {
                  throw _iteratorError20;
                }
              }
            }
          }

          return t.length > 0 ? t : null;
        }
      }, {
        key: "getElementName",
        value: function getElementName() {
          if (1 !== this._patterns.length) return null;
          var e = this._patterns[0],
              t = e.name;
          return "function" == typeof e || !t || t instanceof RegExp ? null : t;
        }
      }]);

      return mn;
    }();

    function fn(e, t) {
      if ("function" == typeof t) return t(e);
      var i = {};
      return t.name && (i.name = function (e, t) {
        if (e instanceof RegExp) return e.test(t);
        return e === t;
      }(t.name, e.name), !i.name) || t.attributes && (i.attributes = function (e, t) {
        return pn(e, t.getAttributeKeys(), function (e) {
          return t.getAttribute(e);
        });
      }(t.attributes, e), !i.attributes) ? null : !(t.classes && (i.classes = function (e, t) {
        return pn(e, t.getClassNames());
      }(t.classes, e), !i.classes)) && !(t.styles && (i.styles = function (e, t) {
        return pn(e, t.getStyleNames(!0), function (e) {
          return t.getStyle(e);
        });
      }(t.styles, e), !i.styles)) && i;
    }

    function pn(e, t, i) {
      var n = function (e) {
        if (Array.isArray(e)) return e.map(function (e) {
          return ct(e) ? (void 0 !== e.key && void 0 !== e.value || Object(c.b)("matcher-pattern-missing-key-or-value", e), [e.key, e.value]) : [e, !0];
        });
        if (ct(e)) return Object.entries(e);
        return [[e, !0]];
      }(e),
          o = Array.from(t),
          r = [];

      return n.forEach(function (_ref10) {
        var _ref11 = _slicedToArray(_ref10, 2),
            e = _ref11[0],
            t = _ref11[1];

        o.forEach(function (n) {
          (function (e, t) {
            return !0 === e || e === t || e instanceof RegExp && e.test(t);
          })(e, n) && function (e, t, i) {
            if (!0 === e) return !0;
            var n = i(t);
            return e === n || e instanceof RegExp && e.test(n);
          }(t, n, i) && r.push(n);
        });
      }), !n.length || r.length < n.length ? null : r;
    }

    var bn = function bn(e) {
      return "symbol" == typeof e || me(e) && "[object Symbol]" == I(e);
    },
        wn = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
        kn = /^\w*$/;

    var _n = function _n(e, t) {
      if (_e(e)) return !1;
      var i = typeof e;
      return !("number" != i && "symbol" != i && "boolean" != i && null != e && !bn(e)) || kn.test(e) || !wn.test(e) || null != t && e in Object(t);
    };

    function vn(e, t) {
      if ("function" != typeof e || null != t && "function" != typeof t) throw new TypeError("Expected a function");

      var i = function i() {
        var n = arguments,
            o = t ? t.apply(this, n) : n[0],
            r = i.cache;
        if (r.has(o)) return r.get(o);
        var s = e.apply(this, n);
        return i.cache = r.set(o, s) || r, s;
      };

      return i.cache = new (vn.Cache || Ft)(), i;
    }

    vn.Cache = Ft;
    var yn = vn;

    var xn = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
        An = /\\(\\)?/g,
        Cn = function (e) {
      var t = yn(e, function (e) {
        return 500 === i.size && i.clear(), e;
      }),
          i = t.cache;
      return t;
    }(function (e) {
      var t = [];
      return 46 === e.charCodeAt(0) && t.push(""), e.replace(xn, function (e, i, n, o) {
        t.push(n ? o.replace(An, "$1") : i || e);
      }), t;
    });

    var Tn = function Tn(e, t) {
      for (var i = -1, n = null == e ? 0 : e.length, o = Array(n); ++i < n;) {
        o[i] = t(e[i], i, e);
      }

      return o;
    },
        En = _ ? _.prototype : void 0,
        Sn = En ? En.toString : void 0;

    var In = function e(t) {
      if ("string" == typeof t) return t;
      if (_e(t)) return Tn(t, e) + "";
      if (bn(t)) return Sn ? Sn.call(t) : "";
      var i = t + "";
      return "0" == i && 1 / t == -1 / 0 ? "-0" : i;
    };

    var Pn = function Pn(e) {
      return null == e ? "" : In(e);
    };

    var Mn = function Mn(e, t) {
      return _e(e) ? e : _n(e, t) ? [e] : Cn(Pn(e));
    };

    var Nn = function Nn(e) {
      var t = null == e ? 0 : e.length;
      return t ? e[t - 1] : void 0;
    };

    var Rn = function Rn(e) {
      if ("string" == typeof e || bn(e)) return e;
      var t = e + "";
      return "0" == t && 1 / e == -1 / 0 ? "-0" : t;
    };

    var On = function On(e, t) {
      for (var i = 0, n = (t = Mn(t, e)).length; null != e && i < n;) {
        e = e[Rn(t[i++])];
      }

      return i && i == n ? e : void 0;
    };

    var zn = function zn(e, t, i) {
      var n = -1,
          o = e.length;
      t < 0 && (t = -t > o ? 0 : o + t), (i = i > o ? o : i) < 0 && (i += o), o = t > i ? 0 : i - t >>> 0, t >>>= 0;

      for (var r = Array(o); ++n < o;) {
        r[n] = e[n + t];
      }

      return r;
    };

    var Dn = function Dn(e, t) {
      return t.length < 2 ? e : On(e, zn(t, 0, -1));
    };

    var Ln = function Ln(e, t) {
      return t = Mn(t, e), null == (e = Dn(e, t)) || delete e[Rn(Nn(t))];
    };

    var Vn = function Vn(e, t) {
      return null == e || Ln(e, t);
    };

    var jn = function jn(e, t, i) {
      var n = null == e ? void 0 : On(e, t);
      return void 0 === n ? i : n;
    };

    var Bn = function Bn(e, t, i) {
      (void 0 !== i && !G(e[t], i) || void 0 === i && !(t in e)) && Y(e, t, i);
    };

    var Fn = function (e) {
      return function (t, i, n) {
        for (var o = -1, r = Object(t), s = n(t), a = s.length; a--;) {
          var c = s[e ? a : ++o];
          if (!1 === i(r[c], c, r)) break;
        }

        return t;
      };
    }();

    var Hn = function Hn(e) {
      return me(e) && ce(e);
    };

    var Un = function Un(e, t) {
      if (("constructor" !== t || "function" != typeof e[t]) && "__proto__" != t) return e[t];
    };

    var Wn = function Wn(e) {
      return J(e, ze(e));
    };

    var qn = function qn(e, t, i, n, o, r, s) {
      var a = Un(e, i),
          c = Un(t, i),
          l = s.get(c);
      if (l) Bn(e, i, l);else {
        var d = r ? r(a, c, i + "", e, t, s) : void 0,
            h = void 0 === d;

        if (h) {
          var u = _e(c),
              g = !u && Object(ve.a)(c),
              m = !u && !g && Ee(c);

          d = c, u || g || m ? _e(a) ? d = a : Hn(a) ? d = Xt(a) : g ? (h = !1, d = Object(Zt.a)(c, !0)) : m ? (h = !1, d = Ri(c, !0)) : d = [] : ct(c) || ke(c) ? (d = a, ke(a) ? d = Wn(a) : w(a) && !M(a) || (d = Li(c))) : h = !1;
        }

        h && (s.set(c, d), o(d, c, n, r, s), s.delete(c)), Bn(e, i, d);
      }
    };

    var $n = function e(t, i, n, o, r) {
      t !== i && Fn(i, function (s, a) {
        if (r || (r = new Wt()), w(s)) qn(t, i, a, n, e, o, r);else {
          var c = o ? o(Un(t, a), s, a + "", t, i, r) : void 0;
          void 0 === c && (c = s), Bn(t, a, c);
        }
      }, ze);
    },
        Yn = ue(function (e, t, i) {
      $n(e, t, i);
    });

    var Gn = function Gn(e, t, i, n) {
      if (!w(e)) return e;

      for (var o = -1, r = (t = Mn(t, e)).length, s = r - 1, a = e; null != a && ++o < r;) {
        var c = Rn(t[o]),
            l = i;
        if ("__proto__" === c || "constructor" === c || "prototype" === c) return e;

        if (o != s) {
          var d = a[c];
          void 0 === (l = n ? n(d, c, a) : void 0) && (l = w(d) ? d : de(t[o + 1]) ? [] : {});
        }

        Q(a, c, l), a = a[c];
      }

      return e;
    };

    var Kn = function Kn(e, t, i) {
      return null == e ? e : Gn(e, t, i);
    };

    var Qn =
    /*#__PURE__*/
    function () {
      function Qn(e) {
        _classCallCheck(this, Qn);

        this._styles = {}, this._styleProcessor = e;
      }

      _createClass(Qn, [{
        key: "setTo",
        value: function setTo(e) {
          this.clear();
          var t = Array.from(function (e) {
            var t = null,
                i = 0,
                n = 0,
                o = null;
            var r = new Map();
            if ("" === e) return r;
            ";" != e.charAt(e.length - 1) && (e += ";");

            for (var _s2 = 0; _s2 < e.length; _s2++) {
              var _a2 = e.charAt(_s2);

              if (null === t) switch (_a2) {
                case ":":
                  o || (o = e.substr(i, _s2 - i), n = _s2 + 1);
                  break;

                case '"':
                case "'":
                  t = _a2;
                  break;

                case ";":
                  {
                    var _t16 = e.substr(n, _s2 - n);

                    o && r.set(o.trim(), _t16.trim()), o = null, i = _s2 + 1;
                    break;
                  }
              } else _a2 === t && (t = null);
            }

            return r;
          }(e).entries());

          for (var _i18 = 0, _t17 = t; _i18 < _t17.length; _i18++) {
            var _ref14 = _t17[_i18];

            var _ref13 = _slicedToArray(_ref14, 2);

            var _e22 = _ref13[0];
            var _i19 = _ref13[1];

            this._styleProcessor.toNormalizedForm(_e22, _i19, this._styles);
          }
        }
      }, {
        key: "has",
        value: function has(e) {
          if (this.isEmpty) return !1;

          var t = this._styleProcessor.getReducedForm(e, this._styles).find(function (_ref15) {
            var _ref16 = _slicedToArray(_ref15, 1),
                t = _ref16[0];

            return t === e;
          });

          return Array.isArray(t);
        }
      }, {
        key: "set",
        value: function set(e, t) {
          if (w(e)) {
            for (var _i20 = 0, _Object$entries = Object.entries(e); _i20 < _Object$entries.length; _i20++) {
              var _ref19 = _Object$entries[_i20];

              var _ref18 = _slicedToArray(_ref19, 2);

              var _t18 = _ref18[0];
              var _i21 = _ref18[1];

              this._styleProcessor.toNormalizedForm(_t18, _i21, this._styles);
            }
          } else this._styleProcessor.toNormalizedForm(e, t, this._styles);
        }
      }, {
        key: "remove",
        value: function remove(e) {
          var t = Zn(e);
          Vn(this._styles, t), delete this._styles[e], this._cleanEmptyObjectsOnPath(t);
        }
      }, {
        key: "getNormalized",
        value: function getNormalized(e) {
          return this._styleProcessor.getNormalized(e, this._styles);
        }
      }, {
        key: "toString",
        value: function toString() {
          return this.isEmpty ? "" : this._getStylesEntries().map(function (e) {
            return e.join(":");
          }).sort().join(";") + ";";
        }
      }, {
        key: "getAsString",
        value: function getAsString(e) {
          if (this.isEmpty) return;
          if (this._styles[e] && !w(this._styles[e])) return this._styles[e];

          var t = this._styleProcessor.getReducedForm(e, this._styles).find(function (_ref20) {
            var _ref21 = _slicedToArray(_ref20, 1),
                t = _ref21[0];

            return t === e;
          });

          return Array.isArray(t) ? t[1] : void 0;
        }
      }, {
        key: "getStyleNames",
        value: function getStyleNames() {
          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
          if (this.isEmpty) return [];
          if (e) return this._styleProcessor.getStyleNames(this._styles);
          return this._getStylesEntries().map(function (_ref22) {
            var _ref23 = _slicedToArray(_ref22, 1),
                e = _ref23[0];

            return e;
          });
        }
      }, {
        key: "clear",
        value: function clear() {
          this._styles = {};
        }
      }, {
        key: "_getStylesEntries",
        value: function _getStylesEntries() {
          var e = [],
              t = Object.keys(this._styles);

          for (var _i22 = 0, _t19 = t; _i22 < _t19.length; _i22++) {
            var _i23 = _t19[_i22];
            e.push.apply(e, _toConsumableArray(this._styleProcessor.getReducedForm(_i23, this._styles)));
          }

          return e;
        }
      }, {
        key: "_cleanEmptyObjectsOnPath",
        value: function _cleanEmptyObjectsOnPath(e) {
          var t = e.split(".");
          if (!(t.length > 1)) return;
          var i = t.splice(0, t.length - 1).join("."),
              n = jn(this._styles, i);
          if (!n) return;
          !Array.from(Object.keys(n)).length && this.remove(i);
        }
      }, {
        key: "isEmpty",
        get: function get() {
          var e = Object.entries(this._styles);
          return !Array.from(e).length;
        }
      }, {
        key: "size",
        get: function get() {
          return this.isEmpty ? 0 : this.getStyleNames().length;
        }
      }]);

      return Qn;
    }();

    var Jn =
    /*#__PURE__*/
    function () {
      function Jn() {
        _classCallCheck(this, Jn);

        this._normalizers = new Map(), this._extractors = new Map(), this._reducers = new Map(), this._consumables = new Map();
      }

      _createClass(Jn, [{
        key: "toNormalizedForm",
        value: function toNormalizedForm(e, t, i) {
          if (w(t)) Xn(i, Zn(e), t);else if (this._normalizers.has(e)) {
            var _n7 = this._normalizers.get(e),
                _n8 = _n7(t),
                _o6 = _n8.path,
                _r7 = _n8.value;

            Xn(i, _o6, _r7);
          } else Xn(i, e, t);
        }
      }, {
        key: "getNormalized",
        value: function getNormalized(e, t) {
          if (!e) return Yn({}, t);
          if (void 0 !== t[e]) return t[e];

          if (this._extractors.has(e)) {
            var _i24 = this._extractors.get(e);

            if ("string" == typeof _i24) return jn(t, _i24);

            var _n9 = _i24(e, t);

            if (_n9) return _n9;
          }

          return jn(t, Zn(e));
        }
      }, {
        key: "getReducedForm",
        value: function getReducedForm(e, t) {
          var i = this.getNormalized(e, t);
          if (void 0 === i) return [];

          if (this._reducers.has(e)) {
            return this._reducers.get(e)(i);
          }

          return [[e, i]];
        }
      }, {
        key: "getStyleNames",
        value: function getStyleNames(e) {
          var _this18 = this;

          var t = Array.from(this._consumables.keys()).filter(function (t) {
            var i = _this18.getNormalized(t, e);

            return i && "object" == typeof i ? Object.keys(i).length : i;
          }),
              i = new Set([].concat(_toConsumableArray(t), _toConsumableArray(Object.keys(e))));
          return Array.from(i.values());
        }
      }, {
        key: "getRelatedStyles",
        value: function getRelatedStyles(e) {
          return this._consumables.get(e) || [];
        }
      }, {
        key: "setNormalizer",
        value: function setNormalizer(e, t) {
          this._normalizers.set(e, t);
        }
      }, {
        key: "setExtractor",
        value: function setExtractor(e, t) {
          this._extractors.set(e, t);
        }
      }, {
        key: "setReducer",
        value: function setReducer(e, t) {
          this._reducers.set(e, t);
        }
      }, {
        key: "setStyleRelation",
        value: function setStyleRelation(e, t) {
          this._mapStyleNames(e, t);

          var _iteratorNormalCompletion21 = true;
          var _didIteratorError21 = false;
          var _iteratorError21 = undefined;

          try {
            for (var _iterator21 = t[Symbol.iterator](), _step21; !(_iteratorNormalCompletion21 = (_step21 = _iterator21.next()).done); _iteratorNormalCompletion21 = true) {
              var _i25 = _step21.value;

              this._mapStyleNames(_i25, [e]);
            }
          } catch (err) {
            _didIteratorError21 = true;
            _iteratorError21 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion21 && _iterator21.return != null) {
                _iterator21.return();
              }
            } finally {
              if (_didIteratorError21) {
                throw _iteratorError21;
              }
            }
          }
        }
      }, {
        key: "_mapStyleNames",
        value: function _mapStyleNames(e, t) {
          var _this$_consumables$ge;

          this._consumables.has(e) || this._consumables.set(e, []), (_this$_consumables$ge = this._consumables.get(e)).push.apply(_this$_consumables$ge, _toConsumableArray(t));
        }
      }]);

      return Jn;
    }();

    function Zn(e) {
      return e.replace("-", ".");
    }

    function Xn(e, t, i) {
      var n = i;
      w(i) && (n = Yn({}, jn(e, t), i)), Kn(e, t, n);
    }

    var eo =
    /*#__PURE__*/
    function (_dn2) {
      _inherits(eo, _dn2);

      function eo(e, t, i, n) {
        var _this19;

        _classCallCheck(this, eo);

        if (_this19 = _possibleConstructorReturn(this, _getPrototypeOf(eo).call(this, e)), _this19.name = t, _this19._attrs = function (e) {
          e = gn(e);
          var _iteratorNormalCompletion22 = true;
          var _didIteratorError22 = false;
          var _iteratorError22 = undefined;

          try {
            for (var _iterator22 = e[Symbol.iterator](), _step22; !(_iteratorNormalCompletion22 = (_step22 = _iterator22.next()).done); _iteratorNormalCompletion22 = true) {
              var _ref26 = _step22.value;

              var _ref25 = _slicedToArray(_ref26, 2);

              var _t20 = _ref25[0];
              var _i26 = _ref25[1];
              null === _i26 ? e.delete(_t20) : "string" != typeof _i26 && e.set(_t20, String(_i26));
            }
          } catch (err) {
            _didIteratorError22 = true;
            _iteratorError22 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion22 && _iterator22.return != null) {
                _iterator22.return();
              }
            } finally {
              if (_didIteratorError22) {
                throw _iteratorError22;
              }
            }
          }

          return e;
        }(i), _this19._children = [], n && _this19._insertChild(0, n), _this19._classes = new Set(), _this19._attrs.has("class")) {
          var _e23 = _this19._attrs.get("class");

          to(_this19._classes, _e23), _this19._attrs.delete("class");
        }

        _this19._styles = new Qn(_this19.document.stylesProcessor), _this19._attrs.has("style") && (_this19._styles.setTo(_this19._attrs.get("style")), _this19._attrs.delete("style")), _this19._customProperties = new Map(), _this19._isAllowedInsideAttributeElement = !1;
        return _possibleConstructorReturn(_this19);
      }

      _createClass(eo, [{
        key: "is",
        value: function is(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          return t ? t === this.name && ("element" === e || "view:element" === e) : "element" === e || "view:element" === e || "node" === e || "view:node" === e;
        }
      }, {
        key: "getChild",
        value: function getChild(e) {
          return this._children[e];
        }
      }, {
        key: "getChildIndex",
        value: function getChildIndex(e) {
          return this._children.indexOf(e);
        }
      }, {
        key: "getChildren",
        value: function getChildren() {
          return this._children[Symbol.iterator]();
        }
      }, {
        key: "getAttributeKeys",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function getAttributeKeys() {
          return _regeneratorRuntime.wrap(function getAttributeKeys$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.t0 = this._classes.size > 0;

                  if (!_context3.t0) {
                    _context3.next = 4;
                    break;
                  }

                  _context3.next = 4;
                  return "class";

                case 4:
                  _context3.t1 = this._styles.isEmpty;

                  if (_context3.t1) {
                    _context3.next = 8;
                    break;
                  }

                  _context3.next = 8;
                  return "style";

                case 8:
                  return _context3.delegateYield(this._attrs.keys(), "t2", 9);

                case 9:
                case "end":
                  return _context3.stop();
              }
            }
          }, getAttributeKeys, this);
        })
      }, {
        key: "getAttributes",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function getAttributes() {
          return _regeneratorRuntime.wrap(function getAttributes$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  return _context4.delegateYield(this._attrs.entries(), "t0", 1);

                case 1:
                  _context4.t1 = this._classes.size > 0;

                  if (!_context4.t1) {
                    _context4.next = 5;
                    break;
                  }

                  _context4.next = 5;
                  return ["class", this.getAttribute("class")];

                case 5:
                  _context4.t2 = this._styles.isEmpty;

                  if (_context4.t2) {
                    _context4.next = 9;
                    break;
                  }

                  _context4.next = 9;
                  return ["style", this.getAttribute("style")];

                case 9:
                case "end":
                  return _context4.stop();
              }
            }
          }, getAttributes, this);
        })
      }, {
        key: "getAttribute",
        value: function getAttribute(e) {
          if ("class" == e) return this._classes.size > 0 ? _toConsumableArray(this._classes).join(" ") : void 0;

          if ("style" == e) {
            var _e24 = this._styles.toString();

            return "" == _e24 ? void 0 : _e24;
          }

          return this._attrs.get(e);
        }
      }, {
        key: "hasAttribute",
        value: function hasAttribute(e) {
          return "class" == e ? this._classes.size > 0 : "style" == e ? !this._styles.isEmpty : this._attrs.has(e);
        }
      }, {
        key: "isSimilar",
        value: function isSimilar(e) {
          if (!(e instanceof eo)) return !1;
          if (this === e) return !0;
          if (this.name != e.name) return !1;
          if (this.isAllowedInsideAttributeElement != e.isAllowedInsideAttributeElement) return !1;
          if (this._attrs.size !== e._attrs.size || this._classes.size !== e._classes.size || this._styles.size !== e._styles.size) return !1;
          var _iteratorNormalCompletion23 = true;
          var _didIteratorError23 = false;
          var _iteratorError23 = undefined;

          try {
            for (var _iterator23 = this._attrs[Symbol.iterator](), _step23; !(_iteratorNormalCompletion23 = (_step23 = _iterator23.next()).done); _iteratorNormalCompletion23 = true) {
              var _ref29 = _step23.value;

              var _ref28 = _slicedToArray(_ref29, 2);

              var _t21 = _ref28[0];
              var _i27 = _ref28[1];
              if (!e._attrs.has(_t21) || e._attrs.get(_t21) !== _i27) return !1;
            }
          } catch (err) {
            _didIteratorError23 = true;
            _iteratorError23 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion23 && _iterator23.return != null) {
                _iterator23.return();
              }
            } finally {
              if (_didIteratorError23) {
                throw _iteratorError23;
              }
            }
          }

          var _iteratorNormalCompletion24 = true;
          var _didIteratorError24 = false;
          var _iteratorError24 = undefined;

          try {
            for (var _iterator24 = this._classes[Symbol.iterator](), _step24; !(_iteratorNormalCompletion24 = (_step24 = _iterator24.next()).done); _iteratorNormalCompletion24 = true) {
              var _t22 = _step24.value;
              if (!e._classes.has(_t22)) return !1;
            }
          } catch (err) {
            _didIteratorError24 = true;
            _iteratorError24 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion24 && _iterator24.return != null) {
                _iterator24.return();
              }
            } finally {
              if (_didIteratorError24) {
                throw _iteratorError24;
              }
            }
          }

          var _iteratorNormalCompletion25 = true;
          var _didIteratorError25 = false;
          var _iteratorError25 = undefined;

          try {
            for (var _iterator25 = this._styles.getStyleNames()[Symbol.iterator](), _step25; !(_iteratorNormalCompletion25 = (_step25 = _iterator25.next()).done); _iteratorNormalCompletion25 = true) {
              var _t23 = _step25.value;
              if (!e._styles.has(_t23) || e._styles.getAsString(_t23) !== this._styles.getAsString(_t23)) return !1;
            }
          } catch (err) {
            _didIteratorError25 = true;
            _iteratorError25 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion25 && _iterator25.return != null) {
                _iterator25.return();
              }
            } finally {
              if (_didIteratorError25) {
                throw _iteratorError25;
              }
            }
          }

          return !0;
        }
      }, {
        key: "hasClass",
        value: function hasClass() {
          for (var _len13 = arguments.length, e = new Array(_len13), _key13 = 0; _key13 < _len13; _key13++) {
            e[_key13] = arguments[_key13];
          }

          for (var _i28 = 0, _e25 = e; _i28 < _e25.length; _i28++) {
            var _t24 = _e25[_i28];
            if (!this._classes.has(_t24)) return !1;
          }

          return !0;
        }
      }, {
        key: "getClassNames",
        value: function getClassNames() {
          return this._classes.keys();
        }
      }, {
        key: "getStyle",
        value: function getStyle(e) {
          return this._styles.getAsString(e);
        }
      }, {
        key: "getNormalizedStyle",
        value: function getNormalizedStyle(e) {
          return this._styles.getNormalized(e);
        }
      }, {
        key: "getStyleNames",
        value: function getStyleNames() {
          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
          return this._styles.getStyleNames(e);
        }
      }, {
        key: "hasStyle",
        value: function hasStyle() {
          for (var _len14 = arguments.length, e = new Array(_len14), _key14 = 0; _key14 < _len14; _key14++) {
            e[_key14] = arguments[_key14];
          }

          for (var _i29 = 0, _e26 = e; _i29 < _e26.length; _i29++) {
            var _t25 = _e26[_i29];
            if (!this._styles.has(_t25)) return !1;
          }

          return !0;
        }
      }, {
        key: "findAncestor",
        value: function findAncestor() {
          for (var _len15 = arguments.length, e = new Array(_len15), _key15 = 0; _key15 < _len15; _key15++) {
            e[_key15] = arguments[_key15];
          }

          var t = _construct(mn, e);

          var i = this.parent;

          for (; i;) {
            if (t.match(i)) return i;
            i = i.parent;
          }

          return null;
        }
      }, {
        key: "getCustomProperty",
        value: function getCustomProperty(e) {
          return this._customProperties.get(e);
        }
      }, {
        key: "getCustomProperties",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function getCustomProperties() {
          return _regeneratorRuntime.wrap(function getCustomProperties$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  return _context5.delegateYield(this._customProperties.entries(), "t0", 1);

                case 1:
                case "end":
                  return _context5.stop();
              }
            }
          }, getCustomProperties, this);
        })
      }, {
        key: "getIdentity",
        value: function getIdentity() {
          var e = Array.from(this._classes).sort().join(","),
              t = this._styles.toString(),
              i = Array.from(this._attrs).map(function (e) {
            return "".concat(e[0], "=\"").concat(e[1], "\"");
          }).sort().join(" ");

          return this.name + ("" == e ? "" : " class=\"".concat(e, "\"")) + (t ? " style=\"".concat(t, "\"") : "") + ("" == i ? "" : " " + i);
        }
      }, {
        key: "_clone",
        value: function _clone() {
          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
          var t = [];

          if (e) {
            var _iteratorNormalCompletion26 = true;
            var _didIteratorError26 = false;
            var _iteratorError26 = undefined;

            try {
              for (var _iterator26 = this.getChildren()[Symbol.iterator](), _step26; !(_iteratorNormalCompletion26 = (_step26 = _iterator26.next()).done); _iteratorNormalCompletion26 = true) {
                var _i30 = _step26.value;
                t.push(_i30._clone(e));
              }
            } catch (err) {
              _didIteratorError26 = true;
              _iteratorError26 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion26 && _iterator26.return != null) {
                  _iterator26.return();
                }
              } finally {
                if (_didIteratorError26) {
                  throw _iteratorError26;
                }
              }
            }
          }

          var i = new this.constructor(this.document, this.name, this._attrs, t);
          return i._classes = new Set(this._classes), i._styles.set(this._styles.getNormalized()), i._customProperties = new Map(this._customProperties), i.getFillerOffset = this.getFillerOffset, i._isAllowedInsideAttributeElement = this.isAllowedInsideAttributeElement, i;
        }
      }, {
        key: "_appendChild",
        value: function _appendChild(e) {
          return this._insertChild(this.childCount, e);
        }
      }, {
        key: "_insertChild",
        value: function _insertChild(e, t) {
          this._fireChange("children", this);

          var i = 0;

          var n = function (e, t) {
            if ("string" == typeof t) return [new hn(e, t)];
            Ji(t) || (t = [t]);
            return Array.from(t).map(function (t) {
              return "string" == typeof t ? new hn(e, t) : t instanceof un ? new hn(e, t.data) : t;
            });
          }(this.document, t);

          var _iteratorNormalCompletion27 = true;
          var _didIteratorError27 = false;
          var _iteratorError27 = undefined;

          try {
            for (var _iterator27 = n[Symbol.iterator](), _step27; !(_iteratorNormalCompletion27 = (_step27 = _iterator27.next()).done); _iteratorNormalCompletion27 = true) {
              var _t26 = _step27.value;
              null !== _t26.parent && _t26._remove(), _t26.parent = this, _t26.document = this.document, this._children.splice(e, 0, _t26), e++, i++;
            }
          } catch (err) {
            _didIteratorError27 = true;
            _iteratorError27 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion27 && _iterator27.return != null) {
                _iterator27.return();
              }
            } finally {
              if (_didIteratorError27) {
                throw _iteratorError27;
              }
            }
          }

          return i;
        }
      }, {
        key: "_removeChildren",
        value: function _removeChildren(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

          this._fireChange("children", this);

          for (var _i31 = e; _i31 < e + t; _i31++) {
            this._children[_i31].parent = null;
          }

          return this._children.splice(e, t);
        }
      }, {
        key: "_setAttribute",
        value: function _setAttribute(e, t) {
          t = String(t), this._fireChange("attributes", this), "class" == e ? to(this._classes, t) : "style" == e ? this._styles.setTo(t) : this._attrs.set(e, t);
        }
      }, {
        key: "_removeAttribute",
        value: function _removeAttribute(e) {
          return this._fireChange("attributes", this), "class" == e ? this._classes.size > 0 && (this._classes.clear(), !0) : "style" == e ? !this._styles.isEmpty && (this._styles.clear(), !0) : this._attrs.delete(e);
        }
      }, {
        key: "_addClass",
        value: function _addClass(e) {
          this._fireChange("attributes", this);

          var _iteratorNormalCompletion28 = true;
          var _didIteratorError28 = false;
          var _iteratorError28 = undefined;

          try {
            for (var _iterator28 = en(e)[Symbol.iterator](), _step28; !(_iteratorNormalCompletion28 = (_step28 = _iterator28.next()).done); _iteratorNormalCompletion28 = true) {
              var _t27 = _step28.value;

              this._classes.add(_t27);
            }
          } catch (err) {
            _didIteratorError28 = true;
            _iteratorError28 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion28 && _iterator28.return != null) {
                _iterator28.return();
              }
            } finally {
              if (_didIteratorError28) {
                throw _iteratorError28;
              }
            }
          }
        }
      }, {
        key: "_removeClass",
        value: function _removeClass(e) {
          this._fireChange("attributes", this);

          var _iteratorNormalCompletion29 = true;
          var _didIteratorError29 = false;
          var _iteratorError29 = undefined;

          try {
            for (var _iterator29 = en(e)[Symbol.iterator](), _step29; !(_iteratorNormalCompletion29 = (_step29 = _iterator29.next()).done); _iteratorNormalCompletion29 = true) {
              var _t28 = _step29.value;

              this._classes.delete(_t28);
            }
          } catch (err) {
            _didIteratorError29 = true;
            _iteratorError29 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion29 && _iterator29.return != null) {
                _iterator29.return();
              }
            } finally {
              if (_didIteratorError29) {
                throw _iteratorError29;
              }
            }
          }
        }
      }, {
        key: "_setStyle",
        value: function _setStyle(e, t) {
          this._fireChange("attributes", this), this._styles.set(e, t);
        }
      }, {
        key: "_removeStyle",
        value: function _removeStyle(e) {
          this._fireChange("attributes", this);

          var _iteratorNormalCompletion30 = true;
          var _didIteratorError30 = false;
          var _iteratorError30 = undefined;

          try {
            for (var _iterator30 = en(e)[Symbol.iterator](), _step30; !(_iteratorNormalCompletion30 = (_step30 = _iterator30.next()).done); _iteratorNormalCompletion30 = true) {
              var _t29 = _step30.value;

              this._styles.remove(_t29);
            }
          } catch (err) {
            _didIteratorError30 = true;
            _iteratorError30 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion30 && _iterator30.return != null) {
                _iterator30.return();
              }
            } finally {
              if (_didIteratorError30) {
                throw _iteratorError30;
              }
            }
          }
        }
      }, {
        key: "_setCustomProperty",
        value: function _setCustomProperty(e, t) {
          this._customProperties.set(e, t);
        }
      }, {
        key: "_removeCustomProperty",
        value: function _removeCustomProperty(e) {
          return this._customProperties.delete(e);
        }
      }, {
        key: "childCount",
        get: function get() {
          return this._children.length;
        }
      }, {
        key: "isEmpty",
        get: function get() {
          return 0 === this._children.length;
        }
      }, {
        key: "isAllowedInsideAttributeElement",
        get: function get() {
          return this._isAllowedInsideAttributeElement;
        }
      }]);

      return eo;
    }(dn);

    function to(e, t) {
      var i = t.split(/\s+/);
      e.clear(), i.forEach(function (t) {
        return e.add(t);
      });
    }

    var io =
    /*#__PURE__*/
    function (_eo) {
      _inherits(io, _eo);

      function io(e, t, i, n) {
        var _this20;

        _classCallCheck(this, io);

        _this20 = _possibleConstructorReturn(this, _getPrototypeOf(io).call(this, e, t, i, n)), _this20.getFillerOffset = no;
        return _this20;
      }

      _createClass(io, [{
        key: "is",
        value: function is(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          return t ? t === this.name && ("containerElement" === e || "view:containerElement" === e || "element" === e || "view:element" === e) : "containerElement" === e || "view:containerElement" === e || "element" === e || "view:element" === e || "node" === e || "view:node" === e;
        }
      }]);

      return io;
    }(eo);

    function no() {
      var e = _toConsumableArray(this.getChildren()),
          t = e[this.childCount - 1];

      if (t && t.is("element", "br")) return this.childCount;
      var _iteratorNormalCompletion31 = true;
      var _didIteratorError31 = false;
      var _iteratorError31 = undefined;

      try {
        for (var _iterator31 = e[Symbol.iterator](), _step31; !(_iteratorNormalCompletion31 = (_step31 = _iterator31.next()).done); _iteratorNormalCompletion31 = true) {
          var _t30 = _step31.value;
          if (!_t30.is("uiElement")) return null;
        }
      } catch (err) {
        _didIteratorError31 = true;
        _iteratorError31 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion31 && _iterator31.return != null) {
            _iterator31.return();
          }
        } finally {
          if (_didIteratorError31) {
            throw _iteratorError31;
          }
        }
      }

      return this.childCount;
    }

    var oo =
    /*#__PURE__*/
    function (_io) {
      _inherits(oo, _io);

      function oo(e, t, i, n) {
        var _this21;

        _classCallCheck(this, oo);

        _this21 = _possibleConstructorReturn(this, _getPrototypeOf(oo).call(this, e, t, i, n)), _this21.set("isReadOnly", !1), _this21.set("isFocused", !1), _this21.bind("isReadOnly").to(e), _this21.bind("isFocused").to(e, "isFocused", function (t) {
          return t && e.selection.editableElement == _assertThisInitialized(_this21);
        }), _this21.listenTo(e.selection, "change", function () {
          _this21.isFocused = e.isFocused && e.selection.editableElement == _assertThisInitialized(_this21);
        });
        return _this21;
      }

      _createClass(oo, [{
        key: "is",
        value: function is(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          return t ? t === this.name && ("editableElement" === e || "view:editableElement" === e || "containerElement" === e || "view:containerElement" === e || "element" === e || "view:element" === e) : "editableElement" === e || "view:editableElement" === e || "containerElement" === e || "view:containerElement" === e || "element" === e || "view:element" === e || "node" === e || "view:node" === e;
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.stopListening();
        }
      }]);

      return oo;
    }(io);

    Ke(oo, Ue);
    var ro = Symbol("rootName");

    var so =
    /*#__PURE__*/
    function (_oo) {
      _inherits(so, _oo);

      function so(e, t) {
        var _this22;

        _classCallCheck(this, so);

        _this22 = _possibleConstructorReturn(this, _getPrototypeOf(so).call(this, e, t)), _this22.rootName = "main";
        return _this22;
      }

      _createClass(so, [{
        key: "is",
        value: function is(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          return t ? t === this.name && ("rootElement" === e || "view:rootElement" === e || "editableElement" === e || "view:editableElement" === e || "containerElement" === e || "view:containerElement" === e || "element" === e || "view:element" === e) : "rootElement" === e || "view:rootElement" === e || "editableElement" === e || "view:editableElement" === e || "containerElement" === e || "view:containerElement" === e || "element" === e || "view:element" === e || "node" === e || "view:node" === e;
        }
      }, {
        key: "rootName",
        get: function get() {
          return this.getCustomProperty(ro);
        },
        set: function set(e) {
          this._setCustomProperty(ro, e);
        }
      }, {
        key: "_name",
        set: function set(e) {
          this.name = e;
        }
      }]);

      return so;
    }(oo);

    var ao =
    /*#__PURE__*/
    function () {
      function ao() {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, ao);

        if (!e.boundaries && !e.startPosition) throw new c.a("view-tree-walker-no-start-position", null);
        if (e.direction && "forward" != e.direction && "backward" != e.direction) throw new c.a("view-tree-walker-unknown-direction", e.startPosition, {
          direction: e.direction
        });
        this.boundaries = e.boundaries || null, e.startPosition ? this.position = co._createAt(e.startPosition) : this.position = co._createAt(e.boundaries["backward" == e.direction ? "end" : "start"]), this.direction = e.direction || "forward", this.singleCharacters = !!e.singleCharacters, this.shallow = !!e.shallow, this.ignoreElementEnd = !!e.ignoreElementEnd, this._boundaryStartParent = this.boundaries ? this.boundaries.start.parent : null, this._boundaryEndParent = this.boundaries ? this.boundaries.end.parent : null;
      }

      _createClass(ao, [{
        key: Symbol.iterator,
        value: function value() {
          return this;
        }
      }, {
        key: "skip",
        value: function skip(e) {
          var t, i, n;

          do {
            var _this$next;

            n = this.position, (_this$next = this.next(), t = _this$next.done, i = _this$next.value, _this$next);
          } while (!t && e(i));

          t || (this.position = n);
        }
      }, {
        key: "next",
        value: function next() {
          return "forward" == this.direction ? this._next() : this._previous();
        }
      }, {
        key: "_next",
        value: function _next() {
          var e = this.position.clone();
          var t = this.position,
              i = e.parent;
          if (null === i.parent && e.offset === i.childCount) return {
            done: !0
          };
          if (i === this._boundaryEndParent && e.offset == this.boundaries.end.offset) return {
            done: !0
          };
          var n;

          if (i instanceof hn) {
            if (e.isAtEnd) return this.position = co._createAfter(i), this._next();
            n = i.data[e.offset];
          } else n = i.getChild(e.offset);

          if (n instanceof eo) return this.shallow ? e.offset++ : e = new co(n, 0), this.position = e, this._formatReturnValue("elementStart", n, t, e, 1);

          if (n instanceof hn) {
            if (this.singleCharacters) return e = new co(n, 0), this.position = e, this._next();
            {
              var _i32,
                  _o7 = n.data.length;

              return n == this._boundaryEndParent ? (_o7 = this.boundaries.end.offset, _i32 = new un(n, 0, _o7), e = co._createAfter(_i32)) : (_i32 = new un(n, 0, n.data.length), e.offset++), this.position = e, this._formatReturnValue("text", _i32, t, e, _o7);
            }
          }

          if ("string" == typeof n) {
            var _n10;

            if (this.singleCharacters) _n10 = 1;else {
              _n10 = (i === this._boundaryEndParent ? this.boundaries.end.offset : i.data.length) - e.offset;
            }

            var _o8 = new un(i, e.offset, _n10);

            return e.offset += _n10, this.position = e, this._formatReturnValue("text", _o8, t, e, _n10);
          }

          return e = co._createAfter(i), this.position = e, this.ignoreElementEnd ? this._next() : this._formatReturnValue("elementEnd", i, t, e);
        }
      }, {
        key: "_previous",
        value: function _previous() {
          var e = this.position.clone();
          var t = this.position,
              i = e.parent;
          if (null === i.parent && 0 === e.offset) return {
            done: !0
          };
          if (i == this._boundaryStartParent && e.offset == this.boundaries.start.offset) return {
            done: !0
          };
          var n;

          if (i instanceof hn) {
            if (e.isAtStart) return this.position = co._createBefore(i), this._previous();
            n = i.data[e.offset - 1];
          } else n = i.getChild(e.offset - 1);

          if (n instanceof eo) return this.shallow ? (e.offset--, this.position = e, this._formatReturnValue("elementStart", n, t, e, 1)) : (e = new co(n, n.childCount), this.position = e, this.ignoreElementEnd ? this._previous() : this._formatReturnValue("elementEnd", n, t, e));

          if (n instanceof hn) {
            if (this.singleCharacters) return e = new co(n, n.data.length), this.position = e, this._previous();
            {
              var _i33,
                  _o9 = n.data.length;

              if (n == this._boundaryStartParent) {
                var _t31 = this.boundaries.start.offset;
                _i33 = new un(n, _t31, n.data.length - _t31), _o9 = _i33.data.length, e = co._createBefore(_i33);
              } else _i33 = new un(n, 0, n.data.length), e.offset--;

              return this.position = e, this._formatReturnValue("text", _i33, t, e, _o9);
            }
          }

          if ("string" == typeof n) {
            var _n11;

            if (this.singleCharacters) _n11 = 1;else {
              var _t32 = i === this._boundaryStartParent ? this.boundaries.start.offset : 0;

              _n11 = e.offset - _t32;
            }
            e.offset -= _n11;

            var _o10 = new un(i, e.offset, _n11);

            return this.position = e, this._formatReturnValue("text", _o10, t, e, _n11);
          }

          return e = co._createBefore(i), this.position = e, this._formatReturnValue("elementStart", i, t, e, 1);
        }
      }, {
        key: "_formatReturnValue",
        value: function _formatReturnValue(e, t, i, n, o) {
          return t instanceof un && (t.offsetInText + t.data.length == t.textNode.data.length && ("forward" != this.direction || this.boundaries && this.boundaries.end.isEqual(this.position) ? i = co._createAfter(t.textNode) : (n = co._createAfter(t.textNode), this.position = n)), 0 === t.offsetInText && ("backward" != this.direction || this.boundaries && this.boundaries.start.isEqual(this.position) ? i = co._createBefore(t.textNode) : (n = co._createBefore(t.textNode), this.position = n))), {
            done: !1,
            value: {
              type: e,
              item: t,
              previousPosition: i,
              nextPosition: n,
              length: o
            }
          };
        }
      }]);

      return ao;
    }();

    var co =
    /*#__PURE__*/
    function () {
      function co(e, t) {
        _classCallCheck(this, co);

        this.parent = e, this.offset = t;
      }

      _createClass(co, [{
        key: "getShiftedBy",
        value: function getShiftedBy(e) {
          var t = co._createAt(this),
              i = t.offset + e;

          return t.offset = i < 0 ? 0 : i, t;
        }
      }, {
        key: "getLastMatchingPosition",
        value: function getLastMatchingPosition(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          t.startPosition = this;
          var i = new ao(t);
          return i.skip(e), i.position;
        }
      }, {
        key: "getAncestors",
        value: function getAncestors() {
          return this.parent.is("documentFragment") ? [this.parent] : this.parent.getAncestors({
            includeSelf: !0
          });
        }
      }, {
        key: "getCommonAncestor",
        value: function getCommonAncestor(e) {
          var t = this.getAncestors(),
              i = e.getAncestors();
          var n = 0;

          for (; t[n] == i[n] && t[n];) {
            n++;
          }

          return 0 === n ? null : t[n - 1];
        }
      }, {
        key: "is",
        value: function is(e) {
          return "position" === e || "view:position" === e;
        }
      }, {
        key: "isEqual",
        value: function isEqual(e) {
          return this.parent == e.parent && this.offset == e.offset;
        }
      }, {
        key: "isBefore",
        value: function isBefore(e) {
          return "before" == this.compareWith(e);
        }
      }, {
        key: "isAfter",
        value: function isAfter(e) {
          return "after" == this.compareWith(e);
        }
      }, {
        key: "compareWith",
        value: function compareWith(e) {
          if (this.root !== e.root) return "different";
          if (this.isEqual(e)) return "same";
          var t = this.parent.is("node") ? this.parent.getPath() : [],
              i = e.parent.is("node") ? e.parent.getPath() : [];
          t.push(this.offset), i.push(e.offset);
          var n = cn(t, i);

          switch (n) {
            case "prefix":
              return "before";

            case "extension":
              return "after";

            default:
              return t[n] < i[n] ? "before" : "after";
          }
        }
      }, {
        key: "getWalker",
        value: function getWalker() {
          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          return e.startPosition = this, new ao(e);
        }
      }, {
        key: "clone",
        value: function clone() {
          return new co(this.parent, this.offset);
        }
      }, {
        key: "nodeAfter",
        get: function get() {
          return this.parent.is("$text") ? null : this.parent.getChild(this.offset) || null;
        }
      }, {
        key: "nodeBefore",
        get: function get() {
          return this.parent.is("$text") ? null : this.parent.getChild(this.offset - 1) || null;
        }
      }, {
        key: "isAtStart",
        get: function get() {
          return 0 === this.offset;
        }
      }, {
        key: "isAtEnd",
        get: function get() {
          var e = this.parent.is("$text") ? this.parent.data.length : this.parent.childCount;
          return this.offset === e;
        }
      }, {
        key: "root",
        get: function get() {
          return this.parent.root;
        }
      }, {
        key: "editableElement",
        get: function get() {
          var e = this.parent;

          for (; !(e instanceof oo);) {
            if (!e.parent) return null;
            e = e.parent;
          }

          return e;
        }
      }], [{
        key: "_createAt",
        value: function _createAt(e, t) {
          if (e instanceof co) return new this(e.parent, e.offset);
          {
            var _i34 = e;
            if ("end" == t) t = _i34.is("$text") ? _i34.data.length : _i34.childCount;else {
              if ("before" == t) return this._createBefore(_i34);
              if ("after" == t) return this._createAfter(_i34);
              if (0 !== t && !t) throw new c.a("view-createpositionat-offset-required", _i34);
            }
            return new co(_i34, t);
          }
        }
      }, {
        key: "_createAfter",
        value: function _createAfter(e) {
          if (e.is("$textProxy")) return new co(e.textNode, e.offsetInText + e.data.length);
          if (!e.parent) throw new c.a("view-position-after-root", e, {
            root: e
          });
          return new co(e.parent, e.index + 1);
        }
      }, {
        key: "_createBefore",
        value: function _createBefore(e) {
          if (e.is("$textProxy")) return new co(e.textNode, e.offsetInText);
          if (!e.parent) throw new c.a("view-position-before-root", e, {
            root: e
          });
          return new co(e.parent, e.index);
        }
      }]);

      return co;
    }();

    var lo =
    /*#__PURE__*/
    function () {
      function lo(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

        _classCallCheck(this, lo);

        this.start = e.clone(), this.end = t ? t.clone() : e.clone();
      }

      _createClass(lo, [{
        key: Symbol.iterator,
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function value() {
          return _regeneratorRuntime.wrap(function value$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  return _context6.delegateYield(new ao({
                    boundaries: this,
                    ignoreElementEnd: !0
                  }), "t0", 1);

                case 1:
                case "end":
                  return _context6.stop();
              }
            }
          }, value, this);
        })
      }, {
        key: "getEnlarged",
        value: function getEnlarged() {
          var e = this.start.getLastMatchingPosition(ho, {
            direction: "backward"
          }),
              t = this.end.getLastMatchingPosition(ho);
          return e.parent.is("$text") && e.isAtStart && (e = co._createBefore(e.parent)), t.parent.is("$text") && t.isAtEnd && (t = co._createAfter(t.parent)), new lo(e, t);
        }
      }, {
        key: "getTrimmed",
        value: function getTrimmed() {
          var e = this.start.getLastMatchingPosition(ho);
          if (e.isAfter(this.end) || e.isEqual(this.end)) return new lo(e, e);
          var t = this.end.getLastMatchingPosition(ho, {
            direction: "backward"
          });
          var i = e.nodeAfter,
              n = t.nodeBefore;
          return i && i.is("$text") && (e = new co(i, 0)), n && n.is("$text") && (t = new co(n, n.data.length)), new lo(e, t);
        }
      }, {
        key: "isEqual",
        value: function isEqual(e) {
          return this == e || this.start.isEqual(e.start) && this.end.isEqual(e.end);
        }
      }, {
        key: "containsPosition",
        value: function containsPosition(e) {
          return e.isAfter(this.start) && e.isBefore(this.end);
        }
      }, {
        key: "containsRange",
        value: function containsRange(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          e.isCollapsed && (t = !1);
          var i = this.containsPosition(e.start) || t && this.start.isEqual(e.start),
              n = this.containsPosition(e.end) || t && this.end.isEqual(e.end);
          return i && n;
        }
      }, {
        key: "getDifference",
        value: function getDifference(e) {
          var t = [];
          return this.isIntersecting(e) ? (this.containsPosition(e.start) && t.push(new lo(this.start, e.start)), this.containsPosition(e.end) && t.push(new lo(e.end, this.end))) : t.push(this.clone()), t;
        }
      }, {
        key: "getIntersection",
        value: function getIntersection(e) {
          if (this.isIntersecting(e)) {
            var _t33 = this.start,
                _i35 = this.end;
            return this.containsPosition(e.start) && (_t33 = e.start), this.containsPosition(e.end) && (_i35 = e.end), new lo(_t33, _i35);
          }

          return null;
        }
      }, {
        key: "getWalker",
        value: function getWalker() {
          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          return e.boundaries = this, new ao(e);
        }
      }, {
        key: "getCommonAncestor",
        value: function getCommonAncestor() {
          return this.start.getCommonAncestor(this.end);
        }
      }, {
        key: "getContainedElement",
        value: function getContainedElement() {
          if (this.isCollapsed) return null;
          var e = this.start.nodeAfter,
              t = this.end.nodeBefore;
          return this.start.parent.is("$text") && this.start.isAtEnd && this.start.parent.nextSibling && (e = this.start.parent.nextSibling), this.end.parent.is("$text") && this.end.isAtStart && this.end.parent.previousSibling && (t = this.end.parent.previousSibling), e && e.is("element") && e === t ? e : null;
        }
      }, {
        key: "clone",
        value: function clone() {
          return new lo(this.start, this.end);
        }
      }, {
        key: "getItems",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function getItems() {
          var e,
              t,
              _iteratorNormalCompletion32,
              _didIteratorError32,
              _iteratorError32,
              _iterator32,
              _step32,
              _e27,
              _args7 = arguments;

          return _regeneratorRuntime.wrap(function getItems$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  e = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : {};
                  e.boundaries = this, e.ignoreElementEnd = !0;
                  t = new ao(e);
                  _iteratorNormalCompletion32 = true;
                  _didIteratorError32 = false;
                  _iteratorError32 = undefined;
                  _context7.prev = 6;
                  _iterator32 = t[Symbol.iterator]();

                case 8:
                  if (_iteratorNormalCompletion32 = (_step32 = _iterator32.next()).done) {
                    _context7.next = 15;
                    break;
                  }

                  _e27 = _step32.value;
                  _context7.next = 12;
                  return _e27.item;

                case 12:
                  _iteratorNormalCompletion32 = true;
                  _context7.next = 8;
                  break;

                case 15:
                  _context7.next = 21;
                  break;

                case 17:
                  _context7.prev = 17;
                  _context7.t0 = _context7["catch"](6);
                  _didIteratorError32 = true;
                  _iteratorError32 = _context7.t0;

                case 21:
                  _context7.prev = 21;
                  _context7.prev = 22;

                  if (!_iteratorNormalCompletion32 && _iterator32.return != null) {
                    _iterator32.return();
                  }

                case 24:
                  _context7.prev = 24;

                  if (!_didIteratorError32) {
                    _context7.next = 27;
                    break;
                  }

                  throw _iteratorError32;

                case 27:
                  return _context7.finish(24);

                case 28:
                  return _context7.finish(21);

                case 29:
                case "end":
                  return _context7.stop();
              }
            }
          }, getItems, this, [[6, 17, 21, 29], [22,, 24, 28]]);
        })
      }, {
        key: "getPositions",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function getPositions() {
          var e,
              t,
              _iteratorNormalCompletion33,
              _didIteratorError33,
              _iteratorError33,
              _iterator33,
              _step33,
              _e28,
              _args8 = arguments;

          return _regeneratorRuntime.wrap(function getPositions$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  e = _args8.length > 0 && _args8[0] !== undefined ? _args8[0] : {};
                  e.boundaries = this;
                  t = new ao(e);
                  _context8.next = 5;
                  return t.position;

                case 5:
                  _iteratorNormalCompletion33 = true;
                  _didIteratorError33 = false;
                  _iteratorError33 = undefined;
                  _context8.prev = 8;
                  _iterator33 = t[Symbol.iterator]();

                case 10:
                  if (_iteratorNormalCompletion33 = (_step33 = _iterator33.next()).done) {
                    _context8.next = 17;
                    break;
                  }

                  _e28 = _step33.value;
                  _context8.next = 14;
                  return _e28.nextPosition;

                case 14:
                  _iteratorNormalCompletion33 = true;
                  _context8.next = 10;
                  break;

                case 17:
                  _context8.next = 23;
                  break;

                case 19:
                  _context8.prev = 19;
                  _context8.t0 = _context8["catch"](8);
                  _didIteratorError33 = true;
                  _iteratorError33 = _context8.t0;

                case 23:
                  _context8.prev = 23;
                  _context8.prev = 24;

                  if (!_iteratorNormalCompletion33 && _iterator33.return != null) {
                    _iterator33.return();
                  }

                case 26:
                  _context8.prev = 26;

                  if (!_didIteratorError33) {
                    _context8.next = 29;
                    break;
                  }

                  throw _iteratorError33;

                case 29:
                  return _context8.finish(26);

                case 30:
                  return _context8.finish(23);

                case 31:
                case "end":
                  return _context8.stop();
              }
            }
          }, getPositions, this, [[8, 19, 23, 31], [24,, 26, 30]]);
        })
      }, {
        key: "is",
        value: function is(e) {
          return "range" === e || "view:range" === e;
        }
      }, {
        key: "isIntersecting",
        value: function isIntersecting(e) {
          return this.start.isBefore(e.end) && this.end.isAfter(e.start);
        }
      }, {
        key: "isCollapsed",
        get: function get() {
          return this.start.isEqual(this.end);
        }
      }, {
        key: "isFlat",
        get: function get() {
          return this.start.parent === this.end.parent;
        }
      }, {
        key: "root",
        get: function get() {
          return this.start.root;
        }
      }], [{
        key: "_createFromParentsAndOffsets",
        value: function _createFromParentsAndOffsets(e, t, i, n) {
          return new this(new co(e, t), new co(i, n));
        }
      }, {
        key: "_createFromPositionAndShift",
        value: function _createFromPositionAndShift(e, t) {
          var i = e,
              n = e.getShiftedBy(t);
          return t > 0 ? new this(i, n) : new this(n, i);
        }
      }, {
        key: "_createIn",
        value: function _createIn(e) {
          return this._createFromParentsAndOffsets(e, 0, e, e.childCount);
        }
      }, {
        key: "_createOn",
        value: function _createOn(e) {
          var t = e.is("$textProxy") ? e.offsetSize : 1;
          return this._createFromPositionAndShift(co._createBefore(e), t);
        }
      }]);

      return lo;
    }();

    function ho(e) {
      return !(!e.item.is("attributeElement") && !e.item.is("uiElement"));
    }

    function uo(e) {
      var t = 0;
      var _iteratorNormalCompletion34 = true;
      var _didIteratorError34 = false;
      var _iteratorError34 = undefined;

      try {
        for (var _iterator34 = e[Symbol.iterator](), _step34; !(_iteratorNormalCompletion34 = (_step34 = _iterator34.next()).done); _iteratorNormalCompletion34 = true) {
          var _i36 = _step34.value;
          t++;
        }
      } catch (err) {
        _didIteratorError34 = true;
        _iteratorError34 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion34 && _iterator34.return != null) {
            _iterator34.return();
          }
        } finally {
          if (_didIteratorError34) {
            throw _iteratorError34;
          }
        }
      }

      return t;
    }

    var go =
    /*#__PURE__*/
    function () {
      function go() {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var t = arguments.length > 1 ? arguments[1] : undefined;
        var i = arguments.length > 2 ? arguments[2] : undefined;

        _classCallCheck(this, go);

        this._ranges = [], this._lastRangeBackward = !1, this._isFake = !1, this._fakeSelectionLabel = "", this.setTo(e, t, i);
      }

      _createClass(go, [{
        key: "getRanges",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function getRanges() {
          var _iteratorNormalCompletion35, _didIteratorError35, _iteratorError35, _iterator35, _step35, _e29;

          return _regeneratorRuntime.wrap(function getRanges$(_context9) {
            while (1) {
              switch (_context9.prev = _context9.next) {
                case 0:
                  _iteratorNormalCompletion35 = true;
                  _didIteratorError35 = false;
                  _iteratorError35 = undefined;
                  _context9.prev = 3;
                  _iterator35 = this._ranges[Symbol.iterator]();

                case 5:
                  if (_iteratorNormalCompletion35 = (_step35 = _iterator35.next()).done) {
                    _context9.next = 12;
                    break;
                  }

                  _e29 = _step35.value;
                  _context9.next = 9;
                  return _e29.clone();

                case 9:
                  _iteratorNormalCompletion35 = true;
                  _context9.next = 5;
                  break;

                case 12:
                  _context9.next = 18;
                  break;

                case 14:
                  _context9.prev = 14;
                  _context9.t0 = _context9["catch"](3);
                  _didIteratorError35 = true;
                  _iteratorError35 = _context9.t0;

                case 18:
                  _context9.prev = 18;
                  _context9.prev = 19;

                  if (!_iteratorNormalCompletion35 && _iterator35.return != null) {
                    _iterator35.return();
                  }

                case 21:
                  _context9.prev = 21;

                  if (!_didIteratorError35) {
                    _context9.next = 24;
                    break;
                  }

                  throw _iteratorError35;

                case 24:
                  return _context9.finish(21);

                case 25:
                  return _context9.finish(18);

                case 26:
                case "end":
                  return _context9.stop();
              }
            }
          }, getRanges, this, [[3, 14, 18, 26], [19,, 21, 25]]);
        })
      }, {
        key: "getFirstRange",
        value: function getFirstRange() {
          var e = null;
          var _iteratorNormalCompletion36 = true;
          var _didIteratorError36 = false;
          var _iteratorError36 = undefined;

          try {
            for (var _iterator36 = this._ranges[Symbol.iterator](), _step36; !(_iteratorNormalCompletion36 = (_step36 = _iterator36.next()).done); _iteratorNormalCompletion36 = true) {
              var _t34 = _step36.value;
              e && !_t34.start.isBefore(e.start) || (e = _t34);
            }
          } catch (err) {
            _didIteratorError36 = true;
            _iteratorError36 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion36 && _iterator36.return != null) {
                _iterator36.return();
              }
            } finally {
              if (_didIteratorError36) {
                throw _iteratorError36;
              }
            }
          }

          return e ? e.clone() : null;
        }
      }, {
        key: "getLastRange",
        value: function getLastRange() {
          var e = null;
          var _iteratorNormalCompletion37 = true;
          var _didIteratorError37 = false;
          var _iteratorError37 = undefined;

          try {
            for (var _iterator37 = this._ranges[Symbol.iterator](), _step37; !(_iteratorNormalCompletion37 = (_step37 = _iterator37.next()).done); _iteratorNormalCompletion37 = true) {
              var _t35 = _step37.value;
              e && !_t35.end.isAfter(e.end) || (e = _t35);
            }
          } catch (err) {
            _didIteratorError37 = true;
            _iteratorError37 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion37 && _iterator37.return != null) {
                _iterator37.return();
              }
            } finally {
              if (_didIteratorError37) {
                throw _iteratorError37;
              }
            }
          }

          return e ? e.clone() : null;
        }
      }, {
        key: "getFirstPosition",
        value: function getFirstPosition() {
          var e = this.getFirstRange();
          return e ? e.start.clone() : null;
        }
      }, {
        key: "getLastPosition",
        value: function getLastPosition() {
          var e = this.getLastRange();
          return e ? e.end.clone() : null;
        }
      }, {
        key: "isEqual",
        value: function isEqual(e) {
          if (this.isFake != e.isFake) return !1;
          if (this.isFake && this.fakeSelectionLabel != e.fakeSelectionLabel) return !1;
          if (this.rangeCount != e.rangeCount) return !1;
          if (0 === this.rangeCount) return !0;
          if (!this.anchor.isEqual(e.anchor) || !this.focus.isEqual(e.focus)) return !1;
          var _iteratorNormalCompletion38 = true;
          var _didIteratorError38 = false;
          var _iteratorError38 = undefined;

          try {
            for (var _iterator38 = this._ranges[Symbol.iterator](), _step38; !(_iteratorNormalCompletion38 = (_step38 = _iterator38.next()).done); _iteratorNormalCompletion38 = true) {
              var _t36 = _step38.value;

              var _i37 = !1;

              var _iteratorNormalCompletion39 = true;
              var _didIteratorError39 = false;
              var _iteratorError39 = undefined;

              try {
                for (var _iterator39 = e._ranges[Symbol.iterator](), _step39; !(_iteratorNormalCompletion39 = (_step39 = _iterator39.next()).done); _iteratorNormalCompletion39 = true) {
                  var _n12 = _step39.value;

                  if (_t36.isEqual(_n12)) {
                    _i37 = !0;
                    break;
                  }
                }
              } catch (err) {
                _didIteratorError39 = true;
                _iteratorError39 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion39 && _iterator39.return != null) {
                    _iterator39.return();
                  }
                } finally {
                  if (_didIteratorError39) {
                    throw _iteratorError39;
                  }
                }
              }

              if (!_i37) return !1;
            }
          } catch (err) {
            _didIteratorError38 = true;
            _iteratorError38 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion38 && _iterator38.return != null) {
                _iterator38.return();
              }
            } finally {
              if (_didIteratorError38) {
                throw _iteratorError38;
              }
            }
          }

          return !0;
        }
      }, {
        key: "isSimilar",
        value: function isSimilar(e) {
          if (this.isBackward != e.isBackward) return !1;
          var t = uo(this.getRanges());
          if (t != uo(e.getRanges())) return !1;
          if (0 == t) return !0;
          var _iteratorNormalCompletion40 = true;
          var _didIteratorError40 = false;
          var _iteratorError40 = undefined;

          try {
            for (var _iterator40 = this.getRanges()[Symbol.iterator](), _step40; !(_iteratorNormalCompletion40 = (_step40 = _iterator40.next()).done); _iteratorNormalCompletion40 = true) {
              var _t37 = _step40.value;
              _t37 = _t37.getTrimmed();

              var _i38 = !1;

              var _iteratorNormalCompletion41 = true;
              var _didIteratorError41 = false;
              var _iteratorError41 = undefined;

              try {
                for (var _iterator41 = e.getRanges()[Symbol.iterator](), _step41; !(_iteratorNormalCompletion41 = (_step41 = _iterator41.next()).done); _iteratorNormalCompletion41 = true) {
                  var _n13 = _step41.value;

                  if (_n13 = _n13.getTrimmed(), _t37.start.isEqual(_n13.start) && _t37.end.isEqual(_n13.end)) {
                    _i38 = !0;
                    break;
                  }
                }
              } catch (err) {
                _didIteratorError41 = true;
                _iteratorError41 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion41 && _iterator41.return != null) {
                    _iterator41.return();
                  }
                } finally {
                  if (_didIteratorError41) {
                    throw _iteratorError41;
                  }
                }
              }

              if (!_i38) return !1;
            }
          } catch (err) {
            _didIteratorError40 = true;
            _iteratorError40 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion40 && _iterator40.return != null) {
                _iterator40.return();
              }
            } finally {
              if (_didIteratorError40) {
                throw _iteratorError40;
              }
            }
          }

          return !0;
        }
      }, {
        key: "getSelectedElement",
        value: function getSelectedElement() {
          return 1 !== this.rangeCount ? null : this.getFirstRange().getContainedElement();
        }
      }, {
        key: "setTo",
        value: function setTo(e, t, i) {
          if (null === e) this._setRanges([]), this._setFakeOptions(t);else if (e instanceof go || e instanceof mo) this._setRanges(e.getRanges(), e.isBackward), this._setFakeOptions({
            fake: e.isFake,
            label: e.fakeSelectionLabel
          });else if (e instanceof lo) this._setRanges([e], t && t.backward), this._setFakeOptions(t);else if (e instanceof co) this._setRanges([new lo(e)]), this._setFakeOptions(t);else if (e instanceof dn) {
            var _n14 = !!i && !!i.backward;

            var _o11;

            if (void 0 === t) throw new c.a("view-selection-setto-required-second-parameter", this);
            _o11 = "in" == t ? lo._createIn(e) : "on" == t ? lo._createOn(e) : new lo(co._createAt(e, t)), this._setRanges([_o11], _n14), this._setFakeOptions(i);
          } else {
            if (!Ji(e)) throw new c.a("view-selection-setto-not-selectable", this);
            this._setRanges(e, t && t.backward), this._setFakeOptions(t);
          }
          this.fire("change");
        }
      }, {
        key: "setFocus",
        value: function setFocus(e, t) {
          if (null === this.anchor) throw new c.a("view-selection-setfocus-no-ranges", this);

          var i = co._createAt(e, t);

          if ("same" == i.compareWith(this.focus)) return;
          var n = this.anchor;
          this._ranges.pop(), "before" == i.compareWith(n) ? this._addRange(new lo(i, n), !0) : this._addRange(new lo(n, i)), this.fire("change");
        }
      }, {
        key: "is",
        value: function is(e) {
          return "selection" === e || "view:selection" === e;
        }
      }, {
        key: "_setRanges",
        value: function _setRanges(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          e = Array.from(e), this._ranges = [];
          var _iteratorNormalCompletion42 = true;
          var _didIteratorError42 = false;
          var _iteratorError42 = undefined;

          try {
            for (var _iterator42 = e[Symbol.iterator](), _step42; !(_iteratorNormalCompletion42 = (_step42 = _iterator42.next()).done); _iteratorNormalCompletion42 = true) {
              var _t38 = _step42.value;

              this._addRange(_t38);
            }
          } catch (err) {
            _didIteratorError42 = true;
            _iteratorError42 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion42 && _iterator42.return != null) {
                _iterator42.return();
              }
            } finally {
              if (_didIteratorError42) {
                throw _iteratorError42;
              }
            }
          }

          this._lastRangeBackward = !!t;
        }
      }, {
        key: "_setFakeOptions",
        value: function _setFakeOptions() {
          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          this._isFake = !!e.fake, this._fakeSelectionLabel = e.fake && e.label || "";
        }
      }, {
        key: "_addRange",
        value: function _addRange(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          if (!(e instanceof lo)) throw new c.a("view-selection-add-range-not-range", this);
          this._pushRange(e), this._lastRangeBackward = !!t;
        }
      }, {
        key: "_pushRange",
        value: function _pushRange(e) {
          var _iteratorNormalCompletion43 = true;
          var _didIteratorError43 = false;
          var _iteratorError43 = undefined;

          try {
            for (var _iterator43 = this._ranges[Symbol.iterator](), _step43; !(_iteratorNormalCompletion43 = (_step43 = _iterator43.next()).done); _iteratorNormalCompletion43 = true) {
              var _t39 = _step43.value;
              if (e.isIntersecting(_t39)) throw new c.a("view-selection-range-intersects", this, {
                addedRange: e,
                intersectingRange: _t39
              });
            }
          } catch (err) {
            _didIteratorError43 = true;
            _iteratorError43 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion43 && _iterator43.return != null) {
                _iterator43.return();
              }
            } finally {
              if (_didIteratorError43) {
                throw _iteratorError43;
              }
            }
          }

          this._ranges.push(new lo(e.start, e.end));
        }
      }, {
        key: "isFake",
        get: function get() {
          return this._isFake;
        }
      }, {
        key: "fakeSelectionLabel",
        get: function get() {
          return this._fakeSelectionLabel;
        }
      }, {
        key: "anchor",
        get: function get() {
          if (!this._ranges.length) return null;
          var e = this._ranges[this._ranges.length - 1];
          return (this._lastRangeBackward ? e.end : e.start).clone();
        }
      }, {
        key: "focus",
        get: function get() {
          if (!this._ranges.length) return null;
          var e = this._ranges[this._ranges.length - 1];
          return (this._lastRangeBackward ? e.start : e.end).clone();
        }
      }, {
        key: "isCollapsed",
        get: function get() {
          return 1 === this.rangeCount && this._ranges[0].isCollapsed;
        }
      }, {
        key: "rangeCount",
        get: function get() {
          return this._ranges.length;
        }
      }, {
        key: "isBackward",
        get: function get() {
          return !this.isCollapsed && this._lastRangeBackward;
        }
      }, {
        key: "editableElement",
        get: function get() {
          return this.anchor ? this.anchor.editableElement : null;
        }
      }]);

      return go;
    }();

    Ke(go, h);

    var mo =
    /*#__PURE__*/
    function () {
      function mo() {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var t = arguments.length > 1 ? arguments[1] : undefined;
        var i = arguments.length > 2 ? arguments[2] : undefined;

        _classCallCheck(this, mo);

        this._selection = new go(), this._selection.delegate("change").to(this), this._selection.setTo(e, t, i);
      }

      _createClass(mo, [{
        key: "getRanges",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function getRanges() {
          return _regeneratorRuntime.wrap(function getRanges$(_context10) {
            while (1) {
              switch (_context10.prev = _context10.next) {
                case 0:
                  return _context10.delegateYield(this._selection.getRanges(), "t0", 1);

                case 1:
                case "end":
                  return _context10.stop();
              }
            }
          }, getRanges, this);
        })
      }, {
        key: "getFirstRange",
        value: function getFirstRange() {
          return this._selection.getFirstRange();
        }
      }, {
        key: "getLastRange",
        value: function getLastRange() {
          return this._selection.getLastRange();
        }
      }, {
        key: "getFirstPosition",
        value: function getFirstPosition() {
          return this._selection.getFirstPosition();
        }
      }, {
        key: "getLastPosition",
        value: function getLastPosition() {
          return this._selection.getLastPosition();
        }
      }, {
        key: "getSelectedElement",
        value: function getSelectedElement() {
          return this._selection.getSelectedElement();
        }
      }, {
        key: "isEqual",
        value: function isEqual(e) {
          return this._selection.isEqual(e);
        }
      }, {
        key: "isSimilar",
        value: function isSimilar(e) {
          return this._selection.isSimilar(e);
        }
      }, {
        key: "is",
        value: function is(e) {
          return "selection" === e || "documentSelection" == e || "view:selection" == e || "view:documentSelection" == e;
        }
      }, {
        key: "_setTo",
        value: function _setTo(e, t, i) {
          this._selection.setTo(e, t, i);
        }
      }, {
        key: "_setFocus",
        value: function _setFocus(e, t) {
          this._selection.setFocus(e, t);
        }
      }, {
        key: "isFake",
        get: function get() {
          return this._selection.isFake;
        }
      }, {
        key: "fakeSelectionLabel",
        get: function get() {
          return this._selection.fakeSelectionLabel;
        }
      }, {
        key: "anchor",
        get: function get() {
          return this._selection.anchor;
        }
      }, {
        key: "focus",
        get: function get() {
          return this._selection.focus;
        }
      }, {
        key: "isCollapsed",
        get: function get() {
          return this._selection.isCollapsed;
        }
      }, {
        key: "rangeCount",
        get: function get() {
          return this._selection.rangeCount;
        }
      }, {
        key: "isBackward",
        get: function get() {
          return this._selection.isBackward;
        }
      }, {
        key: "editableElement",
        get: function get() {
          return this._selection.editableElement;
        }
      }, {
        key: "_ranges",
        get: function get() {
          return this._selection._ranges;
        }
      }]);

      return mo;
    }();

    Ke(mo, h);

    var fo =
    /*#__PURE__*/
    function (_o12) {
      _inherits(fo, _o12);

      function fo(e, t, i) {
        var _this23;

        _classCallCheck(this, fo);

        _this23 = _possibleConstructorReturn(this, _getPrototypeOf(fo).call(this, e, t)), _this23.startRange = i, _this23._eventPhase = "none", _this23._currentTarget = null;
        return _this23;
      }

      _createClass(fo, [{
        key: "eventPhase",
        get: function get() {
          return this._eventPhase;
        }
      }, {
        key: "currentTarget",
        get: function get() {
          return this._currentTarget;
        }
      }]);

      return fo;
    }(o);

    var po = Symbol("bubbling contexts");
    var bo = {
      fire: function fire(e) {
        try {
          var _i39 = e instanceof o ? e : new o(this, e),
              _n15 = vo(this);

          if (!_n15.size) return;

          for (var _len16 = arguments.length, t = new Array(_len16 > 1 ? _len16 - 1 : 0), _key16 = 1; _key16 < _len16; _key16++) {
            t[_key16 - 1] = arguments[_key16];
          }

          if (wo(_i39, "capturing", this), ko.apply(void 0, [_n15, "$capture", _i39].concat(t))) return _i39.return;

          var _r8 = _i39.startRange || this.selection.getFirstRange(),
              _s3 = _r8 ? _r8.getContainedElement() : null,
              _a3 = !!_s3 && Boolean(_o(_n15, _s3));

          var _c2 = _s3 || function (e) {
            if (!e) return null;
            var t = e.start.parent,
                i = e.end.parent,
                n = t.getPath(),
                o = i.getPath();
            return n.length > o.length ? t : i;
          }(_r8);

          if (wo(_i39, "atTarget", _c2), !_a3) {
            if (ko.apply(void 0, [_n15, "$text", _i39].concat(t))) return _i39.return;
            wo(_i39, "bubbling", _c2);
          }

          for (; _c2;) {
            if (_c2.is("rootElement")) {
              if (ko.apply(void 0, [_n15, "$root", _i39].concat(t))) return _i39.return;
            } else if (_c2.is("element") && ko.apply(void 0, [_n15, _c2.name, _i39].concat(t))) return _i39.return;

            if (ko.apply(void 0, [_n15, _c2, _i39].concat(t))) return _i39.return;
            _c2 = _c2.parent, wo(_i39, "bubbling", _c2);
          }

          return wo(_i39, "bubbling", this), ko.apply(void 0, [_n15, "$document", _i39].concat(t)), _i39.return;
        } catch (e) {
          c.a.rethrowUnexpectedError(e, this);
        }
      },
      _addEventListener: function _addEventListener(e, t, i) {
        var n = en(i.context || "$document"),
            o = vo(this);
        var _iteratorNormalCompletion44 = true;
        var _didIteratorError44 = false;
        var _iteratorError44 = undefined;

        try {
          for (var _iterator44 = n[Symbol.iterator](), _step44; !(_iteratorNormalCompletion44 = (_step44 = _iterator44.next()).done); _iteratorNormalCompletion44 = true) {
            var _r9 = _step44.value;

            var _n16 = o.get(_r9);

            _n16 || (_n16 = Object.create(h), o.set(_r9, _n16)), this.listenTo(_n16, e, t, i);
          }
        } catch (err) {
          _didIteratorError44 = true;
          _iteratorError44 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion44 && _iterator44.return != null) {
              _iterator44.return();
            }
          } finally {
            if (_didIteratorError44) {
              throw _iteratorError44;
            }
          }
        }
      },
      _removeEventListener: function _removeEventListener(e, t) {
        var i = vo(this);
        var _iteratorNormalCompletion45 = true;
        var _didIteratorError45 = false;
        var _iteratorError45 = undefined;

        try {
          for (var _iterator45 = i.values()[Symbol.iterator](), _step45; !(_iteratorNormalCompletion45 = (_step45 = _iterator45.next()).done); _iteratorNormalCompletion45 = true) {
            var _n17 = _step45.value;
            this.stopListening(_n17, e, t);
          }
        } catch (err) {
          _didIteratorError45 = true;
          _iteratorError45 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion45 && _iterator45.return != null) {
              _iterator45.return();
            }
          } finally {
            if (_didIteratorError45) {
              throw _iteratorError45;
            }
          }
        }
      }
    };

    function wo(e, t, i) {
      e instanceof fo && (e._eventPhase = t, e._currentTarget = i);
    }

    function ko(e, t, i) {
      var o = "string" == typeof t ? e.get(t) : _o(e, t);

      for (var _len17 = arguments.length, n = new Array(_len17 > 3 ? _len17 - 3 : 0), _key17 = 3; _key17 < _len17; _key17++) {
        n[_key17 - 3] = arguments[_key17];
      }

      return !!o && (o.fire.apply(o, [i].concat(n)), i.stop.called);
    }

    function _o(e, t) {
      var _iteratorNormalCompletion46 = true;
      var _didIteratorError46 = false;
      var _iteratorError46 = undefined;

      try {
        for (var _iterator46 = e[Symbol.iterator](), _step46; !(_iteratorNormalCompletion46 = (_step46 = _iterator46.next()).done); _iteratorNormalCompletion46 = true) {
          var _ref32 = _step46.value;

          var _ref31 = _slicedToArray(_ref32, 2);

          var _i40 = _ref31[0];
          var _n18 = _ref31[1];
          if ("function" == typeof _i40 && _i40(t)) return _n18;
        }
      } catch (err) {
        _didIteratorError46 = true;
        _iteratorError46 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion46 && _iterator46.return != null) {
            _iterator46.return();
          }
        } finally {
          if (_didIteratorError46) {
            throw _iteratorError46;
          }
        }
      }

      return null;
    }

    function vo(e) {
      return e[po] || (e[po] = new Map()), e[po];
    }

    var yo =
    /*#__PURE__*/
    function () {
      function yo(e) {
        _classCallCheck(this, yo);

        this.selection = new mo(), this.roots = new Zi({
          idProperty: "rootName"
        }), this.stylesProcessor = e, this.set("isReadOnly", !1), this.set("isFocused", !1), this.set("isComposing", !1), this._postFixers = new Set();
      }

      _createClass(yo, [{
        key: "getRoot",
        value: function getRoot() {
          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "main";
          return this.roots.get(e);
        }
      }, {
        key: "registerPostFixer",
        value: function registerPostFixer(e) {
          this._postFixers.add(e);
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.roots.map(function (e) {
            return e.destroy();
          }), this.stopListening();
        }
      }, {
        key: "_callPostFixers",
        value: function _callPostFixers(e) {
          var t = !1;

          do {
            var _iteratorNormalCompletion47 = true;
            var _didIteratorError47 = false;
            var _iteratorError47 = undefined;

            try {
              for (var _iterator47 = this._postFixers[Symbol.iterator](), _step47; !(_iteratorNormalCompletion47 = (_step47 = _iterator47.next()).done); _iteratorNormalCompletion47 = true) {
                var _i41 = _step47.value;
                if (t = _i41(e), t) break;
              }
            } catch (err) {
              _didIteratorError47 = true;
              _iteratorError47 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion47 && _iterator47.return != null) {
                  _iterator47.return();
                }
              } finally {
                if (_didIteratorError47) {
                  throw _iteratorError47;
                }
              }
            }
          } while (t);
        }
      }]);

      return yo;
    }();

    Ke(yo, bo), Ke(yo, Ue);

    var xo =
    /*#__PURE__*/
    function (_eo2) {
      _inherits(xo, _eo2);

      function xo(e, t, i, n) {
        var _this24;

        _classCallCheck(this, xo);

        _this24 = _possibleConstructorReturn(this, _getPrototypeOf(xo).call(this, e, t, i, n)), _this24.getFillerOffset = Ao, _this24._priority = 10, _this24._id = null, _this24._clonesGroup = null;
        return _this24;
      }

      _createClass(xo, [{
        key: "getElementsWithSameId",
        value: function getElementsWithSameId() {
          if (null === this.id) throw new c.a("attribute-element-get-elements-with-same-id-no-id", this);
          return new Set(this._clonesGroup);
        }
      }, {
        key: "is",
        value: function is(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          return t ? t === this.name && ("attributeElement" === e || "view:attributeElement" === e || "element" === e || "view:element" === e) : "attributeElement" === e || "view:attributeElement" === e || "element" === e || "view:element" === e || "node" === e || "view:node" === e;
        }
      }, {
        key: "isSimilar",
        value: function isSimilar(e) {
          return null !== this.id || null !== e.id ? this.id === e.id : _get(_getPrototypeOf(xo.prototype), "isSimilar", this).call(this, e) && this.priority == e.priority;
        }
      }, {
        key: "_clone",
        value: function _clone(e) {
          var t = _get(_getPrototypeOf(xo.prototype), "_clone", this).call(this, e);

          return t._priority = this._priority, t._id = this._id, t;
        }
      }, {
        key: "priority",
        get: function get() {
          return this._priority;
        }
      }, {
        key: "id",
        get: function get() {
          return this._id;
        }
      }]);

      return xo;
    }(eo);

    function Ao() {
      if (Co(this)) return null;
      var e = this.parent;

      for (; e && e.is("attributeElement");) {
        if (Co(e) > 1) return null;
        e = e.parent;
      }

      return !e || Co(e) > 1 ? null : this.childCount;
    }

    function Co(e) {
      return Array.from(e.getChildren()).filter(function (e) {
        return !e.is("uiElement");
      }).length;
    }

    xo.DEFAULT_PRIORITY = 10;

    var To =
    /*#__PURE__*/
    function (_eo3) {
      _inherits(To, _eo3);

      function To(e, t, i, n) {
        var _this25;

        _classCallCheck(this, To);

        _this25 = _possibleConstructorReturn(this, _getPrototypeOf(To).call(this, e, t, i, n)), _this25._isAllowedInsideAttributeElement = !0, _this25.getFillerOffset = Eo;
        return _this25;
      }

      _createClass(To, [{
        key: "is",
        value: function is(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          return t ? t === this.name && ("emptyElement" === e || "view:emptyElement" === e || "element" === e || "view:element" === e) : "emptyElement" === e || "view:emptyElement" === e || "element" === e || "view:element" === e || "node" === e || "view:node" === e;
        }
      }, {
        key: "_insertChild",
        value: function _insertChild(e, t) {
          if (t && (t instanceof dn || Array.from(t).length > 0)) throw new c.a("view-emptyelement-cannot-add", [this, t]);
        }
      }]);

      return To;
    }(eo);

    function Eo() {
      return null;
    }

    var So = navigator.userAgent.toLowerCase();
    var Io = {
      isMac: function (e) {
        return e.indexOf("macintosh") > -1;
      }(So),
      isGecko: function (e) {
        return !!e.match(/gecko\/\d+/);
      }(So),
      isSafari: function (e) {
        return e.indexOf(" applewebkit/") > -1 && -1 === e.indexOf("chrome");
      }(So),
      isAndroid: function (e) {
        return e.indexOf("android") > -1;
      }(So),
      isBlink: function (e) {
        return e.indexOf("chrome/") > -1 && e.indexOf("edge/") < 0;
      }(So),
      features: {
        isRegExpUnicodePropertySupported: function () {
          var e = !1;

          try {
            e = 0 === "ć".search(new RegExp("[\\p{L}]", "u"));
          } catch (e) {}

          return e;
        }()
      }
    };

    var Po = {
      ctrl: "⌃",
      cmd: "⌘",
      alt: "⌥",
      shift: "⇧"
    },
        Mo = {
      ctrl: "Ctrl+",
      alt: "Alt+",
      shift: "Shift+"
    },
        No = function () {
      var e = {
        arrowleft: 37,
        arrowup: 38,
        arrowright: 39,
        arrowdown: 40,
        backspace: 8,
        delete: 46,
        enter: 13,
        space: 32,
        esc: 27,
        tab: 9,
        ctrl: 1114112,
        shift: 2228224,
        alt: 4456448,
        cmd: 8912896
      };

      for (var _t40 = 65; _t40 <= 90; _t40++) {
        var _i42 = String.fromCharCode(_t40);

        e[_i42.toLowerCase()] = _t40;
      }

      for (var _t41 = 48; _t41 <= 57; _t41++) {
        e[_t41 - 48] = _t41;
      }

      for (var _t42 = 112; _t42 <= 123; _t42++) {
        e["f" + (_t42 - 111)] = _t42;
      }

      return e;
    }(),
        Ro = Object.fromEntries(Object.entries(No).map(function (_ref33) {
      var _ref34 = _slicedToArray(_ref33, 2),
          e = _ref34[0],
          t = _ref34[1];

      return [t, e.charAt(0).toUpperCase() + e.slice(1)];
    }));

    function Oo(e) {
      var t;

      if ("string" == typeof e) {
        if (t = No[e.toLowerCase()], !t) throw new c.a("keyboard-unknown-key", null, {
          key: e
        });
      } else t = e.keyCode + (e.altKey ? No.alt : 0) + (e.ctrlKey ? No.ctrl : 0) + (e.shiftKey ? No.shift : 0) + (e.metaKey ? No.cmd : 0);

      return t;
    }

    function zo(e) {
      return "string" == typeof e && (e = function (e) {
        return e.split("+").map(function (e) {
          return e.trim();
        });
      }(e)), e.map(function (e) {
        return "string" == typeof e ? function (e) {
          if (e.endsWith("!")) return Oo(e.slice(0, -1));
          var t = Oo(e);
          return Io.isMac && t == No.ctrl ? No.cmd : t;
        }(e) : e;
      }).reduce(function (e, t) {
        return t + e;
      }, 0);
    }

    function Do(e) {
      var t = zo(e);
      return Object.entries(Io.isMac ? Po : Mo).reduce(function (e, _ref35) {
        var _ref36 = _slicedToArray(_ref35, 2),
            i = _ref36[0],
            n = _ref36[1];

        return 0 != (t & No[i]) && (t &= ~No[i], e += n), e;
      }, "") + (t ? Ro[t] : "");
    }

    function Lo(e, t) {
      var i = "ltr" === t;

      switch (e) {
        case No.arrowleft:
          return i ? "left" : "right";

        case No.arrowright:
          return i ? "right" : "left";

        case No.arrowup:
          return "up";

        case No.arrowdown:
          return "down";
      }
    }

    function Vo(e, t) {
      var i = Lo(e, t);
      return "down" === i || "right" === i;
    }

    var jo =
    /*#__PURE__*/
    function (_eo4) {
      _inherits(jo, _eo4);

      function jo(e, t, i, n) {
        var _this26;

        _classCallCheck(this, jo);

        _this26 = _possibleConstructorReturn(this, _getPrototypeOf(jo).call(this, e, t, i, n)), _this26._isAllowedInsideAttributeElement = !0, _this26.getFillerOffset = Fo;
        return _this26;
      }

      _createClass(jo, [{
        key: "is",
        value: function is(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          return t ? t === this.name && ("uiElement" === e || "view:uiElement" === e || "element" === e || "view:element" === e) : "uiElement" === e || "view:uiElement" === e || "element" === e || "view:element" === e || "node" === e || "view:node" === e;
        }
      }, {
        key: "_insertChild",
        value: function _insertChild(e, t) {
          if (t && (t instanceof dn || Array.from(t).length > 0)) throw new c.a("view-uielement-cannot-add", this);
        }
      }, {
        key: "render",
        value: function render(e) {
          return this.toDomElement(e);
        }
      }, {
        key: "toDomElement",
        value: function toDomElement(e) {
          var t = e.createElement(this.name);
          var _iteratorNormalCompletion48 = true;
          var _didIteratorError48 = false;
          var _iteratorError48 = undefined;

          try {
            for (var _iterator48 = this.getAttributeKeys()[Symbol.iterator](), _step48; !(_iteratorNormalCompletion48 = (_step48 = _iterator48.next()).done); _iteratorNormalCompletion48 = true) {
              var _e30 = _step48.value;
              t.setAttribute(_e30, this.getAttribute(_e30));
            }
          } catch (err) {
            _didIteratorError48 = true;
            _iteratorError48 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion48 && _iterator48.return != null) {
                _iterator48.return();
              }
            } finally {
              if (_didIteratorError48) {
                throw _iteratorError48;
              }
            }
          }

          return t;
        }
      }]);

      return jo;
    }(eo);

    function Bo(e) {
      e.document.on("arrowKey", function (t, i) {
        return function (e, t, i) {
          if (t.keyCode == No.arrowright) {
            var _e31 = t.domTarget.ownerDocument.defaultView.getSelection(),
                _n19 = 1 == _e31.rangeCount && _e31.getRangeAt(0).collapsed;

            if (_n19 || t.shiftKey) {
              var _t43 = _e31.focusNode,
                  _o13 = _e31.focusOffset,
                  _r10 = i.domPositionToView(_t43, _o13);

              if (null === _r10) return;

              var _s4 = !1;

              var _a4 = _r10.getLastMatchingPosition(function (e) {
                return e.item.is("uiElement") && (_s4 = !0), !(!e.item.is("uiElement") && !e.item.is("attributeElement"));
              });

              if (_s4) {
                var _t44 = i.viewPositionToDom(_a4);

                _n19 ? _e31.collapse(_t44.parent, _t44.offset) : _e31.extend(_t44.parent, _t44.offset);
              }
            }
          }
        }(0, i, e.domConverter);
      }, {
        priority: "low"
      });
    }

    function Fo() {
      return null;
    }

    var Ho =
    /*#__PURE__*/
    function (_eo5) {
      _inherits(Ho, _eo5);

      function Ho(e, t, i, n) {
        var _this27;

        _classCallCheck(this, Ho);

        _this27 = _possibleConstructorReturn(this, _getPrototypeOf(Ho).call(this, e, t, i, n)), _this27._isAllowedInsideAttributeElement = !0, _this27.getFillerOffset = Uo;
        return _this27;
      }

      _createClass(Ho, [{
        key: "is",
        value: function is(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          return t ? t === this.name && ("rawElement" === e || "view:rawElement" === e || "element" === e || "view:element" === e) : "rawElement" === e || "view:rawElement" === e || e === this.name || e === "view:" + this.name || "element" === e || "view:element" === e || "node" === e || "view:node" === e;
        }
      }, {
        key: "_insertChild",
        value: function _insertChild(e, t) {
          if (t && (t instanceof dn || Array.from(t).length > 0)) throw new c.a("view-rawelement-cannot-add", [this, t]);
        }
      }]);

      return Ho;
    }(eo);

    function Uo() {
      return null;
    }

    var Wo =
    /*#__PURE__*/
    function () {
      function Wo(e, t) {
        _classCallCheck(this, Wo);

        this.document = e, this._children = [], t && this._insertChild(0, t);
      }

      _createClass(Wo, [{
        key: Symbol.iterator,
        value: function value() {
          return this._children[Symbol.iterator]();
        }
      }, {
        key: "is",
        value: function is(e) {
          return "documentFragment" === e || "view:documentFragment" === e;
        }
      }, {
        key: "_appendChild",
        value: function _appendChild(e) {
          return this._insertChild(this.childCount, e);
        }
      }, {
        key: "getChild",
        value: function getChild(e) {
          return this._children[e];
        }
      }, {
        key: "getChildIndex",
        value: function getChildIndex(e) {
          return this._children.indexOf(e);
        }
      }, {
        key: "getChildren",
        value: function getChildren() {
          return this._children[Symbol.iterator]();
        }
      }, {
        key: "_insertChild",
        value: function _insertChild(e, t) {
          this._fireChange("children", this);

          var i = 0;

          var n = function (e, t) {
            if ("string" == typeof t) return [new hn(e, t)];
            Ji(t) || (t = [t]);
            return Array.from(t).map(function (t) {
              return "string" == typeof t ? new hn(e, t) : t instanceof un ? new hn(e, t.data) : t;
            });
          }(this.document, t);

          var _iteratorNormalCompletion49 = true;
          var _didIteratorError49 = false;
          var _iteratorError49 = undefined;

          try {
            for (var _iterator49 = n[Symbol.iterator](), _step49; !(_iteratorNormalCompletion49 = (_step49 = _iterator49.next()).done); _iteratorNormalCompletion49 = true) {
              var _t45 = _step49.value;
              null !== _t45.parent && _t45._remove(), _t45.parent = this, this._children.splice(e, 0, _t45), e++, i++;
            }
          } catch (err) {
            _didIteratorError49 = true;
            _iteratorError49 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion49 && _iterator49.return != null) {
                _iterator49.return();
              }
            } finally {
              if (_didIteratorError49) {
                throw _iteratorError49;
              }
            }
          }

          return i;
        }
      }, {
        key: "_removeChildren",
        value: function _removeChildren(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

          this._fireChange("children", this);

          for (var _i43 = e; _i43 < e + t; _i43++) {
            this._children[_i43].parent = null;
          }

          return this._children.splice(e, t);
        }
      }, {
        key: "_fireChange",
        value: function _fireChange(e, t) {
          this.fire("change:" + e, t);
        }
      }, {
        key: "childCount",
        get: function get() {
          return this._children.length;
        }
      }, {
        key: "isEmpty",
        get: function get() {
          return 0 === this.childCount;
        }
      }, {
        key: "root",
        get: function get() {
          return this;
        }
      }, {
        key: "parent",
        get: function get() {
          return null;
        }
      }]);

      return Wo;
    }();

    Ke(Wo, h);

    var qo =
    /*#__PURE__*/
    function () {
      function qo(e) {
        _classCallCheck(this, qo);

        this.document = e, this._cloneGroups = new Map();
      }

      _createClass(qo, [{
        key: "setSelection",
        value: function setSelection(e, t, i) {
          this.document.selection._setTo(e, t, i);
        }
      }, {
        key: "setSelectionFocus",
        value: function setSelectionFocus(e, t) {
          this.document.selection._setFocus(e, t);
        }
      }, {
        key: "createDocumentFragment",
        value: function createDocumentFragment(e) {
          return new Wo(this.document, e);
        }
      }, {
        key: "createText",
        value: function createText(e) {
          return new hn(this.document, e);
        }
      }, {
        key: "createAttributeElement",
        value: function createAttributeElement(e, t) {
          var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
          var n = new xo(this.document, e, t);
          return "number" == typeof i.priority && (n._priority = i.priority), i.id && (n._id = i.id), n;
        }
      }, {
        key: "createContainerElement",
        value: function createContainerElement(e, t) {
          var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
          var n = new io(this.document, e, t);
          return void 0 !== i.isAllowedInsideAttributeElement && (n._isAllowedInsideAttributeElement = i.isAllowedInsideAttributeElement), n;
        }
      }, {
        key: "createEditableElement",
        value: function createEditableElement(e, t) {
          var i = new oo(this.document, e, t);
          return i._document = this.document, i;
        }
      }, {
        key: "createEmptyElement",
        value: function createEmptyElement(e, t) {
          var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
          var n = new To(this.document, e, t);
          return void 0 !== i.isAllowedInsideAttributeElement && (n._isAllowedInsideAttributeElement = i.isAllowedInsideAttributeElement), n;
        }
      }, {
        key: "createUIElement",
        value: function createUIElement(e, t, i) {
          var n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
          var o = new jo(this.document, e, t);
          return i && (o.render = i), void 0 !== n.isAllowedInsideAttributeElement && (o._isAllowedInsideAttributeElement = n.isAllowedInsideAttributeElement), o;
        }
      }, {
        key: "createRawElement",
        value: function createRawElement(e, t, i) {
          var n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
          var o = new Ho(this.document, e, t);
          return o.render = i || function () {}, void 0 !== n.isAllowedInsideAttributeElement && (o._isAllowedInsideAttributeElement = n.isAllowedInsideAttributeElement), o;
        }
      }, {
        key: "setAttribute",
        value: function setAttribute(e, t, i) {
          i._setAttribute(e, t);
        }
      }, {
        key: "removeAttribute",
        value: function removeAttribute(e, t) {
          t._removeAttribute(e);
        }
      }, {
        key: "addClass",
        value: function addClass(e, t) {
          t._addClass(e);
        }
      }, {
        key: "removeClass",
        value: function removeClass(e, t) {
          t._removeClass(e);
        }
      }, {
        key: "setStyle",
        value: function setStyle(e, t, i) {
          ct(e) && void 0 === i && (i = t), i._setStyle(e, t);
        }
      }, {
        key: "removeStyle",
        value: function removeStyle(e, t) {
          t._removeStyle(e);
        }
      }, {
        key: "setCustomProperty",
        value: function setCustomProperty(e, t, i) {
          i._setCustomProperty(e, t);
        }
      }, {
        key: "removeCustomProperty",
        value: function removeCustomProperty(e, t) {
          return t._removeCustomProperty(e);
        }
      }, {
        key: "breakAttributes",
        value: function breakAttributes(e) {
          return e instanceof co ? this._breakAttributes(e) : this._breakAttributesRange(e);
        }
      }, {
        key: "breakContainer",
        value: function breakContainer(e) {
          var t = e.parent;
          if (!t.is("containerElement")) throw new c.a("view-writer-break-non-container-element", this.document);
          if (!t.parent) throw new c.a("view-writer-break-root", this.document);
          if (e.isAtStart) return co._createBefore(t);

          if (!e.isAtEnd) {
            var _i44 = t._clone(!1);

            this.insert(co._createAfter(t), _i44);

            var _n20 = new lo(e, co._createAt(t, "end")),
                _o14 = new co(_i44, 0);

            this.move(_n20, _o14);
          }

          return co._createAfter(t);
        }
      }, {
        key: "mergeAttributes",
        value: function mergeAttributes(e) {
          var t = e.offset,
              i = e.parent;
          if (i.is("$text")) return e;

          if (i.is("attributeElement") && 0 === i.childCount) {
            var _e32 = i.parent,
                _t46 = i.index;
            return i._remove(), this._removeFromClonedElementsGroup(i), this.mergeAttributes(new co(_e32, _t46));
          }

          var n = i.getChild(t - 1),
              o = i.getChild(t);
          if (!n || !o) return e;
          if (n.is("$text") && o.is("$text")) return Qo(n, o);

          if (n.is("attributeElement") && o.is("attributeElement") && n.isSimilar(o)) {
            var _e33 = n.childCount;
            return n._appendChild(o.getChildren()), o._remove(), this._removeFromClonedElementsGroup(o), this.mergeAttributes(new co(n, _e33));
          }

          return e;
        }
      }, {
        key: "mergeContainers",
        value: function mergeContainers(e) {
          var t = e.nodeBefore,
              i = e.nodeAfter;
          if (!(t && i && t.is("containerElement") && i.is("containerElement"))) throw new c.a("view-writer-merge-containers-invalid-position", this.document);
          var n = t.getChild(t.childCount - 1),
              o = n instanceof hn ? co._createAt(n, "end") : co._createAt(t, "end");
          return this.move(lo._createIn(i), co._createAt(t, "end")), this.remove(lo._createOn(i)), o;
        }
      }, {
        key: "insert",
        value: function insert(e, t) {
          (function e(t, i) {
            var _iteratorNormalCompletion50 = true;
            var _didIteratorError50 = false;
            var _iteratorError50 = undefined;

            try {
              var _loop = function _loop() {
                var n = _step50.value;
                if (!Jo.some(function (e) {
                  return n instanceof e;
                })) throw new c.a("view-writer-insert-invalid-node-type", i);
                n.is("$text") || e(n.getChildren(), i);
              };

              for (var _iterator50 = t[Symbol.iterator](), _step50; !(_iteratorNormalCompletion50 = (_step50 = _iterator50.next()).done); _iteratorNormalCompletion50 = true) {
                _loop();
              }
            } catch (err) {
              _didIteratorError50 = true;
              _iteratorError50 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion50 && _iterator50.return != null) {
                  _iterator50.return();
                }
              } finally {
                if (_didIteratorError50) {
                  throw _iteratorError50;
                }
              }
            }
          })(t = Ji(t) ? _toConsumableArray(t) : [t], this.document);

          var i = t.reduce(function (e, t) {
            var i = e[e.length - 1],
                n = !(t.is("uiElement") && t.isAllowedInsideAttributeElement);
            return i && i.breakAttributes == n ? i.nodes.push(t) : e.push({
              breakAttributes: n,
              nodes: [t]
            }), e;
          }, []);
          var n = null,
              o = e;
          var _iteratorNormalCompletion51 = true;
          var _didIteratorError51 = false;
          var _iteratorError51 = undefined;

          try {
            for (var _iterator51 = i[Symbol.iterator](), _step51; !(_iteratorNormalCompletion51 = (_step51 = _iterator51.next()).done); _iteratorNormalCompletion51 = true) {
              var _ref38 = _step51.value;
              var _e34 = _ref38.nodes;
              var _t47 = _ref38.breakAttributes;

              var _i45 = this._insertNodes(o, _e34, _t47);

              n || (n = _i45.start), o = _i45.end;
            }
          } catch (err) {
            _didIteratorError51 = true;
            _iteratorError51 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion51 && _iterator51.return != null) {
                _iterator51.return();
              }
            } finally {
              if (_didIteratorError51) {
                throw _iteratorError51;
              }
            }
          }

          return n ? new lo(n, o) : new lo(e);
        }
      }, {
        key: "remove",
        value: function remove(e) {
          var t = e instanceof lo ? e : lo._createOn(e);
          if (Xo(t, this.document), t.isCollapsed) return new Wo(this.document);

          var _this$_breakAttribute = this._breakAttributesRange(t, !0),
              i = _this$_breakAttribute.start,
              n = _this$_breakAttribute.end,
              o = i.parent,
              r = n.offset - i.offset,
              s = o._removeChildren(i.offset, r);

          var _iteratorNormalCompletion52 = true;
          var _didIteratorError52 = false;
          var _iteratorError52 = undefined;

          try {
            for (var _iterator52 = s[Symbol.iterator](), _step52; !(_iteratorNormalCompletion52 = (_step52 = _iterator52.next()).done); _iteratorNormalCompletion52 = true) {
              var _e35 = _step52.value;

              this._removeFromClonedElementsGroup(_e35);
            }
          } catch (err) {
            _didIteratorError52 = true;
            _iteratorError52 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion52 && _iterator52.return != null) {
                _iterator52.return();
              }
            } finally {
              if (_didIteratorError52) {
                throw _iteratorError52;
              }
            }
          }

          var a = this.mergeAttributes(i);
          return t.start = a, t.end = a.clone(), new Wo(this.document, s);
        }
      }, {
        key: "clear",
        value: function clear(e, t) {
          Xo(e, this.document);
          var i = e.getWalker({
            direction: "backward",
            ignoreElementEnd: !0
          });
          var _iteratorNormalCompletion53 = true;
          var _didIteratorError53 = false;
          var _iteratorError53 = undefined;

          try {
            for (var _iterator53 = i[Symbol.iterator](), _step53; !(_iteratorNormalCompletion53 = (_step53 = _iterator53.next()).done); _iteratorNormalCompletion53 = true) {
              var _n21 = _step53.value;
              var _i46 = _n21.item;

              var _o15 = void 0;

              if (_i46.is("element") && t.isSimilar(_i46)) _o15 = lo._createOn(_i46);else if (!_n21.nextPosition.isAfter(e.start) && _i46.is("$textProxy")) {
                var _e36 = _i46.getAncestors().find(function (e) {
                  return e.is("element") && t.isSimilar(e);
                });

                _e36 && (_o15 = lo._createIn(_e36));
              }
              _o15 && (_o15.end.isAfter(e.end) && (_o15.end = e.end), _o15.start.isBefore(e.start) && (_o15.start = e.start), this.remove(_o15));
            }
          } catch (err) {
            _didIteratorError53 = true;
            _iteratorError53 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion53 && _iterator53.return != null) {
                _iterator53.return();
              }
            } finally {
              if (_didIteratorError53) {
                throw _iteratorError53;
              }
            }
          }
        }
      }, {
        key: "move",
        value: function move(e, t) {
          var i;

          if (t.isAfter(e.end)) {
            var _n22 = (t = this._breakAttributes(t, !0)).parent,
                _o16 = _n22.childCount;

            e = this._breakAttributesRange(e, !0), i = this.remove(e), t.offset += _n22.childCount - _o16;
          } else i = this.remove(e);

          return this.insert(t, i);
        }
      }, {
        key: "wrap",
        value: function wrap(e, t) {
          if (!(t instanceof xo)) throw new c.a("view-writer-wrap-invalid-attribute", this.document);

          if (Xo(e, this.document), e.isCollapsed) {
            var _n23 = e.start;
            _n23.parent.is("element") && (i = _n23.parent, !Array.from(i.getChildren()).some(function (e) {
              return !e.is("uiElement");
            })) && (_n23 = _n23.getLastMatchingPosition(function (e) {
              return e.item.is("uiElement");
            })), _n23 = this._wrapPosition(_n23, t);
            var _o17 = this.document.selection;
            return _o17.isCollapsed && _o17.getFirstPosition().isEqual(e.start) && this.setSelection(_n23), new lo(_n23);
          }

          return this._wrapRange(e, t);
          var i;
        }
      }, {
        key: "unwrap",
        value: function unwrap(e, t) {
          if (!(t instanceof xo)) throw new c.a("view-writer-unwrap-invalid-attribute", this.document);
          if (Xo(e, this.document), e.isCollapsed) return e;

          var _this$_breakAttribute2 = this._breakAttributesRange(e, !0),
              i = _this$_breakAttribute2.start,
              n = _this$_breakAttribute2.end,
              o = i.parent,
              r = this._unwrapChildren(o, i.offset, n.offset, t),
              s = this.mergeAttributes(r.start);

          s.isEqual(r.start) || r.end.offset--;
          var a = this.mergeAttributes(r.end);
          return new lo(s, a);
        }
      }, {
        key: "rename",
        value: function rename(e, t) {
          var i = new io(this.document, e, t.getAttributes());
          return this.insert(co._createAfter(t), i), this.move(lo._createIn(t), co._createAt(i, 0)), this.remove(lo._createOn(t)), i;
        }
      }, {
        key: "clearClonedElementsGroup",
        value: function clearClonedElementsGroup(e) {
          this._cloneGroups.delete(e);
        }
      }, {
        key: "createPositionAt",
        value: function createPositionAt(e, t) {
          return co._createAt(e, t);
        }
      }, {
        key: "createPositionAfter",
        value: function createPositionAfter(e) {
          return co._createAfter(e);
        }
      }, {
        key: "createPositionBefore",
        value: function createPositionBefore(e) {
          return co._createBefore(e);
        }
      }, {
        key: "createRange",
        value: function createRange(e, t) {
          return new lo(e, t);
        }
      }, {
        key: "createRangeOn",
        value: function createRangeOn(e) {
          return lo._createOn(e);
        }
      }, {
        key: "createRangeIn",
        value: function createRangeIn(e) {
          return lo._createIn(e);
        }
      }, {
        key: "createSelection",
        value: function createSelection(e, t, i) {
          return new go(e, t, i);
        }
      }, {
        key: "_insertNodes",
        value: function _insertNodes(e, t, i) {
          var n, o;
          if (n = i ? $o(e) : e.parent.is("$text") ? e.parent.parent : e.parent, !n) throw new c.a("view-writer-invalid-position-container", this.document);
          o = i ? this._breakAttributes(e, !0) : e.parent.is("$text") ? Ko(e) : e;

          var r = n._insertChild(o.offset, t);

          var _iteratorNormalCompletion54 = true;
          var _didIteratorError54 = false;
          var _iteratorError54 = undefined;

          try {
            for (var _iterator54 = t[Symbol.iterator](), _step54; !(_iteratorNormalCompletion54 = (_step54 = _iterator54.next()).done); _iteratorNormalCompletion54 = true) {
              var _e37 = _step54.value;

              this._addToClonedElementsGroup(_e37);
            }
          } catch (err) {
            _didIteratorError54 = true;
            _iteratorError54 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion54 && _iterator54.return != null) {
                _iterator54.return();
              }
            } finally {
              if (_didIteratorError54) {
                throw _iteratorError54;
              }
            }
          }

          var s = o.getShiftedBy(r),
              a = this.mergeAttributes(o);
          a.isEqual(o) || s.offset--;
          var l = this.mergeAttributes(s);
          return new lo(a, l);
        }
      }, {
        key: "_wrapChildren",
        value: function _wrapChildren(e, t, i, n) {
          var o = t;
          var r = [];

          for (; o < i;) {
            var _t48 = e.getChild(o),
                _i47 = _t48.is("$text"),
                _s5 = _t48.is("attributeElement"),
                _a5 = _t48.isAllowedInsideAttributeElement;

            if (_s5 && this._wrapAttributeElement(n, _t48)) r.push(new co(e, o));else if (_i47 || _a5 || _s5 && Yo(n, _t48)) {
              var _i48 = n._clone();

              _t48._remove(), _i48._appendChild(_t48), e._insertChild(o, _i48), this._addToClonedElementsGroup(_i48), r.push(new co(e, o));
            } else _s5 && this._wrapChildren(_t48, 0, _t48.childCount, n);
            o++;
          }

          var s = 0;

          for (var _i49 = 0, _r11 = r; _i49 < _r11.length; _i49++) {
            var _e38 = _r11[_i49];
            if (_e38.offset -= s, _e38.offset == t) continue;
            this.mergeAttributes(_e38).isEqual(_e38) || (s++, i--);
          }

          return lo._createFromParentsAndOffsets(e, t, e, i);
        }
      }, {
        key: "_unwrapChildren",
        value: function _unwrapChildren(e, t, i, n) {
          var o = t;
          var r = [];

          for (; o < i;) {
            var _t49 = e.getChild(o);

            if (_t49.is("attributeElement")) {
              if (_t49.isSimilar(n)) {
                var _n24 = _t49.getChildren(),
                    _s6 = _t49.childCount;

                _t49._remove(), e._insertChild(o, _n24), this._removeFromClonedElementsGroup(_t49), r.push(new co(e, o), new co(e, o + _s6)), o += _s6, i += _s6 - 1;
              } else this._unwrapAttributeElement(n, _t49) ? (r.push(new co(e, o), new co(e, o + 1)), o++) : (this._unwrapChildren(_t49, 0, _t49.childCount, n), o++);
            } else o++;
          }

          var s = 0;

          for (var _i50 = 0, _r12 = r; _i50 < _r12.length; _i50++) {
            var _e39 = _r12[_i50];
            if (_e39.offset -= s, _e39.offset == t || _e39.offset == i) continue;
            this.mergeAttributes(_e39).isEqual(_e39) || (s++, i--);
          }

          return lo._createFromParentsAndOffsets(e, t, e, i);
        }
      }, {
        key: "_wrapRange",
        value: function _wrapRange(e, t) {
          var _this$_breakAttribute3 = this._breakAttributesRange(e, !0),
              i = _this$_breakAttribute3.start,
              n = _this$_breakAttribute3.end,
              o = i.parent,
              r = this._wrapChildren(o, i.offset, n.offset, t),
              s = this.mergeAttributes(r.start);

          s.isEqual(r.start) || r.end.offset--;
          var a = this.mergeAttributes(r.end);
          return new lo(s, a);
        }
      }, {
        key: "_wrapPosition",
        value: function _wrapPosition(e, t) {
          if (t.isSimilar(e.parent)) return Go(e.clone());
          e.parent.is("$text") && (e = Ko(e));
          var i = this.createAttributeElement();
          i._priority = Number.POSITIVE_INFINITY, i.isSimilar = function () {
            return !1;
          }, e.parent._insertChild(e.offset, i);
          var n = new lo(e, e.getShiftedBy(1));
          this.wrap(n, t);
          var o = new co(i.parent, i.index);

          i._remove();

          var r = o.nodeBefore,
              s = o.nodeAfter;
          return r instanceof hn && s instanceof hn ? Qo(r, s) : Go(o);
        }
      }, {
        key: "_wrapAttributeElement",
        value: function _wrapAttributeElement(e, t) {
          if (!er(e, t)) return !1;
          if (e.name !== t.name || e.priority !== t.priority) return !1;
          var _iteratorNormalCompletion55 = true;
          var _didIteratorError55 = false;
          var _iteratorError55 = undefined;

          try {
            for (var _iterator55 = e.getAttributeKeys()[Symbol.iterator](), _step55; !(_iteratorNormalCompletion55 = (_step55 = _iterator55.next()).done); _iteratorNormalCompletion55 = true) {
              var _i51 = _step55.value;
              if ("class" !== _i51 && "style" !== _i51 && t.hasAttribute(_i51) && t.getAttribute(_i51) !== e.getAttribute(_i51)) return !1;
            }
          } catch (err) {
            _didIteratorError55 = true;
            _iteratorError55 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion55 && _iterator55.return != null) {
                _iterator55.return();
              }
            } finally {
              if (_didIteratorError55) {
                throw _iteratorError55;
              }
            }
          }

          var _iteratorNormalCompletion56 = true;
          var _didIteratorError56 = false;
          var _iteratorError56 = undefined;

          try {
            for (var _iterator56 = e.getStyleNames()[Symbol.iterator](), _step56; !(_iteratorNormalCompletion56 = (_step56 = _iterator56.next()).done); _iteratorNormalCompletion56 = true) {
              var _i52 = _step56.value;
              if (t.hasStyle(_i52) && t.getStyle(_i52) !== e.getStyle(_i52)) return !1;
            }
          } catch (err) {
            _didIteratorError56 = true;
            _iteratorError56 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion56 && _iterator56.return != null) {
                _iterator56.return();
              }
            } finally {
              if (_didIteratorError56) {
                throw _iteratorError56;
              }
            }
          }

          var _iteratorNormalCompletion57 = true;
          var _didIteratorError57 = false;
          var _iteratorError57 = undefined;

          try {
            for (var _iterator57 = e.getAttributeKeys()[Symbol.iterator](), _step57; !(_iteratorNormalCompletion57 = (_step57 = _iterator57.next()).done); _iteratorNormalCompletion57 = true) {
              var _i53 = _step57.value;
              "class" !== _i53 && "style" !== _i53 && (t.hasAttribute(_i53) || this.setAttribute(_i53, e.getAttribute(_i53), t));
            }
          } catch (err) {
            _didIteratorError57 = true;
            _iteratorError57 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion57 && _iterator57.return != null) {
                _iterator57.return();
              }
            } finally {
              if (_didIteratorError57) {
                throw _iteratorError57;
              }
            }
          }

          var _iteratorNormalCompletion58 = true;
          var _didIteratorError58 = false;
          var _iteratorError58 = undefined;

          try {
            for (var _iterator58 = e.getStyleNames()[Symbol.iterator](), _step58; !(_iteratorNormalCompletion58 = (_step58 = _iterator58.next()).done); _iteratorNormalCompletion58 = true) {
              var _i54 = _step58.value;
              t.hasStyle(_i54) || this.setStyle(_i54, e.getStyle(_i54), t);
            }
          } catch (err) {
            _didIteratorError58 = true;
            _iteratorError58 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion58 && _iterator58.return != null) {
                _iterator58.return();
              }
            } finally {
              if (_didIteratorError58) {
                throw _iteratorError58;
              }
            }
          }

          var _iteratorNormalCompletion59 = true;
          var _didIteratorError59 = false;
          var _iteratorError59 = undefined;

          try {
            for (var _iterator59 = e.getClassNames()[Symbol.iterator](), _step59; !(_iteratorNormalCompletion59 = (_step59 = _iterator59.next()).done); _iteratorNormalCompletion59 = true) {
              var _i55 = _step59.value;
              t.hasClass(_i55) || this.addClass(_i55, t);
            }
          } catch (err) {
            _didIteratorError59 = true;
            _iteratorError59 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion59 && _iterator59.return != null) {
                _iterator59.return();
              }
            } finally {
              if (_didIteratorError59) {
                throw _iteratorError59;
              }
            }
          }

          return !0;
        }
      }, {
        key: "_unwrapAttributeElement",
        value: function _unwrapAttributeElement(e, t) {
          if (!er(e, t)) return !1;
          if (e.name !== t.name || e.priority !== t.priority) return !1;
          var _iteratorNormalCompletion60 = true;
          var _didIteratorError60 = false;
          var _iteratorError60 = undefined;

          try {
            for (var _iterator60 = e.getAttributeKeys()[Symbol.iterator](), _step60; !(_iteratorNormalCompletion60 = (_step60 = _iterator60.next()).done); _iteratorNormalCompletion60 = true) {
              var _i56 = _step60.value;
              if ("class" !== _i56 && "style" !== _i56 && (!t.hasAttribute(_i56) || t.getAttribute(_i56) !== e.getAttribute(_i56))) return !1;
            }
          } catch (err) {
            _didIteratorError60 = true;
            _iteratorError60 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion60 && _iterator60.return != null) {
                _iterator60.return();
              }
            } finally {
              if (_didIteratorError60) {
                throw _iteratorError60;
              }
            }
          }

          if (!t.hasClass.apply(t, _toConsumableArray(e.getClassNames()))) return !1;
          var _iteratorNormalCompletion61 = true;
          var _didIteratorError61 = false;
          var _iteratorError61 = undefined;

          try {
            for (var _iterator61 = e.getStyleNames()[Symbol.iterator](), _step61; !(_iteratorNormalCompletion61 = (_step61 = _iterator61.next()).done); _iteratorNormalCompletion61 = true) {
              var _i57 = _step61.value;
              if (!t.hasStyle(_i57) || t.getStyle(_i57) !== e.getStyle(_i57)) return !1;
            }
          } catch (err) {
            _didIteratorError61 = true;
            _iteratorError61 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion61 && _iterator61.return != null) {
                _iterator61.return();
              }
            } finally {
              if (_didIteratorError61) {
                throw _iteratorError61;
              }
            }
          }

          var _iteratorNormalCompletion62 = true;
          var _didIteratorError62 = false;
          var _iteratorError62 = undefined;

          try {
            for (var _iterator62 = e.getAttributeKeys()[Symbol.iterator](), _step62; !(_iteratorNormalCompletion62 = (_step62 = _iterator62.next()).done); _iteratorNormalCompletion62 = true) {
              var _i58 = _step62.value;
              "class" !== _i58 && "style" !== _i58 && this.removeAttribute(_i58, t);
            }
          } catch (err) {
            _didIteratorError62 = true;
            _iteratorError62 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion62 && _iterator62.return != null) {
                _iterator62.return();
              }
            } finally {
              if (_didIteratorError62) {
                throw _iteratorError62;
              }
            }
          }

          return this.removeClass(Array.from(e.getClassNames()), t), this.removeStyle(Array.from(e.getStyleNames()), t), !0;
        }
      }, {
        key: "_breakAttributesRange",
        value: function _breakAttributesRange(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          var i = e.start,
              n = e.end;

          if (Xo(e, this.document), e.isCollapsed) {
            var _i59 = this._breakAttributes(e.start, t);

            return new lo(_i59, _i59);
          }

          var o = this._breakAttributes(n, t),
              r = o.parent.childCount,
              s = this._breakAttributes(i, t);

          return o.offset += o.parent.childCount - r, new lo(s, o);
        }
      }, {
        key: "_breakAttributes",
        value: function _breakAttributes(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          var i = e.offset,
              n = e.parent;
          if (e.parent.is("emptyElement")) throw new c.a("view-writer-cannot-break-empty-element", this.document);
          if (e.parent.is("uiElement")) throw new c.a("view-writer-cannot-break-ui-element", this.document);
          if (e.parent.is("rawElement")) throw new c.a("view-writer-cannot-break-raw-element", this.document);
          if (!t && n.is("$text") && Zo(n.parent)) return e.clone();
          if (Zo(n)) return e.clone();
          if (n.is("$text")) return this._breakAttributes(Ko(e), t);

          if (i == n.childCount) {
            var _e40 = new co(n.parent, n.index + 1);

            return this._breakAttributes(_e40, t);
          }

          if (0 === i) {
            var _e41 = new co(n.parent, n.index);

            return this._breakAttributes(_e41, t);
          }

          {
            var _e42 = n.index + 1,
                _o18 = n._clone();

            n.parent._insertChild(_e42, _o18), this._addToClonedElementsGroup(_o18);

            var _r13 = n.childCount - i,
                _s7 = n._removeChildren(i, _r13);

            _o18._appendChild(_s7);

            var _a6 = new co(n.parent, _e42);

            return this._breakAttributes(_a6, t);
          }
        }
      }, {
        key: "_addToClonedElementsGroup",
        value: function _addToClonedElementsGroup(e) {
          if (!e.root.is("rootElement")) return;

          if (e.is("element")) {
            var _iteratorNormalCompletion63 = true;
            var _didIteratorError63 = false;
            var _iteratorError63 = undefined;

            try {
              for (var _iterator63 = e.getChildren()[Symbol.iterator](), _step63; !(_iteratorNormalCompletion63 = (_step63 = _iterator63.next()).done); _iteratorNormalCompletion63 = true) {
                var _t50 = _step63.value;

                this._addToClonedElementsGroup(_t50);
              }
            } catch (err) {
              _didIteratorError63 = true;
              _iteratorError63 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion63 && _iterator63.return != null) {
                  _iterator63.return();
                }
              } finally {
                if (_didIteratorError63) {
                  throw _iteratorError63;
                }
              }
            }
          }

          var t = e.id;
          if (!t) return;

          var i = this._cloneGroups.get(t);

          i || (i = new Set(), this._cloneGroups.set(t, i)), i.add(e), e._clonesGroup = i;
        }
      }, {
        key: "_removeFromClonedElementsGroup",
        value: function _removeFromClonedElementsGroup(e) {
          if (e.is("element")) {
            var _iteratorNormalCompletion64 = true;
            var _didIteratorError64 = false;
            var _iteratorError64 = undefined;

            try {
              for (var _iterator64 = e.getChildren()[Symbol.iterator](), _step64; !(_iteratorNormalCompletion64 = (_step64 = _iterator64.next()).done); _iteratorNormalCompletion64 = true) {
                var _t51 = _step64.value;

                this._removeFromClonedElementsGroup(_t51);
              }
            } catch (err) {
              _didIteratorError64 = true;
              _iteratorError64 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion64 && _iterator64.return != null) {
                  _iterator64.return();
                }
              } finally {
                if (_didIteratorError64) {
                  throw _iteratorError64;
                }
              }
            }
          }

          var t = e.id;
          if (!t) return;

          var i = this._cloneGroups.get(t);

          i && i.delete(e);
        }
      }]);

      return qo;
    }();

    function $o(e) {
      var t = e.parent;

      for (; !Zo(t);) {
        if (!t) return;
        t = t.parent;
      }

      return t;
    }

    function Yo(e, t) {
      return e.priority < t.priority || !(e.priority > t.priority) && e.getIdentity() < t.getIdentity();
    }

    function Go(e) {
      var t = e.nodeBefore;
      if (t && t.is("$text")) return new co(t, t.data.length);
      var i = e.nodeAfter;
      return i && i.is("$text") ? new co(i, 0) : e;
    }

    function Ko(e) {
      if (e.offset == e.parent.data.length) return new co(e.parent.parent, e.parent.index + 1);
      if (0 === e.offset) return new co(e.parent.parent, e.parent.index);
      var t = e.parent.data.slice(e.offset);
      return e.parent._data = e.parent.data.slice(0, e.offset), e.parent.parent._insertChild(e.parent.index + 1, new hn(e.root.document, t)), new co(e.parent.parent, e.parent.index + 1);
    }

    function Qo(e, t) {
      var i = e.data.length;
      return e._data += t.data, t._remove(), new co(e, i);
    }

    var Jo = [hn, xo, io, To, Ho, jo];

    function Zo(e) {
      return e && (e.is("containerElement") || e.is("documentFragment"));
    }

    function Xo(e, t) {
      var i = $o(e.start),
          n = $o(e.end);
      if (!i || !n || i !== n) throw new c.a("view-writer-invalid-range-container", t);
    }

    function er(e, t) {
      return null === e.id && null === t.id;
    }

    function tr(e) {
      return "[object Text]" == Object.prototype.toString.call(e);
    }

    var ir = function ir(e) {
      return e.createTextNode(" ");
    },
        nr = function nr(e) {
      var t = e.createElement("span");
      return t.dataset.ckeFiller = !0, t.innerHTML = " ", t;
    },
        or = function or(e) {
      var t = e.createElement("br");
      return t.dataset.ckeFiller = !0, t;
    },
        rr = "⁠".repeat(7);

    function sr(e) {
      return tr(e) && e.data.substr(0, 7) === rr;
    }

    function ar(e) {
      return 7 == e.data.length && sr(e);
    }

    function cr(e) {
      return sr(e) ? e.data.slice(7) : e.data;
    }

    function lr(e, t) {
      if (t.keyCode == No.arrowleft) {
        var _e43 = t.domTarget.ownerDocument.defaultView.getSelection();

        if (1 == _e43.rangeCount && _e43.getRangeAt(0).collapsed) {
          var _t52 = _e43.getRangeAt(0).startContainer,
              _i60 = _e43.getRangeAt(0).startOffset;

          sr(_t52) && _i60 <= 7 && _e43.collapse(_t52, 0);
        }
      }
    }

    function dr(e, t, i) {
      var n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
      i = i || function (e, t) {
        return e === t;
      }, Array.isArray(e) || (e = Array.prototype.slice.call(e)), Array.isArray(t) || (t = Array.prototype.slice.call(t));

      var o = function (e, t, i) {
        var n = hr(e, t, i);
        if (-1 === n) return {
          firstIndex: -1,
          lastIndexOld: -1,
          lastIndexNew: -1
        };
        var o = ur(e, n),
            r = ur(t, n),
            s = hr(o, r, i),
            a = e.length - s,
            c = t.length - s;
        return {
          firstIndex: n,
          lastIndexOld: a,
          lastIndexNew: c
        };
      }(e, t, i);

      return n ? function (e, t) {
        var i = e.firstIndex,
            n = e.lastIndexOld,
            o = e.lastIndexNew;
        if (-1 === i) return Array(t).fill("equal");
        var r = [];
        i > 0 && (r = r.concat(Array(i).fill("equal")));
        o - i > 0 && (r = r.concat(Array(o - i).fill("insert")));
        n - i > 0 && (r = r.concat(Array(n - i).fill("delete")));
        o < t && (r = r.concat(Array(t - o).fill("equal")));
        return r;
      }(o, t.length) : function (e, t) {
        var i = [],
            n = t.firstIndex,
            o = t.lastIndexOld,
            r = t.lastIndexNew;
        r - n > 0 && i.push({
          index: n,
          type: "insert",
          values: e.slice(n, r)
        });
        o - n > 0 && i.push({
          index: n + (r - n),
          type: "delete",
          howMany: o - n
        });
        return i;
      }(t, o);
    }

    function hr(e, t, i) {
      for (var _n25 = 0; _n25 < Math.max(e.length, t.length); _n25++) {
        if (void 0 === e[_n25] || void 0 === t[_n25] || !i(e[_n25], t[_n25])) return _n25;
      }

      return -1;
    }

    function ur(e, t) {
      return e.slice(t).reverse();
    }

    function gr(e, t, i) {
      i = i || function (e, t) {
        return e === t;
      };

      var n = e.length,
          o = t.length;
      if (n > 200 || o > 200 || n + o > 300) return gr.fastDiff(e, t, i, !0);
      var r, s;

      if (o < n) {
        var _i61 = e;
        e = t, t = _i61, r = "delete", s = "insert";
      } else r = "insert", s = "delete";

      var a = e.length,
          c = t.length,
          l = c - a,
          d = {},
          h = {};

      function u(n) {
        var o = (void 0 !== h[n - 1] ? h[n - 1] : -1) + 1,
            l = void 0 !== h[n + 1] ? h[n + 1] : -1,
            u = o > l ? -1 : 1;
        d[n + u] && (d[n] = d[n + u].slice(0)), d[n] || (d[n] = []), d[n].push(o > l ? r : s);
        var g = Math.max(o, l),
            m = g - n;

        for (; m < a && g < c && i(e[m], t[g]);) {
          m++, g++, d[n].push("equal");
        }

        return g;
      }

      var g,
          m = 0;

      do {
        for (g = -m; g < l; g++) {
          h[g] = u(g);
        }

        for (g = l + m; g > l; g--) {
          h[g] = u(g);
        }

        h[l] = u(l), m++;
      } while (h[l] !== c);

      return d[l].slice(1);
    }

    function mr(e, t, i) {
      e.insertBefore(i, e.childNodes[t] || null);
    }

    function fr(e) {
      var t = e.parentNode;
      t && t.removeChild(e);
    }

    function pr(e) {
      if (e) {
        if (e.defaultView) return e instanceof e.defaultView.Document;
        if (e.ownerDocument && e.ownerDocument.defaultView) return e instanceof e.ownerDocument.defaultView.Node;
      }

      return !1;
    }

    gr.fastDiff = dr;

    var br =
    /*#__PURE__*/
    function () {
      function br(e, t) {
        _classCallCheck(this, br);

        this.domDocuments = new Set(), this.domConverter = e, this.markedAttributes = new Set(), this.markedChildren = new Set(), this.markedTexts = new Set(), this.selection = t, this.isFocused = !1, this._inlineFiller = null, this._fakeSelectionContainer = null;
      }

      _createClass(br, [{
        key: "markToSync",
        value: function markToSync(e, t) {
          if ("text" === e) this.domConverter.mapViewToDom(t.parent) && this.markedTexts.add(t);else {
            if (!this.domConverter.mapViewToDom(t)) return;
            if ("attributes" === e) this.markedAttributes.add(t);else {
              if ("children" !== e) throw new c.a("view-renderer-unknown-type", this);
              this.markedChildren.add(t);
            }
          }
        }
      }, {
        key: "render",
        value: function render() {
          var e;
          var _iteratorNormalCompletion65 = true;
          var _didIteratorError65 = false;
          var _iteratorError65 = undefined;

          try {
            for (var _iterator65 = this.markedChildren[Symbol.iterator](), _step65; !(_iteratorNormalCompletion65 = (_step65 = _iterator65.next()).done); _iteratorNormalCompletion65 = true) {
              var _e44 = _step65.value;

              this._updateChildrenMappings(_e44);
            }
          } catch (err) {
            _didIteratorError65 = true;
            _iteratorError65 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion65 && _iterator65.return != null) {
                _iterator65.return();
              }
            } finally {
              if (_didIteratorError65) {
                throw _iteratorError65;
              }
            }
          }

          this._inlineFiller && !this._isSelectionInInlineFiller() && this._removeInlineFiller(), this._inlineFiller ? e = this._getInlineFillerPosition() : this._needsInlineFillerAtSelection() && (e = this.selection.getFirstPosition(), this.markedChildren.add(e.parent));
          var _iteratorNormalCompletion66 = true;
          var _didIteratorError66 = false;
          var _iteratorError66 = undefined;

          try {
            for (var _iterator66 = this.markedAttributes[Symbol.iterator](), _step66; !(_iteratorNormalCompletion66 = (_step66 = _iterator66.next()).done); _iteratorNormalCompletion66 = true) {
              var _e45 = _step66.value;

              this._updateAttrs(_e45);
            }
          } catch (err) {
            _didIteratorError66 = true;
            _iteratorError66 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion66 && _iterator66.return != null) {
                _iterator66.return();
              }
            } finally {
              if (_didIteratorError66) {
                throw _iteratorError66;
              }
            }
          }

          var _iteratorNormalCompletion67 = true;
          var _didIteratorError67 = false;
          var _iteratorError67 = undefined;

          try {
            for (var _iterator67 = this.markedChildren[Symbol.iterator](), _step67; !(_iteratorNormalCompletion67 = (_step67 = _iterator67.next()).done); _iteratorNormalCompletion67 = true) {
              var _t54 = _step67.value;

              this._updateChildren(_t54, {
                inlineFillerPosition: e
              });
            }
          } catch (err) {
            _didIteratorError67 = true;
            _iteratorError67 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion67 && _iterator67.return != null) {
                _iterator67.return();
              }
            } finally {
              if (_didIteratorError67) {
                throw _iteratorError67;
              }
            }
          }

          var _iteratorNormalCompletion68 = true;
          var _didIteratorError68 = false;
          var _iteratorError68 = undefined;

          try {
            for (var _iterator68 = this.markedTexts[Symbol.iterator](), _step68; !(_iteratorNormalCompletion68 = (_step68 = _iterator68.next()).done); _iteratorNormalCompletion68 = true) {
              var _t55 = _step68.value;
              !this.markedChildren.has(_t55.parent) && this.domConverter.mapViewToDom(_t55.parent) && this._updateText(_t55, {
                inlineFillerPosition: e
              });
            }
          } catch (err) {
            _didIteratorError68 = true;
            _iteratorError68 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion68 && _iterator68.return != null) {
                _iterator68.return();
              }
            } finally {
              if (_didIteratorError68) {
                throw _iteratorError68;
              }
            }
          }

          if (e) {
            var _t53 = this.domConverter.viewPositionToDom(e),
                _i62 = _t53.parent.ownerDocument;

            sr(_t53.parent) ? this._inlineFiller = _t53.parent : this._inlineFiller = wr(_i62, _t53.parent, _t53.offset);
          } else this._inlineFiller = null;

          this._updateFocus(), this._updateSelection(), this.markedTexts.clear(), this.markedAttributes.clear(), this.markedChildren.clear();
        }
      }, {
        key: "_updateChildrenMappings",
        value: function _updateChildrenMappings(e) {
          var t = this.domConverter.mapViewToDom(e);
          if (!t) return;

          var i = Array.from(this.domConverter.mapViewToDom(e).childNodes),
              n = Array.from(this.domConverter.viewChildrenToDom(e, t.ownerDocument, {
            withChildren: !1
          })),
              o = this._diffNodeLists(i, n),
              r = this._findReplaceActions(o, i, n);

          if (-1 !== r.indexOf("replace")) {
            var _t56 = {
              equal: 0,
              insert: 0,
              delete: 0
            };
            var _iteratorNormalCompletion69 = true;
            var _didIteratorError69 = false;
            var _iteratorError69 = undefined;

            try {
              for (var _iterator69 = r[Symbol.iterator](), _step69; !(_iteratorNormalCompletion69 = (_step69 = _iterator69.next()).done); _iteratorNormalCompletion69 = true) {
                var _o19 = _step69.value;

                if ("replace" === _o19) {
                  var _o20 = _t56.equal + _t56.insert,
                      _r14 = _t56.equal + _t56.delete,
                      _s8 = e.getChild(_o20);

                  !_s8 || _s8.is("uiElement") || _s8.is("rawElement") || this._updateElementMappings(_s8, i[_r14]), fr(n[_o20]), _t56.equal++;
                } else _t56[_o19]++;
              }
            } catch (err) {
              _didIteratorError69 = true;
              _iteratorError69 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion69 && _iterator69.return != null) {
                  _iterator69.return();
                }
              } finally {
                if (_didIteratorError69) {
                  throw _iteratorError69;
                }
              }
            }
          }
        }
      }, {
        key: "_updateElementMappings",
        value: function _updateElementMappings(e, t) {
          this.domConverter.unbindDomElement(t), this.domConverter.bindElements(t, e), this.markedChildren.add(e), this.markedAttributes.add(e);
        }
      }, {
        key: "_getInlineFillerPosition",
        value: function _getInlineFillerPosition() {
          var e = this.selection.getFirstPosition();
          return e.parent.is("$text") ? co._createBefore(this.selection.getFirstPosition().parent) : e;
        }
      }, {
        key: "_isSelectionInInlineFiller",
        value: function _isSelectionInInlineFiller() {
          if (1 != this.selection.rangeCount || !this.selection.isCollapsed) return !1;
          var e = this.selection.getFirstPosition(),
              t = this.domConverter.viewPositionToDom(e);
          return !!(t && tr(t.parent) && sr(t.parent));
        }
      }, {
        key: "_removeInlineFiller",
        value: function _removeInlineFiller() {
          var e = this._inlineFiller;
          if (!sr(e)) throw new c.a("view-renderer-filler-was-lost", this);
          ar(e) ? e.parentNode.removeChild(e) : e.data = e.data.substr(7), this._inlineFiller = null;
        }
      }, {
        key: "_needsInlineFillerAtSelection",
        value: function _needsInlineFillerAtSelection() {
          if (1 != this.selection.rangeCount || !this.selection.isCollapsed) return !1;
          var e = this.selection.getFirstPosition(),
              t = e.parent,
              i = e.offset;
          if (!this.domConverter.mapViewToDom(t.root)) return !1;
          if (!t.is("element")) return !1;
          if (!function (e) {
            if ("false" == e.getAttribute("contenteditable")) return !1;
            var t = e.findAncestor(function (e) {
              return e.hasAttribute("contenteditable");
            });
            return !t || "true" == t.getAttribute("contenteditable");
          }(t)) return !1;
          if (i === t.getFillerOffset()) return !1;
          var n = e.nodeBefore,
              o = e.nodeAfter;
          return !(n instanceof hn || o instanceof hn);
        }
      }, {
        key: "_updateText",
        value: function _updateText(e, t) {
          var i = this.domConverter.findCorrespondingDomText(e),
              n = this.domConverter.viewToDom(e, i.ownerDocument),
              o = i.data;
          var r = n.data;
          var s = t.inlineFillerPosition;

          if (s && s.parent == e.parent && s.offset == e.index && (r = rr + r), o != r) {
            var _e46 = dr(o, r);

            var _iteratorNormalCompletion70 = true;
            var _didIteratorError70 = false;
            var _iteratorError70 = undefined;

            try {
              for (var _iterator70 = _e46[Symbol.iterator](), _step70; !(_iteratorNormalCompletion70 = (_step70 = _iterator70.next()).done); _iteratorNormalCompletion70 = true) {
                var _t57 = _step70.value;
                "insert" === _t57.type ? i.insertData(_t57.index, _t57.values.join("")) : i.deleteData(_t57.index, _t57.howMany);
              }
            } catch (err) {
              _didIteratorError70 = true;
              _iteratorError70 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion70 && _iterator70.return != null) {
                  _iterator70.return();
                }
              } finally {
                if (_didIteratorError70) {
                  throw _iteratorError70;
                }
              }
            }
          }
        }
      }, {
        key: "_updateAttrs",
        value: function _updateAttrs(e) {
          var t = this.domConverter.mapViewToDom(e);
          if (!t) return;
          var i = Array.from(t.attributes).map(function (e) {
            return e.name;
          }),
              n = e.getAttributeKeys();
          var _iteratorNormalCompletion71 = true;
          var _didIteratorError71 = false;
          var _iteratorError71 = undefined;

          try {
            for (var _iterator71 = n[Symbol.iterator](), _step71; !(_iteratorNormalCompletion71 = (_step71 = _iterator71.next()).done); _iteratorNormalCompletion71 = true) {
              var _i63 = _step71.value;
              t.setAttribute(_i63, e.getAttribute(_i63));
            }
          } catch (err) {
            _didIteratorError71 = true;
            _iteratorError71 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion71 && _iterator71.return != null) {
                _iterator71.return();
              }
            } finally {
              if (_didIteratorError71) {
                throw _iteratorError71;
              }
            }
          }

          var _iteratorNormalCompletion72 = true;
          var _didIteratorError72 = false;
          var _iteratorError72 = undefined;

          try {
            for (var _iterator72 = i[Symbol.iterator](), _step72; !(_iteratorNormalCompletion72 = (_step72 = _iterator72.next()).done); _iteratorNormalCompletion72 = true) {
              var _n26 = _step72.value;
              e.hasAttribute(_n26) || t.removeAttribute(_n26);
            }
          } catch (err) {
            _didIteratorError72 = true;
            _iteratorError72 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion72 && _iterator72.return != null) {
                _iterator72.return();
              }
            } finally {
              if (_didIteratorError72) {
                throw _iteratorError72;
              }
            }
          }
        }
      }, {
        key: "_updateChildren",
        value: function _updateChildren(e, t) {
          var i = this.domConverter.mapViewToDom(e);
          if (!i) return;
          var n = t.inlineFillerPosition,
              o = this.domConverter.mapViewToDom(e).childNodes,
              r = Array.from(this.domConverter.viewChildrenToDom(e, i.ownerDocument, {
            bind: !0,
            inlineFillerPosition: n
          }));
          n && n.parent === e && wr(i.ownerDocument, r, n.offset);

          var s = this._diffNodeLists(o, r);

          var a = 0;
          var c = new Set();
          var _iteratorNormalCompletion73 = true;
          var _didIteratorError73 = false;
          var _iteratorError73 = undefined;

          try {
            for (var _iterator73 = s[Symbol.iterator](), _step73; !(_iteratorNormalCompletion73 = (_step73 = _iterator73.next()).done); _iteratorNormalCompletion73 = true) {
              var _e47 = _step73.value;
              "delete" === _e47 ? (c.add(o[a]), fr(o[a])) : "equal" === _e47 && a++;
            }
          } catch (err) {
            _didIteratorError73 = true;
            _iteratorError73 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion73 && _iterator73.return != null) {
                _iterator73.return();
              }
            } finally {
              if (_didIteratorError73) {
                throw _iteratorError73;
              }
            }
          }

          a = 0;
          var _iteratorNormalCompletion74 = true;
          var _didIteratorError74 = false;
          var _iteratorError74 = undefined;

          try {
            for (var _iterator74 = s[Symbol.iterator](), _step74; !(_iteratorNormalCompletion74 = (_step74 = _iterator74.next()).done); _iteratorNormalCompletion74 = true) {
              var _e48 = _step74.value;
              "insert" === _e48 ? (mr(i, a, r[a]), a++) : "equal" === _e48 && (this._markDescendantTextToSync(this.domConverter.domToView(r[a])), a++);
            }
          } catch (err) {
            _didIteratorError74 = true;
            _iteratorError74 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion74 && _iterator74.return != null) {
                _iterator74.return();
              }
            } finally {
              if (_didIteratorError74) {
                throw _iteratorError74;
              }
            }
          }

          var _iteratorNormalCompletion75 = true;
          var _didIteratorError75 = false;
          var _iteratorError75 = undefined;

          try {
            for (var _iterator75 = c[Symbol.iterator](), _step75; !(_iteratorNormalCompletion75 = (_step75 = _iterator75.next()).done); _iteratorNormalCompletion75 = true) {
              var _e49 = _step75.value;
              _e49.parentNode || this.domConverter.unbindDomElement(_e49);
            }
          } catch (err) {
            _didIteratorError75 = true;
            _iteratorError75 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion75 && _iterator75.return != null) {
                _iterator75.return();
              }
            } finally {
              if (_didIteratorError75) {
                throw _iteratorError75;
              }
            }
          }
        }
      }, {
        key: "_diffNodeLists",
        value: function _diffNodeLists(e, t) {
          return gr(e = function (e, t) {
            var i = Array.from(e);
            if (0 == i.length || !t) return i;
            i[i.length - 1] == t && i.pop();
            return i;
          }(e, this._fakeSelectionContainer), t, _r.bind(null, this.domConverter));
        }
      }, {
        key: "_findReplaceActions",
        value: function _findReplaceActions(e, t, i) {
          if (-1 === e.indexOf("insert") || -1 === e.indexOf("delete")) return e;
          var n = [],
              o = [],
              r = [];
          var s = {
            equal: 0,
            insert: 0,
            delete: 0
          };
          var _iteratorNormalCompletion76 = true;
          var _didIteratorError76 = false;
          var _iteratorError76 = undefined;

          try {
            for (var _iterator76 = e[Symbol.iterator](), _step76; !(_iteratorNormalCompletion76 = (_step76 = _iterator76.next()).done); _iteratorNormalCompletion76 = true) {
              var _a7 = _step76.value;
              "insert" === _a7 ? r.push(i[s.equal + s.insert]) : "delete" === _a7 ? o.push(t[s.equal + s.delete]) : (n = n.concat(gr(o, r, kr).map(function (e) {
                return "equal" === e ? "replace" : e;
              })), n.push("equal"), o = [], r = []), s[_a7]++;
            }
          } catch (err) {
            _didIteratorError76 = true;
            _iteratorError76 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion76 && _iterator76.return != null) {
                _iterator76.return();
              }
            } finally {
              if (_didIteratorError76) {
                throw _iteratorError76;
              }
            }
          }

          return n.concat(gr(o, r, kr).map(function (e) {
            return "equal" === e ? "replace" : e;
          }));
        }
      }, {
        key: "_markDescendantTextToSync",
        value: function _markDescendantTextToSync(e) {
          if (e) if (e.is("$text")) this.markedTexts.add(e);else if (e.is("element")) {
            var _iteratorNormalCompletion77 = true;
            var _didIteratorError77 = false;
            var _iteratorError77 = undefined;

            try {
              for (var _iterator77 = e.getChildren()[Symbol.iterator](), _step77; !(_iteratorNormalCompletion77 = (_step77 = _iterator77.next()).done); _iteratorNormalCompletion77 = true) {
                var _t58 = _step77.value;

                this._markDescendantTextToSync(_t58);
              }
            } catch (err) {
              _didIteratorError77 = true;
              _iteratorError77 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion77 && _iterator77.return != null) {
                  _iterator77.return();
                }
              } finally {
                if (_didIteratorError77) {
                  throw _iteratorError77;
                }
              }
            }
          }
        }
      }, {
        key: "_updateSelection",
        value: function _updateSelection() {
          if (0 === this.selection.rangeCount) return this._removeDomSelection(), void this._removeFakeSelection();
          var e = this.domConverter.mapViewToDom(this.selection.editableElement);
          this.isFocused && e && (this.selection.isFake ? this._updateFakeSelection(e) : (this._removeFakeSelection(), this._updateDomSelection(e)));
        }
      }, {
        key: "_updateFakeSelection",
        value: function _updateFakeSelection(e) {
          var t = e.ownerDocument;
          this._fakeSelectionContainer || (this._fakeSelectionContainer = function (e) {
            var t = e.createElement("div");
            return t.className = "ck-fake-selection-container", Object.assign(t.style, {
              position: "fixed",
              top: 0,
              left: "-9999px",
              width: "42px"
            }), t.textContent = " ", t;
          }(t));
          var i = this._fakeSelectionContainer;
          if (this.domConverter.bindFakeSelection(i, this.selection), !this._fakeSelectionNeedsUpdate(e)) return;
          i.parentElement && i.parentElement == e || e.appendChild(i), i.textContent = this.selection.fakeSelectionLabel || " ";
          var n = t.getSelection(),
              o = t.createRange();
          n.removeAllRanges(), o.selectNodeContents(i), n.addRange(o);
        }
      }, {
        key: "_updateDomSelection",
        value: function _updateDomSelection(e) {
          var t = e.ownerDocument.defaultView.getSelection();
          if (!this._domSelectionNeedsUpdate(t)) return;
          var i = this.domConverter.viewPositionToDom(this.selection.anchor),
              n = this.domConverter.viewPositionToDom(this.selection.focus);
          t.collapse(i.parent, i.offset), t.extend(n.parent, n.offset), Io.isGecko && function (e, t) {
            var i = e.parent;
            if (i.nodeType != Node.ELEMENT_NODE || e.offset != i.childNodes.length - 1) return;
            var n = i.childNodes[e.offset];
            n && "BR" == n.tagName && t.addRange(t.getRangeAt(0));
          }(n, t);
        }
      }, {
        key: "_domSelectionNeedsUpdate",
        value: function _domSelectionNeedsUpdate(e) {
          if (!this.domConverter.isDomSelectionCorrect(e)) return !0;
          var t = e && this.domConverter.domSelectionToView(e);
          return (!t || !this.selection.isEqual(t)) && !(!this.selection.isCollapsed && this.selection.isSimilar(t));
        }
      }, {
        key: "_fakeSelectionNeedsUpdate",
        value: function _fakeSelectionNeedsUpdate(e) {
          var t = this._fakeSelectionContainer,
              i = e.ownerDocument.getSelection();
          return !t || t.parentElement !== e || i.anchorNode !== t && !t.contains(i.anchorNode) || t.textContent !== this.selection.fakeSelectionLabel;
        }
      }, {
        key: "_removeDomSelection",
        value: function _removeDomSelection() {
          var _iteratorNormalCompletion78 = true;
          var _didIteratorError78 = false;
          var _iteratorError78 = undefined;

          try {
            for (var _iterator78 = this.domDocuments[Symbol.iterator](), _step78; !(_iteratorNormalCompletion78 = (_step78 = _iterator78.next()).done); _iteratorNormalCompletion78 = true) {
              var _e50 = _step78.value;

              if (_e50.getSelection().rangeCount) {
                var _t59 = _e50.activeElement,
                    _i64 = this.domConverter.mapDomToView(_t59);

                _t59 && _i64 && _e50.getSelection().removeAllRanges();
              }
            }
          } catch (err) {
            _didIteratorError78 = true;
            _iteratorError78 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion78 && _iterator78.return != null) {
                _iterator78.return();
              }
            } finally {
              if (_didIteratorError78) {
                throw _iteratorError78;
              }
            }
          }
        }
      }, {
        key: "_removeFakeSelection",
        value: function _removeFakeSelection() {
          var e = this._fakeSelectionContainer;
          e && e.remove();
        }
      }, {
        key: "_updateFocus",
        value: function _updateFocus() {
          if (this.isFocused) {
            var _e51 = this.selection.editableElement;
            _e51 && this.domConverter.focus(_e51);
          }
        }
      }]);

      return br;
    }();

    function wr(e, t, i) {
      var n = t instanceof Array ? t : t.childNodes,
          o = n[i];
      if (tr(o)) return o.data = rr + o.data, o;
      {
        var _o21 = e.createTextNode(rr);

        return Array.isArray(t) ? n.splice(i, 0, _o21) : mr(t, i, _o21), _o21;
      }
    }

    function kr(e, t) {
      return pr(e) && pr(t) && !tr(e) && !tr(t) && e.nodeType !== Node.COMMENT_NODE && t.nodeType !== Node.COMMENT_NODE && e.tagName.toLowerCase() === t.tagName.toLowerCase();
    }

    function _r(e, t, i) {
      return t === i || (tr(t) && tr(i) ? t.data === i.data : !(!e.isBlockFiller(t) || !e.isBlockFiller(i)));
    }

    Ke(br, Ue);
    var vr = {
      window: window,
      document: document
    };

    function yr(e) {
      var t = 0;

      for (; e.previousSibling;) {
        e = e.previousSibling, t++;
      }

      return t;
    }

    function xr(e) {
      var t = [];

      for (; e && e.nodeType != Node.DOCUMENT_NODE;) {
        t.unshift(e), e = e.parentNode;
      }

      return t;
    }

    var Ar = or(document),
        Cr = ir(document),
        Tr = nr(document);

    var Er =
    /*#__PURE__*/
    function () {
      function Er(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        _classCallCheck(this, Er);

        this.document = e, this.blockFillerMode = t.blockFillerMode || "br", this.preElements = ["pre"], this.blockElements = ["address", "article", "aside", "blockquote", "caption", "center", "dd", "details", "dir", "div", "dl", "dt", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "header", "hgroup", "legend", "li", "main", "menu", "nav", "ol", "p", "pre", "section", "summary", "table", "tbody", "td", "tfoot", "th", "thead", "tr", "ul"], this._domToViewMapping = new WeakMap(), this._viewToDomMapping = new WeakMap(), this._fakeSelectionMapping = new WeakMap(), this._rawContentElementMatcher = new mn(), this._encounteredRawContentDomNodes = new WeakSet();
      }

      _createClass(Er, [{
        key: "bindFakeSelection",
        value: function bindFakeSelection(e, t) {
          this._fakeSelectionMapping.set(e, new go(t));
        }
      }, {
        key: "fakeSelectionToView",
        value: function fakeSelectionToView(e) {
          return this._fakeSelectionMapping.get(e);
        }
      }, {
        key: "bindElements",
        value: function bindElements(e, t) {
          this._domToViewMapping.set(e, t), this._viewToDomMapping.set(t, e);
        }
      }, {
        key: "unbindDomElement",
        value: function unbindDomElement(e) {
          var t = this._domToViewMapping.get(e);

          if (t) {
            this._domToViewMapping.delete(e), this._viewToDomMapping.delete(t);
            var _iteratorNormalCompletion79 = true;
            var _didIteratorError79 = false;
            var _iteratorError79 = undefined;

            try {
              for (var _iterator79 = e.childNodes[Symbol.iterator](), _step79; !(_iteratorNormalCompletion79 = (_step79 = _iterator79.next()).done); _iteratorNormalCompletion79 = true) {
                var _t60 = _step79.value;
                this.unbindDomElement(_t60);
              }
            } catch (err) {
              _didIteratorError79 = true;
              _iteratorError79 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion79 && _iterator79.return != null) {
                  _iterator79.return();
                }
              } finally {
                if (_didIteratorError79) {
                  throw _iteratorError79;
                }
              }
            }
          }
        }
      }, {
        key: "bindDocumentFragments",
        value: function bindDocumentFragments(e, t) {
          this._domToViewMapping.set(e, t), this._viewToDomMapping.set(t, e);
        }
      }, {
        key: "viewToDom",
        value: function viewToDom(e, t) {
          var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

          if (e.is("$text")) {
            var _i65 = this._processDataFromViewText(e);

            return t.createTextNode(_i65);
          }

          {
            if (this.mapViewToDom(e)) return this.mapViewToDom(e);

            var _n27;

            if (e.is("documentFragment")) _n27 = t.createDocumentFragment(), i.bind && this.bindDocumentFragments(_n27, e);else {
              if (e.is("uiElement")) return _n27 = e.render(t), i.bind && this.bindElements(_n27, e), _n27;
              _n27 = e.hasAttribute("xmlns") ? t.createElementNS(e.getAttribute("xmlns"), e.name) : t.createElement(e.name), e.is("rawElement") && e.render(_n27), i.bind && this.bindElements(_n27, e);
              var _iteratorNormalCompletion80 = true;
              var _didIteratorError80 = false;
              var _iteratorError80 = undefined;

              try {
                for (var _iterator80 = e.getAttributeKeys()[Symbol.iterator](), _step80; !(_iteratorNormalCompletion80 = (_step80 = _iterator80.next()).done); _iteratorNormalCompletion80 = true) {
                  var _t61 = _step80.value;

                  _n27.setAttribute(_t61, e.getAttribute(_t61));
                }
              } catch (err) {
                _didIteratorError80 = true;
                _iteratorError80 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion80 && _iterator80.return != null) {
                    _iterator80.return();
                  }
                } finally {
                  if (_didIteratorError80) {
                    throw _iteratorError80;
                  }
                }
              }
            }

            if (!1 !== i.withChildren) {
              var _iteratorNormalCompletion81 = true;
              var _didIteratorError81 = false;
              var _iteratorError81 = undefined;

              try {
                for (var _iterator81 = this.viewChildrenToDom(e, t, i)[Symbol.iterator](), _step81; !(_iteratorNormalCompletion81 = (_step81 = _iterator81.next()).done); _iteratorNormalCompletion81 = true) {
                  var _o22 = _step81.value;

                  _n27.appendChild(_o22);
                }
              } catch (err) {
                _didIteratorError81 = true;
                _iteratorError81 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion81 && _iterator81.return != null) {
                    _iterator81.return();
                  }
                } finally {
                  if (_didIteratorError81) {
                    throw _iteratorError81;
                  }
                }
              }
            }

            return _n27;
          }
        }
      }, {
        key: "viewChildrenToDom",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function viewChildrenToDom(e, t) {
          var i,
              n,
              o,
              _iteratorNormalCompletion82,
              _didIteratorError82,
              _iteratorError82,
              _iterator82,
              _step82,
              _r15,
              _args11 = arguments;

          return _regeneratorRuntime.wrap(function viewChildrenToDom$(_context11) {
            while (1) {
              switch (_context11.prev = _context11.next) {
                case 0:
                  i = _args11.length > 2 && _args11[2] !== undefined ? _args11[2] : {};
                  n = e.getFillerOffset && e.getFillerOffset();
                  o = 0;
                  _iteratorNormalCompletion82 = true;
                  _didIteratorError82 = false;
                  _iteratorError82 = undefined;
                  _context11.prev = 6;
                  _iterator82 = e.getChildren()[Symbol.iterator]();

                case 8:
                  if (_iteratorNormalCompletion82 = (_step82 = _iterator82.next()).done) {
                    _context11.next = 20;
                    break;
                  }

                  _r15 = _step82.value;
                  _context11.t0 = n === o;

                  if (!_context11.t0) {
                    _context11.next = 14;
                    break;
                  }

                  _context11.next = 14;
                  return this._getBlockFiller(t);

                case 14:
                  _context11.next = 16;
                  return this.viewToDom(_r15, t, i);

                case 16:
                  o++;

                case 17:
                  _iteratorNormalCompletion82 = true;
                  _context11.next = 8;
                  break;

                case 20:
                  _context11.next = 26;
                  break;

                case 22:
                  _context11.prev = 22;
                  _context11.t1 = _context11["catch"](6);
                  _didIteratorError82 = true;
                  _iteratorError82 = _context11.t1;

                case 26:
                  _context11.prev = 26;
                  _context11.prev = 27;

                  if (!_iteratorNormalCompletion82 && _iterator82.return != null) {
                    _iterator82.return();
                  }

                case 29:
                  _context11.prev = 29;

                  if (!_didIteratorError82) {
                    _context11.next = 32;
                    break;
                  }

                  throw _iteratorError82;

                case 32:
                  return _context11.finish(29);

                case 33:
                  return _context11.finish(26);

                case 34:
                  _context11.t2 = n === o;

                  if (!_context11.t2) {
                    _context11.next = 38;
                    break;
                  }

                  _context11.next = 38;
                  return this._getBlockFiller(t);

                case 38:
                case "end":
                  return _context11.stop();
              }
            }
          }, viewChildrenToDom, this, [[6, 22, 26, 34], [27,, 29, 33]]);
        })
      }, {
        key: "viewRangeToDom",
        value: function viewRangeToDom(e) {
          var t = this.viewPositionToDom(e.start),
              i = this.viewPositionToDom(e.end),
              n = document.createRange();
          return n.setStart(t.parent, t.offset), n.setEnd(i.parent, i.offset), n;
        }
      }, {
        key: "viewPositionToDom",
        value: function viewPositionToDom(e) {
          var t = e.parent;

          if (t.is("$text")) {
            var _i66 = this.findCorrespondingDomText(t);

            if (!_i66) return null;
            var _n28 = e.offset;
            return sr(_i66) && (_n28 += 7), {
              parent: _i66,
              offset: _n28
            };
          }

          {
            var _i67, _n29, _o23;

            if (0 === e.offset) {
              if (_i67 = this.mapViewToDom(t), !_i67) return null;
              _o23 = _i67.childNodes[0];
            } else {
              var _t62 = e.nodeBefore;
              if (_n29 = _t62.is("$text") ? this.findCorrespondingDomText(_t62) : this.mapViewToDom(e.nodeBefore), !_n29) return null;
              _i67 = _n29.parentNode, _o23 = _n29.nextSibling;
            }

            if (tr(_o23) && sr(_o23)) return {
              parent: _o23,
              offset: 7
            };
            return {
              parent: _i67,
              offset: _n29 ? yr(_n29) + 1 : 0
            };
          }
        }
      }, {
        key: "domToView",
        value: function domToView(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          if (this.isBlockFiller(e)) return null;
          var i = this.getHostViewElement(e);
          if (i) return i;

          if (tr(e)) {
            if (ar(e)) return null;
            {
              var _t63 = this._processDataFromDomText(e);

              return "" === _t63 ? null : new hn(this.document, _t63);
            }
          }

          if (this.isComment(e)) return null;
          {
            if (this.mapDomToView(e)) return this.mapDomToView(e);

            var _i68;

            if (this.isDocumentFragment(e)) _i68 = new Wo(this.document), t.bind && this.bindDocumentFragments(e, _i68);else {
              var _n30 = t.keepOriginalCase ? e.tagName : e.tagName.toLowerCase();

              _i68 = new eo(this.document, _n30), t.bind && this.bindElements(e, _i68);
              var _o24 = e.attributes;

              for (var _e52 = _o24.length - 1; _e52 >= 0; _e52--) {
                _i68._setAttribute(_o24[_e52].name, _o24[_e52].value);
              }

              if (!1 !== t.withChildren && this._rawContentElementMatcher.match(_i68)) return _i68._setCustomProperty("$rawContent", e.innerHTML), this._encounteredRawContentDomNodes.add(e), _i68;
            }

            if (!1 !== t.withChildren) {
              var _iteratorNormalCompletion83 = true;
              var _didIteratorError83 = false;
              var _iteratorError83 = undefined;

              try {
                for (var _iterator83 = this.domChildrenToView(e, t)[Symbol.iterator](), _step83; !(_iteratorNormalCompletion83 = (_step83 = _iterator83.next()).done); _iteratorNormalCompletion83 = true) {
                  var _n31 = _step83.value;

                  _i68._appendChild(_n31);
                }
              } catch (err) {
                _didIteratorError83 = true;
                _iteratorError83 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion83 && _iterator83.return != null) {
                    _iterator83.return();
                  }
                } finally {
                  if (_didIteratorError83) {
                    throw _iteratorError83;
                  }
                }
              }
            }

            return _i68;
          }
        }
      }, {
        key: "domChildrenToView",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function domChildrenToView(e) {
          var t,
              _i69,
              _n32,
              _o25,
              _args12 = arguments;

          return _regeneratorRuntime.wrap(function domChildrenToView$(_context12) {
            while (1) {
              switch (_context12.prev = _context12.next) {
                case 0:
                  t = _args12.length > 1 && _args12[1] !== undefined ? _args12[1] : {};
                  _i69 = 0;

                case 2:
                  if (!(_i69 < e.childNodes.length)) {
                    _context12.next = 11;
                    break;
                  }

                  _n32 = e.childNodes[_i69], _o25 = this.domToView(_n32, t);
                  _context12.t0 = null !== _o25;

                  if (!_context12.t0) {
                    _context12.next = 8;
                    break;
                  }

                  _context12.next = 8;
                  return _o25;

                case 8:
                  _i69++;
                  _context12.next = 2;
                  break;

                case 11:
                case "end":
                  return _context12.stop();
              }
            }
          }, domChildrenToView, this);
        })
      }, {
        key: "domSelectionToView",
        value: function domSelectionToView(e) {
          if (1 === e.rangeCount) {
            var _t64 = e.getRangeAt(0).startContainer;
            tr(_t64) && (_t64 = _t64.parentNode);

            var _i70 = this.fakeSelectionToView(_t64);

            if (_i70) return _i70;
          }

          var t = this.isDomSelectionBackward(e),
              i = [];

          for (var _t65 = 0; _t65 < e.rangeCount; _t65++) {
            var _n33 = e.getRangeAt(_t65),
                _o26 = this.domRangeToView(_n33);

            _o26 && i.push(_o26);
          }

          return new go(i, {
            backward: t
          });
        }
      }, {
        key: "domRangeToView",
        value: function domRangeToView(e) {
          var t = this.domPositionToView(e.startContainer, e.startOffset),
              i = this.domPositionToView(e.endContainer, e.endOffset);
          return t && i ? new lo(t, i) : null;
        }
      }, {
        key: "domPositionToView",
        value: function domPositionToView(e, t) {
          if (this.isBlockFiller(e)) return this.domPositionToView(e.parentNode, yr(e));
          var i = this.mapDomToView(e);
          if (i && (i.is("uiElement") || i.is("rawElement"))) return co._createBefore(i);

          if (tr(e)) {
            if (ar(e)) return this.domPositionToView(e.parentNode, yr(e));

            var _i71 = this.findCorrespondingViewText(e);

            var _n34 = t;
            return _i71 ? (sr(e) && (_n34 -= 7, _n34 = _n34 < 0 ? 0 : _n34), new co(_i71, _n34)) : null;
          }

          if (0 === t) {
            var _t66 = this.mapDomToView(e);

            if (_t66) return new co(_t66, 0);
          } else {
            var _i72 = e.childNodes[t - 1],
                _n35 = tr(_i72) ? this.findCorrespondingViewText(_i72) : this.mapDomToView(_i72);

            if (_n35 && _n35.parent) return new co(_n35.parent, _n35.index + 1);
          }

          return null;
        }
      }, {
        key: "mapDomToView",
        value: function mapDomToView(e) {
          return this.getHostViewElement(e) || this._domToViewMapping.get(e);
        }
      }, {
        key: "findCorrespondingViewText",
        value: function findCorrespondingViewText(e) {
          if (ar(e)) return null;
          var t = this.getHostViewElement(e);
          if (t) return t;
          var i = e.previousSibling;

          if (i) {
            if (!this.isElement(i)) return null;

            var _e53 = this.mapDomToView(i);

            if (_e53) {
              return _e53.nextSibling instanceof hn ? _e53.nextSibling : null;
            }
          } else {
            var _t67 = this.mapDomToView(e.parentNode);

            if (_t67) {
              var _e54 = _t67.getChild(0);

              return _e54 instanceof hn ? _e54 : null;
            }
          }

          return null;
        }
      }, {
        key: "mapViewToDom",
        value: function mapViewToDom(e) {
          return this._viewToDomMapping.get(e);
        }
      }, {
        key: "findCorrespondingDomText",
        value: function findCorrespondingDomText(e) {
          var t = e.previousSibling;
          return t && this.mapViewToDom(t) ? this.mapViewToDom(t).nextSibling : !t && e.parent && this.mapViewToDom(e.parent) ? this.mapViewToDom(e.parent).childNodes[0] : null;
        }
      }, {
        key: "focus",
        value: function focus(e) {
          var t = this.mapViewToDom(e);

          if (t && t.ownerDocument.activeElement !== t) {
            var _vr$window = vr.window,
                _e55 = _vr$window.scrollX,
                _i73 = _vr$window.scrollY,
                _n36 = [];
            Ir(t, function (e) {
              var t = e.scrollLeft,
                  i = e.scrollTop;

              _n36.push([t, i]);
            }), t.focus(), Ir(t, function (e) {
              var _n36$shift = _n36.shift(),
                  _n36$shift2 = _slicedToArray(_n36$shift, 2),
                  t = _n36$shift2[0],
                  i = _n36$shift2[1];

              e.scrollLeft = t, e.scrollTop = i;
            }), vr.window.scrollTo(_e55, _i73);
          }
        }
      }, {
        key: "isElement",
        value: function isElement(e) {
          return e && e.nodeType == Node.ELEMENT_NODE;
        }
      }, {
        key: "isDocumentFragment",
        value: function isDocumentFragment(e) {
          return e && e.nodeType == Node.DOCUMENT_FRAGMENT_NODE;
        }
      }, {
        key: "isComment",
        value: function isComment(e) {
          return e && e.nodeType == Node.COMMENT_NODE;
        }
      }, {
        key: "isBlockFiller",
        value: function isBlockFiller(e) {
          return "br" == this.blockFillerMode ? e.isEqualNode(Ar) : !("BR" !== e.tagName || !Pr(e, this.blockElements) || 1 !== e.parentNode.childNodes.length) || e.isEqualNode(Tr) || function (e, t) {
            return e.isEqualNode(Cr) && Pr(e, t) && 1 === e.parentNode.childNodes.length;
          }(e, this.blockElements);
        }
      }, {
        key: "isDomSelectionBackward",
        value: function isDomSelectionBackward(e) {
          if (e.isCollapsed) return !1;
          var t = document.createRange();
          t.setStart(e.anchorNode, e.anchorOffset), t.setEnd(e.focusNode, e.focusOffset);
          var i = t.collapsed;
          return t.detach(), i;
        }
      }, {
        key: "getHostViewElement",
        value: function getHostViewElement(e) {
          var t = xr(e);

          for (t.pop(); t.length;) {
            var _e56 = t.pop(),
                _i74 = this._domToViewMapping.get(_e56);

            if (_i74 && (_i74.is("uiElement") || _i74.is("rawElement"))) return _i74;
          }

          return null;
        }
      }, {
        key: "isDomSelectionCorrect",
        value: function isDomSelectionCorrect(e) {
          return this._isDomSelectionPositionCorrect(e.anchorNode, e.anchorOffset) && this._isDomSelectionPositionCorrect(e.focusNode, e.focusOffset);
        }
      }, {
        key: "registerRawContentMatcher",
        value: function registerRawContentMatcher(e) {
          this._rawContentElementMatcher.add(e);
        }
      }, {
        key: "_getBlockFiller",
        value: function _getBlockFiller(e) {
          switch (this.blockFillerMode) {
            case "nbsp":
              return ir(e);

            case "markedNbsp":
              return nr(e);

            case "br":
              return or(e);
          }
        }
      }, {
        key: "_isDomSelectionPositionCorrect",
        value: function _isDomSelectionPositionCorrect(e, t) {
          if (tr(e) && sr(e) && t < 7) return !1;
          if (this.isElement(e) && sr(e.childNodes[t])) return !1;
          var i = this.mapDomToView(e);
          return !i || !i.is("uiElement") && !i.is("rawElement");
        }
      }, {
        key: "_processDataFromViewText",
        value: function _processDataFromViewText(e) {
          var _this28 = this;

          var t = e.data;
          if (e.getAncestors().some(function (e) {
            return _this28.preElements.includes(e.name);
          })) return t;

          if (" " == t.charAt(0)) {
            var _i75 = this._getTouchingViewTextNode(e, !1);

            !(_i75 && this._nodeEndsWithSpace(_i75)) && _i75 || (t = " " + t.substr(1));
          }

          if (" " == t.charAt(t.length - 1)) {
            var _i76 = this._getTouchingViewTextNode(e, !0);

            " " != t.charAt(t.length - 2) && _i76 && " " != _i76.data.charAt(0) || (t = t.substr(0, t.length - 1) + " ");
          }

          return t.replace(/ {2}/g, "  ");
        }
      }, {
        key: "_nodeEndsWithSpace",
        value: function _nodeEndsWithSpace(e) {
          var _this29 = this;

          if (e.getAncestors().some(function (e) {
            return _this29.preElements.includes(e.name);
          })) return !1;

          var t = this._processDataFromViewText(e);

          return " " == t.charAt(t.length - 1);
        }
      }, {
        key: "_processDataFromDomText",
        value: function _processDataFromDomText(e) {
          var t = e.data;
          if (Sr(e, this.preElements)) return cr(e);
          t = t.replace(/[ \n\t\r]{1,}/g, " ");

          var i = this._getTouchingInlineDomNode(e, !1),
              n = this._getTouchingInlineDomNode(e, !0),
              o = this._checkShouldLeftTrimDomText(e, i),
              r = this._checkShouldRightTrimDomText(e, n);

          return o && (t = t.replace(/^ /, "")), r && (t = t.replace(/ $/, "")), t = cr(new Text(t)), t = t.replace(/ \u00A0/g, "  "), (/( |\u00A0)\u00A0$/.test(t) || !n || n.data && " " == n.data.charAt(0)) && (t = t.replace(/\u00A0$/, " ")), o && (t = t.replace(/^\u00A0/, " ")), t;
        }
      }, {
        key: "_checkShouldLeftTrimDomText",
        value: function _checkShouldLeftTrimDomText(e, t) {
          return !t || !!Yi(t) || !this._encounteredRawContentDomNodes.has(e.previousSibling) && /[^\S\u00A0]/.test(t.data.charAt(t.data.length - 1));
        }
      }, {
        key: "_checkShouldRightTrimDomText",
        value: function _checkShouldRightTrimDomText(e, t) {
          return !t && !sr(e);
        }
      }, {
        key: "_getTouchingViewTextNode",
        value: function _getTouchingViewTextNode(e, t) {
          var i = new ao({
            startPosition: t ? co._createAfter(e) : co._createBefore(e),
            direction: t ? "forward" : "backward"
          });
          var _iteratorNormalCompletion84 = true;
          var _didIteratorError84 = false;
          var _iteratorError84 = undefined;

          try {
            for (var _iterator84 = i[Symbol.iterator](), _step84; !(_iteratorNormalCompletion84 = (_step84 = _iterator84.next()).done); _iteratorNormalCompletion84 = true) {
              var _e57 = _step84.value;
              if (_e57.item.is("containerElement")) return null;
              if (_e57.item.is("element", "br")) return null;
              if (_e57.item.is("$textProxy")) return _e57.item;
            }
          } catch (err) {
            _didIteratorError84 = true;
            _iteratorError84 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion84 && _iterator84.return != null) {
                _iterator84.return();
              }
            } finally {
              if (_didIteratorError84) {
                throw _iteratorError84;
              }
            }
          }

          return null;
        }
      }, {
        key: "_getTouchingInlineDomNode",
        value: function _getTouchingInlineDomNode(e, t) {
          if (!e.parentNode) return null;
          var i = t ? "nextNode" : "previousNode",
              n = e.ownerDocument,
              o = xr(e)[0],
              r = n.createTreeWalker(o, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT, {
            acceptNode: function acceptNode(e) {
              return tr(e) || "BR" == e.tagName ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
            }
          });
          r.currentNode = e;
          var s = r[i]();

          if (null !== s) {
            var _t68 = function (e, t) {
              var i = xr(e),
                  n = xr(t);
              var o = 0;

              for (; i[o] == n[o] && i[o];) {
                o++;
              }

              return 0 === o ? null : i[o - 1];
            }(e, s);

            if (_t68 && !Sr(e, this.blockElements, _t68) && !Sr(s, this.blockElements, _t68)) return s;
          }

          return null;
        }
      }]);

      return Er;
    }();

    function Sr(e, t, i) {
      var n = xr(e);
      return i && (n = n.slice(n.indexOf(i) + 1)), n.some(function (e) {
        return e.tagName && t.includes(e.tagName.toLowerCase());
      });
    }

    function Ir(e, t) {
      for (; e && e != vr.document;) {
        t(e), e = e.parentNode;
      }
    }

    function Pr(e, t) {
      var i = e.parentNode;
      return i && i.tagName && t.includes(i.tagName.toLowerCase());
    }

    function Mr(e) {
      var t = Object.prototype.toString.apply(e);
      return "[object Window]" == t || "[object global]" == t;
    }

    var Nr = De({}, h, {
      listenTo: function listenTo(e) {
        var _h$listenTo;

        for (var _len18 = arguments.length, t = new Array(_len18 > 1 ? _len18 - 1 : 0), _key18 = 1; _key18 < _len18; _key18++) {
          t[_key18 - 1] = arguments[_key18];
        }

        if (pr(e) || Mr(e)) {
          var _i77 = this._getProxyEmitter(e) || new Rr(e);

          _i77.attach.apply(_i77, t), e = _i77;
        }

        (_h$listenTo = h.listenTo).call.apply(_h$listenTo, [this, e].concat(t));
      },
      stopListening: function stopListening(e, t, i) {
        if (pr(e) || Mr(e)) {
          var _t69 = this._getProxyEmitter(e);

          if (!_t69) return;
          e = _t69;
        }

        h.stopListening.call(this, e, t, i), e instanceof Rr && e.detach(t);
      },
      _getProxyEmitter: function _getProxyEmitter(e) {
        return t = this, i = Or(e), t[l] && t[l][i] ? t[l][i].emitter : null;
        var t, i;
      }
    });

    var Rr = function Rr(e) {
      _classCallCheck(this, Rr);

      u(this, Or(e)), this._domNode = e;
    };

    function Or(e) {
      return e["data-ck-expando"] || (e["data-ck-expando"] = s());
    }

    De(Rr.prototype, h, {
      attach: function attach(e, t) {
        var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        if (this._domListeners && this._domListeners[e]) return;

        var n = {
          capture: !!i.useCapture,
          passive: !!i.usePassive
        },
            o = this._createDomListener(e, n);

        this._domNode.addEventListener(e, o, n), this._domListeners || (this._domListeners = {}), this._domListeners[e] = o;
      },
      detach: function detach(e) {
        var t;
        !this._domListeners[e] || (t = this._events[e]) && t.callbacks.length || this._domListeners[e].removeListener();
      },
      _createDomListener: function _createDomListener(e, t) {
        var _this30 = this;

        var i = function i(t) {
          _this30.fire(e, t);
        };

        return i.removeListener = function () {
          _this30._domNode.removeEventListener(e, i, t), delete _this30._domListeners[e];
        }, i;
      }
    });

    var zr =
    /*#__PURE__*/
    function () {
      function zr(e) {
        _classCallCheck(this, zr);

        this.view = e, this.document = e.document, this.isEnabled = !1;
      }

      _createClass(zr, [{
        key: "enable",
        value: function enable() {
          this.isEnabled = !0;
        }
      }, {
        key: "disable",
        value: function disable() {
          this.isEnabled = !1;
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.disable(), this.stopListening();
        }
      }, {
        key: "checkShouldIgnoreEventFromTarget",
        value: function checkShouldIgnoreEventFromTarget(e) {
          return e && 3 === e.nodeType && (e = e.parentNode), !(!e || 1 !== e.nodeType) && e.matches("[data-cke-ignore-events], [data-cke-ignore-events] *");
        }
      }]);

      return zr;
    }();

    Ke(zr, Nr);

    var Dr = function Dr(e) {
      return this.__data__.set(e, "__lodash_hash_undefined__"), this;
    };

    var Lr = function Lr(e) {
      return this.__data__.has(e);
    };

    function Vr(e) {
      var t = -1,
          i = null == e ? 0 : e.length;

      for (this.__data__ = new Ft(); ++t < i;) {
        this.add(e[t]);
      }
    }

    Vr.prototype.add = Vr.prototype.push = Dr, Vr.prototype.has = Lr;
    var jr = Vr;

    var Br = function Br(e, t) {
      for (var i = -1, n = null == e ? 0 : e.length; ++i < n;) {
        if (t(e[i], i, e)) return !0;
      }

      return !1;
    };

    var Fr = function Fr(e, t) {
      return e.has(t);
    };

    var Hr = function Hr(e, t, i, n, o, r) {
      var s = 1 & i,
          a = e.length,
          c = t.length;
      if (a != c && !(s && c > a)) return !1;
      var l = r.get(e),
          d = r.get(t);
      if (l && d) return l == t && d == e;
      var h = -1,
          u = !0,
          g = 2 & i ? new jr() : void 0;

      for (r.set(e, t), r.set(t, e); ++h < a;) {
        var m = e[h],
            f = t[h];
        if (n) var p = s ? n(f, m, h, t, e, r) : n(m, f, h, e, t, r);

        if (void 0 !== p) {
          if (p) continue;
          u = !1;
          break;
        }

        if (g) {
          if (!Br(t, function (e, t) {
            if (!Fr(g, t) && (m === e || o(m, e, i, n, r))) return g.push(t);
          })) {
            u = !1;
            break;
          }
        } else if (m !== f && !o(m, f, i, n, r)) {
          u = !1;
          break;
        }
      }

      return r.delete(e), r.delete(t), u;
    };

    var Ur = function Ur(e) {
      var t = -1,
          i = Array(e.size);
      return e.forEach(function (e, n) {
        i[++t] = [n, e];
      }), i;
    };

    var Wr = function Wr(e) {
      var t = -1,
          i = Array(e.size);
      return e.forEach(function (e) {
        i[++t] = e;
      }), i;
    },
        qr = _ ? _.prototype : void 0,
        $r = qr ? qr.valueOf : void 0;

    var Yr = function Yr(e, t, i, n, o, r, s) {
      switch (i) {
        case "[object DataView]":
          if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
          e = e.buffer, t = t.buffer;

        case "[object ArrayBuffer]":
          return !(e.byteLength != t.byteLength || !r(new Ci(e), new Ci(t)));

        case "[object Boolean]":
        case "[object Date]":
        case "[object Number]":
          return G(+e, +t);

        case "[object Error]":
          return e.name == t.name && e.message == t.message;

        case "[object RegExp]":
        case "[object String]":
          return e == t + "";

        case "[object Map]":
          var a = Ur;

        case "[object Set]":
          var c = 1 & n;
          if (a || (a = Wr), e.size != t.size && !c) return !1;
          var l = s.get(e);
          if (l) return l == t;
          n |= 2, s.set(e, t);
          var d = Hr(a(e), a(t), n, o, r, s);
          return s.delete(e), d;

        case "[object Symbol]":
          if ($r) return $r.call(e) == $r.call(t);
      }

      return !1;
    },
        Gr = Object.prototype.hasOwnProperty;

    var Kr = function Kr(e, t, i, n, o, r) {
      var s = 1 & i,
          a = di(e),
          c = a.length;
      if (c != di(t).length && !s) return !1;

      for (var l = c; l--;) {
        var d = a[l];
        if (!(s ? d in t : Gr.call(t, d))) return !1;
      }

      var h = r.get(e),
          u = r.get(t);
      if (h && u) return h == t && u == e;
      var g = !0;
      r.set(e, t), r.set(t, e);

      for (var m = s; ++l < c;) {
        var f = e[d = a[l]],
            p = t[d];
        if (n) var b = s ? n(p, f, d, t, e, r) : n(f, p, d, e, t, r);

        if (!(void 0 === b ? f === p || o(f, p, i, n, r) : b)) {
          g = !1;
          break;
        }

        m || (m = "constructor" == d);
      }

      if (g && !m) {
        var w = e.constructor,
            k = t.constructor;
        w == k || !("constructor" in e) || !("constructor" in t) || "function" == typeof w && w instanceof w && "function" == typeof k && k instanceof k || (g = !1);
      }

      return r.delete(e), r.delete(t), g;
    },
        Qr = Object.prototype.hasOwnProperty;

    var Jr = function Jr(e, t, i, n, o, r) {
      var s = _e(e),
          a = _e(t),
          c = s ? "[object Array]" : yi(e),
          l = a ? "[object Array]" : yi(t),
          d = "[object Object]" == (c = "[object Arguments]" == c ? "[object Object]" : c),
          h = "[object Object]" == (l = "[object Arguments]" == l ? "[object Object]" : l),
          u = c == l;

      if (u && Object(ve.a)(e)) {
        if (!Object(ve.a)(t)) return !1;
        s = !0, d = !1;
      }

      if (u && !d) return r || (r = new Wt()), s || Ee(e) ? Hr(e, t, i, n, o, r) : Yr(e, t, c, i, n, o, r);

      if (!(1 & i)) {
        var g = d && Qr.call(e, "__wrapped__"),
            m = h && Qr.call(t, "__wrapped__");

        if (g || m) {
          var f = g ? e.value() : e,
              p = m ? t.value() : t;
          return r || (r = new Wt()), o(f, p, i, n, r);
        }
      }

      return !!u && (r || (r = new Wt()), Kr(e, t, i, n, o, r));
    };

    var Zr = function e(t, i, n, o, r) {
      return t === i || (null == t || null == i || !me(t) && !me(i) ? t != t && i != i : Jr(t, i, n, o, e, r));
    };

    var Xr = function Xr(e, t, i) {
      var n = (i = "function" == typeof i ? i : void 0) ? i(e, t) : void 0;
      return void 0 === n ? Zr(e, t, void 0, i) : !!n;
    };

    var es =
    /*#__PURE__*/
    function (_zr) {
      _inherits(es, _zr);

      function es(e) {
        var _this31;

        _classCallCheck(this, es);

        _this31 = _possibleConstructorReturn(this, _getPrototypeOf(es).call(this, e)), _this31._config = {
          childList: !0,
          characterData: !0,
          characterDataOldValue: !0,
          subtree: !0
        }, _this31.domConverter = e.domConverter, _this31.renderer = e._renderer, _this31._domElements = [], _this31._mutationObserver = new window.MutationObserver(_this31._onMutations.bind(_assertThisInitialized(_this31)));
        return _this31;
      }

      _createClass(es, [{
        key: "flush",
        value: function flush() {
          this._onMutations(this._mutationObserver.takeRecords());
        }
      }, {
        key: "observe",
        value: function observe(e) {
          this._domElements.push(e), this.isEnabled && this._mutationObserver.observe(e, this._config);
        }
      }, {
        key: "enable",
        value: function enable() {
          _get(_getPrototypeOf(es.prototype), "enable", this).call(this);

          var _iteratorNormalCompletion85 = true;
          var _didIteratorError85 = false;
          var _iteratorError85 = undefined;

          try {
            for (var _iterator85 = this._domElements[Symbol.iterator](), _step85; !(_iteratorNormalCompletion85 = (_step85 = _iterator85.next()).done); _iteratorNormalCompletion85 = true) {
              var _e58 = _step85.value;

              this._mutationObserver.observe(_e58, this._config);
            }
          } catch (err) {
            _didIteratorError85 = true;
            _iteratorError85 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion85 && _iterator85.return != null) {
                _iterator85.return();
              }
            } finally {
              if (_didIteratorError85) {
                throw _iteratorError85;
              }
            }
          }
        }
      }, {
        key: "disable",
        value: function disable() {
          _get(_getPrototypeOf(es.prototype), "disable", this).call(this), this._mutationObserver.disconnect();
        }
      }, {
        key: "destroy",
        value: function destroy() {
          _get(_getPrototypeOf(es.prototype), "destroy", this).call(this), this._mutationObserver.disconnect();
        }
      }, {
        key: "_onMutations",
        value: function _onMutations(e) {
          if (0 === e.length) return;
          var t = this.domConverter,
              i = new Map(),
              n = new Set();
          var _iteratorNormalCompletion86 = true;
          var _didIteratorError86 = false;
          var _iteratorError86 = undefined;

          try {
            for (var _iterator86 = e[Symbol.iterator](), _step86; !(_iteratorNormalCompletion86 = (_step86 = _iterator86.next()).done); _iteratorNormalCompletion86 = true) {
              var _i79 = _step86.value;

              if ("childList" === _i79.type) {
                var _e60 = t.mapDomToView(_i79.target);

                if (_e60 && (_e60.is("uiElement") || _e60.is("rawElement"))) continue;
                _e60 && !this._isBogusBrMutation(_i79) && n.add(_e60);
              }
            }
          } catch (err) {
            _didIteratorError86 = true;
            _iteratorError86 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion86 && _iterator86.return != null) {
                _iterator86.return();
              }
            } finally {
              if (_didIteratorError86) {
                throw _iteratorError86;
              }
            }
          }

          var _iteratorNormalCompletion87 = true;
          var _didIteratorError87 = false;
          var _iteratorError87 = undefined;

          try {
            for (var _iterator87 = e[Symbol.iterator](), _step87; !(_iteratorNormalCompletion87 = (_step87 = _iterator87.next()).done); _iteratorNormalCompletion87 = true) {
              var _o27 = _step87.value;

              var _e61 = t.mapDomToView(_o27.target);

              if ((!_e61 || !_e61.is("uiElement") && !_e61.is("rawElement")) && "characterData" === _o27.type) {
                var _e62 = t.findCorrespondingViewText(_o27.target);

                _e62 && !n.has(_e62.parent) ? i.set(_e62, {
                  type: "text",
                  oldText: _e62.data,
                  newText: cr(_o27.target),
                  node: _e62
                }) : !_e62 && sr(_o27.target) && n.add(t.mapDomToView(_o27.target.parentNode));
              }
            }
          } catch (err) {
            _didIteratorError87 = true;
            _iteratorError87 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion87 && _iterator87.return != null) {
                _iterator87.return();
              }
            } finally {
              if (_didIteratorError87) {
                throw _iteratorError87;
              }
            }
          }

          var o = [];
          var _iteratorNormalCompletion88 = true;
          var _didIteratorError88 = false;
          var _iteratorError88 = undefined;

          try {
            for (var _iterator88 = i.values()[Symbol.iterator](), _step88; !(_iteratorNormalCompletion88 = (_step88 = _iterator88.next()).done); _iteratorNormalCompletion88 = true) {
              var _e63 = _step88.value;
              this.renderer.markToSync("text", _e63.node), o.push(_e63);
            }
          } catch (err) {
            _didIteratorError88 = true;
            _iteratorError88 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion88 && _iterator88.return != null) {
                _iterator88.return();
              }
            } finally {
              if (_didIteratorError88) {
                throw _iteratorError88;
              }
            }
          }

          var _iteratorNormalCompletion89 = true;
          var _didIteratorError89 = false;
          var _iteratorError89 = undefined;

          try {
            for (var _iterator89 = n[Symbol.iterator](), _step89; !(_iteratorNormalCompletion89 = (_step89 = _iterator89.next()).done); _iteratorNormalCompletion89 = true) {
              var _e64 = _step89.value;

              var _i80 = t.mapViewToDom(_e64),
                  _n37 = Array.from(_e64.getChildren()),
                  _r16 = Array.from(t.domChildrenToView(_i80, {
                withChildren: !1
              }));

              Xr(_n37, _r16, a) || (this.renderer.markToSync("children", _e64), o.push({
                type: "children",
                oldChildren: _n37,
                newChildren: _r16,
                node: _e64
              }));
            }
          } catch (err) {
            _didIteratorError89 = true;
            _iteratorError89 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion89 && _iterator89.return != null) {
                _iterator89.return();
              }
            } finally {
              if (_didIteratorError89) {
                throw _iteratorError89;
              }
            }
          }

          var r = e[0].target.ownerDocument.getSelection();
          var s = null;

          if (r && r.anchorNode) {
            var _e59 = t.domPositionToView(r.anchorNode, r.anchorOffset),
                _i78 = t.domPositionToView(r.focusNode, r.focusOffset);

            _e59 && _i78 && (s = new go(_e59), s.setFocus(_i78));
          }

          function a(e, t) {
            if (!Array.isArray(e)) return e === t || !(!e.is("$text") || !t.is("$text")) && e.data === t.data;
          }

          o.length && (this.document.fire("mutations", o, s), this.view.forceRender());
        }
      }, {
        key: "_isBogusBrMutation",
        value: function _isBogusBrMutation(e) {
          var t = null;
          return null === e.nextSibling && 0 === e.removedNodes.length && 1 == e.addedNodes.length && (t = this.domConverter.domToView(e.addedNodes[0], {
            withChildren: !1
          })), t && t.is("element", "br");
        }
      }]);

      return es;
    }(zr);

    var ts =
    /*#__PURE__*/
    function () {
      function ts(e, t, i) {
        _classCallCheck(this, ts);

        this.view = e, this.document = e.document, this.domEvent = t, this.domTarget = t.target, De(this, i);
      }

      _createClass(ts, [{
        key: "preventDefault",
        value: function preventDefault() {
          this.domEvent.preventDefault();
        }
      }, {
        key: "stopPropagation",
        value: function stopPropagation() {
          this.domEvent.stopPropagation();
        }
      }, {
        key: "target",
        get: function get() {
          return this.view.domConverter.mapDomToView(this.domTarget);
        }
      }]);

      return ts;
    }();

    var is =
    /*#__PURE__*/
    function (_zr2) {
      _inherits(is, _zr2);

      function is(e) {
        var _this32;

        _classCallCheck(this, is);

        _this32 = _possibleConstructorReturn(this, _getPrototypeOf(is).call(this, e)), _this32.useCapture = !1;
        return _this32;
      }

      _createClass(is, [{
        key: "observe",
        value: function observe(e) {
          var _this33 = this;

          ("string" == typeof this.domEventType ? [this.domEventType] : this.domEventType).forEach(function (t) {
            _this33.listenTo(e, t, function (e, t) {
              _this33.isEnabled && !_this33.checkShouldIgnoreEventFromTarget(t.target) && _this33.onDomEvent(t);
            }, {
              useCapture: _this33.useCapture
            });
          });
        }
      }, {
        key: "fire",
        value: function fire(e, t, i) {
          this.isEnabled && this.document.fire(e, new ts(this.view, t, i));
        }
      }]);

      return is;
    }(zr);

    var ns =
    /*#__PURE__*/
    function (_is) {
      _inherits(ns, _is);

      function ns(e) {
        var _this34;

        _classCallCheck(this, ns);

        _this34 = _possibleConstructorReturn(this, _getPrototypeOf(ns).call(this, e)), _this34.domEventType = ["keydown", "keyup"];
        return _this34;
      }

      _createClass(ns, [{
        key: "onDomEvent",
        value: function onDomEvent(e) {
          this.fire(e.type, e, {
            keyCode: e.keyCode,
            altKey: e.altKey,
            ctrlKey: e.ctrlKey,
            shiftKey: e.shiftKey,
            metaKey: e.metaKey,

            get keystroke() {
              return Oo(this);
            }

          });
        }
      }]);

      return ns;
    }(is);

    var os = function os() {
      return k.a.Date.now();
    },
        rs = /\s/;

    var ss = function ss(e) {
      for (var t = e.length; t-- && rs.test(e.charAt(t));) {
        ;
      }

      return t;
    },
        as = /^\s+/;

    var cs = function cs(e) {
      return e ? e.slice(0, ss(e) + 1).replace(as, "") : e;
    },
        ls = /^[-+]0x[0-9a-f]+$/i,
        ds = /^0b[01]+$/i,
        hs = /^0o[0-7]+$/i,
        us = parseInt;

    var gs = function gs(e) {
      if ("number" == typeof e) return e;
      if (bn(e)) return NaN;

      if (w(e)) {
        var t = "function" == typeof e.valueOf ? e.valueOf() : e;
        e = w(t) ? t + "" : t;
      }

      if ("string" != typeof e) return 0 === e ? e : +e;
      e = cs(e);
      var i = ds.test(e);
      return i || hs.test(e) ? us(e.slice(2), i ? 2 : 8) : ls.test(e) ? NaN : +e;
    },
        ms = Math.max,
        fs = Math.min;

    var ps = function ps(e, t, i) {
      var n,
          o,
          r,
          s,
          a,
          c,
          l = 0,
          d = !1,
          h = !1,
          u = !0;
      if ("function" != typeof e) throw new TypeError("Expected a function");

      function g(t) {
        var i = n,
            r = o;
        return n = o = void 0, l = t, s = e.apply(r, i);
      }

      function m(e) {
        return l = e, a = setTimeout(p, t), d ? g(e) : s;
      }

      function f(e) {
        var i = e - c;
        return void 0 === c || i >= t || i < 0 || h && e - l >= r;
      }

      function p() {
        var e = os();
        if (f(e)) return b(e);
        a = setTimeout(p, function (e) {
          var i = t - (e - c);
          return h ? fs(i, r - (e - l)) : i;
        }(e));
      }

      function b(e) {
        return a = void 0, u && n ? g(e) : (n = o = void 0, s);
      }

      function k() {
        var e = os(),
            i = f(e);

        if (n = arguments, o = this, c = e, i) {
          if (void 0 === a) return m(c);
          if (h) return clearTimeout(a), a = setTimeout(p, t), g(c);
        }

        return void 0 === a && (a = setTimeout(p, t)), s;
      }

      return t = gs(t) || 0, w(i) && (d = !!i.leading, r = (h = "maxWait" in i) ? ms(gs(i.maxWait) || 0, t) : r, u = "trailing" in i ? !!i.trailing : u), k.cancel = function () {
        void 0 !== a && clearTimeout(a), l = 0, n = c = o = a = void 0;
      }, k.flush = function () {
        return void 0 === a ? s : b(os());
      }, k;
    };

    var bs =
    /*#__PURE__*/
    function (_zr3) {
      _inherits(bs, _zr3);

      function bs(e) {
        var _this35;

        _classCallCheck(this, bs);

        _this35 = _possibleConstructorReturn(this, _getPrototypeOf(bs).call(this, e)), _this35._fireSelectionChangeDoneDebounced = ps(function (e) {
          return _this35.document.fire("selectionChangeDone", e);
        }, 200);
        return _this35;
      }

      _createClass(bs, [{
        key: "observe",
        value: function observe() {
          var _this36 = this;

          var e = this.document;
          e.on("arrowKey", function (t, i) {
            e.selection.isFake && _this36.isEnabled && i.preventDefault();
          }, {
            context: "$capture"
          }), e.on("arrowKey", function (t, i) {
            e.selection.isFake && _this36.isEnabled && _this36._handleSelectionMove(i.keyCode);
          }, {
            priority: "lowest"
          });
        }
      }, {
        key: "destroy",
        value: function destroy() {
          _get(_getPrototypeOf(bs.prototype), "destroy", this).call(this), this._fireSelectionChangeDoneDebounced.cancel();
        }
      }, {
        key: "_handleSelectionMove",
        value: function _handleSelectionMove(e) {
          var t = this.document.selection,
              i = new go(t.getRanges(), {
            backward: t.isBackward,
            fake: !1
          });
          e != No.arrowleft && e != No.arrowup || i.setTo(i.getFirstPosition()), e != No.arrowright && e != No.arrowdown || i.setTo(i.getLastPosition());
          var n = {
            oldSelection: t,
            newSelection: i,
            domSelection: null
          };
          this.document.fire("selectionChange", n), this._fireSelectionChangeDoneDebounced(n);
        }
      }]);

      return bs;
    }(zr);

    var ws =
    /*#__PURE__*/
    function (_zr4) {
      _inherits(ws, _zr4);

      function ws(e) {
        var _this37;

        _classCallCheck(this, ws);

        _this37 = _possibleConstructorReturn(this, _getPrototypeOf(ws).call(this, e)), _this37.mutationObserver = e.getObserver(es), _this37.selection = _this37.document.selection, _this37.domConverter = e.domConverter, _this37._documents = new WeakSet(), _this37._fireSelectionChangeDoneDebounced = ps(function (e) {
          return _this37.document.fire("selectionChangeDone", e);
        }, 200), _this37._clearInfiniteLoopInterval = setInterval(function () {
          return _this37._clearInfiniteLoop();
        }, 1e3), _this37._loopbackCounter = 0;
        return _this37;
      }

      _createClass(ws, [{
        key: "observe",
        value: function observe(e) {
          var _this38 = this;

          var t = e.ownerDocument;
          this._documents.has(t) || (this.listenTo(t, "selectionchange", function (e, i) {
            _this38._handleSelectionChange(i, t);
          }), this._documents.add(t));
        }
      }, {
        key: "destroy",
        value: function destroy() {
          _get(_getPrototypeOf(ws.prototype), "destroy", this).call(this), clearInterval(this._clearInfiniteLoopInterval), this._fireSelectionChangeDoneDebounced.cancel();
        }
      }, {
        key: "_handleSelectionChange",
        value: function _handleSelectionChange(e, t) {
          if (!this.isEnabled) return;
          var i = t.defaultView.getSelection();
          if (this.checkShouldIgnoreEventFromTarget(i.anchorNode)) return;
          this.mutationObserver.flush();
          var n = this.domConverter.domSelectionToView(i);

          if (0 != n.rangeCount) {
            if (this.view.hasDomSelection = !0, !(this.selection.isEqual(n) && this.domConverter.isDomSelectionCorrect(i) || ++this._loopbackCounter > 60)) if (this.selection.isSimilar(n)) this.view.forceRender();else {
              var _e65 = {
                oldSelection: this.selection,
                newSelection: n,
                domSelection: i
              };
              this.document.fire("selectionChange", _e65), this._fireSelectionChangeDoneDebounced(_e65);
            }
          } else this.view.hasDomSelection = !1;
        }
      }, {
        key: "_clearInfiniteLoop",
        value: function _clearInfiniteLoop() {
          this._loopbackCounter = 0;
        }
      }]);

      return ws;
    }(zr);

    var ks =
    /*#__PURE__*/
    function (_is2) {
      _inherits(ks, _is2);

      function ks(e) {
        var _this39;

        _classCallCheck(this, ks);

        _this39 = _possibleConstructorReturn(this, _getPrototypeOf(ks).call(this, e)), _this39.domEventType = ["focus", "blur"], _this39.useCapture = !0;
        var t = _this39.document;
        t.on("focus", function () {
          t.isFocused = !0, _this39._renderTimeoutId = setTimeout(function () {
            return e.change(function () {});
          }, 50);
        }), t.on("blur", function (i, n) {
          var o = t.selection.editableElement;
          null !== o && o !== n.target || (t.isFocused = !1, e.change(function () {}));
        });
        return _this39;
      }

      _createClass(ks, [{
        key: "onDomEvent",
        value: function onDomEvent(e) {
          this.fire(e.type, e);
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this._renderTimeoutId && clearTimeout(this._renderTimeoutId), _get(_getPrototypeOf(ks.prototype), "destroy", this).call(this);
        }
      }]);

      return ks;
    }(is);

    var _s =
    /*#__PURE__*/
    function (_is3) {
      _inherits(_s, _is3);

      function _s(e) {
        var _this40;

        _classCallCheck(this, _s);

        _this40 = _possibleConstructorReturn(this, _getPrototypeOf(_s).call(this, e)), _this40.domEventType = ["compositionstart", "compositionupdate", "compositionend"];
        var t = _this40.document;
        t.on("compositionstart", function () {
          t.isComposing = !0;
        }), t.on("compositionend", function () {
          t.isComposing = !1;
        });
        return _this40;
      }

      _createClass(_s, [{
        key: "onDomEvent",
        value: function onDomEvent(e) {
          this.fire(e.type, e);
        }
      }]);

      return _s;
    }(is);

    var vs =
    /*#__PURE__*/
    function (_is4) {
      _inherits(vs, _is4);

      function vs(e) {
        var _this41;

        _classCallCheck(this, vs);

        _this41 = _possibleConstructorReturn(this, _getPrototypeOf(vs).call(this, e)), _this41.domEventType = ["beforeinput"];
        return _this41;
      }

      _createClass(vs, [{
        key: "onDomEvent",
        value: function onDomEvent(e) {
          this.fire(e.type, e);
        }
      }]);

      return vs;
    }(is);

    var ys =
    /*#__PURE__*/
    function () {
      function ys() {
        _classCallCheck(this, ys);

        this._replacedElements = [];
      }

      _createClass(ys, [{
        key: "replace",
        value: function replace(e, t) {
          this._replacedElements.push({
            element: e,
            newElement: t
          }), e.style.display = "none", t && e.parentNode.insertBefore(t, e.nextSibling);
        }
      }, {
        key: "restore",
        value: function restore() {
          this._replacedElements.forEach(function (_ref39) {
            var e = _ref39.element,
                t = _ref39.newElement;
            e.style.display = "", t && t.remove();
          }), this._replacedElements = [];
        }
      }]);

      return ys;
    }();

    var xs = function xs(e) {
      return "string" == typeof e || !_e(e) && me(e) && "[object String]" == I(e);
    };

    function As(e, t) {
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
      var o = i && i.xmlns,
          r = o ? e.createElementNS(o, t) : e.createElement(t);

      for (var _e66 in i) {
        r.setAttribute(_e66, i[_e66]);
      }

      !xs(n) && Ji(n) || (n = [n]);
      var _iteratorNormalCompletion90 = true;
      var _didIteratorError90 = false;
      var _iteratorError90 = undefined;

      try {
        for (var _iterator90 = n[Symbol.iterator](), _step90; !(_iteratorNormalCompletion90 = (_step90 = _iterator90.next()).done); _iteratorNormalCompletion90 = true) {
          var _t70 = _step90.value;
          xs(_t70) && (_t70 = e.createTextNode(_t70)), r.appendChild(_t70);
        }
      } catch (err) {
        _didIteratorError90 = true;
        _iteratorError90 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion90 && _iterator90.return != null) {
            _iterator90.return();
          }
        } finally {
          if (_didIteratorError90) {
            throw _iteratorError90;
          }
        }
      }

      return r;
    }

    function Cs(e) {
      return "[object Range]" == Object.prototype.toString.apply(e);
    }

    function Ts(e) {
      var t = e.ownerDocument.defaultView.getComputedStyle(e);
      return {
        top: parseInt(t.borderTopWidth, 10),
        right: parseInt(t.borderRightWidth, 10),
        bottom: parseInt(t.borderBottomWidth, 10),
        left: parseInt(t.borderLeftWidth, 10)
      };
    }

    var Es = ["top", "right", "bottom", "left", "width", "height"];

    var Ss =
    /*#__PURE__*/
    function () {
      function Ss(e) {
        _classCallCheck(this, Ss);

        var t = Cs(e);
        if (Object.defineProperty(this, "_source", {
          value: e._source || e,
          writable: !0,
          enumerable: !1
        }), Yi(e) || t) {
          if (t) {
            var _t71 = Ss.getDomRangeRects(e);

            Is(this, Ss.getBoundingRect(_t71));
          } else Is(this, e.getBoundingClientRect());
        } else if (Mr(e)) {
          var _t72 = e.innerWidth,
              _i81 = e.innerHeight;
          Is(this, {
            top: 0,
            right: _t72,
            bottom: _i81,
            left: 0,
            width: _t72,
            height: _i81
          });
        } else Is(this, e);
      }

      _createClass(Ss, [{
        key: "clone",
        value: function clone() {
          return new Ss(this);
        }
      }, {
        key: "moveTo",
        value: function moveTo(e, t) {
          return this.top = t, this.right = e + this.width, this.bottom = t + this.height, this.left = e, this;
        }
      }, {
        key: "moveBy",
        value: function moveBy(e, t) {
          return this.top += t, this.right += e, this.left += e, this.bottom += t, this;
        }
      }, {
        key: "getIntersection",
        value: function getIntersection(e) {
          var t = {
            top: Math.max(this.top, e.top),
            right: Math.min(this.right, e.right),
            bottom: Math.min(this.bottom, e.bottom),
            left: Math.max(this.left, e.left)
          };
          return t.width = t.right - t.left, t.height = t.bottom - t.top, t.width < 0 || t.height < 0 ? null : new Ss(t);
        }
      }, {
        key: "getIntersectionArea",
        value: function getIntersectionArea(e) {
          var t = this.getIntersection(e);
          return t ? t.getArea() : 0;
        }
      }, {
        key: "getArea",
        value: function getArea() {
          return this.width * this.height;
        }
      }, {
        key: "getVisible",
        value: function getVisible() {
          var e = this._source;
          var t = this.clone();

          if (!Ps(e)) {
            var _i82 = e.parentNode || e.commonAncestorContainer;

            for (; _i82 && !Ps(_i82);) {
              var _e67 = new Ss(_i82),
                  _n38 = t.getIntersection(_e67);

              if (!_n38) return null;
              _n38.getArea() < t.getArea() && (t = _n38), _i82 = _i82.parentNode;
            }
          }

          return t;
        }
      }, {
        key: "isEqual",
        value: function isEqual(e) {
          var _iteratorNormalCompletion91 = true;
          var _didIteratorError91 = false;
          var _iteratorError91 = undefined;

          try {
            for (var _iterator91 = Es[Symbol.iterator](), _step91; !(_iteratorNormalCompletion91 = (_step91 = _iterator91.next()).done); _iteratorNormalCompletion91 = true) {
              var _t73 = _step91.value;
              if (this[_t73] !== e[_t73]) return !1;
            }
          } catch (err) {
            _didIteratorError91 = true;
            _iteratorError91 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion91 && _iterator91.return != null) {
                _iterator91.return();
              }
            } finally {
              if (_didIteratorError91) {
                throw _iteratorError91;
              }
            }
          }

          return !0;
        }
      }, {
        key: "contains",
        value: function contains(e) {
          var t = this.getIntersection(e);
          return !(!t || !t.isEqual(e));
        }
      }, {
        key: "excludeScrollbarsAndBorders",
        value: function excludeScrollbarsAndBorders() {
          var e = this._source;
          var t, i, n;
          if (Mr(e)) t = e.innerWidth - e.document.documentElement.clientWidth, i = e.innerHeight - e.document.documentElement.clientHeight, n = e.getComputedStyle(e.document.documentElement).direction;else {
            var _o28 = Ts(this._source);

            t = e.offsetWidth - e.clientWidth - _o28.left - _o28.right, i = e.offsetHeight - e.clientHeight - _o28.top - _o28.bottom, n = e.ownerDocument.defaultView.getComputedStyle(e).direction, this.left += _o28.left, this.top += _o28.top, this.right -= _o28.right, this.bottom -= _o28.bottom, this.width = this.right - this.left, this.height = this.bottom - this.top;
          }
          return this.width -= t, "ltr" === n ? this.right -= t : this.left += t, this.height -= i, this.bottom -= i, this;
        }
      }], [{
        key: "getDomRangeRects",
        value: function getDomRangeRects(e) {
          var t = [],
              i = Array.from(e.getClientRects());

          if (i.length) {
            var _iteratorNormalCompletion92 = true;
            var _didIteratorError92 = false;
            var _iteratorError92 = undefined;

            try {
              for (var _iterator92 = i[Symbol.iterator](), _step92; !(_iteratorNormalCompletion92 = (_step92 = _iterator92.next()).done); _iteratorNormalCompletion92 = true) {
                var _e68 = _step92.value;
                t.push(new Ss(_e68));
              }
            } catch (err) {
              _didIteratorError92 = true;
              _iteratorError92 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion92 && _iterator92.return != null) {
                  _iterator92.return();
                }
              } finally {
                if (_didIteratorError92) {
                  throw _iteratorError92;
                }
              }
            }
          } else {
            var _i83 = e.startContainer;
            tr(_i83) && (_i83 = _i83.parentNode);

            var _n39 = new Ss(_i83.getBoundingClientRect());

            _n39.right = _n39.left, _n39.width = 0, t.push(_n39);
          }

          return t;
        }
      }, {
        key: "getBoundingRect",
        value: function getBoundingRect(e) {
          var t = {
            left: Number.POSITIVE_INFINITY,
            top: Number.POSITIVE_INFINITY,
            right: Number.NEGATIVE_INFINITY,
            bottom: Number.NEGATIVE_INFINITY
          };
          var i = 0;
          var _iteratorNormalCompletion93 = true;
          var _didIteratorError93 = false;
          var _iteratorError93 = undefined;

          try {
            for (var _iterator93 = e[Symbol.iterator](), _step93; !(_iteratorNormalCompletion93 = (_step93 = _iterator93.next()).done); _iteratorNormalCompletion93 = true) {
              var _n40 = _step93.value;
              i++, t.left = Math.min(t.left, _n40.left), t.top = Math.min(t.top, _n40.top), t.right = Math.max(t.right, _n40.right), t.bottom = Math.max(t.bottom, _n40.bottom);
            }
          } catch (err) {
            _didIteratorError93 = true;
            _iteratorError93 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion93 && _iterator93.return != null) {
                _iterator93.return();
              }
            } finally {
              if (_didIteratorError93) {
                throw _iteratorError93;
              }
            }
          }

          return 0 == i ? null : (t.width = t.right - t.left, t.height = t.bottom - t.top, new Ss(t));
        }
      }]);

      return Ss;
    }();

    function Is(e, t) {
      var _iteratorNormalCompletion94 = true;
      var _didIteratorError94 = false;
      var _iteratorError94 = undefined;

      try {
        for (var _iterator94 = Es[Symbol.iterator](), _step94; !(_iteratorNormalCompletion94 = (_step94 = _iterator94.next()).done); _iteratorNormalCompletion94 = true) {
          var _i84 = _step94.value;
          e[_i84] = t[_i84];
        }
      } catch (err) {
        _didIteratorError94 = true;
        _iteratorError94 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion94 && _iterator94.return != null) {
            _iterator94.return();
          }
        } finally {
          if (_didIteratorError94) {
            throw _iteratorError94;
          }
        }
      }
    }

    function Ps(e) {
      return !!Yi(e) && e === e.ownerDocument.body;
    }

    var Ms =
    /*#__PURE__*/
    function () {
      function Ms(e, t) {
        _classCallCheck(this, Ms);

        Ms._observerInstance || Ms._createObserver(), this._element = e, this._callback = t, Ms._addElementCallback(e, t), Ms._observerInstance.observe(e);
      }

      _createClass(Ms, [{
        key: "destroy",
        value: function destroy() {
          Ms._deleteElementCallback(this._element, this._callback);
        }
      }], [{
        key: "_addElementCallback",
        value: function _addElementCallback(e, t) {
          Ms._elementCallbacks || (Ms._elementCallbacks = new Map());

          var i = Ms._elementCallbacks.get(e);

          i || (i = new Set(), Ms._elementCallbacks.set(e, i)), i.add(t);
        }
      }, {
        key: "_deleteElementCallback",
        value: function _deleteElementCallback(e, t) {
          var i = Ms._getElementCallbacks(e);

          i && (i.delete(t), i.size || (Ms._elementCallbacks.delete(e), Ms._observerInstance.unobserve(e))), Ms._elementCallbacks && !Ms._elementCallbacks.size && (Ms._observerInstance = null, Ms._elementCallbacks = null);
        }
      }, {
        key: "_getElementCallbacks",
        value: function _getElementCallbacks(e) {
          return Ms._elementCallbacks ? Ms._elementCallbacks.get(e) : null;
        }
      }, {
        key: "_createObserver",
        value: function _createObserver() {
          var e;
          e = "function" == typeof vr.window.ResizeObserver ? vr.window.ResizeObserver : Ns, Ms._observerInstance = new e(function (e) {
            var _iteratorNormalCompletion95 = true;
            var _didIteratorError95 = false;
            var _iteratorError95 = undefined;

            try {
              for (var _iterator95 = e[Symbol.iterator](), _step95; !(_iteratorNormalCompletion95 = (_step95 = _iterator95.next()).done); _iteratorNormalCompletion95 = true) {
                var _t74 = _step95.value;

                var _e69 = Ms._getElementCallbacks(_t74.target);

                if (_e69) {
                  var _iteratorNormalCompletion96 = true;
                  var _didIteratorError96 = false;
                  var _iteratorError96 = undefined;

                  try {
                    for (var _iterator96 = _e69[Symbol.iterator](), _step96; !(_iteratorNormalCompletion96 = (_step96 = _iterator96.next()).done); _iteratorNormalCompletion96 = true) {
                      var _i85 = _step96.value;

                      _i85(_t74);
                    }
                  } catch (err) {
                    _didIteratorError96 = true;
                    _iteratorError96 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion96 && _iterator96.return != null) {
                        _iterator96.return();
                      }
                    } finally {
                      if (_didIteratorError96) {
                        throw _iteratorError96;
                      }
                    }
                  }
                }
              }
            } catch (err) {
              _didIteratorError95 = true;
              _iteratorError95 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion95 && _iterator95.return != null) {
                  _iterator95.return();
                }
              } finally {
                if (_didIteratorError95) {
                  throw _iteratorError95;
                }
              }
            }
          });
        }
      }]);

      return Ms;
    }();

    Ms._observerInstance = null, Ms._elementCallbacks = null;

    var Ns =
    /*#__PURE__*/
    function () {
      function Ns(e) {
        _classCallCheck(this, Ns);

        this._callback = e, this._elements = new Set(), this._previousRects = new Map(), this._periodicCheckTimeout = null;
      }

      _createClass(Ns, [{
        key: "observe",
        value: function observe(e) {
          this._elements.add(e), this._checkElementRectsAndExecuteCallback(), 1 === this._elements.size && this._startPeriodicCheck();
        }
      }, {
        key: "unobserve",
        value: function unobserve(e) {
          this._elements.delete(e), this._previousRects.delete(e), this._elements.size || this._stopPeriodicCheck();
        }
      }, {
        key: "_startPeriodicCheck",
        value: function _startPeriodicCheck() {
          var _this42 = this;

          var e = function e() {
            _this42._checkElementRectsAndExecuteCallback(), _this42._periodicCheckTimeout = setTimeout(e, 100);
          };

          this.listenTo(vr.window, "resize", function () {
            _this42._checkElementRectsAndExecuteCallback();
          }), this._periodicCheckTimeout = setTimeout(e, 100);
        }
      }, {
        key: "_stopPeriodicCheck",
        value: function _stopPeriodicCheck() {
          clearTimeout(this._periodicCheckTimeout), this.stopListening(), this._previousRects.clear();
        }
      }, {
        key: "_checkElementRectsAndExecuteCallback",
        value: function _checkElementRectsAndExecuteCallback() {
          var e = [];
          var _iteratorNormalCompletion97 = true;
          var _didIteratorError97 = false;
          var _iteratorError97 = undefined;

          try {
            for (var _iterator97 = this._elements[Symbol.iterator](), _step97; !(_iteratorNormalCompletion97 = (_step97 = _iterator97.next()).done); _iteratorNormalCompletion97 = true) {
              var _t75 = _step97.value;
              this._hasRectChanged(_t75) && e.push({
                target: _t75,
                contentRect: this._previousRects.get(_t75)
              });
            }
          } catch (err) {
            _didIteratorError97 = true;
            _iteratorError97 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion97 && _iterator97.return != null) {
                _iterator97.return();
              }
            } finally {
              if (_didIteratorError97) {
                throw _iteratorError97;
              }
            }
          }

          e.length && this._callback(e);
        }
      }, {
        key: "_hasRectChanged",
        value: function _hasRectChanged(e) {
          if (!e.ownerDocument.body.contains(e)) return !1;

          var t = new Ss(e),
              i = this._previousRects.get(e),
              n = !i || !i.isEqual(t);

          return this._previousRects.set(e, t), n;
        }
      }]);

      return Ns;
    }();

    function Rs(e) {
      return function (t) {
        return t + e;
      };
    }

    function Os(e) {
      var t = e.next();
      return t.done ? null : t.value;
    }

    Ke(Ns, Nr);

    var zs =
    /*#__PURE__*/
    function () {
      function zs() {
        _classCallCheck(this, zs);

        this.set("isFocused", !1), this.set("focusedElement", null), this._elements = new Set(), this._nextEventLoopTimeout = null;
      }

      _createClass(zs, [{
        key: "add",
        value: function add(e) {
          var _this43 = this;

          if (this._elements.has(e)) throw new c.a("focustracker-add-element-already-exist", this);
          this.listenTo(e, "focus", function () {
            return _this43._focus(e);
          }, {
            useCapture: !0
          }), this.listenTo(e, "blur", function () {
            return _this43._blur();
          }, {
            useCapture: !0
          }), this._elements.add(e);
        }
      }, {
        key: "remove",
        value: function remove(e) {
          e === this.focusedElement && this._blur(e), this._elements.has(e) && (this.stopListening(e), this._elements.delete(e));
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.stopListening();
        }
      }, {
        key: "_focus",
        value: function _focus(e) {
          clearTimeout(this._nextEventLoopTimeout), this.focusedElement = e, this.isFocused = !0;
        }
      }, {
        key: "_blur",
        value: function _blur() {
          var _this44 = this;

          clearTimeout(this._nextEventLoopTimeout), this._nextEventLoopTimeout = setTimeout(function () {
            _this44.focusedElement = null, _this44.isFocused = !1;
          }, 0);
        }
      }]);

      return zs;
    }();

    Ke(zs, Nr), Ke(zs, Ue);

    var Ds =
    /*#__PURE__*/
    function () {
      function Ds() {
        _classCallCheck(this, Ds);

        this._listener = Object.create(Nr);
      }

      _createClass(Ds, [{
        key: "listenTo",
        value: function listenTo(e) {
          var _this45 = this;

          this._listener.listenTo(e, "keydown", function (e, t) {
            _this45._listener.fire("_keydown:" + Oo(t), t);
          });
        }
      }, {
        key: "set",
        value: function set(e, t) {
          var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
          var n = zo(e),
              o = i.priority;

          this._listener.listenTo(this._listener, "_keydown:" + n, function (e, i) {
            t(i, function () {
              i.preventDefault(), i.stopPropagation(), e.stop();
            }), e.return = !0;
          }, {
            priority: o
          });
        }
      }, {
        key: "press",
        value: function press(e) {
          return !!this._listener.fire("_keydown:" + Oo(e), e);
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this._listener.stopListening();
        }
      }]);

      return Ds;
    }();

    var Ls =
    /*#__PURE__*/
    function (_zr5) {
      _inherits(Ls, _zr5);

      function Ls(e) {
        var _this46;

        _classCallCheck(this, Ls);

        _this46 = _possibleConstructorReturn(this, _getPrototypeOf(Ls).call(this, e)), _this46.document.on("keydown", function (e, t) {
          if (_this46.isEnabled && ((i = t.keyCode) == No.arrowright || i == No.arrowleft || i == No.arrowup || i == No.arrowdown)) {
            var _i86 = new fo(_this46.document, "arrowKey", _this46.document.selection.getFirstRange());

            _this46.document.fire(_i86, t), _i86.stop.called && e.stop();
          }

          var i;
        });
        return _this46;
      }

      _createClass(Ls, [{
        key: "observe",
        value: function observe() {}
      }]);

      return Ls;
    }(zr);

    function Vs(_ref40) {
      var e = _ref40.target,
          _ref40$viewportOffset = _ref40.viewportOffset,
          t = _ref40$viewportOffset === void 0 ? 0 : _ref40$viewportOffset;
      var i = qs(e);
      var n = i,
          o = null;

      for (; n;) {
        var _r17 = void 0;

        _r17 = $s(n == i ? e : o), Bs(_r17, function () {
          return Ys(e, n);
        });

        var _s9 = Ys(e, n);

        if (js(n, _s9, t), n.parent != n) {
          if (o = n.frameElement, n = n.parent, !o) return;
        } else n = null;
      }
    }

    function js(e, t, i) {
      var n = t.clone().moveBy(0, i),
          o = t.clone().moveBy(0, -i),
          r = new Ss(e).excludeScrollbarsAndBorders();

      if (![o, n].every(function (e) {
        return r.contains(e);
      })) {
        var _s10 = e.scrollX,
            _a8 = e.scrollY;
        Hs(o, r) ? _a8 -= r.top - t.top + i : Fs(n, r) && (_a8 += t.bottom - r.bottom + i), Us(t, r) ? _s10 -= r.left - t.left + i : Ws(t, r) && (_s10 += t.right - r.right + i), e.scrollTo(_s10, _a8);
      }
    }

    function Bs(e, t) {
      var i = qs(e);
      var n, o;

      for (; e != i.document.body;) {
        o = t(), n = new Ss(e).excludeScrollbarsAndBorders(), n.contains(o) || (Hs(o, n) ? e.scrollTop -= n.top - o.top : Fs(o, n) && (e.scrollTop += o.bottom - n.bottom), Us(o, n) ? e.scrollLeft -= n.left - o.left : Ws(o, n) && (e.scrollLeft += o.right - n.right)), e = e.parentNode;
      }
    }

    function Fs(e, t) {
      return e.bottom > t.bottom;
    }

    function Hs(e, t) {
      return e.top < t.top;
    }

    function Us(e, t) {
      return e.left < t.left;
    }

    function Ws(e, t) {
      return e.right > t.right;
    }

    function qs(e) {
      return Cs(e) ? e.startContainer.ownerDocument.defaultView : e.ownerDocument.defaultView;
    }

    function $s(e) {
      if (Cs(e)) {
        var _t76 = e.commonAncestorContainer;
        return tr(_t76) && (_t76 = _t76.parentNode), _t76;
      }

      return e.parentNode;
    }

    function Ys(e, t) {
      var i = qs(e),
          n = new Ss(e);
      if (i === t) return n;
      {
        var _e70 = i;

        for (; _e70 != t;) {
          var _t77 = _e70.frameElement,
              _i87 = new Ss(_t77).excludeScrollbarsAndBorders();

          n.moveBy(_i87.left, _i87.top), _e70 = _e70.parent;
        }
      }
      return n;
    }

    Object.assign({}, {
      scrollViewportToShowTarget: Vs,
      scrollAncestorsToShowTarget: function scrollAncestorsToShowTarget(e) {
        Bs($s(e), function () {
          return new Ss(e);
        });
      }
    });

    var Gs =
    /*#__PURE__*/
    function () {
      function Gs(e) {
        var _this47 = this;

        _classCallCheck(this, Gs);

        this.document = new yo(e), this.domConverter = new Er(this.document), this.domRoots = new Map(), this.set("isRenderingInProgress", !1), this.set("hasDomSelection", !1), this._renderer = new br(this.domConverter, this.document.selection), this._renderer.bind("isFocused").to(this.document), this._initialDomRootAttributes = new WeakMap(), this._observers = new Map(), this._ongoingChange = !1, this._postFixersInProgress = !1, this._renderingDisabled = !1, this._hasChangedSinceTheLastRendering = !1, this._writer = new qo(this.document), this.addObserver(es), this.addObserver(ws), this.addObserver(ks), this.addObserver(ns), this.addObserver(bs), this.addObserver(_s), this.addObserver(Ls), Io.isAndroid && this.addObserver(vs), this.document.on("arrowKey", lr, {
          priority: "low"
        }), Bo(this), this.on("render", function () {
          _this47._render(), _this47.document.fire("layoutChanged"), _this47._hasChangedSinceTheLastRendering = !1;
        }), this.listenTo(this.document.selection, "change", function () {
          _this47._hasChangedSinceTheLastRendering = !0;
        }), this.listenTo(this.document, "change:isFocused", function () {
          _this47._hasChangedSinceTheLastRendering = !0;
        });
      }

      _createClass(Gs, [{
        key: "attachDomRoot",
        value: function attachDomRoot(e) {
          var _this48 = this;

          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "main";
          var i = this.document.getRoot(t);
          i._name = e.tagName.toLowerCase();
          var n = {};

          for (var _i88 = 0, _Array$from = Array.from(e.attributes); _i88 < _Array$from.length; _i88++) {
            var _ref42 = _Array$from[_i88];
            var _t78 = _ref42.name;
            var _o29 = _ref42.value;
            n[_t78] = _o29, "class" === _t78 ? this._writer.addClass(_o29.split(" "), i) : this._writer.setAttribute(_t78, _o29, i);
          }

          this._initialDomRootAttributes.set(e, n);

          var o = function o() {
            _this48._writer.setAttribute("contenteditable", !i.isReadOnly, i), i.isReadOnly ? _this48._writer.addClass("ck-read-only", i) : _this48._writer.removeClass("ck-read-only", i);
          };

          o(), this.domRoots.set(t, e), this.domConverter.bindElements(e, i), this._renderer.markToSync("children", i), this._renderer.markToSync("attributes", i), this._renderer.domDocuments.add(e.ownerDocument), i.on("change:children", function (e, t) {
            return _this48._renderer.markToSync("children", t);
          }), i.on("change:attributes", function (e, t) {
            return _this48._renderer.markToSync("attributes", t);
          }), i.on("change:text", function (e, t) {
            return _this48._renderer.markToSync("text", t);
          }), i.on("change:isReadOnly", function () {
            return _this48.change(o);
          }), i.on("change", function () {
            _this48._hasChangedSinceTheLastRendering = !0;
          });
          var _iteratorNormalCompletion98 = true;
          var _didIteratorError98 = false;
          var _iteratorError98 = undefined;

          try {
            for (var _iterator98 = this._observers.values()[Symbol.iterator](), _step98; !(_iteratorNormalCompletion98 = (_step98 = _iterator98.next()).done); _iteratorNormalCompletion98 = true) {
              var _i89 = _step98.value;

              _i89.observe(e, t);
            }
          } catch (err) {
            _didIteratorError98 = true;
            _iteratorError98 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion98 && _iterator98.return != null) {
                _iterator98.return();
              }
            } finally {
              if (_didIteratorError98) {
                throw _iteratorError98;
              }
            }
          }
        }
      }, {
        key: "detachDomRoot",
        value: function detachDomRoot(e) {
          var t = this.domRoots.get(e);
          Array.from(t.attributes).forEach(function (_ref43) {
            var e = _ref43.name;
            return t.removeAttribute(e);
          });

          var i = this._initialDomRootAttributes.get(t);

          for (var _e71 in i) {
            t.setAttribute(_e71, i[_e71]);
          }

          this.domRoots.delete(e), this.domConverter.unbindDomElement(t);
        }
      }, {
        key: "getDomRoot",
        value: function getDomRoot() {
          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "main";
          return this.domRoots.get(e);
        }
      }, {
        key: "addObserver",
        value: function addObserver(e) {
          var t = this._observers.get(e);

          if (t) return t;
          t = new e(this), this._observers.set(e, t);
          var _iteratorNormalCompletion99 = true;
          var _didIteratorError99 = false;
          var _iteratorError99 = undefined;

          try {
            for (var _iterator99 = this.domRoots[Symbol.iterator](), _step99; !(_iteratorNormalCompletion99 = (_step99 = _iterator99.next()).done); _iteratorNormalCompletion99 = true) {
              var _ref46 = _step99.value;

              var _ref45 = _slicedToArray(_ref46, 2);

              var _e72 = _ref45[0];
              var _i90 = _ref45[1];
              t.observe(_i90, _e72);
            }
          } catch (err) {
            _didIteratorError99 = true;
            _iteratorError99 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion99 && _iterator99.return != null) {
                _iterator99.return();
              }
            } finally {
              if (_didIteratorError99) {
                throw _iteratorError99;
              }
            }
          }

          return t.enable(), t;
        }
      }, {
        key: "getObserver",
        value: function getObserver(e) {
          return this._observers.get(e);
        }
      }, {
        key: "disableObservers",
        value: function disableObservers() {
          var _iteratorNormalCompletion100 = true;
          var _didIteratorError100 = false;
          var _iteratorError100 = undefined;

          try {
            for (var _iterator100 = this._observers.values()[Symbol.iterator](), _step100; !(_iteratorNormalCompletion100 = (_step100 = _iterator100.next()).done); _iteratorNormalCompletion100 = true) {
              var _e73 = _step100.value;

              _e73.disable();
            }
          } catch (err) {
            _didIteratorError100 = true;
            _iteratorError100 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion100 && _iterator100.return != null) {
                _iterator100.return();
              }
            } finally {
              if (_didIteratorError100) {
                throw _iteratorError100;
              }
            }
          }
        }
      }, {
        key: "enableObservers",
        value: function enableObservers() {
          var _iteratorNormalCompletion101 = true;
          var _didIteratorError101 = false;
          var _iteratorError101 = undefined;

          try {
            for (var _iterator101 = this._observers.values()[Symbol.iterator](), _step101; !(_iteratorNormalCompletion101 = (_step101 = _iterator101.next()).done); _iteratorNormalCompletion101 = true) {
              var _e74 = _step101.value;

              _e74.enable();
            }
          } catch (err) {
            _didIteratorError101 = true;
            _iteratorError101 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion101 && _iterator101.return != null) {
                _iterator101.return();
              }
            } finally {
              if (_didIteratorError101) {
                throw _iteratorError101;
              }
            }
          }
        }
      }, {
        key: "scrollToTheSelection",
        value: function scrollToTheSelection() {
          var e = this.document.selection.getFirstRange();
          e && Vs({
            target: this.domConverter.viewRangeToDom(e),
            viewportOffset: 20
          });
        }
      }, {
        key: "focus",
        value: function focus() {
          if (!this.document.isFocused) {
            var _e75 = this.document.selection.editableElement;
            _e75 && (this.domConverter.focus(_e75), this.forceRender());
          }
        }
      }, {
        key: "change",
        value: function change(e) {
          if (this.isRenderingInProgress || this._postFixersInProgress) throw new c.a("cannot-change-view-tree", this);

          try {
            if (this._ongoingChange) return e(this._writer);
            this._ongoingChange = !0;

            var _t79 = e(this._writer);

            return this._ongoingChange = !1, !this._renderingDisabled && this._hasChangedSinceTheLastRendering && (this._postFixersInProgress = !0, this.document._callPostFixers(this._writer), this._postFixersInProgress = !1, this.fire("render")), _t79;
          } catch (e) {
            c.a.rethrowUnexpectedError(e, this);
          }
        }
      }, {
        key: "forceRender",
        value: function forceRender() {
          this._hasChangedSinceTheLastRendering = !0, this.change(function () {});
        }
      }, {
        key: "destroy",
        value: function destroy() {
          var _iteratorNormalCompletion102 = true;
          var _didIteratorError102 = false;
          var _iteratorError102 = undefined;

          try {
            for (var _iterator102 = this._observers.values()[Symbol.iterator](), _step102; !(_iteratorNormalCompletion102 = (_step102 = _iterator102.next()).done); _iteratorNormalCompletion102 = true) {
              var _e76 = _step102.value;

              _e76.destroy();
            }
          } catch (err) {
            _didIteratorError102 = true;
            _iteratorError102 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion102 && _iterator102.return != null) {
                _iterator102.return();
              }
            } finally {
              if (_didIteratorError102) {
                throw _iteratorError102;
              }
            }
          }

          this.document.destroy(), this.stopListening();
        }
      }, {
        key: "createPositionAt",
        value: function createPositionAt(e, t) {
          return co._createAt(e, t);
        }
      }, {
        key: "createPositionAfter",
        value: function createPositionAfter(e) {
          return co._createAfter(e);
        }
      }, {
        key: "createPositionBefore",
        value: function createPositionBefore(e) {
          return co._createBefore(e);
        }
      }, {
        key: "createRange",
        value: function createRange(e, t) {
          return new lo(e, t);
        }
      }, {
        key: "createRangeOn",
        value: function createRangeOn(e) {
          return lo._createOn(e);
        }
      }, {
        key: "createRangeIn",
        value: function createRangeIn(e) {
          return lo._createIn(e);
        }
      }, {
        key: "createSelection",
        value: function createSelection(e, t, i) {
          return new go(e, t, i);
        }
      }, {
        key: "_disableRendering",
        value: function _disableRendering(e) {
          this._renderingDisabled = e, 0 == e && this.change(function () {});
        }
      }, {
        key: "_render",
        value: function _render() {
          this.isRenderingInProgress = !0, this.disableObservers(), this._renderer.render(), this.enableObservers(), this.isRenderingInProgress = !1;
        }
      }]);

      return Gs;
    }();

    Ke(Gs, Ue);

    var Ks =
    /*#__PURE__*/
    function () {
      function Ks(e) {
        _classCallCheck(this, Ks);

        this.parent = null, this._attrs = gn(e);
      }

      _createClass(Ks, [{
        key: "isAttached",
        value: function isAttached() {
          return this.root.is("rootElement");
        }
      }, {
        key: "getPath",
        value: function getPath() {
          var e = [];
          var t = this;

          for (; t.parent;) {
            e.unshift(t.startOffset), t = t.parent;
          }

          return e;
        }
      }, {
        key: "getAncestors",
        value: function getAncestors() {
          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            includeSelf: !1,
            parentFirst: !1
          };
          var t = [];
          var i = e.includeSelf ? this : this.parent;

          for (; i;) {
            t[e.parentFirst ? "push" : "unshift"](i), i = i.parent;
          }

          return t;
        }
      }, {
        key: "getCommonAncestor",
        value: function getCommonAncestor(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var i = this.getAncestors(t),
              n = e.getAncestors(t);
          var o = 0;

          for (; i[o] == n[o] && i[o];) {
            o++;
          }

          return 0 === o ? null : i[o - 1];
        }
      }, {
        key: "isBefore",
        value: function isBefore(e) {
          if (this == e) return !1;
          if (this.root !== e.root) return !1;
          var t = this.getPath(),
              i = e.getPath(),
              n = cn(t, i);

          switch (n) {
            case "prefix":
              return !0;

            case "extension":
              return !1;

            default:
              return t[n] < i[n];
          }
        }
      }, {
        key: "isAfter",
        value: function isAfter(e) {
          return this != e && this.root === e.root && !this.isBefore(e);
        }
      }, {
        key: "hasAttribute",
        value: function hasAttribute(e) {
          return this._attrs.has(e);
        }
      }, {
        key: "getAttribute",
        value: function getAttribute(e) {
          return this._attrs.get(e);
        }
      }, {
        key: "getAttributes",
        value: function getAttributes() {
          return this._attrs.entries();
        }
      }, {
        key: "getAttributeKeys",
        value: function getAttributeKeys() {
          return this._attrs.keys();
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var e = {};
          return this._attrs.size && (e.attributes = Array.from(this._attrs).reduce(function (e, t) {
            return e[t[0]] = t[1], e;
          }, {})), e;
        }
      }, {
        key: "is",
        value: function is(e) {
          return "node" === e || "model:node" === e;
        }
      }, {
        key: "_clone",
        value: function _clone() {
          return new Ks(this._attrs);
        }
      }, {
        key: "_remove",
        value: function _remove() {
          this.parent._removeChildren(this.index);
        }
      }, {
        key: "_setAttribute",
        value: function _setAttribute(e, t) {
          this._attrs.set(e, t);
        }
      }, {
        key: "_setAttributesTo",
        value: function _setAttributesTo(e) {
          this._attrs = gn(e);
        }
      }, {
        key: "_removeAttribute",
        value: function _removeAttribute(e) {
          return this._attrs.delete(e);
        }
      }, {
        key: "_clearAttributes",
        value: function _clearAttributes() {
          this._attrs.clear();
        }
      }, {
        key: "index",
        get: function get() {
          var e;
          if (!this.parent) return null;
          if (null === (e = this.parent.getChildIndex(this))) throw new c.a("model-node-not-found-in-parent", this);
          return e;
        }
      }, {
        key: "startOffset",
        get: function get() {
          var e;
          if (!this.parent) return null;
          if (null === (e = this.parent.getChildStartOffset(this))) throw new c.a("model-node-not-found-in-parent", this);
          return e;
        }
      }, {
        key: "offsetSize",
        get: function get() {
          return 1;
        }
      }, {
        key: "endOffset",
        get: function get() {
          return this.parent ? this.startOffset + this.offsetSize : null;
        }
      }, {
        key: "nextSibling",
        get: function get() {
          var e = this.index;
          return null !== e && this.parent.getChild(e + 1) || null;
        }
      }, {
        key: "previousSibling",
        get: function get() {
          var e = this.index;
          return null !== e && this.parent.getChild(e - 1) || null;
        }
      }, {
        key: "root",
        get: function get() {
          var e = this;

          for (; e.parent;) {
            e = e.parent;
          }

          return e;
        }
      }]);

      return Ks;
    }();

    var Qs =
    /*#__PURE__*/
    function (_Ks) {
      _inherits(Qs, _Ks);

      function Qs(e, t) {
        var _this49;

        _classCallCheck(this, Qs);

        _this49 = _possibleConstructorReturn(this, _getPrototypeOf(Qs).call(this, t)), _this49._data = e || "";
        return _this49;
      }

      _createClass(Qs, [{
        key: "is",
        value: function is(e) {
          return "$text" === e || "model:$text" === e || "text" === e || "model:text" === e || "node" === e || "model:node" === e;
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var e = _get(_getPrototypeOf(Qs.prototype), "toJSON", this).call(this);

          return e.data = this.data, e;
        }
      }, {
        key: "_clone",
        value: function _clone() {
          return new Qs(this.data, this.getAttributes());
        }
      }, {
        key: "offsetSize",
        get: function get() {
          return this.data.length;
        }
      }, {
        key: "data",
        get: function get() {
          return this._data;
        }
      }], [{
        key: "fromJSON",
        value: function fromJSON(e) {
          return new Qs(e.data, e.attributes);
        }
      }]);

      return Qs;
    }(Ks);

    var Js =
    /*#__PURE__*/
    function () {
      function Js(e, t, i) {
        _classCallCheck(this, Js);

        if (this.textNode = e, t < 0 || t > e.offsetSize) throw new c.a("model-textproxy-wrong-offsetintext", this);
        if (i < 0 || t + i > e.offsetSize) throw new c.a("model-textproxy-wrong-length", this);
        this.data = e.data.substring(t, t + i), this.offsetInText = t;
      }

      _createClass(Js, [{
        key: "is",
        value: function is(e) {
          return "$textProxy" === e || "model:$textProxy" === e || "textProxy" === e || "model:textProxy" === e;
        }
      }, {
        key: "getPath",
        value: function getPath() {
          var e = this.textNode.getPath();
          return e.length > 0 && (e[e.length - 1] += this.offsetInText), e;
        }
      }, {
        key: "getAncestors",
        value: function getAncestors() {
          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            includeSelf: !1,
            parentFirst: !1
          };
          var t = [];
          var i = e.includeSelf ? this : this.parent;

          for (; i;) {
            t[e.parentFirst ? "push" : "unshift"](i), i = i.parent;
          }

          return t;
        }
      }, {
        key: "hasAttribute",
        value: function hasAttribute(e) {
          return this.textNode.hasAttribute(e);
        }
      }, {
        key: "getAttribute",
        value: function getAttribute(e) {
          return this.textNode.getAttribute(e);
        }
      }, {
        key: "getAttributes",
        value: function getAttributes() {
          return this.textNode.getAttributes();
        }
      }, {
        key: "getAttributeKeys",
        value: function getAttributeKeys() {
          return this.textNode.getAttributeKeys();
        }
      }, {
        key: "startOffset",
        get: function get() {
          return null !== this.textNode.startOffset ? this.textNode.startOffset + this.offsetInText : null;
        }
      }, {
        key: "offsetSize",
        get: function get() {
          return this.data.length;
        }
      }, {
        key: "endOffset",
        get: function get() {
          return null !== this.startOffset ? this.startOffset + this.offsetSize : null;
        }
      }, {
        key: "isPartial",
        get: function get() {
          return this.offsetSize !== this.textNode.offsetSize;
        }
      }, {
        key: "parent",
        get: function get() {
          return this.textNode.parent;
        }
      }, {
        key: "root",
        get: function get() {
          return this.textNode.root;
        }
      }]);

      return Js;
    }();

    var Zs =
    /*#__PURE__*/
    function () {
      function Zs(e) {
        _classCallCheck(this, Zs);

        this._nodes = [], e && this._insertNodes(0, e);
      }

      _createClass(Zs, [{
        key: Symbol.iterator,
        value: function value() {
          return this._nodes[Symbol.iterator]();
        }
      }, {
        key: "getNode",
        value: function getNode(e) {
          return this._nodes[e] || null;
        }
      }, {
        key: "getNodeIndex",
        value: function getNodeIndex(e) {
          var t = this._nodes.indexOf(e);

          return -1 == t ? null : t;
        }
      }, {
        key: "getNodeStartOffset",
        value: function getNodeStartOffset(e) {
          var t = this.getNodeIndex(e);
          return null === t ? null : this._nodes.slice(0, t).reduce(function (e, t) {
            return e + t.offsetSize;
          }, 0);
        }
      }, {
        key: "indexToOffset",
        value: function indexToOffset(e) {
          if (e == this._nodes.length) return this.maxOffset;
          var t = this._nodes[e];
          if (!t) throw new c.a("model-nodelist-index-out-of-bounds", this);
          return this.getNodeStartOffset(t);
        }
      }, {
        key: "offsetToIndex",
        value: function offsetToIndex(e) {
          var t = 0;
          var _iteratorNormalCompletion103 = true;
          var _didIteratorError103 = false;
          var _iteratorError103 = undefined;

          try {
            for (var _iterator103 = this._nodes[Symbol.iterator](), _step103; !(_iteratorNormalCompletion103 = (_step103 = _iterator103.next()).done); _iteratorNormalCompletion103 = true) {
              var _i91 = _step103.value;
              if (e >= t && e < t + _i91.offsetSize) return this.getNodeIndex(_i91);
              t += _i91.offsetSize;
            }
          } catch (err) {
            _didIteratorError103 = true;
            _iteratorError103 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion103 && _iterator103.return != null) {
                _iterator103.return();
              }
            } finally {
              if (_didIteratorError103) {
                throw _iteratorError103;
              }
            }
          }

          if (t != e) throw new c.a("model-nodelist-offset-out-of-bounds", this, {
            offset: e,
            nodeList: this
          });
          return this.length;
        }
      }, {
        key: "_insertNodes",
        value: function _insertNodes(e, t) {
          var _this$_nodes;

          var _iteratorNormalCompletion104 = true;
          var _didIteratorError104 = false;
          var _iteratorError104 = undefined;

          try {
            for (var _iterator104 = t[Symbol.iterator](), _step104; !(_iteratorNormalCompletion104 = (_step104 = _iterator104.next()).done); _iteratorNormalCompletion104 = true) {
              var _e77 = _step104.value;
              if (!(_e77 instanceof Ks)) throw new c.a("model-nodelist-insertnodes-not-node", this);
            }
          } catch (err) {
            _didIteratorError104 = true;
            _iteratorError104 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion104 && _iterator104.return != null) {
                _iterator104.return();
              }
            } finally {
              if (_didIteratorError104) {
                throw _iteratorError104;
              }
            }
          }

          (_this$_nodes = this._nodes).splice.apply(_this$_nodes, [e, 0].concat(_toConsumableArray(t)));
        }
      }, {
        key: "_removeNodes",
        value: function _removeNodes(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
          return this._nodes.splice(e, t);
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          return this._nodes.map(function (e) {
            return e.toJSON();
          });
        }
      }, {
        key: "length",
        get: function get() {
          return this._nodes.length;
        }
      }, {
        key: "maxOffset",
        get: function get() {
          return this._nodes.reduce(function (e, t) {
            return e + t.offsetSize;
          }, 0);
        }
      }]);

      return Zs;
    }();

    var Xs =
    /*#__PURE__*/
    function (_Ks2) {
      _inherits(Xs, _Ks2);

      function Xs(e, t, i) {
        var _this50;

        _classCallCheck(this, Xs);

        _this50 = _possibleConstructorReturn(this, _getPrototypeOf(Xs).call(this, t)), _this50.name = e, _this50._children = new Zs(), i && _this50._insertChild(0, i);
        return _this50;
      }

      _createClass(Xs, [{
        key: "is",
        value: function is(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          return t ? t === this.name && ("element" === e || "model:element" === e) : "element" === e || "model:element" === e || "node" === e || "model:node" === e;
        }
      }, {
        key: "getChild",
        value: function getChild(e) {
          return this._children.getNode(e);
        }
      }, {
        key: "getChildren",
        value: function getChildren() {
          return this._children[Symbol.iterator]();
        }
      }, {
        key: "getChildIndex",
        value: function getChildIndex(e) {
          return this._children.getNodeIndex(e);
        }
      }, {
        key: "getChildStartOffset",
        value: function getChildStartOffset(e) {
          return this._children.getNodeStartOffset(e);
        }
      }, {
        key: "offsetToIndex",
        value: function offsetToIndex(e) {
          return this._children.offsetToIndex(e);
        }
      }, {
        key: "getNodeByPath",
        value: function getNodeByPath(e) {
          var t = this;
          var _iteratorNormalCompletion105 = true;
          var _didIteratorError105 = false;
          var _iteratorError105 = undefined;

          try {
            for (var _iterator105 = e[Symbol.iterator](), _step105; !(_iteratorNormalCompletion105 = (_step105 = _iterator105.next()).done); _iteratorNormalCompletion105 = true) {
              var _i92 = _step105.value;
              t = t.getChild(t.offsetToIndex(_i92));
            }
          } catch (err) {
            _didIteratorError105 = true;
            _iteratorError105 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion105 && _iterator105.return != null) {
                _iterator105.return();
              }
            } finally {
              if (_didIteratorError105) {
                throw _iteratorError105;
              }
            }
          }

          return t;
        }
      }, {
        key: "findAncestor",
        value: function findAncestor(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            includeSelf: !1
          };
          var i = t.includeSelf ? this : this.parent;

          for (; i;) {
            if (i.name === e) return i;
            i = i.parent;
          }

          return null;
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var e = _get(_getPrototypeOf(Xs.prototype), "toJSON", this).call(this);

          if (e.name = this.name, this._children.length > 0) {
            e.children = [];
            var _iteratorNormalCompletion106 = true;
            var _didIteratorError106 = false;
            var _iteratorError106 = undefined;

            try {
              for (var _iterator106 = this._children[Symbol.iterator](), _step106; !(_iteratorNormalCompletion106 = (_step106 = _iterator106.next()).done); _iteratorNormalCompletion106 = true) {
                var _t80 = _step106.value;
                e.children.push(_t80.toJSON());
              }
            } catch (err) {
              _didIteratorError106 = true;
              _iteratorError106 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion106 && _iterator106.return != null) {
                  _iterator106.return();
                }
              } finally {
                if (_didIteratorError106) {
                  throw _iteratorError106;
                }
              }
            }
          }

          return e;
        }
      }, {
        key: "_clone",
        value: function _clone() {
          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
          var t = e ? Array.from(this._children).map(function (e) {
            return e._clone(!0);
          }) : null;
          return new Xs(this.name, this.getAttributes(), t);
        }
      }, {
        key: "_appendChild",
        value: function _appendChild(e) {
          this._insertChild(this.childCount, e);
        }
      }, {
        key: "_insertChild",
        value: function _insertChild(e, t) {
          var i = function (e) {
            if ("string" == typeof e) return [new Qs(e)];
            Ji(e) || (e = [e]);
            return Array.from(e).map(function (e) {
              return "string" == typeof e ? new Qs(e) : e instanceof Js ? new Qs(e.data, e.getAttributes()) : e;
            });
          }(t);

          var _iteratorNormalCompletion107 = true;
          var _didIteratorError107 = false;
          var _iteratorError107 = undefined;

          try {
            for (var _iterator107 = i[Symbol.iterator](), _step107; !(_iteratorNormalCompletion107 = (_step107 = _iterator107.next()).done); _iteratorNormalCompletion107 = true) {
              var _e78 = _step107.value;
              null !== _e78.parent && _e78._remove(), _e78.parent = this;
            }
          } catch (err) {
            _didIteratorError107 = true;
            _iteratorError107 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion107 && _iterator107.return != null) {
                _iterator107.return();
              }
            } finally {
              if (_didIteratorError107) {
                throw _iteratorError107;
              }
            }
          }

          this._children._insertNodes(e, i);
        }
      }, {
        key: "_removeChildren",
        value: function _removeChildren(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

          var i = this._children._removeNodes(e, t);

          var _iteratorNormalCompletion108 = true;
          var _didIteratorError108 = false;
          var _iteratorError108 = undefined;

          try {
            for (var _iterator108 = i[Symbol.iterator](), _step108; !(_iteratorNormalCompletion108 = (_step108 = _iterator108.next()).done); _iteratorNormalCompletion108 = true) {
              var _e79 = _step108.value;
              _e79.parent = null;
            }
          } catch (err) {
            _didIteratorError108 = true;
            _iteratorError108 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion108 && _iterator108.return != null) {
                _iterator108.return();
              }
            } finally {
              if (_didIteratorError108) {
                throw _iteratorError108;
              }
            }
          }

          return i;
        }
      }, {
        key: "childCount",
        get: function get() {
          return this._children.length;
        }
      }, {
        key: "maxOffset",
        get: function get() {
          return this._children.maxOffset;
        }
      }, {
        key: "isEmpty",
        get: function get() {
          return 0 === this.childCount;
        }
      }], [{
        key: "fromJSON",
        value: function fromJSON(e) {
          var t = null;

          if (e.children) {
            t = [];
            var _iteratorNormalCompletion109 = true;
            var _didIteratorError109 = false;
            var _iteratorError109 = undefined;

            try {
              for (var _iterator109 = e.children[Symbol.iterator](), _step109; !(_iteratorNormalCompletion109 = (_step109 = _iterator109.next()).done); _iteratorNormalCompletion109 = true) {
                var _i93 = _step109.value;
                _i93.name ? t.push(Xs.fromJSON(_i93)) : t.push(Qs.fromJSON(_i93));
              }
            } catch (err) {
              _didIteratorError109 = true;
              _iteratorError109 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion109 && _iterator109.return != null) {
                  _iterator109.return();
                }
              } finally {
                if (_didIteratorError109) {
                  throw _iteratorError109;
                }
              }
            }
          }

          return new Xs(e.name, e.attributes, t);
        }
      }]);

      return Xs;
    }(Ks);

    var ea =
    /*#__PURE__*/
    function () {
      function ea() {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, ea);

        if (!e.boundaries && !e.startPosition) throw new c.a("model-tree-walker-no-start-position", null);
        var t = e.direction || "forward";
        if ("forward" != t && "backward" != t) throw new c.a("model-tree-walker-unknown-direction", e, {
          direction: t
        });
        this.direction = t, this.boundaries = e.boundaries || null, e.startPosition ? this.position = e.startPosition.clone() : this.position = ia._createAt(this.boundaries["backward" == this.direction ? "end" : "start"]), this.position.stickiness = "toNone", this.singleCharacters = !!e.singleCharacters, this.shallow = !!e.shallow, this.ignoreElementEnd = !!e.ignoreElementEnd, this._boundaryStartParent = this.boundaries ? this.boundaries.start.parent : null, this._boundaryEndParent = this.boundaries ? this.boundaries.end.parent : null, this._visitedParent = this.position.parent;
      }

      _createClass(ea, [{
        key: Symbol.iterator,
        value: function value() {
          return this;
        }
      }, {
        key: "skip",
        value: function skip(e) {
          var t, i, n, o;

          do {
            var _this$next2;

            n = this.position, o = this._visitedParent, (_this$next2 = this.next(), t = _this$next2.done, i = _this$next2.value, _this$next2);
          } while (!t && e(i));

          t || (this.position = n, this._visitedParent = o);
        }
      }, {
        key: "next",
        value: function next() {
          return "forward" == this.direction ? this._next() : this._previous();
        }
      }, {
        key: "_next",
        value: function _next() {
          var e = this.position,
              t = this.position.clone(),
              i = this._visitedParent;
          if (null === i.parent && t.offset === i.maxOffset) return {
            done: !0
          };
          if (i === this._boundaryEndParent && t.offset == this.boundaries.end.offset) return {
            done: !0
          };
          var n = t.parent,
              o = na(t, n),
              r = o || oa(t, n, o);
          if (r instanceof Xs) return this.shallow ? t.offset++ : (t.path.push(0), this._visitedParent = r), this.position = t, ta("elementStart", r, e, t, 1);

          if (r instanceof Qs) {
            var _n41;

            if (this.singleCharacters) _n41 = 1;else {
              var _e80 = r.endOffset;
              this._boundaryEndParent == i && this.boundaries.end.offset < _e80 && (_e80 = this.boundaries.end.offset), _n41 = _e80 - t.offset;
            }

            var _o30 = t.offset - r.startOffset,
                _s11 = new Js(r, _o30, _n41);

            return t.offset += _n41, this.position = t, ta("text", _s11, e, t, _n41);
          }

          return t.path.pop(), t.offset++, this.position = t, this._visitedParent = i.parent, this.ignoreElementEnd ? this._next() : ta("elementEnd", i, e, t);
        }
      }, {
        key: "_previous",
        value: function _previous() {
          var e = this.position,
              t = this.position.clone(),
              i = this._visitedParent;
          if (null === i.parent && 0 === t.offset) return {
            done: !0
          };
          if (i == this._boundaryStartParent && t.offset == this.boundaries.start.offset) return {
            done: !0
          };
          var n = t.parent,
              o = na(t, n),
              r = o || ra(t, n, o);
          if (r instanceof Xs) return t.offset--, this.shallow ? (this.position = t, ta("elementStart", r, e, t, 1)) : (t.path.push(r.maxOffset), this.position = t, this._visitedParent = r, this.ignoreElementEnd ? this._previous() : ta("elementEnd", r, e, t));

          if (r instanceof Qs) {
            var _n42;

            if (this.singleCharacters) _n42 = 1;else {
              var _e81 = r.startOffset;
              this._boundaryStartParent == i && this.boundaries.start.offset > _e81 && (_e81 = this.boundaries.start.offset), _n42 = t.offset - _e81;
            }

            var _o31 = t.offset - r.startOffset,
                _s12 = new Js(r, _o31 - _n42, _n42);

            return t.offset -= _n42, this.position = t, ta("text", _s12, e, t, _n42);
          }

          return t.path.pop(), this.position = t, this._visitedParent = i.parent, ta("elementStart", i, e, t, 1);
        }
      }]);

      return ea;
    }();

    function ta(e, t, i, n, o) {
      return {
        done: !1,
        value: {
          type: e,
          item: t,
          previousPosition: i,
          nextPosition: n,
          length: o
        }
      };
    }

    var ia =
    /*#__PURE__*/
    function () {
      function ia(e, t) {
        var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "toNone";

        _classCallCheck(this, ia);

        if (!e.is("element") && !e.is("documentFragment")) throw new c.a("model-position-root-invalid", e);
        if (!(t instanceof Array) || 0 === t.length) throw new c.a("model-position-path-incorrect-format", e, {
          path: t
        });
        e.is("rootElement") ? t = t.slice() : (t = [].concat(_toConsumableArray(e.getPath()), _toConsumableArray(t)), e = e.root), this.root = e, this.path = t, this.stickiness = i;
      }

      _createClass(ia, [{
        key: "compareWith",
        value: function compareWith(e) {
          if (this.root != e.root) return "different";
          var t = cn(this.path, e.path);

          switch (t) {
            case "same":
              return "same";

            case "prefix":
              return "before";

            case "extension":
              return "after";

            default:
              return this.path[t] < e.path[t] ? "before" : "after";
          }
        }
      }, {
        key: "getLastMatchingPosition",
        value: function getLastMatchingPosition(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          t.startPosition = this;
          var i = new ea(t);
          return i.skip(e), i.position;
        }
      }, {
        key: "getParentPath",
        value: function getParentPath() {
          return this.path.slice(0, -1);
        }
      }, {
        key: "getAncestors",
        value: function getAncestors() {
          var e = this.parent;
          return e.is("documentFragment") ? [e] : e.getAncestors({
            includeSelf: !0
          });
        }
      }, {
        key: "findAncestor",
        value: function findAncestor(e) {
          var t = this.parent;
          return t.is("element") ? t.findAncestor(e, {
            includeSelf: !0
          }) : null;
        }
      }, {
        key: "getCommonPath",
        value: function getCommonPath(e) {
          if (this.root != e.root) return [];
          var t = cn(this.path, e.path),
              i = "string" == typeof t ? Math.min(this.path.length, e.path.length) : t;
          return this.path.slice(0, i);
        }
      }, {
        key: "getCommonAncestor",
        value: function getCommonAncestor(e) {
          var t = this.getAncestors(),
              i = e.getAncestors();
          var n = 0;

          for (; t[n] == i[n] && t[n];) {
            n++;
          }

          return 0 === n ? null : t[n - 1];
        }
      }, {
        key: "getShiftedBy",
        value: function getShiftedBy(e) {
          var t = this.clone(),
              i = t.offset + e;
          return t.offset = i < 0 ? 0 : i, t;
        }
      }, {
        key: "isAfter",
        value: function isAfter(e) {
          return "after" == this.compareWith(e);
        }
      }, {
        key: "isBefore",
        value: function isBefore(e) {
          return "before" == this.compareWith(e);
        }
      }, {
        key: "isEqual",
        value: function isEqual(e) {
          return "same" == this.compareWith(e);
        }
      }, {
        key: "isTouching",
        value: function isTouching(e) {
          var t = null,
              i = null;

          switch (this.compareWith(e)) {
            case "same":
              return !0;

            case "before":
              t = ia._createAt(this), i = ia._createAt(e);
              break;

            case "after":
              t = ia._createAt(e), i = ia._createAt(this);
              break;

            default:
              return !1;
          }

          var n = t.parent;

          for (; t.path.length + i.path.length;) {
            if (t.isEqual(i)) return !0;

            if (t.path.length > i.path.length) {
              if (t.offset !== n.maxOffset) return !1;
              t.path = t.path.slice(0, -1), n = n.parent, t.offset++;
            } else {
              if (0 !== i.offset) return !1;
              i.path = i.path.slice(0, -1);
            }
          }
        }
      }, {
        key: "is",
        value: function is(e) {
          return "position" === e || "model:position" === e;
        }
      }, {
        key: "hasSameParentAs",
        value: function hasSameParentAs(e) {
          if (this.root !== e.root) return !1;
          return "same" == cn(this.getParentPath(), e.getParentPath());
        }
      }, {
        key: "getTransformedByOperation",
        value: function getTransformedByOperation(e) {
          var t;

          switch (e.type) {
            case "insert":
              t = this._getTransformedByInsertOperation(e);
              break;

            case "move":
            case "remove":
            case "reinsert":
              t = this._getTransformedByMoveOperation(e);
              break;

            case "split":
              t = this._getTransformedBySplitOperation(e);
              break;

            case "merge":
              t = this._getTransformedByMergeOperation(e);
              break;

            default:
              t = ia._createAt(this);
          }

          return t;
        }
      }, {
        key: "_getTransformedByInsertOperation",
        value: function _getTransformedByInsertOperation(e) {
          return this._getTransformedByInsertion(e.position, e.howMany);
        }
      }, {
        key: "_getTransformedByMoveOperation",
        value: function _getTransformedByMoveOperation(e) {
          return this._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany);
        }
      }, {
        key: "_getTransformedBySplitOperation",
        value: function _getTransformedBySplitOperation(e) {
          var t = e.movedRange;
          return t.containsPosition(this) || t.start.isEqual(this) && "toNext" == this.stickiness ? this._getCombined(e.splitPosition, e.moveTargetPosition) : e.graveyardPosition ? this._getTransformedByMove(e.graveyardPosition, e.insertionPosition, 1) : this._getTransformedByInsertion(e.insertionPosition, 1);
        }
      }, {
        key: "_getTransformedByMergeOperation",
        value: function _getTransformedByMergeOperation(e) {
          var t = e.movedRange;
          var i;
          return t.containsPosition(this) || t.start.isEqual(this) ? (i = this._getCombined(e.sourcePosition, e.targetPosition), e.sourcePosition.isBefore(e.targetPosition) && (i = i._getTransformedByDeletion(e.deletionPosition, 1))) : i = this.isEqual(e.deletionPosition) ? ia._createAt(e.deletionPosition) : this._getTransformedByMove(e.deletionPosition, e.graveyardPosition, 1), i;
        }
      }, {
        key: "_getTransformedByDeletion",
        value: function _getTransformedByDeletion(e, t) {
          var i = ia._createAt(this);

          if (this.root != e.root) return i;

          if ("same" == cn(e.getParentPath(), this.getParentPath())) {
            if (e.offset < this.offset) {
              if (e.offset + t > this.offset) return null;
              i.offset -= t;
            }
          } else if ("prefix" == cn(e.getParentPath(), this.getParentPath())) {
            var _n43 = e.path.length - 1;

            if (e.offset <= this.path[_n43]) {
              if (e.offset + t > this.path[_n43]) return null;
              i.path[_n43] -= t;
            }
          }

          return i;
        }
      }, {
        key: "_getTransformedByInsertion",
        value: function _getTransformedByInsertion(e, t) {
          var i = ia._createAt(this);

          if (this.root != e.root) return i;
          if ("same" == cn(e.getParentPath(), this.getParentPath())) (e.offset < this.offset || e.offset == this.offset && "toPrevious" != this.stickiness) && (i.offset += t);else if ("prefix" == cn(e.getParentPath(), this.getParentPath())) {
            var _n44 = e.path.length - 1;

            e.offset <= this.path[_n44] && (i.path[_n44] += t);
          }
          return i;
        }
      }, {
        key: "_getTransformedByMove",
        value: function _getTransformedByMove(e, t, i) {
          if (t = t._getTransformedByDeletion(e, i), e.isEqual(t)) return ia._createAt(this);

          var n = this._getTransformedByDeletion(e, i);

          return null === n || e.isEqual(this) && "toNext" == this.stickiness || e.getShiftedBy(i).isEqual(this) && "toPrevious" == this.stickiness ? this._getCombined(e, t) : n._getTransformedByInsertion(t, i);
        }
      }, {
        key: "_getCombined",
        value: function _getCombined(e, t) {
          var i = e.path.length - 1,
              n = ia._createAt(t);

          return n.stickiness = this.stickiness, n.offset = n.offset + this.path[i] - e.offset, n.path = [].concat(_toConsumableArray(n.path), _toConsumableArray(this.path.slice(i + 1))), n;
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          return {
            root: this.root.toJSON(),
            path: Array.from(this.path),
            stickiness: this.stickiness
          };
        }
      }, {
        key: "clone",
        value: function clone() {
          return new this.constructor(this.root, this.path, this.stickiness);
        }
      }, {
        key: "offset",
        get: function get() {
          return this.path[this.path.length - 1];
        },
        set: function set(e) {
          this.path[this.path.length - 1] = e;
        }
      }, {
        key: "parent",
        get: function get() {
          var e = this.root;

          for (var _t81 = 0; _t81 < this.path.length - 1; _t81++) {
            if (e = e.getChild(e.offsetToIndex(this.path[_t81])), !e) throw new c.a("model-position-path-incorrect", this, {
              position: this
            });
          }

          if (e.is("$text")) throw new c.a("model-position-path-incorrect", this, {
            position: this
          });
          return e;
        }
      }, {
        key: "index",
        get: function get() {
          return this.parent.offsetToIndex(this.offset);
        }
      }, {
        key: "textNode",
        get: function get() {
          return na(this, this.parent);
        }
      }, {
        key: "nodeAfter",
        get: function get() {
          var e = this.parent;
          return oa(this, e, na(this, e));
        }
      }, {
        key: "nodeBefore",
        get: function get() {
          var e = this.parent;
          return ra(this, e, na(this, e));
        }
      }, {
        key: "isAtStart",
        get: function get() {
          return 0 === this.offset;
        }
      }, {
        key: "isAtEnd",
        get: function get() {
          return this.offset == this.parent.maxOffset;
        }
      }], [{
        key: "_createAt",
        value: function _createAt(e, t) {
          var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "toNone";
          if (e instanceof ia) return new ia(e.root, e.path, e.stickiness);
          {
            var _n45 = e;
            if ("end" == t) t = _n45.maxOffset;else {
              if ("before" == t) return this._createBefore(_n45, i);
              if ("after" == t) return this._createAfter(_n45, i);
              if (0 !== t && !t) throw new c.a("model-createpositionat-offset-required", [this, e]);
            }
            if (!_n45.is("element") && !_n45.is("documentFragment")) throw new c.a("model-position-parent-incorrect", [this, e]);

            var _o32 = _n45.getPath();

            return _o32.push(t), new this(_n45.root, _o32, i);
          }
        }
      }, {
        key: "_createAfter",
        value: function _createAfter(e, t) {
          if (!e.parent) throw new c.a("model-position-after-root", [this, e], {
            root: e
          });
          return this._createAt(e.parent, e.endOffset, t);
        }
      }, {
        key: "_createBefore",
        value: function _createBefore(e, t) {
          if (!e.parent) throw new c.a("model-position-before-root", e, {
            root: e
          });
          return this._createAt(e.parent, e.startOffset, t);
        }
      }, {
        key: "fromJSON",
        value: function fromJSON(e, t) {
          if ("$graveyard" === e.root) {
            var _i94 = new ia(t.graveyard, e.path);

            return _i94.stickiness = e.stickiness, _i94;
          }

          if (!t.getRoot(e.root)) throw new c.a("model-position-fromjson-no-root", t, {
            rootName: e.root
          });
          return new ia(t.getRoot(e.root), e.path, e.stickiness);
        }
      }]);

      return ia;
    }();

    function na(e, t) {
      var i = t.getChild(t.offsetToIndex(e.offset));
      return i && i.is("$text") && i.startOffset < e.offset ? i : null;
    }

    function oa(e, t, i) {
      return null !== i ? null : t.getChild(t.offsetToIndex(e.offset));
    }

    function ra(e, t, i) {
      return null !== i ? null : t.getChild(t.offsetToIndex(e.offset) - 1);
    }

    var sa =
    /*#__PURE__*/
    function () {
      function sa(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

        _classCallCheck(this, sa);

        this.start = ia._createAt(e), this.end = t ? ia._createAt(t) : ia._createAt(e), this.start.stickiness = this.isCollapsed ? "toNone" : "toNext", this.end.stickiness = this.isCollapsed ? "toNone" : "toPrevious";
      }

      _createClass(sa, [{
        key: Symbol.iterator,
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function value() {
          return _regeneratorRuntime.wrap(function value$(_context13) {
            while (1) {
              switch (_context13.prev = _context13.next) {
                case 0:
                  return _context13.delegateYield(new ea({
                    boundaries: this,
                    ignoreElementEnd: !0
                  }), "t0", 1);

                case 1:
                case "end":
                  return _context13.stop();
              }
            }
          }, value, this);
        })
      }, {
        key: "containsPosition",
        value: function containsPosition(e) {
          return e.isAfter(this.start) && e.isBefore(this.end);
        }
      }, {
        key: "containsRange",
        value: function containsRange(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          e.isCollapsed && (t = !1);
          var i = this.containsPosition(e.start) || t && this.start.isEqual(e.start),
              n = this.containsPosition(e.end) || t && this.end.isEqual(e.end);
          return i && n;
        }
      }, {
        key: "containsItem",
        value: function containsItem(e) {
          var t = ia._createBefore(e);

          return this.containsPosition(t) || this.start.isEqual(t);
        }
      }, {
        key: "is",
        value: function is(e) {
          return "range" === e || "model:range" === e;
        }
      }, {
        key: "isEqual",
        value: function isEqual(e) {
          return this.start.isEqual(e.start) && this.end.isEqual(e.end);
        }
      }, {
        key: "isIntersecting",
        value: function isIntersecting(e) {
          return this.start.isBefore(e.end) && this.end.isAfter(e.start);
        }
      }, {
        key: "getDifference",
        value: function getDifference(e) {
          var t = [];
          return this.isIntersecting(e) ? (this.containsPosition(e.start) && t.push(new sa(this.start, e.start)), this.containsPosition(e.end) && t.push(new sa(e.end, this.end))) : t.push(new sa(this.start, this.end)), t;
        }
      }, {
        key: "getIntersection",
        value: function getIntersection(e) {
          if (this.isIntersecting(e)) {
            var _t82 = this.start,
                _i95 = this.end;
            return this.containsPosition(e.start) && (_t82 = e.start), this.containsPosition(e.end) && (_i95 = e.end), new sa(_t82, _i95);
          }

          return null;
        }
      }, {
        key: "getJoined",
        value: function getJoined(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          var i = this.isIntersecting(e);
          if (i || (i = this.start.isBefore(e.start) ? t ? this.end.isTouching(e.start) : this.end.isEqual(e.start) : t ? e.end.isTouching(this.start) : e.end.isEqual(this.start)), !i) return null;
          var n = this.start,
              o = this.end;
          return e.start.isBefore(n) && (n = e.start), e.end.isAfter(o) && (o = e.end), new sa(n, o);
        }
      }, {
        key: "getMinimalFlatRanges",
        value: function getMinimalFlatRanges() {
          var e = [],
              t = this.start.getCommonPath(this.end).length,
              i = ia._createAt(this.start);

          var n = i.parent;

          for (; i.path.length > t + 1;) {
            var _t83 = n.maxOffset - i.offset;

            0 !== _t83 && e.push(new sa(i, i.getShiftedBy(_t83))), i.path = i.path.slice(0, -1), i.offset++, n = n.parent;
          }

          for (; i.path.length <= this.end.path.length;) {
            var _t84 = this.end.path[i.path.length - 1],
                _n46 = _t84 - i.offset;

            0 !== _n46 && e.push(new sa(i, i.getShiftedBy(_n46))), i.offset = _t84, i.path.push(0);
          }

          return e;
        }
      }, {
        key: "getWalker",
        value: function getWalker() {
          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          return e.boundaries = this, new ea(e);
        }
      }, {
        key: "getItems",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function getItems() {
          var e,
              t,
              _iteratorNormalCompletion110,
              _didIteratorError110,
              _iteratorError110,
              _iterator110,
              _step110,
              _e82,
              _args14 = arguments;

          return _regeneratorRuntime.wrap(function getItems$(_context14) {
            while (1) {
              switch (_context14.prev = _context14.next) {
                case 0:
                  e = _args14.length > 0 && _args14[0] !== undefined ? _args14[0] : {};
                  e.boundaries = this, e.ignoreElementEnd = !0;
                  t = new ea(e);
                  _iteratorNormalCompletion110 = true;
                  _didIteratorError110 = false;
                  _iteratorError110 = undefined;
                  _context14.prev = 6;
                  _iterator110 = t[Symbol.iterator]();

                case 8:
                  if (_iteratorNormalCompletion110 = (_step110 = _iterator110.next()).done) {
                    _context14.next = 15;
                    break;
                  }

                  _e82 = _step110.value;
                  _context14.next = 12;
                  return _e82.item;

                case 12:
                  _iteratorNormalCompletion110 = true;
                  _context14.next = 8;
                  break;

                case 15:
                  _context14.next = 21;
                  break;

                case 17:
                  _context14.prev = 17;
                  _context14.t0 = _context14["catch"](6);
                  _didIteratorError110 = true;
                  _iteratorError110 = _context14.t0;

                case 21:
                  _context14.prev = 21;
                  _context14.prev = 22;

                  if (!_iteratorNormalCompletion110 && _iterator110.return != null) {
                    _iterator110.return();
                  }

                case 24:
                  _context14.prev = 24;

                  if (!_didIteratorError110) {
                    _context14.next = 27;
                    break;
                  }

                  throw _iteratorError110;

                case 27:
                  return _context14.finish(24);

                case 28:
                  return _context14.finish(21);

                case 29:
                case "end":
                  return _context14.stop();
              }
            }
          }, getItems, this, [[6, 17, 21, 29], [22,, 24, 28]]);
        })
      }, {
        key: "getPositions",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function getPositions() {
          var e,
              t,
              _iteratorNormalCompletion111,
              _didIteratorError111,
              _iteratorError111,
              _iterator111,
              _step111,
              _e83,
              _args15 = arguments;

          return _regeneratorRuntime.wrap(function getPositions$(_context15) {
            while (1) {
              switch (_context15.prev = _context15.next) {
                case 0:
                  e = _args15.length > 0 && _args15[0] !== undefined ? _args15[0] : {};
                  e.boundaries = this;
                  t = new ea(e);
                  _context15.next = 5;
                  return t.position;

                case 5:
                  _iteratorNormalCompletion111 = true;
                  _didIteratorError111 = false;
                  _iteratorError111 = undefined;
                  _context15.prev = 8;
                  _iterator111 = t[Symbol.iterator]();

                case 10:
                  if (_iteratorNormalCompletion111 = (_step111 = _iterator111.next()).done) {
                    _context15.next = 17;
                    break;
                  }

                  _e83 = _step111.value;
                  _context15.next = 14;
                  return _e83.nextPosition;

                case 14:
                  _iteratorNormalCompletion111 = true;
                  _context15.next = 10;
                  break;

                case 17:
                  _context15.next = 23;
                  break;

                case 19:
                  _context15.prev = 19;
                  _context15.t0 = _context15["catch"](8);
                  _didIteratorError111 = true;
                  _iteratorError111 = _context15.t0;

                case 23:
                  _context15.prev = 23;
                  _context15.prev = 24;

                  if (!_iteratorNormalCompletion111 && _iterator111.return != null) {
                    _iterator111.return();
                  }

                case 26:
                  _context15.prev = 26;

                  if (!_didIteratorError111) {
                    _context15.next = 29;
                    break;
                  }

                  throw _iteratorError111;

                case 29:
                  return _context15.finish(26);

                case 30:
                  return _context15.finish(23);

                case 31:
                case "end":
                  return _context15.stop();
              }
            }
          }, getPositions, this, [[8, 19, 23, 31], [24,, 26, 30]]);
        })
      }, {
        key: "getTransformedByOperation",
        value: function getTransformedByOperation(e) {
          switch (e.type) {
            case "insert":
              return this._getTransformedByInsertOperation(e);

            case "move":
            case "remove":
            case "reinsert":
              return this._getTransformedByMoveOperation(e);

            case "split":
              return [this._getTransformedBySplitOperation(e)];

            case "merge":
              return [this._getTransformedByMergeOperation(e)];
          }

          return [new sa(this.start, this.end)];
        }
      }, {
        key: "getTransformedByOperations",
        value: function getTransformedByOperations(e) {
          var t = [new sa(this.start, this.end)];
          var _iteratorNormalCompletion112 = true;
          var _didIteratorError112 = false;
          var _iteratorError112 = undefined;

          try {
            for (var _iterator112 = e[Symbol.iterator](), _step112; !(_iteratorNormalCompletion112 = (_step112 = _iterator112.next()).done); _iteratorNormalCompletion112 = true) {
              var _i97 = _step112.value;

              for (var _e86 = 0; _e86 < t.length; _e86++) {
                var _n48 = t[_e86].getTransformedByOperation(_i97);

                t.splice.apply(t, [_e86, 1].concat(_toConsumableArray(_n48))), _e86 += _n48.length - 1;
              }
            }
          } catch (err) {
            _didIteratorError112 = true;
            _iteratorError112 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion112 && _iterator112.return != null) {
                _iterator112.return();
              }
            } finally {
              if (_didIteratorError112) {
                throw _iteratorError112;
              }
            }
          }

          for (var _e84 = 0; _e84 < t.length; _e84++) {
            var _i96 = t[_e84];

            for (var _n47 = _e84 + 1; _n47 < t.length; _n47++) {
              var _e85 = t[_n47];
              (_i96.containsRange(_e85) || _e85.containsRange(_i96) || _i96.isEqual(_e85)) && t.splice(_n47, 1);
            }
          }

          return t;
        }
      }, {
        key: "getCommonAncestor",
        value: function getCommonAncestor() {
          return this.start.getCommonAncestor(this.end);
        }
      }, {
        key: "getContainedElement",
        value: function getContainedElement() {
          if (this.isCollapsed) return null;
          var e = this.start.nodeAfter,
              t = this.end.nodeBefore;
          return e && e.is("element") && e === t ? e : null;
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          return {
            start: this.start.toJSON(),
            end: this.end.toJSON()
          };
        }
      }, {
        key: "clone",
        value: function clone() {
          return new this.constructor(this.start, this.end);
        }
      }, {
        key: "_getTransformedByInsertOperation",
        value: function _getTransformedByInsertOperation(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          return this._getTransformedByInsertion(e.position, e.howMany, t);
        }
      }, {
        key: "_getTransformedByMoveOperation",
        value: function _getTransformedByMoveOperation(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          var i = e.sourcePosition,
              n = e.howMany,
              o = e.targetPosition;
          return this._getTransformedByMove(i, o, n, t);
        }
      }, {
        key: "_getTransformedBySplitOperation",
        value: function _getTransformedBySplitOperation(e) {
          var t = this.start._getTransformedBySplitOperation(e);

          var i = this.end._getTransformedBySplitOperation(e);

          return this.end.isEqual(e.insertionPosition) && (i = this.end.getShiftedBy(1)), t.root != i.root && (i = this.end.getShiftedBy(-1)), new sa(t, i);
        }
      }, {
        key: "_getTransformedByMergeOperation",
        value: function _getTransformedByMergeOperation(e) {
          if (this.start.isEqual(e.targetPosition) && this.end.isEqual(e.deletionPosition)) return new sa(this.start);

          var t = this.start._getTransformedByMergeOperation(e),
              i = this.end._getTransformedByMergeOperation(e);

          return t.root != i.root && (i = this.end.getShiftedBy(-1)), t.isAfter(i) ? (e.sourcePosition.isBefore(e.targetPosition) ? (t = ia._createAt(i), t.offset = 0) : (e.deletionPosition.isEqual(t) || (i = e.deletionPosition), t = e.targetPosition), new sa(t, i)) : new sa(t, i);
        }
      }, {
        key: "_getTransformedByInsertion",
        value: function _getTransformedByInsertion(e, t) {
          var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
          if (i && this.containsPosition(e)) return [new sa(this.start, e), new sa(e.getShiftedBy(t), this.end._getTransformedByInsertion(e, t))];
          {
            var _i98 = new sa(this.start, this.end);

            return _i98.start = _i98.start._getTransformedByInsertion(e, t), _i98.end = _i98.end._getTransformedByInsertion(e, t), [_i98];
          }
        }
      }, {
        key: "_getTransformedByMove",
        value: function _getTransformedByMove(e, t, i) {
          var n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;

          if (this.isCollapsed) {
            var _n49 = this.start._getTransformedByMove(e, t, i);

            return [new sa(_n49)];
          }

          var o = sa._createFromPositionAndShift(e, i),
              r = t._getTransformedByDeletion(e, i);

          if (this.containsPosition(t) && !n && (o.containsPosition(this.start) || o.containsPosition(this.end))) {
            var _n50 = this.start._getTransformedByMove(e, t, i),
                _o33 = this.end._getTransformedByMove(e, t, i);

            return [new sa(_n50, _o33)];
          }

          var s;
          var a = this.getDifference(o);
          var c = null;
          var l = this.getIntersection(o);

          if (1 == a.length ? c = new sa(a[0].start._getTransformedByDeletion(e, i), a[0].end._getTransformedByDeletion(e, i)) : 2 == a.length && (c = new sa(this.start, this.end._getTransformedByDeletion(e, i))), s = c ? c._getTransformedByInsertion(r, i, null !== l || n) : [], l) {
            var _e87 = new sa(l.start._getCombined(o.start, r), l.end._getCombined(o.start, r));

            2 == s.length ? s.splice(1, 0, _e87) : s.push(_e87);
          }

          return s;
        }
      }, {
        key: "_getTransformedByDeletion",
        value: function _getTransformedByDeletion(e, t) {
          var i = this.start._getTransformedByDeletion(e, t),
              n = this.end._getTransformedByDeletion(e, t);

          return null == i && null == n ? null : (null == i && (i = e), null == n && (n = e), new sa(i, n));
        }
      }, {
        key: "isCollapsed",
        get: function get() {
          return this.start.isEqual(this.end);
        }
      }, {
        key: "isFlat",
        get: function get() {
          return "same" == cn(this.start.getParentPath(), this.end.getParentPath());
        }
      }, {
        key: "root",
        get: function get() {
          return this.start.root;
        }
      }], [{
        key: "_createFromPositionAndShift",
        value: function _createFromPositionAndShift(e, t) {
          var i = e,
              n = e.getShiftedBy(t);
          return t > 0 ? new this(i, n) : new this(n, i);
        }
      }, {
        key: "_createIn",
        value: function _createIn(e) {
          return new this(ia._createAt(e, 0), ia._createAt(e, e.maxOffset));
        }
      }, {
        key: "_createOn",
        value: function _createOn(e) {
          return this._createFromPositionAndShift(ia._createBefore(e), e.offsetSize);
        }
      }, {
        key: "_createFromRanges",
        value: function _createFromRanges(e) {
          if (0 === e.length) throw new c.a("range-create-from-ranges-empty-array", null);
          if (1 == e.length) return e[0].clone();
          var t = e[0];
          e.sort(function (e, t) {
            return e.start.isAfter(t.start) ? 1 : -1;
          });
          var i = e.indexOf(t),
              n = new this(t.start, t.end);
          if (i > 0) for (var _t85 = i - 1; e[_t85].end.isEqual(n.start); _t85++) {
            n.start = ia._createAt(e[_t85].start);
          }

          for (var _t86 = i + 1; _t86 < e.length && e[_t86].start.isEqual(n.end); _t86++) {
            n.end = ia._createAt(e[_t86].end);
          }

          return n;
        }
      }, {
        key: "fromJSON",
        value: function fromJSON(e, t) {
          return new this(ia.fromJSON(e.start, t), ia.fromJSON(e.end, t));
        }
      }]);

      return sa;
    }();

    var aa =
    /*#__PURE__*/
    function () {
      function aa() {
        var _this51 = this;

        _classCallCheck(this, aa);

        this._modelToViewMapping = new WeakMap(), this._viewToModelMapping = new WeakMap(), this._viewToModelLengthCallbacks = new Map(), this._markerNameToElements = new Map(), this._elementToMarkerNames = new Map(), this._unboundMarkerNames = new Set(), this.on("modelToViewPosition", function (e, t) {
          if (t.viewPosition) return;

          var i = _this51._modelToViewMapping.get(t.modelPosition.parent);

          t.viewPosition = _this51.findPositionIn(i, t.modelPosition.offset);
        }, {
          priority: "low"
        }), this.on("viewToModelPosition", function (e, t) {
          if (t.modelPosition) return;

          var i = _this51.findMappedViewAncestor(t.viewPosition),
              n = _this51._viewToModelMapping.get(i),
              o = _this51._toModelOffset(t.viewPosition.parent, t.viewPosition.offset, i);

          t.modelPosition = ia._createAt(n, o);
        }, {
          priority: "low"
        });
      }

      _createClass(aa, [{
        key: "bindElements",
        value: function bindElements(e, t) {
          this._modelToViewMapping.set(e, t), this._viewToModelMapping.set(t, e);
        }
      }, {
        key: "unbindViewElement",
        value: function unbindViewElement(e) {
          var t = this.toModelElement(e);

          if (this._viewToModelMapping.delete(e), this._elementToMarkerNames.has(e)) {
            var _iteratorNormalCompletion113 = true;
            var _didIteratorError113 = false;
            var _iteratorError113 = undefined;

            try {
              for (var _iterator113 = this._elementToMarkerNames.get(e)[Symbol.iterator](), _step113; !(_iteratorNormalCompletion113 = (_step113 = _iterator113.next()).done); _iteratorNormalCompletion113 = true) {
                var _t87 = _step113.value;

                this._unboundMarkerNames.add(_t87);
              }
            } catch (err) {
              _didIteratorError113 = true;
              _iteratorError113 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion113 && _iterator113.return != null) {
                  _iterator113.return();
                }
              } finally {
                if (_didIteratorError113) {
                  throw _iteratorError113;
                }
              }
            }
          }

          this._modelToViewMapping.get(t) == e && this._modelToViewMapping.delete(t);
        }
      }, {
        key: "unbindModelElement",
        value: function unbindModelElement(e) {
          var t = this.toViewElement(e);
          this._modelToViewMapping.delete(e), this._viewToModelMapping.get(t) == e && this._viewToModelMapping.delete(t);
        }
      }, {
        key: "bindElementToMarker",
        value: function bindElementToMarker(e, t) {
          var i = this._markerNameToElements.get(t) || new Set();
          i.add(e);
          var n = this._elementToMarkerNames.get(e) || new Set();
          n.add(t), this._markerNameToElements.set(t, i), this._elementToMarkerNames.set(e, n);
        }
      }, {
        key: "unbindElementFromMarkerName",
        value: function unbindElementFromMarkerName(e, t) {
          var i = this._markerNameToElements.get(t);

          i && (i.delete(e), 0 == i.size && this._markerNameToElements.delete(t));

          var n = this._elementToMarkerNames.get(e);

          n && (n.delete(t), 0 == n.size && this._elementToMarkerNames.delete(e));
        }
      }, {
        key: "flushUnboundMarkerNames",
        value: function flushUnboundMarkerNames() {
          var e = Array.from(this._unboundMarkerNames);
          return this._unboundMarkerNames.clear(), e;
        }
      }, {
        key: "clearBindings",
        value: function clearBindings() {
          this._modelToViewMapping = new WeakMap(), this._viewToModelMapping = new WeakMap(), this._markerNameToElements = new Map(), this._elementToMarkerNames = new Map(), this._unboundMarkerNames = new Set();
        }
      }, {
        key: "toModelElement",
        value: function toModelElement(e) {
          return this._viewToModelMapping.get(e);
        }
      }, {
        key: "toViewElement",
        value: function toViewElement(e) {
          return this._modelToViewMapping.get(e);
        }
      }, {
        key: "toModelRange",
        value: function toModelRange(e) {
          return new sa(this.toModelPosition(e.start), this.toModelPosition(e.end));
        }
      }, {
        key: "toViewRange",
        value: function toViewRange(e) {
          return new lo(this.toViewPosition(e.start), this.toViewPosition(e.end));
        }
      }, {
        key: "toModelPosition",
        value: function toModelPosition(e) {
          var t = {
            viewPosition: e,
            mapper: this
          };
          return this.fire("viewToModelPosition", t), t.modelPosition;
        }
      }, {
        key: "toViewPosition",
        value: function toViewPosition(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            isPhantom: !1
          };
          var i = {
            modelPosition: e,
            mapper: this,
            isPhantom: t.isPhantom
          };
          return this.fire("modelToViewPosition", i), i.viewPosition;
        }
      }, {
        key: "markerNameToElements",
        value: function markerNameToElements(e) {
          var t = this._markerNameToElements.get(e);

          if (!t) return null;
          var i = new Set();
          var _iteratorNormalCompletion114 = true;
          var _didIteratorError114 = false;
          var _iteratorError114 = undefined;

          try {
            for (var _iterator114 = t[Symbol.iterator](), _step114; !(_iteratorNormalCompletion114 = (_step114 = _iterator114.next()).done); _iteratorNormalCompletion114 = true) {
              var _e88 = _step114.value;

              if (_e88.is("attributeElement")) {
                var _iteratorNormalCompletion115 = true;
                var _didIteratorError115 = false;
                var _iteratorError115 = undefined;

                try {
                  for (var _iterator115 = _e88.getElementsWithSameId()[Symbol.iterator](), _step115; !(_iteratorNormalCompletion115 = (_step115 = _iterator115.next()).done); _iteratorNormalCompletion115 = true) {
                    var _t88 = _step115.value;
                    i.add(_t88);
                  }
                } catch (err) {
                  _didIteratorError115 = true;
                  _iteratorError115 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion115 && _iterator115.return != null) {
                      _iterator115.return();
                    }
                  } finally {
                    if (_didIteratorError115) {
                      throw _iteratorError115;
                    }
                  }
                }
              } else i.add(_e88);
            }
          } catch (err) {
            _didIteratorError114 = true;
            _iteratorError114 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion114 && _iterator114.return != null) {
                _iterator114.return();
              }
            } finally {
              if (_didIteratorError114) {
                throw _iteratorError114;
              }
            }
          }

          return i;
        }
      }, {
        key: "registerViewToModelLength",
        value: function registerViewToModelLength(e, t) {
          this._viewToModelLengthCallbacks.set(e, t);
        }
      }, {
        key: "findMappedViewAncestor",
        value: function findMappedViewAncestor(e) {
          var t = e.parent;

          for (; !this._viewToModelMapping.has(t);) {
            t = t.parent;
          }

          return t;
        }
      }, {
        key: "_toModelOffset",
        value: function _toModelOffset(e, t, i) {
          if (i != e) {
            return this._toModelOffset(e.parent, e.index, i) + this._toModelOffset(e, t, e);
          }

          if (e.is("$text")) return t;
          var n = 0;

          for (var _i99 = 0; _i99 < t; _i99++) {
            n += this.getModelLength(e.getChild(_i99));
          }

          return n;
        }
      }, {
        key: "getModelLength",
        value: function getModelLength(e) {
          if (this._viewToModelLengthCallbacks.get(e.name)) {
            return this._viewToModelLengthCallbacks.get(e.name)(e);
          }

          if (this._viewToModelMapping.has(e)) return 1;
          if (e.is("$text")) return e.data.length;
          if (e.is("uiElement")) return 0;
          {
            var _t89 = 0;
            var _iteratorNormalCompletion116 = true;
            var _didIteratorError116 = false;
            var _iteratorError116 = undefined;

            try {
              for (var _iterator116 = e.getChildren()[Symbol.iterator](), _step116; !(_iteratorNormalCompletion116 = (_step116 = _iterator116.next()).done); _iteratorNormalCompletion116 = true) {
                var _i100 = _step116.value;
                _t89 += this.getModelLength(_i100);
              }
            } catch (err) {
              _didIteratorError116 = true;
              _iteratorError116 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion116 && _iterator116.return != null) {
                  _iterator116.return();
                }
              } finally {
                if (_didIteratorError116) {
                  throw _iteratorError116;
                }
              }
            }

            return _t89;
          }
        }
      }, {
        key: "findPositionIn",
        value: function findPositionIn(e, t) {
          var i,
              n = 0,
              o = 0,
              r = 0;
          if (e.is("$text")) return new co(e, t);

          for (; o < t;) {
            i = e.getChild(r), n = this.getModelLength(i), o += n, r++;
          }

          return o == t ? this._moveViewPositionToTextNode(new co(e, r)) : this.findPositionIn(i, t - (o - n));
        }
      }, {
        key: "_moveViewPositionToTextNode",
        value: function _moveViewPositionToTextNode(e) {
          var t = e.nodeBefore,
              i = e.nodeAfter;
          return t instanceof hn ? new co(t, t.data.length) : i instanceof hn ? new co(i, 0) : e;
        }
      }]);

      return aa;
    }();

    Ke(aa, h);

    var ca =
    /*#__PURE__*/
    function () {
      function ca() {
        _classCallCheck(this, ca);

        this._consumable = new Map(), this._textProxyRegistry = new Map();
      }

      _createClass(ca, [{
        key: "add",
        value: function add(e, t) {
          t = la(t), e instanceof Js && (e = this._getSymbolForTextProxy(e)), this._consumable.has(e) || this._consumable.set(e, new Map()), this._consumable.get(e).set(t, !0);
        }
      }, {
        key: "consume",
        value: function consume(e, t) {
          return t = la(t), e instanceof Js && (e = this._getSymbolForTextProxy(e)), !!this.test(e, t) && (this._consumable.get(e).set(t, !1), !0);
        }
      }, {
        key: "test",
        value: function test(e, t) {
          t = la(t), e instanceof Js && (e = this._getSymbolForTextProxy(e));

          var i = this._consumable.get(e);

          if (void 0 === i) return null;
          var n = i.get(t);
          return void 0 === n ? null : n;
        }
      }, {
        key: "revert",
        value: function revert(e, t) {
          t = la(t), e instanceof Js && (e = this._getSymbolForTextProxy(e));
          var i = this.test(e, t);
          return !1 === i ? (this._consumable.get(e).set(t, !0), !0) : !0 !== i && null;
        }
      }, {
        key: "_getSymbolForTextProxy",
        value: function _getSymbolForTextProxy(e) {
          var t = null;

          var i = this._textProxyRegistry.get(e.startOffset);

          if (i) {
            var _n51 = i.get(e.endOffset);

            _n51 && (t = _n51.get(e.parent));
          }

          return t || (t = this._addSymbolForTextProxy(e.startOffset, e.endOffset, e.parent)), t;
        }
      }, {
        key: "_addSymbolForTextProxy",
        value: function _addSymbolForTextProxy(e, t, i) {
          var n = Symbol("textProxySymbol");
          var o, r;
          return o = this._textProxyRegistry.get(e), o || (o = new Map(), this._textProxyRegistry.set(e, o)), r = o.get(t), r || (r = new Map(), o.set(t, r)), r.set(i, n), n;
        }
      }]);

      return ca;
    }();

    function la(e) {
      var t = e.split(":");
      return "addMarker" == t[0] || "removeMarker" == t[0] ? e : t.length > 1 ? t[0] + ":" + t[1] : t[0];
    }

    var da =
    /*#__PURE__*/
    function () {
      function da(e) {
        _classCallCheck(this, da);

        this.conversionApi = Object.assign({
          dispatcher: this
        }, e), this._reconversionEventsMapping = new Map();
      }

      _createClass(da, [{
        key: "convertChanges",
        value: function convertChanges(e, t, i) {
          var _iteratorNormalCompletion117 = true;
          var _didIteratorError117 = false;
          var _iteratorError117 = undefined;

          try {
            for (var _iterator117 = e.getMarkersToRemove()[Symbol.iterator](), _step117; !(_iteratorNormalCompletion117 = (_step117 = _iterator117.next()).done); _iteratorNormalCompletion117 = true) {
              var _t90 = _step117.value;
              this.convertMarkerRemove(_t90.name, _t90.range, i);
            }
          } catch (err) {
            _didIteratorError117 = true;
            _iteratorError117 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion117 && _iterator117.return != null) {
                _iterator117.return();
              }
            } finally {
              if (_didIteratorError117) {
                throw _iteratorError117;
              }
            }
          }

          var n = this._mapChangesWithAutomaticReconversion(e);

          var _iteratorNormalCompletion118 = true;
          var _didIteratorError118 = false;
          var _iteratorError118 = undefined;

          try {
            for (var _iterator118 = n[Symbol.iterator](), _step118; !(_iteratorNormalCompletion118 = (_step118 = _iterator118.next()).done); _iteratorNormalCompletion118 = true) {
              var _e89 = _step118.value;
              "insert" === _e89.type ? this.convertInsert(sa._createFromPositionAndShift(_e89.position, _e89.length), i) : "remove" === _e89.type ? this.convertRemove(_e89.position, _e89.length, _e89.name, i) : "reconvert" === _e89.type ? this.reconvertElement(_e89.element, i) : this.convertAttribute(_e89.range, _e89.attributeKey, _e89.attributeOldValue, _e89.attributeNewValue, i);
            }
          } catch (err) {
            _didIteratorError118 = true;
            _iteratorError118 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion118 && _iterator118.return != null) {
                _iterator118.return();
              }
            } finally {
              if (_didIteratorError118) {
                throw _iteratorError118;
              }
            }
          }

          var _iteratorNormalCompletion119 = true;
          var _didIteratorError119 = false;
          var _iteratorError119 = undefined;

          try {
            for (var _iterator119 = this.conversionApi.mapper.flushUnboundMarkerNames()[Symbol.iterator](), _step119; !(_iteratorNormalCompletion119 = (_step119 = _iterator119.next()).done); _iteratorNormalCompletion119 = true) {
              var _e90 = _step119.value;

              var _n52 = t.get(_e90).getRange();

              this.convertMarkerRemove(_e90, _n52, i), this.convertMarkerAdd(_e90, _n52, i);
            }
          } catch (err) {
            _didIteratorError119 = true;
            _iteratorError119 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion119 && _iterator119.return != null) {
                _iterator119.return();
              }
            } finally {
              if (_didIteratorError119) {
                throw _iteratorError119;
              }
            }
          }

          var _iteratorNormalCompletion120 = true;
          var _didIteratorError120 = false;
          var _iteratorError120 = undefined;

          try {
            for (var _iterator120 = e.getMarkersToAdd()[Symbol.iterator](), _step120; !(_iteratorNormalCompletion120 = (_step120 = _iterator120.next()).done); _iteratorNormalCompletion120 = true) {
              var _t91 = _step120.value;
              this.convertMarkerAdd(_t91.name, _t91.range, i);
            }
          } catch (err) {
            _didIteratorError120 = true;
            _iteratorError120 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion120 && _iterator120.return != null) {
                _iterator120.return();
              }
            } finally {
              if (_didIteratorError120) {
                throw _iteratorError120;
              }
            }
          }
        }
      }, {
        key: "convertInsert",
        value: function convertInsert(e, t) {
          this.conversionApi.writer = t, this.conversionApi.consumable = this._createInsertConsumable(e);
          var _iteratorNormalCompletion121 = true;
          var _didIteratorError121 = false;
          var _iteratorError121 = undefined;

          try {
            for (var _iterator121 = Array.from(e).map(ua)[Symbol.iterator](), _step121; !(_iteratorNormalCompletion121 = (_step121 = _iterator121.next()).done); _iteratorNormalCompletion121 = true) {
              var _t92 = _step121.value;

              this._convertInsertWithAttributes(_t92);
            }
          } catch (err) {
            _didIteratorError121 = true;
            _iteratorError121 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion121 && _iterator121.return != null) {
                _iterator121.return();
              }
            } finally {
              if (_didIteratorError121) {
                throw _iteratorError121;
              }
            }
          }

          this._clearConversionApi();
        }
      }, {
        key: "convertRemove",
        value: function convertRemove(e, t, i, n) {
          this.conversionApi.writer = n, this.fire("remove:" + i, {
            position: e,
            length: t
          }, this.conversionApi), this._clearConversionApi();
        }
      }, {
        key: "convertAttribute",
        value: function convertAttribute(e, t, i, n, o) {
          this.conversionApi.writer = o, this.conversionApi.consumable = this._createConsumableForRange(e, "attribute:" + t);
          var _iteratorNormalCompletion122 = true;
          var _didIteratorError122 = false;
          var _iteratorError122 = undefined;

          try {
            for (var _iterator122 = e[Symbol.iterator](), _step122; !(_iteratorNormalCompletion122 = (_step122 = _iterator122.next()).done); _iteratorNormalCompletion122 = true) {
              var _o34 = _step122.value;
              var _e91 = {
                item: _o34.item,
                range: sa._createFromPositionAndShift(_o34.previousPosition, _o34.length),
                attributeKey: t,
                attributeOldValue: i,
                attributeNewValue: n
              };

              this._testAndFire("attribute:" + t, _e91);
            }
          } catch (err) {
            _didIteratorError122 = true;
            _iteratorError122 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion122 && _iterator122.return != null) {
                _iterator122.return();
              }
            } finally {
              if (_didIteratorError122) {
                throw _iteratorError122;
              }
            }
          }

          this._clearConversionApi();
        }
      }, {
        key: "reconvertElement",
        value: function reconvertElement(e, t) {
          var i = sa._createOn(e);

          this.conversionApi.writer = t, this.conversionApi.consumable = this._createInsertConsumable(i);
          var n = this.conversionApi.mapper,
              o = n.toViewElement(e);
          t.remove(o), this._convertInsertWithAttributes({
            item: e,
            range: i
          });
          var r = n.toViewElement(e);
          var _iteratorNormalCompletion123 = true;
          var _didIteratorError123 = false;
          var _iteratorError123 = undefined;

          try {
            for (var _iterator123 = sa._createIn(e)[Symbol.iterator](), _step123; !(_iteratorNormalCompletion123 = (_step123 = _iterator123.next()).done); _iteratorNormalCompletion123 = true) {
              var _i101 = _step123.value;

              var _e92 = _i101.item,
                  _o35 = ga(_e92, n);

              _o35 ? _o35.root !== r.root && t.move(t.createRangeOn(_o35), n.toViewPosition(ia._createBefore(_e92))) : this._convertInsertWithAttributes(ua(_i101));
            }
          } catch (err) {
            _didIteratorError123 = true;
            _iteratorError123 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion123 && _iterator123.return != null) {
                _iterator123.return();
              }
            } finally {
              if (_didIteratorError123) {
                throw _iteratorError123;
              }
            }
          }

          n.unbindViewElement(o), this._clearConversionApi();
        }
      }, {
        key: "convertSelection",
        value: function convertSelection(e, t, i) {
          var n = Array.from(t.getMarkersAtPosition(e.getFirstPosition()));

          if (this.conversionApi.writer = i, this.conversionApi.consumable = this._createSelectionConsumable(e, n), this.fire("selection", {
            selection: e
          }, this.conversionApi), e.isCollapsed) {
            var _iteratorNormalCompletion124 = true;
            var _didIteratorError124 = false;
            var _iteratorError124 = undefined;

            try {
              for (var _iterator124 = n[Symbol.iterator](), _step124; !(_iteratorNormalCompletion124 = (_step124 = _iterator124.next()).done); _iteratorNormalCompletion124 = true) {
                var _t93 = _step124.value;

                var _i102 = _t93.getRange();

                if (!ha(e.getFirstPosition(), _t93, this.conversionApi.mapper)) continue;
                var _n53 = {
                  item: e,
                  markerName: _t93.name,
                  markerRange: _i102
                };
                this.conversionApi.consumable.test(e, "addMarker:" + _t93.name) && this.fire("addMarker:" + _t93.name, _n53, this.conversionApi);
              }
            } catch (err) {
              _didIteratorError124 = true;
              _iteratorError124 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion124 && _iterator124.return != null) {
                  _iterator124.return();
                }
              } finally {
                if (_didIteratorError124) {
                  throw _iteratorError124;
                }
              }
            }

            var _iteratorNormalCompletion125 = true;
            var _didIteratorError125 = false;
            var _iteratorError125 = undefined;

            try {
              for (var _iterator125 = e.getAttributeKeys()[Symbol.iterator](), _step125; !(_iteratorNormalCompletion125 = (_step125 = _iterator125.next()).done); _iteratorNormalCompletion125 = true) {
                var _t94 = _step125.value;
                var _i103 = {
                  item: e,
                  range: e.getFirstRange(),
                  attributeKey: _t94,
                  attributeOldValue: null,
                  attributeNewValue: e.getAttribute(_t94)
                };
                this.conversionApi.consumable.test(e, "attribute:" + _i103.attributeKey) && this.fire("attribute:" + _i103.attributeKey + ":$text", _i103, this.conversionApi);
              }
            } catch (err) {
              _didIteratorError125 = true;
              _iteratorError125 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion125 && _iterator125.return != null) {
                  _iterator125.return();
                }
              } finally {
                if (_didIteratorError125) {
                  throw _iteratorError125;
                }
              }
            }

            this._clearConversionApi();
          } else this._clearConversionApi();
        }
      }, {
        key: "convertMarkerAdd",
        value: function convertMarkerAdd(e, t, i) {
          if ("$graveyard" == t.root.rootName) return;
          this.conversionApi.writer = i;
          var n = "addMarker:" + e,
              o = new ca();

          if (o.add(t, n), this.conversionApi.consumable = o, this.fire(n, {
            markerName: e,
            markerRange: t
          }, this.conversionApi), o.test(t, n)) {
            this.conversionApi.consumable = this._createConsumableForRange(t, n);
            var _iteratorNormalCompletion126 = true;
            var _didIteratorError126 = false;
            var _iteratorError126 = undefined;

            try {
              for (var _iterator126 = t.getItems()[Symbol.iterator](), _step126; !(_iteratorNormalCompletion126 = (_step126 = _iterator126.next()).done); _iteratorNormalCompletion126 = true) {
                var _i104 = _step126.value;
                if (!this.conversionApi.consumable.test(_i104, n)) continue;
                var _o36 = {
                  item: _i104,
                  range: sa._createOn(_i104),
                  markerName: e,
                  markerRange: t
                };
                this.fire(n, _o36, this.conversionApi);
              }
            } catch (err) {
              _didIteratorError126 = true;
              _iteratorError126 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion126 && _iterator126.return != null) {
                  _iterator126.return();
                }
              } finally {
                if (_didIteratorError126) {
                  throw _iteratorError126;
                }
              }
            }

            this._clearConversionApi();
          } else this._clearConversionApi();
        }
      }, {
        key: "convertMarkerRemove",
        value: function convertMarkerRemove(e, t, i) {
          "$graveyard" != t.root.rootName && (this.conversionApi.writer = i, this.fire("removeMarker:" + e, {
            markerName: e,
            markerRange: t
          }, this.conversionApi), this._clearConversionApi());
        }
      }, {
        key: "_mapReconversionTriggerEvent",
        value: function _mapReconversionTriggerEvent(e, t) {
          this._reconversionEventsMapping.set(t, e);
        }
      }, {
        key: "_createInsertConsumable",
        value: function _createInsertConsumable(e) {
          var t = new ca();
          var _iteratorNormalCompletion127 = true;
          var _didIteratorError127 = false;
          var _iteratorError127 = undefined;

          try {
            for (var _iterator127 = e[Symbol.iterator](), _step127; !(_iteratorNormalCompletion127 = (_step127 = _iterator127.next()).done); _iteratorNormalCompletion127 = true) {
              var _i105 = _step127.value;
              var _e93 = _i105.item;
              t.add(_e93, "insert");
              var _iteratorNormalCompletion128 = true;
              var _didIteratorError128 = false;
              var _iteratorError128 = undefined;

              try {
                for (var _iterator128 = _e93.getAttributeKeys()[Symbol.iterator](), _step128; !(_iteratorNormalCompletion128 = (_step128 = _iterator128.next()).done); _iteratorNormalCompletion128 = true) {
                  var _i106 = _step128.value;
                  t.add(_e93, "attribute:" + _i106);
                }
              } catch (err) {
                _didIteratorError128 = true;
                _iteratorError128 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion128 && _iterator128.return != null) {
                    _iterator128.return();
                  }
                } finally {
                  if (_didIteratorError128) {
                    throw _iteratorError128;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError127 = true;
            _iteratorError127 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion127 && _iterator127.return != null) {
                _iterator127.return();
              }
            } finally {
              if (_didIteratorError127) {
                throw _iteratorError127;
              }
            }
          }

          return t;
        }
      }, {
        key: "_createConsumableForRange",
        value: function _createConsumableForRange(e, t) {
          var i = new ca();
          var _iteratorNormalCompletion129 = true;
          var _didIteratorError129 = false;
          var _iteratorError129 = undefined;

          try {
            for (var _iterator129 = e.getItems()[Symbol.iterator](), _step129; !(_iteratorNormalCompletion129 = (_step129 = _iterator129.next()).done); _iteratorNormalCompletion129 = true) {
              var _n54 = _step129.value;
              i.add(_n54, t);
            }
          } catch (err) {
            _didIteratorError129 = true;
            _iteratorError129 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion129 && _iterator129.return != null) {
                _iterator129.return();
              }
            } finally {
              if (_didIteratorError129) {
                throw _iteratorError129;
              }
            }
          }

          return i;
        }
      }, {
        key: "_createSelectionConsumable",
        value: function _createSelectionConsumable(e, t) {
          var i = new ca();
          i.add(e, "selection");
          var _iteratorNormalCompletion130 = true;
          var _didIteratorError130 = false;
          var _iteratorError130 = undefined;

          try {
            for (var _iterator130 = t[Symbol.iterator](), _step130; !(_iteratorNormalCompletion130 = (_step130 = _iterator130.next()).done); _iteratorNormalCompletion130 = true) {
              var _n55 = _step130.value;
              i.add(e, "addMarker:" + _n55.name);
            }
          } catch (err) {
            _didIteratorError130 = true;
            _iteratorError130 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion130 && _iterator130.return != null) {
                _iterator130.return();
              }
            } finally {
              if (_didIteratorError130) {
                throw _iteratorError130;
              }
            }
          }

          var _iteratorNormalCompletion131 = true;
          var _didIteratorError131 = false;
          var _iteratorError131 = undefined;

          try {
            for (var _iterator131 = e.getAttributeKeys()[Symbol.iterator](), _step131; !(_iteratorNormalCompletion131 = (_step131 = _iterator131.next()).done); _iteratorNormalCompletion131 = true) {
              var _t95 = _step131.value;
              i.add(e, "attribute:" + _t95);
            }
          } catch (err) {
            _didIteratorError131 = true;
            _iteratorError131 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion131 && _iterator131.return != null) {
                _iterator131.return();
              }
            } finally {
              if (_didIteratorError131) {
                throw _iteratorError131;
              }
            }
          }

          return i;
        }
      }, {
        key: "_testAndFire",
        value: function _testAndFire(e, t) {
          this.conversionApi.consumable.test(t.item, e) && this.fire(function (e, t) {
            var i = t.item.name || "$text";
            return "".concat(e, ":").concat(i);
          }(e, t), t, this.conversionApi);
        }
      }, {
        key: "_clearConversionApi",
        value: function _clearConversionApi() {
          delete this.conversionApi.writer, delete this.conversionApi.consumable;
        }
      }, {
        key: "_convertInsertWithAttributes",
        value: function _convertInsertWithAttributes(e) {
          this._testAndFire("insert", e);

          var _iteratorNormalCompletion132 = true;
          var _didIteratorError132 = false;
          var _iteratorError132 = undefined;

          try {
            for (var _iterator132 = e.item.getAttributeKeys()[Symbol.iterator](), _step132; !(_iteratorNormalCompletion132 = (_step132 = _iterator132.next()).done); _iteratorNormalCompletion132 = true) {
              var _t96 = _step132.value;
              e.attributeKey = _t96, e.attributeOldValue = null, e.attributeNewValue = e.item.getAttribute(_t96), this._testAndFire("attribute:" + _t96, e);
            }
          } catch (err) {
            _didIteratorError132 = true;
            _iteratorError132 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion132 && _iterator132.return != null) {
                _iterator132.return();
              }
            } finally {
              if (_didIteratorError132) {
                throw _iteratorError132;
              }
            }
          }
        }
      }, {
        key: "_mapChangesWithAutomaticReconversion",
        value: function _mapChangesWithAutomaticReconversion(e) {
          var t = new Set(),
              i = [];
          var _iteratorNormalCompletion133 = true;
          var _didIteratorError133 = false;
          var _iteratorError133 = undefined;

          try {
            for (var _iterator133 = e.getChanges()[Symbol.iterator](), _step133; !(_iteratorNormalCompletion133 = (_step133 = _iterator133.next()).done); _iteratorNormalCompletion133 = true) {
              var _n56 = _step133.value;

              var _e94 = _n56.position || _n56.range.start,
                  _o37 = _e94.parent;

              if (na(_e94, _o37)) {
                i.push(_n56);
                continue;
              }

              var _r18 = "attribute" === _n56.type ? oa(_e94, _o37, null) : _o37;

              if (_r18.is("$text")) {
                i.push(_n56);
                continue;
              }

              var _s13 = void 0;

              if (_s13 = "attribute" === _n56.type ? "attribute:".concat(_n56.attributeKey, ":").concat(_r18.name) : "".concat(_n56.type, ":").concat(_n56.name), this._isReconvertTriggerEvent(_s13, _r18.name)) {
                if (t.has(_r18)) continue;
                t.add(_r18), i.push({
                  type: "reconvert",
                  element: _r18
                });
              } else i.push(_n56);
            }
          } catch (err) {
            _didIteratorError133 = true;
            _iteratorError133 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion133 && _iterator133.return != null) {
                _iterator133.return();
              }
            } finally {
              if (_didIteratorError133) {
                throw _iteratorError133;
              }
            }
          }

          return i;
        }
      }, {
        key: "_isReconvertTriggerEvent",
        value: function _isReconvertTriggerEvent(e, t) {
          return this._reconversionEventsMapping.get(e) === t;
        }
      }]);

      return da;
    }();

    function ha(e, t, i) {
      var n = t.getRange(),
          o = Array.from(e.getAncestors());
      o.shift(), o.reverse();
      return !o.some(function (e) {
        if (n.containsItem(e)) {
          return !!i.toViewElement(e).getCustomProperty("addHighlight");
        }
      });
    }

    function ua(e) {
      return {
        item: e.item,
        range: sa._createFromPositionAndShift(e.previousPosition, e.length)
      };
    }

    function ga(e, t) {
      if (e.is("textProxy")) {
        var _i107 = t.toViewPosition(ia._createBefore(e)).parent;
        return _i107.is("$text") ? _i107 : null;
      }

      return t.toViewElement(e);
    }

    Ke(da, h);

    var ma =
    /*#__PURE__*/
    function () {
      function ma(e, t, i) {
        _classCallCheck(this, ma);

        this._lastRangeBackward = !1, this._ranges = [], this._attrs = new Map(), e && this.setTo(e, t, i);
      }

      _createClass(ma, [{
        key: "isEqual",
        value: function isEqual(e) {
          if (this.rangeCount != e.rangeCount) return !1;
          if (0 === this.rangeCount) return !0;
          if (!this.anchor.isEqual(e.anchor) || !this.focus.isEqual(e.focus)) return !1;
          var _iteratorNormalCompletion134 = true;
          var _didIteratorError134 = false;
          var _iteratorError134 = undefined;

          try {
            for (var _iterator134 = this._ranges[Symbol.iterator](), _step134; !(_iteratorNormalCompletion134 = (_step134 = _iterator134.next()).done); _iteratorNormalCompletion134 = true) {
              var _t97 = _step134.value;

              var _i108 = !1;

              var _iteratorNormalCompletion135 = true;
              var _didIteratorError135 = false;
              var _iteratorError135 = undefined;

              try {
                for (var _iterator135 = e._ranges[Symbol.iterator](), _step135; !(_iteratorNormalCompletion135 = (_step135 = _iterator135.next()).done); _iteratorNormalCompletion135 = true) {
                  var _n57 = _step135.value;

                  if (_t97.isEqual(_n57)) {
                    _i108 = !0;
                    break;
                  }
                }
              } catch (err) {
                _didIteratorError135 = true;
                _iteratorError135 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion135 && _iterator135.return != null) {
                    _iterator135.return();
                  }
                } finally {
                  if (_didIteratorError135) {
                    throw _iteratorError135;
                  }
                }
              }

              if (!_i108) return !1;
            }
          } catch (err) {
            _didIteratorError134 = true;
            _iteratorError134 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion134 && _iterator134.return != null) {
                _iterator134.return();
              }
            } finally {
              if (_didIteratorError134) {
                throw _iteratorError134;
              }
            }
          }

          return !0;
        }
      }, {
        key: "getRanges",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function getRanges() {
          var _iteratorNormalCompletion136, _didIteratorError136, _iteratorError136, _iterator136, _step136, _e95;

          return _regeneratorRuntime.wrap(function getRanges$(_context16) {
            while (1) {
              switch (_context16.prev = _context16.next) {
                case 0:
                  _iteratorNormalCompletion136 = true;
                  _didIteratorError136 = false;
                  _iteratorError136 = undefined;
                  _context16.prev = 3;
                  _iterator136 = this._ranges[Symbol.iterator]();

                case 5:
                  if (_iteratorNormalCompletion136 = (_step136 = _iterator136.next()).done) {
                    _context16.next = 12;
                    break;
                  }

                  _e95 = _step136.value;
                  _context16.next = 9;
                  return new sa(_e95.start, _e95.end);

                case 9:
                  _iteratorNormalCompletion136 = true;
                  _context16.next = 5;
                  break;

                case 12:
                  _context16.next = 18;
                  break;

                case 14:
                  _context16.prev = 14;
                  _context16.t0 = _context16["catch"](3);
                  _didIteratorError136 = true;
                  _iteratorError136 = _context16.t0;

                case 18:
                  _context16.prev = 18;
                  _context16.prev = 19;

                  if (!_iteratorNormalCompletion136 && _iterator136.return != null) {
                    _iterator136.return();
                  }

                case 21:
                  _context16.prev = 21;

                  if (!_didIteratorError136) {
                    _context16.next = 24;
                    break;
                  }

                  throw _iteratorError136;

                case 24:
                  return _context16.finish(21);

                case 25:
                  return _context16.finish(18);

                case 26:
                case "end":
                  return _context16.stop();
              }
            }
          }, getRanges, this, [[3, 14, 18, 26], [19,, 21, 25]]);
        })
      }, {
        key: "getFirstRange",
        value: function getFirstRange() {
          var e = null;
          var _iteratorNormalCompletion137 = true;
          var _didIteratorError137 = false;
          var _iteratorError137 = undefined;

          try {
            for (var _iterator137 = this._ranges[Symbol.iterator](), _step137; !(_iteratorNormalCompletion137 = (_step137 = _iterator137.next()).done); _iteratorNormalCompletion137 = true) {
              var _t98 = _step137.value;
              e && !_t98.start.isBefore(e.start) || (e = _t98);
            }
          } catch (err) {
            _didIteratorError137 = true;
            _iteratorError137 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion137 && _iterator137.return != null) {
                _iterator137.return();
              }
            } finally {
              if (_didIteratorError137) {
                throw _iteratorError137;
              }
            }
          }

          return e ? new sa(e.start, e.end) : null;
        }
      }, {
        key: "getLastRange",
        value: function getLastRange() {
          var e = null;
          var _iteratorNormalCompletion138 = true;
          var _didIteratorError138 = false;
          var _iteratorError138 = undefined;

          try {
            for (var _iterator138 = this._ranges[Symbol.iterator](), _step138; !(_iteratorNormalCompletion138 = (_step138 = _iterator138.next()).done); _iteratorNormalCompletion138 = true) {
              var _t99 = _step138.value;
              e && !_t99.end.isAfter(e.end) || (e = _t99);
            }
          } catch (err) {
            _didIteratorError138 = true;
            _iteratorError138 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion138 && _iterator138.return != null) {
                _iterator138.return();
              }
            } finally {
              if (_didIteratorError138) {
                throw _iteratorError138;
              }
            }
          }

          return e ? new sa(e.start, e.end) : null;
        }
      }, {
        key: "getFirstPosition",
        value: function getFirstPosition() {
          var e = this.getFirstRange();
          return e ? e.start.clone() : null;
        }
      }, {
        key: "getLastPosition",
        value: function getLastPosition() {
          var e = this.getLastRange();
          return e ? e.end.clone() : null;
        }
      }, {
        key: "setTo",
        value: function setTo(e, t, i) {
          if (null === e) this._setRanges([]);else if (e instanceof ma) this._setRanges(e.getRanges(), e.isBackward);else if (e && "function" == typeof e.getRanges) this._setRanges(e.getRanges(), e.isBackward);else if (e instanceof sa) this._setRanges([e], !!t && !!t.backward);else if (e instanceof ia) this._setRanges([new sa(e)]);else if (e instanceof Ks) {
            var _n58 = !!i && !!i.backward;

            var _o38;

            if ("in" == t) _o38 = sa._createIn(e);else if ("on" == t) _o38 = sa._createOn(e);else {
              if (void 0 === t) throw new c.a("model-selection-setto-required-second-parameter", [this, e]);
              _o38 = new sa(ia._createAt(e, t));
            }

            this._setRanges([_o38], _n58);
          } else {
            if (!Ji(e)) throw new c.a("model-selection-setto-not-selectable", [this, e]);

            this._setRanges(e, t && !!t.backward);
          }
        }
      }, {
        key: "_setRanges",
        value: function _setRanges(e) {
          var _this52 = this;

          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          var i = (e = Array.from(e)).some(function (t) {
            if (!(t instanceof sa)) throw new c.a("model-selection-set-ranges-not-range", [_this52, e]);
            return _this52._ranges.every(function (e) {
              return !e.isEqual(t);
            });
          });

          if (e.length !== this._ranges.length || i) {
            this._removeAllRanges();

            var _iteratorNormalCompletion139 = true;
            var _didIteratorError139 = false;
            var _iteratorError139 = undefined;

            try {
              for (var _iterator139 = e[Symbol.iterator](), _step139; !(_iteratorNormalCompletion139 = (_step139 = _iterator139.next()).done); _iteratorNormalCompletion139 = true) {
                var _t100 = _step139.value;

                this._pushRange(_t100);
              }
            } catch (err) {
              _didIteratorError139 = true;
              _iteratorError139 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion139 && _iterator139.return != null) {
                  _iterator139.return();
                }
              } finally {
                if (_didIteratorError139) {
                  throw _iteratorError139;
                }
              }
            }

            this._lastRangeBackward = !!t, this.fire("change:range", {
              directChange: !0
            });
          }
        }
      }, {
        key: "setFocus",
        value: function setFocus(e, t) {
          if (null === this.anchor) throw new c.a("model-selection-setfocus-no-ranges", [this, e]);

          var i = ia._createAt(e, t);

          if ("same" == i.compareWith(this.focus)) return;
          var n = this.anchor;
          this._ranges.length && this._popRange(), "before" == i.compareWith(n) ? (this._pushRange(new sa(i, n)), this._lastRangeBackward = !0) : (this._pushRange(new sa(n, i)), this._lastRangeBackward = !1), this.fire("change:range", {
            directChange: !0
          });
        }
      }, {
        key: "getAttribute",
        value: function getAttribute(e) {
          return this._attrs.get(e);
        }
      }, {
        key: "getAttributes",
        value: function getAttributes() {
          return this._attrs.entries();
        }
      }, {
        key: "getAttributeKeys",
        value: function getAttributeKeys() {
          return this._attrs.keys();
        }
      }, {
        key: "hasAttribute",
        value: function hasAttribute(e) {
          return this._attrs.has(e);
        }
      }, {
        key: "removeAttribute",
        value: function removeAttribute(e) {
          this.hasAttribute(e) && (this._attrs.delete(e), this.fire("change:attribute", {
            attributeKeys: [e],
            directChange: !0
          }));
        }
      }, {
        key: "setAttribute",
        value: function setAttribute(e, t) {
          this.getAttribute(e) !== t && (this._attrs.set(e, t), this.fire("change:attribute", {
            attributeKeys: [e],
            directChange: !0
          }));
        }
      }, {
        key: "getSelectedElement",
        value: function getSelectedElement() {
          return 1 !== this.rangeCount ? null : this.getFirstRange().getContainedElement();
        }
      }, {
        key: "is",
        value: function is(e) {
          return "selection" === e || "model:selection" === e;
        }
      }, {
        key: "getSelectedBlocks",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function getSelectedBlocks() {
          var e, _iteratorNormalCompletion140, _didIteratorError140, _iteratorError140, _iterator140, _step140, _t101, _i109, _iteratorNormalCompletion141, _didIteratorError141, _iteratorError141, _iterator141, _step141, _i110, _n60, _n59;

          return _regeneratorRuntime.wrap(function getSelectedBlocks$(_context17) {
            while (1) {
              switch (_context17.prev = _context17.next) {
                case 0:
                  e = new WeakSet();
                  _iteratorNormalCompletion140 = true;
                  _didIteratorError140 = false;
                  _iteratorError140 = undefined;
                  _context17.prev = 4;
                  _iterator140 = this.getRanges()[Symbol.iterator]();

                case 6:
                  if (_iteratorNormalCompletion140 = (_step140 = _iterator140.next()).done) {
                    _context17.next = 50;
                    break;
                  }

                  _t101 = _step140.value;
                  _i109 = ba(_t101.start, e);
                  _context17.t0 = _i109 && wa(_i109, _t101);

                  if (!_context17.t0) {
                    _context17.next = 13;
                    break;
                  }

                  _context17.next = 13;
                  return _i109;

                case 13:
                  _iteratorNormalCompletion141 = true;
                  _didIteratorError141 = false;
                  _iteratorError141 = undefined;
                  _context17.prev = 16;
                  _iterator141 = _t101.getWalker()[Symbol.iterator]();

                case 18:
                  if (_iteratorNormalCompletion141 = (_step141 = _iterator141.next()).done) {
                    _context17.next = 28;
                    break;
                  }

                  _i110 = _step141.value;
                  _n60 = _i110.item;
                  _context17.t1 = "elementEnd" == _i110.type && pa(_n60, e, _t101);

                  if (!_context17.t1) {
                    _context17.next = 25;
                    break;
                  }

                  _context17.next = 25;
                  return _n60;

                case 25:
                  _iteratorNormalCompletion141 = true;
                  _context17.next = 18;
                  break;

                case 28:
                  _context17.next = 34;
                  break;

                case 30:
                  _context17.prev = 30;
                  _context17.t2 = _context17["catch"](16);
                  _didIteratorError141 = true;
                  _iteratorError141 = _context17.t2;

                case 34:
                  _context17.prev = 34;
                  _context17.prev = 35;

                  if (!_iteratorNormalCompletion141 && _iterator141.return != null) {
                    _iterator141.return();
                  }

                case 37:
                  _context17.prev = 37;

                  if (!_didIteratorError141) {
                    _context17.next = 40;
                    break;
                  }

                  throw _iteratorError141;

                case 40:
                  return _context17.finish(37);

                case 41:
                  return _context17.finish(34);

                case 42:
                  _n59 = ba(_t101.end, e);
                  _context17.t3 = _n59 && !_t101.end.isTouching(ia._createAt(_n59, 0)) && wa(_n59, _t101);

                  if (!_context17.t3) {
                    _context17.next = 47;
                    break;
                  }

                  _context17.next = 47;
                  return _n59;

                case 47:
                  _iteratorNormalCompletion140 = true;
                  _context17.next = 6;
                  break;

                case 50:
                  _context17.next = 56;
                  break;

                case 52:
                  _context17.prev = 52;
                  _context17.t4 = _context17["catch"](4);
                  _didIteratorError140 = true;
                  _iteratorError140 = _context17.t4;

                case 56:
                  _context17.prev = 56;
                  _context17.prev = 57;

                  if (!_iteratorNormalCompletion140 && _iterator140.return != null) {
                    _iterator140.return();
                  }

                case 59:
                  _context17.prev = 59;

                  if (!_didIteratorError140) {
                    _context17.next = 62;
                    break;
                  }

                  throw _iteratorError140;

                case 62:
                  return _context17.finish(59);

                case 63:
                  return _context17.finish(56);

                case 64:
                case "end":
                  return _context17.stop();
              }
            }
          }, getSelectedBlocks, this, [[4, 52, 56, 64], [16, 30, 34, 42], [35,, 37, 41], [57,, 59, 63]]);
        })
      }, {
        key: "containsEntireContent",
        value: function containsEntireContent() {
          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.anchor.root;

          var t = ia._createAt(e, 0),
              i = ia._createAt(e, "end");

          return t.isTouching(this.getFirstPosition()) && i.isTouching(this.getLastPosition());
        }
      }, {
        key: "_pushRange",
        value: function _pushRange(e) {
          this._checkRange(e), this._ranges.push(new sa(e.start, e.end));
        }
      }, {
        key: "_checkRange",
        value: function _checkRange(e) {
          for (var _t102 = 0; _t102 < this._ranges.length; _t102++) {
            if (e.isIntersecting(this._ranges[_t102])) throw new c.a("model-selection-range-intersects", [this, e], {
              addedRange: e,
              intersectingRange: this._ranges[_t102]
            });
          }
        }
      }, {
        key: "_removeAllRanges",
        value: function _removeAllRanges() {
          for (; this._ranges.length > 0;) {
            this._popRange();
          }
        }
      }, {
        key: "_popRange",
        value: function _popRange() {
          this._ranges.pop();
        }
      }, {
        key: "anchor",
        get: function get() {
          if (this._ranges.length > 0) {
            var _e96 = this._ranges[this._ranges.length - 1];
            return this._lastRangeBackward ? _e96.end : _e96.start;
          }

          return null;
        }
      }, {
        key: "focus",
        get: function get() {
          if (this._ranges.length > 0) {
            var _e97 = this._ranges[this._ranges.length - 1];
            return this._lastRangeBackward ? _e97.start : _e97.end;
          }

          return null;
        }
      }, {
        key: "isCollapsed",
        get: function get() {
          return 1 === this._ranges.length && this._ranges[0].isCollapsed;
        }
      }, {
        key: "rangeCount",
        get: function get() {
          return this._ranges.length;
        }
      }, {
        key: "isBackward",
        get: function get() {
          return !this.isCollapsed && this._lastRangeBackward;
        }
      }]);

      return ma;
    }();

    function fa(e, t) {
      return !t.has(e) && (t.add(e), e.root.document.model.schema.isBlock(e) && e.parent);
    }

    function pa(e, t, i) {
      return fa(e, t) && wa(e, i);
    }

    function ba(e, t) {
      var i = e.parent.root.document.model.schema,
          n = e.parent.getAncestors({
        parentFirst: !0,
        includeSelf: !0
      });
      var o = !1;
      var r = n.find(function (e) {
        return !o && (o = i.isLimit(e), !o && fa(e, t));
      });
      return n.forEach(function (e) {
        return t.add(e);
      }), r;
    }

    function wa(e, t) {
      var i = function (e) {
        var t = e.root.document.model.schema;
        var i = e.parent;

        for (; i;) {
          if (t.isBlock(i)) return i;
          i = i.parent;
        }
      }(e);

      if (!i) return !0;
      return !t.containsRange(sa._createOn(i), !0);
    }

    Ke(ma, h);

    var ka =
    /*#__PURE__*/
    function (_sa) {
      _inherits(ka, _sa);

      function ka(e, t) {
        var _this53;

        _classCallCheck(this, ka);

        _this53 = _possibleConstructorReturn(this, _getPrototypeOf(ka).call(this, e, t)), _a.call(_assertThisInitialized(_this53));
        return _this53;
      }

      _createClass(ka, [{
        key: "detach",
        value: function detach() {
          this.stopListening();
        }
      }, {
        key: "is",
        value: function is(e) {
          return "liveRange" === e || "model:liveRange" === e || "range" == e || "model:range" === e;
        }
      }, {
        key: "toRange",
        value: function toRange() {
          return new sa(this.start, this.end);
        }
      }], [{
        key: "fromRange",
        value: function fromRange(e) {
          return new ka(e.start, e.end);
        }
      }]);

      return ka;
    }(sa);

    function _a() {
      var _this54 = this;

      this.listenTo(this.root.document.model, "applyOperation", function (e, t) {
        var i = t[0];
        i.isDocumentOperation && va.call(_this54, i);
      }, {
        priority: "low"
      });
    }

    function va(e) {
      var t = this.getTransformedByOperation(e),
          i = sa._createFromRanges(t),
          n = !i.isEqual(this),
          o = function (e, t) {
        switch (t.type) {
          case "insert":
            return e.containsPosition(t.position);

          case "move":
          case "remove":
          case "reinsert":
          case "merge":
            return e.containsPosition(t.sourcePosition) || e.start.isEqual(t.sourcePosition) || e.containsPosition(t.targetPosition);

          case "split":
            return e.containsPosition(t.splitPosition) || e.containsPosition(t.insertionPosition);
        }

        return !1;
      }(this, e);

      var r = null;

      if (n) {
        "$graveyard" == i.root.rootName && (r = "remove" == e.type ? e.sourcePosition : e.deletionPosition);

        var _t103 = this.toRange();

        this.start = i.start, this.end = i.end, this.fire("change:range", _t103, {
          deletionPosition: r
        });
      } else o && this.fire("change:content", this.toRange(), {
        deletionPosition: r
      });
    }

    Ke(ka, h);

    var ya =
    /*#__PURE__*/
    function () {
      function ya(e) {
        _classCallCheck(this, ya);

        this._selection = new xa(e), this._selection.delegate("change:range").to(this), this._selection.delegate("change:attribute").to(this), this._selection.delegate("change:marker").to(this);
      }

      _createClass(ya, [{
        key: "getRanges",
        value: function getRanges() {
          return this._selection.getRanges();
        }
      }, {
        key: "getFirstPosition",
        value: function getFirstPosition() {
          return this._selection.getFirstPosition();
        }
      }, {
        key: "getLastPosition",
        value: function getLastPosition() {
          return this._selection.getLastPosition();
        }
      }, {
        key: "getFirstRange",
        value: function getFirstRange() {
          return this._selection.getFirstRange();
        }
      }, {
        key: "getLastRange",
        value: function getLastRange() {
          return this._selection.getLastRange();
        }
      }, {
        key: "getSelectedBlocks",
        value: function getSelectedBlocks() {
          return this._selection.getSelectedBlocks();
        }
      }, {
        key: "getSelectedElement",
        value: function getSelectedElement() {
          return this._selection.getSelectedElement();
        }
      }, {
        key: "containsEntireContent",
        value: function containsEntireContent(e) {
          return this._selection.containsEntireContent(e);
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this._selection.destroy();
        }
      }, {
        key: "getAttributeKeys",
        value: function getAttributeKeys() {
          return this._selection.getAttributeKeys();
        }
      }, {
        key: "getAttributes",
        value: function getAttributes() {
          return this._selection.getAttributes();
        }
      }, {
        key: "getAttribute",
        value: function getAttribute(e) {
          return this._selection.getAttribute(e);
        }
      }, {
        key: "hasAttribute",
        value: function hasAttribute(e) {
          return this._selection.hasAttribute(e);
        }
      }, {
        key: "refresh",
        value: function refresh() {
          this._selection._updateMarkers(), this._selection._updateAttributes(!1);
        }
      }, {
        key: "observeMarkers",
        value: function observeMarkers(e) {
          this._selection.observeMarkers(e);
        }
      }, {
        key: "is",
        value: function is(e) {
          return "selection" === e || "model:selection" == e || "documentSelection" == e || "model:documentSelection" == e;
        }
      }, {
        key: "_setFocus",
        value: function _setFocus(e, t) {
          this._selection.setFocus(e, t);
        }
      }, {
        key: "_setTo",
        value: function _setTo(e, t, i) {
          this._selection.setTo(e, t, i);
        }
      }, {
        key: "_setAttribute",
        value: function _setAttribute(e, t) {
          this._selection.setAttribute(e, t);
        }
      }, {
        key: "_removeAttribute",
        value: function _removeAttribute(e) {
          this._selection.removeAttribute(e);
        }
      }, {
        key: "_getStoredAttributes",
        value: function _getStoredAttributes() {
          return this._selection._getStoredAttributes();
        }
      }, {
        key: "_overrideGravity",
        value: function _overrideGravity() {
          return this._selection.overrideGravity();
        }
      }, {
        key: "_restoreGravity",
        value: function _restoreGravity(e) {
          this._selection.restoreGravity(e);
        }
      }, {
        key: "isCollapsed",
        get: function get() {
          return this._selection.isCollapsed;
        }
      }, {
        key: "anchor",
        get: function get() {
          return this._selection.anchor;
        }
      }, {
        key: "focus",
        get: function get() {
          return this._selection.focus;
        }
      }, {
        key: "rangeCount",
        get: function get() {
          return this._selection.rangeCount;
        }
      }, {
        key: "hasOwnRange",
        get: function get() {
          return this._selection.hasOwnRange;
        }
      }, {
        key: "isBackward",
        get: function get() {
          return this._selection.isBackward;
        }
      }, {
        key: "isGravityOverridden",
        get: function get() {
          return this._selection.isGravityOverridden;
        }
      }, {
        key: "markers",
        get: function get() {
          return this._selection.markers;
        }
      }, {
        key: "_ranges",
        get: function get() {
          return this._selection._ranges;
        }
      }], [{
        key: "_getStoreAttributeKey",
        value: function _getStoreAttributeKey(e) {
          return "selection:" + e;
        }
      }, {
        key: "_isStoreAttributeKey",
        value: function _isStoreAttributeKey(e) {
          return e.startsWith("selection:");
        }
      }]);

      return ya;
    }();

    Ke(ya, h);

    var xa =
    /*#__PURE__*/
    function (_ma) {
      _inherits(xa, _ma);

      function xa(e) {
        var _this55;

        _classCallCheck(this, xa);

        _this55 = _possibleConstructorReturn(this, _getPrototypeOf(xa).call(this)), _this55.markers = new Zi({
          idProperty: "name"
        }), _this55._model = e.model, _this55._document = e, _this55._attributePriority = new Map(), _this55._selectionRestorePosition = null, _this55._hasChangedRange = !1, _this55._overriddenGravityRegister = new Set(), _this55._observedMarkers = new Set(), _this55.listenTo(_this55._model, "applyOperation", function (e, t) {
          var i = t[0];
          i.isDocumentOperation && "marker" != i.type && "rename" != i.type && "noop" != i.type && (0 == _this55._ranges.length && _this55._selectionRestorePosition && _this55._fixGraveyardSelection(_this55._selectionRestorePosition), _this55._selectionRestorePosition = null, _this55._hasChangedRange && (_this55._hasChangedRange = !1, _this55.fire("change:range", {
            directChange: !1
          })));
        }, {
          priority: "lowest"
        }), _this55.on("change:range", function () {
          var _iteratorNormalCompletion142 = true;
          var _didIteratorError142 = false;
          var _iteratorError142 = undefined;

          try {
            for (var _iterator142 = _this55.getRanges()[Symbol.iterator](), _step142; !(_iteratorNormalCompletion142 = (_step142 = _iterator142.next()).done); _iteratorNormalCompletion142 = true) {
              var _e98 = _step142.value;
              if (!_this55._document._validateSelectionRange(_e98)) throw new c.a("document-selection-wrong-position", _assertThisInitialized(_this55), {
                range: _e98
              });
            }
          } catch (err) {
            _didIteratorError142 = true;
            _iteratorError142 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion142 && _iterator142.return != null) {
                _iterator142.return();
              }
            } finally {
              if (_didIteratorError142) {
                throw _iteratorError142;
              }
            }
          }
        }), _this55.listenTo(_this55._model.markers, "update", function (e, t, i, n) {
          _this55._updateMarker(t, n);
        }), _this55.listenTo(_this55._document, "change", function (e, t) {
          !function (e, t) {
            var i = e.document.differ;
            var _iteratorNormalCompletion143 = true;
            var _didIteratorError143 = false;
            var _iteratorError143 = undefined;

            try {
              var _loop2 = function _loop2() {
                var n = _step143.value;
                if ("insert" != n.type) return "continue";
                var i = n.position.parent;
                n.length === i.maxOffset && e.enqueueChange(t, function (e) {
                  var t = Array.from(i.getAttributeKeys()).filter(function (e) {
                    return e.startsWith("selection:");
                  });
                  var _iteratorNormalCompletion144 = true;
                  var _didIteratorError144 = false;
                  var _iteratorError144 = undefined;

                  try {
                    for (var _iterator144 = t[Symbol.iterator](), _step144; !(_iteratorNormalCompletion144 = (_step144 = _iterator144.next()).done); _iteratorNormalCompletion144 = true) {
                      var _n61 = _step144.value;
                      e.removeAttribute(_n61, i);
                    }
                  } catch (err) {
                    _didIteratorError144 = true;
                    _iteratorError144 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion144 && _iterator144.return != null) {
                        _iterator144.return();
                      }
                    } finally {
                      if (_didIteratorError144) {
                        throw _iteratorError144;
                      }
                    }
                  }
                });
              };

              for (var _iterator143 = i.getChanges()[Symbol.iterator](), _step143; !(_iteratorNormalCompletion143 = (_step143 = _iterator143.next()).done); _iteratorNormalCompletion143 = true) {
                var _ret = _loop2();

                if (_ret === "continue") continue;
              }
            } catch (err) {
              _didIteratorError143 = true;
              _iteratorError143 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion143 && _iterator143.return != null) {
                  _iterator143.return();
                }
              } finally {
                if (_didIteratorError143) {
                  throw _iteratorError143;
                }
              }
            }
          }(_this55._model, t);
        });
        return _this55;
      }

      _createClass(xa, [{
        key: "destroy",
        value: function destroy() {
          for (var _e99 = 0; _e99 < this._ranges.length; _e99++) {
            this._ranges[_e99].detach();
          }

          this.stopListening();
        }
      }, {
        key: "getRanges",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function getRanges() {
          return _regeneratorRuntime.wrap(function getRanges$(_context18) {
            while (1) {
              switch (_context18.prev = _context18.next) {
                case 0:
                  if (!this._ranges.length) {
                    _context18.next = 4;
                    break;
                  }

                  return _context18.delegateYield(_get(_getPrototypeOf(xa.prototype), "getRanges", this).call(this), "t0", 2);

                case 2:
                  _context18.next = 6;
                  break;

                case 4:
                  _context18.next = 6;
                  return this._document._getDefaultRange();

                case 6:
                case "end":
                  return _context18.stop();
              }
            }
          }, getRanges, this);
        })
      }, {
        key: "getFirstRange",
        value: function getFirstRange() {
          return _get(_getPrototypeOf(xa.prototype), "getFirstRange", this).call(this) || this._document._getDefaultRange();
        }
      }, {
        key: "getLastRange",
        value: function getLastRange() {
          return _get(_getPrototypeOf(xa.prototype), "getLastRange", this).call(this) || this._document._getDefaultRange();
        }
      }, {
        key: "setTo",
        value: function setTo(e, t, i) {
          _get(_getPrototypeOf(xa.prototype), "setTo", this).call(this, e, t, i), this._updateAttributes(!0), this._updateMarkers();
        }
      }, {
        key: "setFocus",
        value: function setFocus(e, t) {
          _get(_getPrototypeOf(xa.prototype), "setFocus", this).call(this, e, t), this._updateAttributes(!0), this._updateMarkers();
        }
      }, {
        key: "setAttribute",
        value: function setAttribute(e, t) {
          if (this._setAttribute(e, t)) {
            var _t104 = [e];
            this.fire("change:attribute", {
              attributeKeys: _t104,
              directChange: !0
            });
          }
        }
      }, {
        key: "removeAttribute",
        value: function removeAttribute(e) {
          if (this._removeAttribute(e)) {
            var _t105 = [e];
            this.fire("change:attribute", {
              attributeKeys: _t105,
              directChange: !0
            });
          }
        }
      }, {
        key: "overrideGravity",
        value: function overrideGravity() {
          var e = s();
          return this._overriddenGravityRegister.add(e), 1 === this._overriddenGravityRegister.size && this._updateAttributes(!0), e;
        }
      }, {
        key: "restoreGravity",
        value: function restoreGravity(e) {
          if (!this._overriddenGravityRegister.has(e)) throw new c.a("document-selection-gravity-wrong-restore", this, {
            uid: e
          });
          this._overriddenGravityRegister.delete(e), this.isGravityOverridden || this._updateAttributes(!0);
        }
      }, {
        key: "observeMarkers",
        value: function observeMarkers(e) {
          this._observedMarkers.add(e), this._updateMarkers();
        }
      }, {
        key: "_popRange",
        value: function _popRange() {
          this._ranges.pop().detach();
        }
      }, {
        key: "_pushRange",
        value: function _pushRange(e) {
          var t = this._prepareRange(e);

          t && this._ranges.push(t);
        }
      }, {
        key: "_prepareRange",
        value: function _prepareRange(e) {
          var _this56 = this;

          if (this._checkRange(e), e.root == this._document.graveyard) return;
          var t = ka.fromRange(e);
          return t.on("change:range", function (e, i, n) {
            if (_this56._hasChangedRange = !0, t.root == _this56._document.graveyard) {
              _this56._selectionRestorePosition = n.deletionPosition;

              var _e100 = _this56._ranges.indexOf(t);

              _this56._ranges.splice(_e100, 1), t.detach();
            }
          }), t;
        }
      }, {
        key: "_updateMarkers",
        value: function _updateMarkers() {
          if (!this._observedMarkers.size) return;
          var e = [];
          var t = !1;
          var _iteratorNormalCompletion145 = true;
          var _didIteratorError145 = false;
          var _iteratorError145 = undefined;

          try {
            for (var _iterator145 = this._model.markers[Symbol.iterator](), _step145; !(_iteratorNormalCompletion145 = (_step145 = _iterator145.next()).done); _iteratorNormalCompletion145 = true) {
              var _t106 = _step145.value;

              var _i113 = _t106.name.split(":", 1)[0];

              if (!this._observedMarkers.has(_i113)) continue;

              var _n62 = _t106.getRange();

              var _iteratorNormalCompletion146 = true;
              var _didIteratorError146 = false;
              var _iteratorError146 = undefined;

              try {
                for (var _iterator146 = this.getRanges()[Symbol.iterator](), _step146; !(_iteratorNormalCompletion146 = (_step146 = _iterator146.next()).done); _iteratorNormalCompletion146 = true) {
                  var _i114 = _step146.value;
                  _n62.containsRange(_i114, !_i114.isCollapsed) && e.push(_t106);
                }
              } catch (err) {
                _didIteratorError146 = true;
                _iteratorError146 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion146 && _iterator146.return != null) {
                    _iterator146.return();
                  }
                } finally {
                  if (_didIteratorError146) {
                    throw _iteratorError146;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError145 = true;
            _iteratorError145 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion145 && _iterator145.return != null) {
                _iterator145.return();
              }
            } finally {
              if (_didIteratorError145) {
                throw _iteratorError145;
              }
            }
          }

          var i = Array.from(this.markers);

          for (var _i111 = 0, _e101 = e; _i111 < _e101.length; _i111++) {
            var _i115 = _e101[_i111];
            this.markers.has(_i115) || (this.markers.add(_i115), t = !0);
          }

          for (var _i112 = 0, _Array$from2 = Array.from(this.markers); _i112 < _Array$from2.length; _i112++) {
            var _i116 = _Array$from2[_i112];
            e.includes(_i116) || (this.markers.remove(_i116), t = !0);
          }

          t && this.fire("change:marker", {
            oldMarkers: i,
            directChange: !1
          });
        }
      }, {
        key: "_updateMarker",
        value: function _updateMarker(e, t) {
          var i = e.name.split(":", 1)[0];
          if (!this._observedMarkers.has(i)) return;
          var n = !1;
          var o = Array.from(this.markers),
              r = this.markers.has(e);

          if (t) {
            var _i117 = !1;

            var _iteratorNormalCompletion147 = true;
            var _didIteratorError147 = false;
            var _iteratorError147 = undefined;

            try {
              for (var _iterator147 = this.getRanges()[Symbol.iterator](), _step147; !(_iteratorNormalCompletion147 = (_step147 = _iterator147.next()).done); _iteratorNormalCompletion147 = true) {
                var _e102 = _step147.value;

                if (t.containsRange(_e102, !_e102.isCollapsed)) {
                  _i117 = !0;
                  break;
                }
              }
            } catch (err) {
              _didIteratorError147 = true;
              _iteratorError147 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion147 && _iterator147.return != null) {
                  _iterator147.return();
                }
              } finally {
                if (_didIteratorError147) {
                  throw _iteratorError147;
                }
              }
            }

            _i117 && !r ? (this.markers.add(e), n = !0) : !_i117 && r && (this.markers.remove(e), n = !0);
          } else r && (this.markers.remove(e), n = !0);

          n && this.fire("change:marker", {
            oldMarkers: o,
            directChange: !1
          });
        }
      }, {
        key: "_updateAttributes",
        value: function _updateAttributes(e) {
          var t = gn(this._getSurroundingAttributes()),
              i = gn(this.getAttributes());
          if (e) this._attributePriority = new Map(), this._attrs = new Map();else {
            var _iteratorNormalCompletion148 = true;
            var _didIteratorError148 = false;
            var _iteratorError148 = undefined;

            try {
              for (var _iterator148 = this._attributePriority[Symbol.iterator](), _step148; !(_iteratorNormalCompletion148 = (_step148 = _iterator148.next()).done); _iteratorNormalCompletion148 = true) {
                var _ref49 = _step148.value;

                var _ref48 = _slicedToArray(_ref49, 2);

                var _e103 = _ref48[0];
                var _t107 = _ref48[1];
                "low" == _t107 && (this._attrs.delete(_e103), this._attributePriority.delete(_e103));
              }
            } catch (err) {
              _didIteratorError148 = true;
              _iteratorError148 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion148 && _iterator148.return != null) {
                  _iterator148.return();
                }
              } finally {
                if (_didIteratorError148) {
                  throw _iteratorError148;
                }
              }
            }
          }

          this._setAttributesTo(t);

          var n = [];
          var _iteratorNormalCompletion149 = true;
          var _didIteratorError149 = false;
          var _iteratorError149 = undefined;

          try {
            for (var _iterator149 = this.getAttributes()[Symbol.iterator](), _step149; !(_iteratorNormalCompletion149 = (_step149 = _iterator149.next()).done); _iteratorNormalCompletion149 = true) {
              var _ref54 = _step149.value;

              var _ref51 = _slicedToArray(_ref54, 2);

              var _e104 = _ref51[0];
              var _t108 = _ref51[1];
              i.has(_e104) && i.get(_e104) === _t108 || n.push(_e104);
            }
          } catch (err) {
            _didIteratorError149 = true;
            _iteratorError149 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion149 && _iterator149.return != null) {
                _iterator149.return();
              }
            } finally {
              if (_didIteratorError149) {
                throw _iteratorError149;
              }
            }
          }

          var _iteratorNormalCompletion150 = true;
          var _didIteratorError150 = false;
          var _iteratorError150 = undefined;

          try {
            for (var _iterator150 = i[Symbol.iterator](), _step150; !(_iteratorNormalCompletion150 = (_step150 = _iterator150.next()).done); _iteratorNormalCompletion150 = true) {
              var _ref55 = _step150.value;

              var _ref53 = _slicedToArray(_ref55, 1);

              var _e105 = _ref53[0];
              this.hasAttribute(_e105) || n.push(_e105);
            }
          } catch (err) {
            _didIteratorError150 = true;
            _iteratorError150 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion150 && _iterator150.return != null) {
                _iterator150.return();
              }
            } finally {
              if (_didIteratorError150) {
                throw _iteratorError150;
              }
            }
          }

          n.length > 0 && this.fire("change:attribute", {
            attributeKeys: n,
            directChange: !1
          });
        }
      }, {
        key: "_setAttribute",
        value: function _setAttribute(e, t) {
          var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
          var n = i ? "normal" : "low";
          if ("low" == n && "normal" == this._attributePriority.get(e)) return !1;
          return _get(_getPrototypeOf(xa.prototype), "getAttribute", this).call(this, e) !== t && (this._attrs.set(e, t), this._attributePriority.set(e, n), !0);
        }
      }, {
        key: "_removeAttribute",
        value: function _removeAttribute(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
          var i = t ? "normal" : "low";
          return ("low" != i || "normal" != this._attributePriority.get(e)) && (this._attributePriority.set(e, i), !!_get(_getPrototypeOf(xa.prototype), "hasAttribute", this).call(this, e) && (this._attrs.delete(e), !0));
        }
      }, {
        key: "_setAttributesTo",
        value: function _setAttributesTo(e) {
          var t = new Set();
          var _iteratorNormalCompletion151 = true;
          var _didIteratorError151 = false;
          var _iteratorError151 = undefined;

          try {
            for (var _iterator151 = this.getAttributes()[Symbol.iterator](), _step151; !(_iteratorNormalCompletion151 = (_step151 = _iterator151.next()).done); _iteratorNormalCompletion151 = true) {
              var _ref60 = _step151.value;

              var _ref57 = _slicedToArray(_ref60, 2);

              var _t109 = _ref57[0];
              var _i118 = _ref57[1];
              e.get(_t109) !== _i118 && this._removeAttribute(_t109, !1);
            }
          } catch (err) {
            _didIteratorError151 = true;
            _iteratorError151 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion151 && _iterator151.return != null) {
                _iterator151.return();
              }
            } finally {
              if (_didIteratorError151) {
                throw _iteratorError151;
              }
            }
          }

          var _iteratorNormalCompletion152 = true;
          var _didIteratorError152 = false;
          var _iteratorError152 = undefined;

          try {
            for (var _iterator152 = e[Symbol.iterator](), _step152; !(_iteratorNormalCompletion152 = (_step152 = _iterator152.next()).done); _iteratorNormalCompletion152 = true) {
              var _ref61 = _step152.value;

              var _ref59 = _slicedToArray(_ref61, 2);

              var _i119 = _ref59[0];
              var _n63 = _ref59[1];
              this._setAttribute(_i119, _n63, !1) && t.add(_i119);
            }
          } catch (err) {
            _didIteratorError152 = true;
            _iteratorError152 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion152 && _iterator152.return != null) {
                _iterator152.return();
              }
            } finally {
              if (_didIteratorError152) {
                throw _iteratorError152;
              }
            }
          }

          return t;
        }
      }, {
        key: "_getStoredAttributes",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _getStoredAttributes() {
          var e, _iteratorNormalCompletion153, _didIteratorError153, _iteratorError153, _iterator153, _step153, _t110, _i120;

          return _regeneratorRuntime.wrap(function _getStoredAttributes$(_context19) {
            while (1) {
              switch (_context19.prev = _context19.next) {
                case 0:
                  e = this.getFirstPosition().parent;

                  if (!(this.isCollapsed && e.isEmpty)) {
                    _context19.next = 30;
                    break;
                  }

                  _iteratorNormalCompletion153 = true;
                  _didIteratorError153 = false;
                  _iteratorError153 = undefined;
                  _context19.prev = 5;
                  _iterator153 = e.getAttributeKeys()[Symbol.iterator]();

                case 7:
                  if (_iteratorNormalCompletion153 = (_step153 = _iterator153.next()).done) {
                    _context19.next = 16;
                    break;
                  }

                  _t110 = _step153.value;

                  if (!_t110.startsWith("selection:")) {
                    _context19.next = 13;
                    break;
                  }

                  _i120 = _t110.substr("selection:".length);
                  _context19.next = 13;
                  return [_i120, e.getAttribute(_t110)];

                case 13:
                  _iteratorNormalCompletion153 = true;
                  _context19.next = 7;
                  break;

                case 16:
                  _context19.next = 22;
                  break;

                case 18:
                  _context19.prev = 18;
                  _context19.t0 = _context19["catch"](5);
                  _didIteratorError153 = true;
                  _iteratorError153 = _context19.t0;

                case 22:
                  _context19.prev = 22;
                  _context19.prev = 23;

                  if (!_iteratorNormalCompletion153 && _iterator153.return != null) {
                    _iterator153.return();
                  }

                case 25:
                  _context19.prev = 25;

                  if (!_didIteratorError153) {
                    _context19.next = 28;
                    break;
                  }

                  throw _iteratorError153;

                case 28:
                  return _context19.finish(25);

                case 29:
                  return _context19.finish(22);

                case 30:
                case "end":
                  return _context19.stop();
              }
            }
          }, _getStoredAttributes, this, [[5, 18, 22, 30], [23,, 25, 29]]);
        })
      }, {
        key: "_getSurroundingAttributes",
        value: function _getSurroundingAttributes() {
          var e = this.getFirstPosition(),
              t = this._model.schema;
          var i = null;

          if (this.isCollapsed) {
            var _n64 = e.textNode ? e.textNode : e.nodeBefore,
                _o39 = e.textNode ? e.textNode : e.nodeAfter;

            if (this.isGravityOverridden || (i = Aa(_n64)), i || (i = Aa(_o39)), !this.isGravityOverridden && !i) {
              var _e106 = _n64;

              for (; _e106 && !t.isInline(_e106) && !i;) {
                _e106 = _e106.previousSibling, i = Aa(_e106);
              }
            }

            if (!i) {
              var _e107 = _o39;

              for (; _e107 && !t.isInline(_e107) && !i;) {
                _e107 = _e107.nextSibling, i = Aa(_e107);
              }
            }

            i || (i = this._getStoredAttributes());
          } else {
            var _e108 = this.getFirstRange();

            var _iteratorNormalCompletion154 = true;
            var _didIteratorError154 = false;
            var _iteratorError154 = undefined;

            try {
              for (var _iterator154 = _e108[Symbol.iterator](), _step154; !(_iteratorNormalCompletion154 = (_step154 = _iterator154.next()).done); _iteratorNormalCompletion154 = true) {
                var _n65 = _step154.value;
                if (_n65.item.is("element") && t.isObject(_n65.item)) break;

                if ("text" == _n65.type) {
                  i = _n65.item.getAttributes();
                  break;
                }
              }
            } catch (err) {
              _didIteratorError154 = true;
              _iteratorError154 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion154 && _iterator154.return != null) {
                  _iterator154.return();
                }
              } finally {
                if (_didIteratorError154) {
                  throw _iteratorError154;
                }
              }
            }
          }

          return i;
        }
      }, {
        key: "_fixGraveyardSelection",
        value: function _fixGraveyardSelection(e) {
          var t = this._model.schema.getNearestSelectionRange(e);

          t && this._pushRange(t);
        }
      }, {
        key: "isCollapsed",
        get: function get() {
          return 0 === this._ranges.length ? this._document._getDefaultRange().isCollapsed : _get(_getPrototypeOf(xa.prototype), "isCollapsed", this);
        }
      }, {
        key: "anchor",
        get: function get() {
          return _get(_getPrototypeOf(xa.prototype), "anchor", this) || this._document._getDefaultRange().start;
        }
      }, {
        key: "focus",
        get: function get() {
          return _get(_getPrototypeOf(xa.prototype), "focus", this) || this._document._getDefaultRange().end;
        }
      }, {
        key: "rangeCount",
        get: function get() {
          return this._ranges.length ? this._ranges.length : 1;
        }
      }, {
        key: "hasOwnRange",
        get: function get() {
          return this._ranges.length > 0;
        }
      }, {
        key: "isGravityOverridden",
        get: function get() {
          return !!this._overriddenGravityRegister.size;
        }
      }]);

      return xa;
    }(ma);

    function Aa(e) {
      return e instanceof Js || e instanceof Qs ? e.getAttributes() : null;
    }

    var Ca =
    /*#__PURE__*/
    function () {
      function Ca(e) {
        _classCallCheck(this, Ca);

        this._dispatchers = e;
      }

      _createClass(Ca, [{
        key: "add",
        value: function add(e) {
          var _iteratorNormalCompletion155 = true;
          var _didIteratorError155 = false;
          var _iteratorError155 = undefined;

          try {
            for (var _iterator155 = this._dispatchers[Symbol.iterator](), _step155; !(_iteratorNormalCompletion155 = (_step155 = _iterator155.next()).done); _iteratorNormalCompletion155 = true) {
              var _t111 = _step155.value;
              e(_t111);
            }
          } catch (err) {
            _didIteratorError155 = true;
            _iteratorError155 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion155 && _iterator155.return != null) {
                _iterator155.return();
              }
            } finally {
              if (_didIteratorError155) {
                throw _iteratorError155;
              }
            }
          }

          return this;
        }
      }]);

      return Ca;
    }();

    var Ta = function Ta(e) {
      return qi(e, 5);
    };

    var Ea =
    /*#__PURE__*/
    function (_Ca) {
      _inherits(Ea, _Ca);

      function Ea() {
        _classCallCheck(this, Ea);

        return _possibleConstructorReturn(this, _getPrototypeOf(Ea).apply(this, arguments));
      }

      _createClass(Ea, [{
        key: "elementToElement",
        value: function elementToElement(e) {
          return this.add(function (e) {
            return (e = Ta(e)).view = Pa(e.view, "container"), function (t) {
              var i;

              if (t.on("insert:" + e.model, (i = e.view, function (e, t, n) {
                var o = i(t.item, n);
                if (!o) return;
                if (!n.consumable.consume(t.item, "insert")) return;
                var r = n.mapper.toViewPosition(t.range.start);
                n.mapper.bindElements(t.item, o), n.writer.insert(r, o);
              }), {
                priority: e.converterPriority || "normal"
              }), e.triggerBy) {
                if (e.triggerBy.attributes) {
                  var _iteratorNormalCompletion156 = true;
                  var _didIteratorError156 = false;
                  var _iteratorError156 = undefined;

                  try {
                    for (var _iterator156 = e.triggerBy.attributes[Symbol.iterator](), _step156; !(_iteratorNormalCompletion156 = (_step156 = _iterator156.next()).done); _iteratorNormalCompletion156 = true) {
                      var _i121 = _step156.value;

                      t._mapReconversionTriggerEvent(e.model, "attribute:".concat(_i121, ":").concat(e.model));
                    }
                  } catch (err) {
                    _didIteratorError156 = true;
                    _iteratorError156 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion156 && _iterator156.return != null) {
                        _iterator156.return();
                      }
                    } finally {
                      if (_didIteratorError156) {
                        throw _iteratorError156;
                      }
                    }
                  }
                }

                if (e.triggerBy.children) {
                  var _iteratorNormalCompletion157 = true;
                  var _didIteratorError157 = false;
                  var _iteratorError157 = undefined;

                  try {
                    for (var _iterator157 = e.triggerBy.children[Symbol.iterator](), _step157; !(_iteratorNormalCompletion157 = (_step157 = _iterator157.next()).done); _iteratorNormalCompletion157 = true) {
                      var _i122 = _step157.value;
                      t._mapReconversionTriggerEvent(e.model, "insert:" + _i122), t._mapReconversionTriggerEvent(e.model, "remove:" + _i122);
                    }
                  } catch (err) {
                    _didIteratorError157 = true;
                    _iteratorError157 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion157 && _iterator157.return != null) {
                        _iterator157.return();
                      }
                    } finally {
                      if (_didIteratorError157) {
                        throw _iteratorError157;
                      }
                    }
                  }
                }
              }
            };
          }(e));
        }
      }, {
        key: "attributeToElement",
        value: function attributeToElement(e) {
          return this.add(function (e) {
            e = Ta(e);
            var t = "attribute:" + (e.model.key ? e.model.key : e.model);
            e.model.name && (t += ":" + e.model.name);

            if (e.model.values) {
              var _iteratorNormalCompletion158 = true;
              var _didIteratorError158 = false;
              var _iteratorError158 = undefined;

              try {
                for (var _iterator158 = e.model.values[Symbol.iterator](), _step158; !(_iteratorNormalCompletion158 = (_step158 = _iterator158.next()).done); _iteratorNormalCompletion158 = true) {
                  var _t112 = _step158.value;
                  e.view[_t112] = Pa(e.view[_t112], "attribute");
                }
              } catch (err) {
                _didIteratorError158 = true;
                _iteratorError158 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion158 && _iterator158.return != null) {
                    _iterator158.return();
                  }
                } finally {
                  if (_didIteratorError158) {
                    throw _iteratorError158;
                  }
                }
              }
            } else e.view = Pa(e.view, "attribute");

            var i = Ma(e);
            return function (n) {
              n.on(t, function (e) {
                return function (t, i, n) {
                  var o = e(i.attributeOldValue, n),
                      r = e(i.attributeNewValue, n);
                  if (!o && !r) return;
                  if (!n.consumable.consume(i.item, t.name)) return;
                  var s = n.writer,
                      a = s.document.selection;
                  if (i.item instanceof ma || i.item instanceof ya) s.wrap(a.getFirstRange(), r);else {
                    var _e109 = n.mapper.toViewRange(i.range);

                    null !== i.attributeOldValue && o && (_e109 = s.unwrap(_e109, o)), null !== i.attributeNewValue && r && s.wrap(_e109, r);
                  }
                };
              }(i), {
                priority: e.converterPriority || "normal"
              });
            };
          }(e));
        }
      }, {
        key: "attributeToAttribute",
        value: function attributeToAttribute(e) {
          return this.add(function (e) {
            e = Ta(e);
            var t = "attribute:" + (e.model.key ? e.model.key : e.model);
            e.model.name && (t += ":" + e.model.name);

            if (e.model.values) {
              var _iteratorNormalCompletion159 = true;
              var _didIteratorError159 = false;
              var _iteratorError159 = undefined;

              try {
                for (var _iterator159 = e.model.values[Symbol.iterator](), _step159; !(_iteratorNormalCompletion159 = (_step159 = _iterator159.next()).done); _iteratorNormalCompletion159 = true) {
                  var _t113 = _step159.value;
                  e.view[_t113] = Na(e.view[_t113]);
                }
              } catch (err) {
                _didIteratorError159 = true;
                _iteratorError159 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion159 && _iterator159.return != null) {
                    _iterator159.return();
                  }
                } finally {
                  if (_didIteratorError159) {
                    throw _iteratorError159;
                  }
                }
              }
            } else e.view = Na(e.view);

            var i = Ma(e);
            return function (n) {
              var o;
              n.on(t, (o = i, function (e, t, i) {
                var n = o(t.attributeOldValue, i),
                    r = o(t.attributeNewValue, i);
                if (!n && !r) return;
                if (!i.consumable.consume(t.item, e.name)) return;
                var s = i.mapper.toViewElement(t.item),
                    a = i.writer;
                if (!s) throw new c.a("conversion-attribute-to-attribute-on-text", [t, i]);
                if (null !== t.attributeOldValue && n) if ("class" == n.key) {
                  var _e110 = en(n.value);

                  var _iteratorNormalCompletion160 = true;
                  var _didIteratorError160 = false;
                  var _iteratorError160 = undefined;

                  try {
                    for (var _iterator160 = _e110[Symbol.iterator](), _step160; !(_iteratorNormalCompletion160 = (_step160 = _iterator160.next()).done); _iteratorNormalCompletion160 = true) {
                      var _t114 = _step160.value;
                      a.removeClass(_t114, s);
                    }
                  } catch (err) {
                    _didIteratorError160 = true;
                    _iteratorError160 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion160 && _iterator160.return != null) {
                        _iterator160.return();
                      }
                    } finally {
                      if (_didIteratorError160) {
                        throw _iteratorError160;
                      }
                    }
                  }
                } else if ("style" == n.key) {
                  var _e111 = Object.keys(n.value);

                  for (var _i123 = 0, _e112 = _e111; _i123 < _e112.length; _i123++) {
                    var _t115 = _e112[_i123];
                    a.removeStyle(_t115, s);
                  }
                } else a.removeAttribute(n.key, s);
                if (null !== t.attributeNewValue && r) if ("class" == r.key) {
                  var _e113 = en(r.value);

                  var _iteratorNormalCompletion161 = true;
                  var _didIteratorError161 = false;
                  var _iteratorError161 = undefined;

                  try {
                    for (var _iterator161 = _e113[Symbol.iterator](), _step161; !(_iteratorNormalCompletion161 = (_step161 = _iterator161.next()).done); _iteratorNormalCompletion161 = true) {
                      var _t116 = _step161.value;
                      a.addClass(_t116, s);
                    }
                  } catch (err) {
                    _didIteratorError161 = true;
                    _iteratorError161 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion161 && _iterator161.return != null) {
                        _iterator161.return();
                      }
                    } finally {
                      if (_didIteratorError161) {
                        throw _iteratorError161;
                      }
                    }
                  }
                } else if ("style" == r.key) {
                  var _e114 = Object.keys(r.value);

                  for (var _i124 = 0, _e115 = _e114; _i124 < _e115.length; _i124++) {
                    var _t117 = _e115[_i124];
                    a.setStyle(_t117, r.value[_t117], s);
                  }
                } else a.setAttribute(r.key, r.value, s);
              }), {
                priority: e.converterPriority || "normal"
              });
            };
          }(e));
        }
      }, {
        key: "markerToElement",
        value: function markerToElement(e) {
          return this.add(function (e) {
            return (e = Ta(e)).view = Pa(e.view, "ui"), function (t) {
              var i;
              t.on("addMarker:" + e.model, (i = e.view, function (e, t, n) {
                t.isOpening = !0;
                var o = i(t, n);
                t.isOpening = !1;
                var r = i(t, n);
                if (!o || !r) return;
                var s = t.markerRange;
                if (s.isCollapsed && !n.consumable.consume(s, e.name)) return;
                var _iteratorNormalCompletion162 = true;
                var _didIteratorError162 = false;
                var _iteratorError162 = undefined;

                try {
                  for (var _iterator162 = s[Symbol.iterator](), _step162; !(_iteratorNormalCompletion162 = (_step162 = _iterator162.next()).done); _iteratorNormalCompletion162 = true) {
                    var _t118 = _step162.value;
                    if (!n.consumable.consume(_t118.item, e.name)) return;
                  }
                } catch (err) {
                  _didIteratorError162 = true;
                  _iteratorError162 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion162 && _iterator162.return != null) {
                      _iterator162.return();
                    }
                  } finally {
                    if (_didIteratorError162) {
                      throw _iteratorError162;
                    }
                  }
                }

                var a = n.mapper,
                    c = n.writer;
                c.insert(a.toViewPosition(s.start), o), n.mapper.bindElementToMarker(o, t.markerName), s.isCollapsed || (c.insert(a.toViewPosition(s.end), r), n.mapper.bindElementToMarker(r, t.markerName)), e.stop();
              }), {
                priority: e.converterPriority || "normal"
              }), t.on("removeMarker:" + e.model, (e.view, function (e, t, i) {
                var n = i.mapper.markerNameToElements(t.markerName);

                if (n) {
                  var _iteratorNormalCompletion163 = true;
                  var _didIteratorError163 = false;
                  var _iteratorError163 = undefined;

                  try {
                    for (var _iterator163 = n[Symbol.iterator](), _step163; !(_iteratorNormalCompletion163 = (_step163 = _iterator163.next()).done); _iteratorNormalCompletion163 = true) {
                      var _e116 = _step163.value;
                      i.mapper.unbindElementFromMarkerName(_e116, t.markerName), i.writer.clear(i.writer.createRangeOn(_e116), _e116);
                    }
                  } catch (err) {
                    _didIteratorError163 = true;
                    _iteratorError163 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion163 && _iterator163.return != null) {
                        _iterator163.return();
                      }
                    } finally {
                      if (_didIteratorError163) {
                        throw _iteratorError163;
                      }
                    }
                  }

                  i.writer.clearClonedElementsGroup(t.markerName), e.stop();
                }
              }), {
                priority: e.converterPriority || "normal"
              });
            };
          }(e));
        }
      }, {
        key: "markerToHighlight",
        value: function markerToHighlight(e) {
          return this.add(function (e) {
            return function (t) {
              var i;
              t.on("addMarker:" + e.model, (i = e.view, function (e, t, n) {
                if (!t.item) return;
                if (!(t.item instanceof ma || t.item instanceof ya || t.item.is("$textProxy"))) return;
                var o = Ra(i, t, n);
                if (!o) return;
                if (!n.consumable.consume(t.item, e.name)) return;
                var r = n.writer,
                    s = Sa(r, o),
                    a = r.document.selection;
                if (t.item instanceof ma || t.item instanceof ya) r.wrap(a.getFirstRange(), s, a);else {
                  var _e117 = n.mapper.toViewRange(t.range),
                      _i125 = r.wrap(_e117, s);

                  var _iteratorNormalCompletion164 = true;
                  var _didIteratorError164 = false;
                  var _iteratorError164 = undefined;

                  try {
                    for (var _iterator164 = _i125.getItems()[Symbol.iterator](), _step164; !(_iteratorNormalCompletion164 = (_step164 = _iterator164.next()).done); _iteratorNormalCompletion164 = true) {
                      var _e118 = _step164.value;

                      if (_e118.is("attributeElement") && _e118.isSimilar(s)) {
                        n.mapper.bindElementToMarker(_e118, t.markerName);
                        break;
                      }
                    }
                  } catch (err) {
                    _didIteratorError164 = true;
                    _iteratorError164 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion164 && _iterator164.return != null) {
                        _iterator164.return();
                      }
                    } finally {
                      if (_didIteratorError164) {
                        throw _iteratorError164;
                      }
                    }
                  }
                }
              }), {
                priority: e.converterPriority || "normal"
              }), t.on("addMarker:" + e.model, function (e) {
                return function (t, i, n) {
                  if (!i.item) return;
                  if (!(i.item instanceof Xs)) return;
                  var o = Ra(e, i, n);
                  if (!o) return;
                  if (!n.consumable.test(i.item, t.name)) return;
                  var r = n.mapper.toViewElement(i.item);

                  if (r && r.getCustomProperty("addHighlight")) {
                    n.consumable.consume(i.item, t.name);
                    var _iteratorNormalCompletion165 = true;
                    var _didIteratorError165 = false;
                    var _iteratorError165 = undefined;

                    try {
                      for (var _iterator165 = sa._createIn(i.item)[Symbol.iterator](), _step165; !(_iteratorNormalCompletion165 = (_step165 = _iterator165.next()).done); _iteratorNormalCompletion165 = true) {
                        var _e119 = _step165.value;
                        n.consumable.consume(_e119.item, t.name);
                      }
                    } catch (err) {
                      _didIteratorError165 = true;
                      _iteratorError165 = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion165 && _iterator165.return != null) {
                          _iterator165.return();
                        }
                      } finally {
                        if (_didIteratorError165) {
                          throw _iteratorError165;
                        }
                      }
                    }

                    r.getCustomProperty("addHighlight")(r, o, n.writer), n.mapper.bindElementToMarker(r, i.markerName);
                  }
                };
              }(e.view), {
                priority: e.converterPriority || "normal"
              }), t.on("removeMarker:" + e.model, function (e) {
                return function (t, i, n) {
                  if (i.markerRange.isCollapsed) return;
                  var o = Ra(e, i, n);
                  if (!o) return;
                  var r = Sa(n.writer, o),
                      s = n.mapper.markerNameToElements(i.markerName);

                  if (s) {
                    var _iteratorNormalCompletion166 = true;
                    var _didIteratorError166 = false;
                    var _iteratorError166 = undefined;

                    try {
                      for (var _iterator166 = s[Symbol.iterator](), _step166; !(_iteratorNormalCompletion166 = (_step166 = _iterator166.next()).done); _iteratorNormalCompletion166 = true) {
                        var _e120 = _step166.value;
                        n.mapper.unbindElementFromMarkerName(_e120, i.markerName), _e120.is("attributeElement") ? n.writer.unwrap(n.writer.createRangeOn(_e120), r) : _e120.getCustomProperty("removeHighlight")(_e120, o.id, n.writer);
                      }
                    } catch (err) {
                      _didIteratorError166 = true;
                      _iteratorError166 = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion166 && _iterator166.return != null) {
                          _iterator166.return();
                        }
                      } finally {
                        if (_didIteratorError166) {
                          throw _iteratorError166;
                        }
                      }
                    }

                    n.writer.clearClonedElementsGroup(i.markerName), t.stop();
                  }
                };
              }(e.view), {
                priority: e.converterPriority || "normal"
              });
            };
          }(e));
        }
      }, {
        key: "markerToData",
        value: function markerToData(e) {
          return this.add(function (e) {
            var t = (e = Ta(e)).model;
            e.view || (e.view = function (i) {
              return {
                group: t,
                name: i.substr(e.model.length + 1)
              };
            });
            return function (i) {
              var n;
              i.on("addMarker:" + t, (n = e.view, function (e, t, i) {
                var o = n(t.markerName, i);
                if (!o) return;
                var r = t.markerRange;
                i.consumable.consume(r, e.name) && (Ia(r, !1, i, t, o), Ia(r, !0, i, t, o), e.stop());
              }), {
                priority: e.converterPriority || "normal"
              }), i.on("removeMarker:" + t, function (e) {
                return function (t, i, n) {
                  var o = e(i.markerName, n);
                  if (!o) return;
                  var r = n.mapper.markerNameToElements(i.markerName);

                  if (r) {
                    var _iteratorNormalCompletion167 = true;
                    var _didIteratorError167 = false;
                    var _iteratorError167 = undefined;

                    try {
                      for (var _iterator167 = r[Symbol.iterator](), _step167; !(_iteratorNormalCompletion167 = (_step167 = _iterator167.next()).done); _iteratorNormalCompletion167 = true) {
                        var _e121 = _step167.value;
                        n.mapper.unbindElementFromMarkerName(_e121, i.markerName), _e121.is("containerElement") ? (s("data-".concat(o.group, "-start-before"), _e121), s("data-".concat(o.group, "-start-after"), _e121), s("data-".concat(o.group, "-end-before"), _e121), s("data-".concat(o.group, "-end-after"), _e121)) : n.writer.clear(n.writer.createRangeOn(_e121), _e121);
                      }
                    } catch (err) {
                      _didIteratorError167 = true;
                      _iteratorError167 = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion167 && _iterator167.return != null) {
                          _iterator167.return();
                        }
                      } finally {
                        if (_didIteratorError167) {
                          throw _iteratorError167;
                        }
                      }
                    }

                    n.writer.clearClonedElementsGroup(i.markerName), t.stop();
                  }

                  function s(e, t) {
                    if (t.hasAttribute(e)) {
                      var _i126 = new Set(t.getAttribute(e).split(","));

                      _i126.delete(o.name), 0 == _i126.size ? n.writer.removeAttribute(e, t) : n.writer.setAttribute(e, Array.from(_i126).join(","), t);
                    }
                  }
                };
              }(e.view), {
                priority: e.converterPriority || "normal"
              });
            };
          }(e));
        }
      }]);

      return Ea;
    }(Ca);

    function Sa(e, t) {
      var i = e.createAttributeElement("span", t.attributes);
      return t.classes && i._addClass(t.classes), "number" == typeof t.priority && (i._priority = t.priority), i._id = t.id, i;
    }

    function Ia(e, t, i, n, o) {
      var r = t ? e.start : e.end,
          s = r.nodeAfter && r.nodeAfter.is("element") ? r.nodeAfter : null,
          a = r.nodeBefore && r.nodeBefore.is("element") ? r.nodeBefore : null;

      if (s || a) {
        var _e122, _r19;

        t && s || !t && !a ? (_e122 = s, _r19 = !0) : (_e122 = a, _r19 = !1);

        var _c3 = i.mapper.toViewElement(_e122);

        if (_c3) return void function (e, t, i, n, o, r) {
          var s = "data-".concat(r.group, "-").concat(t ? "start" : "end", "-").concat(i ? "before" : "after"),
              a = e.hasAttribute(s) ? e.getAttribute(s).split(",") : [];
          a.unshift(r.name), n.writer.setAttribute(s, a.join(","), e), n.mapper.bindElementToMarker(e, o.markerName);
        }(_c3, t, _r19, i, n, o);
      }

      !function (e, t, i, n, o) {
        var r = "".concat(o.group, "-").concat(t ? "start" : "end"),
            s = o.name ? {
          name: o.name
        } : null,
            a = i.writer.createUIElement(r, s);
        i.writer.insert(e, a), i.mapper.bindElementToMarker(a, n.markerName);
      }(i.mapper.toViewPosition(r), t, i, n, o);
    }

    function Pa(e, t) {
      return "function" == typeof e ? e : function (i, n) {
        return function (e, t, i) {
          "string" == typeof e && (e = {
            name: e
          });
          var n;
          var o = t.writer,
              r = Object.assign({}, e.attributes);
          if ("container" == i) n = o.createContainerElement(e.name, r);else if ("attribute" == i) {
            var _t119 = {
              priority: e.priority || xo.DEFAULT_PRIORITY
            };
            n = o.createAttributeElement(e.name, r, _t119);
          } else n = o.createUIElement(e.name, r);

          if (e.styles) {
            var _t120 = Object.keys(e.styles);

            for (var _i127 = 0, _t121 = _t120; _i127 < _t121.length; _i127++) {
              var _i128 = _t121[_i127];
              o.setStyle(_i128, e.styles[_i128], n);
            }
          }

          if (e.classes) {
            var _t122 = e.classes;
            if ("string" == typeof _t122) o.addClass(_t122, n);else {
              var _iteratorNormalCompletion168 = true;
              var _didIteratorError168 = false;
              var _iteratorError168 = undefined;

              try {
                for (var _iterator168 = _t122[Symbol.iterator](), _step168; !(_iteratorNormalCompletion168 = (_step168 = _iterator168.next()).done); _iteratorNormalCompletion168 = true) {
                  var _e123 = _step168.value;
                  o.addClass(_e123, n);
                }
              } catch (err) {
                _didIteratorError168 = true;
                _iteratorError168 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion168 && _iterator168.return != null) {
                    _iterator168.return();
                  }
                } finally {
                  if (_didIteratorError168) {
                    throw _iteratorError168;
                  }
                }
              }
            }
          }

          return n;
        }(e, n, t);
      };
    }

    function Ma(e) {
      return e.model.values ? function (t, i) {
        var n = e.view[t];
        return n ? n(t, i) : null;
      } : e.view;
    }

    function Na(e) {
      return "string" == typeof e ? function (t) {
        return {
          key: e,
          value: t
        };
      } : "object" == typeof e ? e.value ? function () {
        return e;
      } : function (t) {
        return {
          key: e.key,
          value: t
        };
      } : e;
    }

    function Ra(e, t, i) {
      var n = "function" == typeof e ? e(t, i) : e;
      return n ? (n.priority || (n.priority = 10), n.id || (n.id = t.markerName), n) : null;
    }

    function Oa(e) {
      var _e$model = e.model,
          t = _e$model.schema,
          i = _e$model.document;
      var _iteratorNormalCompletion169 = true;
      var _didIteratorError169 = false;
      var _iteratorError169 = undefined;

      try {
        for (var _iterator169 = i.getRootNames()[Symbol.iterator](), _step169; !(_iteratorNormalCompletion169 = (_step169 = _iterator169.next()).done); _iteratorNormalCompletion169 = true) {
          var _n66 = _step169.value;

          var _o40 = i.getRoot(_n66);

          if (_o40.isEmpty && !t.checkChild(_o40, "$text") && t.checkChild(_o40, "paragraph")) return e.insertElement("paragraph", _o40), !0;
        }
      } catch (err) {
        _didIteratorError169 = true;
        _iteratorError169 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion169 && _iterator169.return != null) {
            _iterator169.return();
          }
        } finally {
          if (_didIteratorError169) {
            throw _iteratorError169;
          }
        }
      }

      return !1;
    }

    function za(e, t, i) {
      var n = i.createContext(e);
      return !!i.checkChild(n, "paragraph") && !!i.checkChild(n.push("paragraph"), t);
    }

    function Da(e, t) {
      var i = t.createElement("paragraph");
      return t.insert(i, e), t.createPositionAt(i, 0);
    }

    var La =
    /*#__PURE__*/
    function (_Ca2) {
      _inherits(La, _Ca2);

      function La() {
        _classCallCheck(this, La);

        return _possibleConstructorReturn(this, _getPrototypeOf(La).apply(this, arguments));
      }

      _createClass(La, [{
        key: "elementToElement",
        value: function elementToElement(e) {
          return this.add(Va(e));
        }
      }, {
        key: "elementToAttribute",
        value: function elementToAttribute(e) {
          return this.add(function (e) {
            Fa(e = Ta(e));
            var t = Ha(e, !1),
                i = ja(e.view),
                n = i ? "element:" + i : "element";
            return function (i) {
              i.on(n, t, {
                priority: e.converterPriority || "low"
              });
            };
          }(e));
        }
      }, {
        key: "attributeToAttribute",
        value: function attributeToAttribute(e) {
          return this.add(function (e) {
            e = Ta(e);
            var t = null;
            ("string" == typeof e.view || e.view.key) && (t = function (e) {
              "string" == typeof e.view && (e.view = {
                key: e.view
              });
              var t = e.view.key;
              var i;

              if ("class" == t || "style" == t) {
                i = _defineProperty({}, "class" == t ? "classes" : "styles", e.view.value);
              } else {
                var _n67 = void 0 === e.view.value ? /[\s\S]*/ : e.view.value;

                i = {
                  attributes: _defineProperty({}, t, _n67)
                };
              }

              e.view.name && (i.name = e.view.name);
              return e.view = i, t;
            }(e));
            Fa(e, t);
            var i = Ha(e, !0);
            return function (t) {
              t.on("element", i, {
                priority: e.converterPriority || "low"
              });
            };
          }(e));
        }
      }, {
        key: "elementToMarker",
        value: function elementToMarker(e) {
          return Object(c.b)("upcast-helpers-element-to-marker-deprecated"), this.add(function (e) {
            return function (e) {
              var t = e.model;

              e.model = function (e, i) {
                var n = "string" == typeof t ? t : t(e, i);
                return i.writer.createElement("$marker", {
                  "data-name": n
                });
              };
            }(e = Ta(e)), Va(e);
          }(e));
        }
      }, {
        key: "dataToMarker",
        value: function dataToMarker(e) {
          return this.add(function (e) {
            (e = Ta(e)).model || (e.model = function (t) {
              return t ? e.view + ":" + t : e.view;
            });
            var t = Ba(Ua(e, "start")),
                i = Ba(Ua(e, "end"));
            return function (n) {
              n.on("element:" + e.view + "-start", t, {
                priority: e.converterPriority || "normal"
              }), n.on("element:" + e.view + "-end", i, {
                priority: e.converterPriority || "normal"
              });
              var o = a.get("low"),
                  r = a.get("highest"),
                  s = a.get(e.converterPriority) / r;
              n.on("element", function (e) {
                return function (t, i, n) {
                  var o = "data-" + e.view;

                  function r(t, o) {
                    var _iteratorNormalCompletion170 = true;
                    var _didIteratorError170 = false;
                    var _iteratorError170 = undefined;

                    try {
                      for (var _iterator170 = o[Symbol.iterator](), _step170; !(_iteratorNormalCompletion170 = (_step170 = _iterator170.next()).done); _iteratorNormalCompletion170 = true) {
                        var _r20 = _step170.value;

                        var _o41 = e.model(_r20, n),
                            _s14 = n.writer.createElement("$marker", {
                          "data-name": _o41
                        });

                        n.writer.insert(_s14, t), i.modelCursor.isEqual(t) ? i.modelCursor = i.modelCursor.getShiftedBy(1) : i.modelCursor = i.modelCursor._getTransformedByInsertion(t, 1), i.modelRange = i.modelRange._getTransformedByInsertion(t, 1)[0];
                      }
                    } catch (err) {
                      _didIteratorError170 = true;
                      _iteratorError170 = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion170 && _iterator170.return != null) {
                          _iterator170.return();
                        }
                      } finally {
                        if (_didIteratorError170) {
                          throw _iteratorError170;
                        }
                      }
                    }
                  }

                  (n.consumable.test(i.viewItem, {
                    attributes: o + "-end-after"
                  }) || n.consumable.test(i.viewItem, {
                    attributes: o + "-start-after"
                  }) || n.consumable.test(i.viewItem, {
                    attributes: o + "-end-before"
                  }) || n.consumable.test(i.viewItem, {
                    attributes: o + "-start-before"
                  })) && (i.modelRange || Object.assign(i, n.convertChildren(i.viewItem, i.modelCursor)), n.consumable.consume(i.viewItem, {
                    attributes: o + "-end-after"
                  }) && r(i.modelRange.end, i.viewItem.getAttribute(o + "-end-after").split(",")), n.consumable.consume(i.viewItem, {
                    attributes: o + "-start-after"
                  }) && r(i.modelRange.end, i.viewItem.getAttribute(o + "-start-after").split(",")), n.consumable.consume(i.viewItem, {
                    attributes: o + "-end-before"
                  }) && r(i.modelRange.start, i.viewItem.getAttribute(o + "-end-before").split(",")), n.consumable.consume(i.viewItem, {
                    attributes: o + "-start-before"
                  }) && r(i.modelRange.start, i.viewItem.getAttribute(o + "-start-before").split(",")));
                };
              }(e), {
                priority: o + s
              });
            };
          }(e));
        }
      }]);

      return La;
    }(Ca);

    function Va(e) {
      var t = Ba(e = Ta(e)),
          i = ja(e.view),
          n = i ? "element:" + i : "element";
      return function (i) {
        i.on(n, t, {
          priority: e.converterPriority || "normal"
        });
      };
    }

    function ja(e) {
      return "string" == typeof e ? e : "object" == typeof e && "string" == typeof e.name ? e.name : null;
    }

    function Ba(e) {
      var t = new mn(e.view);
      return function (i, n, o) {
        var r = t.match(n.viewItem);
        if (!r) return;
        var s = r.match;
        if (s.name = !0, !o.consumable.test(n.viewItem, s)) return;

        var a = function (e, t, i) {
          return e instanceof Function ? e(t, i) : i.writer.createElement(e);
        }(e.model, n.viewItem, o);

        a && o.safeInsert(a, n.modelCursor) && (o.consumable.consume(n.viewItem, s), o.convertChildren(n.viewItem, a), o.updateConversionResult(a, n));
      };
    }

    function Fa(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var i = null === t || function (e) {
        return e.getAttribute(t);
      },
          n = "object" != typeof e.model ? e.model : e.model.key,
          o = "object" != typeof e.model || void 0 === e.model.value ? i : e.model.value;

      e.model = {
        key: n,
        value: o
      };
    }

    function Ha(e, t) {
      var i = new mn(e.view);
      return function (n, o, r) {
        var s = i.match(o.viewItem);
        if (!s) return;
        if (!function (e, t) {
          var i = "function" == typeof e ? e(t) : e;
          if ("object" == typeof i && !ja(i)) return !1;
          return !i.classes && !i.attributes && !i.styles;
        }(e.view, o.viewItem) ? delete s.match.name : s.match.name = !0, !r.consumable.test(o.viewItem, s.match)) return;
        var a = e.model.key,
            c = "function" == typeof e.model.value ? e.model.value(o.viewItem, r) : e.model.value;
        if (null === c) return;
        o.modelRange || Object.assign(o, r.convertChildren(o.viewItem, o.modelCursor));
        (function (e, t, i, n) {
          var o = !1;

          for (var _i130 = 0, _Array$from3 = Array.from(e.getItems({
            shallow: i
          })); _i130 < _Array$from3.length; _i130++) {
            var _r21 = _Array$from3[_i130];
            n.schema.checkAttribute(_r21, t.key) && (o = !0, _r21.hasAttribute(t.key) || n.writer.setAttribute(t.key, t.value, _r21));
          }

          return o;
        })(o.modelRange, {
          key: a,
          value: c
        }, t, r) && r.consumable.consume(o.viewItem, s.match);
      };
    }

    function Ua(e, t) {
      var i = {};
      return i.view = e.view + "-" + t, i.model = function (t, i) {
        var n = t.getAttribute("name"),
            o = e.model(n, i);
        return i.writer.createElement("$marker", {
          "data-name": o
        });
      }, i;
    }

    var Wa =
    /*#__PURE__*/
    function () {
      function Wa(e, t) {
        var _this57 = this;

        _classCallCheck(this, Wa);

        this.model = e, this.view = new Gs(t), this.mapper = new aa(), this.downcastDispatcher = new da({
          mapper: this.mapper,
          schema: e.schema
        });
        var i = this.model.document,
            n = i.selection,
            o = this.model.markers;
        this.listenTo(this.model, "_beforeChanges", function () {
          _this57.view._disableRendering(!0);
        }, {
          priority: "highest"
        }), this.listenTo(this.model, "_afterChanges", function () {
          _this57.view._disableRendering(!1);
        }, {
          priority: "lowest"
        }), this.listenTo(i, "change", function () {
          _this57.view.change(function (e) {
            _this57.downcastDispatcher.convertChanges(i.differ, o, e), _this57.downcastDispatcher.convertSelection(n, o, e);
          });
        }, {
          priority: "low"
        }), this.listenTo(this.view.document, "selectionChange", function (e, t) {
          return function (i, n) {
            var o = n.newSelection,
                r = [];
            var _iteratorNormalCompletion171 = true;
            var _didIteratorError171 = false;
            var _iteratorError171 = undefined;

            try {
              for (var _iterator171 = o.getRanges()[Symbol.iterator](), _step171; !(_iteratorNormalCompletion171 = (_step171 = _iterator171.next()).done); _iteratorNormalCompletion171 = true) {
                var _e124 = _step171.value;
                r.push(t.toModelRange(_e124));
              }
            } catch (err) {
              _didIteratorError171 = true;
              _iteratorError171 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion171 && _iterator171.return != null) {
                  _iterator171.return();
                }
              } finally {
                if (_didIteratorError171) {
                  throw _iteratorError171;
                }
              }
            }

            var s = e.createSelection(r, {
              backward: o.isBackward
            });
            s.isEqual(e.document.selection) || e.change(function (e) {
              e.setSelection(s);
            });
          };
        }(this.model, this.mapper)), this.downcastDispatcher.on("insert:$text", function (e, t, i) {
          if (!i.consumable.consume(t.item, "insert")) return;
          var n = i.writer,
              o = i.mapper.toViewPosition(t.range.start),
              r = n.createText(t.item.data);
          n.insert(o, r);
        }, {
          priority: "lowest"
        }), this.downcastDispatcher.on("remove", function (e, t, i) {
          var n = i.mapper.toViewPosition(t.position),
              o = t.position.getShiftedBy(t.length),
              r = i.mapper.toViewPosition(o, {
            isPhantom: !0
          }),
              s = i.writer.createRange(n, r),
              a = i.writer.remove(s.getTrimmed());
          var _iteratorNormalCompletion172 = true;
          var _didIteratorError172 = false;
          var _iteratorError172 = undefined;

          try {
            for (var _iterator172 = i.writer.createRangeIn(a).getItems()[Symbol.iterator](), _step172; !(_iteratorNormalCompletion172 = (_step172 = _iterator172.next()).done); _iteratorNormalCompletion172 = true) {
              var _e125 = _step172.value;
              i.mapper.unbindViewElement(_e125);
            }
          } catch (err) {
            _didIteratorError172 = true;
            _iteratorError172 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion172 && _iterator172.return != null) {
                _iterator172.return();
              }
            } finally {
              if (_didIteratorError172) {
                throw _iteratorError172;
              }
            }
          }
        }, {
          priority: "low"
        }), this.downcastDispatcher.on("selection", function (e, t, i) {
          var n = i.writer,
              o = n.document.selection;
          var _iteratorNormalCompletion173 = true;
          var _didIteratorError173 = false;
          var _iteratorError173 = undefined;

          try {
            for (var _iterator173 = o.getRanges()[Symbol.iterator](), _step173; !(_iteratorNormalCompletion173 = (_step173 = _iterator173.next()).done); _iteratorNormalCompletion173 = true) {
              var _e126 = _step173.value;
              _e126.isCollapsed && _e126.end.parent.isAttached() && i.writer.mergeAttributes(_e126.start);
            }
          } catch (err) {
            _didIteratorError173 = true;
            _iteratorError173 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion173 && _iterator173.return != null) {
                _iterator173.return();
              }
            } finally {
              if (_didIteratorError173) {
                throw _iteratorError173;
              }
            }
          }

          n.setSelection(null);
        }, {
          priority: "high"
        }), this.downcastDispatcher.on("selection", function (e, t, i) {
          var n = t.selection;
          if (n.isCollapsed) return;
          if (!i.consumable.consume(n, "selection")) return;
          var o = [];
          var _iteratorNormalCompletion174 = true;
          var _didIteratorError174 = false;
          var _iteratorError174 = undefined;

          try {
            for (var _iterator174 = n.getRanges()[Symbol.iterator](), _step174; !(_iteratorNormalCompletion174 = (_step174 = _iterator174.next()).done); _iteratorNormalCompletion174 = true) {
              var _e127 = _step174.value;

              var _t123 = i.mapper.toViewRange(_e127);

              o.push(_t123);
            }
          } catch (err) {
            _didIteratorError174 = true;
            _iteratorError174 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion174 && _iterator174.return != null) {
                _iterator174.return();
              }
            } finally {
              if (_didIteratorError174) {
                throw _iteratorError174;
              }
            }
          }

          i.writer.setSelection(o, {
            backward: n.isBackward
          });
        }, {
          priority: "low"
        }), this.downcastDispatcher.on("selection", function (e, t, i) {
          var n = t.selection;
          if (!n.isCollapsed) return;
          if (!i.consumable.consume(n, "selection")) return;
          var o = i.writer,
              r = n.getFirstPosition(),
              s = i.mapper.toViewPosition(r),
              a = o.breakAttributes(s);
          o.setSelection(a);
        }, {
          priority: "low"
        }), this.view.document.roots.bindTo(this.model.document.roots).using(function (e) {
          if ("$graveyard" == e.rootName) return null;
          var t = new so(_this57.view.document, e.name);
          return t.rootName = e.rootName, _this57.mapper.bindElements(e, t), t;
        });
      }

      _createClass(Wa, [{
        key: "destroy",
        value: function destroy() {
          this.view.destroy(), this.stopListening();
        }
      }]);

      return Wa;
    }();

    Ke(Wa, Ue);

    var qa =
    /*#__PURE__*/
    function () {
      function qa() {
        _classCallCheck(this, qa);

        this._commands = new Map();
      }

      _createClass(qa, [{
        key: "add",
        value: function add(e, t) {
          this._commands.set(e, t);
        }
      }, {
        key: "get",
        value: function get(e) {
          return this._commands.get(e);
        }
      }, {
        key: "execute",
        value: function execute(e) {
          var i = this.get(e);
          if (!i) throw new c.a("commandcollection-command-not-found", this, {
            commandName: e
          });

          for (var _len19 = arguments.length, t = new Array(_len19 > 1 ? _len19 - 1 : 0), _key19 = 1; _key19 < _len19; _key19++) {
            t[_key19 - 1] = arguments[_key19];
          }

          return i.execute.apply(i, t);
        }
      }, {
        key: "names",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function names() {
          return _regeneratorRuntime.wrap(function names$(_context20) {
            while (1) {
              switch (_context20.prev = _context20.next) {
                case 0:
                  return _context20.delegateYield(this._commands.keys(), "t0", 1);

                case 1:
                case "end":
                  return _context20.stop();
              }
            }
          }, names, this);
        })
      }, {
        key: "commands",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function commands() {
          return _regeneratorRuntime.wrap(function commands$(_context21) {
            while (1) {
              switch (_context21.prev = _context21.next) {
                case 0:
                  return _context21.delegateYield(this._commands.values(), "t0", 1);

                case 1:
                case "end":
                  return _context21.stop();
              }
            }
          }, commands, this);
        })
      }, {
        key: Symbol.iterator,
        value: function value() {
          return this._commands[Symbol.iterator]();
        }
      }, {
        key: "destroy",
        value: function destroy() {
          var _iteratorNormalCompletion175 = true;
          var _didIteratorError175 = false;
          var _iteratorError175 = undefined;

          try {
            for (var _iterator175 = this.commands()[Symbol.iterator](), _step175; !(_iteratorNormalCompletion175 = (_step175 = _iterator175.next()).done); _iteratorNormalCompletion175 = true) {
              var _e128 = _step175.value;

              _e128.destroy();
            }
          } catch (err) {
            _didIteratorError175 = true;
            _iteratorError175 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion175 && _iterator175.return != null) {
                _iterator175.return();
              }
            } finally {
              if (_didIteratorError175) {
                throw _iteratorError175;
              }
            }
          }
        }
      }]);

      return qa;
    }();

    var $a =
    /*#__PURE__*/
    function () {
      function $a() {
        _classCallCheck(this, $a);

        this._consumables = new Map();
      }

      _createClass($a, [{
        key: "add",
        value: function add(e, t) {
          var i;
          e.is("$text") || e.is("documentFragment") ? this._consumables.set(e, !0) : (this._consumables.has(e) ? i = this._consumables.get(e) : (i = new Ya(e), this._consumables.set(e, i)), i.add(t));
        }
      }, {
        key: "test",
        value: function test(e, t) {
          var i = this._consumables.get(e);

          return void 0 === i ? null : e.is("$text") || e.is("documentFragment") ? i : i.test(t);
        }
      }, {
        key: "consume",
        value: function consume(e, t) {
          return !!this.test(e, t) && (e.is("$text") || e.is("documentFragment") ? this._consumables.set(e, !1) : this._consumables.get(e).consume(t), !0);
        }
      }, {
        key: "revert",
        value: function revert(e, t) {
          var i = this._consumables.get(e);

          void 0 !== i && (e.is("$text") || e.is("documentFragment") ? this._consumables.set(e, !0) : i.revert(t));
        }
      }], [{
        key: "consumablesFromElement",
        value: function consumablesFromElement(e) {
          var t = {
            element: e,
            name: !0,
            attributes: [],
            classes: [],
            styles: []
          },
              i = e.getAttributeKeys();
          var _iteratorNormalCompletion176 = true;
          var _didIteratorError176 = false;
          var _iteratorError176 = undefined;

          try {
            for (var _iterator176 = i[Symbol.iterator](), _step176; !(_iteratorNormalCompletion176 = (_step176 = _iterator176.next()).done); _iteratorNormalCompletion176 = true) {
              var _e129 = _step176.value;
              "style" != _e129 && "class" != _e129 && t.attributes.push(_e129);
            }
          } catch (err) {
            _didIteratorError176 = true;
            _iteratorError176 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion176 && _iterator176.return != null) {
                _iterator176.return();
              }
            } finally {
              if (_didIteratorError176) {
                throw _iteratorError176;
              }
            }
          }

          var n = e.getClassNames();
          var _iteratorNormalCompletion177 = true;
          var _didIteratorError177 = false;
          var _iteratorError177 = undefined;

          try {
            for (var _iterator177 = n[Symbol.iterator](), _step177; !(_iteratorNormalCompletion177 = (_step177 = _iterator177.next()).done); _iteratorNormalCompletion177 = true) {
              var _e130 = _step177.value;
              t.classes.push(_e130);
            }
          } catch (err) {
            _didIteratorError177 = true;
            _iteratorError177 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion177 && _iterator177.return != null) {
                _iterator177.return();
              }
            } finally {
              if (_didIteratorError177) {
                throw _iteratorError177;
              }
            }
          }

          var o = e.getStyleNames();
          var _iteratorNormalCompletion178 = true;
          var _didIteratorError178 = false;
          var _iteratorError178 = undefined;

          try {
            for (var _iterator178 = o[Symbol.iterator](), _step178; !(_iteratorNormalCompletion178 = (_step178 = _iterator178.next()).done); _iteratorNormalCompletion178 = true) {
              var _e131 = _step178.value;
              t.styles.push(_e131);
            }
          } catch (err) {
            _didIteratorError178 = true;
            _iteratorError178 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion178 && _iterator178.return != null) {
                _iterator178.return();
              }
            } finally {
              if (_didIteratorError178) {
                throw _iteratorError178;
              }
            }
          }

          return t;
        }
      }, {
        key: "createFrom",
        value: function createFrom(e, t) {
          if (t || (t = new $a(e)), e.is("$text")) return t.add(e), t;
          e.is("element") && t.add(e, $a.consumablesFromElement(e)), e.is("documentFragment") && t.add(e);
          var _iteratorNormalCompletion179 = true;
          var _didIteratorError179 = false;
          var _iteratorError179 = undefined;

          try {
            for (var _iterator179 = e.getChildren()[Symbol.iterator](), _step179; !(_iteratorNormalCompletion179 = (_step179 = _iterator179.next()).done); _iteratorNormalCompletion179 = true) {
              var _i131 = _step179.value;
              t = $a.createFrom(_i131, t);
            }
          } catch (err) {
            _didIteratorError179 = true;
            _iteratorError179 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion179 && _iterator179.return != null) {
                _iterator179.return();
              }
            } finally {
              if (_didIteratorError179) {
                throw _iteratorError179;
              }
            }
          }

          return t;
        }
      }]);

      return $a;
    }();

    var Ya =
    /*#__PURE__*/
    function () {
      function Ya(e) {
        _classCallCheck(this, Ya);

        this.element = e, this._canConsumeName = null, this._consumables = {
          attributes: new Map(),
          styles: new Map(),
          classes: new Map()
        };
      }

      _createClass(Ya, [{
        key: "add",
        value: function add(e) {
          e.name && (this._canConsumeName = !0);

          for (var _t124 in this._consumables) {
            _t124 in e && this._add(_t124, e[_t124]);
          }
        }
      }, {
        key: "test",
        value: function test(e) {
          if (e.name && !this._canConsumeName) return this._canConsumeName;

          for (var _t125 in this._consumables) {
            if (_t125 in e) {
              var _i132 = this._test(_t125, e[_t125]);

              if (!0 !== _i132) return _i132;
            }
          }

          return !0;
        }
      }, {
        key: "consume",
        value: function consume(e) {
          e.name && (this._canConsumeName = !1);

          for (var _t126 in this._consumables) {
            _t126 in e && this._consume(_t126, e[_t126]);
          }
        }
      }, {
        key: "revert",
        value: function revert(e) {
          e.name && (this._canConsumeName = !0);

          for (var _t127 in this._consumables) {
            _t127 in e && this._revert(_t127, e[_t127]);
          }
        }
      }, {
        key: "_add",
        value: function _add(e, t) {
          var i = _e(t) ? t : [t],
              n = this._consumables[e];
          var _iteratorNormalCompletion180 = true;
          var _didIteratorError180 = false;
          var _iteratorError180 = undefined;

          try {
            for (var _iterator180 = i[Symbol.iterator](), _step180; !(_iteratorNormalCompletion180 = (_step180 = _iterator180.next()).done); _iteratorNormalCompletion180 = true) {
              var _t128 = _step180.value;
              if ("attributes" === e && ("class" === _t128 || "style" === _t128)) throw new c.a("viewconsumable-invalid-attribute", this);

              if (n.set(_t128, !0), "styles" === e) {
                var _iteratorNormalCompletion181 = true;
                var _didIteratorError181 = false;
                var _iteratorError181 = undefined;

                try {
                  for (var _iterator181 = this.element.document.stylesProcessor.getRelatedStyles(_t128)[Symbol.iterator](), _step181; !(_iteratorNormalCompletion181 = (_step181 = _iterator181.next()).done); _iteratorNormalCompletion181 = true) {
                    var _e132 = _step181.value;
                    n.set(_e132, !0);
                  }
                } catch (err) {
                  _didIteratorError181 = true;
                  _iteratorError181 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion181 && _iterator181.return != null) {
                      _iterator181.return();
                    }
                  } finally {
                    if (_didIteratorError181) {
                      throw _iteratorError181;
                    }
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError180 = true;
            _iteratorError180 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion180 && _iterator180.return != null) {
                _iterator180.return();
              }
            } finally {
              if (_didIteratorError180) {
                throw _iteratorError180;
              }
            }
          }
        }
      }, {
        key: "_test",
        value: function _test(e, t) {
          var i = _e(t) ? t : [t],
              n = this._consumables[e];
          var _iteratorNormalCompletion182 = true;
          var _didIteratorError182 = false;
          var _iteratorError182 = undefined;

          try {
            for (var _iterator182 = i[Symbol.iterator](), _step182; !(_iteratorNormalCompletion182 = (_step182 = _iterator182.next()).done); _iteratorNormalCompletion182 = true) {
              var _t129 = _step182.value;

              if ("attributes" !== e || "class" !== _t129 && "style" !== _t129) {
                var _e133 = n.get(_t129);

                if (void 0 === _e133) return null;
                if (!_e133) return !1;
              } else {
                var _e134 = "class" == _t129 ? "classes" : "styles",
                    _i133 = this._test(_e134, _toConsumableArray(this._consumables[_e134].keys()));

                if (!0 !== _i133) return _i133;
              }
            }
          } catch (err) {
            _didIteratorError182 = true;
            _iteratorError182 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion182 && _iterator182.return != null) {
                _iterator182.return();
              }
            } finally {
              if (_didIteratorError182) {
                throw _iteratorError182;
              }
            }
          }

          return !0;
        }
      }, {
        key: "_consume",
        value: function _consume(e, t) {
          var i = _e(t) ? t : [t],
              n = this._consumables[e];
          var _iteratorNormalCompletion183 = true;
          var _didIteratorError183 = false;
          var _iteratorError183 = undefined;

          try {
            for (var _iterator183 = i[Symbol.iterator](), _step183; !(_iteratorNormalCompletion183 = (_step183 = _iterator183.next()).done); _iteratorNormalCompletion183 = true) {
              var _t130 = _step183.value;

              if ("attributes" !== e || "class" !== _t130 && "style" !== _t130) {
                if (n.set(_t130, !1), "styles" == e) {
                  var _iteratorNormalCompletion184 = true;
                  var _didIteratorError184 = false;
                  var _iteratorError184 = undefined;

                  try {
                    for (var _iterator184 = this.element.document.stylesProcessor.getRelatedStyles(_t130)[Symbol.iterator](), _step184; !(_iteratorNormalCompletion184 = (_step184 = _iterator184.next()).done); _iteratorNormalCompletion184 = true) {
                      var _e135 = _step184.value;
                      n.set(_e135, !1);
                    }
                  } catch (err) {
                    _didIteratorError184 = true;
                    _iteratorError184 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion184 && _iterator184.return != null) {
                        _iterator184.return();
                      }
                    } finally {
                      if (_didIteratorError184) {
                        throw _iteratorError184;
                      }
                    }
                  }
                }
              } else {
                var _e136 = "class" == _t130 ? "classes" : "styles";

                this._consume(_e136, _toConsumableArray(this._consumables[_e136].keys()));
              }
            }
          } catch (err) {
            _didIteratorError183 = true;
            _iteratorError183 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion183 && _iterator183.return != null) {
                _iterator183.return();
              }
            } finally {
              if (_didIteratorError183) {
                throw _iteratorError183;
              }
            }
          }
        }
      }, {
        key: "_revert",
        value: function _revert(e, t) {
          var i = _e(t) ? t : [t],
              n = this._consumables[e];
          var _iteratorNormalCompletion185 = true;
          var _didIteratorError185 = false;
          var _iteratorError185 = undefined;

          try {
            for (var _iterator185 = i[Symbol.iterator](), _step185; !(_iteratorNormalCompletion185 = (_step185 = _iterator185.next()).done); _iteratorNormalCompletion185 = true) {
              var _t131 = _step185.value;

              if ("attributes" !== e || "class" !== _t131 && "style" !== _t131) {
                !1 === n.get(_t131) && n.set(_t131, !0);
              } else {
                var _e137 = "class" == _t131 ? "classes" : "styles";

                this._revert(_e137, _toConsumableArray(this._consumables[_e137].keys()));
              }
            }
          } catch (err) {
            _didIteratorError185 = true;
            _iteratorError185 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion185 && _iterator185.return != null) {
                _iterator185.return();
              }
            } finally {
              if (_didIteratorError185) {
                throw _iteratorError185;
              }
            }
          }
        }
      }]);

      return Ya;
    }();

    var Ga =
    /*#__PURE__*/
    function () {
      function Ga() {
        var _this58 = this;

        _classCallCheck(this, Ga);

        this._sourceDefinitions = {}, this._attributeProperties = {}, this.decorate("checkChild"), this.decorate("checkAttribute"), this.on("checkAttribute", function (e, t) {
          t[0] = new Ka(t[0]);
        }, {
          priority: "highest"
        }), this.on("checkChild", function (e, t) {
          t[0] = new Ka(t[0]), t[1] = _this58.getDefinition(t[1]);
        }, {
          priority: "highest"
        });
      }

      _createClass(Ga, [{
        key: "register",
        value: function register(e, t) {
          if (this._sourceDefinitions[e]) throw new c.a("schema-cannot-register-item-twice", this, {
            itemName: e
          });
          this._sourceDefinitions[e] = [Object.assign({}, t)], this._clearCache();
        }
      }, {
        key: "extend",
        value: function extend(e, t) {
          if (!this._sourceDefinitions[e]) throw new c.a("schema-cannot-extend-missing-item", this, {
            itemName: e
          });
          this._sourceDefinitions[e].push(Object.assign({}, t)), this._clearCache();
        }
      }, {
        key: "getDefinitions",
        value: function getDefinitions() {
          return this._compiledDefinitions || this._compile(), this._compiledDefinitions;
        }
      }, {
        key: "getDefinition",
        value: function getDefinition(e) {
          var t;
          return t = "string" == typeof e ? e : e.is && (e.is("$text") || e.is("$textProxy")) ? "$text" : e.name, this.getDefinitions()[t];
        }
      }, {
        key: "isRegistered",
        value: function isRegistered(e) {
          return !!this.getDefinition(e);
        }
      }, {
        key: "isBlock",
        value: function isBlock(e) {
          var t = this.getDefinition(e);
          return !(!t || !t.isBlock);
        }
      }, {
        key: "isLimit",
        value: function isLimit(e) {
          var t = this.getDefinition(e);
          return !!t && !(!t.isLimit && !t.isObject);
        }
      }, {
        key: "isObject",
        value: function isObject(e) {
          var t = this.getDefinition(e);
          return !!t && !!(t.isObject || t.isLimit && t.isSelectable && t.isContent);
        }
      }, {
        key: "isInline",
        value: function isInline(e) {
          var t = this.getDefinition(e);
          return !(!t || !t.isInline);
        }
      }, {
        key: "isSelectable",
        value: function isSelectable(e) {
          var t = this.getDefinition(e);
          return !!t && !(!t.isSelectable && !t.isObject);
        }
      }, {
        key: "isContent",
        value: function isContent(e) {
          var t = this.getDefinition(e);
          return !!t && !(!t.isContent && !t.isObject);
        }
      }, {
        key: "checkChild",
        value: function checkChild(e, t) {
          return !!t && this._checkContextMatch(t, e);
        }
      }, {
        key: "checkAttribute",
        value: function checkAttribute(e, t) {
          var i = this.getDefinition(e.last);
          return !!i && i.allowAttributes.includes(t);
        }
      }, {
        key: "checkMerge",
        value: function checkMerge(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

          if (e instanceof ia) {
            var _t132 = e.nodeBefore,
                _i134 = e.nodeAfter;
            if (!(_t132 instanceof Xs)) throw new c.a("schema-check-merge-no-element-before", this);
            if (!(_i134 instanceof Xs)) throw new c.a("schema-check-merge-no-element-after", this);
            return this.checkMerge(_t132, _i134);
          }

          var _iteratorNormalCompletion186 = true;
          var _didIteratorError186 = false;
          var _iteratorError186 = undefined;

          try {
            for (var _iterator186 = t.getChildren()[Symbol.iterator](), _step186; !(_iteratorNormalCompletion186 = (_step186 = _iterator186.next()).done); _iteratorNormalCompletion186 = true) {
              var _i135 = _step186.value;
              if (!this.checkChild(e, _i135)) return !1;
            }
          } catch (err) {
            _didIteratorError186 = true;
            _iteratorError186 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion186 && _iterator186.return != null) {
                _iterator186.return();
              }
            } finally {
              if (_didIteratorError186) {
                throw _iteratorError186;
              }
            }
          }

          return !0;
        }
      }, {
        key: "addChildCheck",
        value: function addChildCheck(e) {
          this.on("checkChild", function (t, _ref62) {
            var _ref63 = _slicedToArray(_ref62, 2),
                i = _ref63[0],
                n = _ref63[1];

            if (!n) return;
            var o = e(i, n);
            "boolean" == typeof o && (t.stop(), t.return = o);
          }, {
            priority: "high"
          });
        }
      }, {
        key: "addAttributeCheck",
        value: function addAttributeCheck(e) {
          this.on("checkAttribute", function (t, _ref64) {
            var _ref65 = _slicedToArray(_ref64, 2),
                i = _ref65[0],
                n = _ref65[1];

            var o = e(i, n);
            "boolean" == typeof o && (t.stop(), t.return = o);
          }, {
            priority: "high"
          });
        }
      }, {
        key: "setAttributeProperties",
        value: function setAttributeProperties(e, t) {
          this._attributeProperties[e] = Object.assign(this.getAttributeProperties(e), t);
        }
      }, {
        key: "getAttributeProperties",
        value: function getAttributeProperties(e) {
          return this._attributeProperties[e] || {};
        }
      }, {
        key: "getLimitElement",
        value: function getLimitElement(e) {
          var t;
          if (e instanceof ia) t = e.parent;else {
            t = (e instanceof sa ? [e] : Array.from(e.getRanges())).reduce(function (e, t) {
              var i = t.getCommonAncestor();
              return e ? e.getCommonAncestor(i, {
                includeSelf: !0
              }) : i;
            }, null);
          }

          for (; !this.isLimit(t) && t.parent;) {
            t = t.parent;
          }

          return t;
        }
      }, {
        key: "checkAttributeInSelection",
        value: function checkAttributeInSelection(e, t) {
          if (e.isCollapsed) {
            var _i136 = [].concat(_toConsumableArray(e.getFirstPosition().getAncestors()), [new Qs("", e.getAttributes())]);

            return this.checkAttribute(_i136, t);
          }

          {
            var _i137 = e.getRanges();

            var _iteratorNormalCompletion187 = true;
            var _didIteratorError187 = false;
            var _iteratorError187 = undefined;

            try {
              for (var _iterator187 = _i137[Symbol.iterator](), _step187; !(_iteratorNormalCompletion187 = (_step187 = _iterator187.next()).done); _iteratorNormalCompletion187 = true) {
                var _e138 = _step187.value;
                var _iteratorNormalCompletion188 = true;
                var _didIteratorError188 = false;
                var _iteratorError188 = undefined;

                try {
                  for (var _iterator188 = _e138[Symbol.iterator](), _step188; !(_iteratorNormalCompletion188 = (_step188 = _iterator188.next()).done); _iteratorNormalCompletion188 = true) {
                    var _i138 = _step188.value;
                    if (this.checkAttribute(_i138.item, t)) return !0;
                  }
                } catch (err) {
                  _didIteratorError188 = true;
                  _iteratorError188 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion188 && _iterator188.return != null) {
                      _iterator188.return();
                    }
                  } finally {
                    if (_didIteratorError188) {
                      throw _iteratorError188;
                    }
                  }
                }
              }
            } catch (err) {
              _didIteratorError187 = true;
              _iteratorError187 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion187 && _iterator187.return != null) {
                  _iterator187.return();
                }
              } finally {
                if (_didIteratorError187) {
                  throw _iteratorError187;
                }
              }
            }
          }
          return !1;
        }
      }, {
        key: "getValidRanges",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function getValidRanges(e, t) {
          var _iteratorNormalCompletion190, _didIteratorError190, _iteratorError190, _iterator190, _step190, _i139;

          return _regeneratorRuntime.wrap(function getValidRanges$(_context23) {
            while (1) {
              switch (_context23.prev = _context23.next) {
                case 0:
                  e =
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee(e) {
                    var _iteratorNormalCompletion189, _didIteratorError189, _iteratorError189, _iterator189, _step189, _t133;

                    return _regeneratorRuntime.wrap(function _callee$(_context22) {
                      while (1) {
                        switch (_context22.prev = _context22.next) {
                          case 0:
                            _iteratorNormalCompletion189 = true;
                            _didIteratorError189 = false;
                            _iteratorError189 = undefined;
                            _context22.prev = 3;
                            _iterator189 = e[Symbol.iterator]();

                          case 5:
                            if (_iteratorNormalCompletion189 = (_step189 = _iterator189.next()).done) {
                              _context22.next = 11;
                              break;
                            }

                            _t133 = _step189.value;
                            return _context22.delegateYield(_t133.getMinimalFlatRanges(), "t0", 8);

                          case 8:
                            _iteratorNormalCompletion189 = true;
                            _context22.next = 5;
                            break;

                          case 11:
                            _context22.next = 17;
                            break;

                          case 13:
                            _context22.prev = 13;
                            _context22.t1 = _context22["catch"](3);
                            _didIteratorError189 = true;
                            _iteratorError189 = _context22.t1;

                          case 17:
                            _context22.prev = 17;
                            _context22.prev = 18;

                            if (!_iteratorNormalCompletion189 && _iterator189.return != null) {
                              _iterator189.return();
                            }

                          case 20:
                            _context22.prev = 20;

                            if (!_didIteratorError189) {
                              _context22.next = 23;
                              break;
                            }

                            throw _iteratorError189;

                          case 23:
                            return _context22.finish(20);

                          case 24:
                            return _context22.finish(17);

                          case 25:
                          case "end":
                            return _context22.stop();
                        }
                      }
                    }, _callee, null, [[3, 13, 17, 25], [18,, 20, 24]]);
                  })(e);
                  _iteratorNormalCompletion190 = true;
                  _didIteratorError190 = false;
                  _iteratorError190 = undefined;
                  _context23.prev = 4;
                  _iterator190 = e[Symbol.iterator]();

                case 6:
                  if (_iteratorNormalCompletion190 = (_step190 = _iterator190.next()).done) {
                    _context23.next = 12;
                    break;
                  }

                  _i139 = _step190.value;
                  return _context23.delegateYield(this._getValidRangesForRange(_i139, t), "t0", 9);

                case 9:
                  _iteratorNormalCompletion190 = true;
                  _context23.next = 6;
                  break;

                case 12:
                  _context23.next = 18;
                  break;

                case 14:
                  _context23.prev = 14;
                  _context23.t1 = _context23["catch"](4);
                  _didIteratorError190 = true;
                  _iteratorError190 = _context23.t1;

                case 18:
                  _context23.prev = 18;
                  _context23.prev = 19;

                  if (!_iteratorNormalCompletion190 && _iterator190.return != null) {
                    _iterator190.return();
                  }

                case 21:
                  _context23.prev = 21;

                  if (!_didIteratorError190) {
                    _context23.next = 24;
                    break;
                  }

                  throw _iteratorError190;

                case 24:
                  return _context23.finish(21);

                case 25:
                  return _context23.finish(18);

                case 26:
                case "end":
                  return _context23.stop();
              }
            }
          }, getValidRanges, this, [[4, 14, 18, 26], [19,, 21, 25]]);
        })
      }, {
        key: "getNearestSelectionRange",
        value: function getNearestSelectionRange(e) {
          var _this59 = this;

          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "both";
          if (this.checkChild(e, "$text")) return new sa(e);
          var i, n;
          var o = e.getAncestors().reverse().find(function (e) {
            return _this59.isLimit(e);
          }) || e.root;
          "both" != t && "backward" != t || (i = new ea({
            boundaries: sa._createIn(o),
            startPosition: e,
            direction: "backward"
          })), "both" != t && "forward" != t || (n = new ea({
            boundaries: sa._createIn(o),
            startPosition: e
          }));
          var _iteratorNormalCompletion191 = true;
          var _didIteratorError191 = false;
          var _iteratorError191 = undefined;

          try {
            for (var _iterator191 =
            /*#__PURE__*/
            _regeneratorRuntime.mark(function _callee2(e, t) {
              var i, _t135, _e140;

              return _regeneratorRuntime.wrap(function _callee2$(_context24) {
                while (1) {
                  switch (_context24.prev = _context24.next) {
                    case 0:
                      i = !1;

                    case 1:
                      if (i) {
                        _context24.next = 18;
                        break;
                      }

                      if (!(i = !0, e)) {
                        _context24.next = 9;
                        break;
                      }

                      _t135 = e.next();
                      _context24.t0 = _t135.done;

                      if (_context24.t0) {
                        _context24.next = 9;
                        break;
                      }

                      i = !1;
                      _context24.next = 9;
                      return {
                        walker: e,
                        value: _t135.value
                      };

                    case 9:
                      if (!t) {
                        _context24.next = 16;
                        break;
                      }

                      _e140 = t.next();
                      _context24.t1 = _e140.done;

                      if (_context24.t1) {
                        _context24.next = 16;
                        break;
                      }

                      i = !1;
                      _context24.next = 16;
                      return {
                        walker: t,
                        value: _e140.value
                      };

                    case 16:
                      _context24.next = 1;
                      break;

                    case 18:
                    case "end":
                      return _context24.stop();
                  }
                }
              }, _callee2);
            })(i, n)[Symbol.iterator](), _step191; !(_iteratorNormalCompletion191 = (_step191 = _iterator191.next()).done); _iteratorNormalCompletion191 = true) {
              var _e139 = _step191.value;

              var _t134 = _e139.walker == i ? "elementEnd" : "elementStart",
                  _n68 = _e139.value;

              if (_n68.type == _t134 && this.isObject(_n68.item)) return sa._createOn(_n68.item);
              if (this.checkChild(_n68.nextPosition, "$text")) return new sa(_n68.nextPosition);
            }
          } catch (err) {
            _didIteratorError191 = true;
            _iteratorError191 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion191 && _iterator191.return != null) {
                _iterator191.return();
              }
            } finally {
              if (_didIteratorError191) {
                throw _iteratorError191;
              }
            }
          }

          return null;
        }
      }, {
        key: "findAllowedParent",
        value: function findAllowedParent(e, t) {
          var i = e.parent;

          for (; i;) {
            if (this.checkChild(i, t)) return i;
            if (this.isLimit(i)) return null;
            i = i.parent;
          }

          return null;
        }
      }, {
        key: "removeDisallowedAttributes",
        value: function removeDisallowedAttributes(e, t) {
          var _iteratorNormalCompletion192 = true;
          var _didIteratorError192 = false;
          var _iteratorError192 = undefined;

          try {
            for (var _iterator192 = e[Symbol.iterator](), _step192; !(_iteratorNormalCompletion192 = (_step192 = _iterator192.next()).done); _iteratorNormalCompletion192 = true) {
              var _i140 = _step192.value;
              if (_i140.is("$text")) cc(this, _i140, t);else {
                var _e141 = sa._createIn(_i140).getPositions();

                var _iteratorNormalCompletion193 = true;
                var _didIteratorError193 = false;
                var _iteratorError193 = undefined;

                try {
                  for (var _iterator193 = _e141[Symbol.iterator](), _step193; !(_iteratorNormalCompletion193 = (_step193 = _iterator193.next()).done); _iteratorNormalCompletion193 = true) {
                    var _i141 = _step193.value;
                    cc(this, _i141.nodeBefore || _i141.parent, t);
                  }
                } catch (err) {
                  _didIteratorError193 = true;
                  _iteratorError193 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion193 && _iterator193.return != null) {
                      _iterator193.return();
                    }
                  } finally {
                    if (_didIteratorError193) {
                      throw _iteratorError193;
                    }
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError192 = true;
            _iteratorError192 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion192 && _iterator192.return != null) {
                _iterator192.return();
              }
            } finally {
              if (_didIteratorError192) {
                throw _iteratorError192;
              }
            }
          }
        }
      }, {
        key: "createContext",
        value: function createContext(e) {
          return new Ka(e);
        }
      }, {
        key: "_clearCache",
        value: function _clearCache() {
          this._compiledDefinitions = null;
        }
      }, {
        key: "_compile",
        value: function _compile() {
          var e = {},
              t = this._sourceDefinitions,
              i = Object.keys(t);

          for (var _i143 = 0, _i142 = i; _i143 < _i142.length; _i143++) {
            var _n69 = _i142[_i143];
            e[_n69] = Qa(t[_n69], _n69);
          }

          for (var _i145 = 0, _i144 = i; _i145 < _i144.length; _i145++) {
            var _t136 = _i144[_i145];
            Ja(e, _t136);
          }

          for (var _i147 = 0, _i146 = i; _i147 < _i146.length; _i147++) {
            var _t137 = _i146[_i147];
            Za(e, _t137);
          }

          for (var _i149 = 0, _i148 = i; _i149 < _i148.length; _i149++) {
            var _t138 = _i148[_i149];
            Xa(e, _t138);
          }

          for (var _i151 = 0, _i150 = i; _i151 < _i150.length; _i151++) {
            var _t139 = _i150[_i151];
            ec(e, _t139), tc(e, _t139);
          }

          for (var _i153 = 0, _i152 = i; _i153 < _i152.length; _i153++) {
            var _t140 = _i152[_i153];
            ic(e, _t140), nc(e, _t140), oc(e, _t140);
          }

          this._compiledDefinitions = e;
        }
      }, {
        key: "_checkContextMatch",
        value: function _checkContextMatch(e, t) {
          var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : t.length - 1;
          var n = t.getItem(i);

          if (e.allowIn.includes(n.name)) {
            if (0 == i) return !0;
            {
              var _e142 = this.getDefinition(n);

              return this._checkContextMatch(_e142, t, i - 1);
            }
          }

          return !1;
        }
      }, {
        key: "_getValidRangesForRange",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _getValidRangesForRange(e, t) {
          var i, n, _iteratorNormalCompletion194, _didIteratorError194, _iteratorError194, _iterator194, _step194, _o42;

          return _regeneratorRuntime.wrap(function _getValidRangesForRange$(_context25) {
            while (1) {
              switch (_context25.prev = _context25.next) {
                case 0:
                  i = e.start, n = e.start;
                  _iteratorNormalCompletion194 = true;
                  _didIteratorError194 = false;
                  _iteratorError194 = undefined;
                  _context25.prev = 4;
                  _iterator194 = e.getItems({
                    shallow: !0
                  })[Symbol.iterator]();

                case 6:
                  if (_iteratorNormalCompletion194 = (_step194 = _iterator194.next()).done) {
                    _context25.next = 22;
                    break;
                  }

                  _o42 = _step194.value;
                  _context25.t0 = _o42.is("element");

                  if (!_context25.t0) {
                    _context25.next = 11;
                    break;
                  }

                  return _context25.delegateYield(this._getValidRangesForRange(sa._createIn(_o42), t), "t1", 11);

                case 11:
                  _context25.t2 = this.checkAttribute(_o42, t);

                  if (_context25.t2) {
                    _context25.next = 18;
                    break;
                  }

                  _context25.t3 = i.isEqual(n);

                  if (_context25.t3) {
                    _context25.next = 17;
                    break;
                  }

                  _context25.next = 17;
                  return new sa(i, n);

                case 17:
                  i = ia._createAfter(_o42);

                case 18:
                  n = ia._createAfter(_o42);

                case 19:
                  _iteratorNormalCompletion194 = true;
                  _context25.next = 6;
                  break;

                case 22:
                  _context25.next = 28;
                  break;

                case 24:
                  _context25.prev = 24;
                  _context25.t4 = _context25["catch"](4);
                  _didIteratorError194 = true;
                  _iteratorError194 = _context25.t4;

                case 28:
                  _context25.prev = 28;
                  _context25.prev = 29;

                  if (!_iteratorNormalCompletion194 && _iterator194.return != null) {
                    _iterator194.return();
                  }

                case 31:
                  _context25.prev = 31;

                  if (!_didIteratorError194) {
                    _context25.next = 34;
                    break;
                  }

                  throw _iteratorError194;

                case 34:
                  return _context25.finish(31);

                case 35:
                  return _context25.finish(28);

                case 36:
                  _context25.t5 = i.isEqual(n);

                  if (_context25.t5) {
                    _context25.next = 40;
                    break;
                  }

                  _context25.next = 40;
                  return new sa(i, n);

                case 40:
                case "end":
                  return _context25.stop();
              }
            }
          }, _getValidRangesForRange, this, [[4, 24, 28, 36], [29,, 31, 35]]);
        })
      }]);

      return Ga;
    }();

    Ke(Ga, Ue);

    var Ka =
    /*#__PURE__*/
    function () {
      function Ka(e) {
        _classCallCheck(this, Ka);

        if (e instanceof Ka) return e;
        "string" == typeof e ? e = [e] : Array.isArray(e) || (e = e.getAncestors({
          includeSelf: !0
        })), this._items = e.map(ac);
      }

      _createClass(Ka, [{
        key: Symbol.iterator,
        value: function value() {
          return this._items[Symbol.iterator]();
        }
      }, {
        key: "push",
        value: function push(e) {
          var t = new Ka([e]);
          return t._items = [].concat(_toConsumableArray(this._items), _toConsumableArray(t._items)), t;
        }
      }, {
        key: "getItem",
        value: function getItem(e) {
          return this._items[e];
        }
      }, {
        key: "getNames",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function getNames() {
          return _regeneratorRuntime.wrap(function getNames$(_context26) {
            while (1) {
              switch (_context26.prev = _context26.next) {
                case 0:
                  return _context26.delegateYield(this._items.map(function (e) {
                    return e.name;
                  }), "t0", 1);

                case 1:
                case "end":
                  return _context26.stop();
              }
            }
          }, getNames, this);
        })
      }, {
        key: "endsWith",
        value: function endsWith(e) {
          return Array.from(this.getNames()).join(" ").endsWith(e);
        }
      }, {
        key: "startsWith",
        value: function startsWith(e) {
          return Array.from(this.getNames()).join(" ").startsWith(e);
        }
      }, {
        key: "length",
        get: function get() {
          return this._items.length;
        }
      }, {
        key: "last",
        get: function get() {
          return this._items[this._items.length - 1];
        }
      }]);

      return Ka;
    }();

    function Qa(e, t) {
      var i = {
        name: t,
        allowIn: [],
        allowContentOf: [],
        allowWhere: [],
        allowAttributes: [],
        allowAttributesOf: [],
        allowChildren: [],
        inheritTypesFrom: []
      };
      return function (e, t) {
        var _iteratorNormalCompletion195 = true;
        var _didIteratorError195 = false;
        var _iteratorError195 = undefined;

        try {
          for (var _iterator195 = e[Symbol.iterator](), _step195; !(_iteratorNormalCompletion195 = (_step195 = _iterator195.next()).done); _iteratorNormalCompletion195 = true) {
            var _i154 = _step195.value;

            var _e143 = Object.keys(_i154).filter(function (e) {
              return e.startsWith("is");
            });

            var _iteratorNormalCompletion196 = true;
            var _didIteratorError196 = false;
            var _iteratorError196 = undefined;

            try {
              for (var _iterator196 = _e143[Symbol.iterator](), _step196; !(_iteratorNormalCompletion196 = (_step196 = _iterator196.next()).done); _iteratorNormalCompletion196 = true) {
                var _n70 = _step196.value;
                t[_n70] = _i154[_n70];
              }
            } catch (err) {
              _didIteratorError196 = true;
              _iteratorError196 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion196 && _iterator196.return != null) {
                  _iterator196.return();
                }
              } finally {
                if (_didIteratorError196) {
                  throw _iteratorError196;
                }
              }
            }
          }
        } catch (err) {
          _didIteratorError195 = true;
          _iteratorError195 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion195 && _iterator195.return != null) {
              _iterator195.return();
            }
          } finally {
            if (_didIteratorError195) {
              throw _iteratorError195;
            }
          }
        }
      }(e, i), rc(e, i, "allowIn"), rc(e, i, "allowContentOf"), rc(e, i, "allowWhere"), rc(e, i, "allowAttributes"), rc(e, i, "allowAttributesOf"), rc(e, i, "allowChildren"), rc(e, i, "inheritTypesFrom"), function (e, t) {
        var _iteratorNormalCompletion197 = true;
        var _didIteratorError197 = false;
        var _iteratorError197 = undefined;

        try {
          for (var _iterator197 = e[Symbol.iterator](), _step197; !(_iteratorNormalCompletion197 = (_step197 = _iterator197.next()).done); _iteratorNormalCompletion197 = true) {
            var _i155 = _step197.value;
            var _e144 = _i155.inheritAllFrom;
            _e144 && (t.allowContentOf.push(_e144), t.allowWhere.push(_e144), t.allowAttributesOf.push(_e144), t.inheritTypesFrom.push(_e144));
          }
        } catch (err) {
          _didIteratorError197 = true;
          _iteratorError197 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion197 && _iterator197.return != null) {
              _iterator197.return();
            }
          } finally {
            if (_didIteratorError197) {
              throw _iteratorError197;
            }
          }
        }
      }(e, i), i;
    }

    function Ja(e, t) {
      var i = e[t];
      var _iteratorNormalCompletion198 = true;
      var _didIteratorError198 = false;
      var _iteratorError198 = undefined;

      try {
        for (var _iterator198 = i.allowChildren[Symbol.iterator](), _step198; !(_iteratorNormalCompletion198 = (_step198 = _iterator198.next()).done); _iteratorNormalCompletion198 = true) {
          var _n71 = _step198.value;
          var _i156 = e[_n71];
          _i156 && _i156.allowIn.push(t);
        }
      } catch (err) {
        _didIteratorError198 = true;
        _iteratorError198 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion198 && _iterator198.return != null) {
            _iterator198.return();
          }
        } finally {
          if (_didIteratorError198) {
            throw _iteratorError198;
          }
        }
      }

      i.allowChildren.length = 0;
    }

    function Za(e, t) {
      var _iteratorNormalCompletion199 = true;
      var _didIteratorError199 = false;
      var _iteratorError199 = undefined;

      try {
        for (var _iterator199 = e[t].allowContentOf[Symbol.iterator](), _step199; !(_iteratorNormalCompletion199 = (_step199 = _iterator199.next()).done); _iteratorNormalCompletion199 = true) {
          var _i157 = _step199.value;

          if (e[_i157]) {
            sc(e, _i157).forEach(function (e) {
              e.allowIn.push(t);
            });
          }
        }
      } catch (err) {
        _didIteratorError199 = true;
        _iteratorError199 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion199 && _iterator199.return != null) {
            _iterator199.return();
          }
        } finally {
          if (_didIteratorError199) {
            throw _iteratorError199;
          }
        }
      }

      delete e[t].allowContentOf;
    }

    function Xa(e, t) {
      var _iteratorNormalCompletion200 = true;
      var _didIteratorError200 = false;
      var _iteratorError200 = undefined;

      try {
        for (var _iterator200 = e[t].allowWhere[Symbol.iterator](), _step200; !(_iteratorNormalCompletion200 = (_step200 = _iterator200.next()).done); _iteratorNormalCompletion200 = true) {
          var _i158 = _step200.value;
          var _n72 = e[_i158];

          if (_n72) {
            var _e$t$allowIn;

            var _i159 = _n72.allowIn;

            (_e$t$allowIn = e[t].allowIn).push.apply(_e$t$allowIn, _toConsumableArray(_i159));
          }
        }
      } catch (err) {
        _didIteratorError200 = true;
        _iteratorError200 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion200 && _iterator200.return != null) {
            _iterator200.return();
          }
        } finally {
          if (_didIteratorError200) {
            throw _iteratorError200;
          }
        }
      }

      delete e[t].allowWhere;
    }

    function ec(e, t) {
      var _iteratorNormalCompletion201 = true;
      var _didIteratorError201 = false;
      var _iteratorError201 = undefined;

      try {
        for (var _iterator201 = e[t].allowAttributesOf[Symbol.iterator](), _step201; !(_iteratorNormalCompletion201 = (_step201 = _iterator201.next()).done); _iteratorNormalCompletion201 = true) {
          var _i160 = _step201.value;
          var _n73 = e[_i160];

          if (_n73) {
            var _e$t$allowAttributes;

            var _i161 = _n73.allowAttributes;

            (_e$t$allowAttributes = e[t].allowAttributes).push.apply(_e$t$allowAttributes, _toConsumableArray(_i161));
          }
        }
      } catch (err) {
        _didIteratorError201 = true;
        _iteratorError201 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion201 && _iterator201.return != null) {
            _iterator201.return();
          }
        } finally {
          if (_didIteratorError201) {
            throw _iteratorError201;
          }
        }
      }

      delete e[t].allowAttributesOf;
    }

    function tc(e, t) {
      var i = e[t];
      var _iteratorNormalCompletion202 = true;
      var _didIteratorError202 = false;
      var _iteratorError202 = undefined;

      try {
        for (var _iterator202 = i.inheritTypesFrom[Symbol.iterator](), _step202; !(_iteratorNormalCompletion202 = (_step202 = _iterator202.next()).done); _iteratorNormalCompletion202 = true) {
          var _t141 = _step202.value;
          var _n74 = e[_t141];

          if (_n74) {
            var _e145 = Object.keys(_n74).filter(function (e) {
              return e.startsWith("is");
            });

            var _iteratorNormalCompletion203 = true;
            var _didIteratorError203 = false;
            var _iteratorError203 = undefined;

            try {
              for (var _iterator203 = _e145[Symbol.iterator](), _step203; !(_iteratorNormalCompletion203 = (_step203 = _iterator203.next()).done); _iteratorNormalCompletion203 = true) {
                var _t142 = _step203.value;
                _t142 in i || (i[_t142] = _n74[_t142]);
              }
            } catch (err) {
              _didIteratorError203 = true;
              _iteratorError203 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion203 && _iterator203.return != null) {
                  _iterator203.return();
                }
              } finally {
                if (_didIteratorError203) {
                  throw _iteratorError203;
                }
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError202 = true;
        _iteratorError202 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion202 && _iterator202.return != null) {
            _iterator202.return();
          }
        } finally {
          if (_didIteratorError202) {
            throw _iteratorError202;
          }
        }
      }

      delete i.inheritTypesFrom;
    }

    function ic(e, t) {
      var i = e[t],
          n = i.allowIn.filter(function (t) {
        return e[t];
      });
      i.allowIn = Array.from(new Set(n));
    }

    function nc(e, t) {
      var i = e[t];
      var _iteratorNormalCompletion204 = true;
      var _didIteratorError204 = false;
      var _iteratorError204 = undefined;

      try {
        for (var _iterator204 = i.allowIn[Symbol.iterator](), _step204; !(_iteratorNormalCompletion204 = (_step204 = _iterator204.next()).done); _iteratorNormalCompletion204 = true) {
          var _n75 = _step204.value;

          e[_n75].allowChildren.push(t);
        }
      } catch (err) {
        _didIteratorError204 = true;
        _iteratorError204 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion204 && _iterator204.return != null) {
            _iterator204.return();
          }
        } finally {
          if (_didIteratorError204) {
            throw _iteratorError204;
          }
        }
      }
    }

    function oc(e, t) {
      var i = e[t];
      i.allowAttributes = Array.from(new Set(i.allowAttributes));
    }

    function rc(e, t, i) {
      var _iteratorNormalCompletion205 = true;
      var _didIteratorError205 = false;
      var _iteratorError205 = undefined;

      try {
        for (var _iterator205 = e[Symbol.iterator](), _step205; !(_iteratorNormalCompletion205 = (_step205 = _iterator205.next()).done); _iteratorNormalCompletion205 = true) {
          var _t$i;

          var _n76 = _step205.value;
          "string" == typeof _n76[i] ? t[i].push(_n76[i]) : Array.isArray(_n76[i]) && (_t$i = t[i]).push.apply(_t$i, _toConsumableArray(_n76[i]));
        }
      } catch (err) {
        _didIteratorError205 = true;
        _iteratorError205 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion205 && _iterator205.return != null) {
            _iterator205.return();
          }
        } finally {
          if (_didIteratorError205) {
            throw _iteratorError205;
          }
        }
      }
    }

    function sc(e, t) {
      var i = e[t];
      return (n = e, Object.keys(n).map(function (e) {
        return n[e];
      })).filter(function (e) {
        return e.allowIn.includes(i.name);
      });
      var n;
    }

    function ac(e) {
      return "string" == typeof e || e.is("documentFragment") ? {
        name: "string" == typeof e ? e : "$documentFragment",
        getAttributeKeys:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function getAttributeKeys() {
          return _regeneratorRuntime.wrap(function getAttributeKeys$(_context27) {
            while (1) {
              switch (_context27.prev = _context27.next) {
                case 0:
                case "end":
                  return _context27.stop();
              }
            }
          }, getAttributeKeys);
        }),
        getAttribute: function getAttribute() {}
      } : {
        name: e.is("element") ? e.name : "$text",
        getAttributeKeys:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function getAttributeKeys() {
          return _regeneratorRuntime.wrap(function getAttributeKeys$(_context28) {
            while (1) {
              switch (_context28.prev = _context28.next) {
                case 0:
                  return _context28.delegateYield(e.getAttributeKeys(), "t0", 1);

                case 1:
                case "end":
                  return _context28.stop();
              }
            }
          }, getAttributeKeys);
        }),
        getAttribute: function getAttribute(t) {
          return e.getAttribute(t);
        }
      };
    }

    function cc(e, t, i) {
      var _iteratorNormalCompletion206 = true;
      var _didIteratorError206 = false;
      var _iteratorError206 = undefined;

      try {
        for (var _iterator206 = t.getAttributeKeys()[Symbol.iterator](), _step206; !(_iteratorNormalCompletion206 = (_step206 = _iterator206.next()).done); _iteratorNormalCompletion206 = true) {
          var _n77 = _step206.value;
          e.checkAttribute(t, _n77) || i.removeAttribute(_n77, t);
        }
      } catch (err) {
        _didIteratorError206 = true;
        _iteratorError206 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion206 && _iterator206.return != null) {
            _iterator206.return();
          }
        } finally {
          if (_didIteratorError206) {
            throw _iteratorError206;
          }
        }
      }
    }

    var lc =
    /*#__PURE__*/
    function () {
      function lc() {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, lc);

        this._splitParts = new Map(), this._cursorParents = new Map(), this._modelCursor = null, this.conversionApi = Object.assign({}, e), this.conversionApi.convertItem = this._convertItem.bind(this), this.conversionApi.convertChildren = this._convertChildren.bind(this), this.conversionApi.safeInsert = this._safeInsert.bind(this), this.conversionApi.updateConversionResult = this._updateConversionResult.bind(this), this.conversionApi.splitToAllowedParent = this._splitToAllowedParent.bind(this), this.conversionApi.getSplitParts = this._getSplitParts.bind(this);
      }

      _createClass(lc, [{
        key: "convert",
        value: function convert(e, t) {
          var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ["$root"];
          this.fire("viewCleanup", e), this._modelCursor = function (e, t) {
            var i;
            var _iteratorNormalCompletion207 = true;
            var _didIteratorError207 = false;
            var _iteratorError207 = undefined;

            try {
              for (var _iterator207 = new Ka(e)[Symbol.iterator](), _step207; !(_iteratorNormalCompletion207 = (_step207 = _iterator207.next()).done); _iteratorNormalCompletion207 = true) {
                var _n78 = _step207.value;
                var _e146 = {};
                var _iteratorNormalCompletion208 = true;
                var _didIteratorError208 = false;
                var _iteratorError208 = undefined;

                try {
                  for (var _iterator208 = _n78.getAttributeKeys()[Symbol.iterator](), _step208; !(_iteratorNormalCompletion208 = (_step208 = _iterator208.next()).done); _iteratorNormalCompletion208 = true) {
                    var _t143 = _step208.value;
                    _e146[_t143] = _n78.getAttribute(_t143);
                  }
                } catch (err) {
                  _didIteratorError208 = true;
                  _iteratorError208 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion208 && _iterator208.return != null) {
                      _iterator208.return();
                    }
                  } finally {
                    if (_didIteratorError208) {
                      throw _iteratorError208;
                    }
                  }
                }

                var _o43 = t.createElement(_n78.name, _e146);

                i && t.append(_o43, i), i = ia._createAt(_o43, 0);
              }
            } catch (err) {
              _didIteratorError207 = true;
              _iteratorError207 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion207 && _iterator207.return != null) {
                  _iterator207.return();
                }
              } finally {
                if (_didIteratorError207) {
                  throw _iteratorError207;
                }
              }
            }

            return i;
          }(i, t), this.conversionApi.writer = t, this.conversionApi.consumable = $a.createFrom(e), this.conversionApi.store = {};

          var _this$_convertItem = this._convertItem(e, this._modelCursor),
              n = _this$_convertItem.modelRange,
              o = t.createDocumentFragment();

          if (n) {
            this._removeEmptyElements();

            for (var _i162 = 0, _Array$from4 = Array.from(this._modelCursor.parent.getChildren()); _i162 < _Array$from4.length; _i162++) {
              var _e149 = _Array$from4[_i162];
              t.append(_e149, o);
            }

            o.markers = function (e, t) {
              var i = new Set(),
                  n = new Map(),
                  o = sa._createIn(e).getItems();

              var _iteratorNormalCompletion209 = true;
              var _didIteratorError209 = false;
              var _iteratorError209 = undefined;

              try {
                for (var _iterator209 = o[Symbol.iterator](), _step209; !(_iteratorNormalCompletion209 = (_step209 = _iterator209.next()).done); _iteratorNormalCompletion209 = true) {
                  var _e147 = _step209.value;
                  "$marker" == _e147.name && i.add(_e147);
                }
              } catch (err) {
                _didIteratorError209 = true;
                _iteratorError209 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion209 && _iterator209.return != null) {
                    _iterator209.return();
                  }
                } finally {
                  if (_didIteratorError209) {
                    throw _iteratorError209;
                  }
                }
              }

              var _iteratorNormalCompletion210 = true;
              var _didIteratorError210 = false;
              var _iteratorError210 = undefined;

              try {
                for (var _iterator210 = i[Symbol.iterator](), _step210; !(_iteratorNormalCompletion210 = (_step210 = _iterator210.next()).done); _iteratorNormalCompletion210 = true) {
                  var _e148 = _step210.value;

                  var _i163 = _e148.getAttribute("data-name"),
                      _o44 = t.createPositionBefore(_e148);

                  n.has(_i163) ? n.get(_i163).end = _o44.clone() : n.set(_i163, new sa(_o44.clone())), t.remove(_e148);
                }
              } catch (err) {
                _didIteratorError210 = true;
                _iteratorError210 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion210 && _iterator210.return != null) {
                    _iterator210.return();
                  }
                } finally {
                  if (_didIteratorError210) {
                    throw _iteratorError210;
                  }
                }
              }

              return n;
            }(o, t);
          }

          return this._modelCursor = null, this._splitParts.clear(), this._cursorParents.clear(), this.conversionApi.writer = null, this.conversionApi.store = null, o;
        }
      }, {
        key: "_convertItem",
        value: function _convertItem(e, t) {
          var i = Object.assign({
            viewItem: e,
            modelCursor: t,
            modelRange: null
          });
          if (e.is("element") ? this.fire("element:" + e.name, i, this.conversionApi) : e.is("$text") ? this.fire("text", i, this.conversionApi) : this.fire("documentFragment", i, this.conversionApi), i.modelRange && !(i.modelRange instanceof sa)) throw new c.a("view-conversion-dispatcher-incorrect-result", this);
          return {
            modelRange: i.modelRange,
            modelCursor: i.modelCursor
          };
        }
      }, {
        key: "_convertChildren",
        value: function _convertChildren(e, t) {
          var i = t.is("position") ? t : ia._createAt(t, 0);
          var n = new sa(i);

          for (var _i164 = 0, _Array$from5 = Array.from(e.getChildren()); _i164 < _Array$from5.length; _i164++) {
            var _t144 = _Array$from5[_i164];

            var _e150 = this._convertItem(_t144, i);

            _e150.modelRange instanceof sa && (n.end = _e150.modelRange.end, i = _e150.modelCursor);
          }

          return {
            modelRange: n,
            modelCursor: i
          };
        }
      }, {
        key: "_safeInsert",
        value: function _safeInsert(e, t) {
          var i = this._splitToAllowedParent(e, t);

          return !!i && (this.conversionApi.writer.insert(e, i.position), !0);
        }
      }, {
        key: "_updateConversionResult",
        value: function _updateConversionResult(e, t) {
          var i = this._getSplitParts(e),
              n = this.conversionApi.writer;

          t.modelRange || (t.modelRange = n.createRange(n.createPositionBefore(e), n.createPositionAfter(i[i.length - 1])));

          var o = this._cursorParents.get(e);

          t.modelCursor = o ? n.createPositionAt(o, 0) : t.modelRange.end;
        }
      }, {
        key: "_splitToAllowedParent",
        value: function _splitToAllowedParent(e, t) {
          var _this$conversionApi = this.conversionApi,
              i = _this$conversionApi.schema,
              n = _this$conversionApi.writer;
          var o = i.findAllowedParent(t, e);

          if (o) {
            if (o === t.parent) return {
              position: t
            };
            this._modelCursor.parent.getAncestors().includes(o) && (o = null);
          }

          if (!o) return za(t, e, i) ? {
            position: Da(t, n)
          } : null;
          var r = this.conversionApi.writer.split(t, o),
              s = [];
          var _iteratorNormalCompletion211 = true;
          var _didIteratorError211 = false;
          var _iteratorError211 = undefined;

          try {
            for (var _iterator211 = r.range.getWalker()[Symbol.iterator](), _step211; !(_iteratorNormalCompletion211 = (_step211 = _iterator211.next()).done); _iteratorNormalCompletion211 = true) {
              var _e151 = _step211.value;
              if ("elementEnd" == _e151.type) s.push(_e151.item);else {
                var _t145 = s.pop(),
                    _i165 = _e151.item;

                this._registerSplitPair(_t145, _i165);
              }
            }
          } catch (err) {
            _didIteratorError211 = true;
            _iteratorError211 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion211 && _iterator211.return != null) {
                _iterator211.return();
              }
            } finally {
              if (_didIteratorError211) {
                throw _iteratorError211;
              }
            }
          }

          var a = r.range.end.parent;
          return this._cursorParents.set(e, a), {
            position: r.position,
            cursorParent: a
          };
        }
      }, {
        key: "_registerSplitPair",
        value: function _registerSplitPair(e, t) {
          this._splitParts.has(e) || this._splitParts.set(e, [e]);

          var i = this._splitParts.get(e);

          this._splitParts.set(t, i), i.push(t);
        }
      }, {
        key: "_getSplitParts",
        value: function _getSplitParts(e) {
          var t;
          return t = this._splitParts.has(e) ? this._splitParts.get(e) : [e], t;
        }
      }, {
        key: "_removeEmptyElements",
        value: function _removeEmptyElements() {
          var e = !1;
          var _iteratorNormalCompletion212 = true;
          var _didIteratorError212 = false;
          var _iteratorError212 = undefined;

          try {
            for (var _iterator212 = this._splitParts.keys()[Symbol.iterator](), _step212; !(_iteratorNormalCompletion212 = (_step212 = _iterator212.next()).done); _iteratorNormalCompletion212 = true) {
              var _t146 = _step212.value;
              _t146.isEmpty && (this.conversionApi.writer.remove(_t146), this._splitParts.delete(_t146), e = !0);
            }
          } catch (err) {
            _didIteratorError212 = true;
            _iteratorError212 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion212 && _iterator212.return != null) {
                _iterator212.return();
              }
            } finally {
              if (_didIteratorError212) {
                throw _iteratorError212;
              }
            }
          }

          e && this._removeEmptyElements();
        }
      }]);

      return lc;
    }();

    Ke(lc, h);

    var dc =
    /*#__PURE__*/
    function () {
      function dc() {
        _classCallCheck(this, dc);
      }

      _createClass(dc, [{
        key: "getHtml",
        value: function getHtml(e) {
          var t = document.implementation.createHTMLDocument("").createElement("div");
          return t.appendChild(e), t.innerHTML;
        }
      }]);

      return dc;
    }();

    var hc =
    /*#__PURE__*/
    function () {
      function hc(e) {
        _classCallCheck(this, hc);

        this._domParser = new DOMParser(), this._domConverter = new Er(e, {
          blockFillerMode: "nbsp"
        }), this._htmlWriter = new dc();
      }

      _createClass(hc, [{
        key: "toData",
        value: function toData(e) {
          var t = this._domConverter.viewToDom(e, document);

          return this._htmlWriter.getHtml(t);
        }
      }, {
        key: "toView",
        value: function toView(e) {
          var t = this._toDom(e);

          return this._domConverter.domToView(t);
        }
      }, {
        key: "registerRawContentMatcher",
        value: function registerRawContentMatcher(e) {
          this._domConverter.registerRawContentMatcher(e);
        }
      }, {
        key: "useFillerType",
        value: function useFillerType(e) {
          this._domConverter.blockFillerMode = "marked" == e ? "markedNbsp" : "nbsp";
        }
      }, {
        key: "_toDom",
        value: function _toDom(e) {
          var t = this._domParser.parseFromString(e, "text/html"),
              i = t.createDocumentFragment();

          var n = t.firstChild;

          for (; !n.isSameNode(t.documentElement);) {
            var _e152 = n;
            n = n.nextSibling, _e152.nodeType == Node.COMMENT_NODE && i.appendChild(_e152);
          }

          var o = t.body.childNodes;

          for (; o.length > 0;) {
            i.appendChild(o[0]);
          }

          return i;
        }
      }]);

      return hc;
    }();

    var uc =
    /*#__PURE__*/
    function () {
      function uc(e, t) {
        var _this60 = this;

        _classCallCheck(this, uc);

        this.model = e, this.mapper = new aa(), this.downcastDispatcher = new da({
          mapper: this.mapper,
          schema: e.schema
        }), this.downcastDispatcher.on("insert:$text", function (e, t, i) {
          if (!i.consumable.consume(t.item, "insert")) return;
          var n = i.writer,
              o = i.mapper.toViewPosition(t.range.start),
              r = n.createText(t.item.data);
          n.insert(o, r);
        }, {
          priority: "lowest"
        }), this.upcastDispatcher = new lc({
          schema: e.schema
        }), this.viewDocument = new yo(t), this.stylesProcessor = t, this.htmlProcessor = new hc(this.viewDocument), this.processor = this.htmlProcessor, this._viewWriter = new qo(this.viewDocument), this.upcastDispatcher.on("text", function (e, t, _ref66) {
          var i = _ref66.schema,
              n = _ref66.consumable,
              o = _ref66.writer;
          var r = t.modelCursor;
          if (!n.test(t.viewItem)) return;

          if (!i.checkChild(r, "$text")) {
            if (!za(r, "$text", i)) return;
            r = Da(r, o);
          }

          n.consume(t.viewItem);
          var s = o.createText(t.viewItem.data);
          o.insert(s, r), t.modelRange = o.createRange(r, r.getShiftedBy(s.offsetSize)), t.modelCursor = t.modelRange.end;
        }, {
          priority: "lowest"
        }), this.upcastDispatcher.on("element", function (e, t, i) {
          if (!t.modelRange && i.consumable.consume(t.viewItem, {
            name: !0
          })) {
            var _i$convertChildren = i.convertChildren(t.viewItem, t.modelCursor),
                _e153 = _i$convertChildren.modelRange,
                _n79 = _i$convertChildren.modelCursor;

            t.modelRange = _e153, t.modelCursor = _n79;
          }
        }, {
          priority: "lowest"
        }), this.upcastDispatcher.on("documentFragment", function (e, t, i) {
          if (!t.modelRange && i.consumable.consume(t.viewItem, {
            name: !0
          })) {
            var _i$convertChildren2 = i.convertChildren(t.viewItem, t.modelCursor),
                _e154 = _i$convertChildren2.modelRange,
                _n80 = _i$convertChildren2.modelCursor;

            t.modelRange = _e154, t.modelCursor = _n80;
          }
        }, {
          priority: "lowest"
        }), this.decorate("init"), this.decorate("set"), this.on("init", function () {
          _this60.fire("ready");
        }, {
          priority: "lowest"
        }), this.on("ready", function () {
          _this60.model.enqueueChange("transparent", Oa);
        }, {
          priority: "lowest"
        });
      }

      _createClass(uc, [{
        key: "get",
        value: function get() {
          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var _e$rootName = e.rootName,
              t = _e$rootName === void 0 ? "main" : _e$rootName,
              _e$trim = e.trim,
              i = _e$trim === void 0 ? "empty" : _e$trim;
          if (!this._checkIfRootsExists([t])) throw new c.a("datacontroller-get-non-existent-root", this);
          var n = this.model.document.getRoot(t);
          return "empty" !== i || this.model.hasContent(n, {
            ignoreWhitespaces: !0
          }) ? this.stringify(n, e) : "";
        }
      }, {
        key: "stringify",
        value: function stringify(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var i = this.toView(e, t);
          return this.processor.toData(i);
        }
      }, {
        key: "toView",
        value: function toView(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var i = this.viewDocument,
              n = this._viewWriter;
          this.mapper.clearBindings();

          var o = sa._createIn(e),
              r = new Wo(i);

          this.mapper.bindElements(e, r), this.downcastDispatcher.conversionApi.options = t, this.downcastDispatcher.convertInsert(o, n);
          var s = e.is("documentFragment") ? Array.from(e.markers) : function (e) {
            var t = [],
                i = e.root.document;
            if (!i) return [];

            var n = sa._createIn(e);

            var _iteratorNormalCompletion213 = true;
            var _didIteratorError213 = false;
            var _iteratorError213 = undefined;

            try {
              for (var _iterator213 = i.model.markers[Symbol.iterator](), _step213; !(_iteratorNormalCompletion213 = (_step213 = _iterator213.next()).done); _iteratorNormalCompletion213 = true) {
                var _e155 = _step213.value;

                var _i166 = _e155.getRange(),
                    _o45 = _i166.isCollapsed,
                    _r22 = _i166.start.isEqual(n.start) || _i166.end.isEqual(n.end);

                if (_o45 && _r22) t.push([_e155.name, _i166]);else {
                  var _o46 = n.getIntersection(_i166);

                  _o46 && t.push([_e155.name, _o46]);
                }
              }
            } catch (err) {
              _didIteratorError213 = true;
              _iteratorError213 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion213 && _iterator213.return != null) {
                  _iterator213.return();
                }
              } finally {
                if (_didIteratorError213) {
                  throw _iteratorError213;
                }
              }
            }

            return t;
          }(e);
          var _iteratorNormalCompletion214 = true;
          var _didIteratorError214 = false;
          var _iteratorError214 = undefined;

          try {
            for (var _iterator214 = s[Symbol.iterator](), _step214; !(_iteratorNormalCompletion214 = (_step214 = _iterator214.next()).done); _iteratorNormalCompletion214 = true) {
              var _ref69 = _step214.value;

              var _ref68 = _slicedToArray(_ref69, 2);

              var _e156 = _ref68[0];
              var _t147 = _ref68[1];
              this.downcastDispatcher.convertMarkerAdd(_e156, _t147, n);
            }
          } catch (err) {
            _didIteratorError214 = true;
            _iteratorError214 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion214 && _iterator214.return != null) {
                _iterator214.return();
              }
            } finally {
              if (_didIteratorError214) {
                throw _iteratorError214;
              }
            }
          }

          return delete this.downcastDispatcher.conversionApi.options, r;
        }
      }, {
        key: "init",
        value: function init(e) {
          var _this61 = this;

          if (this.model.document.version) throw new c.a("datacontroller-init-document-not-empty", this);
          var t = {};
          if ("string" == typeof e ? t.main = e : t = e, !this._checkIfRootsExists(Object.keys(t))) throw new c.a("datacontroller-init-non-existent-root", this);
          return this.model.enqueueChange("transparent", function (e) {
            for (var _i167 = 0, _Object$keys2 = Object.keys(t); _i167 < _Object$keys2.length; _i167++) {
              var _i168 = _Object$keys2[_i167];

              var _n81 = _this61.model.document.getRoot(_i168);

              e.insert(_this61.parse(t[_i168], _n81), _n81, 0);
            }
          }), Promise.resolve();
        }
      }, {
        key: "set",
        value: function set(e) {
          var _this62 = this;

          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var i = {};
          if ("string" == typeof e ? i.main = e : i = e, !this._checkIfRootsExists(Object.keys(i))) throw new c.a("datacontroller-set-non-existent-root", this);
          var n = t.batchType || "default";
          this.model.enqueueChange(n, function (e) {
            e.setSelection(null), e.removeSelectionAttribute(_this62.model.document.selection.getAttributeKeys());

            for (var _i169 = 0, _Object$keys3 = Object.keys(i); _i169 < _Object$keys3.length; _i169++) {
              var _t148 = _Object$keys3[_i169];

              var _n82 = _this62.model.document.getRoot(_t148);

              e.remove(e.createRangeIn(_n82)), e.insert(_this62.parse(i[_t148], _n82), _n82, 0);
            }
          });
        }
      }, {
        key: "parse",
        value: function parse(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "$root";
          var i = this.processor.toView(e);
          return this.toModel(i, t);
        }
      }, {
        key: "toModel",
        value: function toModel(e) {
          var _this63 = this;

          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "$root";
          return this.model.change(function (i) {
            return _this63.upcastDispatcher.convert(e, i, t);
          });
        }
      }, {
        key: "addStyleProcessorRules",
        value: function addStyleProcessorRules(e) {
          e(this.stylesProcessor);
        }
      }, {
        key: "registerRawContentMatcher",
        value: function registerRawContentMatcher(e) {
          this.processor && this.processor !== this.htmlProcessor && this.processor.registerRawContentMatcher(e), this.htmlProcessor.registerRawContentMatcher(e);
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.stopListening();
        }
      }, {
        key: "_checkIfRootsExists",
        value: function _checkIfRootsExists(e) {
          var _iteratorNormalCompletion215 = true;
          var _didIteratorError215 = false;
          var _iteratorError215 = undefined;

          try {
            for (var _iterator215 = e[Symbol.iterator](), _step215; !(_iteratorNormalCompletion215 = (_step215 = _iterator215.next()).done); _iteratorNormalCompletion215 = true) {
              var _t149 = _step215.value;
              if (!this.model.document.getRootNames().includes(_t149)) return !1;
            }
          } catch (err) {
            _didIteratorError215 = true;
            _iteratorError215 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion215 && _iterator215.return != null) {
                _iterator215.return();
              }
            } finally {
              if (_didIteratorError215) {
                throw _iteratorError215;
              }
            }
          }

          return !0;
        }
      }]);

      return uc;
    }();

    Ke(uc, Ue);

    var gc =
    /*#__PURE__*/
    function () {
      function gc(e, t) {
        _classCallCheck(this, gc);

        this._helpers = new Map(), this._downcast = en(e), this._createConversionHelpers({
          name: "downcast",
          dispatchers: this._downcast,
          isDowncast: !0
        }), this._upcast = en(t), this._createConversionHelpers({
          name: "upcast",
          dispatchers: this._upcast,
          isDowncast: !1
        });
      }

      _createClass(gc, [{
        key: "addAlias",
        value: function addAlias(e, t) {
          var i = this._downcast.includes(t);

          if (!this._upcast.includes(t) && !i) throw new c.a("conversion-add-alias-dispatcher-not-registered", this);

          this._createConversionHelpers({
            name: e,
            dispatchers: [t],
            isDowncast: i
          });
        }
      }, {
        key: "for",
        value: function _for(e) {
          if (!this._helpers.has(e)) throw new c.a("conversion-for-unknown-group", this);
          return this._helpers.get(e);
        }
      }, {
        key: "elementToElement",
        value: function elementToElement(e) {
          this.for("downcast").elementToElement(e);
          var _iteratorNormalCompletion216 = true;
          var _didIteratorError216 = false;
          var _iteratorError216 = undefined;

          try {
            for (var _iterator216 = mc(e)[Symbol.iterator](), _step216; !(_iteratorNormalCompletion216 = (_step216 = _iterator216.next()).done); _iteratorNormalCompletion216 = true) {
              var _ref71 = _step216.value;
              var _t150 = _ref71.model;
              var _i170 = _ref71.view;
              this.for("upcast").elementToElement({
                model: _t150,
                view: _i170,
                converterPriority: e.converterPriority
              });
            }
          } catch (err) {
            _didIteratorError216 = true;
            _iteratorError216 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion216 && _iterator216.return != null) {
                _iterator216.return();
              }
            } finally {
              if (_didIteratorError216) {
                throw _iteratorError216;
              }
            }
          }
        }
      }, {
        key: "attributeToElement",
        value: function attributeToElement(e) {
          this.for("downcast").attributeToElement(e);
          var _iteratorNormalCompletion217 = true;
          var _didIteratorError217 = false;
          var _iteratorError217 = undefined;

          try {
            for (var _iterator217 = mc(e)[Symbol.iterator](), _step217; !(_iteratorNormalCompletion217 = (_step217 = _iterator217.next()).done); _iteratorNormalCompletion217 = true) {
              var _ref73 = _step217.value;
              var _t151 = _ref73.model;
              var _i171 = _ref73.view;
              this.for("upcast").elementToAttribute({
                view: _i171,
                model: _t151,
                converterPriority: e.converterPriority
              });
            }
          } catch (err) {
            _didIteratorError217 = true;
            _iteratorError217 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion217 && _iterator217.return != null) {
                _iterator217.return();
              }
            } finally {
              if (_didIteratorError217) {
                throw _iteratorError217;
              }
            }
          }
        }
      }, {
        key: "attributeToAttribute",
        value: function attributeToAttribute(e) {
          this.for("downcast").attributeToAttribute(e);
          var _iteratorNormalCompletion218 = true;
          var _didIteratorError218 = false;
          var _iteratorError218 = undefined;

          try {
            for (var _iterator218 = mc(e)[Symbol.iterator](), _step218; !(_iteratorNormalCompletion218 = (_step218 = _iterator218.next()).done); _iteratorNormalCompletion218 = true) {
              var _ref75 = _step218.value;
              var _t152 = _ref75.model;
              var _i172 = _ref75.view;
              this.for("upcast").attributeToAttribute({
                view: _i172,
                model: _t152
              });
            }
          } catch (err) {
            _didIteratorError218 = true;
            _iteratorError218 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion218 && _iterator218.return != null) {
                _iterator218.return();
              }
            } finally {
              if (_didIteratorError218) {
                throw _iteratorError218;
              }
            }
          }
        }
      }, {
        key: "_createConversionHelpers",
        value: function _createConversionHelpers(_ref76) {
          var e = _ref76.name,
              t = _ref76.dispatchers,
              i = _ref76.isDowncast;
          if (this._helpers.has(e)) throw new c.a("conversion-group-exists", this);
          var n = i ? new Ea(t) : new La(t);

          this._helpers.set(e, n);
        }
      }]);

      return gc;
    }();

    function mc(e) {
      var _iteratorNormalCompletion219, _didIteratorError219, _iteratorError219, _iterator219, _step219, _t153, _i173, _n83, _o47;

      return _regeneratorRuntime.wrap(function mc$(_context29) {
        while (1) {
          switch (_context29.prev = _context29.next) {
            case 0:
              if (!e.model.values) {
                _context29.next = 29;
                break;
              }

              _iteratorNormalCompletion219 = true;
              _didIteratorError219 = false;
              _iteratorError219 = undefined;
              _context29.prev = 4;
              _iterator219 = e.model.values[Symbol.iterator]();

            case 6:
              if (_iteratorNormalCompletion219 = (_step219 = _iterator219.next()).done) {
                _context29.next = 13;
                break;
              }

              _t153 = _step219.value;
              _i173 = {
                key: e.model.key,
                value: _t153
              }, _n83 = e.view[_t153], _o47 = e.upcastAlso ? e.upcastAlso[_t153] : void 0;
              return _context29.delegateYield(fc(_i173, _n83, _o47), "t0", 10);

            case 10:
              _iteratorNormalCompletion219 = true;
              _context29.next = 6;
              break;

            case 13:
              _context29.next = 19;
              break;

            case 15:
              _context29.prev = 15;
              _context29.t1 = _context29["catch"](4);
              _didIteratorError219 = true;
              _iteratorError219 = _context29.t1;

            case 19:
              _context29.prev = 19;
              _context29.prev = 20;

              if (!_iteratorNormalCompletion219 && _iterator219.return != null) {
                _iterator219.return();
              }

            case 22:
              _context29.prev = 22;

              if (!_didIteratorError219) {
                _context29.next = 25;
                break;
              }

              throw _iteratorError219;

            case 25:
              return _context29.finish(22);

            case 26:
              return _context29.finish(19);

            case 27:
              _context29.next = 30;
              break;

            case 29:
              return _context29.delegateYield(fc(e.model, e.view, e.upcastAlso), "t2", 30);

            case 30:
            case "end":
              return _context29.stop();
          }
        }
      }, _marked, null, [[4, 15, 19, 27], [20,, 22, 26]]);
    }

    function fc(e, t, i) {
      var _iteratorNormalCompletion220, _didIteratorError220, _iteratorError220, _iterator220, _step220, _t154;

      return _regeneratorRuntime.wrap(function fc$(_context30) {
        while (1) {
          switch (_context30.prev = _context30.next) {
            case 0:
              _context30.next = 2;
              return {
                model: e,
                view: t
              };

            case 2:
              if (!i) {
                _context30.next = 29;
                break;
              }

              _iteratorNormalCompletion220 = true;
              _didIteratorError220 = false;
              _iteratorError220 = undefined;
              _context30.prev = 6;
              _iterator220 = en(i)[Symbol.iterator]();

            case 8:
              if (_iteratorNormalCompletion220 = (_step220 = _iterator220.next()).done) {
                _context30.next = 15;
                break;
              }

              _t154 = _step220.value;
              _context30.next = 12;
              return {
                model: e,
                view: _t154
              };

            case 12:
              _iteratorNormalCompletion220 = true;
              _context30.next = 8;
              break;

            case 15:
              _context30.next = 21;
              break;

            case 17:
              _context30.prev = 17;
              _context30.t0 = _context30["catch"](6);
              _didIteratorError220 = true;
              _iteratorError220 = _context30.t0;

            case 21:
              _context30.prev = 21;
              _context30.prev = 22;

              if (!_iteratorNormalCompletion220 && _iterator220.return != null) {
                _iterator220.return();
              }

            case 24:
              _context30.prev = 24;

              if (!_didIteratorError220) {
                _context30.next = 27;
                break;
              }

              throw _iteratorError220;

            case 27:
              return _context30.finish(24);

            case 28:
              return _context30.finish(21);

            case 29:
            case "end":
              return _context30.stop();
          }
        }
      }, _marked2, null, [[6, 17, 21, 29], [22,, 24, 28]]);
    }

    var pc =
    /*#__PURE__*/
    function () {
      function pc() {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "default";

        _classCallCheck(this, pc);

        this.operations = [], this.type = e;
      }

      _createClass(pc, [{
        key: "addOperation",
        value: function addOperation(e) {
          return e.batch = this, this.operations.push(e), e;
        }
      }, {
        key: "baseVersion",
        get: function get() {
          var _iteratorNormalCompletion221 = true;
          var _didIteratorError221 = false;
          var _iteratorError221 = undefined;

          try {
            for (var _iterator221 = this.operations[Symbol.iterator](), _step221; !(_iteratorNormalCompletion221 = (_step221 = _iterator221.next()).done); _iteratorNormalCompletion221 = true) {
              var _e157 = _step221.value;
              if (null !== _e157.baseVersion) return _e157.baseVersion;
            }
          } catch (err) {
            _didIteratorError221 = true;
            _iteratorError221 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion221 && _iterator221.return != null) {
                _iterator221.return();
              }
            } finally {
              if (_didIteratorError221) {
                throw _iteratorError221;
              }
            }
          }

          return null;
        }
      }]);

      return pc;
    }();

    var bc =
    /*#__PURE__*/
    function () {
      function bc(e) {
        _classCallCheck(this, bc);

        this.baseVersion = e, this.isDocumentOperation = null !== this.baseVersion, this.batch = null;
      }

      _createClass(bc, [{
        key: "_validate",
        value: function _validate() {}
      }, {
        key: "toJSON",
        value: function toJSON() {
          var e = Object.assign({}, this);
          return e.__className = this.constructor.className, delete e.batch, delete e.isDocumentOperation, e;
        }
      }], [{
        key: "fromJSON",
        value: function fromJSON(e) {
          return new this(e.baseVersion);
        }
      }, {
        key: "className",
        get: function get() {
          return "Operation";
        }
      }]);

      return bc;
    }();

    var wc =
    /*#__PURE__*/
    function () {
      function wc(e) {
        _classCallCheck(this, wc);

        this.markers = new Map(), this._children = new Zs(), e && this._insertChild(0, e);
      }

      _createClass(wc, [{
        key: Symbol.iterator,
        value: function value() {
          return this.getChildren();
        }
      }, {
        key: "is",
        value: function is(e) {
          return "documentFragment" === e || "model:documentFragment" === e;
        }
      }, {
        key: "getChild",
        value: function getChild(e) {
          return this._children.getNode(e);
        }
      }, {
        key: "getChildren",
        value: function getChildren() {
          return this._children[Symbol.iterator]();
        }
      }, {
        key: "getChildIndex",
        value: function getChildIndex(e) {
          return this._children.getNodeIndex(e);
        }
      }, {
        key: "getChildStartOffset",
        value: function getChildStartOffset(e) {
          return this._children.getNodeStartOffset(e);
        }
      }, {
        key: "getPath",
        value: function getPath() {
          return [];
        }
      }, {
        key: "getNodeByPath",
        value: function getNodeByPath(e) {
          var t = this;
          var _iteratorNormalCompletion222 = true;
          var _didIteratorError222 = false;
          var _iteratorError222 = undefined;

          try {
            for (var _iterator222 = e[Symbol.iterator](), _step222; !(_iteratorNormalCompletion222 = (_step222 = _iterator222.next()).done); _iteratorNormalCompletion222 = true) {
              var _i174 = _step222.value;
              t = t.getChild(t.offsetToIndex(_i174));
            }
          } catch (err) {
            _didIteratorError222 = true;
            _iteratorError222 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion222 && _iterator222.return != null) {
                _iterator222.return();
              }
            } finally {
              if (_didIteratorError222) {
                throw _iteratorError222;
              }
            }
          }

          return t;
        }
      }, {
        key: "offsetToIndex",
        value: function offsetToIndex(e) {
          return this._children.offsetToIndex(e);
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var e = [];
          var _iteratorNormalCompletion223 = true;
          var _didIteratorError223 = false;
          var _iteratorError223 = undefined;

          try {
            for (var _iterator223 = this._children[Symbol.iterator](), _step223; !(_iteratorNormalCompletion223 = (_step223 = _iterator223.next()).done); _iteratorNormalCompletion223 = true) {
              var _t155 = _step223.value;
              e.push(_t155.toJSON());
            }
          } catch (err) {
            _didIteratorError223 = true;
            _iteratorError223 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion223 && _iterator223.return != null) {
                _iterator223.return();
              }
            } finally {
              if (_didIteratorError223) {
                throw _iteratorError223;
              }
            }
          }

          return e;
        }
      }, {
        key: "_appendChild",
        value: function _appendChild(e) {
          this._insertChild(this.childCount, e);
        }
      }, {
        key: "_insertChild",
        value: function _insertChild(e, t) {
          var i = function (e) {
            if ("string" == typeof e) return [new Qs(e)];
            Ji(e) || (e = [e]);
            return Array.from(e).map(function (e) {
              return "string" == typeof e ? new Qs(e) : e instanceof Js ? new Qs(e.data, e.getAttributes()) : e;
            });
          }(t);

          var _iteratorNormalCompletion224 = true;
          var _didIteratorError224 = false;
          var _iteratorError224 = undefined;

          try {
            for (var _iterator224 = i[Symbol.iterator](), _step224; !(_iteratorNormalCompletion224 = (_step224 = _iterator224.next()).done); _iteratorNormalCompletion224 = true) {
              var _e158 = _step224.value;
              null !== _e158.parent && _e158._remove(), _e158.parent = this;
            }
          } catch (err) {
            _didIteratorError224 = true;
            _iteratorError224 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion224 && _iterator224.return != null) {
                _iterator224.return();
              }
            } finally {
              if (_didIteratorError224) {
                throw _iteratorError224;
              }
            }
          }

          this._children._insertNodes(e, i);
        }
      }, {
        key: "_removeChildren",
        value: function _removeChildren(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

          var i = this._children._removeNodes(e, t);

          var _iteratorNormalCompletion225 = true;
          var _didIteratorError225 = false;
          var _iteratorError225 = undefined;

          try {
            for (var _iterator225 = i[Symbol.iterator](), _step225; !(_iteratorNormalCompletion225 = (_step225 = _iterator225.next()).done); _iteratorNormalCompletion225 = true) {
              var _e159 = _step225.value;
              _e159.parent = null;
            }
          } catch (err) {
            _didIteratorError225 = true;
            _iteratorError225 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion225 && _iterator225.return != null) {
                _iterator225.return();
              }
            } finally {
              if (_didIteratorError225) {
                throw _iteratorError225;
              }
            }
          }

          return i;
        }
      }, {
        key: "childCount",
        get: function get() {
          return this._children.length;
        }
      }, {
        key: "maxOffset",
        get: function get() {
          return this._children.maxOffset;
        }
      }, {
        key: "isEmpty",
        get: function get() {
          return 0 === this.childCount;
        }
      }, {
        key: "root",
        get: function get() {
          return this;
        }
      }, {
        key: "parent",
        get: function get() {
          return null;
        }
      }], [{
        key: "fromJSON",
        value: function fromJSON(e) {
          var t = [];
          var _iteratorNormalCompletion226 = true;
          var _didIteratorError226 = false;
          var _iteratorError226 = undefined;

          try {
            for (var _iterator226 = e[Symbol.iterator](), _step226; !(_iteratorNormalCompletion226 = (_step226 = _iterator226.next()).done); _iteratorNormalCompletion226 = true) {
              var _i175 = _step226.value;
              _i175.name ? t.push(Xs.fromJSON(_i175)) : t.push(Qs.fromJSON(_i175));
            }
          } catch (err) {
            _didIteratorError226 = true;
            _iteratorError226 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion226 && _iterator226.return != null) {
                _iterator226.return();
              }
            } finally {
              if (_didIteratorError226) {
                throw _iteratorError226;
              }
            }
          }

          return new wc(t);
        }
      }]);

      return wc;
    }();

    function kc(e, t) {
      var i = (t = yc(t)).reduce(function (e, t) {
        return e + t.offsetSize;
      }, 0),
          n = e.parent;
      Ac(e);
      var o = e.index;
      return n._insertChild(o, t), xc(n, o + t.length), xc(n, o), new sa(e, e.getShiftedBy(i));
    }

    function _c(e) {
      if (!e.isFlat) throw new c.a("operation-utils-remove-range-not-flat", this);
      var t = e.start.parent;
      Ac(e.start), Ac(e.end);

      var i = t._removeChildren(e.start.index, e.end.index - e.start.index);

      return xc(t, e.start.index), i;
    }

    function vc(e, t) {
      if (!e.isFlat) throw new c.a("operation-utils-move-range-not-flat", this);

      var i = _c(e);

      return kc(t = t._getTransformedByDeletion(e.start, e.end.offset - e.start.offset), i);
    }

    function yc(e) {
      var t = [];
      e instanceof Array || (e = [e]);

      for (var _i176 = 0; _i176 < e.length; _i176++) {
        if ("string" == typeof e[_i176]) t.push(new Qs(e[_i176]));else if (e[_i176] instanceof Js) t.push(new Qs(e[_i176].data, e[_i176].getAttributes()));else if (e[_i176] instanceof wc || e[_i176] instanceof Zs) {
          var _iteratorNormalCompletion227 = true;
          var _didIteratorError227 = false;
          var _iteratorError227 = undefined;

          try {
            for (var _iterator227 = e[_i176][Symbol.iterator](), _step227; !(_iteratorNormalCompletion227 = (_step227 = _iterator227.next()).done); _iteratorNormalCompletion227 = true) {
              var _n84 = _step227.value;
              t.push(_n84);
            }
          } catch (err) {
            _didIteratorError227 = true;
            _iteratorError227 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion227 && _iterator227.return != null) {
                _iterator227.return();
              }
            } finally {
              if (_didIteratorError227) {
                throw _iteratorError227;
              }
            }
          }
        } else e[_i176] instanceof Ks && t.push(e[_i176]);
      }

      for (var _e160 = 1; _e160 < t.length; _e160++) {
        var _i177 = t[_e160],
            _n85 = t[_e160 - 1];
        _i177 instanceof Qs && _n85 instanceof Qs && Cc(_i177, _n85) && (t.splice(_e160 - 1, 2, new Qs(_n85.data + _i177.data, _n85.getAttributes())), _e160--);
      }

      return t;
    }

    function xc(e, t) {
      var i = e.getChild(t - 1),
          n = e.getChild(t);

      if (i && n && i.is("$text") && n.is("$text") && Cc(i, n)) {
        var _o48 = new Qs(i.data + n.data, i.getAttributes());

        e._removeChildren(t - 1, 2), e._insertChild(t - 1, _o48);
      }
    }

    function Ac(e) {
      var t = e.textNode,
          i = e.parent;

      if (t) {
        var _n86 = e.offset - t.startOffset,
            _o49 = t.index;

        i._removeChildren(_o49, 1);

        var _r23 = new Qs(t.data.substr(0, _n86), t.getAttributes()),
            _s15 = new Qs(t.data.substr(_n86), t.getAttributes());

        i._insertChild(_o49, [_r23, _s15]);
      }
    }

    function Cc(e, t) {
      var i = e.getAttributes(),
          n = t.getAttributes();
      var _iteratorNormalCompletion228 = true;
      var _didIteratorError228 = false;
      var _iteratorError228 = undefined;

      try {
        for (var _iterator228 = i[Symbol.iterator](), _step228; !(_iteratorNormalCompletion228 = (_step228 = _iterator228.next()).done); _iteratorNormalCompletion228 = true) {
          var _e161 = _step228.value;
          if (_e161[1] !== t.getAttribute(_e161[0])) return !1;
          n.next();
        }
      } catch (err) {
        _didIteratorError228 = true;
        _iteratorError228 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion228 && _iterator228.return != null) {
            _iterator228.return();
          }
        } finally {
          if (_didIteratorError228) {
            throw _iteratorError228;
          }
        }
      }

      return n.next().done;
    }

    var Tc = function Tc(e, t) {
      return Zr(e, t);
    };

    var Ec =
    /*#__PURE__*/
    function (_bc) {
      _inherits(Ec, _bc);

      function Ec(e, t, i, n, o) {
        var _this64;

        _classCallCheck(this, Ec);

        _this64 = _possibleConstructorReturn(this, _getPrototypeOf(Ec).call(this, o)), _this64.range = e.clone(), _this64.key = t, _this64.oldValue = void 0 === i ? null : i, _this64.newValue = void 0 === n ? null : n;
        return _this64;
      }

      _createClass(Ec, [{
        key: "clone",
        value: function clone() {
          return new Ec(this.range, this.key, this.oldValue, this.newValue, this.baseVersion);
        }
      }, {
        key: "getReversed",
        value: function getReversed() {
          return new Ec(this.range, this.key, this.newValue, this.oldValue, this.baseVersion + 1);
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var e = _get(_getPrototypeOf(Ec.prototype), "toJSON", this).call(this);

          return e.range = this.range.toJSON(), e;
        }
      }, {
        key: "_validate",
        value: function _validate() {
          if (!this.range.isFlat) throw new c.a("attribute-operation-range-not-flat", this);
          var _iteratorNormalCompletion229 = true;
          var _didIteratorError229 = false;
          var _iteratorError229 = undefined;

          try {
            for (var _iterator229 = this.range.getItems({
              shallow: !0
            })[Symbol.iterator](), _step229; !(_iteratorNormalCompletion229 = (_step229 = _iterator229.next()).done); _iteratorNormalCompletion229 = true) {
              var _e162 = _step229.value;
              if (null !== this.oldValue && !Tc(_e162.getAttribute(this.key), this.oldValue)) throw new c.a("attribute-operation-wrong-old-value", this, {
                item: _e162,
                key: this.key,
                value: this.oldValue
              });
              if (null === this.oldValue && null !== this.newValue && _e162.hasAttribute(this.key)) throw new c.a("attribute-operation-attribute-exists", this, {
                node: _e162,
                key: this.key
              });
            }
          } catch (err) {
            _didIteratorError229 = true;
            _iteratorError229 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion229 && _iterator229.return != null) {
                _iterator229.return();
              }
            } finally {
              if (_didIteratorError229) {
                throw _iteratorError229;
              }
            }
          }
        }
      }, {
        key: "_execute",
        value: function _execute() {
          Tc(this.oldValue, this.newValue) || function (e, t, i) {
            Ac(e.start), Ac(e.end);
            var _iteratorNormalCompletion230 = true;
            var _didIteratorError230 = false;
            var _iteratorError230 = undefined;

            try {
              for (var _iterator230 = e.getItems({
                shallow: !0
              })[Symbol.iterator](), _step230; !(_iteratorNormalCompletion230 = (_step230 = _iterator230.next()).done); _iteratorNormalCompletion230 = true) {
                var _n87 = _step230.value;

                var _e163 = _n87.is("$textProxy") ? _n87.textNode : _n87;

                null !== i ? _e163._setAttribute(t, i) : _e163._removeAttribute(t), xc(_e163.parent, _e163.index);
              }
            } catch (err) {
              _didIteratorError230 = true;
              _iteratorError230 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion230 && _iterator230.return != null) {
                  _iterator230.return();
                }
              } finally {
                if (_didIteratorError230) {
                  throw _iteratorError230;
                }
              }
            }

            xc(e.end.parent, e.end.index);
          }(this.range, this.key, this.newValue);
        }
      }, {
        key: "type",
        get: function get() {
          return null === this.oldValue ? "addAttribute" : null === this.newValue ? "removeAttribute" : "changeAttribute";
        }
      }], [{
        key: "fromJSON",
        value: function fromJSON(e, t) {
          return new Ec(sa.fromJSON(e.range, t), e.key, e.oldValue, e.newValue, e.baseVersion);
        }
      }, {
        key: "className",
        get: function get() {
          return "AttributeOperation";
        }
      }]);

      return Ec;
    }(bc);

    var Sc =
    /*#__PURE__*/
    function (_bc2) {
      _inherits(Sc, _bc2);

      function Sc(e, t) {
        var _this65;

        _classCallCheck(this, Sc);

        _this65 = _possibleConstructorReturn(this, _getPrototypeOf(Sc).call(this, null)), _this65.sourcePosition = e.clone(), _this65.howMany = t;
        return _this65;
      }

      _createClass(Sc, [{
        key: "toJSON",
        value: function toJSON() {
          var e = _get(_getPrototypeOf(Sc.prototype), "toJSON", this).call(this);

          return e.sourcePosition = this.sourcePosition.toJSON(), e;
        }
      }, {
        key: "_validate",
        value: function _validate() {
          if (this.sourcePosition.root.document) throw new c.a("detach-operation-on-document-node", this);
        }
      }, {
        key: "_execute",
        value: function _execute() {
          _c(sa._createFromPositionAndShift(this.sourcePosition, this.howMany));
        }
      }, {
        key: "type",
        get: function get() {
          return "detach";
        }
      }], [{
        key: "className",
        get: function get() {
          return "DetachOperation";
        }
      }]);

      return Sc;
    }(bc);

    var Ic =
    /*#__PURE__*/
    function (_bc3) {
      _inherits(Ic, _bc3);

      function Ic(e, t, i, n) {
        var _this66;

        _classCallCheck(this, Ic);

        _this66 = _possibleConstructorReturn(this, _getPrototypeOf(Ic).call(this, n)), _this66.sourcePosition = e.clone(), _this66.sourcePosition.stickiness = "toNext", _this66.howMany = t, _this66.targetPosition = i.clone(), _this66.targetPosition.stickiness = "toNone";
        return _this66;
      }

      _createClass(Ic, [{
        key: "clone",
        value: function clone() {
          return new this.constructor(this.sourcePosition, this.howMany, this.targetPosition, this.baseVersion);
        }
      }, {
        key: "getMovedRangeStart",
        value: function getMovedRangeStart() {
          return this.targetPosition._getTransformedByDeletion(this.sourcePosition, this.howMany);
        }
      }, {
        key: "getReversed",
        value: function getReversed() {
          var e = this.sourcePosition._getTransformedByInsertion(this.targetPosition, this.howMany);

          return new this.constructor(this.getMovedRangeStart(), this.howMany, e, this.baseVersion + 1);
        }
      }, {
        key: "_validate",
        value: function _validate() {
          var e = this.sourcePosition.parent,
              t = this.targetPosition.parent,
              i = this.sourcePosition.offset,
              n = this.targetPosition.offset;
          if (i + this.howMany > e.maxOffset) throw new c.a("move-operation-nodes-do-not-exist", this);
          if (e === t && i < n && n < i + this.howMany) throw new c.a("move-operation-range-into-itself", this);

          if (this.sourcePosition.root == this.targetPosition.root && "prefix" == cn(this.sourcePosition.getParentPath(), this.targetPosition.getParentPath())) {
            var _e164 = this.sourcePosition.path.length - 1;

            if (this.targetPosition.path[_e164] >= i && this.targetPosition.path[_e164] < i + this.howMany) throw new c.a("move-operation-node-into-itself", this);
          }
        }
      }, {
        key: "_execute",
        value: function _execute() {
          vc(sa._createFromPositionAndShift(this.sourcePosition, this.howMany), this.targetPosition);
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var e = _get(_getPrototypeOf(Ic.prototype), "toJSON", this).call(this);

          return e.sourcePosition = this.sourcePosition.toJSON(), e.targetPosition = this.targetPosition.toJSON(), e;
        }
      }, {
        key: "type",
        get: function get() {
          return "$graveyard" == this.targetPosition.root.rootName ? "remove" : "$graveyard" == this.sourcePosition.root.rootName ? "reinsert" : "move";
        }
      }], [{
        key: "fromJSON",
        value: function fromJSON(e, t) {
          var i = ia.fromJSON(e.sourcePosition, t),
              n = ia.fromJSON(e.targetPosition, t);
          return new this(i, e.howMany, n, e.baseVersion);
        }
      }, {
        key: "className",
        get: function get() {
          return "MoveOperation";
        }
      }]);

      return Ic;
    }(bc);

    var Pc =
    /*#__PURE__*/
    function (_bc4) {
      _inherits(Pc, _bc4);

      function Pc(e, t, i) {
        var _this67;

        _classCallCheck(this, Pc);

        _this67 = _possibleConstructorReturn(this, _getPrototypeOf(Pc).call(this, i)), _this67.position = e.clone(), _this67.position.stickiness = "toNone", _this67.nodes = new Zs(yc(t)), _this67.shouldReceiveAttributes = !1;
        return _this67;
      }

      _createClass(Pc, [{
        key: "clone",
        value: function clone() {
          var e = new Zs(_toConsumableArray(this.nodes).map(function (e) {
            return e._clone(!0);
          })),
              t = new Pc(this.position, e, this.baseVersion);
          return t.shouldReceiveAttributes = this.shouldReceiveAttributes, t;
        }
      }, {
        key: "getReversed",
        value: function getReversed() {
          var e = this.position.root.document.graveyard,
              t = new ia(e, [0]);
          return new Ic(this.position, this.nodes.maxOffset, t, this.baseVersion + 1);
        }
      }, {
        key: "_validate",
        value: function _validate() {
          var e = this.position.parent;
          if (!e || e.maxOffset < this.position.offset) throw new c.a("insert-operation-position-invalid", this);
        }
      }, {
        key: "_execute",
        value: function _execute() {
          var e = this.nodes;
          this.nodes = new Zs(_toConsumableArray(e).map(function (e) {
            return e._clone(!0);
          })), kc(this.position, e);
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var e = _get(_getPrototypeOf(Pc.prototype), "toJSON", this).call(this);

          return e.position = this.position.toJSON(), e.nodes = this.nodes.toJSON(), e;
        }
      }, {
        key: "type",
        get: function get() {
          return "insert";
        }
      }, {
        key: "howMany",
        get: function get() {
          return this.nodes.maxOffset;
        }
      }], [{
        key: "fromJSON",
        value: function fromJSON(e, t) {
          var i = [];
          var _iteratorNormalCompletion231 = true;
          var _didIteratorError231 = false;
          var _iteratorError231 = undefined;

          try {
            for (var _iterator231 = e.nodes[Symbol.iterator](), _step231; !(_iteratorNormalCompletion231 = (_step231 = _iterator231.next()).done); _iteratorNormalCompletion231 = true) {
              var _t156 = _step231.value;
              _t156.name ? i.push(Xs.fromJSON(_t156)) : i.push(Qs.fromJSON(_t156));
            }
          } catch (err) {
            _didIteratorError231 = true;
            _iteratorError231 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion231 && _iterator231.return != null) {
                _iterator231.return();
              }
            } finally {
              if (_didIteratorError231) {
                throw _iteratorError231;
              }
            }
          }

          var n = new Pc(ia.fromJSON(e.position, t), i, e.baseVersion);
          return n.shouldReceiveAttributes = e.shouldReceiveAttributes, n;
        }
      }, {
        key: "className",
        get: function get() {
          return "InsertOperation";
        }
      }]);

      return Pc;
    }(bc);

    var Mc =
    /*#__PURE__*/
    function (_bc5) {
      _inherits(Mc, _bc5);

      function Mc(e, t, i, n, o, r) {
        var _this68;

        _classCallCheck(this, Mc);

        _this68 = _possibleConstructorReturn(this, _getPrototypeOf(Mc).call(this, r)), _this68.name = e, _this68.oldRange = t ? t.clone() : null, _this68.newRange = i ? i.clone() : null, _this68.affectsData = o, _this68._markers = n;
        return _this68;
      }

      _createClass(Mc, [{
        key: "clone",
        value: function clone() {
          return new Mc(this.name, this.oldRange, this.newRange, this._markers, this.affectsData, this.baseVersion);
        }
      }, {
        key: "getReversed",
        value: function getReversed() {
          return new Mc(this.name, this.newRange, this.oldRange, this._markers, this.affectsData, this.baseVersion + 1);
        }
      }, {
        key: "_execute",
        value: function _execute() {
          var e = this.newRange ? "_set" : "_remove";

          this._markers[e](this.name, this.newRange, !0, this.affectsData);
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var e = _get(_getPrototypeOf(Mc.prototype), "toJSON", this).call(this);

          return this.oldRange && (e.oldRange = this.oldRange.toJSON()), this.newRange && (e.newRange = this.newRange.toJSON()), delete e._markers, e;
        }
      }, {
        key: "type",
        get: function get() {
          return "marker";
        }
      }], [{
        key: "fromJSON",
        value: function fromJSON(e, t) {
          return new Mc(e.name, e.oldRange ? sa.fromJSON(e.oldRange, t) : null, e.newRange ? sa.fromJSON(e.newRange, t) : null, t.model.markers, e.affectsData, e.baseVersion);
        }
      }, {
        key: "className",
        get: function get() {
          return "MarkerOperation";
        }
      }]);

      return Mc;
    }(bc);

    var Nc =
    /*#__PURE__*/
    function (_bc6) {
      _inherits(Nc, _bc6);

      function Nc(e, t, i, n) {
        var _this69;

        _classCallCheck(this, Nc);

        _this69 = _possibleConstructorReturn(this, _getPrototypeOf(Nc).call(this, n)), _this69.position = e, _this69.position.stickiness = "toNext", _this69.oldName = t, _this69.newName = i;
        return _this69;
      }

      _createClass(Nc, [{
        key: "clone",
        value: function clone() {
          return new Nc(this.position.clone(), this.oldName, this.newName, this.baseVersion);
        }
      }, {
        key: "getReversed",
        value: function getReversed() {
          return new Nc(this.position.clone(), this.newName, this.oldName, this.baseVersion + 1);
        }
      }, {
        key: "_validate",
        value: function _validate() {
          var e = this.position.nodeAfter;
          if (!(e instanceof Xs)) throw new c.a("rename-operation-wrong-position", this);
          if (e.name !== this.oldName) throw new c.a("rename-operation-wrong-name", this);
        }
      }, {
        key: "_execute",
        value: function _execute() {
          this.position.nodeAfter.name = this.newName;
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var e = _get(_getPrototypeOf(Nc.prototype), "toJSON", this).call(this);

          return e.position = this.position.toJSON(), e;
        }
      }, {
        key: "type",
        get: function get() {
          return "rename";
        }
      }], [{
        key: "fromJSON",
        value: function fromJSON(e, t) {
          return new Nc(ia.fromJSON(e.position, t), e.oldName, e.newName, e.baseVersion);
        }
      }, {
        key: "className",
        get: function get() {
          return "RenameOperation";
        }
      }]);

      return Nc;
    }(bc);

    var Rc =
    /*#__PURE__*/
    function (_bc7) {
      _inherits(Rc, _bc7);

      function Rc(e, t, i, n, o) {
        var _this70;

        _classCallCheck(this, Rc);

        _this70 = _possibleConstructorReturn(this, _getPrototypeOf(Rc).call(this, o)), _this70.root = e, _this70.key = t, _this70.oldValue = i, _this70.newValue = n;
        return _this70;
      }

      _createClass(Rc, [{
        key: "clone",
        value: function clone() {
          return new Rc(this.root, this.key, this.oldValue, this.newValue, this.baseVersion);
        }
      }, {
        key: "getReversed",
        value: function getReversed() {
          return new Rc(this.root, this.key, this.newValue, this.oldValue, this.baseVersion + 1);
        }
      }, {
        key: "_validate",
        value: function _validate() {
          if (this.root != this.root.root || this.root.is("documentFragment")) throw new c.a("rootattribute-operation-not-a-root", this, {
            root: this.root,
            key: this.key
          });
          if (null !== this.oldValue && this.root.getAttribute(this.key) !== this.oldValue) throw new c.a("rootattribute-operation-wrong-old-value", this, {
            root: this.root,
            key: this.key
          });
          if (null === this.oldValue && null !== this.newValue && this.root.hasAttribute(this.key)) throw new c.a("rootattribute-operation-attribute-exists", this, {
            root: this.root,
            key: this.key
          });
        }
      }, {
        key: "_execute",
        value: function _execute() {
          null !== this.newValue ? this.root._setAttribute(this.key, this.newValue) : this.root._removeAttribute(this.key);
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var e = _get(_getPrototypeOf(Rc.prototype), "toJSON", this).call(this);

          return e.root = this.root.toJSON(), e;
        }
      }, {
        key: "type",
        get: function get() {
          return null === this.oldValue ? "addRootAttribute" : null === this.newValue ? "removeRootAttribute" : "changeRootAttribute";
        }
      }], [{
        key: "fromJSON",
        value: function fromJSON(e, t) {
          if (!t.getRoot(e.root)) throw new c.a("rootattribute-operation-fromjson-no-root", this, {
            rootName: e.root
          });
          return new Rc(t.getRoot(e.root), e.key, e.oldValue, e.newValue, e.baseVersion);
        }
      }, {
        key: "className",
        get: function get() {
          return "RootAttributeOperation";
        }
      }]);

      return Rc;
    }(bc);

    var Oc =
    /*#__PURE__*/
    function (_bc8) {
      _inherits(Oc, _bc8);

      function Oc(e, t, i, n, o) {
        var _this71;

        _classCallCheck(this, Oc);

        _this71 = _possibleConstructorReturn(this, _getPrototypeOf(Oc).call(this, o)), _this71.sourcePosition = e.clone(), _this71.sourcePosition.stickiness = "toPrevious", _this71.howMany = t, _this71.targetPosition = i.clone(), _this71.targetPosition.stickiness = "toNext", _this71.graveyardPosition = n.clone();
        return _this71;
      }

      _createClass(Oc, [{
        key: "clone",
        value: function clone() {
          return new this.constructor(this.sourcePosition, this.howMany, this.targetPosition, this.graveyardPosition, this.baseVersion);
        }
      }, {
        key: "getReversed",
        value: function getReversed() {
          var e = this.targetPosition._getTransformedByMergeOperation(this),
              t = this.sourcePosition.path.slice(0, -1),
              i = new ia(this.sourcePosition.root, t)._getTransformedByMergeOperation(this);

          return new zc(e, this.howMany, i, this.graveyardPosition, this.baseVersion + 1);
        }
      }, {
        key: "_validate",
        value: function _validate() {
          var e = this.sourcePosition.parent,
              t = this.targetPosition.parent;
          if (!e.parent) throw new c.a("merge-operation-source-position-invalid", this);
          if (!t.parent) throw new c.a("merge-operation-target-position-invalid", this);
          if (this.howMany != e.maxOffset) throw new c.a("merge-operation-how-many-invalid", this);
        }
      }, {
        key: "_execute",
        value: function _execute() {
          var e = this.sourcePosition.parent;
          vc(sa._createIn(e), this.targetPosition), vc(sa._createOn(e), this.graveyardPosition);
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var e = _get(_getPrototypeOf(Oc.prototype), "toJSON", this).call(this);

          return e.sourcePosition = e.sourcePosition.toJSON(), e.targetPosition = e.targetPosition.toJSON(), e.graveyardPosition = e.graveyardPosition.toJSON(), e;
        }
      }, {
        key: "type",
        get: function get() {
          return "merge";
        }
      }, {
        key: "deletionPosition",
        get: function get() {
          return new ia(this.sourcePosition.root, this.sourcePosition.path.slice(0, -1));
        }
      }, {
        key: "movedRange",
        get: function get() {
          var e = this.sourcePosition.getShiftedBy(Number.POSITIVE_INFINITY);
          return new sa(this.sourcePosition, e);
        }
      }], [{
        key: "fromJSON",
        value: function fromJSON(e, t) {
          var i = ia.fromJSON(e.sourcePosition, t),
              n = ia.fromJSON(e.targetPosition, t),
              o = ia.fromJSON(e.graveyardPosition, t);
          return new this(i, e.howMany, n, o, e.baseVersion);
        }
      }, {
        key: "className",
        get: function get() {
          return "MergeOperation";
        }
      }]);

      return Oc;
    }(bc);

    var zc =
    /*#__PURE__*/
    function (_bc9) {
      _inherits(zc, _bc9);

      function zc(e, t, i, n, o) {
        var _this72;

        _classCallCheck(this, zc);

        _this72 = _possibleConstructorReturn(this, _getPrototypeOf(zc).call(this, o)), _this72.splitPosition = e.clone(), _this72.splitPosition.stickiness = "toNext", _this72.howMany = t, _this72.insertionPosition = i, _this72.graveyardPosition = n ? n.clone() : null, _this72.graveyardPosition && (_this72.graveyardPosition.stickiness = "toNext");
        return _this72;
      }

      _createClass(zc, [{
        key: "clone",
        value: function clone() {
          return new this.constructor(this.splitPosition, this.howMany, this.insertionPosition, this.graveyardPosition, this.baseVersion);
        }
      }, {
        key: "getReversed",
        value: function getReversed() {
          var e = this.splitPosition.root.document.graveyard,
              t = new ia(e, [0]);
          return new Oc(this.moveTargetPosition, this.howMany, this.splitPosition, t, this.baseVersion + 1);
        }
      }, {
        key: "_validate",
        value: function _validate() {
          var e = this.splitPosition.parent,
              t = this.splitPosition.offset;
          if (!e || e.maxOffset < t) throw new c.a("split-operation-position-invalid", this);
          if (!e.parent) throw new c.a("split-operation-split-in-root", this);
          if (this.howMany != e.maxOffset - this.splitPosition.offset) throw new c.a("split-operation-how-many-invalid", this);
          if (this.graveyardPosition && !this.graveyardPosition.nodeAfter) throw new c.a("split-operation-graveyard-position-invalid", this);
        }
      }, {
        key: "_execute",
        value: function _execute() {
          var e = this.splitPosition.parent;
          if (this.graveyardPosition) vc(sa._createFromPositionAndShift(this.graveyardPosition, 1), this.insertionPosition);else {
            var _t157 = e._clone();

            kc(this.insertionPosition, _t157);
          }
          vc(new sa(ia._createAt(e, this.splitPosition.offset), ia._createAt(e, e.maxOffset)), this.moveTargetPosition);
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var e = _get(_getPrototypeOf(zc.prototype), "toJSON", this).call(this);

          return e.splitPosition = this.splitPosition.toJSON(), e.insertionPosition = this.insertionPosition.toJSON(), this.graveyardPosition && (e.graveyardPosition = this.graveyardPosition.toJSON()), e;
        }
      }, {
        key: "type",
        get: function get() {
          return "split";
        }
      }, {
        key: "moveTargetPosition",
        get: function get() {
          var e = this.insertionPosition.path.slice();
          return e.push(0), new ia(this.insertionPosition.root, e);
        }
      }, {
        key: "movedRange",
        get: function get() {
          var e = this.splitPosition.getShiftedBy(Number.POSITIVE_INFINITY);
          return new sa(this.splitPosition, e);
        }
      }], [{
        key: "getInsertionPosition",
        value: function getInsertionPosition(e) {
          var t = e.path.slice(0, -1);
          return t[t.length - 1]++, new ia(e.root, t, "toPrevious");
        }
      }, {
        key: "fromJSON",
        value: function fromJSON(e, t) {
          var i = ia.fromJSON(e.splitPosition, t),
              n = ia.fromJSON(e.insertionPosition, t),
              o = e.graveyardPosition ? ia.fromJSON(e.graveyardPosition, t) : null;
          return new this(i, e.howMany, n, o, e.baseVersion);
        }
      }, {
        key: "className",
        get: function get() {
          return "SplitOperation";
        }
      }]);

      return zc;
    }(bc);

    var Dc =
    /*#__PURE__*/
    function (_Xs) {
      _inherits(Dc, _Xs);

      function Dc(e, t) {
        var _this73;

        var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "main";

        _classCallCheck(this, Dc);

        _this73 = _possibleConstructorReturn(this, _getPrototypeOf(Dc).call(this, t)), _this73._document = e, _this73.rootName = i;
        return _this73;
      }

      _createClass(Dc, [{
        key: "is",
        value: function is(e, t) {
          return t ? t === this.name && ("rootElement" === e || "model:rootElement" === e || "element" === e || "model:element" === e) : "rootElement" === e || "model:rootElement" === e || "element" === e || "model:element" === e || "node" === e || "model:node" === e;
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          return this.rootName;
        }
      }, {
        key: "document",
        get: function get() {
          return this._document;
        }
      }]);

      return Dc;
    }(Xs);

    var Lc =
    /*#__PURE__*/
    function () {
      function Lc(e, t) {
        _classCallCheck(this, Lc);

        this.model = e, this.batch = t;
      }

      _createClass(Lc, [{
        key: "createText",
        value: function createText(e, t) {
          return new Qs(e, t);
        }
      }, {
        key: "createElement",
        value: function createElement(e, t) {
          return new Xs(e, t);
        }
      }, {
        key: "createDocumentFragment",
        value: function createDocumentFragment() {
          return new wc();
        }
      }, {
        key: "cloneElement",
        value: function cloneElement(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
          return e._clone(t);
        }
      }, {
        key: "insert",
        value: function insert(e, t) {
          var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
          if (this._assertWriterUsedCorrectly(), e instanceof Qs && "" == e.data) return;

          var n = ia._createAt(t, i);

          if (e.parent) {
            if (Hc(e.root, n.root)) return void this.move(sa._createOn(e), n);
            if (e.root.document) throw new c.a("model-writer-insert-forbidden-move", this);
            this.remove(e);
          }

          var o = n.root.document ? n.root.document.version : null,
              r = new Pc(n, e, o);

          if (e instanceof Qs && (r.shouldReceiveAttributes = !0), this.batch.addOperation(r), this.model.applyOperation(r), e instanceof wc) {
            var _iteratorNormalCompletion232 = true;
            var _didIteratorError232 = false;
            var _iteratorError232 = undefined;

            try {
              for (var _iterator232 = e.markers[Symbol.iterator](), _step232; !(_iteratorNormalCompletion232 = (_step232 = _iterator232.next()).done); _iteratorNormalCompletion232 = true) {
                var _ref79 = _step232.value;

                var _ref78 = _slicedToArray(_ref79, 2);

                var _t158 = _ref78[0];
                var _i178 = _ref78[1];

                var _e165 = ia._createAt(_i178.root, 0),
                    _o50 = {
                  range: new sa(_i178.start._getCombined(_e165, n), _i178.end._getCombined(_e165, n)),
                  usingOperation: !0,
                  affectsData: !0
                };

                this.model.markers.has(_t158) ? this.updateMarker(_t158, _o50) : this.addMarker(_t158, _o50);
              }
            } catch (err) {
              _didIteratorError232 = true;
              _iteratorError232 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion232 && _iterator232.return != null) {
                  _iterator232.return();
                }
              } finally {
                if (_didIteratorError232) {
                  throw _iteratorError232;
                }
              }
            }
          }
        }
      }, {
        key: "insertText",
        value: function insertText(e, t, i, n) {
          t instanceof wc || t instanceof Xs || t instanceof ia ? this.insert(this.createText(e), t, i) : this.insert(this.createText(e, t), i, n);
        }
      }, {
        key: "insertElement",
        value: function insertElement(e, t, i, n) {
          t instanceof wc || t instanceof Xs || t instanceof ia ? this.insert(this.createElement(e), t, i) : this.insert(this.createElement(e, t), i, n);
        }
      }, {
        key: "append",
        value: function append(e, t) {
          this.insert(e, t, "end");
        }
      }, {
        key: "appendText",
        value: function appendText(e, t, i) {
          t instanceof wc || t instanceof Xs ? this.insert(this.createText(e), t, "end") : this.insert(this.createText(e, t), i, "end");
        }
      }, {
        key: "appendElement",
        value: function appendElement(e, t, i) {
          t instanceof wc || t instanceof Xs ? this.insert(this.createElement(e), t, "end") : this.insert(this.createElement(e, t), i, "end");
        }
      }, {
        key: "setAttribute",
        value: function setAttribute(e, t, i) {
          if (this._assertWriterUsedCorrectly(), i instanceof sa) {
            var _n88 = i.getMinimalFlatRanges();

            var _iteratorNormalCompletion233 = true;
            var _didIteratorError233 = false;
            var _iteratorError233 = undefined;

            try {
              for (var _iterator233 = _n88[Symbol.iterator](), _step233; !(_iteratorNormalCompletion233 = (_step233 = _iterator233.next()).done); _iteratorNormalCompletion233 = true) {
                var _i179 = _step233.value;
                Vc(this, e, t, _i179);
              }
            } catch (err) {
              _didIteratorError233 = true;
              _iteratorError233 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion233 && _iterator233.return != null) {
                  _iterator233.return();
                }
              } finally {
                if (_didIteratorError233) {
                  throw _iteratorError233;
                }
              }
            }
          } else jc(this, e, t, i);
        }
      }, {
        key: "setAttributes",
        value: function setAttributes(e, t) {
          var _iteratorNormalCompletion234 = true;
          var _didIteratorError234 = false;
          var _iteratorError234 = undefined;

          try {
            for (var _iterator234 = gn(e)[Symbol.iterator](), _step234; !(_iteratorNormalCompletion234 = (_step234 = _iterator234.next()).done); _iteratorNormalCompletion234 = true) {
              var _ref82 = _step234.value;

              var _ref81 = _slicedToArray(_ref82, 2);

              var _i180 = _ref81[0];
              var _n89 = _ref81[1];
              this.setAttribute(_i180, _n89, t);
            }
          } catch (err) {
            _didIteratorError234 = true;
            _iteratorError234 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion234 && _iterator234.return != null) {
                _iterator234.return();
              }
            } finally {
              if (_didIteratorError234) {
                throw _iteratorError234;
              }
            }
          }
        }
      }, {
        key: "removeAttribute",
        value: function removeAttribute(e, t) {
          if (this._assertWriterUsedCorrectly(), t instanceof sa) {
            var _i181 = t.getMinimalFlatRanges();

            var _iteratorNormalCompletion235 = true;
            var _didIteratorError235 = false;
            var _iteratorError235 = undefined;

            try {
              for (var _iterator235 = _i181[Symbol.iterator](), _step235; !(_iteratorNormalCompletion235 = (_step235 = _iterator235.next()).done); _iteratorNormalCompletion235 = true) {
                var _t159 = _step235.value;
                Vc(this, e, null, _t159);
              }
            } catch (err) {
              _didIteratorError235 = true;
              _iteratorError235 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion235 && _iterator235.return != null) {
                  _iterator235.return();
                }
              } finally {
                if (_didIteratorError235) {
                  throw _iteratorError235;
                }
              }
            }
          } else jc(this, e, null, t);
        }
      }, {
        key: "clearAttributes",
        value: function clearAttributes(e) {
          var _this74 = this;

          this._assertWriterUsedCorrectly();

          var t = function t(e) {
            var _iteratorNormalCompletion236 = true;
            var _didIteratorError236 = false;
            var _iteratorError236 = undefined;

            try {
              for (var _iterator236 = e.getAttributeKeys()[Symbol.iterator](), _step236; !(_iteratorNormalCompletion236 = (_step236 = _iterator236.next()).done); _iteratorNormalCompletion236 = true) {
                var _t160 = _step236.value;

                _this74.removeAttribute(_t160, e);
              }
            } catch (err) {
              _didIteratorError236 = true;
              _iteratorError236 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion236 && _iterator236.return != null) {
                  _iterator236.return();
                }
              } finally {
                if (_didIteratorError236) {
                  throw _iteratorError236;
                }
              }
            }
          };

          if (e instanceof sa) {
            var _iteratorNormalCompletion237 = true;
            var _didIteratorError237 = false;
            var _iteratorError237 = undefined;

            try {
              for (var _iterator237 = e.getItems()[Symbol.iterator](), _step237; !(_iteratorNormalCompletion237 = (_step237 = _iterator237.next()).done); _iteratorNormalCompletion237 = true) {
                var _i182 = _step237.value;
                t(_i182);
              }
            } catch (err) {
              _didIteratorError237 = true;
              _iteratorError237 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion237 && _iterator237.return != null) {
                  _iterator237.return();
                }
              } finally {
                if (_didIteratorError237) {
                  throw _iteratorError237;
                }
              }
            }
          } else t(e);
        }
      }, {
        key: "move",
        value: function move(e, t, i) {
          if (this._assertWriterUsedCorrectly(), !(e instanceof sa)) throw new c.a("writer-move-invalid-range", this);
          if (!e.isFlat) throw new c.a("writer-move-range-not-flat", this);

          var n = ia._createAt(t, i);

          if (n.isEqual(e.start)) return;
          if (this._addOperationForAffectedMarkers("move", e), !Hc(e.root, n.root)) throw new c.a("writer-move-different-document", this);
          var o = e.root.document ? e.root.document.version : null,
              r = new Ic(e.start, e.end.offset - e.start.offset, n, o);
          this.batch.addOperation(r), this.model.applyOperation(r);
        }
      }, {
        key: "remove",
        value: function remove(e) {
          this._assertWriterUsedCorrectly();

          var t = (e instanceof sa ? e : sa._createOn(e)).getMinimalFlatRanges().reverse();
          var _iteratorNormalCompletion238 = true;
          var _didIteratorError238 = false;
          var _iteratorError238 = undefined;

          try {
            for (var _iterator238 = t[Symbol.iterator](), _step238; !(_iteratorNormalCompletion238 = (_step238 = _iterator238.next()).done); _iteratorNormalCompletion238 = true) {
              var _e166 = _step238.value;
              this._addOperationForAffectedMarkers("move", _e166), Fc(_e166.start, _e166.end.offset - _e166.start.offset, this.batch, this.model);
            }
          } catch (err) {
            _didIteratorError238 = true;
            _iteratorError238 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion238 && _iterator238.return != null) {
                _iterator238.return();
              }
            } finally {
              if (_didIteratorError238) {
                throw _iteratorError238;
              }
            }
          }
        }
      }, {
        key: "merge",
        value: function merge(e) {
          this._assertWriterUsedCorrectly();

          var t = e.nodeBefore,
              i = e.nodeAfter;
          if (this._addOperationForAffectedMarkers("merge", e), !(t instanceof Xs)) throw new c.a("writer-merge-no-element-before", this);
          if (!(i instanceof Xs)) throw new c.a("writer-merge-no-element-after", this);
          e.root.document ? this._merge(e) : this._mergeDetached(e);
        }
      }, {
        key: "createPositionFromPath",
        value: function createPositionFromPath(e, t, i) {
          return this.model.createPositionFromPath(e, t, i);
        }
      }, {
        key: "createPositionAt",
        value: function createPositionAt(e, t) {
          return this.model.createPositionAt(e, t);
        }
      }, {
        key: "createPositionAfter",
        value: function createPositionAfter(e) {
          return this.model.createPositionAfter(e);
        }
      }, {
        key: "createPositionBefore",
        value: function createPositionBefore(e) {
          return this.model.createPositionBefore(e);
        }
      }, {
        key: "createRange",
        value: function createRange(e, t) {
          return this.model.createRange(e, t);
        }
      }, {
        key: "createRangeIn",
        value: function createRangeIn(e) {
          return this.model.createRangeIn(e);
        }
      }, {
        key: "createRangeOn",
        value: function createRangeOn(e) {
          return this.model.createRangeOn(e);
        }
      }, {
        key: "createSelection",
        value: function createSelection(e, t, i) {
          return this.model.createSelection(e, t, i);
        }
      }, {
        key: "_mergeDetached",
        value: function _mergeDetached(e) {
          var t = e.nodeBefore,
              i = e.nodeAfter;
          this.move(sa._createIn(i), ia._createAt(t, "end")), this.remove(i);
        }
      }, {
        key: "_merge",
        value: function _merge(e) {
          var t = ia._createAt(e.nodeBefore, "end"),
              i = ia._createAt(e.nodeAfter, 0),
              n = e.root.document.graveyard,
              o = new ia(n, [0]),
              r = e.root.document.version,
              s = new Oc(i, e.nodeAfter.maxOffset, t, o, r);

          this.batch.addOperation(s), this.model.applyOperation(s);
        }
      }, {
        key: "rename",
        value: function rename(e, t) {
          if (this._assertWriterUsedCorrectly(), !(e instanceof Xs)) throw new c.a("writer-rename-not-element-instance", this);
          var i = e.root.document ? e.root.document.version : null,
              n = new Nc(ia._createBefore(e), e.name, t, i);
          this.batch.addOperation(n), this.model.applyOperation(n);
        }
      }, {
        key: "split",
        value: function split(e, t) {
          this._assertWriterUsedCorrectly();

          var i,
              n,
              o = e.parent;
          if (!o.parent) throw new c.a("writer-split-element-no-parent", this);
          if (t || (t = o.parent), !e.parent.getAncestors({
            includeSelf: !0
          }).includes(t)) throw new c.a("writer-split-invalid-limit-element", this);

          do {
            var _t161 = o.root.document ? o.root.document.version : null,
                _r24 = o.maxOffset - e.offset,
                _s16 = zc.getInsertionPosition(e),
                _a9 = new zc(e, _r24, _s16, null, _t161);

            this.batch.addOperation(_a9), this.model.applyOperation(_a9), i || n || (i = o, n = e.parent.nextSibling), o = (e = this.createPositionAfter(e.parent)).parent;
          } while (o !== t);

          return {
            position: e,
            range: new sa(ia._createAt(i, "end"), ia._createAt(n, 0))
          };
        }
      }, {
        key: "wrap",
        value: function wrap(e, t) {
          if (this._assertWriterUsedCorrectly(), !e.isFlat) throw new c.a("writer-wrap-range-not-flat", this);
          var i = t instanceof Xs ? t : new Xs(t);
          if (i.childCount > 0) throw new c.a("writer-wrap-element-not-empty", this);
          if (null !== i.parent) throw new c.a("writer-wrap-element-attached", this);
          this.insert(i, e.start);
          var n = new sa(e.start.getShiftedBy(1), e.end.getShiftedBy(1));
          this.move(n, ia._createAt(i, 0));
        }
      }, {
        key: "unwrap",
        value: function unwrap(e) {
          if (this._assertWriterUsedCorrectly(), null === e.parent) throw new c.a("writer-unwrap-element-no-parent", this);
          this.move(sa._createIn(e), this.createPositionAfter(e)), this.remove(e);
        }
      }, {
        key: "addMarker",
        value: function addMarker(e, t) {
          if (this._assertWriterUsedCorrectly(), !t || "boolean" != typeof t.usingOperation) throw new c.a("writer-addmarker-no-usingoperation", this);
          var i = t.usingOperation,
              n = t.range,
              o = void 0 !== t.affectsData && t.affectsData;
          if (this.model.markers.has(e)) throw new c.a("writer-addmarker-marker-exists", this);
          if (!n) throw new c.a("writer-addmarker-no-range", this);
          return i ? (Bc(this, e, null, n, o), this.model.markers.get(e)) : this.model.markers._set(e, n, i, o);
        }
      }, {
        key: "updateMarker",
        value: function updateMarker(e, t) {
          this._assertWriterUsedCorrectly();

          var i = "string" == typeof e ? e : e.name,
              n = this.model.markers.get(i);
          if (!n) throw new c.a("writer-updatemarker-marker-not-exists", this);
          if (!t) return void this.model.markers._refresh(n);
          var o = "boolean" == typeof t.usingOperation,
              r = "boolean" == typeof t.affectsData,
              s = r ? t.affectsData : n.affectsData;
          if (!o && !t.range && !r) throw new c.a("writer-updatemarker-wrong-options", this);
          var a = n.getRange(),
              l = t.range ? t.range : a;
          o && t.usingOperation !== n.managedUsingOperations ? t.usingOperation ? Bc(this, i, null, l, s) : (Bc(this, i, a, null, s), this.model.markers._set(i, l, void 0, s)) : n.managedUsingOperations ? Bc(this, i, a, l, s) : this.model.markers._set(i, l, void 0, s);
        }
      }, {
        key: "removeMarker",
        value: function removeMarker(e) {
          this._assertWriterUsedCorrectly();

          var t = "string" == typeof e ? e : e.name;
          if (!this.model.markers.has(t)) throw new c.a("writer-removemarker-no-marker", this);
          var i = this.model.markers.get(t);
          if (!i.managedUsingOperations) return void this.model.markers._remove(t);
          Bc(this, t, i.getRange(), null, i.affectsData);
        }
      }, {
        key: "setSelection",
        value: function setSelection(e, t, i) {
          this._assertWriterUsedCorrectly(), this.model.document.selection._setTo(e, t, i);
        }
      }, {
        key: "setSelectionFocus",
        value: function setSelectionFocus(e, t) {
          this._assertWriterUsedCorrectly(), this.model.document.selection._setFocus(e, t);
        }
      }, {
        key: "setSelectionAttribute",
        value: function setSelectionAttribute(e, t) {
          if (this._assertWriterUsedCorrectly(), "string" == typeof e) this._setSelectionAttribute(e, t);else {
            var _iteratorNormalCompletion239 = true;
            var _didIteratorError239 = false;
            var _iteratorError239 = undefined;

            try {
              for (var _iterator239 = gn(e)[Symbol.iterator](), _step239; !(_iteratorNormalCompletion239 = (_step239 = _iterator239.next()).done); _iteratorNormalCompletion239 = true) {
                var _ref85 = _step239.value;

                var _ref84 = _slicedToArray(_ref85, 2);

                var _t162 = _ref84[0];
                var _i183 = _ref84[1];

                this._setSelectionAttribute(_t162, _i183);
              }
            } catch (err) {
              _didIteratorError239 = true;
              _iteratorError239 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion239 && _iterator239.return != null) {
                  _iterator239.return();
                }
              } finally {
                if (_didIteratorError239) {
                  throw _iteratorError239;
                }
              }
            }
          }
        }
      }, {
        key: "removeSelectionAttribute",
        value: function removeSelectionAttribute(e) {
          if (this._assertWriterUsedCorrectly(), "string" == typeof e) this._removeSelectionAttribute(e);else {
            var _iteratorNormalCompletion240 = true;
            var _didIteratorError240 = false;
            var _iteratorError240 = undefined;

            try {
              for (var _iterator240 = e[Symbol.iterator](), _step240; !(_iteratorNormalCompletion240 = (_step240 = _iterator240.next()).done); _iteratorNormalCompletion240 = true) {
                var _t163 = _step240.value;

                this._removeSelectionAttribute(_t163);
              }
            } catch (err) {
              _didIteratorError240 = true;
              _iteratorError240 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion240 && _iterator240.return != null) {
                  _iterator240.return();
                }
              } finally {
                if (_didIteratorError240) {
                  throw _iteratorError240;
                }
              }
            }
          }
        }
      }, {
        key: "overrideSelectionGravity",
        value: function overrideSelectionGravity() {
          return this.model.document.selection._overrideGravity();
        }
      }, {
        key: "restoreSelectionGravity",
        value: function restoreSelectionGravity(e) {
          this.model.document.selection._restoreGravity(e);
        }
      }, {
        key: "_setSelectionAttribute",
        value: function _setSelectionAttribute(e, t) {
          var i = this.model.document.selection;

          if (i.isCollapsed && i.anchor.parent.isEmpty) {
            var _n90 = ya._getStoreAttributeKey(e);

            this.setAttribute(_n90, t, i.anchor.parent);
          }

          i._setAttribute(e, t);
        }
      }, {
        key: "_removeSelectionAttribute",
        value: function _removeSelectionAttribute(e) {
          var t = this.model.document.selection;

          if (t.isCollapsed && t.anchor.parent.isEmpty) {
            var _i184 = ya._getStoreAttributeKey(e);

            this.removeAttribute(_i184, t.anchor.parent);
          }

          t._removeAttribute(e);
        }
      }, {
        key: "_assertWriterUsedCorrectly",
        value: function _assertWriterUsedCorrectly() {
          if (this.model._currentWriter !== this) throw new c.a("writer-incorrect-use", this);
        }
      }, {
        key: "_addOperationForAffectedMarkers",
        value: function _addOperationForAffectedMarkers(e, t) {
          var _iteratorNormalCompletion241 = true;
          var _didIteratorError241 = false;
          var _iteratorError241 = undefined;

          try {
            for (var _iterator241 = this.model.markers[Symbol.iterator](), _step241; !(_iteratorNormalCompletion241 = (_step241 = _iterator241.next()).done); _iteratorNormalCompletion241 = true) {
              var _i185 = _step241.value;
              if (!_i185.managedUsingOperations) continue;

              var _n91 = _i185.getRange();

              var _o51 = !1;

              if ("move" === e) _o51 = t.containsPosition(_n91.start) || t.start.isEqual(_n91.start) || t.containsPosition(_n91.end) || t.end.isEqual(_n91.end);else {
                var _e167 = t.nodeBefore,
                    _i186 = t.nodeAfter,
                    _r25 = _n91.start.parent == _e167 && _n91.start.isAtEnd,
                    _s17 = _n91.end.parent == _i186 && 0 == _n91.end.offset,
                    _a10 = _n91.end.nodeAfter == _i186,
                    _c4 = _n91.start.nodeAfter == _i186;

                _o51 = _r25 || _s17 || _a10 || _c4;
              }
              _o51 && this.updateMarker(_i185.name, {
                range: _n91
              });
            }
          } catch (err) {
            _didIteratorError241 = true;
            _iteratorError241 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion241 && _iterator241.return != null) {
                _iterator241.return();
              }
            } finally {
              if (_didIteratorError241) {
                throw _iteratorError241;
              }
            }
          }
        }
      }]);

      return Lc;
    }();

    function Vc(e, t, i, n) {
      var o = e.model,
          r = o.document;
      var s,
          a,
          c,
          l = n.start;
      var _iteratorNormalCompletion242 = true;
      var _didIteratorError242 = false;
      var _iteratorError242 = undefined;

      try {
        for (var _iterator242 = n.getWalker({
          shallow: !0
        })[Symbol.iterator](), _step242; !(_iteratorNormalCompletion242 = (_step242 = _iterator242.next()).done); _iteratorNormalCompletion242 = true) {
          var _e168 = _step242.value;
          c = _e168.item.getAttribute(t), s && a != c && (a != i && d(), l = s), s = _e168.nextPosition, a = c;
        }
      } catch (err) {
        _didIteratorError242 = true;
        _iteratorError242 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion242 && _iterator242.return != null) {
            _iterator242.return();
          }
        } finally {
          if (_didIteratorError242) {
            throw _iteratorError242;
          }
        }
      }

      function d() {
        var n = new sa(l, s),
            c = n.root.document ? r.version : null,
            d = new Ec(n, t, a, i, c);
        e.batch.addOperation(d), o.applyOperation(d);
      }

      s instanceof ia && s != l && a != i && d();
    }

    function jc(e, t, i, n) {
      var o = e.model,
          r = o.document,
          s = n.getAttribute(t);
      var a, c;

      if (s != i) {
        if (n.root === n) {
          var _e169 = n.document ? r.version : null;

          c = new Rc(n, t, s, i, _e169);
        } else {
          a = new sa(ia._createBefore(n), e.createPositionAfter(n));

          var _o52 = a.root.document ? r.version : null;

          c = new Ec(a, t, s, i, _o52);
        }

        e.batch.addOperation(c), o.applyOperation(c);
      }
    }

    function Bc(e, t, i, n, o) {
      var r = e.model,
          s = r.document,
          a = new Mc(t, i, n, r.markers, o, s.version);
      e.batch.addOperation(a), r.applyOperation(a);
    }

    function Fc(e, t, i, n) {
      var o;

      if (e.root.document) {
        var _i187 = n.document,
            _r26 = new ia(_i187.graveyard, [0]);

        o = new Ic(e, t, _r26, _i187.version);
      } else o = new Sc(e, t);

      i.addOperation(o), n.applyOperation(o);
    }

    function Hc(e, t) {
      return e === t || e instanceof Dc && t instanceof Dc;
    }

    var Uc =
    /*#__PURE__*/
    function () {
      function Uc(e) {
        _classCallCheck(this, Uc);

        this._markerCollection = e, this._changesInElement = new Map(), this._elementSnapshots = new Map(), this._changedMarkers = new Map(), this._changeCount = 0, this._cachedChanges = null, this._cachedChangesWithGraveyard = null;
      }

      _createClass(Uc, [{
        key: "refreshItem",
        value: function refreshItem(e) {
          if (this._isInInsertedElement(e.parent)) return;
          this._markRemove(e.parent, e.startOffset, e.offsetSize), this._markInsert(e.parent, e.startOffset, e.offsetSize);

          var t = sa._createOn(e);

          var _iteratorNormalCompletion243 = true;
          var _didIteratorError243 = false;
          var _iteratorError243 = undefined;

          try {
            for (var _iterator243 = this._markerCollection.getMarkersIntersectingRange(t)[Symbol.iterator](), _step243; !(_iteratorNormalCompletion243 = (_step243 = _iterator243.next()).done); _iteratorNormalCompletion243 = true) {
              var _e170 = _step243.value;

              var _t164 = _e170.getRange();

              this.bufferMarkerChange(_e170.name, _t164, _t164, _e170.affectsData);
            }
          } catch (err) {
            _didIteratorError243 = true;
            _iteratorError243 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion243 && _iterator243.return != null) {
                _iterator243.return();
              }
            } finally {
              if (_didIteratorError243) {
                throw _iteratorError243;
              }
            }
          }

          this._cachedChanges = null;
        }
      }, {
        key: "bufferOperation",
        value: function bufferOperation(e) {
          switch (e.type) {
            case "insert":
              if (this._isInInsertedElement(e.position.parent)) return;

              this._markInsert(e.position.parent, e.position.offset, e.nodes.maxOffset);

              break;

            case "addAttribute":
            case "removeAttribute":
            case "changeAttribute":
              var _iteratorNormalCompletion244 = true;
              var _didIteratorError244 = false;
              var _iteratorError244 = undefined;

              try {
                for (var _iterator244 = e.range.getItems({
                  shallow: !0
                })[Symbol.iterator](), _step244; !(_iteratorNormalCompletion244 = (_step244 = _iterator244.next()).done); _iteratorNormalCompletion244 = true) {
                  var _t165 = _step244.value;
                  this._isInInsertedElement(_t165.parent) || this._markAttribute(_t165);
                }
              } catch (err) {
                _didIteratorError244 = true;
                _iteratorError244 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion244 && _iterator244.return != null) {
                    _iterator244.return();
                  }
                } finally {
                  if (_didIteratorError244) {
                    throw _iteratorError244;
                  }
                }
              }

              break;

            case "remove":
            case "move":
            case "reinsert":
              {
                if (e.sourcePosition.isEqual(e.targetPosition) || e.sourcePosition.getShiftedBy(e.howMany).isEqual(e.targetPosition)) return;

                var _t166 = this._isInInsertedElement(e.sourcePosition.parent),
                    _i188 = this._isInInsertedElement(e.targetPosition.parent);

                _t166 || this._markRemove(e.sourcePosition.parent, e.sourcePosition.offset, e.howMany), _i188 || this._markInsert(e.targetPosition.parent, e.getMovedRangeStart().offset, e.howMany);
                break;
              }

            case "rename":
              {
                if (this._isInInsertedElement(e.position.parent)) return;
                this._markRemove(e.position.parent, e.position.offset, 1), this._markInsert(e.position.parent, e.position.offset, 1);

                var _t167 = sa._createFromPositionAndShift(e.position, 1);

                var _iteratorNormalCompletion245 = true;
                var _didIteratorError245 = false;
                var _iteratorError245 = undefined;

                try {
                  for (var _iterator245 = this._markerCollection.getMarkersIntersectingRange(_t167)[Symbol.iterator](), _step245; !(_iteratorNormalCompletion245 = (_step245 = _iterator245.next()).done); _iteratorNormalCompletion245 = true) {
                    var _e171 = _step245.value;

                    var _t168 = _e171.getRange();

                    this.bufferMarkerChange(_e171.name, _t168, _t168, _e171.affectsData);
                  }
                } catch (err) {
                  _didIteratorError245 = true;
                  _iteratorError245 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion245 && _iterator245.return != null) {
                      _iterator245.return();
                    }
                  } finally {
                    if (_didIteratorError245) {
                      throw _iteratorError245;
                    }
                  }
                }

                break;
              }

            case "split":
              {
                var _t169 = e.splitPosition.parent;
                this._isInInsertedElement(_t169) || this._markRemove(_t169, e.splitPosition.offset, e.howMany), this._isInInsertedElement(e.insertionPosition.parent) || this._markInsert(e.insertionPosition.parent, e.insertionPosition.offset, 1), e.graveyardPosition && this._markRemove(e.graveyardPosition.parent, e.graveyardPosition.offset, 1);
                break;
              }

            case "merge":
              {
                var _t170 = e.sourcePosition.parent;
                this._isInInsertedElement(_t170.parent) || this._markRemove(_t170.parent, _t170.startOffset, 1);
                var _i189 = e.graveyardPosition.parent;

                this._markInsert(_i189, e.graveyardPosition.offset, 1);

                var _n92 = e.targetPosition.parent;
                this._isInInsertedElement(_n92) || this._markInsert(_n92, e.targetPosition.offset, _t170.maxOffset);
                break;
              }
          }

          this._cachedChanges = null;
        }
      }, {
        key: "bufferMarkerChange",
        value: function bufferMarkerChange(e, t, i, n) {
          var o = this._changedMarkers.get(e);

          o ? (o.newRange = i, o.affectsData = n, null == o.oldRange && null == o.newRange && this._changedMarkers.delete(e)) : this._changedMarkers.set(e, {
            oldRange: t,
            newRange: i,
            affectsData: n
          });
        }
      }, {
        key: "getMarkersToRemove",
        value: function getMarkersToRemove() {
          var e = [];
          var _iteratorNormalCompletion246 = true;
          var _didIteratorError246 = false;
          var _iteratorError246 = undefined;

          try {
            for (var _iterator246 = this._changedMarkers[Symbol.iterator](), _step246; !(_iteratorNormalCompletion246 = (_step246 = _iterator246.next()).done); _iteratorNormalCompletion246 = true) {
              var _ref88 = _step246.value;

              var _ref87 = _slicedToArray(_ref88, 2);

              var _t171 = _ref87[0];
              var _i190 = _ref87[1];
              null != _i190.oldRange && e.push({
                name: _t171,
                range: _i190.oldRange
              });
            }
          } catch (err) {
            _didIteratorError246 = true;
            _iteratorError246 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion246 && _iterator246.return != null) {
                _iterator246.return();
              }
            } finally {
              if (_didIteratorError246) {
                throw _iteratorError246;
              }
            }
          }

          return e;
        }
      }, {
        key: "getMarkersToAdd",
        value: function getMarkersToAdd() {
          var e = [];
          var _iteratorNormalCompletion247 = true;
          var _didIteratorError247 = false;
          var _iteratorError247 = undefined;

          try {
            for (var _iterator247 = this._changedMarkers[Symbol.iterator](), _step247; !(_iteratorNormalCompletion247 = (_step247 = _iterator247.next()).done); _iteratorNormalCompletion247 = true) {
              var _ref91 = _step247.value;

              var _ref90 = _slicedToArray(_ref91, 2);

              var _t172 = _ref90[0];
              var _i191 = _ref90[1];
              null != _i191.newRange && e.push({
                name: _t172,
                range: _i191.newRange
              });
            }
          } catch (err) {
            _didIteratorError247 = true;
            _iteratorError247 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion247 && _iterator247.return != null) {
                _iterator247.return();
              }
            } finally {
              if (_didIteratorError247) {
                throw _iteratorError247;
              }
            }
          }

          return e;
        }
      }, {
        key: "getChangedMarkers",
        value: function getChangedMarkers() {
          return Array.from(this._changedMarkers).map(function (e) {
            return {
              name: e[0],
              data: {
                oldRange: e[1].oldRange,
                newRange: e[1].newRange
              }
            };
          });
        }
      }, {
        key: "hasDataChanges",
        value: function hasDataChanges() {
          var _iteratorNormalCompletion248 = true;
          var _didIteratorError248 = false;
          var _iteratorError248 = undefined;

          try {
            for (var _iterator248 = this._changedMarkers[Symbol.iterator](), _step248; !(_iteratorNormalCompletion248 = (_step248 = _iterator248.next()).done); _iteratorNormalCompletion248 = true) {
              var _ref94 = _step248.value;

              var _ref93 = _slicedToArray(_ref94, 2);

              var _e172 = _ref93[1];
              if (_e172.affectsData) return !0;
            }
          } catch (err) {
            _didIteratorError248 = true;
            _iteratorError248 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion248 && _iterator248.return != null) {
                _iterator248.return();
              }
            } finally {
              if (_didIteratorError248) {
                throw _iteratorError248;
              }
            }
          }

          return this._changesInElement.size > 0;
        }
      }, {
        key: "getChanges",
        value: function getChanges() {
          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            includeChangesInGraveyard: !1
          };
          if (this._cachedChanges) return e.includeChangesInGraveyard ? this._cachedChangesWithGraveyard.slice() : this._cachedChanges.slice();
          var t = [];
          var _iteratorNormalCompletion249 = true;
          var _didIteratorError249 = false;
          var _iteratorError249 = undefined;

          try {
            for (var _iterator249 = this._changesInElement.keys()[Symbol.iterator](), _step249; !(_iteratorNormalCompletion249 = (_step249 = _iterator249.next()).done); _iteratorNormalCompletion249 = true) {
              var _e174 = _step249.value;

              var _i193 = this._changesInElement.get(_e174).sort(function (e, t) {
                return e.offset === t.offset ? e.type != t.type ? "remove" == e.type ? -1 : 1 : 0 : e.offset < t.offset ? -1 : 1;
              }),
                  _n94 = this._elementSnapshots.get(_e174),
                  _o54 = Wc(_e174.getChildren()),
                  _r28 = qc(_n94.length, _i193);

              var _s19 = 0,
                  _a12 = 0;
              var _iteratorNormalCompletion251 = true;
              var _didIteratorError251 = false;
              var _iteratorError251 = undefined;

              try {
                for (var _iterator251 = _r28[Symbol.iterator](), _step251; !(_iteratorNormalCompletion251 = (_step251 = _iterator251.next()).done); _iteratorNormalCompletion251 = true) {
                  var _i194 = _step251.value;
                  if ("i" === _i194) t.push(this._getInsertDiff(_e174, _s19, _o54[_s19].name)), _s19++;else if ("r" === _i194) t.push(this._getRemoveDiff(_e174, _s19, _n94[_a12].name)), _a12++;else if ("a" === _i194) {
                    var _t174;

                    var _i195 = _o54[_s19].attributes,
                        _r29 = _n94[_a12].attributes;

                    var _c5 = void 0;

                    if ("$text" == _o54[_s19].name) _c5 = new sa(ia._createAt(_e174, _s19), ia._createAt(_e174, _s19 + 1));else {
                      var _t173 = _e174.offsetToIndex(_s19);

                      _c5 = new sa(ia._createAt(_e174, _s19), ia._createAt(_e174.getChild(_t173), 0));
                    }
                    (_t174 = t).push.apply(_t174, _toConsumableArray(this._getAttributesDiff(_c5, _r29, _i195))), _s19++, _a12++;
                  } else _s19++, _a12++;
                }
              } catch (err) {
                _didIteratorError251 = true;
                _iteratorError251 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion251 && _iterator251.return != null) {
                    _iterator251.return();
                  }
                } finally {
                  if (_didIteratorError251) {
                    throw _iteratorError251;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError249 = true;
            _iteratorError249 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion249 && _iterator249.return != null) {
                _iterator249.return();
              }
            } finally {
              if (_didIteratorError249) {
                throw _iteratorError249;
              }
            }
          }

          t.sort(function (e, t) {
            return e.position.root != t.position.root ? e.position.root.rootName < t.position.root.rootName ? -1 : 1 : e.position.isEqual(t.position) ? e.changeCount - t.changeCount : e.position.isBefore(t.position) ? -1 : 1;
          });

          for (var _e173 = 1, _i192 = 0; _e173 < t.length; _e173++) {
            var _n93 = t[_i192],
                _o53 = t[_e173],
                _r27 = "remove" == _n93.type && "remove" == _o53.type && "$text" == _n93.name && "$text" == _o53.name && _n93.position.isEqual(_o53.position),
                _s18 = "insert" == _n93.type && "insert" == _o53.type && "$text" == _n93.name && "$text" == _o53.name && _n93.position.parent == _o53.position.parent && _n93.position.offset + _n93.length == _o53.position.offset,
                _a11 = "attribute" == _n93.type && "attribute" == _o53.type && _n93.position.parent == _o53.position.parent && _n93.range.isFlat && _o53.range.isFlat && _n93.position.offset + _n93.length == _o53.position.offset && _n93.attributeKey == _o53.attributeKey && _n93.attributeOldValue == _o53.attributeOldValue && _n93.attributeNewValue == _o53.attributeNewValue;

            _r27 || _s18 || _a11 ? (_n93.length++, _a11 && (_n93.range.end = _n93.range.end.getShiftedBy(1)), t[_e173] = null) : _i192 = _e173;
          }

          t = t.filter(function (e) {
            return e;
          });
          var _iteratorNormalCompletion250 = true;
          var _didIteratorError250 = false;
          var _iteratorError250 = undefined;

          try {
            for (var _iterator250 = t[Symbol.iterator](), _step250; !(_iteratorNormalCompletion250 = (_step250 = _iterator250.next()).done); _iteratorNormalCompletion250 = true) {
              var _e175 = _step250.value;
              delete _e175.changeCount, "attribute" == _e175.type && (delete _e175.position, delete _e175.length);
            }
          } catch (err) {
            _didIteratorError250 = true;
            _iteratorError250 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion250 && _iterator250.return != null) {
                _iterator250.return();
              }
            } finally {
              if (_didIteratorError250) {
                throw _iteratorError250;
              }
            }
          }

          return this._changeCount = 0, this._cachedChangesWithGraveyard = t.slice(), this._cachedChanges = t.filter($c), e.includeChangesInGraveyard ? this._cachedChangesWithGraveyard : this._cachedChanges;
        }
      }, {
        key: "reset",
        value: function reset() {
          this._changesInElement.clear(), this._elementSnapshots.clear(), this._changedMarkers.clear(), this._cachedChanges = null;
        }
      }, {
        key: "_markInsert",
        value: function _markInsert(e, t, i) {
          var n = {
            type: "insert",
            offset: t,
            howMany: i,
            count: this._changeCount++
          };

          this._markChange(e, n);
        }
      }, {
        key: "_markRemove",
        value: function _markRemove(e, t, i) {
          var n = {
            type: "remove",
            offset: t,
            howMany: i,
            count: this._changeCount++
          };
          this._markChange(e, n), this._removeAllNestedChanges(e, t, i);
        }
      }, {
        key: "_markAttribute",
        value: function _markAttribute(e) {
          var t = {
            type: "attribute",
            offset: e.startOffset,
            howMany: e.offsetSize,
            count: this._changeCount++
          };

          this._markChange(e.parent, t);
        }
      }, {
        key: "_markChange",
        value: function _markChange(e, t) {
          this._makeSnapshot(e);

          var i = this._getChangesForElement(e);

          this._handleChange(t, i), i.push(t);

          for (var _e176 = 0; _e176 < i.length; _e176++) {
            i[_e176].howMany < 1 && (i.splice(_e176, 1), _e176--);
          }
        }
      }, {
        key: "_getChangesForElement",
        value: function _getChangesForElement(e) {
          var t;
          return this._changesInElement.has(e) ? t = this._changesInElement.get(e) : (t = [], this._changesInElement.set(e, t)), t;
        }
      }, {
        key: "_makeSnapshot",
        value: function _makeSnapshot(e) {
          this._elementSnapshots.has(e) || this._elementSnapshots.set(e, Wc(e.getChildren()));
        }
      }, {
        key: "_handleChange",
        value: function _handleChange(e, t) {
          e.nodesToHandle = e.howMany;
          var _iteratorNormalCompletion252 = true;
          var _didIteratorError252 = false;
          var _iteratorError252 = undefined;

          try {
            for (var _iterator252 = t[Symbol.iterator](), _step252; !(_iteratorNormalCompletion252 = (_step252 = _iterator252.next()).done); _iteratorNormalCompletion252 = true) {
              var _i196 = _step252.value;

              var _n95 = e.offset + e.howMany,
                  _o55 = _i196.offset + _i196.howMany;

              if ("insert" == e.type && ("insert" == _i196.type && (e.offset <= _i196.offset ? _i196.offset += e.howMany : e.offset < _o55 && (_i196.howMany += e.nodesToHandle, e.nodesToHandle = 0)), "remove" == _i196.type && e.offset < _i196.offset && (_i196.offset += e.howMany), "attribute" == _i196.type)) if (e.offset <= _i196.offset) _i196.offset += e.howMany;else if (e.offset < _o55) {
                var _o56 = _i196.howMany;
                _i196.howMany = e.offset - _i196.offset, t.unshift({
                  type: "attribute",
                  offset: _n95,
                  howMany: _o56 - _i196.howMany,
                  count: this._changeCount++
                });
              }

              if ("remove" == e.type) {
                if ("insert" == _i196.type) if (_n95 <= _i196.offset) _i196.offset -= e.howMany;else if (_n95 <= _o55) {
                  if (e.offset < _i196.offset) {
                    var _t175 = _n95 - _i196.offset;

                    _i196.offset = e.offset, _i196.howMany -= _t175, e.nodesToHandle -= _t175;
                  } else _i196.howMany -= e.nodesToHandle, e.nodesToHandle = 0;
                } else if (e.offset <= _i196.offset) e.nodesToHandle -= _i196.howMany, _i196.howMany = 0;else if (e.offset < _o55) {
                  var _t176 = _o55 - e.offset;

                  _i196.howMany -= _t176, e.nodesToHandle -= _t176;
                }
                if ("remove" == _i196.type && (_n95 <= _i196.offset ? _i196.offset -= e.howMany : e.offset < _i196.offset && (e.nodesToHandle += _i196.howMany, _i196.howMany = 0)), "attribute" == _i196.type) if (_n95 <= _i196.offset) _i196.offset -= e.howMany;else if (e.offset < _i196.offset) {
                  var _t177 = _n95 - _i196.offset;

                  _i196.offset = e.offset, _i196.howMany -= _t177;
                } else if (e.offset < _o55) if (_n95 <= _o55) {
                  var _n96 = _i196.howMany;
                  _i196.howMany = e.offset - _i196.offset;

                  var _o57 = _n96 - _i196.howMany - e.nodesToHandle;

                  t.unshift({
                    type: "attribute",
                    offset: e.offset,
                    howMany: _o57,
                    count: this._changeCount++
                  });
                } else _i196.howMany -= _o55 - e.offset;
              }

              if ("attribute" == e.type) {
                if ("insert" == _i196.type) if (e.offset < _i196.offset && _n95 > _i196.offset) {
                  if (_n95 > _o55) {
                    var _e177 = {
                      type: "attribute",
                      offset: _o55,
                      howMany: _n95 - _o55,
                      count: this._changeCount++
                    };
                    this._handleChange(_e177, t), t.push(_e177);
                  }

                  e.nodesToHandle = _i196.offset - e.offset, e.howMany = e.nodesToHandle;
                } else e.offset >= _i196.offset && e.offset < _o55 && (_n95 > _o55 ? (e.nodesToHandle = _n95 - _o55, e.offset = _o55) : e.nodesToHandle = 0);

                if ("remove" == _i196.type && e.offset < _i196.offset && _n95 > _i196.offset) {
                  var _o58 = {
                    type: "attribute",
                    offset: _i196.offset,
                    howMany: _n95 - _i196.offset,
                    count: this._changeCount++
                  };
                  this._handleChange(_o58, t), t.push(_o58), e.nodesToHandle = _i196.offset - e.offset, e.howMany = e.nodesToHandle;
                }

                "attribute" == _i196.type && (e.offset >= _i196.offset && _n95 <= _o55 ? (e.nodesToHandle = 0, e.howMany = 0, e.offset = 0) : e.offset <= _i196.offset && _n95 >= _o55 && (_i196.howMany = 0));
              }
            }
          } catch (err) {
            _didIteratorError252 = true;
            _iteratorError252 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion252 && _iterator252.return != null) {
                _iterator252.return();
              }
            } finally {
              if (_didIteratorError252) {
                throw _iteratorError252;
              }
            }
          }

          e.howMany = e.nodesToHandle, delete e.nodesToHandle;
        }
      }, {
        key: "_getInsertDiff",
        value: function _getInsertDiff(e, t, i) {
          return {
            type: "insert",
            position: ia._createAt(e, t),
            name: i,
            length: 1,
            changeCount: this._changeCount++
          };
        }
      }, {
        key: "_getRemoveDiff",
        value: function _getRemoveDiff(e, t, i) {
          return {
            type: "remove",
            position: ia._createAt(e, t),
            name: i,
            length: 1,
            changeCount: this._changeCount++
          };
        }
      }, {
        key: "_getAttributesDiff",
        value: function _getAttributesDiff(e, t, i) {
          var n = [];
          i = new Map(i);
          var _iteratorNormalCompletion253 = true;
          var _didIteratorError253 = false;
          var _iteratorError253 = undefined;

          try {
            for (var _iterator253 = t[Symbol.iterator](), _step253; !(_iteratorNormalCompletion253 = (_step253 = _iterator253.next()).done); _iteratorNormalCompletion253 = true) {
              var _ref99 = _step253.value;

              var _ref96 = _slicedToArray(_ref99, 2);

              var _o59 = _ref96[0];
              var _r30 = _ref96[1];

              var _t178 = i.has(_o59) ? i.get(_o59) : null;

              _t178 !== _r30 && n.push({
                type: "attribute",
                position: e.start,
                range: e.clone(),
                length: 1,
                attributeKey: _o59,
                attributeOldValue: _r30,
                attributeNewValue: _t178,
                changeCount: this._changeCount++
              }), i.delete(_o59);
            }
          } catch (err) {
            _didIteratorError253 = true;
            _iteratorError253 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion253 && _iterator253.return != null) {
                _iterator253.return();
              }
            } finally {
              if (_didIteratorError253) {
                throw _iteratorError253;
              }
            }
          }

          var _iteratorNormalCompletion254 = true;
          var _didIteratorError254 = false;
          var _iteratorError254 = undefined;

          try {
            for (var _iterator254 = i[Symbol.iterator](), _step254; !(_iteratorNormalCompletion254 = (_step254 = _iterator254.next()).done); _iteratorNormalCompletion254 = true) {
              var _ref100 = _step254.value;

              var _ref98 = _slicedToArray(_ref100, 2);

              var _t179 = _ref98[0];
              var _o60 = _ref98[1];
              n.push({
                type: "attribute",
                position: e.start,
                range: e.clone(),
                length: 1,
                attributeKey: _t179,
                attributeOldValue: null,
                attributeNewValue: _o60,
                changeCount: this._changeCount++
              });
            }
          } catch (err) {
            _didIteratorError254 = true;
            _iteratorError254 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion254 && _iterator254.return != null) {
                _iterator254.return();
              }
            } finally {
              if (_didIteratorError254) {
                throw _iteratorError254;
              }
            }
          }

          return n;
        }
      }, {
        key: "_isInInsertedElement",
        value: function _isInInsertedElement(e) {
          var t = e.parent;
          if (!t) return !1;

          var i = this._changesInElement.get(t),
              n = e.startOffset;

          if (i) {
            var _iteratorNormalCompletion255 = true;
            var _didIteratorError255 = false;
            var _iteratorError255 = undefined;

            try {
              for (var _iterator255 = i[Symbol.iterator](), _step255; !(_iteratorNormalCompletion255 = (_step255 = _iterator255.next()).done); _iteratorNormalCompletion255 = true) {
                var _e178 = _step255.value;
                if ("insert" == _e178.type && n >= _e178.offset && n < _e178.offset + _e178.howMany) return !0;
              }
            } catch (err) {
              _didIteratorError255 = true;
              _iteratorError255 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion255 && _iterator255.return != null) {
                  _iterator255.return();
                }
              } finally {
                if (_didIteratorError255) {
                  throw _iteratorError255;
                }
              }
            }
          }

          return this._isInInsertedElement(t);
        }
      }, {
        key: "_removeAllNestedChanges",
        value: function _removeAllNestedChanges(e, t, i) {
          var n = new sa(ia._createAt(e, t), ia._createAt(e, t + i));
          var _iteratorNormalCompletion256 = true;
          var _didIteratorError256 = false;
          var _iteratorError256 = undefined;

          try {
            for (var _iterator256 = n.getItems({
              shallow: !0
            })[Symbol.iterator](), _step256; !(_iteratorNormalCompletion256 = (_step256 = _iterator256.next()).done); _iteratorNormalCompletion256 = true) {
              var _e179 = _step256.value;
              _e179.is("element") && (this._elementSnapshots.delete(_e179), this._changesInElement.delete(_e179), this._removeAllNestedChanges(_e179, 0, _e179.maxOffset));
            }
          } catch (err) {
            _didIteratorError256 = true;
            _iteratorError256 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion256 && _iterator256.return != null) {
                _iterator256.return();
              }
            } finally {
              if (_didIteratorError256) {
                throw _iteratorError256;
              }
            }
          }
        }
      }, {
        key: "isEmpty",
        get: function get() {
          return 0 == this._changesInElement.size && 0 == this._changedMarkers.size;
        }
      }]);

      return Uc;
    }();

    function Wc(e) {
      var t = [];
      var _iteratorNormalCompletion257 = true;
      var _didIteratorError257 = false;
      var _iteratorError257 = undefined;

      try {
        for (var _iterator257 = e[Symbol.iterator](), _step257; !(_iteratorNormalCompletion257 = (_step257 = _iterator257.next()).done); _iteratorNormalCompletion257 = true) {
          var _i197 = _step257.value;
          if (_i197.is("$text")) for (var _e180 = 0; _e180 < _i197.data.length; _e180++) {
            t.push({
              name: "$text",
              attributes: new Map(_i197.getAttributes())
            });
          } else t.push({
            name: _i197.name,
            attributes: new Map(_i197.getAttributes())
          });
        }
      } catch (err) {
        _didIteratorError257 = true;
        _iteratorError257 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion257 && _iterator257.return != null) {
            _iterator257.return();
          }
        } finally {
          if (_didIteratorError257) {
            throw _iteratorError257;
          }
        }
      }

      return t;
    }

    function qc(e, t) {
      var i = [];
      var n = 0,
          o = 0;
      var _iteratorNormalCompletion258 = true;
      var _didIteratorError258 = false;
      var _iteratorError258 = undefined;

      try {
        for (var _iterator258 = t[Symbol.iterator](), _step258; !(_iteratorNormalCompletion258 = (_step258 = _iterator258.next()).done); _iteratorNormalCompletion258 = true) {
          var _e181 = _step258.value;

          if (_e181.offset > n) {
            for (var _t181 = 0; _t181 < _e181.offset - n; _t181++) {
              i.push("e");
            }

            o += _e181.offset - n;
          }

          if ("insert" == _e181.type) {
            for (var _t182 = 0; _t182 < _e181.howMany; _t182++) {
              i.push("i");
            }

            n = _e181.offset + _e181.howMany;
          } else if ("remove" == _e181.type) {
            for (var _t183 = 0; _t183 < _e181.howMany; _t183++) {
              i.push("r");
            }

            n = _e181.offset, o += _e181.howMany;
          } else i.push.apply(i, _toConsumableArray("a".repeat(_e181.howMany).split(""))), n = _e181.offset + _e181.howMany, o += _e181.howMany;
        }
      } catch (err) {
        _didIteratorError258 = true;
        _iteratorError258 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion258 && _iterator258.return != null) {
            _iterator258.return();
          }
        } finally {
          if (_didIteratorError258) {
            throw _iteratorError258;
          }
        }
      }

      if (o < e) for (var _t180 = 0; _t180 < e - o - n; _t180++) {
        i.push("e");
      }
      return i;
    }

    function $c(e) {
      var t = e.position && "$graveyard" == e.position.root.rootName,
          i = e.range && "$graveyard" == e.range.root.rootName;
      return !t && !i;
    }

    var Yc =
    /*#__PURE__*/
    function () {
      function Yc() {
        _classCallCheck(this, Yc);

        this._operations = [], this._undoPairs = new Map(), this._undoneOperations = new Set();
      }

      _createClass(Yc, [{
        key: "addOperation",
        value: function addOperation(e) {
          this._operations.includes(e) || this._operations.push(e);
        }
      }, {
        key: "getOperations",
        value: function getOperations() {
          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Number.NEGATIVE_INFINITY;
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.POSITIVE_INFINITY;
          var i = [];
          var _iteratorNormalCompletion259 = true;
          var _didIteratorError259 = false;
          var _iteratorError259 = undefined;

          try {
            for (var _iterator259 = this._operations[Symbol.iterator](), _step259; !(_iteratorNormalCompletion259 = (_step259 = _iterator259.next()).done); _iteratorNormalCompletion259 = true) {
              var _n97 = _step259.value;
              _n97.baseVersion >= e && _n97.baseVersion < t && i.push(_n97);
            }
          } catch (err) {
            _didIteratorError259 = true;
            _iteratorError259 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion259 && _iterator259.return != null) {
                _iterator259.return();
              }
            } finally {
              if (_didIteratorError259) {
                throw _iteratorError259;
              }
            }
          }

          return i;
        }
      }, {
        key: "getOperation",
        value: function getOperation(e) {
          var _iteratorNormalCompletion260 = true;
          var _didIteratorError260 = false;
          var _iteratorError260 = undefined;

          try {
            for (var _iterator260 = this._operations[Symbol.iterator](), _step260; !(_iteratorNormalCompletion260 = (_step260 = _iterator260.next()).done); _iteratorNormalCompletion260 = true) {
              var _t184 = _step260.value;
              if (_t184.baseVersion == e) return _t184;
            }
          } catch (err) {
            _didIteratorError260 = true;
            _iteratorError260 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion260 && _iterator260.return != null) {
                _iterator260.return();
              }
            } finally {
              if (_didIteratorError260) {
                throw _iteratorError260;
              }
            }
          }
        }
      }, {
        key: "setOperationAsUndone",
        value: function setOperationAsUndone(e, t) {
          this._undoPairs.set(t, e), this._undoneOperations.add(e);
        }
      }, {
        key: "isUndoingOperation",
        value: function isUndoingOperation(e) {
          return this._undoPairs.has(e);
        }
      }, {
        key: "isUndoneOperation",
        value: function isUndoneOperation(e) {
          return this._undoneOperations.has(e);
        }
      }, {
        key: "getUndoneOperation",
        value: function getUndoneOperation(e) {
          return this._undoPairs.get(e);
        }
      }]);

      return Yc;
    }();

    function Gc(e, t) {
      return !!(i = e.charAt(t - 1)) && 1 == i.length && /[\ud800-\udbff]/.test(i) && function (e) {
        return !!e && 1 == e.length && /[\udc00-\udfff]/.test(e);
      }(e.charAt(t));
      var i;
    }

    function Kc(e, t) {
      return !!(i = e.charAt(t)) && 1 == i.length && /[\u0300-\u036f\u1ab0-\u1aff\u1dc0-\u1dff\u20d0-\u20ff\ufe20-\ufe2f]/.test(i);
      var i;
    }

    var Qc =
    /*#__PURE__*/
    function () {
      function Qc(e) {
        var _this75 = this;

        _classCallCheck(this, Qc);

        this.model = e, this.version = 0, this.history = new Yc(this), this.selection = new ya(this), this.roots = new Zi({
          idProperty: "rootName"
        }), this.differ = new Uc(e.markers), this._postFixers = new Set(), this._hasSelectionChangedFromTheLastChangeBlock = !1, this.createRoot("$root", "$graveyard"), this.listenTo(e, "applyOperation", function (e, t) {
          var i = t[0];
          if (i.isDocumentOperation && i.baseVersion !== _this75.version) throw new c.a("model-document-applyoperation-wrong-version", _this75, {
            operation: i
          });
        }, {
          priority: "highest"
        }), this.listenTo(e, "applyOperation", function (e, t) {
          var i = t[0];
          i.isDocumentOperation && _this75.differ.bufferOperation(i);
        }, {
          priority: "high"
        }), this.listenTo(e, "applyOperation", function (e, t) {
          var i = t[0];
          i.isDocumentOperation && (_this75.version++, _this75.history.addOperation(i));
        }, {
          priority: "low"
        }), this.listenTo(this.selection, "change", function () {
          _this75._hasSelectionChangedFromTheLastChangeBlock = !0;
        }), this.listenTo(e.markers, "update", function (e, t, i, n) {
          _this75.differ.bufferMarkerChange(t.name, i, n, t.affectsData), null === i && t.on("change", function (e, i) {
            _this75.differ.bufferMarkerChange(t.name, i, t.getRange(), t.affectsData);
          });
        });
      }

      _createClass(Qc, [{
        key: "createRoot",
        value: function createRoot() {
          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "$root";
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "main";
          if (this.roots.get(t)) throw new c.a("model-document-createroot-name-exists", this, {
            name: t
          });
          var i = new Dc(this, e, t);
          return this.roots.add(i), i;
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.selection.destroy(), this.stopListening();
        }
      }, {
        key: "getRoot",
        value: function getRoot() {
          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "main";
          return this.roots.get(e);
        }
      }, {
        key: "getRootNames",
        value: function getRootNames() {
          return Array.from(this.roots, function (e) {
            return e.rootName;
          }).filter(function (e) {
            return "$graveyard" != e;
          });
        }
      }, {
        key: "registerPostFixer",
        value: function registerPostFixer(e) {
          this._postFixers.add(e);
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var e = ln(this);
          return e.selection = "[engine.model.DocumentSelection]", e.model = "[engine.model.Model]", e;
        }
      }, {
        key: "_handleChangeBlock",
        value: function _handleChangeBlock(e) {
          this._hasDocumentChangedFromTheLastChangeBlock() && (this._callPostFixers(e), this.selection.refresh(), this.differ.hasDataChanges() ? this.fire("change:data", e.batch) : this.fire("change", e.batch), this.selection.refresh(), this.differ.reset()), this._hasSelectionChangedFromTheLastChangeBlock = !1;
        }
      }, {
        key: "_hasDocumentChangedFromTheLastChangeBlock",
        value: function _hasDocumentChangedFromTheLastChangeBlock() {
          return !this.differ.isEmpty || this._hasSelectionChangedFromTheLastChangeBlock;
        }
      }, {
        key: "_getDefaultRoot",
        value: function _getDefaultRoot() {
          var _iteratorNormalCompletion261 = true;
          var _didIteratorError261 = false;
          var _iteratorError261 = undefined;

          try {
            for (var _iterator261 = this.roots[Symbol.iterator](), _step261; !(_iteratorNormalCompletion261 = (_step261 = _iterator261.next()).done); _iteratorNormalCompletion261 = true) {
              var _e182 = _step261.value;
              if (_e182 !== this.graveyard) return _e182;
            }
          } catch (err) {
            _didIteratorError261 = true;
            _iteratorError261 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion261 && _iterator261.return != null) {
                _iterator261.return();
              }
            } finally {
              if (_didIteratorError261) {
                throw _iteratorError261;
              }
            }
          }

          return this.graveyard;
        }
      }, {
        key: "_getDefaultRange",
        value: function _getDefaultRange() {
          var e = this._getDefaultRoot(),
              t = this.model,
              i = t.schema,
              n = t.createPositionFromPath(e, [0]);

          return i.getNearestSelectionRange(n) || t.createRange(n);
        }
      }, {
        key: "_validateSelectionRange",
        value: function _validateSelectionRange(e) {
          return Jc(e.start) && Jc(e.end);
        }
      }, {
        key: "_callPostFixers",
        value: function _callPostFixers(e) {
          var t = !1;

          do {
            var _iteratorNormalCompletion262 = true;
            var _didIteratorError262 = false;
            var _iteratorError262 = undefined;

            try {
              for (var _iterator262 = this._postFixers[Symbol.iterator](), _step262; !(_iteratorNormalCompletion262 = (_step262 = _iterator262.next()).done); _iteratorNormalCompletion262 = true) {
                var _i198 = _step262.value;
                if (this.selection.refresh(), t = _i198(e), t) break;
              }
            } catch (err) {
              _didIteratorError262 = true;
              _iteratorError262 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion262 && _iterator262.return != null) {
                  _iterator262.return();
                }
              } finally {
                if (_didIteratorError262) {
                  throw _iteratorError262;
                }
              }
            }
          } while (t);
        }
      }, {
        key: "graveyard",
        get: function get() {
          return this.getRoot("$graveyard");
        }
      }]);

      return Qc;
    }();

    function Jc(e) {
      var t = e.textNode;

      if (t) {
        var _i199 = t.data,
            _n98 = e.offset - t.startOffset;

        return !Gc(_i199, _n98) && !Kc(_i199, _n98);
      }

      return !0;
    }

    Ke(Qc, h);

    var Zc =
    /*#__PURE__*/
    function () {
      function Zc() {
        _classCallCheck(this, Zc);

        this._markers = new Map();
      }

      _createClass(Zc, [{
        key: Symbol.iterator,
        value: function value() {
          return this._markers.values();
        }
      }, {
        key: "has",
        value: function has(e) {
          return this._markers.has(e);
        }
      }, {
        key: "get",
        value: function get(e) {
          return this._markers.get(e) || null;
        }
      }, {
        key: "_set",
        value: function _set(e, t) {
          var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
          var n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
          var o = e instanceof Xc ? e.name : e;
          if (o.includes(",")) throw new c.a("markercollection-incorrect-marker-name", this);

          var r = this._markers.get(o);

          if (r) {
            var _e183 = r.getRange();

            var _s20 = !1;

            return _e183.isEqual(t) || (r._attachLiveRange(ka.fromRange(t)), _s20 = !0), i != r.managedUsingOperations && (r._managedUsingOperations = i, _s20 = !0), "boolean" == typeof n && n != r.affectsData && (r._affectsData = n, _s20 = !0), _s20 && this.fire("update:" + o, r, _e183, t), r;
          }

          var s = ka.fromRange(t),
              a = new Xc(o, s, i, n);
          return this._markers.set(o, a), this.fire("update:" + o, a, null, t), a;
        }
      }, {
        key: "_remove",
        value: function _remove(e) {
          var t = e instanceof Xc ? e.name : e,
              i = this._markers.get(t);

          return !!i && (this._markers.delete(t), this.fire("update:" + t, i, i.getRange(), null), this._destroyMarker(i), !0);
        }
      }, {
        key: "_refresh",
        value: function _refresh(e) {
          var t = e instanceof Xc ? e.name : e,
              i = this._markers.get(t);

          if (!i) throw new c.a("markercollection-refresh-marker-not-exists", this);
          var n = i.getRange();
          this.fire("update:" + t, i, n, n, i.managedUsingOperations, i.affectsData);
        }
      }, {
        key: "getMarkersAtPosition",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function getMarkersAtPosition(e) {
          var _iteratorNormalCompletion263, _didIteratorError263, _iteratorError263, _iterator263, _step263, _t185;

          return _regeneratorRuntime.wrap(function getMarkersAtPosition$(_context31) {
            while (1) {
              switch (_context31.prev = _context31.next) {
                case 0:
                  _iteratorNormalCompletion263 = true;
                  _didIteratorError263 = false;
                  _iteratorError263 = undefined;
                  _context31.prev = 3;
                  _iterator263 = this[Symbol.iterator]();

                case 5:
                  if (_iteratorNormalCompletion263 = (_step263 = _iterator263.next()).done) {
                    _context31.next = 14;
                    break;
                  }

                  _t185 = _step263.value;
                  _context31.t0 = _t185.getRange().containsPosition(e);

                  if (!_context31.t0) {
                    _context31.next = 11;
                    break;
                  }

                  _context31.next = 11;
                  return _t185;

                case 11:
                  _iteratorNormalCompletion263 = true;
                  _context31.next = 5;
                  break;

                case 14:
                  _context31.next = 20;
                  break;

                case 16:
                  _context31.prev = 16;
                  _context31.t1 = _context31["catch"](3);
                  _didIteratorError263 = true;
                  _iteratorError263 = _context31.t1;

                case 20:
                  _context31.prev = 20;
                  _context31.prev = 21;

                  if (!_iteratorNormalCompletion263 && _iterator263.return != null) {
                    _iterator263.return();
                  }

                case 23:
                  _context31.prev = 23;

                  if (!_didIteratorError263) {
                    _context31.next = 26;
                    break;
                  }

                  throw _iteratorError263;

                case 26:
                  return _context31.finish(23);

                case 27:
                  return _context31.finish(20);

                case 28:
                case "end":
                  return _context31.stop();
              }
            }
          }, getMarkersAtPosition, this, [[3, 16, 20, 28], [21,, 23, 27]]);
        })
      }, {
        key: "getMarkersIntersectingRange",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function getMarkersIntersectingRange(e) {
          var _iteratorNormalCompletion264, _didIteratorError264, _iteratorError264, _iterator264, _step264, _t186;

          return _regeneratorRuntime.wrap(function getMarkersIntersectingRange$(_context32) {
            while (1) {
              switch (_context32.prev = _context32.next) {
                case 0:
                  _iteratorNormalCompletion264 = true;
                  _didIteratorError264 = false;
                  _iteratorError264 = undefined;
                  _context32.prev = 3;
                  _iterator264 = this[Symbol.iterator]();

                case 5:
                  if (_iteratorNormalCompletion264 = (_step264 = _iterator264.next()).done) {
                    _context32.next = 14;
                    break;
                  }

                  _t186 = _step264.value;
                  _context32.t0 = null !== _t186.getRange().getIntersection(e);

                  if (!_context32.t0) {
                    _context32.next = 11;
                    break;
                  }

                  _context32.next = 11;
                  return _t186;

                case 11:
                  _iteratorNormalCompletion264 = true;
                  _context32.next = 5;
                  break;

                case 14:
                  _context32.next = 20;
                  break;

                case 16:
                  _context32.prev = 16;
                  _context32.t1 = _context32["catch"](3);
                  _didIteratorError264 = true;
                  _iteratorError264 = _context32.t1;

                case 20:
                  _context32.prev = 20;
                  _context32.prev = 21;

                  if (!_iteratorNormalCompletion264 && _iterator264.return != null) {
                    _iterator264.return();
                  }

                case 23:
                  _context32.prev = 23;

                  if (!_didIteratorError264) {
                    _context32.next = 26;
                    break;
                  }

                  throw _iteratorError264;

                case 26:
                  return _context32.finish(23);

                case 27:
                  return _context32.finish(20);

                case 28:
                case "end":
                  return _context32.stop();
              }
            }
          }, getMarkersIntersectingRange, this, [[3, 16, 20, 28], [21,, 23, 27]]);
        })
      }, {
        key: "destroy",
        value: function destroy() {
          var _iteratorNormalCompletion265 = true;
          var _didIteratorError265 = false;
          var _iteratorError265 = undefined;

          try {
            for (var _iterator265 = this._markers.values()[Symbol.iterator](), _step265; !(_iteratorNormalCompletion265 = (_step265 = _iterator265.next()).done); _iteratorNormalCompletion265 = true) {
              var _e184 = _step265.value;

              this._destroyMarker(_e184);
            }
          } catch (err) {
            _didIteratorError265 = true;
            _iteratorError265 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion265 && _iterator265.return != null) {
                _iterator265.return();
              }
            } finally {
              if (_didIteratorError265) {
                throw _iteratorError265;
              }
            }
          }

          this._markers = null, this.stopListening();
        }
      }, {
        key: "getMarkersGroup",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function getMarkersGroup(e) {
          var _iteratorNormalCompletion266, _didIteratorError266, _iteratorError266, _iterator266, _step266, _t187;

          return _regeneratorRuntime.wrap(function getMarkersGroup$(_context33) {
            while (1) {
              switch (_context33.prev = _context33.next) {
                case 0:
                  _iteratorNormalCompletion266 = true;
                  _didIteratorError266 = false;
                  _iteratorError266 = undefined;
                  _context33.prev = 3;
                  _iterator266 = this._markers.values()[Symbol.iterator]();

                case 5:
                  if (_iteratorNormalCompletion266 = (_step266 = _iterator266.next()).done) {
                    _context33.next = 14;
                    break;
                  }

                  _t187 = _step266.value;
                  _context33.t0 = _t187.name.startsWith(e + ":");

                  if (!_context33.t0) {
                    _context33.next = 11;
                    break;
                  }

                  _context33.next = 11;
                  return _t187;

                case 11:
                  _iteratorNormalCompletion266 = true;
                  _context33.next = 5;
                  break;

                case 14:
                  _context33.next = 20;
                  break;

                case 16:
                  _context33.prev = 16;
                  _context33.t1 = _context33["catch"](3);
                  _didIteratorError266 = true;
                  _iteratorError266 = _context33.t1;

                case 20:
                  _context33.prev = 20;
                  _context33.prev = 21;

                  if (!_iteratorNormalCompletion266 && _iterator266.return != null) {
                    _iterator266.return();
                  }

                case 23:
                  _context33.prev = 23;

                  if (!_didIteratorError266) {
                    _context33.next = 26;
                    break;
                  }

                  throw _iteratorError266;

                case 26:
                  return _context33.finish(23);

                case 27:
                  return _context33.finish(20);

                case 28:
                case "end":
                  return _context33.stop();
              }
            }
          }, getMarkersGroup, this, [[3, 16, 20, 28], [21,, 23, 27]]);
        })
      }, {
        key: "_destroyMarker",
        value: function _destroyMarker(e) {
          e.stopListening(), e._detachLiveRange();
        }
      }]);

      return Zc;
    }();

    Ke(Zc, h);

    var Xc =
    /*#__PURE__*/
    function () {
      function Xc(e, t, i, n) {
        _classCallCheck(this, Xc);

        this.name = e, this._liveRange = this._attachLiveRange(t), this._managedUsingOperations = i, this._affectsData = n;
      }

      _createClass(Xc, [{
        key: "getStart",
        value: function getStart() {
          if (!this._liveRange) throw new c.a("marker-destroyed", this);
          return this._liveRange.start.clone();
        }
      }, {
        key: "getEnd",
        value: function getEnd() {
          if (!this._liveRange) throw new c.a("marker-destroyed", this);
          return this._liveRange.end.clone();
        }
      }, {
        key: "getRange",
        value: function getRange() {
          if (!this._liveRange) throw new c.a("marker-destroyed", this);
          return this._liveRange.toRange();
        }
      }, {
        key: "is",
        value: function is(e) {
          return "marker" === e || "model:marker" === e;
        }
      }, {
        key: "_attachLiveRange",
        value: function _attachLiveRange(e) {
          return this._liveRange && this._detachLiveRange(), e.delegate("change:range").to(this), e.delegate("change:content").to(this), this._liveRange = e, e;
        }
      }, {
        key: "_detachLiveRange",
        value: function _detachLiveRange() {
          this._liveRange.stopDelegating("change:range", this), this._liveRange.stopDelegating("change:content", this), this._liveRange.detach(), this._liveRange = null;
        }
      }, {
        key: "managedUsingOperations",
        get: function get() {
          if (!this._liveRange) throw new c.a("marker-destroyed", this);
          return this._managedUsingOperations;
        }
      }, {
        key: "affectsData",
        get: function get() {
          if (!this._liveRange) throw new c.a("marker-destroyed", this);
          return this._affectsData;
        }
      }]);

      return Xc;
    }();

    Ke(Xc, h);

    var el =
    /*#__PURE__*/
    function (_bc10) {
      _inherits(el, _bc10);

      function el() {
        _classCallCheck(this, el);

        return _possibleConstructorReturn(this, _getPrototypeOf(el).apply(this, arguments));
      }

      _createClass(el, [{
        key: "clone",
        value: function clone() {
          return new el(this.baseVersion);
        }
      }, {
        key: "getReversed",
        value: function getReversed() {
          return new el(this.baseVersion + 1);
        }
      }, {
        key: "_execute",
        value: function _execute() {}
      }, {
        key: "type",
        get: function get() {
          return "noop";
        }
      }], [{
        key: "className",
        get: function get() {
          return "NoOperation";
        }
      }]);

      return el;
    }(bc);

    var tl = {};
    tl[Ec.className] = Ec, tl[Pc.className] = Pc, tl[Mc.className] = Mc, tl[Ic.className] = Ic, tl[el.className] = el, tl[bc.className] = bc, tl[Nc.className] = Nc, tl[Rc.className] = Rc, tl[zc.className] = zc, tl[Oc.className] = Oc;

    var il =
    /*#__PURE__*/
    function (_ia) {
      _inherits(il, _ia);

      function il(e, t) {
        var _this76;

        var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "toNone";

        _classCallCheck(this, il);

        if (_this76 = _possibleConstructorReturn(this, _getPrototypeOf(il).call(this, e, t, i)), !_this76.root.is("rootElement")) throw new c.a("model-liveposition-root-not-rootelement", e);
        nl.call(_assertThisInitialized(_this76));
        return _possibleConstructorReturn(_this76);
      }

      _createClass(il, [{
        key: "detach",
        value: function detach() {
          this.stopListening();
        }
      }, {
        key: "is",
        value: function is(e) {
          return "livePosition" === e || "model:livePosition" === e || "position" == e || "model:position" === e;
        }
      }, {
        key: "toPosition",
        value: function toPosition() {
          return new ia(this.root, this.path.slice(), this.stickiness);
        }
      }], [{
        key: "fromPosition",
        value: function fromPosition(e, t) {
          return new this(e.root, e.path.slice(), t || e.stickiness);
        }
      }]);

      return il;
    }(ia);

    function nl() {
      var _this77 = this;

      this.listenTo(this.root.document.model, "applyOperation", function (e, t) {
        var i = t[0];
        i.isDocumentOperation && ol.call(_this77, i);
      }, {
        priority: "low"
      });
    }

    function ol(e) {
      var t = this.getTransformedByOperation(e);

      if (!this.isEqual(t)) {
        var _e185 = this.toPosition();

        this.path = t.path, this.root = t.root, this.fire("change", _e185);
      }
    }

    Ke(il, h);

    var rl =
    /*#__PURE__*/
    function () {
      function rl(e, t, i) {
        _classCallCheck(this, rl);

        this.model = e, this.writer = t, this.position = i, this.canMergeWith = new Set([this.position.parent]), this.schema = e.schema, this._documentFragment = t.createDocumentFragment(), this._documentFragmentPosition = t.createPositionAt(this._documentFragment, 0), this._firstNode = null, this._lastNode = null, this._lastAutoParagraph = null, this._filterAttributesOf = [], this._affectedStart = null, this._affectedEnd = null;
      }

      _createClass(rl, [{
        key: "handleNodes",
        value: function handleNodes(e) {
          for (var _i200 = 0, _Array$from6 = Array.from(e); _i200 < _Array$from6.length; _i200++) {
            var _t188 = _Array$from6[_i200];

            this._handleNode(_t188);
          }

          this._insertPartialFragment(), this._lastAutoParagraph && this._updateLastNodeFromAutoParagraph(this._lastAutoParagraph), this._mergeOnRight(), this.schema.removeDisallowedAttributes(this._filterAttributesOf, this.writer), this._filterAttributesOf = [];
        }
      }, {
        key: "_updateLastNodeFromAutoParagraph",
        value: function _updateLastNodeFromAutoParagraph(e) {
          var t = this.writer.createPositionAfter(this._lastNode),
              i = this.writer.createPositionAfter(e);

          if (i.isAfter(t)) {
            if (this._lastNode = e, this.position.parent != e || !this.position.isAtEnd) throw new c.a("insertcontent-invalid-insertion-position", this);
            this.position = i, this._setAffectedBoundaries(this.position);
          }
        }
      }, {
        key: "getSelectionRange",
        value: function getSelectionRange() {
          return this.nodeToSelect ? sa._createOn(this.nodeToSelect) : this.model.schema.getNearestSelectionRange(this.position);
        }
      }, {
        key: "getAffectedRange",
        value: function getAffectedRange() {
          return this._affectedStart ? new sa(this._affectedStart, this._affectedEnd) : null;
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this._affectedStart && this._affectedStart.detach(), this._affectedEnd && this._affectedEnd.detach();
        }
      }, {
        key: "_handleNode",
        value: function _handleNode(e) {
          if (this.schema.isObject(e)) return void this._handleObject(e);

          var t = this._checkAndAutoParagraphToAllowedPosition(e);

          t || (t = this._checkAndSplitToAllowedPosition(e), t) ? (this._appendToFragment(e), this._firstNode || (this._firstNode = e), this._lastNode = e) : this._handleDisallowedNode(e);
        }
      }, {
        key: "_insertPartialFragment",
        value: function _insertPartialFragment() {
          if (this._documentFragment.isEmpty) return;
          var e = il.fromPosition(this.position, "toNext");
          this._setAffectedBoundaries(this.position), this._documentFragment.getChild(0) == this._firstNode && (this.writer.insert(this._firstNode, this.position), this._mergeOnLeft(), this.position = e.toPosition()), this._documentFragment.isEmpty || this.writer.insert(this._documentFragment, this.position), this._documentFragmentPosition = this.writer.createPositionAt(this._documentFragment, 0), this.position = e.toPosition(), e.detach();
        }
      }, {
        key: "_handleObject",
        value: function _handleObject(e) {
          this._checkAndSplitToAllowedPosition(e) ? this._appendToFragment(e) : this._tryAutoparagraphing(e);
        }
      }, {
        key: "_handleDisallowedNode",
        value: function _handleDisallowedNode(e) {
          e.is("element") ? this.handleNodes(e.getChildren()) : this._tryAutoparagraphing(e);
        }
      }, {
        key: "_appendToFragment",
        value: function _appendToFragment(e) {
          if (!this.schema.checkChild(this.position, e)) throw new c.a("insertcontent-wrong-position", this, {
            node: e,
            position: this.position
          });
          this.writer.insert(e, this._documentFragmentPosition), this._documentFragmentPosition = this._documentFragmentPosition.getShiftedBy(e.offsetSize), this.schema.isObject(e) && !this.schema.checkChild(this.position, "$text") ? this.nodeToSelect = e : this.nodeToSelect = null, this._filterAttributesOf.push(e);
        }
      }, {
        key: "_setAffectedBoundaries",
        value: function _setAffectedBoundaries(e) {
          this._affectedStart || (this._affectedStart = il.fromPosition(e, "toPrevious")), this._affectedEnd && !this._affectedEnd.isBefore(e) || (this._affectedEnd && this._affectedEnd.detach(), this._affectedEnd = il.fromPosition(e, "toNext"));
        }
      }, {
        key: "_mergeOnLeft",
        value: function _mergeOnLeft() {
          var e = this._firstNode;
          if (!(e instanceof Xs)) return;
          if (!this._canMergeLeft(e)) return;

          var t = il._createBefore(e);

          t.stickiness = "toNext";
          var i = il.fromPosition(this.position, "toNext");
          this._affectedStart.isEqual(t) && (this._affectedStart.detach(), this._affectedStart = il._createAt(t.nodeBefore, "end", "toPrevious")), this._firstNode === this._lastNode && (this._firstNode = t.nodeBefore, this._lastNode = t.nodeBefore), this.writer.merge(t), t.isEqual(this._affectedEnd) && this._firstNode === this._lastNode && (this._affectedEnd.detach(), this._affectedEnd = il._createAt(t.nodeBefore, "end", "toNext")), this.position = i.toPosition(), i.detach(), this._filterAttributesOf.push(this.position.parent), t.detach();
        }
      }, {
        key: "_mergeOnRight",
        value: function _mergeOnRight() {
          var e = this._lastNode;
          if (!(e instanceof Xs)) return;
          if (!this._canMergeRight(e)) return;

          var t = il._createAfter(e);

          if (t.stickiness = "toNext", !this.position.isEqual(t)) throw new c.a("insertcontent-invalid-insertion-position", this);
          this.position = ia._createAt(t.nodeBefore, "end");
          var i = il.fromPosition(this.position, "toPrevious");
          this._affectedEnd.isEqual(t) && (this._affectedEnd.detach(), this._affectedEnd = il._createAt(t.nodeBefore, "end", "toNext")), this._firstNode === this._lastNode && (this._firstNode = t.nodeBefore, this._lastNode = t.nodeBefore), this.writer.merge(t), t.getShiftedBy(-1).isEqual(this._affectedStart) && this._firstNode === this._lastNode && (this._affectedStart.detach(), this._affectedStart = il._createAt(t.nodeBefore, 0, "toPrevious")), this.position = i.toPosition(), i.detach(), this._filterAttributesOf.push(this.position.parent), t.detach();
        }
      }, {
        key: "_canMergeLeft",
        value: function _canMergeLeft(e) {
          var t = e.previousSibling;
          return t instanceof Xs && this.canMergeWith.has(t) && this.model.schema.checkMerge(t, e);
        }
      }, {
        key: "_canMergeRight",
        value: function _canMergeRight(e) {
          var t = e.nextSibling;
          return t instanceof Xs && this.canMergeWith.has(t) && this.model.schema.checkMerge(e, t);
        }
      }, {
        key: "_tryAutoparagraphing",
        value: function _tryAutoparagraphing(e) {
          var t = this.writer.createElement("paragraph");
          this._getAllowedIn(this.position.parent, t) && this.schema.checkChild(t, e) && (t._appendChild(e), this._handleNode(t));
        }
      }, {
        key: "_checkAndAutoParagraphToAllowedPosition",
        value: function _checkAndAutoParagraphToAllowedPosition(e) {
          if (this.schema.checkChild(this.position.parent, e)) return !0;
          if (!this.schema.checkChild(this.position.parent, "paragraph") || !this.schema.checkChild("paragraph", e)) return !1;

          this._insertPartialFragment();

          var t = this.writer.createElement("paragraph");
          return this.writer.insert(t, this.position), this._setAffectedBoundaries(this.position), this._lastAutoParagraph = t, this.position = this.writer.createPositionAt(t, 0), !0;
        }
      }, {
        key: "_checkAndSplitToAllowedPosition",
        value: function _checkAndSplitToAllowedPosition(e) {
          var t = this._getAllowedIn(this.position.parent, e);

          if (!t) return !1;

          for (t != this.position.parent && this._insertPartialFragment(); t != this.position.parent;) {
            if (this.position.isAtStart) {
              var _e186 = this.position.parent;
              this.position = this.writer.createPositionBefore(_e186), _e186.isEmpty && _e186.parent === t && this.writer.remove(_e186);
            } else if (this.position.isAtEnd) this.position = this.writer.createPositionAfter(this.position.parent);else {
              var _e187 = this.writer.createPositionAfter(this.position.parent);

              this._setAffectedBoundaries(this.position), this.writer.split(this.position), this.position = _e187, this.canMergeWith.add(this.position.nodeAfter);
            }
          }

          return !0;
        }
      }, {
        key: "_getAllowedIn",
        value: function _getAllowedIn(e, t) {
          return this.schema.checkChild(e, t) ? e : this.schema.isLimit(e) ? null : this._getAllowedIn(e.parent, t);
        }
      }]);

      return rl;
    }();

    function sl(e, t) {
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      if (t.isCollapsed) return;
      var n = t.getFirstRange();
      if ("$graveyard" == n.root.rootName) return;
      var o = e.schema;
      e.change(function (e) {
        if (!i.doNotResetEntireContent && function (e, t) {
          var i = e.getLimitElement(t);
          if (!t.containsEntireContent(i)) return !1;
          var n = t.getFirstRange();
          if (n.start.parent == n.end.parent) return !1;
          return e.checkChild(i, "paragraph");
        }(o, t)) return void function (e, t) {
          var i = e.model.schema.getLimitElement(t);
          e.remove(e.createRangeIn(i)), cl(e, e.createPositionAt(i, 0), t);
        }(e, t);

        var _ref101 = function (e) {
          var t = e.root.document.model,
              i = e.start;
          var n = e.end;

          if (t.hasContent(e, {
            ignoreMarkers: !0
          })) {
            var _i201 = function (e) {
              var t = e.parent,
                  i = t.root.document.model.schema,
                  n = t.getAncestors({
                parentFirst: !0,
                includeSelf: !0
              });
              var _iteratorNormalCompletion267 = true;
              var _didIteratorError267 = false;
              var _iteratorError267 = undefined;

              try {
                for (var _iterator267 = n[Symbol.iterator](), _step267; !(_iteratorNormalCompletion267 = (_step267 = _iterator267.next()).done); _iteratorNormalCompletion267 = true) {
                  var _e188 = _step267.value;
                  if (i.isLimit(_e188)) return null;
                  if (i.isBlock(_e188)) return _e188;
                }
              } catch (err) {
                _didIteratorError267 = true;
                _iteratorError267 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion267 && _iterator267.return != null) {
                    _iterator267.return();
                  }
                } finally {
                  if (_didIteratorError267) {
                    throw _iteratorError267;
                  }
                }
              }
            }(n);

            if (_i201 && n.isTouching(t.createPositionAt(_i201, 0))) {
              var _i202 = t.createSelection(e);

              t.modifySelection(_i202, {
                direction: "backward"
              });

              var _o61 = _i202.getLastPosition(),
                  _r31 = t.createRange(_o61, n);

              t.hasContent(_r31, {
                ignoreMarkers: !0
              }) || (n = _o61);
            }
          }

          return [il.fromPosition(i, "toPrevious"), il.fromPosition(n, "toNext")];
        }(n),
            _ref102 = _slicedToArray(_ref101, 2),
            r = _ref102[0],
            s = _ref102[1];

        r.isTouching(s) || e.remove(e.createRange(r, s)), i.leaveUnmerged || (!function (e, t, i) {
          var n = e.model;
          if (!al(e.model.schema, t, i)) return;

          var _ref103 = function (e, t) {
            var i = e.getAncestors(),
                n = t.getAncestors();
            var o = 0;

            for (; i[o] && i[o] == n[o];) {
              o++;
            }

            return [i[o], n[o]];
          }(t, i),
              _ref104 = _slicedToArray(_ref103, 2),
              o = _ref104[0],
              r = _ref104[1];

          if (!o || !r) return;
          !n.hasContent(o, {
            ignoreMarkers: !0
          }) && n.hasContent(r, {
            ignoreMarkers: !0
          }) ? function e(t, i, n, o) {
            var r = i.parent,
                s = n.parent;
            if (r == o || s == o) return;
            i = t.createPositionAfter(r), (n = t.createPositionBefore(s)).isEqual(i) || t.insert(r, n);

            for (; i.parent.isEmpty;) {
              var _e189 = i.parent;
              i = t.createPositionBefore(_e189), t.remove(_e189);
            }

            if (n = t.createPositionBefore(s), function (e, t) {
              var i = t.nodeBefore,
                  n = t.nodeAfter;
              i.name != n.name && e.rename(i, n.name);
              e.clearAttributes(i), e.setAttributes(Object.fromEntries(n.getAttributes()), i), e.merge(t);
            }(t, n), !al(t.model.schema, i, n)) return;
            e(t, i, n, o);
          }(e, t, i, o.parent) : function e(t, i, n, o) {
            var r = i.parent,
                s = n.parent;
            if (r == o || s == o) return;
            i = t.createPositionAfter(r), (n = t.createPositionBefore(s)).isEqual(i) || t.insert(s, i);
            t.merge(i);

            for (; n.parent.isEmpty;) {
              var _e190 = n.parent;
              n = t.createPositionBefore(_e190), t.remove(_e190);
            }

            if (!al(t.model.schema, i, n)) return;
            e(t, i, n, o);
          }(e, t, i, o.parent);
        }(e, r, s), o.removeDisallowedAttributes(r.parent.getChildren(), e)), ll(e, t, r), !i.doNotAutoparagraph && function (e, t) {
          var i = e.checkChild(t, "$text"),
              n = e.checkChild(t, "paragraph");
          return !i && n;
        }(o, r) && cl(e, r, t), r.detach(), s.detach();
      });
    }

    function al(e, t, i) {
      var n = t.parent,
          o = i.parent;
      return n != o && !e.isLimit(n) && !e.isLimit(o) && function (e, t, i) {
        var n = new sa(e, t);
        var _iteratorNormalCompletion268 = true;
        var _didIteratorError268 = false;
        var _iteratorError268 = undefined;

        try {
          for (var _iterator268 = n.getWalker()[Symbol.iterator](), _step268; !(_iteratorNormalCompletion268 = (_step268 = _iterator268.next()).done); _iteratorNormalCompletion268 = true) {
            var _e191 = _step268.value;
            if (i.isLimit(_e191.item)) return !1;
          }
        } catch (err) {
          _didIteratorError268 = true;
          _iteratorError268 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion268 && _iterator268.return != null) {
              _iterator268.return();
            }
          } finally {
            if (_didIteratorError268) {
              throw _iteratorError268;
            }
          }
        }

        return !0;
      }(t, i, e);
    }

    function cl(e, t, i) {
      var n = e.createElement("paragraph");
      e.insert(n, t), ll(e, i, e.createPositionAt(n, 0));
    }

    function ll(e, t, i) {
      t instanceof ya ? e.setSelection(i) : t.setTo(i);
    }

    function dl(e, t) {
      var i = e.isForward,
          n = e.walker,
          o = e.unit,
          r = e.schema,
          s = t.type,
          a = t.item,
          c = t.nextPosition;
      if ("text" == s) return "word" === e.unit ? function (e, t) {
        var i = e.position.textNode;

        if (i) {
          var _n99 = e.position.offset - i.startOffset;

          for (; !ul(i.data, _n99, t) && !gl(i, _n99, t);) {
            e.next();

            var _o62 = t ? e.position.nodeAfter : e.position.nodeBefore;

            if (_o62 && _o62.is("$text")) {
              var _n100 = _o62.data.charAt(t ? 0 : _o62.data.length - 1);

              ' ,.?!:;"-()'.includes(_n100) || (e.next(), i = e.position.textNode);
            }

            _n99 = e.position.offset - i.startOffset;
          }
        }

        return e.position;
      }(n, i) : function (e, t) {
        var i = e.position.textNode;

        if (i) {
          var _n101 = i.data;

          var _o63 = e.position.offset - i.startOffset;

          for (; Gc(_n101, _o63) || "character" == t && Kc(_n101, _o63);) {
            e.next(), _o63 = e.position.offset - i.startOffset;
          }
        }

        return e.position;
      }(n, o);

      if (s == (i ? "elementStart" : "elementEnd")) {
        if (r.isSelectable(a)) return ia._createAt(a, i ? "after" : "before");
        if (r.checkChild(c, "$text")) return c;
      } else {
        if (r.isLimit(a)) return void n.skip(function () {
          return !0;
        });
        if (r.checkChild(c, "$text")) return c;
      }
    }

    function hl(e, t) {
      var i = e.root,
          n = ia._createAt(i, t ? "end" : 0);

      return t ? new sa(e, n) : new sa(n, e);
    }

    function ul(e, t, i) {
      var n = t + (i ? 0 : -1);
      return ' ,.?!:;"-()'.includes(e.charAt(n));
    }

    function gl(e, t, i) {
      return t === (i ? e.endOffset : 0);
    }

    function ml(e, t) {
      var i = [];
      Array.from(e.getItems({
        direction: "backward"
      })).map(function (e) {
        return t.createRangeOn(e);
      }).filter(function (t) {
        return (t.start.isAfter(e.start) || t.start.isEqual(e.start)) && (t.end.isBefore(e.end) || t.end.isEqual(e.end));
      }).forEach(function (e) {
        i.push(e.start.parent), t.remove(e);
      }), i.forEach(function (e) {
        var i = e;

        for (; i.parent && i.isEmpty;) {
          var _e192 = t.createRangeOn(i);

          i = i.parent, t.remove(_e192);
        }
      });
    }

    function fl(e) {
      e.document.registerPostFixer(function (t) {
        return function (e, t) {
          var i = t.document.selection,
              n = t.schema,
              o = [];
          var r = !1;
          var _iteratorNormalCompletion269 = true;
          var _didIteratorError269 = false;
          var _iteratorError269 = undefined;

          try {
            for (var _iterator269 = i.getRanges()[Symbol.iterator](), _step269; !(_iteratorNormalCompletion269 = (_step269 = _iterator269.next()).done); _iteratorNormalCompletion269 = true) {
              var _e194 = _step269.value;

              var _t189 = pl(_e194, n);

              _t189 && !_t189.isEqual(_e194) ? (o.push(_t189), r = !0) : o.push(_e194);
            }
          } catch (err) {
            _didIteratorError269 = true;
            _iteratorError269 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion269 && _iterator269.return != null) {
                _iterator269.return();
              }
            } finally {
              if (_didIteratorError269) {
                throw _iteratorError269;
              }
            }
          }

          r && e.setSelection(function (e) {
            var t = [];
            t.push(e.shift());
            var _iteratorNormalCompletion270 = true;
            var _didIteratorError270 = false;
            var _iteratorError270 = undefined;

            try {
              for (var _iterator270 = e[Symbol.iterator](), _step270; !(_iteratorNormalCompletion270 = (_step270 = _iterator270.next()).done); _iteratorNormalCompletion270 = true) {
                var _i203 = _step270.value;

                var _e193 = t.pop();

                if (_i203.isEqual(_e193)) t.push(_e193);else if (_i203.isIntersecting(_e193)) {
                  var _n102 = _e193.start.isAfter(_i203.start) ? _i203.start : _e193.start,
                      _o64 = _e193.end.isAfter(_i203.end) ? _e193.end : _i203.end,
                      _r32 = new sa(_n102, _o64);

                  t.push(_r32);
                } else t.push(_e193), t.push(_i203);
              }
            } catch (err) {
              _didIteratorError270 = true;
              _iteratorError270 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion270 && _iterator270.return != null) {
                  _iterator270.return();
                }
              } finally {
                if (_didIteratorError270) {
                  throw _iteratorError270;
                }
              }
            }

            return t;
          }(o), {
            backward: i.isBackward
          });
        }(t, e);
      });
    }

    function pl(e, t) {
      return e.isCollapsed ? function (e, t) {
        var i = e.start,
            n = t.getNearestSelectionRange(i);
        if (!n) return null;
        if (!n.isCollapsed) return n;
        var o = n.start;
        if (i.isEqual(o)) return null;
        return new sa(o);
      }(e, t) : function (e, t) {
        var i = e.start,
            n = e.end,
            o = t.checkChild(i, "$text"),
            r = t.checkChild(n, "$text"),
            s = t.getLimitElement(i),
            a = t.getLimitElement(n);

        if (s === a) {
          if (o && r) return null;

          if (function (e, t, i) {
            var n = e.nodeAfter && !i.isLimit(e.nodeAfter) || i.checkChild(e, "$text"),
                o = t.nodeBefore && !i.isLimit(t.nodeBefore) || i.checkChild(t, "$text");
            return n || o;
          }(i, n, t)) {
            var _e195 = i.nodeAfter && t.isSelectable(i.nodeAfter) ? null : t.getNearestSelectionRange(i, "forward"),
                _o65 = n.nodeBefore && t.isSelectable(n.nodeBefore) ? null : t.getNearestSelectionRange(n, "backward"),
                _r33 = _e195 ? _e195.start : i,
                _s21 = _o65 ? _o65.end : n;

            return new sa(_r33, _s21);
          }
        }

        var c = s && !s.is("rootElement"),
            l = a && !a.is("rootElement");

        if (c || l) {
          var _e196 = i.nodeAfter && n.nodeBefore && i.nodeAfter.parent === n.nodeBefore.parent,
              _o66 = c && (!_e196 || !wl(i.nodeAfter, t)),
              _r34 = l && (!_e196 || !wl(n.nodeBefore, t));

          var _d2 = i,
              _h2 = n;
          return _o66 && (_d2 = ia._createBefore(bl(s, t))), _r34 && (_h2 = ia._createAfter(bl(a, t))), new sa(_d2, _h2);
        }

        return null;
      }(e, t);
    }

    function bl(e, t) {
      var i = e,
          n = i;

      for (; t.isLimit(n) && n.parent;) {
        i = n, n = n.parent;
      }

      return i;
    }

    function wl(e, t) {
      return e && t.isSelectable(e);
    }

    var kl =
    /*#__PURE__*/
    function () {
      function kl() {
        var _this78 = this;

        _classCallCheck(this, kl);

        this.markers = new Zc(), this.document = new Qc(this), this.schema = new Ga(), this._pendingChanges = [], this._currentWriter = null, ["insertContent", "deleteContent", "modifySelection", "getSelectedContent", "applyOperation"].forEach(function (e) {
          return _this78.decorate(e);
        }), this.on("applyOperation", function (e, t) {
          t[0]._validate();
        }, {
          priority: "highest"
        }), this.schema.register("$root", {
          isLimit: !0
        }), this.schema.register("$block", {
          allowIn: "$root",
          isBlock: !0
        }), this.schema.register("$text", {
          allowIn: "$block",
          isInline: !0,
          isContent: !0
        }), this.schema.register("$clipboardHolder", {
          allowContentOf: "$root",
          allowChildren: "$text",
          isLimit: !0
        }), this.schema.register("$documentFragment", {
          allowContentOf: "$root",
          allowChildren: "$text",
          isLimit: !0
        }), this.schema.register("$marker"), this.schema.addChildCheck(function (e, t) {
          if ("$marker" === t.name) return !0;
        }), fl(this), this.document.registerPostFixer(Oa);
      }

      _createClass(kl, [{
        key: "change",
        value: function change(e) {
          try {
            return 0 === this._pendingChanges.length ? (this._pendingChanges.push({
              batch: new pc(),
              callback: e
            }), this._runPendingChanges()[0]) : e(this._currentWriter);
          } catch (e) {
            c.a.rethrowUnexpectedError(e, this);
          }
        }
      }, {
        key: "enqueueChange",
        value: function enqueueChange(e, t) {
          try {
            "string" == typeof e ? e = new pc(e) : "function" == typeof e && (t = e, e = new pc()), this._pendingChanges.push({
              batch: e,
              callback: t
            }), 1 == this._pendingChanges.length && this._runPendingChanges();
          } catch (e) {
            c.a.rethrowUnexpectedError(e, this);
          }
        }
      }, {
        key: "applyOperation",
        value: function applyOperation(e) {
          e._execute();
        }
      }, {
        key: "insertContent",
        value: function insertContent(e, t, i) {
          return function (e, t, i, n) {
            return e.change(function (o) {
              var r;
              r = i ? i instanceof ma || i instanceof ya ? i : o.createSelection(i, n) : e.document.selection, r.isCollapsed || e.deleteContent(r, {
                doNotAutoparagraph: !0
              });
              var s = new rl(e, o, r.anchor);
              var a;
              a = t.is("documentFragment") ? t.getChildren() : [t], s.handleNodes(a);
              var c = s.getSelectionRange();
              c && (r instanceof ya ? o.setSelection(c) : r.setTo(c));
              var l = s.getAffectedRange() || e.createRange(r.anchor);
              return s.destroy(), l;
            });
          }(this, e, t, i);
        }
      }, {
        key: "deleteContent",
        value: function deleteContent(e, t) {
          sl(this, e, t);
        }
      }, {
        key: "modifySelection",
        value: function modifySelection(e, t) {
          !function (e, t) {
            var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            var n = e.schema,
                o = "backward" != i.direction,
                r = i.unit ? i.unit : "character",
                s = t.focus,
                a = new ea({
              boundaries: hl(s, o),
              singleCharacters: !0,
              direction: o ? "forward" : "backward"
            }),
                c = {
              walker: a,
              schema: n,
              isForward: o,
              unit: r
            };
            var l;

            var _loop3 = function _loop3() {
              if (l.done) return {
                v: void 0
              };
              var i = dl(c, l.value);
              if (i) return {
                v: void (t instanceof ya ? e.change(function (e) {
                  e.setSelectionFocus(i);
                }) : t.setFocus(i))
              };
            };

            for (; l = a.next();) {
              var _ret2 = _loop3();

              if (typeof _ret2 === "object") return _ret2.v;
            }
          }(this, e, t);
        }
      }, {
        key: "getSelectedContent",
        value: function getSelectedContent(e) {
          return function (e, t) {
            return e.change(function (e) {
              var i = e.createDocumentFragment(),
                  n = t.getFirstRange();
              if (!n || n.isCollapsed) return i;
              var o = n.start.root,
                  r = n.start.getCommonPath(n.end),
                  s = o.getNodeByPath(r);
              var a;
              a = n.start.parent == n.end.parent ? n : e.createRange(e.createPositionAt(s, n.start.path[r.length]), e.createPositionAt(s, n.end.path[r.length] + 1));
              var c = a.end.offset - a.start.offset;
              var _iteratorNormalCompletion271 = true;
              var _didIteratorError271 = false;
              var _iteratorError271 = undefined;

              try {
                for (var _iterator271 = a.getItems({
                  shallow: !0
                })[Symbol.iterator](), _step271; !(_iteratorNormalCompletion271 = (_step271 = _iterator271.next()).done); _iteratorNormalCompletion271 = true) {
                  var _t191 = _step271.value;
                  _t191.is("$textProxy") ? e.appendText(_t191.data, _t191.getAttributes(), i) : e.append(e.cloneElement(_t191, !0), i);
                }
              } catch (err) {
                _didIteratorError271 = true;
                _iteratorError271 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion271 && _iterator271.return != null) {
                    _iterator271.return();
                  }
                } finally {
                  if (_didIteratorError271) {
                    throw _iteratorError271;
                  }
                }
              }

              if (a != n) {
                var _t190 = n._getTransformedByMove(a.start, e.createPositionAt(i, 0), c)[0],
                    _o67 = e.createRange(e.createPositionAt(i, 0), _t190.start);

                ml(e.createRange(_t190.end, e.createPositionAt(i, "end")), e), ml(_o67, e);
              }

              return i;
            });
          }(this, e);
        }
      }, {
        key: "hasContent",
        value: function hasContent(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var i = e instanceof Xs ? sa._createIn(e) : e;
          if (i.isCollapsed) return !1;
          var _t$ignoreWhitespaces = t.ignoreWhitespaces,
              n = _t$ignoreWhitespaces === void 0 ? !1 : _t$ignoreWhitespaces,
              _t$ignoreMarkers = t.ignoreMarkers,
              o = _t$ignoreMarkers === void 0 ? !1 : _t$ignoreMarkers;

          if (!o) {
            var _iteratorNormalCompletion272 = true;
            var _didIteratorError272 = false;
            var _iteratorError272 = undefined;

            try {
              for (var _iterator272 = this.markers.getMarkersIntersectingRange(i)[Symbol.iterator](), _step272; !(_iteratorNormalCompletion272 = (_step272 = _iterator272.next()).done); _iteratorNormalCompletion272 = true) {
                var _e197 = _step272.value;
                if (_e197.affectsData) return !0;
              }
            } catch (err) {
              _didIteratorError272 = true;
              _iteratorError272 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion272 && _iterator272.return != null) {
                  _iterator272.return();
                }
              } finally {
                if (_didIteratorError272) {
                  throw _iteratorError272;
                }
              }
            }
          }

          var _iteratorNormalCompletion273 = true;
          var _didIteratorError273 = false;
          var _iteratorError273 = undefined;

          try {
            for (var _iterator273 = i.getItems()[Symbol.iterator](), _step273; !(_iteratorNormalCompletion273 = (_step273 = _iterator273.next()).done); _iteratorNormalCompletion273 = true) {
              var _e198 = _step273.value;

              if (this.schema.isContent(_e198)) {
                if (!_e198.is("$textProxy")) return !0;
                if (!n) return !0;
                if (-1 !== _e198.data.search(/\S/)) return !0;
              }
            }
          } catch (err) {
            _didIteratorError273 = true;
            _iteratorError273 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion273 && _iterator273.return != null) {
                _iterator273.return();
              }
            } finally {
              if (_didIteratorError273) {
                throw _iteratorError273;
              }
            }
          }

          return !1;
        }
      }, {
        key: "createPositionFromPath",
        value: function createPositionFromPath(e, t, i) {
          return new ia(e, t, i);
        }
      }, {
        key: "createPositionAt",
        value: function createPositionAt(e, t) {
          return ia._createAt(e, t);
        }
      }, {
        key: "createPositionAfter",
        value: function createPositionAfter(e) {
          return ia._createAfter(e);
        }
      }, {
        key: "createPositionBefore",
        value: function createPositionBefore(e) {
          return ia._createBefore(e);
        }
      }, {
        key: "createRange",
        value: function createRange(e, t) {
          return new sa(e, t);
        }
      }, {
        key: "createRangeIn",
        value: function createRangeIn(e) {
          return sa._createIn(e);
        }
      }, {
        key: "createRangeOn",
        value: function createRangeOn(e) {
          return sa._createOn(e);
        }
      }, {
        key: "createSelection",
        value: function createSelection(e, t, i) {
          return new ma(e, t, i);
        }
      }, {
        key: "createBatch",
        value: function createBatch(e) {
          return new pc(e);
        }
      }, {
        key: "createOperationFromJSON",
        value: function createOperationFromJSON(e) {
          return (
            /*#__PURE__*/
            function () {
              function _class() {
                _classCallCheck(this, _class);
              }

              _createClass(_class, null, [{
                key: "fromJSON",
                value: function fromJSON(e, t) {
                  return tl[e.__className].fromJSON(e, t);
                }
              }]);

              return _class;
            }().fromJSON(e, this.document)
          );
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.document.destroy(), this.stopListening();
        }
      }, {
        key: "_runPendingChanges",
        value: function _runPendingChanges() {
          var e = [];

          for (this.fire("_beforeChanges"); this._pendingChanges.length;) {
            var _t192 = this._pendingChanges[0].batch;
            this._currentWriter = new Lc(this, _t192);

            var _i204 = this._pendingChanges[0].callback(this._currentWriter);

            e.push(_i204), this.document._handleChangeBlock(this._currentWriter), this._pendingChanges.shift(), this._currentWriter = null;
          }

          return this.fire("_afterChanges"), e;
        }
      }]);

      return kl;
    }();

    Ke(kl, Ue);

    var _l =
    /*#__PURE__*/
    function (_Ds) {
      _inherits(_l, _Ds);

      function _l(e) {
        var _this79;

        _classCallCheck(this, _l);

        _this79 = _possibleConstructorReturn(this, _getPrototypeOf(_l).call(this)), _this79.editor = e;
        return _this79;
      }

      _createClass(_l, [{
        key: "set",
        value: function set(e, t) {
          var _this80 = this;

          var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

          if ("string" == typeof t) {
            var _e199 = t;

            t = function t(_t193, i) {
              _this80.editor.execute(_e199), i();
            };
          }

          _get(_getPrototypeOf(_l.prototype), "set", this).call(this, e, t, i);
        }
      }]);

      return _l;
    }(Ds);

    var vl =
    /*#__PURE__*/
    function () {
      function vl() {
        var _this81 = this;

        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, vl);

        this._context = e.context || new sn({
          language: e.language
        }), this._context._addEditor(this, !e.context);
        var t = Array.from(this.constructor.builtinPlugins || []);
        this.config = new Gi(e, this.constructor.defaultConfig), this.config.define("plugins", t), this.config.define(this._context._getEditorConfig()), this.plugins = new Xi(this, t, this._context.plugins), this.locale = this._context.locale, this.t = this.locale.t, this.commands = new qa(), this.set("state", "initializing"), this.once("ready", function () {
          return _this81.state = "ready";
        }, {
          priority: "high"
        }), this.once("destroy", function () {
          return _this81.state = "destroyed";
        }, {
          priority: "high"
        }), this.set("isReadOnly", !1), this.model = new kl();
        var i = new Jn();
        this.data = new uc(this.model, i), this.editing = new Wa(this.model, i), this.editing.view.document.bind("isReadOnly").to(this), this.conversion = new gc([this.editing.downcastDispatcher, this.data.downcastDispatcher], this.data.upcastDispatcher), this.conversion.addAlias("dataDowncast", this.data.downcastDispatcher), this.conversion.addAlias("editingDowncast", this.editing.downcastDispatcher), this.keystrokes = new _l(this), this.keystrokes.listenTo(this.editing.view.document);
      }

      _createClass(vl, [{
        key: "initPlugins",
        value: function initPlugins() {
          var e = this.config,
              t = e.get("plugins"),
              i = e.get("removePlugins") || [],
              n = e.get("extraPlugins") || [],
              o = e.get("substitutePlugins") || [];
          return this.plugins.init(t.concat(n), i, o);
        }
      }, {
        key: "destroy",
        value: function destroy() {
          var _this82 = this;

          var e = Promise.resolve();
          return "initializing" == this.state && (e = new Promise(function (e) {
            return _this82.once("ready", e);
          })), e.then(function () {
            _this82.fire("destroy"), _this82.stopListening(), _this82.commands.destroy();
          }).then(function () {
            return _this82.plugins.destroy();
          }).then(function () {
            _this82.model.destroy(), _this82.data.destroy(), _this82.editing.destroy(), _this82.keystrokes.destroy();
          }).then(function () {
            return _this82._context._removeEditor(_this82);
          });
        }
      }, {
        key: "execute",
        value: function execute() {
          try {
            var _this$commands;

            return (_this$commands = this.commands).execute.apply(_this$commands, arguments);
          } catch (e) {
            c.a.rethrowUnexpectedError(e, this);
          }
        }
      }, {
        key: "focus",
        value: function focus() {
          this.editing.view.focus();
        }
      }]);

      return vl;
    }();

    Ke(vl, Ue);

    var yl =
    /*#__PURE__*/
    function () {
      function yl(e) {
        _classCallCheck(this, yl);

        this.editor = e, this._components = new Map();
      }

      _createClass(yl, [{
        key: "names",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function names() {
          var _iteratorNormalCompletion274, _didIteratorError274, _iteratorError274, _iterator274, _step274, _e200;

          return _regeneratorRuntime.wrap(function names$(_context34) {
            while (1) {
              switch (_context34.prev = _context34.next) {
                case 0:
                  _iteratorNormalCompletion274 = true;
                  _didIteratorError274 = false;
                  _iteratorError274 = undefined;
                  _context34.prev = 3;
                  _iterator274 = this._components.values()[Symbol.iterator]();

                case 5:
                  if (_iteratorNormalCompletion274 = (_step274 = _iterator274.next()).done) {
                    _context34.next = 12;
                    break;
                  }

                  _e200 = _step274.value;
                  _context34.next = 9;
                  return _e200.originalName;

                case 9:
                  _iteratorNormalCompletion274 = true;
                  _context34.next = 5;
                  break;

                case 12:
                  _context34.next = 18;
                  break;

                case 14:
                  _context34.prev = 14;
                  _context34.t0 = _context34["catch"](3);
                  _didIteratorError274 = true;
                  _iteratorError274 = _context34.t0;

                case 18:
                  _context34.prev = 18;
                  _context34.prev = 19;

                  if (!_iteratorNormalCompletion274 && _iterator274.return != null) {
                    _iterator274.return();
                  }

                case 21:
                  _context34.prev = 21;

                  if (!_didIteratorError274) {
                    _context34.next = 24;
                    break;
                  }

                  throw _iteratorError274;

                case 24:
                  return _context34.finish(21);

                case 25:
                  return _context34.finish(18);

                case 26:
                case "end":
                  return _context34.stop();
              }
            }
          }, names, this, [[3, 14, 18, 26], [19,, 21, 25]]);
        })
      }, {
        key: "add",
        value: function add(e, t) {
          this._components.set(xl(e), {
            callback: t,
            originalName: e
          });
        }
      }, {
        key: "create",
        value: function create(e) {
          if (!this.has(e)) throw new c.a("componentfactory-item-missing", this, {
            name: e
          });
          return this._components.get(xl(e)).callback(this.editor.locale);
        }
      }, {
        key: "has",
        value: function has(e) {
          return this._components.has(xl(e));
        }
      }]);

      return yl;
    }();

    function xl(e) {
      return String(e).toLowerCase();
    }

    var Al =
    /*#__PURE__*/
    function () {
      function Al(e) {
        var _this83 = this;

        _classCallCheck(this, Al);

        this.editor = e, this.componentFactory = new yl(e), this.focusTracker = new zs(), this._editableElementsMap = new Map(), this.listenTo(e.editing.view.document, "layoutChanged", function () {
          return _this83.update();
        });
      }

      _createClass(Al, [{
        key: "update",
        value: function update() {
          this.fire("update");
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.stopListening(), this.focusTracker.destroy();
          var _iteratorNormalCompletion275 = true;
          var _didIteratorError275 = false;
          var _iteratorError275 = undefined;

          try {
            for (var _iterator275 = this._editableElementsMap.values()[Symbol.iterator](), _step275; !(_iteratorNormalCompletion275 = (_step275 = _iterator275.next()).done); _iteratorNormalCompletion275 = true) {
              var _e201 = _step275.value;
              _e201.ckeditorInstance = null;
            }
          } catch (err) {
            _didIteratorError275 = true;
            _iteratorError275 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion275 && _iterator275.return != null) {
                _iterator275.return();
              }
            } finally {
              if (_didIteratorError275) {
                throw _iteratorError275;
              }
            }
          }

          this._editableElementsMap = new Map();
        }
      }, {
        key: "setEditableElement",
        value: function setEditableElement(e, t) {
          this._editableElementsMap.set(e, t), t.ckeditorInstance || (t.ckeditorInstance = this.editor);
        }
      }, {
        key: "getEditableElement",
        value: function getEditableElement() {
          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "main";
          return this._editableElementsMap.get(e);
        }
      }, {
        key: "getEditableElementsNames",
        value: function getEditableElementsNames() {
          return this._editableElementsMap.keys();
        }
      }, {
        key: "element",
        get: function get() {
          return null;
        }
      }, {
        key: "_editableElements",
        get: function get() {
          return console.warn("editor-ui-deprecated-editable-elements: The EditorUI#_editableElements property has been deprecated and will be removed in the near future.", {
            editorUI: this
          }), this._editableElementsMap;
        }
      }]);

      return Al;
    }();

    Ke(Al, h);
    var Cl = {
      setData: function setData(e) {
        this.data.set(e);
      },
      getData: function getData(e) {
        return this.data.get(e);
      }
    };
    var Tl = {
      updateSourceElement: function updateSourceElement() {
        if (!this.sourceElement) throw new c.a("editor-missing-sourceelement", this);
        var e, t;
        e = this.sourceElement, t = this.data.get(), e instanceof HTMLTextAreaElement && (e.value = t), e.innerHTML = t;
      }
    };

    var El =
    /*#__PURE__*/
    function (_an) {
      _inherits(El, _an);

      function El() {
        _classCallCheck(this, El);

        return _possibleConstructorReturn(this, _getPrototypeOf(El).apply(this, arguments));
      }

      _createClass(El, [{
        key: "init",
        value: function init() {
          this.set("hasAny", !1), this._actions = new Zi({
            idProperty: "_id"
          }), this._actions.delegate("add", "remove").to(this);
        }
      }, {
        key: "add",
        value: function add(e) {
          if ("string" != typeof e) throw new c.a("pendingactions-add-invalid-message", this);
          var t = Object.create(Ue);
          return t.set("message", e), this._actions.add(t), this.hasAny = !0, t;
        }
      }, {
        key: "remove",
        value: function remove(e) {
          this._actions.remove(e), this.hasAny = !!this._actions.length;
        }
      }, {
        key: Symbol.iterator,
        value: function value() {
          return this._actions[Symbol.iterator]();
        }
      }, {
        key: "first",
        get: function get() {
          return this._actions.get(0);
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "PendingActions";
        }
      }]);

      return El;
    }(an);

    var Sl = {
      cancel: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m11.591 10.177 4.243 4.242a1 1 0 0 1-1.415 1.415l-4.242-4.243-4.243 4.243a1 1 0 0 1-1.414-1.415l4.243-4.242L4.52 5.934A1 1 0 0 1 5.934 4.52l4.243 4.243 4.242-4.243a1 1 0 1 1 1.415 1.414l-4.243 4.243z"/></svg>',
      caption: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 16h9a1 1 0 0 1 0 2H2a1 1 0 0 1 0-2z"/><path d="M17 1a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h14zm0 1.5H3a.5.5 0 0 0-.492.41L2.5 3v9a.5.5 0 0 0 .41.492L3 12.5h14a.5.5 0 0 0 .492-.41L17.5 12V3a.5.5 0 0 0-.41-.492L17 2.5z" fill-opacity=".6"/></svg>',
      check: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M6.972 16.615a.997.997 0 0 1-.744-.292l-4.596-4.596a1 1 0 1 1 1.414-1.414l3.926 3.926 9.937-9.937a1 1 0 0 1 1.414 1.415L7.717 16.323a.997.997 0 0 1-.745.292z"/></svg>',
      eraser: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m8.636 9.531-2.758 3.94a.5.5 0 0 0 .122.696l3.224 2.284h1.314l2.636-3.736L8.636 9.53zm.288 8.451L5.14 15.396a2 2 0 0 1-.491-2.786l6.673-9.53a2 2 0 0 1 2.785-.49l3.742 2.62a2 2 0 0 1 .491 2.785l-7.269 10.053-2.147-.066z"/><path d="M4 18h5.523v-1H4zm-2 0h1v-1H2z"/></svg>',
      lowVision: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M5.085 6.22 2.943 4.078a.75.75 0 1 1 1.06-1.06l2.592 2.59A11.094 11.094 0 0 1 10 5.068c4.738 0 8.578 3.101 8.578 5.083 0 1.197-1.401 2.803-3.555 3.887l1.714 1.713a.75.75 0 0 1-.09 1.138.488.488 0 0 1-.15.084.75.75 0 0 1-.821-.16L6.17 7.304c-.258.11-.51.233-.757.365l6.239 6.24-.006.005.78.78c-.388.094-.78.166-1.174.215l-1.11-1.11h.011L4.55 8.197a7.2 7.2 0 0 0-.665.514l-.112.098 4.897 4.897-.005.006 1.276 1.276a10.164 10.164 0 0 1-1.477-.117l-.479-.479-.009.009-4.863-4.863-.022.031a2.563 2.563 0 0 0-.124.2c-.043.077-.08.158-.108.241a.534.534 0 0 0-.028.133.29.29 0 0 0 .008.072.927.927 0 0 0 .082.226c.067.133.145.26.234.379l3.242 3.365.025.01.59.623c-3.265-.918-5.59-3.155-5.59-4.668 0-1.194 1.448-2.838 3.663-3.93zm7.07.531a4.632 4.632 0 0 1 1.108 5.992l.345.344.046-.018a9.313 9.313 0 0 0 2-1.112c.256-.187.5-.392.727-.613.137-.134.27-.277.392-.431.072-.091.141-.185.203-.286.057-.093.107-.19.148-.292a.72.72 0 0 0 .036-.12.29.29 0 0 0 .008-.072.492.492 0 0 0-.028-.133.999.999 0 0 0-.036-.096 2.165 2.165 0 0 0-.071-.145 2.917 2.917 0 0 0-.125-.2 3.592 3.592 0 0 0-.263-.335 5.444 5.444 0 0 0-.53-.523 7.955 7.955 0 0 0-1.054-.768 9.766 9.766 0 0 0-1.879-.891c-.337-.118-.68-.219-1.027-.301zm-2.85.21-.069.002a.508.508 0 0 0-.254.097.496.496 0 0 0-.104.679.498.498 0 0 0 .326.199l.045.005c.091.003.181.003.272.012a2.45 2.45 0 0 1 2.017 1.513c.024.061.043.125.069.185a.494.494 0 0 0 .45.287h.008a.496.496 0 0 0 .35-.158.482.482 0 0 0 .13-.335.638.638 0 0 0-.048-.219 3.379 3.379 0 0 0-.36-.723 3.438 3.438 0 0 0-2.791-1.543l-.028-.001h-.013z"/></svg>',
      image: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M6.91 10.54c.26-.23.64-.21.88.03l3.36 3.14 2.23-2.06a.64.64 0 0 1 .87 0l2.52 2.97V4.5H3.2v10.12l3.71-4.08zm10.27-7.51c.6 0 1.09.47 1.09 1.05v11.84c0 .59-.49 1.06-1.09 1.06H2.79c-.6 0-1.09-.47-1.09-1.06V4.08c0-.58.49-1.05 1.1-1.05h14.38zm-5.22 5.56a1.96 1.96 0 1 1 3.4-1.96 1.96 1.96 0 0 1-3.4 1.96z"/></svg>',
      alignBottom: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m9.239 13.938-2.88-1.663a.75.75 0 0 1 .75-1.3L9 12.067V4.75a.75.75 0 1 1 1.5 0v7.318l1.89-1.093a.75.75 0 0 1 .75 1.3l-2.879 1.663a.752.752 0 0 1-.511.187.752.752 0 0 1-.511-.187zM4.25 17a.75.75 0 1 1 0-1.5h10.5a.75.75 0 0 1 0 1.5H4.25z"/></svg>',
      alignMiddle: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M9.75 11.875a.752.752 0 0 1 .508.184l2.883 1.666a.75.75 0 0 1-.659 1.344l-.091-.044-1.892-1.093.001 4.318a.75.75 0 1 1-1.5 0v-4.317l-1.89 1.092a.75.75 0 0 1-.75-1.3l2.879-1.663a.752.752 0 0 1 .51-.187zM15.25 9a.75.75 0 1 1 0 1.5H4.75a.75.75 0 1 1 0-1.5h10.5zM9.75.375a.75.75 0 0 1 .75.75v4.318l1.89-1.093.092-.045a.75.75 0 0 1 .659 1.344l-2.883 1.667a.752.752 0 0 1-.508.184.752.752 0 0 1-.511-.187L6.359 5.65a.75.75 0 0 1 .75-1.299L9 5.442V1.125a.75.75 0 0 1 .75-.75z"/></svg>',
      alignTop: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m10.261 7.062 2.88 1.663a.75.75 0 0 1-.75 1.3L10.5 8.933v7.317a.75.75 0 1 1-1.5 0V8.932l-1.89 1.093a.75.75 0 0 1-.75-1.3l2.879-1.663a.752.752 0 0 1 .511-.187.752.752 0 0 1 .511.187zM15.25 4a.75.75 0 1 1 0 1.5H4.75a.75.75 0 0 1 0-1.5h10.5z"/></svg>',
      alignLeft: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 4c0 .414.336.75.75.75h9.929a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0-8c0 .414.336.75.75.75h9.929a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75z"/></svg>',
      alignCenter: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm2.286 4c0 .414.336.75.75.75h9.928a.75.75 0 1 0 0-1.5H5.036a.75.75 0 0 0-.75.75zm0-8c0 .414.336.75.75.75h9.928a.75.75 0 1 0 0-1.5H5.036a.75.75 0 0 0-.75.75z"/></svg>',
      alignRight: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M18 3.75a.75.75 0 0 1-.75.75H2.75a.75.75 0 1 1 0-1.5h14.5a.75.75 0 0 1 .75.75zm0 8a.75.75 0 0 1-.75.75H2.75a.75.75 0 1 1 0-1.5h14.5a.75.75 0 0 1 .75.75zm0 4a.75.75 0 0 1-.75.75H7.321a.75.75 0 1 1 0-1.5h9.929a.75.75 0 0 1 .75.75zm0-8a.75.75 0 0 1-.75.75H7.321a.75.75 0 1 1 0-1.5h9.929a.75.75 0 0 1 .75.75z"/></svg>',
      alignJustify: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 4c0 .414.336.75.75.75h9.929a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0-8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75z"/></svg>',
      objectLeft: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm11.5 9H18v1.5h-4.5zm0-3H18v1.5h-4.5zm0-3H18v1.5h-4.5zM2 15h16v1.5H2z"/><path d="M12.003 7v5.5a1 1 0 0 1-1 1H2.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H3.5V12h6.997V7.5z"/></svg>',
      objectCenter: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm0 12h16v1.5H2z"/><path d="M15.003 7v5.5a1 1 0 0 1-1 1H5.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H6.5V12h6.997V7.5z"/></svg>',
      objectRight: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm0 12h16v1.5H2zm0-9h5v1.5H2zm0 3h5v1.5H2zm0 3h5v1.5H2z"/><path d="M18.003 7v5.5a1 1 0 0 1-1 1H8.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H9.5V12h6.997V7.5z"/></svg>',
      objectFullWidth: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm0 12h16v1.5H2z"/><path d="M18 7v5.5a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1zm-1.505.5H3.504V12h12.991V7.5z"/></svg>',
      objectInline: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm11.5 9H18v1.5h-4.5zM2 15h16v1.5H2z"/><path d="M12.003 7v5.5a1 1 0 0 1-1 1H2.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H3.5V12h6.997V7.5z"/></svg>',
      objectBlockLeft: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm0 12h16v1.5H2z"/><path d="M12.003 7v5.5a1 1 0 0 1-1 1H2.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H3.5V12h6.997V7.5z"/></svg>',
      objectBlockRight: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm0 12h16v1.5H2z"/><path d="M18.003 7v5.5a1 1 0 0 1-1 1H8.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H9.5V12h6.997V7.5z"/></svg>',
      objectSizeFull: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.5 17v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zM1 15.5v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm0-2v1h-1v-1h1zm-19 0v1H0v-1h1zM14.5 2v1h-1V2h1zm2 0v1h-1V2h1zm2 0v1h-1V2h1zm-8 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm8 0v1h-1V2h1zm-10 0v1h-1V2h1z"/><path d="M18.095 2H1.905C.853 2 0 2.895 0 4v12c0 1.105.853 2 1.905 2h16.19C19.147 18 20 17.105 20 16V4c0-1.105-.853-2-1.905-2zm0 1.5c.263 0 .476.224.476.5v12c0 .276-.213.5-.476.5H1.905a.489.489 0 0 1-.476-.5V4c0-.276.213-.5.476-.5h16.19z"/></svg>',
      objectSizeLarge: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.5 17v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zM1 15.5v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm0-2v1h-1v-1h1zm-19 0v1H0v-1h1zM14.5 2v1h-1V2h1zm2 0v1h-1V2h1zm2 0v1h-1V2h1zm-8 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm8 0v1h-1V2h1zm-10 0v1h-1V2h1z"/><path d="M13 6H2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zm0 1.5a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5V8a.5.5 0 0 1 .5-.5h11z"/></svg>',
      objectSizeSmall: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.5 17v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zM1 15.5v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm0-2v1h-1v-1h1zm-19 0v1H0v-1h1zM14.5 2v1h-1V2h1zm2 0v1h-1V2h1zm2 0v1h-1V2h1zm-8 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm8 0v1h-1V2h1zm-10 0v1h-1V2h1z"/><path d="M7 10H2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h5a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2zm0 1.5a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h5z"/></svg>',
      objectSizeMedium: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.5 17v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zM1 15.5v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm0-2v1h-1v-1h1zm-19 0v1H0v-1h1zM14.5 2v1h-1V2h1zm2 0v1h-1V2h1zm2 0v1h-1V2h1zm-8 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm8 0v1h-1V2h1zm-10 0v1h-1V2h1z"/><path d="M10 8H2a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2zm0 1.5a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5v-6a.5.5 0 0 1 .5-.5h8z"/></svg>',
      pencil: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m7.3 17.37-.061.088a1.518 1.518 0 0 1-.934.535l-4.178.663-.806-4.153a1.495 1.495 0 0 1 .187-1.058l.056-.086L8.77 2.639c.958-1.351 2.803-1.076 4.296-.03 1.497 1.047 2.387 2.693 1.433 4.055L7.3 17.37zM9.14 4.728l-5.545 8.346 3.277 2.294 5.544-8.346L9.14 4.728zM6.07 16.512l-3.276-2.295.53 2.73 2.746-.435zM9.994 3.506 13.271 5.8c.316-.452-.16-1.333-1.065-1.966-.905-.634-1.895-.78-2.212-.328zM8 18.5 9.375 17H19v1.5H8z"/></svg>',
      pilcrow: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M6.999 2H15a1 1 0 0 1 0 2h-1.004v13a1 1 0 1 1-2 0V4H8.999v13a1 1 0 1 1-2 0v-7A4 4 0 0 1 3 6a4 4 0 0 1 3.999-4z"/></svg>',
      quote: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3 10.423a6.5 6.5 0 0 1 6.056-6.408l.038.67C6.448 5.423 5.354 7.663 5.22 10H9c.552 0 .5.432.5.986v4.511c0 .554-.448.503-1 .503h-5c-.552 0-.5-.449-.5-1.003v-4.574zm8 0a6.5 6.5 0 0 1 6.056-6.408l.038.67c-2.646.739-3.74 2.979-3.873 5.315H17c.552 0 .5.432.5.986v4.511c0 .554-.448.503-1 .503h-5c-.552 0-.5-.449-.5-1.003v-4.574z"/></svg>',
      threeVerticalDots: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><circle cx="9.5" cy="4.5" r="1.5"/><circle cx="9.5" cy="10.5" r="1.5"/><circle cx="9.5" cy="16.5" r="1.5"/></svg>'
    };

    function Il(_ref105) {
      var e = _ref105.emitter,
          t = _ref105.activator,
          i = _ref105.callback,
          n = _ref105.contextElements;
      e.listenTo(document, "mousedown", function (e, o) {
        if (!t()) return;
        var r = "function" == typeof o.composedPath ? o.composedPath() : [];
        var _iteratorNormalCompletion276 = true;
        var _didIteratorError276 = false;
        var _iteratorError276 = undefined;

        try {
          for (var _iterator276 = n[Symbol.iterator](), _step276; !(_iteratorNormalCompletion276 = (_step276 = _iterator276.next()).done); _iteratorNormalCompletion276 = true) {
            var _e202 = _step276.value;
            if (_e202.contains(o.target) || r.includes(_e202)) return;
          }
        } catch (err) {
          _didIteratorError276 = true;
          _iteratorError276 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion276 && _iterator276.return != null) {
              _iterator276.return();
            }
          } finally {
            if (_didIteratorError276) {
              throw _iteratorError276;
            }
          }
        }

        i();
      });
    }

    function Pl(e) {
      e.set("_isCssTransitionsDisabled", !1), e.disableCssTransitions = function () {
        e._isCssTransitionsDisabled = !0;
      }, e.enableCssTransitions = function () {
        e._isCssTransitionsDisabled = !1;
      }, e.extendTemplate({
        attributes: {
          class: [e.bindTemplate.if("_isCssTransitionsDisabled", "ck-transitions-disabled")]
        }
      });
    }

    function Ml(_ref106) {
      var e = _ref106.view;
      e.listenTo(e.element, "submit", function (t, i) {
        i.preventDefault(), e.fire("submit");
      }, {
        useCapture: !0
      });
    }

    var Nl =
    /*#__PURE__*/
    function (_Zi) {
      _inherits(Nl, _Zi);

      function Nl() {
        var _this84;

        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        _classCallCheck(this, Nl);

        _this84 = _possibleConstructorReturn(this, _getPrototypeOf(Nl).call(this, e, {
          idProperty: "viewUid"
        })), _this84.on("add", function (e, t, i) {
          _this84._renderViewIntoCollectionParent(t, i);
        }), _this84.on("remove", function (e, t) {
          t.element && _this84._parentElement && t.element.remove();
        }), _this84._parentElement = null;
        return _this84;
      }

      _createClass(Nl, [{
        key: "destroy",
        value: function destroy() {
          this.map(function (e) {
            return e.destroy();
          });
        }
      }, {
        key: "setParent",
        value: function setParent(e) {
          this._parentElement = e;
          var _iteratorNormalCompletion277 = true;
          var _didIteratorError277 = false;
          var _iteratorError277 = undefined;

          try {
            for (var _iterator277 = this[Symbol.iterator](), _step277; !(_iteratorNormalCompletion277 = (_step277 = _iterator277.next()).done); _iteratorNormalCompletion277 = true) {
              var _e203 = _step277.value;

              this._renderViewIntoCollectionParent(_e203);
            }
          } catch (err) {
            _didIteratorError277 = true;
            _iteratorError277 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion277 && _iterator277.return != null) {
                _iterator277.return();
              }
            } finally {
              if (_didIteratorError277) {
                throw _iteratorError277;
              }
            }
          }
        }
      }, {
        key: "delegate",
        value: function delegate() {
          var _this85 = this;

          for (var _len20 = arguments.length, e = new Array(_len20), _key20 = 0; _key20 < _len20; _key20++) {
            e[_key20] = arguments[_key20];
          }

          if (!e.length || !e.every(function (e) {
            return "string" == typeof e;
          })) throw new c.a("ui-viewcollection-delegate-wrong-events", this);
          return {
            to: function to(t) {
              var _iteratorNormalCompletion278 = true;
              var _didIteratorError278 = false;
              var _iteratorError278 = undefined;

              try {
                for (var _iterator278 = _this85[Symbol.iterator](), _step278; !(_iteratorNormalCompletion278 = (_step278 = _iterator278.next()).done); _iteratorNormalCompletion278 = true) {
                  var _i207 = _step278.value;
                  var _iteratorNormalCompletion281 = true;
                  var _didIteratorError281 = false;
                  var _iteratorError281 = undefined;

                  try {
                    for (var _iterator281 = e[Symbol.iterator](), _step281; !(_iteratorNormalCompletion281 = (_step281 = _iterator281.next()).done); _iteratorNormalCompletion281 = true) {
                      var _n103 = _step281.value;

                      _i207.delegate(_n103).to(t);
                    }
                  } catch (err) {
                    _didIteratorError281 = true;
                    _iteratorError281 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion281 && _iterator281.return != null) {
                        _iterator281.return();
                      }
                    } finally {
                      if (_didIteratorError281) {
                        throw _iteratorError281;
                      }
                    }
                  }
                }
              } catch (err) {
                _didIteratorError278 = true;
                _iteratorError278 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion278 && _iterator278.return != null) {
                    _iterator278.return();
                  }
                } finally {
                  if (_didIteratorError278) {
                    throw _iteratorError278;
                  }
                }
              }

              _this85.on("add", function (i, n) {
                var _iteratorNormalCompletion279 = true;
                var _didIteratorError279 = false;
                var _iteratorError279 = undefined;

                try {
                  for (var _iterator279 = e[Symbol.iterator](), _step279; !(_iteratorNormalCompletion279 = (_step279 = _iterator279.next()).done); _iteratorNormalCompletion279 = true) {
                    var _i205 = _step279.value;
                    n.delegate(_i205).to(t);
                  }
                } catch (err) {
                  _didIteratorError279 = true;
                  _iteratorError279 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion279 && _iterator279.return != null) {
                      _iterator279.return();
                    }
                  } finally {
                    if (_didIteratorError279) {
                      throw _iteratorError279;
                    }
                  }
                }
              }), _this85.on("remove", function (i, n) {
                var _iteratorNormalCompletion280 = true;
                var _didIteratorError280 = false;
                var _iteratorError280 = undefined;

                try {
                  for (var _iterator280 = e[Symbol.iterator](), _step280; !(_iteratorNormalCompletion280 = (_step280 = _iterator280.next()).done); _iteratorNormalCompletion280 = true) {
                    var _i206 = _step280.value;
                    n.stopDelegating(_i206, t);
                  }
                } catch (err) {
                  _didIteratorError280 = true;
                  _iteratorError280 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion280 && _iterator280.return != null) {
                      _iterator280.return();
                    }
                  } finally {
                    if (_didIteratorError280) {
                      throw _iteratorError280;
                    }
                  }
                }
              });
            }
          };
        }
      }, {
        key: "_renderViewIntoCollectionParent",
        value: function _renderViewIntoCollectionParent(e, t) {
          e.isRendered || e.render(), e.element && this._parentElement && this._parentElement.insertBefore(e.element, this._parentElement.children[t]);
        }
      }]);

      return Nl;
    }(Zi);

    i(15);

    var Rl =
    /*#__PURE__*/
    function () {
      function Rl(e) {
        _classCallCheck(this, Rl);

        this.element = null, this.isRendered = !1, this.locale = e, this.t = e && e.t, this._viewCollections = new Zi(), this._unboundChildren = this.createCollection(), this._viewCollections.on("add", function (t, i) {
          i.locale = e;
        }), this.decorate("render");
      }

      _createClass(Rl, [{
        key: "createCollection",
        value: function createCollection(e) {
          var t = new Nl(e);
          return this._viewCollections.add(t), t;
        }
      }, {
        key: "registerChild",
        value: function registerChild(e) {
          Ji(e) || (e = [e]);
          var _iteratorNormalCompletion282 = true;
          var _didIteratorError282 = false;
          var _iteratorError282 = undefined;

          try {
            for (var _iterator282 = e[Symbol.iterator](), _step282; !(_iteratorNormalCompletion282 = (_step282 = _iterator282.next()).done); _iteratorNormalCompletion282 = true) {
              var _t194 = _step282.value;

              this._unboundChildren.add(_t194);
            }
          } catch (err) {
            _didIteratorError282 = true;
            _iteratorError282 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion282 && _iterator282.return != null) {
                _iterator282.return();
              }
            } finally {
              if (_didIteratorError282) {
                throw _iteratorError282;
              }
            }
          }
        }
      }, {
        key: "deregisterChild",
        value: function deregisterChild(e) {
          Ji(e) || (e = [e]);
          var _iteratorNormalCompletion283 = true;
          var _didIteratorError283 = false;
          var _iteratorError283 = undefined;

          try {
            for (var _iterator283 = e[Symbol.iterator](), _step283; !(_iteratorNormalCompletion283 = (_step283 = _iterator283.next()).done); _iteratorNormalCompletion283 = true) {
              var _t195 = _step283.value;

              this._unboundChildren.remove(_t195);
            }
          } catch (err) {
            _didIteratorError283 = true;
            _iteratorError283 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion283 && _iterator283.return != null) {
                _iterator283.return();
              }
            } finally {
              if (_didIteratorError283) {
                throw _iteratorError283;
              }
            }
          }
        }
      }, {
        key: "setTemplate",
        value: function setTemplate(e) {
          this.template = new Ol(e);
        }
      }, {
        key: "extendTemplate",
        value: function extendTemplate(e) {
          Ol.extend(this.template, e);
        }
      }, {
        key: "render",
        value: function render() {
          if (this.isRendered) throw new c.a("ui-view-render-already-rendered", this);
          this.template && (this.element = this.template.render(), this.registerChild(this.template.getViews())), this.isRendered = !0;
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.stopListening(), this._viewCollections.map(function (e) {
            return e.destroy();
          }), this.template && this.template._revertData && this.template.revert(this.element);
        }
      }, {
        key: "bindTemplate",
        get: function get() {
          return this._bindTemplate ? this._bindTemplate : this._bindTemplate = Ol.bind(this, this);
        }
      }]);

      return Rl;
    }();

    Ke(Rl, Nr), Ke(Rl, Ue);

    var Ol =
    /*#__PURE__*/
    function () {
      function Ol(e) {
        _classCallCheck(this, Ol);

        Object.assign(this, Wl(Ul(e))), this._isRendered = !1, this._revertData = null;
      }

      _createClass(Ol, [{
        key: "render",
        value: function render() {
          var e = this._renderNode({
            intoFragment: !0
          });

          return this._isRendered = !0, e;
        }
      }, {
        key: "apply",
        value: function apply(e) {
          return this._revertData = {
            children: [],
            bindings: [],
            attributes: {}
          }, this._renderNode({
            node: e,
            isApplying: !0,
            revertData: this._revertData
          }), e;
        }
      }, {
        key: "revert",
        value: function revert(e) {
          if (!this._revertData) throw new c.a("ui-template-revert-not-applied", [this, e]);

          this._revertTemplateFromNode(e, this._revertData);
        }
      }, {
        key: "getViews",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function getViews() {
          return _regeneratorRuntime.wrap(function getViews$(_context36) {
            while (1) {
              switch (_context36.prev = _context36.next) {
                case 0:
                  return _context36.delegateYield(
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function e(t) {
                    var _iteratorNormalCompletion284, _didIteratorError284, _iteratorError284, _iterator284, _step284, _i208;

                    return _regeneratorRuntime.wrap(function e$(_context35) {
                      while (1) {
                        switch (_context35.prev = _context35.next) {
                          case 0:
                            if (!t.children) {
                              _context35.next = 33;
                              break;
                            }

                            _iteratorNormalCompletion284 = true;
                            _didIteratorError284 = false;
                            _iteratorError284 = undefined;
                            _context35.prev = 4;
                            _iterator284 = t.children[Symbol.iterator]();

                          case 6:
                            if (_iteratorNormalCompletion284 = (_step284 = _iterator284.next()).done) {
                              _context35.next = 19;
                              break;
                            }

                            _i208 = _step284.value;

                            if (!Kl(_i208)) {
                              _context35.next = 13;
                              break;
                            }

                            _context35.next = 11;
                            return _i208;

                          case 11:
                            _context35.next = 16;
                            break;

                          case 13:
                            _context35.t0 = Ql(_i208);

                            if (!_context35.t0) {
                              _context35.next = 16;
                              break;
                            }

                            return _context35.delegateYield(e(_i208), "t1", 16);

                          case 16:
                            _iteratorNormalCompletion284 = true;
                            _context35.next = 6;
                            break;

                          case 19:
                            _context35.next = 25;
                            break;

                          case 21:
                            _context35.prev = 21;
                            _context35.t2 = _context35["catch"](4);
                            _didIteratorError284 = true;
                            _iteratorError284 = _context35.t2;

                          case 25:
                            _context35.prev = 25;
                            _context35.prev = 26;

                            if (!_iteratorNormalCompletion284 && _iterator284.return != null) {
                              _iterator284.return();
                            }

                          case 28:
                            _context35.prev = 28;

                            if (!_didIteratorError284) {
                              _context35.next = 31;
                              break;
                            }

                            throw _iteratorError284;

                          case 31:
                            return _context35.finish(28);

                          case 32:
                            return _context35.finish(25);

                          case 33:
                          case "end":
                            return _context35.stop();
                        }
                      }
                    }, e, null, [[4, 21, 25, 33], [26,, 28, 32]]);
                  })(this), "t0", 1);

                case 1:
                case "end":
                  return _context36.stop();
              }
            }
          }, getViews, this);
        })
      }, {
        key: "_renderNode",
        value: function _renderNode(e) {
          var t;
          if (t = e.node ? this.tag && this.text : this.tag ? this.text : !this.text, t) throw new c.a("ui-template-wrong-syntax", this);
          return this.text ? this._renderText(e) : this._renderElement(e);
        }
      }, {
        key: "_renderElement",
        value: function _renderElement(e) {
          var t = e.node;
          return t || (t = e.node = document.createElementNS(this.ns || "http://www.w3.org/1999/xhtml", this.tag)), this._renderAttributes(e), this._renderElementChildren(e), this._setUpListeners(e), t;
        }
      }, {
        key: "_renderText",
        value: function _renderText(e) {
          var t = e.node;
          return t ? e.revertData.text = t.textContent : t = e.node = document.createTextNode(""), Vl(this.text) ? this._bindToObservable({
            schema: this.text,
            updater: Bl(t),
            data: e
          }) : t.textContent = this.text.join(""), t;
        }
      }, {
        key: "_renderAttributes",
        value: function _renderAttributes(e) {
          var t, i, n, o;
          if (!this.attributes) return;
          var r = e.node,
              s = e.revertData;

          for (t in this.attributes) {
            if (n = r.getAttribute(t), i = this.attributes[t], s && (s.attributes[t] = n), o = w(i[0]) && i[0].ns ? i[0].ns : null, Vl(i)) {
              var _a13 = o ? i[0].value : i;

              s && Zl(t) && _a13.unshift(n), this._bindToObservable({
                schema: _a13,
                updater: Fl(r, t, o),
                data: e
              });
            } else "style" == t && "string" != typeof i[0] ? this._renderStyleAttribute(i[0], e) : (s && n && Zl(t) && i.unshift(n), i = i.map(function (e) {
              return e && e.value || e;
            }).reduce(function (e, t) {
              return e.concat(t);
            }, []).reduce($l, ""), Gl(i) || r.setAttributeNS(o, t, i));
          }
        }
      }, {
        key: "_renderStyleAttribute",
        value: function _renderStyleAttribute(e, t) {
          var i = t.node;

          for (var _n104 in e) {
            var _o68 = e[_n104];
            Vl(_o68) ? this._bindToObservable({
              schema: [_o68],
              updater: Hl(i, _n104),
              data: t
            }) : i.style[_n104] = _o68;
          }
        }
      }, {
        key: "_renderElementChildren",
        value: function _renderElementChildren(e) {
          var t = e.node,
              i = e.intoFragment ? document.createDocumentFragment() : t,
              n = e.isApplying;
          var o = 0;
          var _iteratorNormalCompletion285 = true;
          var _didIteratorError285 = false;
          var _iteratorError285 = undefined;

          try {
            for (var _iterator285 = this.children[Symbol.iterator](), _step285; !(_iteratorNormalCompletion285 = (_step285 = _iterator285.next()).done); _iteratorNormalCompletion285 = true) {
              var _r35 = _step285.value;

              if (Jl(_r35)) {
                if (!n) {
                  _r35.setParent(t);

                  var _iteratorNormalCompletion286 = true;
                  var _didIteratorError286 = false;
                  var _iteratorError286 = undefined;

                  try {
                    for (var _iterator286 = _r35[Symbol.iterator](), _step286; !(_iteratorNormalCompletion286 = (_step286 = _iterator286.next()).done); _iteratorNormalCompletion286 = true) {
                      var _e204 = _step286.value;
                      i.appendChild(_e204.element);
                    }
                  } catch (err) {
                    _didIteratorError286 = true;
                    _iteratorError286 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion286 && _iterator286.return != null) {
                        _iterator286.return();
                      }
                    } finally {
                      if (_didIteratorError286) {
                        throw _iteratorError286;
                      }
                    }
                  }
                }
              } else if (Kl(_r35)) n || (_r35.isRendered || _r35.render(), i.appendChild(_r35.element));else if (pr(_r35)) i.appendChild(_r35);else if (n) {
                var _t196 = {
                  children: [],
                  bindings: [],
                  attributes: {}
                };
                e.revertData.children.push(_t196), _r35._renderNode({
                  node: i.childNodes[o++],
                  isApplying: !0,
                  revertData: _t196
                });
              } else i.appendChild(_r35.render());
            }
          } catch (err) {
            _didIteratorError285 = true;
            _iteratorError285 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion285 && _iterator285.return != null) {
                _iterator285.return();
              }
            } finally {
              if (_didIteratorError285) {
                throw _iteratorError285;
              }
            }
          }

          e.intoFragment && t.appendChild(i);
        }
      }, {
        key: "_setUpListeners",
        value: function _setUpListeners(e) {
          var _this86 = this;

          if (this.eventListeners) {
            var _loop4 = function _loop4(_t197) {
              var i = _this86.eventListeners[_t197].map(function (i) {
                var _t197$split = _t197.split("@"),
                    _t197$split2 = _slicedToArray(_t197$split, 2),
                    n = _t197$split2[0],
                    o = _t197$split2[1];

                return i.activateDomEventListener(n, o, e);
              });

              e.revertData && e.revertData.bindings.push(i);
            };

            for (var _t197 in this.eventListeners) {
              _loop4(_t197);
            }
          }
        }
      }, {
        key: "_bindToObservable",
        value: function _bindToObservable(_ref107) {
          var e = _ref107.schema,
              t = _ref107.updater,
              i = _ref107.data;
          var n = i.revertData;
          jl(e, t, i);
          var o = e.filter(function (e) {
            return !Gl(e);
          }).filter(function (e) {
            return e.observable;
          }).map(function (n) {
            return n.activateAttributeListener(e, t, i);
          });
          n && n.bindings.push(o);
        }
      }, {
        key: "_revertTemplateFromNode",
        value: function _revertTemplateFromNode(e, t) {
          var _iteratorNormalCompletion287 = true;
          var _didIteratorError287 = false;
          var _iteratorError287 = undefined;

          try {
            for (var _iterator287 = t.bindings[Symbol.iterator](), _step287; !(_iteratorNormalCompletion287 = (_step287 = _iterator287.next()).done); _iteratorNormalCompletion287 = true) {
              var _e205 = _step287.value;
              var _iteratorNormalCompletion288 = true;
              var _didIteratorError288 = false;
              var _iteratorError288 = undefined;

              try {
                for (var _iterator288 = _e205[Symbol.iterator](), _step288; !(_iteratorNormalCompletion288 = (_step288 = _iterator288.next()).done); _iteratorNormalCompletion288 = true) {
                  var _t198 = _step288.value;

                  _t198();
                }
              } catch (err) {
                _didIteratorError288 = true;
                _iteratorError288 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion288 && _iterator288.return != null) {
                    _iterator288.return();
                  }
                } finally {
                  if (_didIteratorError288) {
                    throw _iteratorError288;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError287 = true;
            _iteratorError287 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion287 && _iterator287.return != null) {
                _iterator287.return();
              }
            } finally {
              if (_didIteratorError287) {
                throw _iteratorError287;
              }
            }
          }

          if (t.text) e.textContent = t.text;else {
            for (var _i209 in t.attributes) {
              var _n105 = t.attributes[_i209];
              null === _n105 ? e.removeAttribute(_i209) : e.setAttribute(_i209, _n105);
            }

            for (var _i210 = 0; _i210 < t.children.length; ++_i210) {
              this._revertTemplateFromNode(e.childNodes[_i210], t.children[_i210]);
            }
          }
        }
      }], [{
        key: "bind",
        value: function bind(e, t) {
          return {
            to: function to(i, n) {
              return new Dl({
                eventNameOrFunction: i,
                attribute: i,
                observable: e,
                emitter: t,
                callback: n
              });
            },
            if: function _if(i, n, o) {
              return new Ll({
                observable: e,
                emitter: t,
                attribute: i,
                valueIfTrue: n,
                callback: o
              });
            }
          };
        }
      }, {
        key: "extend",
        value: function extend(e, t) {
          if (e._isRendered) throw new c.a("template-extend-render", [this, e]);
          !function e(t, i) {
            var _t$text;

            i.attributes && (t.attributes || (t.attributes = {}), Yl(t.attributes, i.attributes));
            i.eventListeners && (t.eventListeners || (t.eventListeners = {}), Yl(t.eventListeners, i.eventListeners));
            i.text && (_t$text = t.text).push.apply(_t$text, _toConsumableArray(i.text));

            if (i.children && i.children.length) {
              if (t.children.length != i.children.length) throw new c.a("ui-template-extend-children-mismatch", t);
              var _n106 = 0;
              var _iteratorNormalCompletion289 = true;
              var _didIteratorError289 = false;
              var _iteratorError289 = undefined;

              try {
                for (var _iterator289 = i.children[Symbol.iterator](), _step289; !(_iteratorNormalCompletion289 = (_step289 = _iterator289.next()).done); _iteratorNormalCompletion289 = true) {
                  var _o69 = _step289.value;
                  e(t.children[_n106++], _o69);
                }
              } catch (err) {
                _didIteratorError289 = true;
                _iteratorError289 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion289 && _iterator289.return != null) {
                    _iterator289.return();
                  }
                } finally {
                  if (_didIteratorError289) {
                    throw _iteratorError289;
                  }
                }
              }
            }
          }(e, Wl(Ul(t)));
        }
      }]);

      return Ol;
    }();

    Ke(Ol, h);

    var zl =
    /*#__PURE__*/
    function () {
      function zl(e) {
        _classCallCheck(this, zl);

        Object.assign(this, e);
      }

      _createClass(zl, [{
        key: "getValue",
        value: function getValue(e) {
          var t = this.observable[this.attribute];
          return this.callback ? this.callback(t, e) : t;
        }
      }, {
        key: "activateAttributeListener",
        value: function activateAttributeListener(e, t, i) {
          var _this87 = this;

          var n = function n() {
            return jl(e, t, i);
          };

          return this.emitter.listenTo(this.observable, "change:" + this.attribute, n), function () {
            _this87.emitter.stopListening(_this87.observable, "change:" + _this87.attribute, n);
          };
        }
      }]);

      return zl;
    }();

    var Dl =
    /*#__PURE__*/
    function (_zl) {
      _inherits(Dl, _zl);

      function Dl() {
        _classCallCheck(this, Dl);

        return _possibleConstructorReturn(this, _getPrototypeOf(Dl).apply(this, arguments));
      }

      _createClass(Dl, [{
        key: "activateDomEventListener",
        value: function activateDomEventListener(e, t, i) {
          var _this88 = this;

          var n = function n(e, i) {
            t && !i.target.matches(t) || ("function" == typeof _this88.eventNameOrFunction ? _this88.eventNameOrFunction(i) : _this88.observable.fire(_this88.eventNameOrFunction, i));
          };

          return this.emitter.listenTo(i.node, e, n), function () {
            _this88.emitter.stopListening(i.node, e, n);
          };
        }
      }]);

      return Dl;
    }(zl);

    var Ll =
    /*#__PURE__*/
    function (_zl2) {
      _inherits(Ll, _zl2);

      function Ll() {
        _classCallCheck(this, Ll);

        return _possibleConstructorReturn(this, _getPrototypeOf(Ll).apply(this, arguments));
      }

      _createClass(Ll, [{
        key: "getValue",
        value: function getValue(e) {
          return !Gl(_get(_getPrototypeOf(Ll.prototype), "getValue", this).call(this, e)) && (this.valueIfTrue || !0);
        }
      }]);

      return Ll;
    }(zl);

    function Vl(e) {
      return !!e && (e.value && (e = e.value), Array.isArray(e) ? e.some(Vl) : e instanceof zl);
    }

    function jl(e, t, _ref108) {
      var i = _ref108.node;

      var n = function (e, t) {
        return e.map(function (e) {
          return e instanceof zl ? e.getValue(t) : e;
        });
      }(e, i);

      n = 1 == e.length && e[0] instanceof Ll ? n[0] : n.reduce($l, ""), Gl(n) ? t.remove() : t.set(n);
    }

    function Bl(e) {
      return {
        set: function set(t) {
          e.textContent = t;
        },
        remove: function remove() {
          e.textContent = "";
        }
      };
    }

    function Fl(e, t, i) {
      return {
        set: function set(n) {
          e.setAttributeNS(i, t, n);
        },
        remove: function remove() {
          e.removeAttributeNS(i, t);
        }
      };
    }

    function Hl(e, t) {
      return {
        set: function set(i) {
          e.style[t] = i;
        },
        remove: function remove() {
          e.style[t] = null;
        }
      };
    }

    function Ul(e) {
      return $i(e, function (e) {
        if (e && (e instanceof zl || Ql(e) || Kl(e) || Jl(e))) return e;
      });
    }

    function Wl(e) {
      if ("string" == typeof e ? e = function (e) {
        return {
          text: [e]
        };
      }(e) : e.text && function (e) {
        e.text = en(e.text);
      }(e), e.on && (e.eventListeners = function (e) {
        for (var _t199 in e) {
          ql(e, _t199);
        }

        return e;
      }(e.on), delete e.on), !e.text) {
        e.attributes && function (e) {
          for (var _t201 in e) {
            e[_t201].value && (e[_t201].value = en(e[_t201].value)), ql(e, _t201);
          }
        }(e.attributes);
        var _t200 = [];
        if (e.children) if (Jl(e.children)) _t200.push(e.children);else {
          var _iteratorNormalCompletion290 = true;
          var _didIteratorError290 = false;
          var _iteratorError290 = undefined;

          try {
            for (var _iterator290 = e.children[Symbol.iterator](), _step290; !(_iteratorNormalCompletion290 = (_step290 = _iterator290.next()).done); _iteratorNormalCompletion290 = true) {
              var _i211 = _step290.value;
              Ql(_i211) || Kl(_i211) || pr(_i211) ? _t200.push(_i211) : _t200.push(new Ol(_i211));
            }
          } catch (err) {
            _didIteratorError290 = true;
            _iteratorError290 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion290 && _iterator290.return != null) {
                _iterator290.return();
              }
            } finally {
              if (_didIteratorError290) {
                throw _iteratorError290;
              }
            }
          }
        }
        e.children = _t200;
      }

      return e;
    }

    function ql(e, t) {
      e[t] = en(e[t]);
    }

    function $l(e, t) {
      return Gl(t) ? e : Gl(e) ? t : "".concat(e, " ").concat(t);
    }

    function Yl(e, t) {
      for (var _i212 in t) {
        var _e$_i;

        e[_i212] ? (_e$_i = e[_i212]).push.apply(_e$_i, _toConsumableArray(t[_i212])) : e[_i212] = t[_i212];
      }
    }

    function Gl(e) {
      return !e && 0 !== e;
    }

    function Kl(e) {
      return e instanceof Rl;
    }

    function Ql(e) {
      return e instanceof Ol;
    }

    function Jl(e) {
      return e instanceof Nl;
    }

    function Zl(e) {
      return "class" == e || "style" == e;
    }

    var Xl =
    /*#__PURE__*/
    function (_Nl) {
      _inherits(Xl, _Nl);

      function Xl(e) {
        var _this89;

        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

        _classCallCheck(this, Xl);

        _this89 = _possibleConstructorReturn(this, _getPrototypeOf(Xl).call(this, t)), _this89.locale = e;
        return _this89;
      }

      _createClass(Xl, [{
        key: "attachToDom",
        value: function attachToDom() {
          this._bodyCollectionContainer = new Ol({
            tag: "div",
            attributes: {
              class: ["ck", "ck-reset_all", "ck-body", "ck-rounded-corners"],
              dir: this.locale.uiLanguageDirection
            },
            children: this
          }).render();
          var e = document.querySelector(".ck-body-wrapper");
          e || (e = As(document, "div", {
            class: "ck-body-wrapper"
          }), document.body.appendChild(e)), e.appendChild(this._bodyCollectionContainer);
        }
      }, {
        key: "detachFromDom",
        value: function detachFromDom() {
          _get(_getPrototypeOf(Xl.prototype), "destroy", this).call(this), this._bodyCollectionContainer && this._bodyCollectionContainer.remove();
          var e = document.querySelector(".ck-body-wrapper");
          e && 0 == e.childElementCount && e.remove();
        }
      }]);

      return Xl;
    }(Nl);

    i(17);

    var ed =
    /*#__PURE__*/
    function (_Rl) {
      _inherits(ed, _Rl);

      function ed() {
        var _this90;

        _classCallCheck(this, ed);

        _this90 = _possibleConstructorReturn(this, _getPrototypeOf(ed).call(this));
        var e = _this90.bindTemplate;
        _this90.set("content", ""), _this90.set("viewBox", "0 0 20 20"), _this90.set("fillColor", ""), _this90.setTemplate({
          tag: "svg",
          ns: "http://www.w3.org/2000/svg",
          attributes: {
            class: ["ck", "ck-icon"],
            viewBox: e.to("viewBox")
          }
        });
        return _this90;
      }

      _createClass(ed, [{
        key: "render",
        value: function render() {
          var _this91 = this;

          _get(_getPrototypeOf(ed.prototype), "render", this).call(this), this._updateXMLContent(), this._colorFillPaths(), this.on("change:content", function () {
            _this91._updateXMLContent(), _this91._colorFillPaths();
          }), this.on("change:fillColor", function () {
            _this91._colorFillPaths();
          });
        }
      }, {
        key: "_updateXMLContent",
        value: function _updateXMLContent() {
          if (this.content) {
            var _e206 = new DOMParser().parseFromString(this.content.trim(), "image/svg+xml").querySelector("svg"),
                _t202 = _e206.getAttribute("viewBox");

            for (_t202 && (this.viewBox = _t202), this.element.innerHTML = ""; _e206.childNodes.length > 0;) {
              this.element.appendChild(_e206.childNodes[0]);
            }
          }
        }
      }, {
        key: "_colorFillPaths",
        value: function _colorFillPaths() {
          var _this92 = this;

          this.fillColor && this.element.querySelectorAll(".ck-icon__fill").forEach(function (e) {
            e.style.fill = _this92.fillColor;
          });
        }
      }]);

      return ed;
    }(Rl);

    i(19);

    var td =
    /*#__PURE__*/
    function (_Rl2) {
      _inherits(td, _Rl2);

      function td(e) {
        var _this93;

        _classCallCheck(this, td);

        _this93 = _possibleConstructorReturn(this, _getPrototypeOf(td).call(this, e)), _this93.set("text", ""), _this93.set("position", "s");
        var t = _this93.bindTemplate;

        _this93.setTemplate({
          tag: "span",
          attributes: {
            class: ["ck", "ck-tooltip", t.to("position", function (e) {
              return "ck-tooltip_" + e;
            }), t.if("text", "ck-hidden", function (e) {
              return !e.trim();
            })]
          },
          children: [{
            tag: "span",
            attributes: {
              class: ["ck", "ck-tooltip__text"]
            },
            children: [{
              text: t.to("text")
            }]
          }]
        });

        return _this93;
      }

      return td;
    }(Rl);

    i(21);

    var id =
    /*#__PURE__*/
    function (_Rl3) {
      _inherits(id, _Rl3);

      function id(e) {
        var _this94;

        _classCallCheck(this, id);

        _this94 = _possibleConstructorReturn(this, _getPrototypeOf(id).call(this, e));
        var t = _this94.bindTemplate,
            i = s();
        _this94.set("class"), _this94.set("labelStyle"), _this94.set("icon"), _this94.set("isEnabled", !0), _this94.set("isOn", !1), _this94.set("isVisible", !0), _this94.set("isToggleable", !1), _this94.set("keystroke"), _this94.set("label"), _this94.set("tabindex", -1), _this94.set("tooltip"), _this94.set("tooltipPosition", "s"), _this94.set("type", "button"), _this94.set("withText", !1), _this94.set("withKeystroke", !1), _this94.children = _this94.createCollection(), _this94.tooltipView = _this94._createTooltipView(), _this94.labelView = _this94._createLabelView(i), _this94.iconView = new ed(), _this94.iconView.extendTemplate({
          attributes: {
            class: "ck-button__icon"
          }
        }), _this94.keystrokeView = _this94._createKeystrokeView(), _this94.bind("_tooltipString").to(_assertThisInitialized(_this94), "tooltip", _assertThisInitialized(_this94), "label", _assertThisInitialized(_this94), "keystroke", _this94._getTooltipString.bind(_assertThisInitialized(_this94))), _this94.setTemplate({
          tag: "button",
          attributes: {
            class: ["ck", "ck-button", t.to("class"), t.if("isEnabled", "ck-disabled", function (e) {
              return !e;
            }), t.if("isVisible", "ck-hidden", function (e) {
              return !e;
            }), t.to("isOn", function (e) {
              return e ? "ck-on" : "ck-off";
            }), t.if("withText", "ck-button_with-text"), t.if("withKeystroke", "ck-button_with-keystroke")],
            type: t.to("type", function (e) {
              return e || "button";
            }),
            tabindex: t.to("tabindex"),
            "aria-labelledby": "ck-editor__aria-label_" + i,
            "aria-disabled": t.if("isEnabled", !0, function (e) {
              return !e;
            }),
            "aria-pressed": t.to("isOn", function (e) {
              return !!_this94.isToggleable && String(e);
            })
          },
          children: _this94.children,
          on: {
            mousedown: t.to(function (e) {
              e.preventDefault();
            }),
            click: t.to(function (e) {
              _this94.isEnabled ? _this94.fire("execute") : e.preventDefault();
            })
          }
        });
        return _this94;
      }

      _createClass(id, [{
        key: "render",
        value: function render() {
          _get(_getPrototypeOf(id.prototype), "render", this).call(this), this.icon && (this.iconView.bind("content").to(this, "icon"), this.children.add(this.iconView)), this.children.add(this.tooltipView), this.children.add(this.labelView), this.withKeystroke && this.children.add(this.keystrokeView);
        }
      }, {
        key: "focus",
        value: function focus() {
          this.element.focus();
        }
      }, {
        key: "_createTooltipView",
        value: function _createTooltipView() {
          var e = new td();
          return e.bind("text").to(this, "_tooltipString"), e.bind("position").to(this, "tooltipPosition"), e;
        }
      }, {
        key: "_createLabelView",
        value: function _createLabelView(e) {
          var t = new Rl(),
              i = this.bindTemplate;
          return t.setTemplate({
            tag: "span",
            attributes: {
              class: ["ck", "ck-button__label"],
              style: i.to("labelStyle"),
              id: "ck-editor__aria-label_" + e
            },
            children: [{
              text: this.bindTemplate.to("label")
            }]
          }), t;
        }
      }, {
        key: "_createKeystrokeView",
        value: function _createKeystrokeView() {
          var e = new Rl();
          return e.setTemplate({
            tag: "span",
            attributes: {
              class: ["ck", "ck-button__keystroke"]
            },
            children: [{
              text: this.bindTemplate.to("keystroke", function (e) {
                return Do(e);
              })
            }]
          }), e;
        }
      }, {
        key: "_getTooltipString",
        value: function _getTooltipString(e, t, i) {
          return e ? "string" == typeof e ? e : (i && (i = Do(i)), e instanceof Function ? e(t, i) : "".concat(t).concat(i ? " (".concat(i, ")") : "")) : "";
        }
      }]);

      return id;
    }(Rl);

    i(23);

    var nd =
    /*#__PURE__*/
    function (_id) {
      _inherits(nd, _id);

      function nd(e) {
        var _this95;

        _classCallCheck(this, nd);

        _this95 = _possibleConstructorReturn(this, _getPrototypeOf(nd).call(this, e)), _this95.isToggleable = !0, _this95.toggleSwitchView = _this95._createToggleView(), _this95.extendTemplate({
          attributes: {
            class: "ck-switchbutton"
          }
        });
        return _this95;
      }

      _createClass(nd, [{
        key: "render",
        value: function render() {
          _get(_getPrototypeOf(nd.prototype), "render", this).call(this), this.children.add(this.toggleSwitchView);
        }
      }, {
        key: "_createToggleView",
        value: function _createToggleView() {
          var e = new Rl();
          return e.setTemplate({
            tag: "span",
            attributes: {
              class: ["ck", "ck-button__toggle"]
            },
            children: [{
              tag: "span",
              attributes: {
                class: ["ck", "ck-button__toggle__inner"]
              }
            }]
          }), e;
        }
      }]);

      return nd;
    }(id);

    var od =
    /*#__PURE__*/
    function () {
      function od(e) {
        var _this96 = this;

        _classCallCheck(this, od);

        if (Object.assign(this, e), e.actions && e.keystrokeHandler) {
          var _loop5 = function _loop5(_t203) {
            var i = e.actions[_t203];
            "string" == typeof i && (i = [i]);
            var _iteratorNormalCompletion291 = true;
            var _didIteratorError291 = false;
            var _iteratorError291 = undefined;

            try {
              for (var _iterator291 = i[Symbol.iterator](), _step291; !(_iteratorNormalCompletion291 = (_step291 = _iterator291.next()).done); _iteratorNormalCompletion291 = true) {
                var _n107 = _step291.value;
                e.keystrokeHandler.set(_n107, function (e, i) {
                  _this96[_t203](), i();
                });
              }
            } catch (err) {
              _didIteratorError291 = true;
              _iteratorError291 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion291 && _iterator291.return != null) {
                  _iterator291.return();
                }
              } finally {
                if (_didIteratorError291) {
                  throw _iteratorError291;
                }
              }
            }
          };

          for (var _t203 in e.actions) {
            _loop5(_t203);
          }
        }
      }

      _createClass(od, [{
        key: "focusFirst",
        value: function focusFirst() {
          this._focus(this.first);
        }
      }, {
        key: "focusLast",
        value: function focusLast() {
          this._focus(this.last);
        }
      }, {
        key: "focusNext",
        value: function focusNext() {
          this._focus(this.next);
        }
      }, {
        key: "focusPrevious",
        value: function focusPrevious() {
          this._focus(this.previous);
        }
      }, {
        key: "_focus",
        value: function _focus(e) {
          e && e.focus();
        }
      }, {
        key: "_getFocusableItem",
        value: function _getFocusableItem(e) {
          var t = this.current,
              i = this.focusables.length;
          if (!i) return null;
          if (null === t) return this[1 === e ? "first" : "last"];
          var n = (t + i + e) % i;

          do {
            var _t204 = this.focusables.get(n);

            if (rd(_t204)) return _t204;
            n = (n + i + e) % i;
          } while (n !== t);

          return null;
        }
      }, {
        key: "first",
        get: function get() {
          return this.focusables.find(rd) || null;
        }
      }, {
        key: "last",
        get: function get() {
          return this.focusables.filter(rd).slice(-1)[0] || null;
        }
      }, {
        key: "next",
        get: function get() {
          return this._getFocusableItem(1);
        }
      }, {
        key: "previous",
        get: function get() {
          return this._getFocusableItem(-1);
        }
      }, {
        key: "current",
        get: function get() {
          var _this97 = this;

          var e = null;
          return null === this.focusTracker.focusedElement ? null : (this.focusables.find(function (t, i) {
            var n = t.element === _this97.focusTracker.focusedElement;
            return n && (e = i), n;
          }), e);
        }
      }]);

      return od;
    }();

    function rd(e) {
      return !(!e.focus || "none" == vr.window.getComputedStyle(e.element).display);
    }

    i(25);
    var sd = '<svg viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg"><path d="M.941 4.523a.75.75 0 1 1 1.06-1.06l3.006 3.005 3.005-3.005a.75.75 0 1 1 1.06 1.06l-3.549 3.55a.75.75 0 0 1-1.168-.136L.941 4.523z"/></svg>';

    var ad =
    /*#__PURE__*/
    function (_id2) {
      _inherits(ad, _id2);

      function ad(e) {
        var _this98;

        _classCallCheck(this, ad);

        _this98 = _possibleConstructorReturn(this, _getPrototypeOf(ad).call(this, e)), _this98.arrowView = _this98._createArrowView(), _this98.extendTemplate({
          attributes: {
            "aria-haspopup": !0
          }
        }), _this98.delegate("execute").to(_assertThisInitialized(_this98), "open");
        return _this98;
      }

      _createClass(ad, [{
        key: "render",
        value: function render() {
          _get(_getPrototypeOf(ad.prototype), "render", this).call(this), this.children.add(this.arrowView);
        }
      }, {
        key: "_createArrowView",
        value: function _createArrowView() {
          var e = new ed();
          return e.content = sd, e.extendTemplate({
            attributes: {
              class: "ck-dropdown__arrow"
            }
          }), e;
        }
      }]);

      return ad;
    }(id);

    i(27);

    var cd =
    /*#__PURE__*/
    function (_Rl4) {
      _inherits(cd, _Rl4);

      function cd(e) {
        var _this99;

        _classCallCheck(this, cd);

        _this99 = _possibleConstructorReturn(this, _getPrototypeOf(cd).call(this, e));
        var t = _this99.bindTemplate;
        _this99.set("class"), _this99.set("icon"), _this99.set("isEnabled", !0), _this99.set("isOn", !1), _this99.set("isToggleable", !1), _this99.set("isVisible", !0), _this99.set("keystroke"), _this99.set("label"), _this99.set("tabindex", -1), _this99.set("tooltip"), _this99.set("tooltipPosition", "s"), _this99.set("type", "button"), _this99.set("withText", !1), _this99.children = _this99.createCollection(), _this99.actionView = _this99._createActionView(), _this99.arrowView = _this99._createArrowView(), _this99.keystrokes = new Ds(), _this99.focusTracker = new zs(), _this99.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-splitbutton", t.to("class"), t.if("isVisible", "ck-hidden", function (e) {
              return !e;
            }), _this99.arrowView.bindTemplate.if("isOn", "ck-splitbutton_open")]
          },
          children: _this99.children
        });
        return _this99;
      }

      _createClass(cd, [{
        key: "render",
        value: function render() {
          var _this100 = this;

          _get(_getPrototypeOf(cd.prototype), "render", this).call(this), this.children.add(this.actionView), this.children.add(this.arrowView), this.focusTracker.add(this.actionView.element), this.focusTracker.add(this.arrowView.element), this.keystrokes.listenTo(this.element), this.keystrokes.set("arrowright", function (e, t) {
            _this100.focusTracker.focusedElement === _this100.actionView.element && (_this100.arrowView.focus(), t());
          }), this.keystrokes.set("arrowleft", function (e, t) {
            _this100.focusTracker.focusedElement === _this100.arrowView.element && (_this100.actionView.focus(), t());
          });
        }
      }, {
        key: "focus",
        value: function focus() {
          this.actionView.focus();
        }
      }, {
        key: "_createActionView",
        value: function _createActionView() {
          var e = new id();
          return e.bind("icon", "isEnabled", "isOn", "isToggleable", "keystroke", "label", "tabindex", "tooltip", "tooltipPosition", "type", "withText").to(this), e.extendTemplate({
            attributes: {
              class: "ck-splitbutton__action"
            }
          }), e.delegate("execute").to(this), e;
        }
      }, {
        key: "_createArrowView",
        value: function _createArrowView() {
          var e = new id(),
              t = e.bindTemplate;
          return e.icon = sd, e.extendTemplate({
            attributes: {
              class: "ck-splitbutton__arrow",
              "aria-haspopup": !0,
              "aria-expanded": t.to("isOn", function (e) {
                return String(e);
              })
            }
          }), e.bind("isEnabled").to(this), e.delegate("execute").to(this, "open"), e;
        }
      }]);

      return cd;
    }(Rl);

    var ld =
    /*#__PURE__*/
    function (_Rl5) {
      _inherits(ld, _Rl5);

      function ld(e) {
        var _this101;

        _classCallCheck(this, ld);

        _this101 = _possibleConstructorReturn(this, _getPrototypeOf(ld).call(this, e));
        var t = _this101.bindTemplate;
        _this101.set("isVisible", !1), _this101.set("position", "se"), _this101.children = _this101.createCollection(), _this101.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-reset", "ck-dropdown__panel", t.to("position", function (e) {
              return "ck-dropdown__panel_" + e;
            }), t.if("isVisible", "ck-dropdown__panel-visible")]
          },
          children: _this101.children,
          on: {
            selectstart: t.to(function (e) {
              return e.preventDefault();
            })
          }
        });
        return _this101;
      }

      _createClass(ld, [{
        key: "focus",
        value: function focus() {
          this.children.length && this.children.first.focus();
        }
      }, {
        key: "focusLast",
        value: function focusLast() {
          if (this.children.length) {
            var _e207 = this.children.last;
            "function" == typeof _e207.focusLast ? _e207.focusLast() : _e207.focus();
          }
        }
      }]);

      return ld;
    }(Rl);

    i(29);

    function dd(_ref109) {
      var e = _ref109.element,
          t = _ref109.target,
          i = _ref109.positions,
          n = _ref109.limiter,
          o = _ref109.fitInViewport;
      M(t) && (t = t()), M(n) && (n = n());

      var r = function (e) {
        return e && e.parentNode ? e.offsetParent === vr.document.body ? null : e.offsetParent : null;
      }(e),
          s = new Ss(e),
          a = new Ss(t);

      var c, l;

      if (n || o) {
        var _e208 = function (e, t) {
          var i = t.elementRect,
              n = t.viewportRect,
              o = i.getArea(),
              r = function (e, _ref110) {
            var t = _ref110.targetRect,
                i = _ref110.elementRect,
                n = _ref110.limiterRect,
                o = _ref110.viewportRect;
            var r = [],
                s = i.getArea();
            var _iteratorNormalCompletion292 = true;
            var _didIteratorError292 = false;
            var _iteratorError292 = undefined;

            try {
              for (var _iterator292 = e[Symbol.iterator](), _step292; !(_iteratorNormalCompletion292 = (_step292 = _iterator292.next()).done); _iteratorNormalCompletion292 = true) {
                var _a14 = _step292.value;

                var _e209 = hd(_a14, t, i);

                if (!_e209) continue;

                var _e210 = _slicedToArray(_e209, 2),
                    _c6 = _e210[0],
                    _l2 = _e210[1];

                var _d3 = 0,
                    _h3 = 0;
                if (n) if (o) {
                  var _e211 = n.getIntersection(o);

                  _e211 && (_d3 = _e211.getIntersectionArea(_l2));
                } else _d3 = n.getIntersectionArea(_l2);
                o && (_h3 = o.getIntersectionArea(_l2));
                var _u2 = {
                  positionName: _c6,
                  positionRect: _l2,
                  limiterIntersectArea: _d3,
                  viewportIntersectArea: _h3
                };
                if (_d3 === s) return [_u2];
                r.push(_u2);
              }
            } catch (err) {
              _didIteratorError292 = true;
              _iteratorError292 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion292 && _iterator292.return != null) {
                  _iterator292.return();
                }
              } finally {
                if (_didIteratorError292) {
                  throw _iteratorError292;
                }
              }
            }

            return r;
          }(e, t);

          if (n) {
            var _e212 = ud(r.filter(function (_ref111) {
              var e = _ref111.viewportIntersectArea;
              return e === o;
            }), o);

            if (_e212) return _e212;
          }

          return ud(r, o);
        }(i, {
          targetRect: a,
          elementRect: s,
          limiterRect: n && new Ss(n).getVisible(),
          viewportRect: o && new Ss(vr.window)
        });

        var _ref112 = _e208 || hd(i[0], a, s);

        var _ref113 = _slicedToArray(_ref112, 2);

        l = _ref113[0];
        c = _ref113[1];
      } else {
        var _hd = hd(i[0], a, s);

        var _hd2 = _slicedToArray(_hd, 2);

        l = _hd2[0];
        c = _hd2[1];
      }

      var d = gd(c);
      return r && (d = function (_ref114, i) {
        var e = _ref114.left,
            t = _ref114.top;
        var n = gd(new Ss(i)),
            o = Ts(i);
        return e -= n.left, t -= n.top, e += i.scrollLeft, t += i.scrollTop, e -= o.left, t -= o.top, {
          left: e,
          top: t
        };
      }(d, r)), {
        left: d.left,
        top: d.top,
        name: l
      };
    }

    function hd(e, t, i) {
      var n = e(t, i);
      if (!n) return null;
      var o = n.left,
          r = n.top,
          s = n.name;
      return [s, i.clone().moveTo(o, r)];
    }

    function ud(e, t) {
      var i,
          n,
          o = 0;
      var _iteratorNormalCompletion293 = true;
      var _didIteratorError293 = false;
      var _iteratorError293 = undefined;

      try {
        for (var _iterator293 = e[Symbol.iterator](), _step293; !(_iteratorNormalCompletion293 = (_step293 = _iterator293.next()).done); _iteratorNormalCompletion293 = true) {
          var _ref116 = _step293.value;
          var _r36 = _ref116.positionName;
          var _s22 = _ref116.positionRect;
          var _a15 = _ref116.limiterIntersectArea;
          var _c7 = _ref116.viewportIntersectArea;
          if (_a15 === t) return [_r36, _s22];

          var _e213 = Math.pow(_c7, 2) + Math.pow(_a15, 2);

          _e213 > o && (o = _e213, i = _s22, n = _r36);
        }
      } catch (err) {
        _didIteratorError293 = true;
        _iteratorError293 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion293 && _iterator293.return != null) {
            _iterator293.return();
          }
        } finally {
          if (_didIteratorError293) {
            throw _iteratorError293;
          }
        }
      }

      return i ? [n, i] : null;
    }

    function gd(_ref117) {
      var e = _ref117.left,
          t = _ref117.top;
      var _vr$window2 = vr.window,
          i = _vr$window2.scrollX,
          n = _vr$window2.scrollY;
      return {
        left: e + i,
        top: t + n
      };
    }

    var md =
    /*#__PURE__*/
    function (_Rl6) {
      _inherits(md, _Rl6);

      function md(e, t, i) {
        var _this102;

        _classCallCheck(this, md);

        _this102 = _possibleConstructorReturn(this, _getPrototypeOf(md).call(this, e));
        var n = _this102.bindTemplate;
        _this102.buttonView = t, _this102.panelView = i, _this102.set("isOpen", !1), _this102.set("isEnabled", !0), _this102.set("class"), _this102.set("id"), _this102.set("panelPosition", "auto"), _this102.keystrokes = new Ds(), _this102.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-dropdown", n.to("class"), n.if("isEnabled", "ck-disabled", function (e) {
              return !e;
            })],
            id: n.to("id"),
            "aria-describedby": n.to("ariaDescribedById")
          },
          children: [t, i]
        }), t.extendTemplate({
          attributes: {
            class: ["ck-dropdown__button"]
          }
        });
        return _this102;
      }

      _createClass(md, [{
        key: "render",
        value: function render() {
          var _this103 = this;

          _get(_getPrototypeOf(md.prototype), "render", this).call(this), this.listenTo(this.buttonView, "open", function () {
            _this103.isOpen = !_this103.isOpen;
          }), this.panelView.bind("isVisible").to(this, "isOpen"), this.on("change:isOpen", function () {
            _this103.isOpen && ("auto" === _this103.panelPosition ? _this103.panelView.position = md._getOptimalPosition({
              element: _this103.panelView.element,
              target: _this103.buttonView.element,
              fitInViewport: !0,
              positions: _this103._panelPositions
            }).name : _this103.panelView.position = _this103.panelPosition);
          }), this.keystrokes.listenTo(this.element);

          var e = function e(_e214, t) {
            _this103.isOpen && (_this103.buttonView.focus(), _this103.isOpen = !1, t());
          };

          this.keystrokes.set("arrowdown", function (e, t) {
            _this103.buttonView.isEnabled && !_this103.isOpen && (_this103.isOpen = !0, t());
          }), this.keystrokes.set("arrowright", function (e, t) {
            _this103.isOpen && t();
          }), this.keystrokes.set("arrowleft", e), this.keystrokes.set("esc", e);
        }
      }, {
        key: "focus",
        value: function focus() {
          this.buttonView.focus();
        }
      }, {
        key: "_panelPositions",
        get: function get() {
          var _md$defaultPanelPosit = md.defaultPanelPositions,
              e = _md$defaultPanelPosit.south,
              t = _md$defaultPanelPosit.north,
              i = _md$defaultPanelPosit.southEast,
              n = _md$defaultPanelPosit.southWest,
              o = _md$defaultPanelPosit.northEast,
              r = _md$defaultPanelPosit.northWest,
              s = _md$defaultPanelPosit.southMiddleEast,
              a = _md$defaultPanelPosit.southMiddleWest,
              c = _md$defaultPanelPosit.northMiddleEast,
              l = _md$defaultPanelPosit.northMiddleWest;
          return "rtl" !== this.locale.uiLanguageDirection ? [i, n, s, a, e, o, r, c, l, t] : [n, i, a, s, e, r, o, l, c, t];
        }
      }]);

      return md;
    }(Rl);

    md.defaultPanelPositions = {
      south: function south(e, t) {
        return {
          top: e.bottom,
          left: e.left - (t.width - e.width) / 2,
          name: "s"
        };
      },
      southEast: function southEast(e) {
        return {
          top: e.bottom,
          left: e.left,
          name: "se"
        };
      },
      southWest: function southWest(e, t) {
        return {
          top: e.bottom,
          left: e.left - t.width + e.width,
          name: "sw"
        };
      },
      southMiddleEast: function southMiddleEast(e, t) {
        return {
          top: e.bottom,
          left: e.left - (t.width - e.width) / 4,
          name: "sme"
        };
      },
      southMiddleWest: function southMiddleWest(e, t) {
        return {
          top: e.bottom,
          left: e.left - 3 * (t.width - e.width) / 4,
          name: "smw"
        };
      },
      north: function north(e, t) {
        return {
          top: e.top - t.height,
          left: e.left - (t.width - e.width) / 2,
          name: "n"
        };
      },
      northEast: function northEast(e, t) {
        return {
          top: e.top - t.height,
          left: e.left,
          name: "ne"
        };
      },
      northWest: function northWest(e, t) {
        return {
          top: e.top - t.height,
          left: e.left - t.width + e.width,
          name: "nw"
        };
      },
      northMiddleEast: function northMiddleEast(e, t) {
        return {
          top: e.top - t.height,
          left: e.left - (t.width - e.width) / 4,
          name: "nme"
        };
      },
      northMiddleWest: function northMiddleWest(e, t) {
        return {
          top: e.top - t.height,
          left: e.left - 3 * (t.width - e.width) / 4,
          name: "nmw"
        };
      }
    }, md._getOptimalPosition = dd;

    var fd =
    /*#__PURE__*/
    function (_Rl7) {
      _inherits(fd, _Rl7);

      function fd(e) {
        var _this104;

        _classCallCheck(this, fd);

        _this104 = _possibleConstructorReturn(this, _getPrototypeOf(fd).call(this, e)), _this104.setTemplate({
          tag: "span",
          attributes: {
            class: ["ck", "ck-toolbar__separator"]
          }
        });
        return _this104;
      }

      return fd;
    }(Rl);

    var pd =
    /*#__PURE__*/
    function (_Rl8) {
      _inherits(pd, _Rl8);

      function pd(e) {
        var _this105;

        _classCallCheck(this, pd);

        _this105 = _possibleConstructorReturn(this, _getPrototypeOf(pd).call(this, e)), _this105.setTemplate({
          tag: "span",
          attributes: {
            class: ["ck", "ck-toolbar__line-break"]
          }
        });
        return _this105;
      }

      return pd;
    }(Rl);

    function bd(e) {
      return Array.isArray(e) ? {
        items: e,
        removeItems: []
      } : e ? Object.assign({
        items: [],
        removeItems: []
      }, e) : {
        items: [],
        removeItems: []
      };
    }

    i(31);

    var wd =
    /*#__PURE__*/
    function (_Rl9) {
      _inherits(wd, _Rl9);

      function wd(e, t) {
        var _this106;

        _classCallCheck(this, wd);

        _this106 = _possibleConstructorReturn(this, _getPrototypeOf(wd).call(this, e));
        var i = _this106.bindTemplate,
            n = _this106.t;
        _this106.options = t || {}, _this106.set("ariaLabel", n("Editor toolbar")), _this106.set("maxWidth", "auto"), _this106.items = _this106.createCollection(), _this106.focusTracker = new zs(), _this106.keystrokes = new Ds(), _this106.set("class"), _this106.set("isCompact", !1), _this106.itemsView = new kd(e), _this106.children = _this106.createCollection(), _this106.children.add(_this106.itemsView), _this106.focusables = _this106.createCollection();
        var o = "rtl" === e.uiLanguageDirection;
        _this106._focusCycler = new od({
          focusables: _this106.focusables,
          focusTracker: _this106.focusTracker,
          keystrokeHandler: _this106.keystrokes,
          actions: {
            focusPrevious: [o ? "arrowright" : "arrowleft", "arrowup"],
            focusNext: [o ? "arrowleft" : "arrowright", "arrowdown"]
          }
        });
        var r = ["ck", "ck-toolbar", i.to("class"), i.if("isCompact", "ck-toolbar_compact")];
        var s;
        _this106.options.shouldGroupWhenFull && _this106.options.isFloating && r.push("ck-toolbar_floating"), _this106.setTemplate({
          tag: "div",
          attributes: {
            class: r,
            role: "toolbar",
            "aria-label": i.to("ariaLabel"),
            style: {
              maxWidth: i.to("maxWidth")
            }
          },
          children: _this106.children,
          on: {
            mousedown: (s = _assertThisInitialized(_this106), s.bindTemplate.to(function (e) {
              e.target === s.element && e.preventDefault();
            }))
          }
        }), _this106._behavior = _this106.options.shouldGroupWhenFull ? new vd(_assertThisInitialized(_this106)) : new _d(_assertThisInitialized(_this106));
        return _this106;
      }

      _createClass(wd, [{
        key: "render",
        value: function render() {
          var _this107 = this;

          _get(_getPrototypeOf(wd.prototype), "render", this).call(this);

          var _iteratorNormalCompletion294 = true;
          var _didIteratorError294 = false;
          var _iteratorError294 = undefined;

          try {
            for (var _iterator294 = this.items[Symbol.iterator](), _step294; !(_iteratorNormalCompletion294 = (_step294 = _iterator294.next()).done); _iteratorNormalCompletion294 = true) {
              var _e215 = _step294.value;
              this.focusTracker.add(_e215.element);
            }
          } catch (err) {
            _didIteratorError294 = true;
            _iteratorError294 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion294 && _iterator294.return != null) {
                _iterator294.return();
              }
            } finally {
              if (_didIteratorError294) {
                throw _iteratorError294;
              }
            }
          }

          this.items.on("add", function (e, t) {
            _this107.focusTracker.add(t.element);
          }), this.items.on("remove", function (e, t) {
            _this107.focusTracker.remove(t.element);
          }), this.keystrokes.listenTo(this.element), this._behavior.render(this);
        }
      }, {
        key: "destroy",
        value: function destroy() {
          return this._behavior.destroy(), _get(_getPrototypeOf(wd.prototype), "destroy", this).call(this);
        }
      }, {
        key: "focus",
        value: function focus() {
          this._focusCycler.focusFirst();
        }
      }, {
        key: "focusLast",
        value: function focusLast() {
          this._focusCycler.focusLast();
        }
      }, {
        key: "fillFromConfig",
        value: function fillFromConfig(e, t) {
          var _this108 = this;

          var i = bd(e),
              n = i.items.filter(function (e, n, o) {
            return "|" === e || -1 === i.removeItems.indexOf(e) && ("-" === e ? !_this108.options.shouldGroupWhenFull || (Object(c.b)("toolbarview-line-break-ignored-when-grouping-items", o), !1) : !!t.has(e) || (Object(c.b)("toolbarview-item-unavailable", {
              name: e
            }), !1));
          }),
              o = this._cleanSeparators(n).map(function (e) {
            return "|" === e ? new fd() : "-" === e ? new pd() : t.create(e);
          });

          this.items.addMany(o);
        }
      }, {
        key: "_cleanSeparators",
        value: function _cleanSeparators(e) {
          var t = function t(e) {
            return "-" !== e && "|" !== e;
          },
              i = e.length,
              n = e.findIndex(t),
              o = i - e.slice().reverse().findIndex(t);

          return e.slice(n, o).filter(function (e, i, n) {
            if (t(e)) return !0;
            return !(i > 0 && n[i - 1] === e);
          });
        }
      }]);

      return wd;
    }(Rl);

    var kd =
    /*#__PURE__*/
    function (_Rl10) {
      _inherits(kd, _Rl10);

      function kd(e) {
        var _this109;

        _classCallCheck(this, kd);

        _this109 = _possibleConstructorReturn(this, _getPrototypeOf(kd).call(this, e)), _this109.children = _this109.createCollection(), _this109.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-toolbar__items"]
          },
          children: _this109.children
        });
        return _this109;
      }

      return kd;
    }(Rl);

    var _d =
    /*#__PURE__*/
    function () {
      function _d(e) {
        _classCallCheck(this, _d);

        var t = e.bindTemplate;
        e.set("isVertical", !1), e.itemsView.children.bindTo(e.items).using(function (e) {
          return e;
        }), e.focusables.bindTo(e.items).using(function (e) {
          return e;
        }), e.extendTemplate({
          attributes: {
            class: [t.if("isVertical", "ck-toolbar_vertical")]
          }
        });
      }

      _createClass(_d, [{
        key: "render",
        value: function render() {}
      }, {
        key: "destroy",
        value: function destroy() {}
      }]);

      return _d;
    }();

    var vd =
    /*#__PURE__*/
    function () {
      function vd(e) {
        var _this110 = this;

        _classCallCheck(this, vd);

        this.view = e, this.viewChildren = e.children, this.viewFocusables = e.focusables, this.viewItemsView = e.itemsView, this.viewFocusTracker = e.focusTracker, this.viewLocale = e.locale, this.ungroupedItems = e.createCollection(), this.groupedItems = e.createCollection(), this.groupedItemsDropdown = this._createGroupedItemsDropdown(), this.resizeObserver = null, this.cachedPadding = null, this.shouldUpdateGroupingOnNextResize = !1, e.itemsView.children.bindTo(this.ungroupedItems).using(function (e) {
          return e;
        }), this.ungroupedItems.on("add", this._updateFocusCycleableItems.bind(this)), this.ungroupedItems.on("remove", this._updateFocusCycleableItems.bind(this)), e.children.on("add", this._updateFocusCycleableItems.bind(this)), e.children.on("remove", this._updateFocusCycleableItems.bind(this)), e.items.on("change", function (e, t) {
          var i = t.index;
          var _iteratorNormalCompletion295 = true;
          var _didIteratorError295 = false;
          var _iteratorError295 = undefined;

          try {
            for (var _iterator295 = t.removed[Symbol.iterator](), _step295; !(_iteratorNormalCompletion295 = (_step295 = _iterator295.next()).done); _iteratorNormalCompletion295 = true) {
              var _e217 = _step295.value;
              i >= _this110.ungroupedItems.length ? _this110.groupedItems.remove(_e217) : _this110.ungroupedItems.remove(_e217);
            }
          } catch (err) {
            _didIteratorError295 = true;
            _iteratorError295 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion295 && _iterator295.return != null) {
                _iterator295.return();
              }
            } finally {
              if (_didIteratorError295) {
                throw _iteratorError295;
              }
            }
          }

          for (var _e216 = i; _e216 < i + t.added.length; _e216++) {
            var _n108 = t.added[_e216 - i];
            _e216 > _this110.ungroupedItems.length ? _this110.groupedItems.add(_n108, _e216 - _this110.ungroupedItems.length) : _this110.ungroupedItems.add(_n108, _e216);
          }

          _this110._updateGrouping();
        }), e.extendTemplate({
          attributes: {
            class: ["ck-toolbar_grouping"]
          }
        });
      }

      _createClass(vd, [{
        key: "render",
        value: function render(e) {
          this.viewElement = e.element, this._enableGroupingOnResize(), this._enableGroupingOnMaxWidthChange(e);
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.groupedItemsDropdown.destroy(), this.resizeObserver.destroy();
        }
      }, {
        key: "_updateGrouping",
        value: function _updateGrouping() {
          if (!this.viewElement.ownerDocument.body.contains(this.viewElement)) return;
          if (!this.viewElement.offsetParent) return void (this.shouldUpdateGroupingOnNextResize = !0);
          var e = this.groupedItems.length;
          var t;

          for (; this._areItemsOverflowing;) {
            this._groupLastItem(), t = !0;
          }

          if (!t && this.groupedItems.length) {
            for (; this.groupedItems.length && !this._areItemsOverflowing;) {
              this._ungroupFirstItem();
            }

            this._areItemsOverflowing && this._groupLastItem();
          }

          this.groupedItems.length !== e && this.view.fire("groupedItemsUpdate");
        }
      }, {
        key: "_enableGroupingOnResize",
        value: function _enableGroupingOnResize() {
          var _this111 = this;

          var e;
          this.resizeObserver = new Ms(this.viewElement, function (t) {
            e && e === t.contentRect.width && !_this111.shouldUpdateGroupingOnNextResize || (_this111.shouldUpdateGroupingOnNextResize = !1, _this111._updateGrouping(), e = t.contentRect.width);
          }), this._updateGrouping();
        }
      }, {
        key: "_enableGroupingOnMaxWidthChange",
        value: function _enableGroupingOnMaxWidthChange(e) {
          var _this112 = this;

          e.on("change:maxWidth", function () {
            _this112._updateGrouping();
          });
        }
      }, {
        key: "_groupLastItem",
        value: function _groupLastItem() {
          this.groupedItems.length || (this.viewChildren.add(new fd()), this.viewChildren.add(this.groupedItemsDropdown), this.viewFocusTracker.add(this.groupedItemsDropdown.element)), this.groupedItems.add(this.ungroupedItems.remove(this.ungroupedItems.last), 0);
        }
      }, {
        key: "_ungroupFirstItem",
        value: function _ungroupFirstItem() {
          this.ungroupedItems.add(this.groupedItems.remove(this.groupedItems.first)), this.groupedItems.length || (this.viewChildren.remove(this.groupedItemsDropdown), this.viewChildren.remove(this.viewChildren.last), this.viewFocusTracker.remove(this.groupedItemsDropdown.element));
        }
      }, {
        key: "_createGroupedItemsDropdown",
        value: function _createGroupedItemsDropdown() {
          var e = this.viewLocale,
              t = e.t,
              i = Cd(e);
          return i.class = "ck-toolbar__grouped-dropdown", i.panelPosition = "ltr" === e.uiLanguageDirection ? "sw" : "se", Td(i, []), i.buttonView.set({
            label: t("Show more items"),
            tooltip: !0,
            tooltipPosition: "rtl" === e.uiLanguageDirection ? "se" : "sw",
            icon: Sl.threeVerticalDots
          }), i.toolbarView.items.bindTo(this.groupedItems).using(function (e) {
            return e;
          }), i;
        }
      }, {
        key: "_updateFocusCycleableItems",
        value: function _updateFocusCycleableItems() {
          var _this113 = this;

          this.viewFocusables.clear(), this.ungroupedItems.map(function (e) {
            _this113.viewFocusables.add(e);
          }), this.groupedItems.length && this.viewFocusables.add(this.groupedItemsDropdown);
        }
      }, {
        key: "_areItemsOverflowing",
        get: function get() {
          if (!this.ungroupedItems.length) return !1;
          var e = this.viewElement,
              t = this.viewLocale.uiLanguageDirection,
              i = new Ss(e.lastChild),
              n = new Ss(e);

          if (!this.cachedPadding) {
            var _i213 = vr.window.getComputedStyle(e),
                _n109 = "ltr" === t ? "paddingRight" : "paddingLeft";

            this.cachedPadding = Number.parseInt(_i213[_n109]);
          }

          return "ltr" === t ? i.right > n.right - this.cachedPadding : i.left < n.left + this.cachedPadding;
        }
      }]);

      return vd;
    }();

    i(33);

    var yd =
    /*#__PURE__*/
    function (_Rl11) {
      _inherits(yd, _Rl11);

      function yd() {
        var _this114;

        _classCallCheck(this, yd);

        _this114 = _possibleConstructorReturn(this, _getPrototypeOf(yd).call(this)), _this114.items = _this114.createCollection(), _this114.focusTracker = new zs(), _this114.keystrokes = new Ds(), _this114._focusCycler = new od({
          focusables: _this114.items,
          focusTracker: _this114.focusTracker,
          keystrokeHandler: _this114.keystrokes,
          actions: {
            focusPrevious: "arrowup",
            focusNext: "arrowdown"
          }
        }), _this114.setTemplate({
          tag: "ul",
          attributes: {
            class: ["ck", "ck-reset", "ck-list"]
          },
          children: _this114.items
        });
        return _this114;
      }

      _createClass(yd, [{
        key: "render",
        value: function render() {
          var _this115 = this;

          _get(_getPrototypeOf(yd.prototype), "render", this).call(this);

          var _iteratorNormalCompletion296 = true;
          var _didIteratorError296 = false;
          var _iteratorError296 = undefined;

          try {
            for (var _iterator296 = this.items[Symbol.iterator](), _step296; !(_iteratorNormalCompletion296 = (_step296 = _iterator296.next()).done); _iteratorNormalCompletion296 = true) {
              var _e218 = _step296.value;
              this.focusTracker.add(_e218.element);
            }
          } catch (err) {
            _didIteratorError296 = true;
            _iteratorError296 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion296 && _iterator296.return != null) {
                _iterator296.return();
              }
            } finally {
              if (_didIteratorError296) {
                throw _iteratorError296;
              }
            }
          }

          this.items.on("add", function (e, t) {
            _this115.focusTracker.add(t.element);
          }), this.items.on("remove", function (e, t) {
            _this115.focusTracker.remove(t.element);
          }), this.keystrokes.listenTo(this.element);
        }
      }, {
        key: "focus",
        value: function focus() {
          this._focusCycler.focusFirst();
        }
      }, {
        key: "focusLast",
        value: function focusLast() {
          this._focusCycler.focusLast();
        }
      }]);

      return yd;
    }(Rl);

    var xd =
    /*#__PURE__*/
    function (_Rl12) {
      _inherits(xd, _Rl12);

      function xd(e) {
        var _this116;

        _classCallCheck(this, xd);

        _this116 = _possibleConstructorReturn(this, _getPrototypeOf(xd).call(this, e)), _this116.children = _this116.createCollection(), _this116.setTemplate({
          tag: "li",
          attributes: {
            class: ["ck", "ck-list__item"]
          },
          children: _this116.children
        });
        return _this116;
      }

      _createClass(xd, [{
        key: "focus",
        value: function focus() {
          this.children.first.focus();
        }
      }]);

      return xd;
    }(Rl);

    var Ad =
    /*#__PURE__*/
    function (_Rl13) {
      _inherits(Ad, _Rl13);

      function Ad(e) {
        var _this117;

        _classCallCheck(this, Ad);

        _this117 = _possibleConstructorReturn(this, _getPrototypeOf(Ad).call(this, e)), _this117.setTemplate({
          tag: "li",
          attributes: {
            class: ["ck", "ck-list__separator"]
          }
        });
        return _this117;
      }

      return Ad;
    }(Rl);

    i(35), i(37);

    function Cd(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ad;
      var i = new t(e),
          n = new ld(e),
          o = new md(e, i, n);
      return i.bind("isEnabled").to(o), i instanceof ad ? i.bind("isOn").to(o, "isOpen") : i.arrowView.bind("isOn").to(o, "isOpen"), function (e) {
        (function (e) {
          e.on("render", function () {
            Il({
              emitter: e,
              activator: function activator() {
                return e.isOpen;
              },
              callback: function callback() {
                e.isOpen = !1;
              },
              contextElements: [e.element]
            });
          });
        })(e), function (e) {
          e.on("execute", function (t) {
            t.source instanceof nd || (e.isOpen = !1);
          });
        }(e), function (e) {
          e.keystrokes.set("arrowdown", function (t, i) {
            e.isOpen && (e.panelView.focus(), i());
          }), e.keystrokes.set("arrowup", function (t, i) {
            e.isOpen && (e.panelView.focusLast(), i());
          });
        }(e);
      }(o), o;
    }

    function Td(e, t) {
      var i = e.locale,
          n = i.t,
          o = e.toolbarView = new wd(i);
      o.set("ariaLabel", n("Dropdown toolbar")), e.extendTemplate({
        attributes: {
          class: ["ck-toolbar-dropdown"]
        }
      }), t.map(function (e) {
        return o.items.add(e);
      }), e.panelView.children.add(o), o.items.delegate("execute").to(e);
    }

    function Ed(e, t) {
      var i = e.locale,
          n = e.listView = new yd(i);
      n.items.bindTo(t).using(function (_ref118) {
        var e = _ref118.type,
            t = _ref118.model;
        if ("separator" === e) return new Ad(i);

        if ("button" === e || "switchbutton" === e) {
          var _o71;

          var _n110 = new xd(i);

          var _o70;

          return _o70 = "button" === e ? new id(i) : new nd(i), (_o71 = _o70).bind.apply(_o71, _toConsumableArray(Object.keys(t))).to(t), _o70.delegate("execute").to(_n110), _n110.children.add(_o70), _n110;
        }
      }), e.panelView.children.add(n), n.items.delegate("execute").to(e);
    }

    i(39);

    var Sd =
    /*#__PURE__*/
    function (_Rl14) {
      _inherits(Sd, _Rl14);

      function Sd(e) {
        var _this118;

        _classCallCheck(this, Sd);

        _this118 = _possibleConstructorReturn(this, _getPrototypeOf(Sd).call(this, e)), _this118.body = new Xl(e);
        return _this118;
      }

      _createClass(Sd, [{
        key: "render",
        value: function render() {
          _get(_getPrototypeOf(Sd.prototype), "render", this).call(this), this.body.attachToDom();
        }
      }, {
        key: "destroy",
        value: function destroy() {
          return this.body.detachFromDom(), _get(_getPrototypeOf(Sd.prototype), "destroy", this).call(this);
        }
      }]);

      return Sd;
    }(Rl);

    i(41);

    var Id =
    /*#__PURE__*/
    function (_Rl15) {
      _inherits(Id, _Rl15);

      function Id(e) {
        var _this119;

        _classCallCheck(this, Id);

        _this119 = _possibleConstructorReturn(this, _getPrototypeOf(Id).call(this, e)), _this119.set("text"), _this119.set("for"), _this119.id = "ck-editor__label_" + s();
        var t = _this119.bindTemplate;

        _this119.setTemplate({
          tag: "label",
          attributes: {
            class: ["ck", "ck-label"],
            id: _this119.id,
            for: t.to("for")
          },
          children: [{
            text: t.to("text")
          }]
        });

        return _this119;
      }

      return Id;
    }(Rl);

    var Pd =
    /*#__PURE__*/
    function (_Sd) {
      _inherits(Pd, _Sd);

      function Pd(e) {
        var _this120;

        _classCallCheck(this, Pd);

        _this120 = _possibleConstructorReturn(this, _getPrototypeOf(Pd).call(this, e)), _this120.top = _this120.createCollection(), _this120.main = _this120.createCollection(), _this120._voiceLabelView = _this120._createVoiceLabel(), _this120.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-reset", "ck-editor", "ck-rounded-corners"],
            role: "application",
            dir: e.uiLanguageDirection,
            lang: e.uiLanguage,
            "aria-labelledby": _this120._voiceLabelView.id
          },
          children: [_this120._voiceLabelView, {
            tag: "div",
            attributes: {
              class: ["ck", "ck-editor__top", "ck-reset_all"],
              role: "presentation"
            },
            children: _this120.top
          }, {
            tag: "div",
            attributes: {
              class: ["ck", "ck-editor__main"],
              role: "presentation"
            },
            children: _this120.main
          }]
        });
        return _this120;
      }

      _createClass(Pd, [{
        key: "_createVoiceLabel",
        value: function _createVoiceLabel() {
          var e = this.t,
              t = new Id();
          return t.text = e("Rich Text Editor"), t.extendTemplate({
            attributes: {
              class: "ck-voice-label"
            }
          }), t;
        }
      }]);

      return Pd;
    }(Sd);

    var Md =
    /*#__PURE__*/
    function (_Rl16) {
      _inherits(Md, _Rl16);

      function Md(e, t, i) {
        var _this121;

        _classCallCheck(this, Md);

        _this121 = _possibleConstructorReturn(this, _getPrototypeOf(Md).call(this, e)), _this121.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-content", "ck-editor__editable", "ck-rounded-corners"],
            lang: e.contentLanguage,
            dir: e.contentLanguageDirection
          }
        }), _this121.name = null, _this121.set("isFocused", !1), _this121._editableElement = i, _this121._hasExternalElement = !!_this121._editableElement, _this121._editingView = t;
        return _this121;
      }

      _createClass(Md, [{
        key: "render",
        value: function render() {
          var _this122 = this;

          _get(_getPrototypeOf(Md.prototype), "render", this).call(this), this._hasExternalElement ? this.template.apply(this.element = this._editableElement) : this._editableElement = this.element, this.on("change:isFocused", function () {
            return _this122._updateIsFocusedClasses();
          }), this._updateIsFocusedClasses();
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this._hasExternalElement && this.template.revert(this._editableElement), _get(_getPrototypeOf(Md.prototype), "destroy", this).call(this);
        }
      }, {
        key: "_updateIsFocusedClasses",
        value: function _updateIsFocusedClasses() {
          var e = this._editingView;

          function t(t) {
            e.change(function (i) {
              var n = e.document.getRoot(t.name);
              i.addClass(t.isFocused ? "ck-focused" : "ck-blurred", n), i.removeClass(t.isFocused ? "ck-blurred" : "ck-focused", n);
            });
          }

          e.isRenderingInProgress ? function i(n) {
            e.once("change:isRenderingInProgress", function (e, o, r) {
              r ? i(n) : t(n);
            });
          }(this) : t(this);
        }
      }]);

      return Md;
    }(Rl);

    var Nd =
    /*#__PURE__*/
    function (_Md) {
      _inherits(Nd, _Md);

      function Nd(e, t, i) {
        var _this123;

        _classCallCheck(this, Nd);

        _this123 = _possibleConstructorReturn(this, _getPrototypeOf(Nd).call(this, e, t, i)), _this123.extendTemplate({
          attributes: {
            role: "textbox",
            class: "ck-editor__editable_inline"
          }
        });
        return _this123;
      }

      _createClass(Nd, [{
        key: "render",
        value: function render() {
          var _this124 = this;

          _get(_getPrototypeOf(Nd.prototype), "render", this).call(this);

          var e = this._editingView,
              t = this.t;
          e.change(function (i) {
            var n = e.document.getRoot(_this124.name);
            i.setAttribute("aria-label", t("Rich Text Editor, %0", _this124.name), n);
          });
        }
      }]);

      return Nd;
    }(Md);

    i(43);
    i(45);

    var Rd =
    /*#__PURE__*/
    function (_Rl17) {
      _inherits(Rd, _Rl17);

      function Rd(e) {
        var _this125;

        _classCallCheck(this, Rd);

        _this125 = _possibleConstructorReturn(this, _getPrototypeOf(Rd).call(this, e)), _this125.set("value"), _this125.set("id"), _this125.set("placeholder"), _this125.set("isReadOnly", !1), _this125.set("hasError", !1), _this125.set("ariaDescribedById"), _this125.focusTracker = new zs(), _this125.bind("isFocused").to(_this125.focusTracker), _this125.set("isEmpty", !0);
        var t = _this125.bindTemplate;

        _this125.setTemplate({
          tag: "input",
          attributes: {
            type: "text",
            class: ["ck", "ck-input", "ck-input-text", t.if("isFocused", "ck-input_focused"), t.if("isEmpty", "ck-input-text_empty"), t.if("hasError", "ck-error")],
            id: t.to("id"),
            placeholder: t.to("placeholder"),
            readonly: t.to("isReadOnly"),
            "aria-invalid": t.if("hasError", !0),
            "aria-describedby": t.to("ariaDescribedById")
          },
          on: {
            input: t.to("input"),
            change: t.to(_this125._updateIsEmpty.bind(_assertThisInitialized(_this125)))
          }
        });

        return _this125;
      }

      _createClass(Rd, [{
        key: "render",
        value: function render() {
          var _this126 = this;

          _get(_getPrototypeOf(Rd.prototype), "render", this).call(this), this.focusTracker.add(this.element), this._setDomElementValue(this.value), this._updateIsEmpty(), this.on("change:value", function (e, t, i) {
            _this126._setDomElementValue(i), _this126._updateIsEmpty();
          });
        }
      }, {
        key: "select",
        value: function select() {
          this.element.select();
        }
      }, {
        key: "focus",
        value: function focus() {
          this.element.focus();
        }
      }, {
        key: "_updateIsEmpty",
        value: function _updateIsEmpty() {
          this.isEmpty = !this.element.value;
        }
      }, {
        key: "_setDomElementValue",
        value: function _setDomElementValue(e) {
          this.element.value = e || 0 === e ? e : "";
        }
      }]);

      return Rd;
    }(Rl);

    i(47);

    var Od =
    /*#__PURE__*/
    function (_Rl18) {
      _inherits(Od, _Rl18);

      function Od(e, t) {
        var _this127;

        _classCallCheck(this, Od);

        _this127 = _possibleConstructorReturn(this, _getPrototypeOf(Od).call(this, e));
        var i = "ck-labeled-field-view-" + s(),
            n = "ck-labeled-field-view-status-" + s();
        _this127.fieldView = t(_assertThisInitialized(_this127), i, n), _this127.set("label"), _this127.set("isEnabled", !0), _this127.set("isEmpty", !0), _this127.set("isFocused", !1), _this127.set("errorText", null), _this127.set("infoText", null), _this127.set("class"), _this127.set("placeholder"), _this127.labelView = _this127._createLabelView(i), _this127.statusView = _this127._createStatusView(n), _this127.bind("_statusText").to(_assertThisInitialized(_this127), "errorText", _assertThisInitialized(_this127), "infoText", function (e, t) {
          return e || t;
        });
        var o = _this127.bindTemplate;

        _this127.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-labeled-field-view", o.to("class"), o.if("isEnabled", "ck-disabled", function (e) {
              return !e;
            }), o.if("isEmpty", "ck-labeled-field-view_empty"), o.if("isFocused", "ck-labeled-field-view_focused"), o.if("placeholder", "ck-labeled-field-view_placeholder"), o.if("errorText", "ck-error")]
          },
          children: [{
            tag: "div",
            attributes: {
              class: ["ck", "ck-labeled-field-view__input-wrapper"]
            },
            children: [_this127.fieldView, _this127.labelView]
          }, _this127.statusView]
        });

        return _this127;
      }

      _createClass(Od, [{
        key: "_createLabelView",
        value: function _createLabelView(e) {
          var t = new Id(this.locale);
          return t.for = e, t.bind("text").to(this, "label"), t;
        }
      }, {
        key: "_createStatusView",
        value: function _createStatusView(e) {
          var t = new Rl(this.locale),
              i = this.bindTemplate;
          return t.setTemplate({
            tag: "div",
            attributes: {
              class: ["ck", "ck-labeled-field-view__status", i.if("errorText", "ck-labeled-field-view__status_error"), i.if("_statusText", "ck-hidden", function (e) {
                return !e;
              })],
              id: e,
              role: i.if("errorText", "alert")
            },
            children: [{
              text: i.to("_statusText")
            }]
          }), t;
        }
      }, {
        key: "focus",
        value: function focus() {
          this.fieldView.focus();
        }
      }]);

      return Od;
    }(Rl);

    function zd(e, t, i) {
      var n = new Rd(e.locale);
      return n.set({
        id: t,
        ariaDescribedById: i
      }), n.bind("isReadOnly").to(e, "isEnabled", function (e) {
        return !e;
      }), n.bind("hasError").to(e, "errorText", function (e) {
        return !!e;
      }), n.on("input", function () {
        e.errorText = null;
      }), e.bind("isEmpty", "isFocused", "placeholder").to(n), n;
    }

    var Dd =
    /*#__PURE__*/
    function (_an2) {
      _inherits(Dd, _an2);

      function Dd() {
        _classCallCheck(this, Dd);

        return _possibleConstructorReturn(this, _getPrototypeOf(Dd).apply(this, arguments));
      }

      _createClass(Dd, [{
        key: "init",
        value: function init() {
          this.on("show:warning", function (e, t) {
            window.alert(t.message);
          }, {
            priority: "lowest"
          });
        }
      }, {
        key: "showSuccess",
        value: function showSuccess(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

          this._showNotification({
            message: e,
            type: "success",
            namespace: t.namespace,
            title: t.title
          });
        }
      }, {
        key: "showInfo",
        value: function showInfo(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

          this._showNotification({
            message: e,
            type: "info",
            namespace: t.namespace,
            title: t.title
          });
        }
      }, {
        key: "showWarning",
        value: function showWarning(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

          this._showNotification({
            message: e,
            type: "warning",
            namespace: t.namespace,
            title: t.title
          });
        }
      }, {
        key: "_showNotification",
        value: function _showNotification(e) {
          var t = "show:" + e.type + (e.namespace ? ":" + e.namespace : "");
          this.fire(t, {
            message: e.message,
            type: e.type,
            title: e.title || ""
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "Notification";
        }
      }]);

      return Dd;
    }(an);

    var Ld = function Ld(e, t) {
      _classCallCheck(this, Ld);

      t && De(this, t), e && this.set(e);
    };

    Ke(Ld, Ue);
    i(49);
    var Vd = Rs("px"),
        jd = vr.document.body;

    var Bd =
    /*#__PURE__*/
    function (_Rl19) {
      _inherits(Bd, _Rl19);

      function Bd(e) {
        var _this128;

        _classCallCheck(this, Bd);

        _this128 = _possibleConstructorReturn(this, _getPrototypeOf(Bd).call(this, e));
        var t = _this128.bindTemplate;
        _this128.set("top", 0), _this128.set("left", 0), _this128.set("position", "arrow_nw"), _this128.set("isVisible", !1), _this128.set("withArrow", !0), _this128.set("class"), _this128.content = _this128.createCollection(), _this128.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-balloon-panel", t.to("position", function (e) {
              return "ck-balloon-panel_" + e;
            }), t.if("isVisible", "ck-balloon-panel_visible"), t.if("withArrow", "ck-balloon-panel_with-arrow"), t.to("class")],
            style: {
              top: t.to("top", Vd),
              left: t.to("left", Vd)
            }
          },
          children: _this128.content
        });
        return _this128;
      }

      _createClass(Bd, [{
        key: "show",
        value: function show() {
          this.isVisible = !0;
        }
      }, {
        key: "hide",
        value: function hide() {
          this.isVisible = !1;
        }
      }, {
        key: "attachTo",
        value: function attachTo(e) {
          this.show();

          var t = Bd.defaultPositions,
              i = Object.assign({}, {
            element: this.element,
            positions: [t.southArrowNorth, t.southArrowNorthMiddleWest, t.southArrowNorthMiddleEast, t.southArrowNorthWest, t.southArrowNorthEast, t.northArrowSouth, t.northArrowSouthMiddleWest, t.northArrowSouthMiddleEast, t.northArrowSouthWest, t.northArrowSouthEast],
            limiter: jd,
            fitInViewport: !0
          }, e),
              n = Bd._getOptimalPosition(i),
              o = parseInt(n.left),
              r = parseInt(n.top),
              s = n.name;

          Object.assign(this, {
            top: r,
            left: o,
            position: s
          });
        }
      }, {
        key: "pin",
        value: function pin(e) {
          var _this129 = this;

          this.unpin(), this._pinWhenIsVisibleCallback = function () {
            _this129.isVisible ? _this129._startPinning(e) : _this129._stopPinning();
          }, this._startPinning(e), this.listenTo(this, "change:isVisible", this._pinWhenIsVisibleCallback);
        }
      }, {
        key: "unpin",
        value: function unpin() {
          this._pinWhenIsVisibleCallback && (this._stopPinning(), this.stopListening(this, "change:isVisible", this._pinWhenIsVisibleCallback), this._pinWhenIsVisibleCallback = null, this.hide());
        }
      }, {
        key: "_startPinning",
        value: function _startPinning(e) {
          var _this130 = this;

          this.attachTo(e);
          var t = Fd(e.target),
              i = e.limiter ? Fd(e.limiter) : jd;
          this.listenTo(vr.document, "scroll", function (n, o) {
            var r = o.target,
                s = t && r.contains(t),
                a = i && r.contains(i);
            !s && !a && t && i || _this130.attachTo(e);
          }, {
            useCapture: !0
          }), this.listenTo(vr.window, "resize", function () {
            _this130.attachTo(e);
          });
        }
      }, {
        key: "_stopPinning",
        value: function _stopPinning() {
          this.stopListening(vr.document, "scroll"), this.stopListening(vr.window, "resize");
        }
      }]);

      return Bd;
    }(Rl);

    function Fd(e) {
      return Yi(e) ? e : Cs(e) ? e.commonAncestorContainer : "function" == typeof e ? Fd(e()) : null;
    }

    function Hd(e, t) {
      return e.top - t.height - Bd.arrowVerticalOffset;
    }

    function Ud(e) {
      return e.bottom + Bd.arrowVerticalOffset;
    }

    Bd.arrowHorizontalOffset = 25, Bd.arrowVerticalOffset = 10, Bd._getOptimalPosition = dd, Bd.defaultPositions = {
      northWestArrowSouthWest: function northWestArrowSouthWest(e, t) {
        return {
          top: Hd(e, t),
          left: e.left - Bd.arrowHorizontalOffset,
          name: "arrow_sw"
        };
      },
      northWestArrowSouthMiddleWest: function northWestArrowSouthMiddleWest(e, t) {
        return {
          top: Hd(e, t),
          left: e.left - .25 * t.width - Bd.arrowHorizontalOffset,
          name: "arrow_smw"
        };
      },
      northWestArrowSouth: function northWestArrowSouth(e, t) {
        return {
          top: Hd(e, t),
          left: e.left - t.width / 2,
          name: "arrow_s"
        };
      },
      northWestArrowSouthMiddleEast: function northWestArrowSouthMiddleEast(e, t) {
        return {
          top: Hd(e, t),
          left: e.left - .75 * t.width + Bd.arrowHorizontalOffset,
          name: "arrow_sme"
        };
      },
      northWestArrowSouthEast: function northWestArrowSouthEast(e, t) {
        return {
          top: Hd(e, t),
          left: e.left - t.width + Bd.arrowHorizontalOffset,
          name: "arrow_se"
        };
      },
      northArrowSouthWest: function northArrowSouthWest(e, t) {
        return {
          top: Hd(e, t),
          left: e.left + e.width / 2 - Bd.arrowHorizontalOffset,
          name: "arrow_sw"
        };
      },
      northArrowSouthMiddleWest: function northArrowSouthMiddleWest(e, t) {
        return {
          top: Hd(e, t),
          left: e.left + e.width / 2 - .25 * t.width - Bd.arrowHorizontalOffset,
          name: "arrow_smw"
        };
      },
      northArrowSouth: function northArrowSouth(e, t) {
        return {
          top: Hd(e, t),
          left: e.left + e.width / 2 - t.width / 2,
          name: "arrow_s"
        };
      },
      northArrowSouthMiddleEast: function northArrowSouthMiddleEast(e, t) {
        return {
          top: Hd(e, t),
          left: e.left + e.width / 2 - .75 * t.width + Bd.arrowHorizontalOffset,
          name: "arrow_sme"
        };
      },
      northArrowSouthEast: function northArrowSouthEast(e, t) {
        return {
          top: Hd(e, t),
          left: e.left + e.width / 2 - t.width + Bd.arrowHorizontalOffset,
          name: "arrow_se"
        };
      },
      northEastArrowSouthWest: function northEastArrowSouthWest(e, t) {
        return {
          top: Hd(e, t),
          left: e.right - Bd.arrowHorizontalOffset,
          name: "arrow_sw"
        };
      },
      northEastArrowSouthMiddleWest: function northEastArrowSouthMiddleWest(e, t) {
        return {
          top: Hd(e, t),
          left: e.right - .25 * t.width - Bd.arrowHorizontalOffset,
          name: "arrow_smw"
        };
      },
      northEastArrowSouth: function northEastArrowSouth(e, t) {
        return {
          top: Hd(e, t),
          left: e.right - t.width / 2,
          name: "arrow_s"
        };
      },
      northEastArrowSouthMiddleEast: function northEastArrowSouthMiddleEast(e, t) {
        return {
          top: Hd(e, t),
          left: e.right - .75 * t.width + Bd.arrowHorizontalOffset,
          name: "arrow_sme"
        };
      },
      northEastArrowSouthEast: function northEastArrowSouthEast(e, t) {
        return {
          top: Hd(e, t),
          left: e.right - t.width + Bd.arrowHorizontalOffset,
          name: "arrow_se"
        };
      },
      southWestArrowNorthWest: function southWestArrowNorthWest(e, t) {
        return {
          top: Ud(e),
          left: e.left - Bd.arrowHorizontalOffset,
          name: "arrow_nw"
        };
      },
      southWestArrowNorthMiddleWest: function southWestArrowNorthMiddleWest(e, t) {
        return {
          top: Ud(e),
          left: e.left - .25 * t.width - Bd.arrowHorizontalOffset,
          name: "arrow_nmw"
        };
      },
      southWestArrowNorth: function southWestArrowNorth(e, t) {
        return {
          top: Ud(e),
          left: e.left - t.width / 2,
          name: "arrow_n"
        };
      },
      southWestArrowNorthMiddleEast: function southWestArrowNorthMiddleEast(e, t) {
        return {
          top: Ud(e),
          left: e.left - .75 * t.width + Bd.arrowHorizontalOffset,
          name: "arrow_nme"
        };
      },
      southWestArrowNorthEast: function southWestArrowNorthEast(e, t) {
        return {
          top: Ud(e),
          left: e.left - t.width + Bd.arrowHorizontalOffset,
          name: "arrow_ne"
        };
      },
      southArrowNorthWest: function southArrowNorthWest(e, t) {
        return {
          top: Ud(e),
          left: e.left + e.width / 2 - Bd.arrowHorizontalOffset,
          name: "arrow_nw"
        };
      },
      southArrowNorthMiddleWest: function southArrowNorthMiddleWest(e, t) {
        return {
          top: Ud(e),
          left: e.left + e.width / 2 - .25 * t.width - Bd.arrowHorizontalOffset,
          name: "arrow_nmw"
        };
      },
      southArrowNorth: function southArrowNorth(e, t) {
        return {
          top: Ud(e),
          left: e.left + e.width / 2 - t.width / 2,
          name: "arrow_n"
        };
      },
      southArrowNorthMiddleEast: function southArrowNorthMiddleEast(e, t) {
        return {
          top: Ud(e),
          left: e.left + e.width / 2 - .75 * t.width + Bd.arrowHorizontalOffset,
          name: "arrow_nme"
        };
      },
      southArrowNorthEast: function southArrowNorthEast(e, t) {
        return {
          top: Ud(e),
          left: e.left + e.width / 2 - t.width + Bd.arrowHorizontalOffset,
          name: "arrow_ne"
        };
      },
      southEastArrowNorthWest: function southEastArrowNorthWest(e, t) {
        return {
          top: Ud(e),
          left: e.right - Bd.arrowHorizontalOffset,
          name: "arrow_nw"
        };
      },
      southEastArrowNorthMiddleWest: function southEastArrowNorthMiddleWest(e, t) {
        return {
          top: Ud(e),
          left: e.right - .25 * t.width - Bd.arrowHorizontalOffset,
          name: "arrow_nmw"
        };
      },
      southEastArrowNorth: function southEastArrowNorth(e, t) {
        return {
          top: Ud(e),
          left: e.right - t.width / 2,
          name: "arrow_n"
        };
      },
      southEastArrowNorthMiddleEast: function southEastArrowNorthMiddleEast(e, t) {
        return {
          top: Ud(e),
          left: e.right - .75 * t.width + Bd.arrowHorizontalOffset,
          name: "arrow_nme"
        };
      },
      southEastArrowNorthEast: function southEastArrowNorthEast(e, t) {
        return {
          top: Ud(e),
          left: e.right - t.width + Bd.arrowHorizontalOffset,
          name: "arrow_ne"
        };
      }
    };
    i(51), i(53);
    var Wd = Rs("px");

    var qd =
    /*#__PURE__*/
    function (_Qe) {
      _inherits(qd, _Qe);

      _createClass(qd, null, [{
        key: "pluginName",
        get: function get() {
          return "ContextualBalloon";
        }
      }]);

      function qd(e) {
        var _this131;

        _classCallCheck(this, qd);

        _this131 = _possibleConstructorReturn(this, _getPrototypeOf(qd).call(this, e)), _this131.positionLimiter = function () {
          var e = _this131.editor.editing.view,
              t = e.document.selection.editableElement;
          return t ? e.domConverter.mapViewToDom(t.root) : null;
        }, _this131.set("visibleView", null), _this131.view = new Bd(e.locale), e.ui.view.body.add(_this131.view), e.ui.focusTracker.add(_this131.view.element), _this131._viewToStack = new Map(), _this131._idToStack = new Map(), _this131.set("_numberOfStacks", 0), _this131.set("_singleViewMode", !1), _this131._rotatorView = _this131._createRotatorView(), _this131._fakePanelsView = _this131._createFakePanelsView();
        return _this131;
      }

      _createClass(qd, [{
        key: "hasView",
        value: function hasView(e) {
          return Array.from(this._viewToStack.keys()).includes(e);
        }
      }, {
        key: "add",
        value: function add(e) {
          if (this.hasView(e.view)) throw new c.a("contextualballoon-add-view-exist", [this, e]);
          var t = e.stackId || "main";
          if (!this._idToStack.has(t)) return this._idToStack.set(t, new Map([[e.view, e]])), this._viewToStack.set(e.view, this._idToStack.get(t)), this._numberOfStacks = this._idToStack.size, void (this._visibleStack && !e.singleViewMode || this.showStack(t));

          var i = this._idToStack.get(t);

          e.singleViewMode && this.showStack(t), i.set(e.view, e), this._viewToStack.set(e.view, i), i === this._visibleStack && this._showView(e);
        }
      }, {
        key: "remove",
        value: function remove(e) {
          if (!this.hasView(e)) throw new c.a("contextualballoon-remove-view-not-exist", [this, e]);

          var t = this._viewToStack.get(e);

          this._singleViewMode && this.visibleView === e && (this._singleViewMode = !1), this.visibleView === e && (1 === t.size ? this._idToStack.size > 1 ? this._showNextStack() : (this.view.hide(), this.visibleView = null, this._rotatorView.hideView()) : this._showView(Array.from(t.values())[t.size - 2])), 1 === t.size ? (this._idToStack.delete(this._getStackId(t)), this._numberOfStacks = this._idToStack.size) : t.delete(e), this._viewToStack.delete(e);
        }
      }, {
        key: "updatePosition",
        value: function updatePosition(e) {
          e && (this._visibleStack.get(this.visibleView).position = e), this.view.pin(this._getBalloonPosition()), this._fakePanelsView.updatePosition();
        }
      }, {
        key: "showStack",
        value: function showStack(e) {
          this.visibleStack = e;

          var t = this._idToStack.get(e);

          if (!t) throw new c.a("contextualballoon-showstack-stack-not-exist", this);
          this._visibleStack !== t && this._showView(Array.from(t.values()).pop());
        }
      }, {
        key: "_getStackId",
        value: function _getStackId(e) {
          return Array.from(this._idToStack.entries()).find(function (t) {
            return t[1] === e;
          })[0];
        }
      }, {
        key: "_showNextStack",
        value: function _showNextStack() {
          var e = Array.from(this._idToStack.values());
          var t = e.indexOf(this._visibleStack) + 1;
          e[t] || (t = 0), this.showStack(this._getStackId(e[t]));
        }
      }, {
        key: "_showPrevStack",
        value: function _showPrevStack() {
          var e = Array.from(this._idToStack.values());
          var t = e.indexOf(this._visibleStack) - 1;
          e[t] || (t = e.length - 1), this.showStack(this._getStackId(e[t]));
        }
      }, {
        key: "_createRotatorView",
        value: function _createRotatorView() {
          var _this132 = this;

          var e = new $d(this.editor.locale),
              t = this.editor.locale.t;
          return this.view.content.add(e), e.bind("isNavigationVisible").to(this, "_numberOfStacks", this, "_singleViewMode", function (e, t) {
            return !t && e > 1;
          }), e.on("change:isNavigationVisible", function () {
            return _this132.updatePosition();
          }, {
            priority: "low"
          }), e.bind("counter").to(this, "visibleView", this, "_numberOfStacks", function (e, i) {
            if (i < 2) return "";
            var n = Array.from(_this132._idToStack.values()).indexOf(_this132._visibleStack) + 1;
            return t("%0 of %1", [n, i]);
          }), e.buttonNextView.on("execute", function () {
            e.focusTracker.isFocused && _this132.editor.editing.view.focus(), _this132._showNextStack();
          }), e.buttonPrevView.on("execute", function () {
            e.focusTracker.isFocused && _this132.editor.editing.view.focus(), _this132._showPrevStack();
          }), e;
        }
      }, {
        key: "_createFakePanelsView",
        value: function _createFakePanelsView() {
          var e = new Yd(this.editor.locale, this.view);
          return e.bind("numberOfPanels").to(this, "_numberOfStacks", this, "_singleViewMode", function (e, t) {
            return !t && e >= 2 ? Math.min(e - 1, 2) : 0;
          }), e.listenTo(this.view, "change:top", function () {
            return e.updatePosition();
          }), e.listenTo(this.view, "change:left", function () {
            return e.updatePosition();
          }), this.editor.ui.view.body.add(e), e;
        }
      }, {
        key: "_showView",
        value: function _showView(_ref119) {
          var e = _ref119.view,
              _ref119$balloonClassN = _ref119.balloonClassName,
              t = _ref119$balloonClassN === void 0 ? "" : _ref119$balloonClassN,
              _ref119$withArrow = _ref119.withArrow,
              i = _ref119$withArrow === void 0 ? !0 : _ref119$withArrow,
              _ref119$singleViewMod = _ref119.singleViewMode,
              n = _ref119$singleViewMod === void 0 ? !1 : _ref119$singleViewMod;
          this.view.class = t, this.view.withArrow = i, this._rotatorView.showView(e), this.visibleView = e, this.view.pin(this._getBalloonPosition()), this._fakePanelsView.updatePosition(), n && (this._singleViewMode = !0);
        }
      }, {
        key: "_getBalloonPosition",
        value: function _getBalloonPosition() {
          var e = Array.from(this._visibleStack.values()).pop().position;
          return e && !e.limiter && (e = Object.assign({}, e, {
            limiter: this.positionLimiter
          })), e;
        }
      }, {
        key: "_visibleStack",
        get: function get() {
          return this._viewToStack.get(this.visibleView);
        }
      }]);

      return qd;
    }(Qe);

    var $d =
    /*#__PURE__*/
    function (_Rl20) {
      _inherits($d, _Rl20);

      function $d(e) {
        var _this133;

        _classCallCheck(this, $d);

        _this133 = _possibleConstructorReturn(this, _getPrototypeOf($d).call(this, e));
        var t = e.t,
            i = _this133.bindTemplate;
        _this133.set("isNavigationVisible", !0), _this133.focusTracker = new zs(), _this133.buttonPrevView = _this133._createButtonView(t("Previous"), '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11.463 5.187a.888.888 0 1 1 1.254 1.255L9.16 10l3.557 3.557a.888.888 0 1 1-1.254 1.255L7.26 10.61a.888.888 0 0 1 .16-1.382l4.043-4.042z"/></svg>'), _this133.buttonNextView = _this133._createButtonView(t("Next"), '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M8.537 14.813a.888.888 0 1 1-1.254-1.255L10.84 10 7.283 6.442a.888.888 0 1 1 1.254-1.255L12.74 9.39a.888.888 0 0 1-.16 1.382l-4.043 4.042z"/></svg>'), _this133.content = _this133.createCollection(), _this133.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-balloon-rotator"],
            "z-index": "-1"
          },
          children: [{
            tag: "div",
            attributes: {
              class: ["ck-balloon-rotator__navigation", i.to("isNavigationVisible", function (e) {
                return e ? "" : "ck-hidden";
              })]
            },
            children: [_this133.buttonPrevView, {
              tag: "span",
              attributes: {
                class: ["ck-balloon-rotator__counter"]
              },
              children: [{
                text: i.to("counter")
              }]
            }, _this133.buttonNextView]
          }, {
            tag: "div",
            attributes: {
              class: "ck-balloon-rotator__content"
            },
            children: _this133.content
          }]
        });
        return _this133;
      }

      _createClass($d, [{
        key: "render",
        value: function render() {
          _get(_getPrototypeOf($d.prototype), "render", this).call(this), this.focusTracker.add(this.element);
        }
      }, {
        key: "showView",
        value: function showView(e) {
          this.hideView(), this.content.add(e);
        }
      }, {
        key: "hideView",
        value: function hideView() {
          this.content.clear();
        }
      }, {
        key: "_createButtonView",
        value: function _createButtonView(e, t) {
          var i = new id(this.locale);
          return i.set({
            label: e,
            icon: t,
            tooltip: !0
          }), i;
        }
      }]);

      return $d;
    }(Rl);

    var Yd =
    /*#__PURE__*/
    function (_Rl21) {
      _inherits(Yd, _Rl21);

      function Yd(e, t) {
        var _this134;

        _classCallCheck(this, Yd);

        _this134 = _possibleConstructorReturn(this, _getPrototypeOf(Yd).call(this, e));
        var i = _this134.bindTemplate;
        _this134.set("top", 0), _this134.set("left", 0), _this134.set("height", 0), _this134.set("width", 0), _this134.set("numberOfPanels", 0), _this134.content = _this134.createCollection(), _this134._balloonPanelView = t, _this134.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck-fake-panel", i.to("numberOfPanels", function (e) {
              return e ? "" : "ck-hidden";
            })],
            style: {
              top: i.to("top", Wd),
              left: i.to("left", Wd),
              width: i.to("width", Wd),
              height: i.to("height", Wd)
            }
          },
          children: _this134.content
        }), _this134.on("change:numberOfPanels", function (e, t, i, n) {
          i > n ? _this134._addPanels(i - n) : _this134._removePanels(n - i), _this134.updatePosition();
        });
        return _this134;
      }

      _createClass(Yd, [{
        key: "_addPanels",
        value: function _addPanels(e) {
          for (; e--;) {
            var _e219 = new Rl();

            _e219.setTemplate({
              tag: "div"
            }), this.content.add(_e219), this.registerChild(_e219);
          }
        }
      }, {
        key: "_removePanels",
        value: function _removePanels(e) {
          for (; e--;) {
            var _e220 = this.content.last;
            this.content.remove(_e220), this.deregisterChild(_e220), _e220.destroy();
          }
        }
      }, {
        key: "updatePosition",
        value: function updatePosition() {
          if (this.numberOfPanels) {
            var _this$_balloonPanelVi = this._balloonPanelView,
                _e221 = _this$_balloonPanelVi.top,
                _t205 = _this$_balloonPanelVi.left,
                _ref120 = new Ss(this._balloonPanelView.element),
                _i214 = _ref120.width,
                _n111 = _ref120.height;

            Object.assign(this, {
              top: _e221,
              left: _t205,
              width: _i214,
              height: _n111
            });
          }
        }
      }]);

      return Yd;
    }(Rl);

    i(55);
    var Gd = Rs("px");

    var Kd =
    /*#__PURE__*/
    function (_Rl22) {
      _inherits(Kd, _Rl22);

      function Kd(e) {
        var _this135;

        _classCallCheck(this, Kd);

        _this135 = _possibleConstructorReturn(this, _getPrototypeOf(Kd).call(this, e));
        var t = _this135.bindTemplate;
        _this135.set("isActive", !1), _this135.set("isSticky", !1), _this135.set("limiterElement", null), _this135.set("limiterBottomOffset", 50), _this135.set("viewportTopOffset", 0), _this135.set("_marginLeft", null), _this135.set("_isStickyToTheLimiter", !1), _this135.set("_hasViewportTopOffset", !1), _this135.content = _this135.createCollection(), _this135._contentPanelPlaceholder = new Ol({
          tag: "div",
          attributes: {
            class: ["ck", "ck-sticky-panel__placeholder"],
            style: {
              display: t.to("isSticky", function (e) {
                return e ? "block" : "none";
              }),
              height: t.to("isSticky", function (e) {
                return e ? Gd(_this135._panelRect.height) : null;
              })
            }
          }
        }).render(), _this135._contentPanel = new Ol({
          tag: "div",
          attributes: {
            class: ["ck", "ck-sticky-panel__content", t.if("isSticky", "ck-sticky-panel__content_sticky"), t.if("_isStickyToTheLimiter", "ck-sticky-panel__content_sticky_bottom-limit")],
            style: {
              width: t.to("isSticky", function (e) {
                return e ? Gd(_this135._contentPanelPlaceholder.getBoundingClientRect().width) : null;
              }),
              top: t.to("_hasViewportTopOffset", function (e) {
                return e ? Gd(_this135.viewportTopOffset) : null;
              }),
              bottom: t.to("_isStickyToTheLimiter", function (e) {
                return e ? Gd(_this135.limiterBottomOffset) : null;
              }),
              marginLeft: t.to("_marginLeft")
            }
          },
          children: _this135.content
        }).render(), _this135.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-sticky-panel"]
          },
          children: [_this135._contentPanelPlaceholder, _this135._contentPanel]
        });
        return _this135;
      }

      _createClass(Kd, [{
        key: "render",
        value: function render() {
          var _this136 = this;

          _get(_getPrototypeOf(Kd.prototype), "render", this).call(this), this._checkIfShouldBeSticky(), this.listenTo(vr.window, "scroll", function () {
            _this136._checkIfShouldBeSticky();
          }), this.listenTo(this, "change:isActive", function () {
            _this136._checkIfShouldBeSticky();
          });
        }
      }, {
        key: "_checkIfShouldBeSticky",
        value: function _checkIfShouldBeSticky() {
          var e = this._panelRect = this._contentPanel.getBoundingClientRect();

          var t;
          this.limiterElement ? (t = this._limiterRect = this.limiterElement.getBoundingClientRect(), this.isSticky = this.isActive && t.top < this.viewportTopOffset && this._panelRect.height + this.limiterBottomOffset < t.height) : this.isSticky = !1, this.isSticky ? (this._isStickyToTheLimiter = t.bottom < e.height + this.limiterBottomOffset + this.viewportTopOffset, this._hasViewportTopOffset = !this._isStickyToTheLimiter && !!this.viewportTopOffset, this._marginLeft = this._isStickyToTheLimiter ? null : Gd(-vr.window.scrollX)) : (this._isStickyToTheLimiter = !1, this._hasViewportTopOffset = !1, this._marginLeft = null);
        }
      }]);

      return Kd;
    }(Rl);

    Rs("px");
    i(57);
    Rs("px");
    Rs("px");
    i(59);
    var Qd = new WeakMap();

    function Jd(e) {
      var t = e.view,
          i = e.element,
          n = e.text,
          _e$isDirectHost = e.isDirectHost,
          o = _e$isDirectHost === void 0 ? !0 : _e$isDirectHost,
          _e$keepOnFocus = e.keepOnFocus,
          r = _e$keepOnFocus === void 0 ? !1 : _e$keepOnFocus,
          s = t.document;
      Qd.has(s) || (Qd.set(s, new Map()), s.registerPostFixer(function (e) {
        return Xd(s, e);
      })), Qd.get(s).set(i, {
        text: n,
        isDirectHost: o,
        keepOnFocus: r,
        hostElement: o ? i : null
      }), t.change(function (e) {
        return Xd(s, e);
      });
    }

    function Zd(e, t) {
      return !!t.hasClass("ck-placeholder") && (e.removeClass("ck-placeholder", t), !0);
    }

    function Xd(e, t) {
      var i = Qd.get(e),
          n = [];
      var o = !1;
      var _iteratorNormalCompletion297 = true;
      var _didIteratorError297 = false;
      var _iteratorError297 = undefined;

      try {
        for (var _iterator297 = i[Symbol.iterator](), _step297; !(_iteratorNormalCompletion297 = (_step297 = _iterator297.next()).done); _iteratorNormalCompletion297 = true) {
          var _ref125 = _step297.value;

          var _ref122 = _slicedToArray(_ref125, 2);

          var _e222 = _ref122[0];
          var _r37 = _ref122[1];
          _r37.isDirectHost && (n.push(_e222), eh(t, _e222, _r37) && (o = !0));
        }
      } catch (err) {
        _didIteratorError297 = true;
        _iteratorError297 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion297 && _iterator297.return != null) {
            _iterator297.return();
          }
        } finally {
          if (_didIteratorError297) {
            throw _iteratorError297;
          }
        }
      }

      var _iteratorNormalCompletion298 = true;
      var _didIteratorError298 = false;
      var _iteratorError298 = undefined;

      try {
        for (var _iterator298 = i[Symbol.iterator](), _step298; !(_iteratorNormalCompletion298 = (_step298 = _iterator298.next()).done); _iteratorNormalCompletion298 = true) {
          var _ref126 = _step298.value;

          var _ref124 = _slicedToArray(_ref126, 2);

          var _e223 = _ref124[0];
          var _r38 = _ref124[1];
          if (_r38.isDirectHost) continue;

          var _i215 = th(_e223);

          _i215 && (n.includes(_i215) || (_r38.hostElement = _i215, eh(t, _e223, _r38) && (o = !0)));
        }
      } catch (err) {
        _didIteratorError298 = true;
        _iteratorError298 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion298 && _iterator298.return != null) {
            _iterator298.return();
          }
        } finally {
          if (_didIteratorError298) {
            throw _iteratorError298;
          }
        }
      }

      return o;
    }

    function eh(e, t, i) {
      var n = i.text,
          o = i.isDirectHost,
          r = i.hostElement;
      var s = !1;
      r.getAttribute("data-placeholder") !== n && (e.setAttribute("data-placeholder", n, r), s = !0);
      return (o || 1 == t.childCount) && function (e, t) {
        if (!e.isAttached()) return !1;
        if (Array.from(e.getChildren()).some(function (e) {
          return !e.is("uiElement");
        })) return !1;
        if (t) return !0;
        var i = e.document;
        if (!i.isFocused) return !0;
        var n = i.selection.anchor;
        return n && n.parent !== e;
      }(r, i.keepOnFocus) ? function (e, t) {
        return !t.hasClass("ck-placeholder") && (e.addClass("ck-placeholder", t), !0);
      }(e, r) && (s = !0) : Zd(e, r) && (s = !0), s;
    }

    function th(e) {
      if (e.childCount) {
        var _t206 = e.getChild(0);

        if (_t206.is("element") && !_t206.is("uiElement")) return _t206;
      }

      return null;
    }

    var ih = new Map();

    function nh(e, t, i) {
      var n = ih.get(e);
      n || (n = new Map(), ih.set(e, n)), n.set(t, i);
    }

    function oh(e) {
      return [e];
    }

    function rh(e, t) {
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var n = function (e, t) {
        var i = ih.get(e);
        return i && i.has(t) ? i.get(t) : oh;
      }(e.constructor, t.constructor);

      try {
        return n(e = e.clone(), t, i);
      } catch (e) {
        throw e;
      }
    }

    function sh(e, t, i) {
      e = e.slice(), t = t.slice();
      var n = new ah(i.document, i.useRelations, i.forceWeakRemove);
      n.setOriginalOperations(e), n.setOriginalOperations(t);
      var o = n.originalOperations;
      if (0 == e.length || 0 == t.length) return {
        operationsA: e,
        operationsB: t,
        originalOperations: o
      };
      var r = new WeakMap();
      var _iteratorNormalCompletion299 = true;
      var _didIteratorError299 = false;
      var _iteratorError299 = undefined;

      try {
        for (var _iterator299 = e[Symbol.iterator](), _step299; !(_iteratorNormalCompletion299 = (_step299 = _iterator299.next()).done); _iteratorNormalCompletion299 = true) {
          var _t208 = _step299.value;
          r.set(_t208, 0);
        }
      } catch (err) {
        _didIteratorError299 = true;
        _iteratorError299 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion299 && _iterator299.return != null) {
            _iterator299.return();
          }
        } finally {
          if (_didIteratorError299) {
            throw _iteratorError299;
          }
        }
      }

      var s = {
        nextBaseVersionA: e[e.length - 1].baseVersion + 1,
        nextBaseVersionB: t[t.length - 1].baseVersion + 1,
        originalOperationsACount: e.length,
        originalOperationsBCount: t.length
      };
      var a = 0;

      for (; a < e.length;) {
        var _e224, _t207;

        var _i216 = e[a],
            _o72 = r.get(_i216);

        if (_o72 == t.length) {
          a++;
          continue;
        }

        var _s23 = t[_o72],
            _c8 = rh(_i216, _s23, n.getContext(_i216, _s23, !0)),
            _l3 = rh(_s23, _i216, n.getContext(_s23, _i216, !1));

        n.updateRelation(_i216, _s23), n.setOriginalOperations(_c8, _i216), n.setOriginalOperations(_l3, _s23);
        var _iteratorNormalCompletion300 = true;
        var _didIteratorError300 = false;
        var _iteratorError300 = undefined;

        try {
          for (var _iterator300 = _c8[Symbol.iterator](), _step300; !(_iteratorNormalCompletion300 = (_step300 = _iterator300.next()).done); _iteratorNormalCompletion300 = true) {
            var _e225 = _step300.value;
            r.set(_e225, _o72 + _l3.length);
          }
        } catch (err) {
          _didIteratorError300 = true;
          _iteratorError300 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion300 && _iterator300.return != null) {
              _iterator300.return();
            }
          } finally {
            if (_didIteratorError300) {
              throw _iteratorError300;
            }
          }
        }

        (_e224 = e).splice.apply(_e224, [a, 1].concat(_toConsumableArray(_c8))), (_t207 = t).splice.apply(_t207, [_o72, 1].concat(_toConsumableArray(_l3)));
      }

      if (i.padWithNoOps) {
        var _i217 = e.length - s.originalOperationsACount,
            _n112 = t.length - s.originalOperationsBCount;

        lh(e, _n112 - _i217), lh(t, _i217 - _n112);
      }

      return ch(e, s.nextBaseVersionB), ch(t, s.nextBaseVersionA), {
        operationsA: e,
        operationsB: t,
        originalOperations: o
      };
    }

    var ah =
    /*#__PURE__*/
    function () {
      function ah(e, t) {
        var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;

        _classCallCheck(this, ah);

        this.originalOperations = new Map(), this._history = e.history, this._useRelations = t, this._forceWeakRemove = !!i, this._relations = new Map();
      }

      _createClass(ah, [{
        key: "setOriginalOperations",
        value: function setOriginalOperations(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          var i = t ? this.originalOperations.get(t) : null;
          var _iteratorNormalCompletion301 = true;
          var _didIteratorError301 = false;
          var _iteratorError301 = undefined;

          try {
            for (var _iterator301 = e[Symbol.iterator](), _step301; !(_iteratorNormalCompletion301 = (_step301 = _iterator301.next()).done); _iteratorNormalCompletion301 = true) {
              var _t209 = _step301.value;
              this.originalOperations.set(_t209, i || _t209);
            }
          } catch (err) {
            _didIteratorError301 = true;
            _iteratorError301 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion301 && _iterator301.return != null) {
                _iterator301.return();
              }
            } finally {
              if (_didIteratorError301) {
                throw _iteratorError301;
              }
            }
          }
        }
      }, {
        key: "updateRelation",
        value: function updateRelation(e, t) {
          switch (e.constructor) {
            case Ic:
              switch (t.constructor) {
                case Oc:
                  e.targetPosition.isEqual(t.sourcePosition) || t.movedRange.containsPosition(e.targetPosition) ? this._setRelation(e, t, "insertAtSource") : e.targetPosition.isEqual(t.deletionPosition) ? this._setRelation(e, t, "insertBetween") : e.targetPosition.isAfter(t.sourcePosition) && this._setRelation(e, t, "moveTargetAfter");
                  break;

                case Ic:
                  e.targetPosition.isEqual(t.sourcePosition) || e.targetPosition.isBefore(t.sourcePosition) ? this._setRelation(e, t, "insertBefore") : this._setRelation(e, t, "insertAfter");
              }

              break;

            case zc:
              switch (t.constructor) {
                case Oc:
                  e.splitPosition.isBefore(t.sourcePosition) && this._setRelation(e, t, "splitBefore");
                  break;

                case Ic:
                  if (e.splitPosition.isEqual(t.sourcePosition) || e.splitPosition.isBefore(t.sourcePosition)) this._setRelation(e, t, "splitBefore");else {
                    var _i218 = sa._createFromPositionAndShift(t.sourcePosition, t.howMany);

                    if (e.splitPosition.hasSameParentAs(t.sourcePosition) && _i218.containsPosition(e.splitPosition)) {
                      var _n113 = _i218.end.offset - e.splitPosition.offset,
                          _o73 = e.splitPosition.offset - _i218.start.offset;

                      this._setRelation(e, t, {
                        howMany: _n113,
                        offset: _o73
                      });
                    }
                  }
              }

              break;

            case Oc:
              switch (t.constructor) {
                case Oc:
                  e.targetPosition.isEqual(t.sourcePosition) || this._setRelation(e, t, "mergeTargetNotMoved"), e.sourcePosition.isEqual(t.targetPosition) && this._setRelation(e, t, "mergeSourceNotMoved"), e.sourcePosition.isEqual(t.sourcePosition) && this._setRelation(e, t, "mergeSameElement");
                  break;

                case zc:
                  e.sourcePosition.isEqual(t.splitPosition) && this._setRelation(e, t, "splitAtSource");
              }

              break;

            case Mc:
              {
                var _i219 = e.newRange;
                if (!_i219) return;

                switch (t.constructor) {
                  case Ic:
                    {
                      var _n114 = sa._createFromPositionAndShift(t.sourcePosition, t.howMany),
                          _o74 = _n114.containsPosition(_i219.start) || _n114.start.isEqual(_i219.start),
                          _r39 = _n114.containsPosition(_i219.end) || _n114.end.isEqual(_i219.end);

                      !_o74 && !_r39 || _n114.containsRange(_i219) || this._setRelation(e, t, {
                        side: _o74 ? "left" : "right",
                        path: _o74 ? _i219.start.path.slice() : _i219.end.path.slice()
                      });
                      break;
                    }

                  case Oc:
                    {
                      var _n115 = _i219.start.isEqual(t.targetPosition),
                          _o75 = _i219.start.isEqual(t.deletionPosition),
                          _r40 = _i219.end.isEqual(t.deletionPosition),
                          _s24 = _i219.end.isEqual(t.sourcePosition);

                      (_n115 || _o75 || _r40 || _s24) && this._setRelation(e, t, {
                        wasInLeftElement: _n115,
                        wasStartBeforeMergedElement: _o75,
                        wasEndBeforeMergedElement: _r40,
                        wasInRightElement: _s24
                      });
                      break;
                    }
                }

                break;
              }
          }
        }
      }, {
        key: "getContext",
        value: function getContext(e, t, i) {
          return {
            aIsStrong: i,
            aWasUndone: this._wasUndone(e),
            bWasUndone: this._wasUndone(t),
            abRelation: this._useRelations ? this._getRelation(e, t) : null,
            baRelation: this._useRelations ? this._getRelation(t, e) : null,
            forceWeakRemove: this._forceWeakRemove
          };
        }
      }, {
        key: "_wasUndone",
        value: function _wasUndone(e) {
          var t = this.originalOperations.get(e);
          return t.wasUndone || this._history.isUndoneOperation(t);
        }
      }, {
        key: "_getRelation",
        value: function _getRelation(e, t) {
          var i = this.originalOperations.get(t),
              n = this._history.getUndoneOperation(i);

          if (!n) return null;

          var o = this.originalOperations.get(e),
              r = this._relations.get(o);

          return r && r.get(n) || null;
        }
      }, {
        key: "_setRelation",
        value: function _setRelation(e, t, i) {
          var n = this.originalOperations.get(e),
              o = this.originalOperations.get(t);

          var r = this._relations.get(n);

          r || (r = new Map(), this._relations.set(n, r)), r.set(o, i);
        }
      }]);

      return ah;
    }();

    function ch(e, t) {
      var _iteratorNormalCompletion302 = true;
      var _didIteratorError302 = false;
      var _iteratorError302 = undefined;

      try {
        for (var _iterator302 = e[Symbol.iterator](), _step302; !(_iteratorNormalCompletion302 = (_step302 = _iterator302.next()).done); _iteratorNormalCompletion302 = true) {
          var _i220 = _step302.value;
          _i220.baseVersion = t++;
        }
      } catch (err) {
        _didIteratorError302 = true;
        _iteratorError302 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion302 && _iterator302.return != null) {
            _iterator302.return();
          }
        } finally {
          if (_didIteratorError302) {
            throw _iteratorError302;
          }
        }
      }
    }

    function lh(e, t) {
      for (var _i221 = 0; _i221 < t; _i221++) {
        e.push(new el(0));
      }
    }

    function dh(e, t, i) {
      var n = e.nodes.getNode(0).getAttribute(t);
      if (n == i) return null;
      var o = new sa(e.position, e.position.getShiftedBy(e.howMany));
      return new Ec(o, t, n, i, 0);
    }

    function hh(e, t) {
      return null === e.targetPosition._getTransformedByDeletion(t.sourcePosition, t.howMany);
    }

    function uh(e, t) {
      var i = [];

      for (var _n116 = 0; _n116 < e.length; _n116++) {
        var _o76 = e[_n116],
            _r41 = new Ic(_o76.start, _o76.end.offset - _o76.start.offset, t, 0);

        i.push(_r41);

        for (var _t210 = _n116 + 1; _t210 < e.length; _t210++) {
          e[_t210] = e[_t210]._getTransformedByMove(_r41.sourcePosition, _r41.targetPosition, _r41.howMany)[0];
        }

        t = t._getTransformedByMove(_r41.sourcePosition, _r41.targetPosition, _r41.howMany);
      }

      return i;
    }

    nh(Ec, Ec, function (e, t, i) {
      if (e.key === t.key && e.range.start.hasSameParentAs(t.range.start)) {
        var _n117 = e.range.getDifference(t.range).map(function (t) {
          return new Ec(t, e.key, e.oldValue, e.newValue, 0);
        }),
            _o77 = e.range.getIntersection(t.range);

        return _o77 && i.aIsStrong && _n117.push(new Ec(_o77, t.key, t.newValue, e.newValue, 0)), 0 == _n117.length ? [new el(0)] : _n117;
      }

      return [e];
    }), nh(Ec, Pc, function (e, t) {
      if (e.range.start.hasSameParentAs(t.position) && e.range.containsPosition(t.position)) {
        var _i222 = e.range._getTransformedByInsertion(t.position, t.howMany, !t.shouldReceiveAttributes).map(function (t) {
          return new Ec(t, e.key, e.oldValue, e.newValue, e.baseVersion);
        });

        if (t.shouldReceiveAttributes) {
          var _n118 = dh(t, e.key, e.oldValue);

          _n118 && _i222.unshift(_n118);
        }

        return _i222;
      }

      return e.range = e.range._getTransformedByInsertion(t.position, t.howMany, !1)[0], [e];
    }), nh(Ec, Oc, function (e, t) {
      var i = [];
      e.range.start.hasSameParentAs(t.deletionPosition) && (e.range.containsPosition(t.deletionPosition) || e.range.start.isEqual(t.deletionPosition)) && i.push(sa._createFromPositionAndShift(t.graveyardPosition, 1));

      var n = e.range._getTransformedByMergeOperation(t);

      return n.isCollapsed || i.push(n), i.map(function (t) {
        return new Ec(t, e.key, e.oldValue, e.newValue, e.baseVersion);
      });
    }), nh(Ec, Ic, function (e, t) {
      return function (e, t) {
        var i = sa._createFromPositionAndShift(t.sourcePosition, t.howMany);

        var n = null,
            o = [];
        i.containsRange(e, !0) ? n = e : e.start.hasSameParentAs(i.start) ? (o = e.getDifference(i), n = e.getIntersection(i)) : o = [e];
        var r = [];
        var _iteratorNormalCompletion303 = true;
        var _didIteratorError303 = false;
        var _iteratorError303 = undefined;

        try {
          for (var _iterator303 = o[Symbol.iterator](), _step303; !(_iteratorNormalCompletion303 = (_step303 = _iterator303.next()).done); _iteratorNormalCompletion303 = true) {
            var _e226 = _step303.value;
            _e226 = _e226._getTransformedByDeletion(t.sourcePosition, t.howMany);

            var _i223 = t.getMovedRangeStart(),
                _n119 = _e226.start.hasSameParentAs(_i223);

            _e226 = _e226._getTransformedByInsertion(_i223, t.howMany, _n119), r.push.apply(r, _toConsumableArray(_e226));
          }
        } catch (err) {
          _didIteratorError303 = true;
          _iteratorError303 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion303 && _iterator303.return != null) {
              _iterator303.return();
            }
          } finally {
            if (_didIteratorError303) {
              throw _iteratorError303;
            }
          }
        }

        n && r.push(n._getTransformedByMove(t.sourcePosition, t.targetPosition, t.howMany, !1)[0]);
        return r;
      }(e.range, t).map(function (t) {
        return new Ec(t, e.key, e.oldValue, e.newValue, e.baseVersion);
      });
    }), nh(Ec, zc, function (e, t) {
      if (e.range.end.isEqual(t.insertionPosition)) return t.graveyardPosition || e.range.end.offset++, [e];

      if (e.range.start.hasSameParentAs(t.splitPosition) && e.range.containsPosition(t.splitPosition)) {
        var _i224 = e.clone();

        return _i224.range = new sa(t.moveTargetPosition.clone(), e.range.end._getCombined(t.splitPosition, t.moveTargetPosition)), e.range.end = t.splitPosition.clone(), e.range.end.stickiness = "toPrevious", [e, _i224];
      }

      return e.range = e.range._getTransformedBySplitOperation(t), [e];
    }), nh(Pc, Ec, function (e, t) {
      var i = [e];

      if (e.shouldReceiveAttributes && e.position.hasSameParentAs(t.range.start) && t.range.containsPosition(e.position)) {
        var _n120 = dh(e, t.key, t.newValue);

        _n120 && i.push(_n120);
      }

      return i;
    }), nh(Pc, Pc, function (e, t, i) {
      return e.position.isEqual(t.position) && i.aIsStrong || (e.position = e.position._getTransformedByInsertOperation(t)), [e];
    }), nh(Pc, Ic, function (e, t) {
      return e.position = e.position._getTransformedByMoveOperation(t), [e];
    }), nh(Pc, zc, function (e, t) {
      return e.position = e.position._getTransformedBySplitOperation(t), [e];
    }), nh(Pc, Oc, function (e, t) {
      return e.position = e.position._getTransformedByMergeOperation(t), [e];
    }), nh(Mc, Pc, function (e, t) {
      return e.oldRange && (e.oldRange = e.oldRange._getTransformedByInsertOperation(t)[0]), e.newRange && (e.newRange = e.newRange._getTransformedByInsertOperation(t)[0]), [e];
    }), nh(Mc, Mc, function (e, t, i) {
      if (e.name == t.name) {
        if (!i.aIsStrong) return [new el(0)];
        e.oldRange = t.newRange ? t.newRange.clone() : null;
      }

      return [e];
    }), nh(Mc, Oc, function (e, t) {
      return e.oldRange && (e.oldRange = e.oldRange._getTransformedByMergeOperation(t)), e.newRange && (e.newRange = e.newRange._getTransformedByMergeOperation(t)), [e];
    }), nh(Mc, Ic, function (e, t, i) {
      if (e.oldRange && (e.oldRange = sa._createFromRanges(e.oldRange._getTransformedByMoveOperation(t))), e.newRange) {
        if (i.abRelation) {
          var _n121 = sa._createFromRanges(e.newRange._getTransformedByMoveOperation(t));

          if ("left" == i.abRelation.side && t.targetPosition.isEqual(e.newRange.start)) return e.newRange.start.path = i.abRelation.path, e.newRange.end = _n121.end, [e];
          if ("right" == i.abRelation.side && t.targetPosition.isEqual(e.newRange.end)) return e.newRange.start = _n121.start, e.newRange.end.path = i.abRelation.path, [e];
        }

        e.newRange = sa._createFromRanges(e.newRange._getTransformedByMoveOperation(t));
      }

      return [e];
    }), nh(Mc, zc, function (e, t, i) {
      if (e.oldRange && (e.oldRange = e.oldRange._getTransformedBySplitOperation(t)), e.newRange) {
        if (i.abRelation) {
          var _n122 = e.newRange._getTransformedBySplitOperation(t);

          return e.newRange.start.isEqual(t.splitPosition) && i.abRelation.wasStartBeforeMergedElement ? e.newRange.start = ia._createAt(t.insertionPosition) : e.newRange.start.isEqual(t.splitPosition) && !i.abRelation.wasInLeftElement && (e.newRange.start = ia._createAt(t.moveTargetPosition)), e.newRange.end.isEqual(t.splitPosition) && i.abRelation.wasInRightElement ? e.newRange.end = ia._createAt(t.moveTargetPosition) : e.newRange.end.isEqual(t.splitPosition) && i.abRelation.wasEndBeforeMergedElement ? e.newRange.end = ia._createAt(t.insertionPosition) : e.newRange.end = _n122.end, [e];
        }

        e.newRange = e.newRange._getTransformedBySplitOperation(t);
      }

      return [e];
    }), nh(Oc, Pc, function (e, t) {
      return e.sourcePosition.hasSameParentAs(t.position) && (e.howMany += t.howMany), e.sourcePosition = e.sourcePosition._getTransformedByInsertOperation(t), e.targetPosition = e.targetPosition._getTransformedByInsertOperation(t), [e];
    }), nh(Oc, Oc, function (e, t, i) {
      if (e.sourcePosition.isEqual(t.sourcePosition) && e.targetPosition.isEqual(t.targetPosition)) {
        if (i.bWasUndone) {
          var _i225 = t.graveyardPosition.path.slice();

          return _i225.push(0), e.sourcePosition = new ia(t.graveyardPosition.root, _i225), e.howMany = 0, [e];
        }

        return [new el(0)];
      }

      if (e.sourcePosition.isEqual(t.sourcePosition) && !e.targetPosition.isEqual(t.targetPosition) && !i.bWasUndone && "splitAtSource" != i.abRelation) {
        var _n123 = "$graveyard" == e.targetPosition.root.rootName,
            _o78 = "$graveyard" == t.targetPosition.root.rootName,
            _r42 = _n123 && !_o78;

        if (_o78 && !_n123 || !_r42 && i.aIsStrong) {
          var _i226 = t.targetPosition._getTransformedByMergeOperation(t),
              _n124 = e.targetPosition._getTransformedByMergeOperation(t);

          return [new Ic(_i226, e.howMany, _n124, 0)];
        }

        return [new el(0)];
      }

      return e.sourcePosition.hasSameParentAs(t.targetPosition) && (e.howMany += t.howMany), e.sourcePosition = e.sourcePosition._getTransformedByMergeOperation(t), e.targetPosition = e.targetPosition._getTransformedByMergeOperation(t), e.graveyardPosition.isEqual(t.graveyardPosition) && i.aIsStrong || (e.graveyardPosition = e.graveyardPosition._getTransformedByMergeOperation(t)), [e];
    }), nh(Oc, Ic, function (e, t, i) {
      var n = sa._createFromPositionAndShift(t.sourcePosition, t.howMany);

      return "remove" == t.type && !i.bWasUndone && !i.forceWeakRemove && e.deletionPosition.hasSameParentAs(t.sourcePosition) && n.containsPosition(e.sourcePosition) ? [new el(0)] : (e.sourcePosition.hasSameParentAs(t.targetPosition) && (e.howMany += t.howMany), e.sourcePosition.hasSameParentAs(t.sourcePosition) && (e.howMany -= t.howMany), e.sourcePosition = e.sourcePosition._getTransformedByMoveOperation(t), e.targetPosition = e.targetPosition._getTransformedByMoveOperation(t), e.graveyardPosition.isEqual(t.targetPosition) || (e.graveyardPosition = e.graveyardPosition._getTransformedByMoveOperation(t)), [e]);
    }), nh(Oc, zc, function (e, t, i) {
      if (t.graveyardPosition && (e.graveyardPosition = e.graveyardPosition._getTransformedByDeletion(t.graveyardPosition, 1), e.deletionPosition.isEqual(t.graveyardPosition) && (e.howMany = t.howMany)), e.targetPosition.isEqual(t.splitPosition)) {
        var _n125 = 0 != t.howMany,
            _o79 = t.graveyardPosition && e.deletionPosition.isEqual(t.graveyardPosition);

        if (_n125 || _o79 || "mergeTargetNotMoved" == i.abRelation) return e.sourcePosition = e.sourcePosition._getTransformedBySplitOperation(t), [e];
      }

      if (e.sourcePosition.isEqual(t.splitPosition)) {
        if ("mergeSourceNotMoved" == i.abRelation) return e.howMany = 0, e.targetPosition = e.targetPosition._getTransformedBySplitOperation(t), [e];
        if ("mergeSameElement" == i.abRelation || e.sourcePosition.offset > 0) return e.sourcePosition = t.moveTargetPosition.clone(), e.targetPosition = e.targetPosition._getTransformedBySplitOperation(t), [e];
      }

      return e.sourcePosition.hasSameParentAs(t.splitPosition) && (e.howMany = t.splitPosition.offset), e.sourcePosition = e.sourcePosition._getTransformedBySplitOperation(t), e.targetPosition = e.targetPosition._getTransformedBySplitOperation(t), [e];
    }), nh(Ic, Pc, function (e, t) {
      var i = sa._createFromPositionAndShift(e.sourcePosition, e.howMany)._getTransformedByInsertOperation(t, !1)[0];

      return e.sourcePosition = i.start, e.howMany = i.end.offset - i.start.offset, e.targetPosition.isEqual(t.position) || (e.targetPosition = e.targetPosition._getTransformedByInsertOperation(t)), [e];
    }), nh(Ic, Ic, function (e, t, i) {
      var n = sa._createFromPositionAndShift(e.sourcePosition, e.howMany),
          o = sa._createFromPositionAndShift(t.sourcePosition, t.howMany);

      var r,
          s = i.aIsStrong,
          a = !i.aIsStrong;
      if ("insertBefore" == i.abRelation || "insertAfter" == i.baRelation ? a = !0 : "insertAfter" != i.abRelation && "insertBefore" != i.baRelation || (a = !1), r = e.targetPosition.isEqual(t.targetPosition) && a ? e.targetPosition._getTransformedByDeletion(t.sourcePosition, t.howMany) : e.targetPosition._getTransformedByMove(t.sourcePosition, t.targetPosition, t.howMany), hh(e, t) && hh(t, e)) return [t.getReversed()];
      if (n.containsPosition(t.targetPosition) && n.containsRange(o, !0)) return n.start = n.start._getTransformedByMove(t.sourcePosition, t.targetPosition, t.howMany), n.end = n.end._getTransformedByMove(t.sourcePosition, t.targetPosition, t.howMany), uh([n], r);
      if (o.containsPosition(e.targetPosition) && o.containsRange(n, !0)) return n.start = n.start._getCombined(t.sourcePosition, t.getMovedRangeStart()), n.end = n.end._getCombined(t.sourcePosition, t.getMovedRangeStart()), uh([n], r);
      var c = cn(e.sourcePosition.getParentPath(), t.sourcePosition.getParentPath());
      if ("prefix" == c || "extension" == c) return n.start = n.start._getTransformedByMove(t.sourcePosition, t.targetPosition, t.howMany), n.end = n.end._getTransformedByMove(t.sourcePosition, t.targetPosition, t.howMany), uh([n], r);
      "remove" != e.type || "remove" == t.type || i.aWasUndone || i.forceWeakRemove ? "remove" == e.type || "remove" != t.type || i.bWasUndone || i.forceWeakRemove || (s = !1) : s = !0;
      var l = [],
          d = n.getDifference(o);
      var _iteratorNormalCompletion304 = true;
      var _didIteratorError304 = false;
      var _iteratorError304 = undefined;

      try {
        for (var _iterator304 = d[Symbol.iterator](), _step304; !(_iteratorNormalCompletion304 = (_step304 = _iterator304.next()).done); _iteratorNormalCompletion304 = true) {
          var _e227 = _step304.value;
          _e227.start = _e227.start._getTransformedByDeletion(t.sourcePosition, t.howMany), _e227.end = _e227.end._getTransformedByDeletion(t.sourcePosition, t.howMany);

          var _i227 = "same" == cn(_e227.start.getParentPath(), t.getMovedRangeStart().getParentPath()),
              _n126 = _e227._getTransformedByInsertion(t.getMovedRangeStart(), t.howMany, _i227);

          l.push.apply(l, _toConsumableArray(_n126));
        }
      } catch (err) {
        _didIteratorError304 = true;
        _iteratorError304 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion304 && _iterator304.return != null) {
            _iterator304.return();
          }
        } finally {
          if (_didIteratorError304) {
            throw _iteratorError304;
          }
        }
      }

      var h = n.getIntersection(o);
      return null !== h && s && (h.start = h.start._getCombined(t.sourcePosition, t.getMovedRangeStart()), h.end = h.end._getCombined(t.sourcePosition, t.getMovedRangeStart()), 0 === l.length ? l.push(h) : 1 == l.length ? o.start.isBefore(n.start) || o.start.isEqual(n.start) ? l.unshift(h) : l.push(h) : l.splice(1, 0, h)), 0 === l.length ? [new el(e.baseVersion)] : uh(l, r);
    }), nh(Ic, zc, function (e, t, i) {
      var n = e.targetPosition.clone();
      e.targetPosition.isEqual(t.insertionPosition) && t.graveyardPosition && "moveTargetAfter" != i.abRelation || (n = e.targetPosition._getTransformedBySplitOperation(t));

      var o = sa._createFromPositionAndShift(e.sourcePosition, e.howMany);

      if (o.end.isEqual(t.insertionPosition)) return t.graveyardPosition || e.howMany++, e.targetPosition = n, [e];

      if (o.start.hasSameParentAs(t.splitPosition) && o.containsPosition(t.splitPosition)) {
        var _e228 = new sa(t.splitPosition, o.end);

        _e228 = _e228._getTransformedBySplitOperation(t);
        return uh([new sa(o.start, t.splitPosition), _e228], n);
      }

      e.targetPosition.isEqual(t.splitPosition) && "insertAtSource" == i.abRelation && (n = t.moveTargetPosition), e.targetPosition.isEqual(t.insertionPosition) && "insertBetween" == i.abRelation && (n = e.targetPosition);
      var r = [o._getTransformedBySplitOperation(t)];

      if (t.graveyardPosition) {
        var _n127 = o.start.isEqual(t.graveyardPosition) || o.containsPosition(t.graveyardPosition);

        e.howMany > 1 && _n127 && !i.aWasUndone && r.push(sa._createFromPositionAndShift(t.insertionPosition, 1));
      }

      return uh(r, n);
    }), nh(Ic, Oc, function (e, t, i) {
      var n = sa._createFromPositionAndShift(e.sourcePosition, e.howMany);

      if (t.deletionPosition.hasSameParentAs(e.sourcePosition) && n.containsPosition(t.sourcePosition)) if ("remove" != e.type || i.forceWeakRemove) {
        if (1 == e.howMany) return i.bWasUndone ? (e.sourcePosition = t.graveyardPosition.clone(), e.targetPosition = e.targetPosition._getTransformedByMergeOperation(t), [e]) : [new el(0)];
      } else if (!i.aWasUndone) {
        var _i228 = [];

        var _n128 = t.graveyardPosition.clone(),
            _o80 = t.targetPosition._getTransformedByMergeOperation(t);

        e.howMany > 1 && (_i228.push(new Ic(e.sourcePosition, e.howMany - 1, e.targetPosition, 0)), _n128 = _n128._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany - 1), _o80 = _o80._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany - 1));

        var _r43 = t.deletionPosition._getCombined(e.sourcePosition, e.targetPosition),
            _s25 = new Ic(_n128, 1, _r43, 0),
            _a16 = _s25.getMovedRangeStart().path.slice();

        _a16.push(0);

        var _c9 = new ia(_s25.targetPosition.root, _a16);

        _o80 = _o80._getTransformedByMove(_n128, _r43, 1);

        var _l4 = new Ic(_o80, t.howMany, _c9, 0);

        return _i228.push(_s25), _i228.push(_l4), _i228;
      }

      var o = sa._createFromPositionAndShift(e.sourcePosition, e.howMany)._getTransformedByMergeOperation(t);

      return e.sourcePosition = o.start, e.howMany = o.end.offset - o.start.offset, e.targetPosition = e.targetPosition._getTransformedByMergeOperation(t), [e];
    }), nh(Nc, Pc, function (e, t) {
      return e.position = e.position._getTransformedByInsertOperation(t), [e];
    }), nh(Nc, Oc, function (e, t) {
      return e.position.isEqual(t.deletionPosition) ? (e.position = t.graveyardPosition.clone(), e.position.stickiness = "toNext", [e]) : (e.position = e.position._getTransformedByMergeOperation(t), [e]);
    }), nh(Nc, Ic, function (e, t) {
      return e.position = e.position._getTransformedByMoveOperation(t), [e];
    }), nh(Nc, Nc, function (e, t, i) {
      if (e.position.isEqual(t.position)) {
        if (!i.aIsStrong) return [new el(0)];
        e.oldName = t.newName;
      }

      return [e];
    }), nh(Nc, zc, function (e, t) {
      if ("same" == cn(e.position.path, t.splitPosition.getParentPath()) && !t.graveyardPosition) {
        var _t211 = new Nc(e.position.getShiftedBy(1), e.oldName, e.newName, 0);

        return [e, _t211];
      }

      return e.position = e.position._getTransformedBySplitOperation(t), [e];
    }), nh(Rc, Rc, function (e, t, i) {
      if (e.root === t.root && e.key === t.key) {
        if (!i.aIsStrong || e.newValue === t.newValue) return [new el(0)];
        e.oldValue = t.newValue;
      }

      return [e];
    }), nh(zc, Pc, function (e, t) {
      return e.splitPosition.hasSameParentAs(t.position) && e.splitPosition.offset < t.position.offset && (e.howMany += t.howMany), e.splitPosition = e.splitPosition._getTransformedByInsertOperation(t), e.insertionPosition = e.insertionPosition._getTransformedByInsertOperation(t), [e];
    }), nh(zc, Oc, function (e, t, i) {
      if (!e.graveyardPosition && !i.bWasUndone && e.splitPosition.hasSameParentAs(t.sourcePosition)) {
        var _i229 = t.graveyardPosition.path.slice();

        _i229.push(0);

        var _n129 = new ia(t.graveyardPosition.root, _i229),
            _o81 = zc.getInsertionPosition(new ia(t.graveyardPosition.root, _i229)),
            _r44 = new zc(_n129, 0, _o81, null, 0);

        return e.splitPosition = e.splitPosition._getTransformedByMergeOperation(t), e.insertionPosition = zc.getInsertionPosition(e.splitPosition), e.graveyardPosition = _r44.insertionPosition.clone(), e.graveyardPosition.stickiness = "toNext", [_r44, e];
      }

      return e.splitPosition.hasSameParentAs(t.deletionPosition) && !e.splitPosition.isAfter(t.deletionPosition) && e.howMany--, e.splitPosition.hasSameParentAs(t.targetPosition) && (e.howMany += t.howMany), e.splitPosition = e.splitPosition._getTransformedByMergeOperation(t), e.insertionPosition = zc.getInsertionPosition(e.splitPosition), e.graveyardPosition && (e.graveyardPosition = e.graveyardPosition._getTransformedByMergeOperation(t)), [e];
    }), nh(zc, Ic, function (e, t, i) {
      var n = sa._createFromPositionAndShift(t.sourcePosition, t.howMany);

      if (e.graveyardPosition) {
        var _o82 = n.start.isEqual(e.graveyardPosition) || n.containsPosition(e.graveyardPosition);

        if (!i.bWasUndone && _o82) {
          var _i230 = e.splitPosition._getTransformedByMoveOperation(t),
              _n130 = e.graveyardPosition._getTransformedByMoveOperation(t),
              _o83 = _n130.path.slice();

          _o83.push(0);

          var _r45 = new ia(_n130.root, _o83);

          return [new Ic(_i230, e.howMany, _r45, 0)];
        }

        e.graveyardPosition = e.graveyardPosition._getTransformedByMoveOperation(t);
      }

      var o = e.splitPosition.isEqual(t.targetPosition);
      if (o && ("insertAtSource" == i.baRelation || "splitBefore" == i.abRelation)) return e.howMany += t.howMany, e.splitPosition = e.splitPosition._getTransformedByDeletion(t.sourcePosition, t.howMany), e.insertionPosition = zc.getInsertionPosition(e.splitPosition), [e];

      if (o && i.abRelation && i.abRelation.howMany) {
        var _i$abRelation = i.abRelation,
            _t212 = _i$abRelation.howMany,
            _n131 = _i$abRelation.offset;
        return e.howMany += _t212, e.splitPosition = e.splitPosition.getShiftedBy(_n131), [e];
      }

      if (e.splitPosition.hasSameParentAs(t.sourcePosition) && n.containsPosition(e.splitPosition)) {
        var _i231 = t.howMany - (e.splitPosition.offset - t.sourcePosition.offset);

        return e.howMany -= _i231, e.splitPosition.hasSameParentAs(t.targetPosition) && e.splitPosition.offset < t.targetPosition.offset && (e.howMany += t.howMany), e.splitPosition = t.sourcePosition.clone(), e.insertionPosition = zc.getInsertionPosition(e.splitPosition), [e];
      }

      return t.sourcePosition.isEqual(t.targetPosition) || (e.splitPosition.hasSameParentAs(t.sourcePosition) && e.splitPosition.offset <= t.sourcePosition.offset && (e.howMany -= t.howMany), e.splitPosition.hasSameParentAs(t.targetPosition) && e.splitPosition.offset < t.targetPosition.offset && (e.howMany += t.howMany)), e.splitPosition.stickiness = "toNone", e.splitPosition = e.splitPosition._getTransformedByMoveOperation(t), e.splitPosition.stickiness = "toNext", e.graveyardPosition ? e.insertionPosition = e.insertionPosition._getTransformedByMoveOperation(t) : e.insertionPosition = zc.getInsertionPosition(e.splitPosition), [e];
    }), nh(zc, zc, function (e, t, i) {
      if (e.splitPosition.isEqual(t.splitPosition)) {
        if (!e.graveyardPosition && !t.graveyardPosition) return [new el(0)];
        if (e.graveyardPosition && t.graveyardPosition && e.graveyardPosition.isEqual(t.graveyardPosition)) return [new el(0)];
        if ("splitBefore" == i.abRelation) return e.howMany = 0, e.graveyardPosition = e.graveyardPosition._getTransformedBySplitOperation(t), [e];
      }

      if (e.graveyardPosition && t.graveyardPosition && e.graveyardPosition.isEqual(t.graveyardPosition)) {
        var _n132 = "$graveyard" == e.splitPosition.root.rootName,
            _o84 = "$graveyard" == t.splitPosition.root.rootName,
            _r46 = _n132 && !_o84;

        if (_o84 && !_n132 || !_r46 && i.aIsStrong) {
          var _i232 = [];
          return t.howMany && _i232.push(new Ic(t.moveTargetPosition, t.howMany, t.splitPosition, 0)), e.howMany && _i232.push(new Ic(e.splitPosition, e.howMany, e.moveTargetPosition, 0)), _i232;
        }

        return [new el(0)];
      }

      if (e.graveyardPosition && (e.graveyardPosition = e.graveyardPosition._getTransformedBySplitOperation(t)), e.splitPosition.isEqual(t.insertionPosition) && "splitBefore" == i.abRelation) return e.howMany++, [e];

      if (t.splitPosition.isEqual(e.insertionPosition) && "splitBefore" == i.baRelation) {
        var _i233 = t.insertionPosition.path.slice();

        _i233.push(0);

        var _n133 = new ia(t.insertionPosition.root, _i233);

        return [e, new Ic(e.insertionPosition, 1, _n133, 0)];
      }

      return e.splitPosition.hasSameParentAs(t.splitPosition) && e.splitPosition.offset < t.splitPosition.offset && (e.howMany -= t.howMany), e.splitPosition = e.splitPosition._getTransformedBySplitOperation(t), e.insertionPosition = zc.getInsertionPosition(e.splitPosition), [e];
    });

    var gh =
    /*#__PURE__*/
    function (_is5) {
      _inherits(gh, _is5);

      function gh(e) {
        var _this137;

        _classCallCheck(this, gh);

        _this137 = _possibleConstructorReturn(this, _getPrototypeOf(gh).call(this, e)), _this137.domEventType = "click";
        return _this137;
      }

      _createClass(gh, [{
        key: "onDomEvent",
        value: function onDomEvent(e) {
          this.fire(e.type, e);
        }
      }]);

      return gh;
    }(is);

    var mh =
    /*#__PURE__*/
    function (_is6) {
      _inherits(mh, _is6);

      function mh(e) {
        var _this138;

        _classCallCheck(this, mh);

        _this138 = _possibleConstructorReturn(this, _getPrototypeOf(mh).call(this, e)), _this138.domEventType = ["mousedown", "mouseup", "mouseover", "mouseout"];
        return _this138;
      }

      _createClass(mh, [{
        key: "onDomEvent",
        value: function onDomEvent(e) {
          this.fire(e.type, e);
        }
      }]);

      return mh;
    }(is);

    var fh =
    /*#__PURE__*/
    function () {
      function fh(e) {
        _classCallCheck(this, fh);

        this.document = e;
      }

      _createClass(fh, [{
        key: "createDocumentFragment",
        value: function createDocumentFragment(e) {
          return new Wo(this.document, e);
        }
      }, {
        key: "createElement",
        value: function createElement(e, t, i) {
          return new eo(this.document, e, t, i);
        }
      }, {
        key: "createText",
        value: function createText(e) {
          return new hn(this.document, e);
        }
      }, {
        key: "clone",
        value: function clone(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          return e._clone(t);
        }
      }, {
        key: "appendChild",
        value: function appendChild(e, t) {
          return t._appendChild(e);
        }
      }, {
        key: "insertChild",
        value: function insertChild(e, t, i) {
          return i._insertChild(e, t);
        }
      }, {
        key: "removeChildren",
        value: function removeChildren(e, t, i) {
          return i._removeChildren(e, t);
        }
      }, {
        key: "remove",
        value: function remove(e) {
          var t = e.parent;
          return t ? this.removeChildren(t.getChildIndex(e), 1, t) : [];
        }
      }, {
        key: "replace",
        value: function replace(e, t) {
          var i = e.parent;

          if (i) {
            var _n134 = i.getChildIndex(e);

            return this.removeChildren(_n134, 1, i), this.insertChild(_n134, t, i), !0;
          }

          return !1;
        }
      }, {
        key: "unwrapElement",
        value: function unwrapElement(e) {
          var t = e.parent;

          if (t) {
            var _i234 = t.getChildIndex(e);

            this.remove(e), this.insertChild(_i234, e.getChildren(), t);
          }
        }
      }, {
        key: "rename",
        value: function rename(e, t) {
          var i = new eo(this.document, e, t.getAttributes(), t.getChildren());
          return this.replace(t, i) ? i : null;
        }
      }, {
        key: "setAttribute",
        value: function setAttribute(e, t, i) {
          i._setAttribute(e, t);
        }
      }, {
        key: "removeAttribute",
        value: function removeAttribute(e, t) {
          t._removeAttribute(e);
        }
      }, {
        key: "addClass",
        value: function addClass(e, t) {
          t._addClass(e);
        }
      }, {
        key: "removeClass",
        value: function removeClass(e, t) {
          t._removeClass(e);
        }
      }, {
        key: "setStyle",
        value: function setStyle(e, t, i) {
          ct(e) && void 0 === i && (i = t), i._setStyle(e, t);
        }
      }, {
        key: "removeStyle",
        value: function removeStyle(e, t) {
          t._removeStyle(e);
        }
      }, {
        key: "setCustomProperty",
        value: function setCustomProperty(e, t, i) {
          i._setCustomProperty(e, t);
        }
      }, {
        key: "removeCustomProperty",
        value: function removeCustomProperty(e, t) {
          return t._removeCustomProperty(e);
        }
      }, {
        key: "createPositionAt",
        value: function createPositionAt(e, t) {
          return co._createAt(e, t);
        }
      }, {
        key: "createPositionAfter",
        value: function createPositionAfter(e) {
          return co._createAfter(e);
        }
      }, {
        key: "createPositionBefore",
        value: function createPositionBefore(e) {
          return co._createBefore(e);
        }
      }, {
        key: "createRange",
        value: function createRange(e, t) {
          return new lo(e, t);
        }
      }, {
        key: "createRangeOn",
        value: function createRangeOn(e) {
          return lo._createOn(e);
        }
      }, {
        key: "createRangeIn",
        value: function createRangeIn(e) {
          return lo._createIn(e);
        }
      }, {
        key: "createSelection",
        value: function createSelection(e, t, i) {
          return new go(e, t, i);
        }
      }]);

      return fh;
    }();

    new Set(["black", "silver", "gray", "white", "maroon", "red", "purple", "fuchsia", "green", "lime", "olive", "yellow", "navy", "blue", "teal", "aqua", "orange", "aliceblue", "antiquewhite", "aquamarine", "azure", "beige", "bisque", "blanchedalmond", "blueviolet", "brown", "burlywood", "cadetblue", "chartreuse", "chocolate", "coral", "cornflowerblue", "cornsilk", "crimson", "cyan", "darkblue", "darkcyan", "darkgoldenrod", "darkgray", "darkgreen", "darkgrey", "darkkhaki", "darkmagenta", "darkolivegreen", "darkorange", "darkorchid", "darkred", "darksalmon", "darkseagreen", "darkslateblue", "darkslategray", "darkslategrey", "darkturquoise", "darkviolet", "deeppink", "deepskyblue", "dimgray", "dimgrey", "dodgerblue", "firebrick", "floralwhite", "forestgreen", "gainsboro", "ghostwhite", "gold", "goldenrod", "greenyellow", "grey", "honeydew", "hotpink", "indianred", "indigo", "ivory", "khaki", "lavender", "lavenderblush", "lawngreen", "lemonchiffon", "lightblue", "lightcoral", "lightcyan", "lightgoldenrodyellow", "lightgray", "lightgreen", "lightgrey", "lightpink", "lightsalmon", "lightseagreen", "lightskyblue", "lightslategray", "lightslategrey", "lightsteelblue", "lightyellow", "limegreen", "linen", "magenta", "mediumaquamarine", "mediumblue", "mediumorchid", "mediumpurple", "mediumseagreen", "mediumslateblue", "mediumspringgreen", "mediumturquoise", "mediumvioletred", "midnightblue", "mintcream", "mistyrose", "moccasin", "navajowhite", "oldlace", "olivedrab", "orangered", "orchid", "palegoldenrod", "palegreen", "paleturquoise", "palevioletred", "papayawhip", "peachpuff", "peru", "pink", "plum", "powderblue", "rosybrown", "royalblue", "saddlebrown", "salmon", "sandybrown", "seagreen", "seashell", "sienna", "skyblue", "slateblue", "slategray", "slategrey", "snow", "springgreen", "steelblue", "tan", "thistle", "tomato", "turquoise", "violet", "wheat", "whitesmoke", "yellowgreen", "rebeccapurple", "currentcolor", "transparent"]);

    var ph =
    /*#__PURE__*/
    function (_Al) {
      _inherits(ph, _Al);

      function ph(e, t) {
        var _this139;

        _classCallCheck(this, ph);

        _this139 = _possibleConstructorReturn(this, _getPrototypeOf(ph).call(this, e)), _this139.view = t, _this139._toolbarConfig = bd(e.config.get("toolbar")), _this139._elementReplacer = new ys();
        return _this139;
      }

      _createClass(ph, [{
        key: "init",
        value: function init(e) {
          var t = this.editor,
              i = this.view,
              n = t.editing.view,
              o = i.editable,
              r = n.document.getRoot();
          o.name = r.rootName, i.render();
          var s = o.element;
          this.setEditableElement(o.name, s), this.focusTracker.add(s), i.editable.bind("isFocused").to(this.focusTracker), n.attachDomRoot(s), e && this._elementReplacer.replace(e, this.element), this._initPlaceholder(), this._initToolbar(), this.fire("ready");
        }
      }, {
        key: "destroy",
        value: function destroy() {
          var e = this.view,
              t = this.editor.editing.view;
          this._elementReplacer.restore(), t.detachDomRoot(e.editable.name), e.destroy(), _get(_getPrototypeOf(ph.prototype), "destroy", this).call(this);
        }
      }, {
        key: "_initToolbar",
        value: function _initToolbar() {
          var e = this.editor,
              t = this.view,
              i = e.editing.view;
          t.stickyPanel.bind("isActive").to(this.focusTracker, "isFocused"), t.stickyPanel.limiterElement = t.element, this._toolbarConfig.viewportTopOffset && (t.stickyPanel.viewportTopOffset = this._toolbarConfig.viewportTopOffset), t.toolbar.fillFromConfig(this._toolbarConfig, this.componentFactory), function (_ref127) {
            var e = _ref127.origin,
                t = _ref127.originKeystrokeHandler,
                i = _ref127.originFocusTracker,
                n = _ref127.toolbar,
                o = _ref127.beforeFocus,
                r = _ref127.afterBlur;
            i.add(n.element), t.set("Alt+F10", function (e, t) {
              i.isFocused && !n.focusTracker.isFocused && (o && o(), n.focus(), t());
            }), n.keystrokes.set("Esc", function (t, i) {
              n.focusTracker.isFocused && (e.focus(), r && r(), i());
            });
          }({
            origin: i,
            originFocusTracker: this.focusTracker,
            originKeystrokeHandler: e.keystrokes,
            toolbar: t.toolbar
          });
        }
      }, {
        key: "_initPlaceholder",
        value: function _initPlaceholder() {
          var e = this.editor,
              t = e.editing.view,
              i = t.document.getRoot(),
              n = e.sourceElement,
              o = e.config.get("placeholder") || n && "textarea" === n.tagName.toLowerCase() && n.getAttribute("placeholder");
          o && Jd({
            view: t,
            element: i,
            text: o,
            isDirectHost: !1,
            keepOnFocus: !0
          });
        }
      }, {
        key: "element",
        get: function get() {
          return this.view.element;
        }
      }]);

      return ph;
    }(Al);

    i(61);

    var bh =
    /*#__PURE__*/
    function (_Pd) {
      _inherits(bh, _Pd);

      function bh(e, t) {
        var _this140;

        var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        _classCallCheck(this, bh);

        _this140 = _possibleConstructorReturn(this, _getPrototypeOf(bh).call(this, e)), _this140.stickyPanel = new Kd(e), _this140.toolbar = new wd(e, {
          shouldGroupWhenFull: i.shouldToolbarGroupWhenFull
        }), _this140.editable = new Nd(e, t);
        return _this140;
      }

      _createClass(bh, [{
        key: "render",
        value: function render() {
          _get(_getPrototypeOf(bh.prototype), "render", this).call(this), this.stickyPanel.content.add(this.toolbar), this.top.add(this.stickyPanel), this.main.add(this.editable);
        }
      }]);

      return bh;
    }(Pd);

    var wh =
    /*#__PURE__*/
    function (_vl) {
      _inherits(wh, _vl);

      function wh(e, t) {
        var _this141;

        _classCallCheck(this, wh);

        _this141 = _possibleConstructorReturn(this, _getPrototypeOf(wh).call(this, t)), Yi(e) && (_this141.sourceElement = e), _this141.model.document.createRoot();
        var i = !_this141.config.get("toolbar.shouldNotGroupWhenFull"),
            n = new bh(_this141.locale, _this141.editing.view, {
          shouldToolbarGroupWhenFull: i
        });
        _this141.ui = new ph(_assertThisInitialized(_this141), n), function (e) {
          if (!M(e.updateSourceElement)) throw new c.a("attachtoform-missing-elementapi-interface", e);
          var t = e.sourceElement;

          if (t && "textarea" === t.tagName.toLowerCase() && t.form) {
            var _i235;

            var _n135 = t.form,
                _o85 = function _o85() {
              return e.updateSourceElement();
            };

            M(_n135.submit) && (_i235 = _n135.submit, _n135.submit = function () {
              _o85(), _i235.apply(_n135);
            }), _n135.addEventListener("submit", _o85), e.on("destroy", function () {
              _n135.removeEventListener("submit", _o85), _i235 && (_n135.submit = _i235);
            });
          }
        }(_assertThisInitialized(_this141));
        return _this141;
      }

      _createClass(wh, [{
        key: "destroy",
        value: function destroy() {
          return this.sourceElement && this.updateSourceElement(), this.ui.destroy(), _get(_getPrototypeOf(wh.prototype), "destroy", this).call(this);
        }
      }], [{
        key: "create",
        value: function create(e) {
          var _this142 = this;

          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          return new Promise(function (i) {
            var n = new _this142(e, t);
            i(n.initPlugins().then(function () {
              return n.ui.init(Yi(e) ? e : null);
            }).then(function () {
              if (!Yi(e) && t.initialData) throw new c.a("editor-create-initial-data", null);
              var i = void 0 !== t.initialData ? t.initialData : function (e) {
                return Yi(e) ? (t = e, t instanceof HTMLTextAreaElement ? t.value : t.innerHTML) : e;
                var t;
              }(e);
              return n.data.init(i);
            }).then(function () {
              return n.fire("ready");
            }).then(function () {
              return n;
            }));
          });
        }
      }]);

      return wh;
    }(vl);

    Ke(wh, Cl), Ke(wh, Tl);

    var kh =
    /*#__PURE__*/
    function () {
      function kh(e) {
        _classCallCheck(this, kh);

        this.files = function (e) {
          var t = e.files ? Array.from(e.files) : [],
              i = e.items ? Array.from(e.items) : [];
          if (t.length) return t;
          return i.filter(function (e) {
            return "file" === e.kind;
          }).map(function (e) {
            return e.getAsFile();
          });
        }(e), this._native = e;
      }

      _createClass(kh, [{
        key: "getData",
        value: function getData(e) {
          return this._native.getData(e);
        }
      }, {
        key: "setData",
        value: function setData(e, t) {
          this._native.setData(e, t);
        }
      }, {
        key: "types",
        get: function get() {
          return this._native.types;
        }
      }, {
        key: "effectAllowed",
        set: function set(e) {
          this._native.effectAllowed = e;
        },
        get: function get() {
          return this._native.effectAllowed;
        }
      }, {
        key: "dropEffect",
        set: function set(e) {
          this._native.dropEffect = e;
        },
        get: function get() {
          return this._native.dropEffect;
        }
      }, {
        key: "isCanceled",
        get: function get() {
          return "none" == this._native.dropEffect || !!this._native.mozUserCancelled;
        }
      }]);

      return kh;
    }();

    var _h =
    /*#__PURE__*/
    function (_is7) {
      _inherits(_h, _is7);

      function _h(e) {
        var _this143;

        _classCallCheck(this, _h);

        _this143 = _possibleConstructorReturn(this, _getPrototypeOf(_h).call(this, e));
        var t = _this143.document;

        function i(e) {
          return function (i, n) {
            n.preventDefault();
            var r = n.dropRange ? [n.dropRange] : null,
                s = new o(t, e);
            t.fire(s, {
              dataTransfer: n.dataTransfer,
              method: i.name,
              targetRanges: r,
              target: n.target
            }), s.stop.called && n.stopPropagation();
          };
        }

        _this143.domEventType = ["paste", "copy", "cut", "drop", "dragover", "dragstart", "dragend", "dragenter", "dragleave"], _this143.listenTo(t, "paste", i("clipboardInput"), {
          priority: "low"
        }), _this143.listenTo(t, "drop", i("clipboardInput"), {
          priority: "low"
        }), _this143.listenTo(t, "dragover", i("dragging"), {
          priority: "low"
        });
        return _this143;
      }

      _createClass(_h, [{
        key: "onDomEvent",
        value: function onDomEvent(e) {
          var t = {
            dataTransfer: new kh(e.clipboardData ? e.clipboardData : e.dataTransfer)
          };
          "drop" != e.type && "dragover" != e.type || (t.dropRange = function (e, t) {
            var i = t.target.ownerDocument,
                n = t.clientX,
                o = t.clientY;
            var r;
            i.caretRangeFromPoint && i.caretRangeFromPoint(n, o) ? r = i.caretRangeFromPoint(n, o) : t.rangeParent && (r = i.createRange(), r.setStart(t.rangeParent, t.rangeOffset), r.collapse(!0));
            if (r) return e.domConverter.domRangeToView(r);
            return null;
          }(this.view, e)), this.fire(e.type, e, t);
        }
      }]);

      return _h;
    }(is);

    var vh = ["figcaption", "li"];

    var yh =
    /*#__PURE__*/
    function (_Qe2) {
      _inherits(yh, _Qe2);

      function yh() {
        _classCallCheck(this, yh);

        return _possibleConstructorReturn(this, _getPrototypeOf(yh).apply(this, arguments));
      }

      _createClass(yh, [{
        key: "init",
        value: function init() {
          this.editor.editing.view.addObserver(_h), this._setupPasteDrop(), this._setupCopyCut();
        }
      }, {
        key: "_setupPasteDrop",
        value: function _setupPasteDrop() {
          var _this144 = this;

          var e = this.editor,
              t = e.model,
              i = e.editing.view,
              n = i.document;
          this.listenTo(n, "clipboardInput", function (t) {
            e.isReadOnly && t.stop();
          }, {
            priority: "highest"
          }), this.listenTo(n, "clipboardInput", function (e, t) {
            var n = t.dataTransfer;
            var r = t.content || "";
            var s;
            r || (n.getData("text/html") ? r = function (e) {
              return e.replace(/<span(?: class="Apple-converted-space"|)>(\s+)<\/span>/g, function (e, t) {
                return 1 == t.length ? " " : t;
              });
            }(n.getData("text/html")) : n.getData("text/plain") && (((s = (s = n.getData("text/plain")).replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\r?\n\r?\n/g, "</p><p>").replace(/\r?\n/g, "<br>").replace(/^\s/, "&nbsp;").replace(/\s$/, "&nbsp;").replace(/\s\s/g, " &nbsp;")).includes("</p><p>") || s.includes("<br>")) && (s = "<p>".concat(s, "</p>")), r = s), r = _this144.editor.data.htmlProcessor.toView(r));
            var a = new o(_this144, "inputTransformation");
            _this144.fire(a, {
              content: r,
              dataTransfer: n,
              targetRanges: t.targetRanges,
              method: t.method
            }), a.stop.called && e.stop(), i.scrollToTheSelection();
          }, {
            priority: "low"
          }), this.listenTo(this, "inputTransformation", function (e, i) {
            if (i.content.isEmpty) return;

            var n = _this144.editor.data.toModel(i.content, "$clipboardHolder");

            0 != n.childCount && (e.stop(), t.change(function () {
              _this144.fire("contentInsertion", {
                content: n,
                method: i.method,
                dataTransfer: i.dataTransfer,
                targetRanges: i.targetRanges
              });
            }));
          }, {
            priority: "low"
          }), this.listenTo(this, "contentInsertion", function (e, i) {
            i.resultRange = t.insertContent(i.content);
          }, {
            priority: "low"
          });
        }
      }, {
        key: "_setupCopyCut",
        value: function _setupCopyCut() {
          var _this145 = this;

          var e = this.editor,
              t = e.model.document,
              i = e.editing.view.document;

          function n(n, o) {
            var r = o.dataTransfer;
            o.preventDefault();
            var s = e.data.toView(e.model.getSelectedContent(t.selection));
            i.fire("clipboardOutput", {
              dataTransfer: r,
              content: s,
              method: n.name
            });
          }

          this.listenTo(i, "copy", n, {
            priority: "low"
          }), this.listenTo(i, "cut", function (t, i) {
            e.isReadOnly ? i.preventDefault() : n(t, i);
          }, {
            priority: "low"
          }), this.listenTo(i, "clipboardOutput", function (i, n) {
            n.content.isEmpty || (n.dataTransfer.setData("text/html", _this145.editor.data.htmlProcessor.toData(n.content)), n.dataTransfer.setData("text/plain", function e(t) {
              var i = "";
              if (t.is("$text") || t.is("$textProxy")) i = t.data;else if (t.is("element", "img") && t.hasAttribute("alt")) i = t.getAttribute("alt");else if (t.is("element", "br")) i = "\n";else {
                var _n136 = null;
                var _iteratorNormalCompletion305 = true;
                var _didIteratorError305 = false;
                var _iteratorError305 = undefined;

                try {
                  for (var _iterator305 = t.getChildren()[Symbol.iterator](), _step305; !(_iteratorNormalCompletion305 = (_step305 = _iterator305.next()).done); _iteratorNormalCompletion305 = true) {
                    var _o86 = _step305.value;

                    var _t213 = e(_o86);

                    _n136 && (_n136.is("containerElement") || _o86.is("containerElement")) && (vh.includes(_n136.name) || vh.includes(_o86.name) ? i += "\n" : i += "\n\n"), i += _t213, _n136 = _o86;
                  }
                } catch (err) {
                  _didIteratorError305 = true;
                  _iteratorError305 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion305 && _iterator305.return != null) {
                      _iterator305.return();
                    }
                  } finally {
                    if (_didIteratorError305) {
                      throw _iteratorError305;
                    }
                  }
                }
              }
              return i;
            }(n.content))), "cut" == n.method && e.model.deleteContent(t.selection);
          }, {
            priority: "low"
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "ClipboardPipeline";
        }
      }]);

      return yh;
    }(Qe);

    function xh(e, t) {
      var _iteratorNormalCompletion306, _didIteratorError306, _iteratorError306, _iterator306, _step306, _i236;

      return _regeneratorRuntime.wrap(function xh$(_context37) {
        while (1) {
          switch (_context37.prev = _context37.next) {
            case 0:
              _iteratorNormalCompletion306 = true;
              _didIteratorError306 = false;
              _iteratorError306 = undefined;
              _context37.prev = 3;
              _iterator306 = t[Symbol.iterator]();

            case 5:
              if (_iteratorNormalCompletion306 = (_step306 = _iterator306.next()).done) {
                _context37.next = 14;
                break;
              }

              _i236 = _step306.value;
              _context37.t0 = _i236 && e.getAttributeProperties(_i236[0]).copyOnEnter;

              if (!_context37.t0) {
                _context37.next = 11;
                break;
              }

              _context37.next = 11;
              return _i236;

            case 11:
              _iteratorNormalCompletion306 = true;
              _context37.next = 5;
              break;

            case 14:
              _context37.next = 20;
              break;

            case 16:
              _context37.prev = 16;
              _context37.t1 = _context37["catch"](3);
              _didIteratorError306 = true;
              _iteratorError306 = _context37.t1;

            case 20:
              _context37.prev = 20;
              _context37.prev = 21;

              if (!_iteratorNormalCompletion306 && _iterator306.return != null) {
                _iterator306.return();
              }

            case 23:
              _context37.prev = 23;

              if (!_didIteratorError306) {
                _context37.next = 26;
                break;
              }

              throw _iteratorError306;

            case 26:
              return _context37.finish(23);

            case 27:
              return _context37.finish(20);

            case 28:
            case "end":
              return _context37.stop();
          }
        }
      }, _marked3, null, [[3, 16, 20, 28], [21,, 23, 27]]);
    }

    var Ah =
    /*#__PURE__*/
    function (_Ze2) {
      _inherits(Ah, _Ze2);

      function Ah() {
        _classCallCheck(this, Ah);

        return _possibleConstructorReturn(this, _getPrototypeOf(Ah).apply(this, arguments));
      }

      _createClass(Ah, [{
        key: "execute",
        value: function execute() {
          var _this146 = this;

          var e = this.editor.model,
              t = e.document;
          e.change(function (i) {
            !function (e, t, i, n) {
              var o = i.isCollapsed,
                  r = i.getFirstRange(),
                  s = r.start.parent,
                  a = r.end.parent;
              if (n.isLimit(s) || n.isLimit(a)) return void (o || s != a || e.deleteContent(i));

              if (o) {
                var _e229 = xh(t.model.schema, i.getAttributes());

                Ch(t, r.start), t.setSelectionAttribute(_e229);
              } else {
                var _n137 = !(r.start.isAtStart && r.end.isAtEnd),
                    _o87 = s == a;

                e.deleteContent(i, {
                  leaveUnmerged: _n137
                }), _n137 && (_o87 ? Ch(t, i.focus) : t.setSelection(a, 0));
              }
            }(_this146.editor.model, i, t.selection, e.schema), _this146.fire("afterExecute", {
              writer: i
            });
          });
        }
      }]);

      return Ah;
    }(Ze);

    function Ch(e, t) {
      e.split(t), e.setSelection(t.parent.nextSibling, 0);
    }

    var Th =
    /*#__PURE__*/
    function (_zr6) {
      _inherits(Th, _zr6);

      function Th(e) {
        var _this147;

        _classCallCheck(this, Th);

        _this147 = _possibleConstructorReturn(this, _getPrototypeOf(Th).call(this, e));
        var t = _this147.document;
        t.on("keydown", function (e, i) {
          if (_this147.isEnabled && i.keyCode == No.enter) {
            var _n138 = new fo(t, "enter", t.selection.getFirstRange());

            t.fire(_n138, new ts(t, i.domEvent, {
              isSoft: i.shiftKey
            })), _n138.stop.called && e.stop();
          }
        });
        return _this147;
      }

      _createClass(Th, [{
        key: "observe",
        value: function observe() {}
      }]);

      return Th;
    }(zr);

    var Eh =
    /*#__PURE__*/
    function (_Qe3) {
      _inherits(Eh, _Qe3);

      function Eh() {
        _classCallCheck(this, Eh);

        return _possibleConstructorReturn(this, _getPrototypeOf(Eh).apply(this, arguments));
      }

      _createClass(Eh, [{
        key: "init",
        value: function init() {
          var e = this.editor,
              t = e.editing.view,
              i = t.document;
          t.addObserver(Th), e.commands.add("enter", new Ah(e)), this.listenTo(i, "enter", function (i, n) {
            n.preventDefault(), n.isSoft || (e.execute("enter"), t.scrollToTheSelection());
          }, {
            priority: "low"
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "Enter";
        }
      }]);

      return Eh;
    }(Qe);

    var Sh =
    /*#__PURE__*/
    function () {
      function Sh(e) {
        var _this148 = this;

        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;

        _classCallCheck(this, Sh);

        this.model = e, this.size = 0, this.limit = t, this.isLocked = !1, this._changeCallback = function (e, t) {
          "transparent" != t.type && t !== _this148._batch && _this148._reset(!0);
        }, this._selectionChangeCallback = function () {
          _this148._reset();
        }, this.model.document.on("change", this._changeCallback), this.model.document.selection.on("change:range", this._selectionChangeCallback), this.model.document.selection.on("change:attribute", this._selectionChangeCallback);
      }

      _createClass(Sh, [{
        key: "input",
        value: function input(e) {
          this.size += e, this.size >= this.limit && this._reset(!0);
        }
      }, {
        key: "lock",
        value: function lock() {
          this.isLocked = !0;
        }
      }, {
        key: "unlock",
        value: function unlock() {
          this.isLocked = !1;
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.model.document.off("change", this._changeCallback), this.model.document.selection.off("change:range", this._selectionChangeCallback), this.model.document.selection.off("change:attribute", this._selectionChangeCallback);
        }
      }, {
        key: "_reset",
        value: function _reset(e) {
          this.isLocked && !e || (this._batch = null, this.size = 0);
        }
      }, {
        key: "batch",
        get: function get() {
          return this._batch || (this._batch = this.model.createBatch()), this._batch;
        }
      }]);

      return Sh;
    }();

    var Ih =
    /*#__PURE__*/
    function (_Ze3) {
      _inherits(Ih, _Ze3);

      function Ih(e, t) {
        var _this149;

        _classCallCheck(this, Ih);

        _this149 = _possibleConstructorReturn(this, _getPrototypeOf(Ih).call(this, e)), _this149.direction = t, _this149._buffer = new Sh(e.model, e.config.get("typing.undoStep"));
        return _this149;
      }

      _createClass(Ih, [{
        key: "execute",
        value: function execute() {
          var _this150 = this;

          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var t = this.editor.model,
              i = t.document;
          t.enqueueChange(this._buffer.batch, function (n) {
            _this150._buffer.lock();

            var o = n.createSelection(e.selection || i.selection),
                r = e.sequence || 1,
                s = o.isCollapsed;
            if (o.isCollapsed && t.modifySelection(o, {
              direction: _this150.direction,
              unit: e.unit
            }), _this150._shouldEntireContentBeReplacedWithParagraph(r)) return void _this150._replaceEntireContentWithParagraph(n);
            if (_this150._shouldReplaceFirstBlockWithParagraph(o, r)) return void _this150.editor.execute("paragraph", {
              selection: o
            });
            if (o.isCollapsed) return;
            var a = 0;
            o.getFirstRange().getMinimalFlatRanges().forEach(function (e) {
              a += uo(e.getWalker({
                singleCharacters: !0,
                ignoreElementEnd: !0,
                shallow: !0
              }));
            }), t.deleteContent(o, {
              doNotResetEntireContent: s,
              direction: _this150.direction
            }), _this150._buffer.input(a), n.setSelection(o), _this150._buffer.unlock();
          });
        }
      }, {
        key: "_shouldEntireContentBeReplacedWithParagraph",
        value: function _shouldEntireContentBeReplacedWithParagraph(e) {
          if (e > 1) return !1;
          var t = this.editor.model,
              i = t.document.selection,
              n = t.schema.getLimitElement(i);
          if (!(i.isCollapsed && i.containsEntireContent(n))) return !1;
          if (!t.schema.checkChild(n, "paragraph")) return !1;
          var o = n.getChild(0);
          return !o || "paragraph" !== o.name;
        }
      }, {
        key: "_replaceEntireContentWithParagraph",
        value: function _replaceEntireContentWithParagraph(e) {
          var t = this.editor.model,
              i = t.document.selection,
              n = t.schema.getLimitElement(i),
              o = e.createElement("paragraph");
          e.remove(e.createRangeIn(n)), e.insert(o, n), e.setSelection(o, 0);
        }
      }, {
        key: "_shouldReplaceFirstBlockWithParagraph",
        value: function _shouldReplaceFirstBlockWithParagraph(e, t) {
          var i = this.editor.model;
          if (t > 1 || "backward" != this.direction) return !1;
          if (!e.isCollapsed) return !1;
          var n = e.getFirstPosition(),
              o = i.schema.getLimitElement(n),
              r = o.getChild(0);
          return n.parent == r && !!e.containsEntireContent(r) && !!i.schema.checkChild(o, "paragraph") && "paragraph" != r.name;
        }
      }, {
        key: "buffer",
        get: function get() {
          return this._buffer;
        }
      }]);

      return Ih;
    }(Ze);

    var Ph =
    /*#__PURE__*/
    function (_zr7) {
      _inherits(Ph, _zr7);

      function Ph(e) {
        var _this151;

        _classCallCheck(this, Ph);

        _this151 = _possibleConstructorReturn(this, _getPrototypeOf(Ph).call(this, e));
        var t = e.document;
        var i = 0;

        function n(e, i, n) {
          var o = new fo(t, "delete", t.selection.getFirstRange());
          t.fire(o, new ts(t, i, n)), o.stop.called && e.stop();
        }

        t.on("keyup", function (e, t) {
          t.keyCode != No.delete && t.keyCode != No.backspace || (i = 0);
        }), t.on("keydown", function (e, t) {
          var o = {};
          if (t.keyCode == No.delete) o.direction = "forward", o.unit = "character";else {
            if (t.keyCode != No.backspace) return;
            o.direction = "backward", o.unit = "codePoint";
          }
          var r = Io.isMac ? t.altKey : t.ctrlKey;
          o.unit = r ? "word" : o.unit, o.sequence = ++i, n(e, t.domEvent, o);
        }), Io.isAndroid && t.on("beforeinput", function (t, i) {
          if ("deleteContentBackward" != i.domEvent.inputType) return;
          var o = {
            unit: "codepoint",
            direction: "backward",
            sequence: 1
          },
              r = i.domTarget.ownerDocument.defaultView.getSelection();
          r.anchorNode == r.focusNode && r.anchorOffset + 1 != r.focusOffset && (o.selectionToRemove = e.domConverter.domSelectionToView(r)), n(t, i.domEvent, o);
        });
        return _this151;
      }

      _createClass(Ph, [{
        key: "observe",
        value: function observe() {}
      }]);

      return Ph;
    }(zr);

    var Mh =
    /*#__PURE__*/
    function (_Qe4) {
      _inherits(Mh, _Qe4);

      function Mh() {
        _classCallCheck(this, Mh);

        return _possibleConstructorReturn(this, _getPrototypeOf(Mh).apply(this, arguments));
      }

      _createClass(Mh, [{
        key: "init",
        value: function init() {
          var e = this.editor,
              t = e.editing.view,
              i = t.document;
          t.addObserver(Ph);
          var n = new Ih(e, "forward");

          if (e.commands.add("deleteForward", n), e.commands.add("forwardDelete", n), e.commands.add("delete", new Ih(e, "backward")), this.listenTo(i, "delete", function (i, n) {
            var o = {
              unit: n.unit,
              sequence: n.sequence
            };

            if (n.selectionToRemove) {
              var _t214 = e.model.createSelection(),
                  _i237 = [];

              var _iteratorNormalCompletion307 = true;
              var _didIteratorError307 = false;
              var _iteratorError307 = undefined;

              try {
                for (var _iterator307 = n.selectionToRemove.getRanges()[Symbol.iterator](), _step307; !(_iteratorNormalCompletion307 = (_step307 = _iterator307.next()).done); _iteratorNormalCompletion307 = true) {
                  var _t215 = _step307.value;

                  _i237.push(e.editing.mapper.toModelRange(_t215));
                }
              } catch (err) {
                _didIteratorError307 = true;
                _iteratorError307 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion307 && _iterator307.return != null) {
                    _iterator307.return();
                  }
                } finally {
                  if (_didIteratorError307) {
                    throw _iteratorError307;
                  }
                }
              }

              _t214.setTo(_i237), o.selection = _t214;
            }

            e.execute("forward" == n.direction ? "deleteForward" : "delete", o), n.preventDefault(), t.scrollToTheSelection();
          }, {
            priority: "low"
          }), Io.isAndroid) {
            var _e230 = null;
            this.listenTo(i, "delete", function (t, i) {
              var n = i.domTarget.ownerDocument.defaultView.getSelection();
              _e230 = {
                anchorNode: n.anchorNode,
                anchorOffset: n.anchorOffset,
                focusNode: n.focusNode,
                focusOffset: n.focusOffset
              };
            }, {
              priority: "lowest"
            }), this.listenTo(i, "keyup", function (t, i) {
              if (_e230) {
                var _t216 = i.domTarget.ownerDocument.defaultView.getSelection();

                _t216.collapse(_e230.anchorNode, _e230.anchorOffset), _t216.extend(_e230.focusNode, _e230.focusOffset), _e230 = null;
              }
            });
          }
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "Delete";
        }
      }]);

      return Mh;
    }(Qe);

    var Nh =
    /*#__PURE__*/
    function () {
      function Nh() {
        _classCallCheck(this, Nh);

        this._stack = [];
      }

      _createClass(Nh, [{
        key: "add",
        value: function add(e, t) {
          var i = this._stack,
              n = i[0];

          this._insertDescriptor(e);

          var o = i[0];
          n === o || Rh(n, o) || this.fire("change:top", {
            oldDescriptor: n,
            newDescriptor: o,
            writer: t
          });
        }
      }, {
        key: "remove",
        value: function remove(e, t) {
          var i = this._stack,
              n = i[0];

          this._removeDescriptor(e);

          var o = i[0];
          n === o || Rh(n, o) || this.fire("change:top", {
            oldDescriptor: n,
            newDescriptor: o,
            writer: t
          });
        }
      }, {
        key: "_insertDescriptor",
        value: function _insertDescriptor(e) {
          var t = this._stack,
              i = t.findIndex(function (t) {
            return t.id === e.id;
          });
          if (Rh(e, t[i])) return;
          i > -1 && t.splice(i, 1);
          var n = 0;

          for (; t[n] && Oh(t[n], e);) {
            n++;
          }

          t.splice(n, 0, e);
        }
      }, {
        key: "_removeDescriptor",
        value: function _removeDescriptor(e) {
          var t = this._stack,
              i = t.findIndex(function (t) {
            return t.id === e;
          });
          i > -1 && t.splice(i, 1);
        }
      }]);

      return Nh;
    }();

    function Rh(e, t) {
      return e && t && e.priority == t.priority && zh(e.classes) == zh(t.classes);
    }

    function Oh(e, t) {
      return e.priority > t.priority || !(e.priority < t.priority) && zh(e.classes) > zh(t.classes);
    }

    function zh(e) {
      return Array.isArray(e) ? e.sort().join(",") : e;
    }

    Ke(Nh, h);

    function Dh(e) {
      return !!e.is("element") && !!e.getCustomProperty("widget");
    }

    function Lh(e, t) {
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      if (!e.is("containerElement")) throw new c.a("widget-to-widget-wrong-element-type", null, {
        element: e
      });
      return t.setAttribute("contenteditable", "false", e), t.addClass("ck-widget", e), t.setCustomProperty("widget", !0, e), e.getFillerOffset = qh, i.label && function (e, t, i) {
        i.setCustomProperty("widgetLabel", t, e);
      }(e, i.label, t), i.hasSelectionHandle && function (e, t) {
        var i = t.createUIElement("div", {
          class: "ck ck-widget__selection-handle"
        }, function (e) {
          var t = this.toDomElement(e),
              i = new ed();
          return i.set("content", '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M4 0v1H1v3H0V.5A.5.5 0 0 1 .5 0H4zm8 0h3.5a.5.5 0 0 1 .5.5V4h-1V1h-3V0zM4 16H.5a.5.5 0 0 1-.5-.5V12h1v3h3v1zm8 0v-1h3v-3h1v3.5a.5.5 0 0 1-.5.5H12z"/><path fill-opacity=".256" d="M1 1h14v14H1z"/><g class="ck-icon__selected-indicator"><path d="M7 0h2v1H7V0zM0 7h1v2H0V7zm15 0h1v2h-1V7zm-8 8h2v1H7v-1z"/><path fill-opacity=".254" d="M1 1h14v14H1z"/></g></svg>'), i.render(), t.appendChild(i.element), t;
        });
        t.insert(t.createPositionAt(e, 0), i), t.addClass(["ck-widget_with-selection-handle"], e);
      }(e, t), Bh(e, t, Vh, jh), e;
    }

    function Vh(e, t, i) {
      if (t.classes && i.addClass(en(t.classes), e), t.attributes) for (var _n139 in t.attributes) {
        i.setAttribute(_n139, t.attributes[_n139], e);
      }
    }

    function jh(e, t, i) {
      if (t.classes && i.removeClass(en(t.classes), e), t.attributes) for (var _n140 in t.attributes) {
        i.removeAttribute(_n140, e);
      }
    }

    function Bh(e, t, i, n) {
      var o = new Nh();
      o.on("change:top", function (t, o) {
        o.oldDescriptor && n(e, o.oldDescriptor, o.writer), o.newDescriptor && i(e, o.newDescriptor, o.writer);
      }), t.setCustomProperty("addHighlight", function (e, t, i) {
        return o.add(t, i);
      }, e), t.setCustomProperty("removeHighlight", function (e, t, i) {
        return o.remove(t, i);
      }, e);
    }

    function Fh(e) {
      var t = e.getCustomProperty("widgetLabel");
      return t ? "function" == typeof t ? t() : t : "";
    }

    function Hh(e, t) {
      return t.addClass(["ck-editor__editable", "ck-editor__nested-editable"], e), t.setAttribute("contenteditable", e.isReadOnly ? "false" : "true", e), e.on("change:isReadOnly", function (i, n, o) {
        t.setAttribute("contenteditable", o ? "false" : "true", e);
      }), e.on("change:isFocused", function (i, n, o) {
        o ? t.addClass("ck-editor__nested-editable_focused", e) : t.removeClass("ck-editor__nested-editable_focused", e);
      }), e;
    }

    function Uh(e, t) {
      var i = e.getSelectedElement();

      if (i) {
        var _n141 = Yh(e);

        if (_n141) return t.createRange(t.createPositionAt(i, _n141));
        if (t.schema.isObject(i) && !t.schema.isInline(i)) return t.createRangeOn(i);
      }

      var n = e.getSelectedBlocks().next().value;

      if (n) {
        if (n.isEmpty) return t.createRange(t.createPositionAt(n, 0));

        var _i238 = t.createPositionAfter(n);

        return e.focus.isTouching(_i238) ? t.createRange(_i238) : t.createRange(t.createPositionBefore(n));
      }

      return t.createRange(e.focus);
    }

    function Wh(e, t) {
      var i = new Ss(vr.window),
          n = i.getIntersection(e),
          o = t.height + Bd.arrowVerticalOffset;
      if (e.top - o > i.top || e.bottom + o < i.bottom) return null;
      var r = n || e,
          s = r.left + r.width / 2 - t.width / 2;
      return {
        top: Math.max(e.top, 0) + Bd.arrowVerticalOffset,
        left: s,
        name: "arrow_n"
      };
    }

    function qh() {
      return null;
    }

    function $h(e, t, i) {
      return e && Dh(e) && !i.isInline(t);
    }

    function Yh(e) {
      return e.getAttribute("widget-type-around");
    }

    var Gh = [Oo("arrowUp"), Oo("arrowRight"), Oo("arrowDown"), Oo("arrowLeft"), 9, 16, 17, 18, 19, 20, 27, 33, 34, 35, 36, 45, 91, 93, 144, 145, 173, 174, 175, 176, 177, 178, 179, 255];

    for (var _e231 = 112; _e231 <= 135; _e231++) {
      Gh.push(_e231);
    }

    function Kh(e) {
      return !(!e.ctrlKey && !e.metaKey) || Gh.includes(e.keyCode);
    }

    i(63);
    var Qh = ["before", "after"],
        Jh = new DOMParser().parseFromString('<svg viewBox="0 0 10 8" xmlns="http://www.w3.org/2000/svg"><path d="M9.055.263v3.972h-6.77M1 4.216l2-2.038m-2 2 2 2.038"/></svg>', "image/svg+xml").firstChild;

    var Zh =
    /*#__PURE__*/
    function (_Qe5) {
      _inherits(Zh, _Qe5);

      _createClass(Zh, null, [{
        key: "pluginName",
        get: function get() {
          return "WidgetTypeAround";
        }
      }, {
        key: "requires",
        get: function get() {
          return [Eh, Mh];
        }
      }]);

      function Zh(e) {
        var _this152;

        _classCallCheck(this, Zh);

        _this152 = _possibleConstructorReturn(this, _getPrototypeOf(Zh).call(this, e)), _this152._currentFakeCaretModelElement = null;
        return _this152;
      }

      _createClass(Zh, [{
        key: "init",
        value: function init() {
          var e = this.editor,
              t = e.editing.view;
          this.on("change:isEnabled", function (i, n, o) {
            t.change(function (e) {
              var _iteratorNormalCompletion308 = true;
              var _didIteratorError308 = false;
              var _iteratorError308 = undefined;

              try {
                for (var _iterator308 = t.document.roots[Symbol.iterator](), _step308; !(_iteratorNormalCompletion308 = (_step308 = _iterator308.next()).done); _iteratorNormalCompletion308 = true) {
                  var _i239 = _step308.value;
                  o ? e.removeClass("ck-widget__type-around_disabled", _i239) : e.addClass("ck-widget__type-around_disabled", _i239);
                }
              } catch (err) {
                _didIteratorError308 = true;
                _iteratorError308 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion308 && _iterator308.return != null) {
                    _iterator308.return();
                  }
                } finally {
                  if (_didIteratorError308) {
                    throw _iteratorError308;
                  }
                }
              }
            }), o || e.model.change(function (e) {
              e.removeSelectionAttribute("widget-type-around");
            });
          }), this._enableTypeAroundUIInjection(), this._enableInsertingParagraphsOnButtonClick(), this._enableInsertingParagraphsOnEnterKeypress(), this._enableInsertingParagraphsOnTypingKeystroke(), this._enableTypeAroundFakeCaretActivationUsingKeyboardArrows(), this._enableDeleteIntegration(), this._enableInsertContentIntegration(), this._enableDeleteContentIntegration();
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this._currentFakeCaretModelElement = null;
        }
      }, {
        key: "_insertParagraph",
        value: function _insertParagraph(e, t) {
          var i = this.editor,
              n = i.editing.view;
          i.execute("insertParagraph", {
            position: i.model.createPositionAt(e, t)
          }), n.focus(), n.scrollToTheSelection();
        }
      }, {
        key: "_listenToIfEnabled",
        value: function _listenToIfEnabled(e, t, i, n) {
          var _this153 = this;

          this.listenTo(e, t, function () {
            _this153.isEnabled && i.apply(void 0, arguments);
          }, n);
        }
      }, {
        key: "_insertParagraphAccordingToFakeCaretPosition",
        value: function _insertParagraphAccordingToFakeCaretPosition() {
          var e = this.editor.model.document.selection,
              t = Yh(e);
          if (!t) return !1;
          var i = e.getSelectedElement();
          return this._insertParagraph(i, t), !0;
        }
      }, {
        key: "_enableTypeAroundUIInjection",
        value: function _enableTypeAroundUIInjection() {
          var e = this.editor,
              t = e.model.schema,
              i = e.locale.t,
              n = {
            before: i("Insert paragraph before block"),
            after: i("Insert paragraph after block")
          };
          e.editing.downcastDispatcher.on("insert", function (e, i, o) {
            var r = o.mapper.toViewElement(i.item);
            $h(r, i.item, t) && function (e, t, i) {
              var n = e.createUIElement("div", {
                class: "ck ck-reset_all ck-widget__type-around"
              }, function (e) {
                var i = this.toDomElement(e);
                return function (e, t) {
                  var _iteratorNormalCompletion309 = true;
                  var _didIteratorError309 = false;
                  var _iteratorError309 = undefined;

                  try {
                    for (var _iterator309 = Qh[Symbol.iterator](), _step309; !(_iteratorNormalCompletion309 = (_step309 = _iterator309.next()).done); _iteratorNormalCompletion309 = true) {
                      var _i240 = _step309.value;

                      var _n142 = new Ol({
                        tag: "div",
                        attributes: {
                          class: ["ck", "ck-widget__type-around__button", "ck-widget__type-around__button_" + _i240],
                          title: t[_i240]
                        },
                        children: [e.ownerDocument.importNode(Jh, !0)]
                      });

                      e.appendChild(_n142.render());
                    }
                  } catch (err) {
                    _didIteratorError309 = true;
                    _iteratorError309 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion309 && _iterator309.return != null) {
                        _iterator309.return();
                      }
                    } finally {
                      if (_didIteratorError309) {
                        throw _iteratorError309;
                      }
                    }
                  }
                }(i, t), function (e) {
                  var t = new Ol({
                    tag: "div",
                    attributes: {
                      class: ["ck", "ck-widget__type-around__fake-caret"]
                    }
                  });
                  e.appendChild(t.render());
                }(i), i;
              });
              e.insert(e.createPositionAt(i, "end"), n);
            }(o.writer, n, r);
          }, {
            priority: "low"
          });
        }
      }, {
        key: "_enableTypeAroundFakeCaretActivationUsingKeyboardArrows",
        value: function _enableTypeAroundFakeCaretActivationUsingKeyboardArrows() {
          var _this154 = this;

          var e = this.editor,
              t = e.model,
              i = t.document.selection,
              n = t.schema,
              o = e.editing.view;

          function r(e) {
            return "ck-widget_type-around_show-fake-caret_" + e;
          }

          this._listenToIfEnabled(o.document, "arrowKey", function (e, t) {
            _this154._handleArrowKeyPress(e, t);
          }, {
            context: [Dh, "$text"],
            priority: "high"
          }), this._listenToIfEnabled(i, "change:range", function (t, i) {
            i.directChange && e.model.change(function (e) {
              e.removeSelectionAttribute("widget-type-around");
            });
          }), this._listenToIfEnabled(t.document, "change:data", function () {
            var t = i.getSelectedElement();

            if (t) {
              if ($h(e.editing.mapper.toViewElement(t), t, n)) return;
            }

            e.model.change(function (e) {
              e.removeSelectionAttribute("widget-type-around");
            });
          }), this._listenToIfEnabled(e.editing.downcastDispatcher, "selection", function (e, t, i) {
            var o = i.writer;

            if (_this154._currentFakeCaretModelElement) {
              var _e232 = i.mapper.toViewElement(_this154._currentFakeCaretModelElement);

              _e232 && (o.removeClass(Qh.map(r), _e232), _this154._currentFakeCaretModelElement = null);
            }

            var s = t.selection.getSelectedElement();
            if (!s) return;
            var a = i.mapper.toViewElement(s);
            if (!$h(a, s, n)) return;
            var c = Yh(t.selection);
            c && (o.addClass(r(c), a), _this154._currentFakeCaretModelElement = s);
          }), this._listenToIfEnabled(e.ui.focusTracker, "change:isFocused", function (t, i, n) {
            n || e.model.change(function (e) {
              e.removeSelectionAttribute("widget-type-around");
            });
          });
        }
      }, {
        key: "_handleArrowKeyPress",
        value: function _handleArrowKeyPress(e, t) {
          var i = this.editor,
              n = i.model,
              o = n.document.selection,
              r = n.schema,
              s = i.editing.view,
              a = Vo(t.keyCode, i.locale.contentLanguageDirection),
              c = s.document.selection.getSelectedElement();
          var l;
          $h(c, i.editing.mapper.toModelElement(c), r) ? l = this._handleArrowKeyPressOnSelectedWidget(a) : o.isCollapsed && (l = this._handleArrowKeyPressWhenSelectionNextToAWidget(a)), l && (t.preventDefault(), e.stop());
        }
      }, {
        key: "_handleArrowKeyPressOnSelectedWidget",
        value: function _handleArrowKeyPressOnSelectedWidget(e) {
          var t = this.editor.model,
              i = Yh(t.document.selection);
          return t.change(function (t) {
            if (!i) return t.setSelectionAttribute("widget-type-around", e ? "after" : "before"), !0;
            if (!(i === (e ? "after" : "before"))) return t.removeSelectionAttribute("widget-type-around"), !0;
            return !1;
          });
        }
      }, {
        key: "_handleArrowKeyPressWhenSelectionNextToAWidget",
        value: function _handleArrowKeyPressWhenSelectionNextToAWidget(e) {
          var t = this.editor,
              i = t.model,
              n = i.schema,
              o = t.plugins.get("Widget"),
              r = o._getObjectElementNextToSelection(e);

          return !!$h(t.editing.mapper.toViewElement(r), r, n) && (i.change(function (t) {
            o._setSelectionOverElement(r), t.setSelectionAttribute("widget-type-around", e ? "before" : "after");
          }), !0);
        }
      }, {
        key: "_enableInsertingParagraphsOnButtonClick",
        value: function _enableInsertingParagraphsOnButtonClick() {
          var _this155 = this;

          var e = this.editor,
              t = e.editing.view;

          this._listenToIfEnabled(t.document, "mousedown", function (i, n) {
            var o = n.domTarget.closest(".ck-widget__type-around__button");
            if (!o) return;

            var r = function (e) {
              return e.classList.contains("ck-widget__type-around__button_before") ? "before" : "after";
            }(o),
                s = function (e, t) {
              var i = e.closest(".ck-widget");
              return t.mapDomToView(i);
            }(o, t.domConverter),
                a = e.editing.mapper.toModelElement(s);

            _this155._insertParagraph(a, r), n.preventDefault(), i.stop();
          });
        }
      }, {
        key: "_enableInsertingParagraphsOnEnterKeypress",
        value: function _enableInsertingParagraphsOnEnterKeypress() {
          var _this156 = this;

          var e = this.editor,
              t = e.model.document.selection,
              i = e.editing.view;

          this._listenToIfEnabled(i.document, "enter", function (i, n) {
            if ("atTarget" != i.eventPhase) return;
            var o = t.getSelectedElement(),
                r = e.editing.mapper.toViewElement(o),
                s = e.model.schema;
            var a;
            _this156._insertParagraphAccordingToFakeCaretPosition() ? a = !0 : $h(r, o, s) && (_this156._insertParagraph(o, n.isSoft ? "before" : "after"), a = !0), a && (n.preventDefault(), i.stop());
          }, {
            context: Dh
          });
        }
      }, {
        key: "_enableInsertingParagraphsOnTypingKeystroke",
        value: function _enableInsertingParagraphsOnTypingKeystroke() {
          var _this157 = this;

          var e = this.editor.editing.view,
              t = [No.enter, No.delete, No.backspace];

          this._listenToIfEnabled(e.document, "keydown", function (e, i) {
            t.includes(i.keyCode) || Kh(i) || _this157._insertParagraphAccordingToFakeCaretPosition();
          }, {
            priority: "high"
          });
        }
      }, {
        key: "_enableDeleteIntegration",
        value: function _enableDeleteIntegration() {
          var e = this.editor,
              t = e.editing.view,
              i = e.model,
              n = i.schema;

          this._listenToIfEnabled(t.document, "delete", function (t, o) {
            if ("atTarget" != t.eventPhase) return;
            var r = Yh(i.document.selection);
            if (!r) return;
            var s = o.direction,
                a = i.document.selection.getSelectedElement(),
                c = "forward" == s;
            if ("before" === r === c) e.execute("delete", {
              selection: i.createSelection(a, "on")
            });else {
              var _t217 = n.getNearestSelectionRange(i.createPositionAt(a, r), s);

              if (_t217) if (_t217.isCollapsed) {
                var _o88 = i.createSelection(_t217.start);

                if (i.modifySelection(_o88, {
                  direction: s
                }), _o88.focus.isEqual(_t217.start)) {
                  var _e233 = function (e, t) {
                    var i = t;
                    var _iteratorNormalCompletion310 = true;
                    var _didIteratorError310 = false;
                    var _iteratorError310 = undefined;

                    try {
                      for (var _iterator310 = t.getAncestors({
                        parentFirst: !0
                      })[Symbol.iterator](), _step310; !(_iteratorNormalCompletion310 = (_step310 = _iterator310.next()).done); _iteratorNormalCompletion310 = true) {
                        var _n143 = _step310.value;
                        if (_n143.childCount > 1 || e.isLimit(_n143)) break;
                        i = _n143;
                      }
                    } catch (err) {
                      _didIteratorError310 = true;
                      _iteratorError310 = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion310 && _iterator310.return != null) {
                          _iterator310.return();
                        }
                      } finally {
                        if (_didIteratorError310) {
                          throw _iteratorError310;
                        }
                      }
                    }

                    return i;
                  }(n, _t217.start.parent);

                  i.deleteContent(i.createSelection(_e233, "on"), {
                    doNotAutoparagraph: !0
                  });
                } else i.change(function (i) {
                  i.setSelection(_t217), e.execute(c ? "deleteForward" : "delete");
                });
              } else i.change(function (i) {
                i.setSelection(_t217), e.execute(c ? "deleteForward" : "delete");
              });
            }
            o.preventDefault(), t.stop();
          }, {
            context: Dh
          });
        }
      }, {
        key: "_enableInsertContentIntegration",
        value: function _enableInsertContentIntegration() {
          var e = this.editor,
              t = this.editor.model,
              i = t.document.selection;

          this._listenToIfEnabled(e.model, "insertContent", function (e, _ref128) {
            var _ref129 = _slicedToArray(_ref128, 2),
                n = _ref129[0],
                o = _ref129[1];

            if (o && !o.is("documentSelection")) return;
            var r = Yh(i);
            return r ? (e.stop(), t.change(function (e) {
              var o = i.getSelectedElement(),
                  s = t.createPositionAt(o, r),
                  a = e.createSelection(s),
                  c = t.insertContent(n, a);
              return e.setSelection(a), c;
            })) : void 0;
          }, {
            priority: "high"
          });
        }
      }, {
        key: "_enableDeleteContentIntegration",
        value: function _enableDeleteContentIntegration() {
          var e = this.editor,
              t = this.editor.model.document.selection;

          this._listenToIfEnabled(e.model, "deleteContent", function (e, _ref130) {
            var _ref131 = _slicedToArray(_ref130, 1),
                i = _ref131[0];

            if (i && !i.is("documentSelection")) return;
            Yh(t) && e.stop();
          }, {
            priority: "high"
          });
        }
      }]);

      return Zh;
    }(Qe);

    i(65);

    function Xh(e) {
      var t = e.model;
      return function (i, n) {
        var o = n.keyCode == No.arrowup,
            r = n.keyCode == No.arrowdown,
            s = n.shiftKey,
            a = t.document.selection;
        if (!o && !r) return;
        var c = r;
        if (s && function (e, t) {
          return !e.isCollapsed && e.isBackward == t;
        }(a, c)) return;

        var l = function (e, t, i) {
          var n = e.model;

          if (i) {
            var _e234 = t.isCollapsed ? t.focus : t.getLastPosition(),
                _i241 = eu(n, _e234, "forward");

            if (!_i241) return null;

            var _o89 = n.createRange(_e234, _i241),
                _r47 = tu(n.schema, _o89, "backward");

            return _r47 && _e234.isBefore(_r47) ? n.createRange(_e234, _r47) : null;
          }

          {
            var _e235 = t.isCollapsed ? t.focus : t.getFirstPosition(),
                _i242 = eu(n, _e235, "backward");

            if (!_i242) return null;

            var _o90 = n.createRange(_i242, _e235),
                _r48 = tu(n.schema, _o90, "forward");

            return _r48 && _e235.isAfter(_r48) ? n.createRange(_r48, _e235) : null;
          }
        }(e, a, c);

        l && !l.isCollapsed && function (e, t, i) {
          var n = e.model,
              o = e.view.domConverter;

          if (i) {
            var _e236 = n.createSelection(t.start);

            n.modifySelection(_e236), _e236.focus.isAtEnd || t.start.isEqual(_e236.focus) || (t = n.createRange(_e236.focus, t.end));
          }

          var r = e.mapper.toViewRange(t),
              s = o.viewRangeToDom(r),
              a = Ss.getDomRangeRects(s);
          var c;
          var _iteratorNormalCompletion311 = true;
          var _didIteratorError311 = false;
          var _iteratorError311 = undefined;

          try {
            for (var _iterator311 = a[Symbol.iterator](), _step311; !(_iteratorNormalCompletion311 = (_step311 = _iterator311.next()).done); _iteratorNormalCompletion311 = true) {
              var _e237 = _step311.value;

              if (void 0 !== c) {
                if (Math.round(_e237.top) >= c) return !1;
                c = Math.max(c, Math.round(_e237.bottom));
              } else c = Math.round(_e237.bottom);
            }
          } catch (err) {
            _didIteratorError311 = true;
            _iteratorError311 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion311 && _iterator311.return != null) {
                _iterator311.return();
              }
            } finally {
              if (_didIteratorError311) {
                throw _iteratorError311;
              }
            }
          }

          return !0;
        }(e, l, c) && (t.change(function (e) {
          var i = c ? l.end : l.start;

          if (s) {
            var _n144 = t.createSelection(a.anchor);

            _n144.setFocus(i), e.setSelection(_n144);
          } else e.setSelection(i);
        }), i.stop(), n.preventDefault(), n.stopPropagation());
      };
    }

    function eu(e, t, i) {
      var n = e.schema,
          o = e.createRangeIn(t.root),
          r = "forward" == i ? "elementStart" : "elementEnd";
      var _iteratorNormalCompletion312 = true;
      var _didIteratorError312 = false;
      var _iteratorError312 = undefined;

      try {
        for (var _iterator312 = o.getWalker({
          startPosition: t,
          direction: i
        })[Symbol.iterator](), _step312; !(_iteratorNormalCompletion312 = (_step312 = _iterator312.next()).done); _iteratorNormalCompletion312 = true) {
          var _ref133 = _step312.value;
          var _e238 = _ref133.previousPosition;
          var _s26 = _ref133.item;
          var _a17 = _ref133.type;
          if (n.isLimit(_s26) && !n.isInline(_s26)) return _e238;
          if (_a17 == r && n.isBlock(_s26)) return null;
        }
      } catch (err) {
        _didIteratorError312 = true;
        _iteratorError312 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion312 && _iterator312.return != null) {
            _iterator312.return();
          }
        } finally {
          if (_didIteratorError312) {
            throw _iteratorError312;
          }
        }
      }

      return null;
    }

    function tu(e, t, i) {
      var n = "backward" == i ? t.end : t.start;
      if (e.checkChild(n, "$text")) return n;
      var _iteratorNormalCompletion313 = true;
      var _didIteratorError313 = false;
      var _iteratorError313 = undefined;

      try {
        for (var _iterator313 = t.getWalker({
          direction: i
        })[Symbol.iterator](), _step313; !(_iteratorNormalCompletion313 = (_step313 = _iterator313.next()).done); _iteratorNormalCompletion313 = true) {
          var _ref135 = _step313.value;
          var _n145 = _ref135.nextPosition;
          if (e.checkChild(_n145, "$text")) return _n145;
        }
      } catch (err) {
        _didIteratorError313 = true;
        _iteratorError313 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion313 && _iterator313.return != null) {
            _iterator313.return();
          }
        } finally {
          if (_didIteratorError313) {
            throw _iteratorError313;
          }
        }
      }
    }

    var iu =
    /*#__PURE__*/
    function (_Qe6) {
      _inherits(iu, _Qe6);

      function iu() {
        _classCallCheck(this, iu);

        return _possibleConstructorReturn(this, _getPrototypeOf(iu).apply(this, arguments));
      }

      _createClass(iu, [{
        key: "init",
        value: function init() {
          var _this158 = this;

          var e = this.editor,
              t = e.editing.view,
              i = t.document;
          this._previouslySelected = new Set(), this.editor.editing.downcastDispatcher.on("selection", function (t, i, n) {
            var o = n.writer,
                r = i.selection;
            if (r.isCollapsed) return;
            var s = r.getSelectedElement();
            if (!s) return;
            var a = e.editing.mapper.toViewElement(s);
            Dh(a) && n.consumable.consume(r, "selection") && o.setSelection(o.createRangeOn(a), {
              fake: !0,
              label: Fh(a)
            });
          }), this.editor.editing.downcastDispatcher.on("selection", function (e, t, i) {
            _this158._clearPreviouslySelectedWidgets(i.writer);

            var n = i.writer,
                o = n.document.selection;
            var r = null;
            var _iteratorNormalCompletion314 = true;
            var _didIteratorError314 = false;
            var _iteratorError314 = undefined;

            try {
              for (var _iterator314 = o.getRanges()[Symbol.iterator](), _step314; !(_iteratorNormalCompletion314 = (_step314 = _iterator314.next()).done); _iteratorNormalCompletion314 = true) {
                var _e239 = _step314.value;
                var _iteratorNormalCompletion315 = true;
                var _didIteratorError315 = false;
                var _iteratorError315 = undefined;

                try {
                  for (var _iterator315 = _e239[Symbol.iterator](), _step315; !(_iteratorNormalCompletion315 = (_step315 = _iterator315.next()).done); _iteratorNormalCompletion315 = true) {
                    var _t218 = _step315.value;
                    var _e240 = _t218.item;
                    Dh(_e240) && !nu(_e240, r) && (n.addClass("ck-widget_selected", _e240), _this158._previouslySelected.add(_e240), r = _e240);
                  }
                } catch (err) {
                  _didIteratorError315 = true;
                  _iteratorError315 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion315 && _iterator315.return != null) {
                      _iterator315.return();
                    }
                  } finally {
                    if (_didIteratorError315) {
                      throw _iteratorError315;
                    }
                  }
                }
              }
            } catch (err) {
              _didIteratorError314 = true;
              _iteratorError314 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion314 && _iterator314.return != null) {
                  _iterator314.return();
                }
              } finally {
                if (_didIteratorError314) {
                  throw _iteratorError314;
                }
              }
            }
          }, {
            priority: "low"
          }), t.addObserver(mh), this.listenTo(i, "mousedown", function () {
            return _this158._onMousedown.apply(_this158, arguments);
          }), this.listenTo(i, "arrowKey", function () {
            _this158._handleSelectionChangeOnArrowKeyPress.apply(_this158, arguments);
          }, {
            context: [Dh, "$text"]
          }), this.listenTo(i, "arrowKey", function () {
            _this158._preventDefaultOnArrowKeyPress.apply(_this158, arguments);
          }, {
            context: "$root"
          }), this.listenTo(i, "arrowKey", Xh(this.editor.editing), {
            context: "$text"
          }), this.listenTo(i, "delete", function (e, t) {
            _this158._handleDelete("forward" == t.direction) && (t.preventDefault(), e.stop());
          }, {
            context: "$root"
          });
        }
      }, {
        key: "_onMousedown",
        value: function _onMousedown(e, t) {
          var i = this.editor,
              n = i.editing.view,
              o = n.document;
          var r = t.target;

          if (function (e) {
            for (; e;) {
              if (e.is("editableElement") && !e.is("rootElement")) return !0;
              if (Dh(e)) return !1;
              e = e.parent;
            }

            return !1;
          }(r)) {
            if ((Io.isSafari || Io.isGecko) && t.domEvent.detail >= 3) {
              var _e241 = i.editing.mapper,
                  _n146 = r.is("attributeElement") ? r.findAncestor(function (e) {
                return !e.is("attributeElement");
              }) : r,
                  _o91 = _e241.toModelElement(_n146);

              t.preventDefault(), this.editor.model.change(function (e) {
                e.setSelection(_o91, "in");
              });
            }

            return;
          }

          if (!Dh(r) && (r = r.findAncestor(Dh), !r)) return;
          Io.isAndroid && t.preventDefault(), o.isFocused || n.focus();
          var s = i.editing.mapper.toModelElement(r);

          this._setSelectionOverElement(s);
        }
      }, {
        key: "_handleSelectionChangeOnArrowKeyPress",
        value: function _handleSelectionChangeOnArrowKeyPress(e, t) {
          var i = t.keyCode,
              n = this.editor.model,
              o = n.schema,
              r = n.document.selection,
              s = r.getSelectedElement(),
              a = Vo(i, this.editor.locale.contentLanguageDirection);

          if (s && o.isObject(s)) {
            var _i243 = a ? r.getLastPosition() : r.getFirstPosition(),
                _s27 = o.getNearestSelectionRange(_i243, a ? "forward" : "backward");

            return void (_s27 && (n.change(function (e) {
              e.setSelection(_s27);
            }), t.preventDefault(), e.stop()));
          }

          if (!r.isCollapsed) return;

          var c = this._getObjectElementNextToSelection(a);

          c && o.isObject(c) && (this._setSelectionOverElement(c), t.preventDefault(), e.stop());
        }
      }, {
        key: "_preventDefaultOnArrowKeyPress",
        value: function _preventDefaultOnArrowKeyPress(e, t) {
          var i = this.editor.model,
              n = i.schema,
              o = i.document.selection.getSelectedElement();
          o && n.isObject(o) && (t.preventDefault(), e.stop());
        }
      }, {
        key: "_handleDelete",
        value: function _handleDelete(e) {
          var _this159 = this;

          if (this.editor.isReadOnly) return;
          var t = this.editor.model.document.selection;
          if (!t.isCollapsed) return;

          var i = this._getObjectElementNextToSelection(e);

          return i ? (this.editor.model.change(function (e) {
            var n = t.anchor.parent;

            for (; n.isEmpty;) {
              var _t219 = n;
              n = _t219.parent, e.remove(_t219);
            }

            _this159._setSelectionOverElement(i);
          }), !0) : void 0;
        }
      }, {
        key: "_setSelectionOverElement",
        value: function _setSelectionOverElement(e) {
          this.editor.model.change(function (t) {
            t.setSelection(t.createRangeOn(e));
          });
        }
      }, {
        key: "_getObjectElementNextToSelection",
        value: function _getObjectElementNextToSelection(e) {
          var t = this.editor.model,
              i = t.schema,
              n = t.document.selection,
              o = t.createSelection(n);
          t.modifySelection(o, {
            direction: e ? "forward" : "backward"
          });
          var r = e ? o.focus.nodeBefore : o.focus.nodeAfter;
          return r && i.isObject(r) ? r : null;
        }
      }, {
        key: "_clearPreviouslySelectedWidgets",
        value: function _clearPreviouslySelectedWidgets(e) {
          var _iteratorNormalCompletion316 = true;
          var _didIteratorError316 = false;
          var _iteratorError316 = undefined;

          try {
            for (var _iterator316 = this._previouslySelected[Symbol.iterator](), _step316; !(_iteratorNormalCompletion316 = (_step316 = _iterator316.next()).done); _iteratorNormalCompletion316 = true) {
              var _t220 = _step316.value;
              e.removeClass("ck-widget_selected", _t220);
            }
          } catch (err) {
            _didIteratorError316 = true;
            _iteratorError316 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion316 && _iterator316.return != null) {
                _iterator316.return();
              }
            } finally {
              if (_didIteratorError316) {
                throw _iteratorError316;
              }
            }
          }

          this._previouslySelected.clear();
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "Widget";
        }
      }, {
        key: "requires",
        get: function get() {
          return [Zh, Mh];
        }
      }]);

      return iu;
    }(Qe);

    function nu(e, t) {
      return !!t && Array.from(e.getAncestors()).includes(t);
    }

    var ou = function ou(e, t, i) {
      var n = !0,
          o = !0;
      if ("function" != typeof e) throw new TypeError("Expected a function");
      return w(i) && (n = "leading" in i ? !!i.leading : n, o = "trailing" in i ? !!i.trailing : o), ps(e, t, {
        leading: n,
        maxWait: t,
        trailing: o
      });
    };

    i(67);

    var ru =
    /*#__PURE__*/
    function (_Qe7) {
      _inherits(ru, _Qe7);

      function ru() {
        _classCallCheck(this, ru);

        return _possibleConstructorReturn(this, _getPrototypeOf(ru).apply(this, arguments));
      }

      _createClass(ru, [{
        key: "init",
        value: function init() {
          var _this160 = this;

          var e = this.editor,
              t = e.editing.view;
          this._draggedRange = null, this._draggingUid = "", this._draggableElement = null, this._updateDropMarkerThrottled = ou(function (e) {
            return _this160._updateDropMarker(e);
          }, 40), this._removeDropMarkerDelayed = cu(function () {
            return _this160._removeDropMarker();
          }, 40), this._clearDraggableAttributesDelayed = cu(function () {
            return _this160._clearDraggableAttributes();
          }, 40), t.addObserver(_h), t.addObserver(mh), this._setupDragging(), this._setupContentInsertionIntegration(), this._setupClipboardInputIntegration(), this._setupDropMarker(), this._setupDraggableAttributeHandling(), this.listenTo(e, "change:isReadOnly", function (e, t, i) {
            i ? _this160.forceDisabled("readOnlyMode") : _this160.clearForceDisabled("readOnlyMode");
          }), this.on("change:isEnabled", function (e, t, i) {
            i || _this160._finalizeDragging(!1);
          }), Io.isAndroid && this.forceDisabled("noAndroidSupport");
        }
      }, {
        key: "destroy",
        value: function destroy() {
          return this._draggedRange && (this._draggedRange.detach(), this._draggedRange = null), this._updateDropMarkerThrottled.cancel(), this._removeDropMarkerDelayed.cancel(), this._clearDraggableAttributesDelayed.cancel(), _get(_getPrototypeOf(ru.prototype), "destroy", this).call(this);
        }
      }, {
        key: "_setupDragging",
        value: function _setupDragging() {
          var _this161 = this;

          var e = this.editor,
              t = e.model,
              i = t.document,
              n = e.editing.view,
              o = n.document;
          this.listenTo(o, "dragstart", function (n, r) {
            var a = i.selection;
            if (r.target && r.target.is("editableElement")) return void r.preventDefault();
            var c = r.target ? lu(r.target) : null;

            if (c) {
              var _i244 = e.editing.mapper.toModelElement(c);

              _this161._draggedRange = ka.fromRange(t.createRangeOn(_i244)), e.plugins.has("WidgetToolbarRepository") && e.plugins.get("WidgetToolbarRepository").forceDisabled("dragDrop");
            } else if (!o.selection.isCollapsed) {
              var _e242 = o.selection.getSelectedElement();

              _e242 && Dh(_e242) || (_this161._draggedRange = ka.fromRange(a.getFirstRange()));
            }

            if (!_this161._draggedRange) return void r.preventDefault();
            _this161._draggingUid = s(), r.dataTransfer.effectAllowed = _this161.isEnabled ? "copyMove" : "copy", r.dataTransfer.setData("application/ckeditor5-dragging-uid", _this161._draggingUid);
            var l = t.createSelection(_this161._draggedRange.toRange()),
                d = e.data.toView(t.getSelectedContent(l));
            o.fire("clipboardOutput", {
              dataTransfer: r.dataTransfer,
              content: d,
              method: n.name
            }), _this161.isEnabled || (_this161._draggedRange.detach(), _this161._draggedRange = null, _this161._draggingUid = "");
          }, {
            priority: "low"
          }), this.listenTo(o, "dragend", function (e, t) {
            _this161._finalizeDragging(!t.dataTransfer.isCanceled && "move" == t.dataTransfer.dropEffect);
          }, {
            priority: "low"
          }), this.listenTo(o, "dragenter", function () {
            _this161.isEnabled && n.focus();
          }), this.listenTo(o, "dragleave", function () {
            _this161._removeDropMarkerDelayed();
          }), this.listenTo(o, "dragging", function (t, i) {
            if (!_this161.isEnabled) return void (i.dataTransfer.dropEffect = "none");

            _this161._removeDropMarkerDelayed.cancel();

            var n = su(e, i.targetRanges, i.target);
            _this161._draggedRange || (i.dataTransfer.dropEffect = "copy"), Io.isGecko || ("copy" == i.dataTransfer.effectAllowed ? i.dataTransfer.dropEffect = "copy" : ["all", "copyMove"].includes(i.dataTransfer.effectAllowed) && (i.dataTransfer.dropEffect = "move")), n && _this161._updateDropMarkerThrottled(n);
          }, {
            priority: "low"
          });
        }
      }, {
        key: "_setupClipboardInputIntegration",
        value: function _setupClipboardInputIntegration() {
          var _this162 = this;

          var e = this.editor,
              t = e.editing.view.document;
          this.listenTo(t, "clipboardInput", function (t, i) {
            if ("drop" != i.method) return;
            var n = su(e, i.targetRanges, i.target);
            if (_this162._removeDropMarker(), !n) return _this162._finalizeDragging(!1), void t.stop();
            _this162._draggedRange && _this162._draggingUid != i.dataTransfer.getData("application/ckeditor5-dragging-uid") && (_this162._draggedRange.detach(), _this162._draggedRange = null, _this162._draggingUid = "");
            if ("move" == au(i.dataTransfer) && _this162._draggedRange && _this162._draggedRange.containsRange(n, !0)) return _this162._finalizeDragging(!1), void t.stop();
            i.targetRanges = [e.editing.mapper.toViewRange(n)];
          }, {
            priority: "high"
          });
        }
      }, {
        key: "_setupContentInsertionIntegration",
        value: function _setupContentInsertionIntegration() {
          var _this163 = this;

          var e = this.editor.plugins.get(yh);
          e.on("contentInsertion", function (e, t) {
            if (!_this163.isEnabled || "drop" !== t.method) return;
            var i = t.targetRanges.map(function (e) {
              return _this163.editor.editing.mapper.toModelRange(e);
            });

            _this163.editor.model.change(function (e) {
              return e.setSelection(i);
            });
          }, {
            priority: "high"
          }), e.on("contentInsertion", function (e, t) {
            if (!_this163.isEnabled || "drop" !== t.method) return;
            var i = "move" == au(t.dataTransfer),
                n = !t.resultRange || !t.resultRange.isCollapsed;

            _this163._finalizeDragging(n && i);
          }, {
            priority: "lowest"
          });
        }
      }, {
        key: "_setupDraggableAttributeHandling",
        value: function _setupDraggableAttributeHandling() {
          var _this164 = this;

          var e = this.editor,
              t = e.editing.view,
              i = t.document;
          this.listenTo(i, "mousedown", function (n, o) {
            if (Io.isAndroid || !o) return;

            _this164._clearDraggableAttributesDelayed.cancel();

            var r = lu(o.target);

            if (Io.isBlink && !e.isReadOnly && !r && !i.selection.isCollapsed) {
              var _e243 = i.selection.getSelectedElement();

              _e243 && Dh(_e243) || (r = i.selection.editableElement);
            }

            r && (t.change(function (e) {
              e.setAttribute("draggable", "true", r);
            }), _this164._draggableElement = e.editing.mapper.toModelElement(r));
          }), this.listenTo(i, "mouseup", function () {
            Io.isAndroid || _this164._clearDraggableAttributesDelayed();
          });
        }
      }, {
        key: "_clearDraggableAttributes",
        value: function _clearDraggableAttributes() {
          var _this165 = this;

          var e = this.editor.editing;
          e.view.change(function (t) {
            _this165._draggableElement && "$graveyard" != _this165._draggableElement.root.rootName && t.removeAttribute("draggable", e.mapper.toViewElement(_this165._draggableElement)), _this165._draggableElement = null;
          });
        }
      }, {
        key: "_setupDropMarker",
        value: function _setupDropMarker() {
          var e = this.editor;
          e.conversion.for("editingDowncast").markerToHighlight({
            model: "drop-target",
            view: {
              classes: ["ck-clipboard-drop-target-range"]
            }
          }), e.conversion.for("editingDowncast").markerToElement({
            model: "drop-target",
            view: function view(t, _ref136) {
              var i = _ref136.writer;
              if (e.model.schema.checkChild(t.markerRange.start, "$text")) return i.createUIElement("span", {
                class: "ck ck-clipboard-drop-target-position"
              }, function (e) {
                var t = this.toDomElement(e);
                return t.innerHTML = "&NoBreak;<span></span>&NoBreak;", t;
              });
            }
          });
        }
      }, {
        key: "_updateDropMarker",
        value: function _updateDropMarker(e) {
          var t = this.editor,
              i = t.model.markers;
          t.model.change(function (t) {
            i.has("drop-target") ? i.get("drop-target").getRange().isEqual(e) || t.updateMarker("drop-target", {
              range: e
            }) : t.addMarker("drop-target", {
              range: e,
              usingOperation: !1,
              affectsData: !1
            });
          });
        }
      }, {
        key: "_removeDropMarker",
        value: function _removeDropMarker() {
          var e = this.editor.model;
          this._removeDropMarkerDelayed.cancel(), this._updateDropMarkerThrottled.cancel(), e.markers.has("drop-target") && e.change(function (e) {
            e.removeMarker("drop-target");
          });
        }
      }, {
        key: "_finalizeDragging",
        value: function _finalizeDragging(e) {
          var t = this.editor,
              i = t.model;
          this._removeDropMarker(), this._clearDraggableAttributes(), t.plugins.has("WidgetToolbarRepository") && t.plugins.get("WidgetToolbarRepository").clearForceDisabled("dragDrop"), this._draggingUid = "", this._draggedRange && (e && this.isEnabled && i.deleteContent(i.createSelection(this._draggedRange), {
            doNotAutoparagraph: !0
          }), this._draggedRange.detach(), this._draggedRange = null);
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "DragDrop";
        }
      }, {
        key: "requires",
        get: function get() {
          return [yh, iu];
        }
      }]);

      return ru;
    }(Qe);

    function su(e, t, i) {
      var n = e.model,
          o = e.editing.mapper;
      var r = null;
      var s = t ? t[0].start : null;
      if (i.is("uiElement") && (i = i.parent), r = function (e, t) {
        var i = e.model,
            n = e.editing.mapper;
        if (Dh(t)) return i.createRangeOn(n.toModelElement(t));

        if (!t.is("editableElement")) {
          var _e244 = t.findAncestor(function (e) {
            return Dh(e) || e.is("editableElement");
          });

          if (Dh(_e244)) return i.createRangeOn(n.toModelElement(_e244));
        }

        return null;
      }(e, i), r) return r;

      var a = function (e, t) {
        var i = e.editing.mapper,
            n = e.editing.view,
            o = i.toModelElement(t);
        if (o) return o;
        var r = n.createPositionBefore(t),
            s = i.findMappedViewAncestor(r);
        return i.toModelElement(s);
      }(e, i),
          c = s ? o.toModelPosition(s) : null;

      return c ? (r = function (e, t, i) {
        var n = e.model;
        if (!n.schema.checkChild(i, "$block")) return null;
        var o = n.createPositionAt(i, 0),
            r = t.path.slice(0, o.path.length),
            s = n.createPositionFromPath(t.root, r).nodeAfter;
        if (s && n.schema.isObject(s)) return n.createRangeOn(s);
        return null;
      }(e, c, a), r || (r = n.schema.getNearestSelectionRange(c, Io.isGecko ? "forward" : "backward"), r || function (e, t) {
        var i = e.model;

        for (; t;) {
          if (i.schema.isObject(t)) return i.createRangeOn(t);
          t = t.parent;
        }
      }(e, c.parent))) : function (e, t) {
        var i = e.model,
            n = i.schema,
            o = i.createPositionAt(t, 0);
        return n.getNearestSelectionRange(o, "forward");
      }(e, a);
    }

    function au(e) {
      return Io.isGecko ? e.dropEffect : ["all", "copyMove"].includes(e.effectAllowed) ? "move" : "copy";
    }

    function cu(e, t) {
      var i;

      function n() {
        for (var _len21 = arguments.length, o = new Array(_len21), _key21 = 0; _key21 < _len21; _key21++) {
          o[_key21] = arguments[_key21];
        }

        n.cancel(), i = setTimeout(function () {
          return e.apply(void 0, o);
        }, t);
      }

      return n.cancel = function () {
        clearTimeout(i);
      }, n;
    }

    function lu(e) {
      if (e.is("editableElement")) return null;
      if (e.hasClass("ck-widget__selection-handle")) return e.findAncestor(Dh);
      if (Dh(e)) return e;
      var t = e.findAncestor(function (e) {
        return Dh(e) || e.is("editableElement");
      });
      return Dh(t) ? t : null;
    }

    var du =
    /*#__PURE__*/
    function (_Qe8) {
      _inherits(du, _Qe8);

      function du() {
        _classCallCheck(this, du);

        return _possibleConstructorReturn(this, _getPrototypeOf(du).apply(this, arguments));
      }

      _createClass(du, [{
        key: "init",
        value: function init() {
          var e = this.editor,
              t = e.model,
              i = e.editing.view,
              n = i.document,
              o = t.document.selection;
          var r = !1;
          i.addObserver(_h), this.listenTo(n, "keydown", function (e, t) {
            r = t.shiftKey;
          }), e.plugins.get(yh).on("contentInsertion", function (e, i) {
            (r || function (e, t) {
              if (e.childCount > 1) return !1;
              var i = e.getChild(0);
              if (t.isObject(i)) return !1;
              return 0 == _toConsumableArray(i.getAttributeKeys()).length;
            }(i.content, t.schema)) && t.change(function (e) {
              var n = Array.from(o.getAttributes()).filter(function (_ref137) {
                var _ref138 = _slicedToArray(_ref137, 1),
                    e = _ref138[0];

                return t.schema.getAttributeProperties(e).isFormatting;
              });
              o.isCollapsed || t.deleteContent(o, {
                doNotAutoparagraph: !0
              }), n.push.apply(n, _toConsumableArray(o.getAttributes()));
              var r = e.createRangeIn(i.content);
              var _iteratorNormalCompletion317 = true;
              var _didIteratorError317 = false;
              var _iteratorError317 = undefined;

              try {
                for (var _iterator317 = r.getItems()[Symbol.iterator](), _step317; !(_iteratorNormalCompletion317 = (_step317 = _iterator317.next()).done); _iteratorNormalCompletion317 = true) {
                  var _t221 = _step317.value;
                  _t221.is("$textProxy") && e.setAttributes(n, _t221);
                }
              } catch (err) {
                _didIteratorError317 = true;
                _iteratorError317 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion317 && _iterator317.return != null) {
                    _iterator317.return();
                  }
                } finally {
                  if (_didIteratorError317) {
                    throw _iteratorError317;
                  }
                }
              }
            });
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "PastePlainText";
        }
      }, {
        key: "requires",
        get: function get() {
          return [yh];
        }
      }]);

      return du;
    }(Qe);

    var hu =
    /*#__PURE__*/
    function (_Qe9) {
      _inherits(hu, _Qe9);

      function hu() {
        _classCallCheck(this, hu);

        return _possibleConstructorReturn(this, _getPrototypeOf(hu).apply(this, arguments));
      }

      _createClass(hu, null, [{
        key: "pluginName",
        get: function get() {
          return "Clipboard";
        }
      }, {
        key: "requires",
        get: function get() {
          return [yh, ru, du];
        }
      }]);

      return hu;
    }(Qe);

    var uu =
    /*#__PURE__*/
    function (_Ze4) {
      _inherits(uu, _Ze4);

      function uu() {
        _classCallCheck(this, uu);

        return _possibleConstructorReturn(this, _getPrototypeOf(uu).apply(this, arguments));
      }

      _createClass(uu, [{
        key: "execute",
        value: function execute() {
          var _this166 = this;

          var e = this.editor.model,
              t = e.document;
          e.change(function (i) {
            !function (e, t, i) {
              var n = i.isCollapsed,
                  o = i.getFirstRange(),
                  r = o.start.parent,
                  s = o.end.parent,
                  a = r == s;

              if (n) {
                var _n147 = xh(e.schema, i.getAttributes());

                gu(e, t, o.end), t.removeSelectionAttribute(i.getAttributeKeys()), t.setSelectionAttribute(_n147);
              } else {
                var _n148 = !(o.start.isAtStart && o.end.isAtEnd);

                e.deleteContent(i, {
                  leaveUnmerged: _n148
                }), a ? gu(e, t, i.focus) : _n148 && t.setSelection(s, 0);
              }
            }(e, i, t.selection), _this166.fire("afterExecute", {
              writer: i
            });
          });
        }
      }, {
        key: "refresh",
        value: function refresh() {
          var e = this.editor.model,
              t = e.document;

          this.isEnabled = function (e, t) {
            if (t.rangeCount > 1) return !1;
            var i = t.anchor;
            if (!i || !e.checkChild(i, "softBreak")) return !1;
            var n = t.getFirstRange(),
                o = n.start.parent,
                r = n.end.parent;
            if ((mu(o, e) || mu(r, e)) && o !== r) return !1;
            return !0;
          }(e.schema, t.selection);
        }
      }]);

      return uu;
    }(Ze);

    function gu(e, t, i) {
      var n = t.createElement("softBreak");
      e.insertContent(n, i), t.setSelection(n, "after");
    }

    function mu(e, t) {
      return !e.is("rootElement") && (t.isLimit(e) || mu(e.parent, t));
    }

    var fu =
    /*#__PURE__*/
    function (_Qe10) {
      _inherits(fu, _Qe10);

      function fu() {
        _classCallCheck(this, fu);

        return _possibleConstructorReturn(this, _getPrototypeOf(fu).apply(this, arguments));
      }

      _createClass(fu, [{
        key: "init",
        value: function init() {
          var e = this.editor,
              t = e.model.schema,
              i = e.conversion,
              n = e.editing.view,
              o = n.document;
          t.register("softBreak", {
            allowWhere: "$text",
            isInline: !0
          }), i.for("upcast").elementToElement({
            model: "softBreak",
            view: "br"
          }), i.for("downcast").elementToElement({
            model: "softBreak",
            view: function view(e, _ref139) {
              var t = _ref139.writer;
              return t.createEmptyElement("br");
            }
          }), n.addObserver(Th), e.commands.add("shiftEnter", new uu(e)), this.listenTo(o, "enter", function (t, i) {
            i.preventDefault(), i.isSoft && (e.execute("shiftEnter"), n.scrollToTheSelection());
          }, {
            priority: "low"
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "ShiftEnter";
        }
      }]);

      return fu;
    }(Qe);

    var pu =
    /*#__PURE__*/
    function (_Ze5) {
      _inherits(pu, _Ze5);

      function pu() {
        _classCallCheck(this, pu);

        return _possibleConstructorReturn(this, _getPrototypeOf(pu).apply(this, arguments));
      }

      _createClass(pu, [{
        key: "execute",
        value: function execute() {
          var e = this.editor.model,
              t = e.document.selection;
          var i = e.schema.getLimitElement(t);
          if (t.containsEntireContent(i) || !bu(e.schema, i)) do {
            if (i = i.parent, !i) return;
          } while (!bu(e.schema, i));
          e.change(function (e) {
            e.setSelection(i, "in");
          });
        }
      }]);

      return pu;
    }(Ze);

    function bu(e, t) {
      return e.isLimit(t) && (e.checkChild(t, "$text") || e.checkChild(t, "paragraph"));
    }

    var wu = zo("Ctrl+A");

    var ku =
    /*#__PURE__*/
    function (_Qe11) {
      _inherits(ku, _Qe11);

      function ku() {
        _classCallCheck(this, ku);

        return _possibleConstructorReturn(this, _getPrototypeOf(ku).apply(this, arguments));
      }

      _createClass(ku, [{
        key: "init",
        value: function init() {
          var e = this.editor,
              t = e.editing.view.document;
          e.commands.add("selectAll", new pu(e)), this.listenTo(t, "keydown", function (t, i) {
            Oo(i) === wu && (e.execute("selectAll"), i.preventDefault());
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "SelectAllEditing";
        }
      }]);

      return ku;
    }(Qe);

    var _u =
    /*#__PURE__*/
    function (_Qe12) {
      _inherits(_u, _Qe12);

      function _u() {
        _classCallCheck(this, _u);

        return _possibleConstructorReturn(this, _getPrototypeOf(_u).apply(this, arguments));
      }

      _createClass(_u, [{
        key: "init",
        value: function init() {
          var _this167 = this;

          var e = this.editor;
          e.ui.componentFactory.add("selectAll", function (t) {
            var i = e.commands.get("selectAll"),
                n = new id(t),
                o = t.t;
            return n.set({
              label: o("Select all"),
              icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M.75 15.5a.75.75 0 0 1 .75.75V18l.008.09A.5.5 0 0 0 2 18.5h1.75a.75.75 0 1 1 0 1.5H1.5l-.144-.007a1.5 1.5 0 0 1-1.35-1.349L0 18.5v-2.25a.75.75 0 0 1 .75-.75zm18.5 0a.75.75 0 0 1 .75.75v2.25l-.007.144a1.5 1.5 0 0 1-1.349 1.35L18.5 20h-2.25a.75.75 0 1 1 0-1.5H18a.5.5 0 0 0 .492-.41L18.5 18v-1.75a.75.75 0 0 1 .75-.75zm-10.45 3c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2H7.2a.2.2 0 0 1-.2-.2v-1.1c0-.11.09-.2.2-.2h1.6zm4 0c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2h-1.6a.2.2 0 0 1-.2-.2v-1.1c0-.11.09-.2.2-.2h1.6zm.45-5.5a.75.75 0 1 1 0 1.5h-8.5a.75.75 0 1 1 0-1.5h8.5zM1.3 11c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2H.2a.2.2 0 0 1-.2-.2v-1.6c0-.11.09-.2.2-.2h1.1zm18.5 0c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2h-1.1a.2.2 0 0 1-.2-.2v-1.6c0-.11.09-.2.2-.2h1.1zm-4.55-2a.75.75 0 1 1 0 1.5H4.75a.75.75 0 1 1 0-1.5h10.5zM1.3 7c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2H.2a.2.2 0 0 1-.2-.2V7.2c0-.11.09-.2.2-.2h1.1zm18.5 0c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2h-1.1a.2.2 0 0 1-.2-.2V7.2c0-.11.09-.2.2-.2h1.1zm-4.55-2a.75.75 0 1 1 0 1.5h-2.5a.75.75 0 1 1 0-1.5h2.5zm-5 0a.75.75 0 1 1 0 1.5h-5.5a.75.75 0 0 1 0-1.5h5.5zm-6.5-5a.75.75 0 0 1 0 1.5H2a.5.5 0 0 0-.492.41L1.5 2v1.75a.75.75 0 0 1-1.5 0V1.5l.007-.144A1.5 1.5 0 0 1 1.356.006L1.5 0h2.25zM18.5 0l.144.007a1.5 1.5 0 0 1 1.35 1.349L20 1.5v2.25a.75.75 0 1 1-1.5 0V2l-.008-.09A.5.5 0 0 0 18 1.5h-1.75a.75.75 0 1 1 0-1.5h2.25zM8.8 0c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2H7.2a.2.2 0 0 1-.2-.2V.2c0-.11.09-.2.2-.2h1.6zm4 0c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2h-1.6a.2.2 0 0 1-.2-.2V.2c0-.11.09-.2.2-.2h1.6z"/></svg>',
              keystroke: "Ctrl+A",
              tooltip: !0
            }), n.bind("isOn", "isEnabled").to(i, "value", "isEnabled"), _this167.listenTo(n, "execute", function () {
              e.execute("selectAll"), e.editing.view.focus();
            }), n;
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "SelectAllUI";
        }
      }]);

      return _u;
    }(Qe);

    var vu =
    /*#__PURE__*/
    function (_Qe13) {
      _inherits(vu, _Qe13);

      function vu() {
        _classCallCheck(this, vu);

        return _possibleConstructorReturn(this, _getPrototypeOf(vu).apply(this, arguments));
      }

      _createClass(vu, null, [{
        key: "requires",
        get: function get() {
          return [ku, _u];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "SelectAll";
        }
      }]);

      return vu;
    }(Qe);

    var yu =
    /*#__PURE__*/
    function (_Ze6) {
      _inherits(yu, _Ze6);

      function yu(e, t) {
        var _this168;

        _classCallCheck(this, yu);

        _this168 = _possibleConstructorReturn(this, _getPrototypeOf(yu).call(this, e)), _this168._buffer = new Sh(e.model, t), _this168._batches = new WeakSet();
        return _this168;
      }

      _createClass(yu, [{
        key: "destroy",
        value: function destroy() {
          _get(_getPrototypeOf(yu.prototype), "destroy", this).call(this), this._buffer.destroy();
        }
      }, {
        key: "execute",
        value: function execute() {
          var _this169 = this;

          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var t = this.editor.model,
              i = t.document,
              n = e.text || "",
              o = n.length,
              r = e.range ? t.createSelection(e.range) : i.selection,
              s = e.resultRange;
          t.enqueueChange(this._buffer.batch, function (e) {
            _this169._buffer.lock(), _this169._batches.add(_this169._buffer.batch), t.deleteContent(r), n && t.insertContent(e.createText(n, i.selection.getAttributes()), r), s ? e.setSelection(s) : r.is("documentSelection") || e.setSelection(r), _this169._buffer.unlock(), _this169._buffer.input(o);
          });
        }
      }, {
        key: "buffer",
        get: function get() {
          return this._buffer;
        }
      }]);

      return yu;
    }(Ze);

    function xu(e) {
      if (e.newChildren.length - e.oldChildren.length != 1) return;

      var t = function (e, t) {
        var i = [];
        var n,
            o = 0;
        return e.forEach(function (e) {
          "equal" == e ? (r(), o++) : "insert" == e ? (s("insert") ? n.values.push(t[o]) : (r(), n = {
            type: "insert",
            index: o,
            values: [t[o]]
          }), o++) : s("delete") ? n.howMany++ : (r(), n = {
            type: "delete",
            index: o,
            howMany: 1
          });
        }), r(), i;

        function r() {
          n && (i.push(n), n = null);
        }

        function s(e) {
          return n && n.type == e;
        }
      }(gr(e.oldChildren, e.newChildren, Au), e.newChildren);

      if (t.length > 1) return;
      var i = t[0];
      return i.values[0] && i.values[0].is("$text") ? i : void 0;
    }

    function Au(e, t) {
      return e && e.is("$text") && t && t.is("$text") ? e.data === t.data : e === t;
    }

    var Cu =
    /*#__PURE__*/
    function () {
      function Cu(e) {
        _classCallCheck(this, Cu);

        this.editor = e, this.editing = this.editor.editing;
      }

      _createClass(Cu, [{
        key: "handle",
        value: function handle(e, t) {
          if (function (e) {
            if (0 == e.length) return !1;
            var _iteratorNormalCompletion318 = true;
            var _didIteratorError318 = false;
            var _iteratorError318 = undefined;

            try {
              for (var _iterator318 = e[Symbol.iterator](), _step318; !(_iteratorNormalCompletion318 = (_step318 = _iterator318.next()).done); _iteratorNormalCompletion318 = true) {
                var _t222 = _step318.value;
                if ("children" === _t222.type && !xu(_t222)) return !0;
              }
            } catch (err) {
              _didIteratorError318 = true;
              _iteratorError318 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion318 && _iterator318.return != null) {
                  _iterator318.return();
                }
              } finally {
                if (_didIteratorError318) {
                  throw _iteratorError318;
                }
              }
            }

            return !1;
          }(e)) this._handleContainerChildrenMutations(e, t);else {
            var _iteratorNormalCompletion319 = true;
            var _didIteratorError319 = false;
            var _iteratorError319 = undefined;

            try {
              for (var _iterator319 = e[Symbol.iterator](), _step319; !(_iteratorNormalCompletion319 = (_step319 = _iterator319.next()).done); _iteratorNormalCompletion319 = true) {
                var _i245 = _step319.value;
                this._handleTextMutation(_i245, t), this._handleTextNodeInsertion(_i245);
              }
            } catch (err) {
              _didIteratorError319 = true;
              _iteratorError319 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion319 && _iterator319.return != null) {
                  _iterator319.return();
                }
              } finally {
                if (_didIteratorError319) {
                  throw _iteratorError319;
                }
              }
            }
          }
        }
      }, {
        key: "_handleContainerChildrenMutations",
        value: function _handleContainerChildrenMutations(e, t) {
          var i = function (e) {
            var t = e.map(function (e) {
              return e.node;
            }).reduce(function (e, t) {
              return e.getCommonAncestor(t, {
                includeSelf: !0
              });
            });
            if (!t) return;
            return t.getAncestors({
              includeSelf: !0,
              parentFirst: !0
            }).find(function (e) {
              return e.is("containerElement") || e.is("rootElement");
            });
          }(e);

          if (!i) return;
          var n = this.editor.editing.view.domConverter.mapViewToDom(i),
              o = new Er(this.editor.editing.view.document),
              r = this.editor.data.toModel(o.domToView(n)).getChild(0),
              s = this.editor.editing.mapper.toModelElement(i);
          if (!s) return;
          var a = Array.from(r.getChildren()),
              c = Array.from(s.getChildren()),
              l = a[a.length - 1],
              d = c[c.length - 1],
              h = l && l.is("element", "softBreak"),
              u = d && !d.is("element", "softBreak");
          h && u && a.pop();
          var g = this.editor.model.schema;
          if (!Tu(a, g) || !Tu(c, g)) return;
          var m = a.map(function (e) {
            return e.is("$text") ? e.data : "@";
          }).join("").replace(/\u00A0/g, " "),
              f = c.map(function (e) {
            return e.is("$text") ? e.data : "@";
          }).join("").replace(/\u00A0/g, " ");
          if (f === m) return;

          var p = gr(f, m),
              _Eu = Eu(p),
              b = _Eu.firstChangeAt,
              w = _Eu.insertions,
              k = _Eu.deletions;

          var _ = null;
          t && (_ = this.editing.mapper.toModelRange(t.getFirstRange()));
          var v = m.substr(b, w),
              y = this.editor.model.createRange(this.editor.model.createPositionAt(s, b), this.editor.model.createPositionAt(s, b + k));
          this.editor.execute("input", {
            text: v,
            range: y,
            resultRange: _
          });
        }
      }, {
        key: "_handleTextMutation",
        value: function _handleTextMutation(e, t) {
          if ("text" != e.type) return;
          var i = e.newText.replace(/\u00A0/g, " "),
              n = e.oldText.replace(/\u00A0/g, " ");
          if (n === i) return;

          var o = gr(n, i),
              _Eu2 = Eu(o),
              r = _Eu2.firstChangeAt,
              s = _Eu2.insertions,
              a = _Eu2.deletions;

          var c = null;
          t && (c = this.editing.mapper.toModelRange(t.getFirstRange()));
          var l = this.editing.view.createPositionAt(e.node, r),
              d = this.editing.mapper.toModelPosition(l),
              h = this.editor.model.createRange(d, d.getShiftedBy(a)),
              u = i.substr(r, s);
          this.editor.execute("input", {
            text: u,
            range: h,
            resultRange: c
          });
        }
      }, {
        key: "_handleTextNodeInsertion",
        value: function _handleTextNodeInsertion(e) {
          if ("children" != e.type) return;
          var t = xu(e),
              i = this.editing.view.createPositionAt(e.node, t.index),
              n = this.editing.mapper.toModelPosition(i),
              o = t.values[0].data;
          this.editor.execute("input", {
            text: o.replace(/\u00A0/g, " "),
            range: this.editor.model.createRange(n)
          });
        }
      }]);

      return Cu;
    }();

    function Tu(e, t) {
      return e.every(function (e) {
        return t.isInline(e);
      });
    }

    function Eu(e) {
      var t = null,
          i = null;

      for (var _n149 = 0; _n149 < e.length; _n149++) {
        "equal" != e[_n149] && (t = null === t ? _n149 : t, i = _n149);
      }

      var n = 0,
          o = 0;

      for (var _r49 = t; _r49 <= i; _r49++) {
        "insert" != e[_r49] && n++, "delete" != e[_r49] && o++;
      }

      return {
        insertions: o,
        deletions: n,
        firstChangeAt: t
      };
    }

    var Su =
    /*#__PURE__*/
    function (_Qe14) {
      _inherits(Su, _Qe14);

      function Su() {
        _classCallCheck(this, Su);

        return _possibleConstructorReturn(this, _getPrototypeOf(Su).apply(this, arguments));
      }

      _createClass(Su, [{
        key: "init",
        value: function init() {
          var e = this.editor,
              t = new yu(e, e.config.get("typing.undoStep") || 20);
          e.commands.add("input", t), function (e) {
            var t = null;
            var i = e.model,
                n = e.editing.view,
                o = e.commands.get("input");

            function r(e) {
              var r = i.document,
                  a = n.document.isComposing,
                  c = t && t.isEqual(r.selection);
              t = null, o.isEnabled && (Kh(e) || r.selection.isCollapsed || a && 229 === e.keyCode || !a && 229 === e.keyCode && c || s());
            }

            function s() {
              var e = o.buffer;
              e.lock();
              var t = e.batch;
              o._batches.add(t), i.enqueueChange(t, function () {
                i.deleteContent(i.document.selection);
              }), e.unlock();
            }

            Io.isAndroid ? n.document.on("beforeinput", function (e, t) {
              return r(t);
            }, {
              priority: "lowest"
            }) : n.document.on("keydown", function (e, t) {
              return r(t);
            }, {
              priority: "lowest"
            }), n.document.on("compositionstart", function () {
              var e = i.document,
                  t = 1 !== e.selection.rangeCount || e.selection.getFirstRange().isFlat;
              if (e.selection.isCollapsed || t) return;
              s();
            }, {
              priority: "lowest"
            }), n.document.on("compositionend", function () {
              t = i.createSelection(i.document.selection);
            }, {
              priority: "lowest"
            });
          }(e), function (e) {
            e.editing.view.document.on("mutations", function (t, i, n) {
              new Cu(e).handle(i, n);
            });
          }(e);
        }
      }, {
        key: "isInput",
        value: function isInput(e) {
          return this.editor.commands.get("input")._batches.has(e);
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "Input";
        }
      }]);

      return Su;
    }(Qe);

    var Iu =
    /*#__PURE__*/
    function (_Qe15) {
      _inherits(Iu, _Qe15);

      function Iu() {
        _classCallCheck(this, Iu);

        return _possibleConstructorReturn(this, _getPrototypeOf(Iu).apply(this, arguments));
      }

      _createClass(Iu, null, [{
        key: "requires",
        get: function get() {
          return [Su, Mh];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "Typing";
        }
      }]);

      return Iu;
    }(Qe);

    function Pu(e, t) {
      var i = e.start;
      return {
        text: Array.from(e.getItems()).reduce(function (e, n) {
          return n.is("$text") || n.is("$textProxy") ? e + n.data : (i = t.createPositionAfter(n), "");
        }, ""),
        range: t.createRange(i, e.end)
      };
    }

    var Mu =
    /*#__PURE__*/
    function () {
      function Mu(e, t) {
        var _this170 = this;

        _classCallCheck(this, Mu);

        this.model = e, this.testCallback = t, this.hasMatch = !1, this.set("isEnabled", !0), this.on("change:isEnabled", function () {
          _this170.isEnabled ? _this170._startListening() : (_this170.stopListening(e.document.selection), _this170.stopListening(e.document));
        }), this._startListening();
      }

      _createClass(Mu, [{
        key: "_startListening",
        value: function _startListening() {
          var _this171 = this;

          var e = this.model.document;
          this.listenTo(e.selection, "change:range", function (t, _ref140) {
            var i = _ref140.directChange;
            i && (e.selection.isCollapsed ? _this171._evaluateTextBeforeSelection("selection") : _this171.hasMatch && (_this171.fire("unmatched"), _this171.hasMatch = !1));
          }), this.listenTo(e, "change:data", function (e, t) {
            "transparent" != t.type && _this171._evaluateTextBeforeSelection("data", {
              batch: t
            });
          });
        }
      }, {
        key: "_evaluateTextBeforeSelection",
        value: function _evaluateTextBeforeSelection(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

          var i = this.model,
              n = i.document.selection,
              o = i.createRange(i.createPositionAt(n.focus.parent, 0), n.focus),
              _Pu = Pu(o, i),
              r = _Pu.text,
              s = _Pu.range,
              a = this.testCallback(r);

          if (!a && this.hasMatch && this.fire("unmatched"), this.hasMatch = !!a, a) {
            var _i246 = Object.assign(t, {
              text: r,
              range: s
            });

            "object" == typeof a && Object.assign(_i246, a), this.fire("matched:" + e, _i246);
          }
        }
      }]);

      return Mu;
    }();

    Ke(Mu, Ue);

    var Nu =
    /*#__PURE__*/
    function (_Qe16) {
      _inherits(Nu, _Qe16);

      _createClass(Nu, null, [{
        key: "pluginName",
        get: function get() {
          return "TwoStepCaretMovement";
        }
      }]);

      function Nu(e) {
        var _this172;

        _classCallCheck(this, Nu);

        _this172 = _possibleConstructorReturn(this, _getPrototypeOf(Nu).call(this, e)), _this172.attributes = new Set(), _this172._overrideUid = null;
        return _this172;
      }

      _createClass(Nu, [{
        key: "init",
        value: function init() {
          var _this173 = this;

          var e = this.editor,
              t = e.model,
              i = e.editing.view,
              n = e.locale,
              o = t.document.selection;
          this.listenTo(i.document, "arrowKey", function (e, t) {
            if (!o.isCollapsed) return;
            if (t.shiftKey || t.altKey || t.ctrlKey) return;
            var i = t.keyCode == No.arrowright,
                r = t.keyCode == No.arrowleft;
            if (!i && !r) return;
            var s = n.contentLanguageDirection;
            var a = !1;
            a = "ltr" === s && i || "rtl" === s && r ? _this173._handleForwardMovement(t) : _this173._handleBackwardMovement(t), !0 === a && e.stop();
          }, {
            context: "$text",
            priority: "highest"
          }), this._isNextGravityRestorationSkipped = !1, this.listenTo(o, "change:range", function (e, t) {
            _this173._isNextGravityRestorationSkipped ? _this173._isNextGravityRestorationSkipped = !1 : _this173._isGravityOverridden && (!t.directChange && Du(o.getFirstPosition(), _this173.attributes) || _this173._restoreGravity());
          });
        }
      }, {
        key: "registerAttribute",
        value: function registerAttribute(e) {
          this.attributes.add(e);
        }
      }, {
        key: "_handleForwardMovement",
        value: function _handleForwardMovement(e) {
          var t = this.attributes,
              i = this.editor.model.document.selection,
              n = i.getFirstPosition();
          return !this._isGravityOverridden && (!n.isAtStart || !Ru(i, t)) && (Du(n, t) ? (zu(e), this._overrideGravity(), !0) : void 0);
        }
      }, {
        key: "_handleBackwardMovement",
        value: function _handleBackwardMovement(e) {
          var t = this.attributes,
              i = this.editor.model,
              n = i.document.selection,
              o = n.getFirstPosition();
          return this._isGravityOverridden ? (zu(e), this._restoreGravity(), Ou(i, t, o), !0) : o.isAtStart ? !!Ru(n, t) && (zu(e), Ou(i, t, o), !0) : function (e, t) {
            return Du(e.getShiftedBy(-1), t);
          }(o, t) ? o.isAtEnd && !Ru(n, t) && Du(o, t) ? (zu(e), Ou(i, t, o), !0) : (this._isNextGravityRestorationSkipped = !0, this._overrideGravity(), !1) : void 0;
        }
      }, {
        key: "_overrideGravity",
        value: function _overrideGravity() {
          this._overrideUid = this.editor.model.change(function (e) {
            return e.overrideSelectionGravity();
          });
        }
      }, {
        key: "_restoreGravity",
        value: function _restoreGravity() {
          var _this174 = this;

          this.editor.model.change(function (e) {
            e.restoreSelectionGravity(_this174._overrideUid), _this174._overrideUid = null;
          });
        }
      }, {
        key: "_isGravityOverridden",
        get: function get() {
          return !!this._overrideUid;
        }
      }]);

      return Nu;
    }(Qe);

    function Ru(e, t) {
      var _iteratorNormalCompletion320 = true;
      var _didIteratorError320 = false;
      var _iteratorError320 = undefined;

      try {
        for (var _iterator320 = t[Symbol.iterator](), _step320; !(_iteratorNormalCompletion320 = (_step320 = _iterator320.next()).done); _iteratorNormalCompletion320 = true) {
          var _i247 = _step320.value;
          if (e.hasAttribute(_i247)) return !0;
        }
      } catch (err) {
        _didIteratorError320 = true;
        _iteratorError320 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion320 && _iterator320.return != null) {
            _iterator320.return();
          }
        } finally {
          if (_didIteratorError320) {
            throw _iteratorError320;
          }
        }
      }

      return !1;
    }

    function Ou(e, t, i) {
      var n = i.nodeBefore;
      e.change(function (e) {
        n ? e.setSelectionAttribute(n.getAttributes()) : e.removeSelectionAttribute(t);
      });
    }

    function zu(e) {
      e.preventDefault();
    }

    function Du(e, t) {
      var i = e.nodeBefore,
          n = e.nodeAfter;
      var _iteratorNormalCompletion321 = true;
      var _didIteratorError321 = false;
      var _iteratorError321 = undefined;

      try {
        for (var _iterator321 = t[Symbol.iterator](), _step321; !(_iteratorNormalCompletion321 = (_step321 = _iterator321.next()).done); _iteratorNormalCompletion321 = true) {
          var _e245 = _step321.value;

          var _t223 = i ? i.getAttribute(_e245) : void 0;

          if ((n ? n.getAttribute(_e245) : void 0) !== _t223) return !0;
        }
      } catch (err) {
        _didIteratorError321 = true;
        _iteratorError321 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion321 && _iterator321.return != null) {
            _iterator321.return();
          }
        } finally {
          if (_didIteratorError321) {
            throw _iteratorError321;
          }
        }
      }

      return !1;
    }

    var Lu = /[\\^$.*+?()[\]{}|]/g,
        Vu = RegExp(Lu.source);

    var ju = function ju(e) {
      return (e = Pn(e)) && Vu.test(e) ? e.replace(Lu, "\\$&") : e;
    };

    var Bu = {
      copyright: {
        from: "(c)",
        to: "©"
      },
      registeredTrademark: {
        from: "(r)",
        to: "®"
      },
      trademark: {
        from: "(tm)",
        to: "™"
      },
      oneHalf: {
        from: "1/2",
        to: "½"
      },
      oneThird: {
        from: "1/3",
        to: "⅓"
      },
      twoThirds: {
        from: "2/3",
        to: "⅔"
      },
      oneForth: {
        from: "1/4",
        to: "¼"
      },
      threeQuarters: {
        from: "3/4",
        to: "¾"
      },
      lessThanOrEqual: {
        from: "<=",
        to: "≤"
      },
      greaterThanOrEqual: {
        from: ">=",
        to: "≥"
      },
      notEqual: {
        from: "!=",
        to: "≠"
      },
      arrowLeft: {
        from: "<-",
        to: "←"
      },
      arrowRight: {
        from: "->",
        to: "→"
      },
      horizontalEllipsis: {
        from: "...",
        to: "…"
      },
      enDash: {
        from: /(^| )(--)( )$/,
        to: [null, "–", null]
      },
      emDash: {
        from: /(^| )(---)( )$/,
        to: [null, "—", null]
      },
      quotesPrimary: {
        from: $u('"'),
        to: [null, "“", null, "”"]
      },
      quotesSecondary: {
        from: $u("'"),
        to: [null, "‘", null, "’"]
      },
      quotesPrimaryEnGb: {
        from: $u("'"),
        to: [null, "‘", null, "’"]
      },
      quotesSecondaryEnGb: {
        from: $u('"'),
        to: [null, "“", null, "”"]
      },
      quotesPrimaryPl: {
        from: $u('"'),
        to: [null, "„", null, "”"]
      },
      quotesSecondaryPl: {
        from: $u("'"),
        to: [null, "‚", null, "’"]
      }
    },
        Fu = {
      symbols: ["copyright", "registeredTrademark", "trademark"],
      mathematical: ["oneHalf", "oneThird", "twoThirds", "oneForth", "threeQuarters", "lessThanOrEqual", "greaterThanOrEqual", "notEqual", "arrowLeft", "arrowRight"],
      typography: ["horizontalEllipsis", "enDash", "emDash"],
      quotes: ["quotesPrimary", "quotesSecondary"]
    },
        Hu = ["symbols", "mathematical", "typography", "quotes"];

    function Uu(e) {
      return "string" == typeof e ? new RegExp("(".concat(ju(e), ")$")) : e;
    }

    function Wu(e) {
      return "string" == typeof e ? function () {
        return [e];
      } : e instanceof Array ? function () {
        return e;
      } : e;
    }

    function qu(e) {
      return (e.textNode ? e.textNode : e.nodeAfter).getAttributes();
    }

    function $u(e) {
      return new RegExp("(^|\\s)(".concat(e, ")([^").concat(e, "]*)(").concat(e, ")$"));
    }

    function Yu(e, t, i, n) {
      return n.createRange(Gu(e, t, i, !0, n), Gu(e, t, i, !1, n));
    }

    function Gu(e, t, i, n, o) {
      var r = e.textNode || (n ? e.nodeBefore : e.nodeAfter),
          s = null;

      for (; r && r.getAttribute(t) == i;) {
        s = r, r = n ? r.previousSibling : r.nextSibling;
      }

      return s ? o.createPositionAt(s, n ? "before" : "after") : e;
    }

    var Ku =
    /*#__PURE__*/
    function (_Ze7) {
      _inherits(Ku, _Ze7);

      function Ku(e) {
        var _this175;

        _classCallCheck(this, Ku);

        _this175 = _possibleConstructorReturn(this, _getPrototypeOf(Ku).call(this, e)), _this175._stack = [], _this175._createdBatches = new WeakSet(), _this175.refresh(), _this175.listenTo(e.data, "set", function (e, t) {
          t[1] = _objectSpread({}, t[1]);
          var i = t[1];
          i.batchType || (i.batchType = "transparent");
        }, {
          priority: "high"
        }), _this175.listenTo(e.data, "set", function (e, t) {
          "transparent" === t[1].batchType && _this175.clearStack();
        });
        return _this175;
      }

      _createClass(Ku, [{
        key: "refresh",
        value: function refresh() {
          this.isEnabled = this._stack.length > 0;
        }
      }, {
        key: "addBatch",
        value: function addBatch(e) {
          var t = this.editor.model.document.selection,
              i = {
            ranges: t.hasOwnRange ? Array.from(t.getRanges()) : [],
            isBackward: t.isBackward
          };
          this._stack.push({
            batch: e,
            selection: i
          }), this.refresh();
        }
      }, {
        key: "clearStack",
        value: function clearStack() {
          this._stack = [], this.refresh();
        }
      }, {
        key: "_restoreSelection",
        value: function _restoreSelection(e, t, i) {
          var n = this.editor.model,
              o = n.document,
              r = [],
              s = e.map(function (e) {
            return e.getTransformedByOperations(i);
          }),
              a = s.flat();
          var _iteratorNormalCompletion322 = true;
          var _didIteratorError322 = false;
          var _iteratorError322 = undefined;

          try {
            for (var _iterator322 = s[Symbol.iterator](), _step322; !(_iteratorNormalCompletion322 = (_step322 = _iterator322.next()).done); _iteratorNormalCompletion322 = true) {
              var _e246 = _step322.value;

              var _t224 = _e246.filter(function (e) {
                return e.root != o.graveyard;
              }).filter(function (e) {
                return !Ju(e, a);
              });

              _t224.length && (Qu(_t224), r.push(_t224[0]));
            }
          } catch (err) {
            _didIteratorError322 = true;
            _iteratorError322 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion322 && _iterator322.return != null) {
                _iterator322.return();
              }
            } finally {
              if (_didIteratorError322) {
                throw _iteratorError322;
              }
            }
          }

          r.length && n.change(function (e) {
            e.setSelection(r, {
              backward: t
            });
          });
        }
      }, {
        key: "_undo",
        value: function _undo(e, t) {
          var i = this.editor.model,
              n = i.document;

          this._createdBatches.add(t);

          var o = e.operations.slice().filter(function (e) {
            return e.isDocumentOperation;
          });
          o.reverse();
          var _iteratorNormalCompletion323 = true;
          var _didIteratorError323 = false;
          var _iteratorError323 = undefined;

          try {
            for (var _iterator323 = o[Symbol.iterator](), _step323; !(_iteratorNormalCompletion323 = (_step323 = _iterator323.next()).done); _iteratorNormalCompletion323 = true) {
              var _e247 = _step323.value;

              var _o92 = _e247.baseVersion + 1,
                  _r50 = Array.from(n.history.getOperations(_o92)),
                  _s28 = sh([_e247.getReversed()], _r50, {
                useRelations: !0,
                document: this.editor.model.document,
                padWithNoOps: !1,
                forceWeakRemove: !0
              }).operationsA;

              var _iteratorNormalCompletion324 = true;
              var _didIteratorError324 = false;
              var _iteratorError324 = undefined;

              try {
                for (var _iterator324 = _s28[Symbol.iterator](), _step324; !(_iteratorNormalCompletion324 = (_step324 = _iterator324.next()).done); _iteratorNormalCompletion324 = true) {
                  var _o93 = _step324.value;
                  t.addOperation(_o93), i.applyOperation(_o93), n.history.setOperationAsUndone(_e247, _o93);
                }
              } catch (err) {
                _didIteratorError324 = true;
                _iteratorError324 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion324 && _iterator324.return != null) {
                    _iterator324.return();
                  }
                } finally {
                  if (_didIteratorError324) {
                    throw _iteratorError324;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError323 = true;
            _iteratorError323 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion323 && _iterator323.return != null) {
                _iterator323.return();
              }
            } finally {
              if (_didIteratorError323) {
                throw _iteratorError323;
              }
            }
          }
        }
      }]);

      return Ku;
    }(Ze);

    function Qu(e) {
      e.sort(function (e, t) {
        return e.start.isBefore(t.start) ? -1 : 1;
      });

      for (var _t225 = 1; _t225 < e.length; _t225++) {
        var _i248 = e[_t225 - 1].getJoined(e[_t225], !0);

        _i248 && (_t225--, e.splice(_t225, 2, _i248));
      }
    }

    function Ju(e, t) {
      return t.some(function (t) {
        return t !== e && t.containsRange(e, !0);
      });
    }

    var Zu =
    /*#__PURE__*/
    function (_Ku) {
      _inherits(Zu, _Ku);

      function Zu() {
        _classCallCheck(this, Zu);

        return _possibleConstructorReturn(this, _getPrototypeOf(Zu).apply(this, arguments));
      }

      _createClass(Zu, [{
        key: "execute",
        value: function execute() {
          var _this176 = this;

          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

          var t = e ? this._stack.findIndex(function (t) {
            return t.batch == e;
          }) : this._stack.length - 1,
              i = this._stack.splice(t, 1)[0],
              n = this.editor.model.createBatch("transparent");

          this.editor.model.enqueueChange(n, function () {
            _this176._undo(i.batch, n);

            var e = _this176.editor.model.document.history.getOperations(i.batch.baseVersion);

            _this176._restoreSelection(i.selection.ranges, i.selection.isBackward, e), _this176.fire("revert", i.batch, n);
          }), this.refresh();
        }
      }]);

      return Zu;
    }(Ku);

    var Xu =
    /*#__PURE__*/
    function (_Ku2) {
      _inherits(Xu, _Ku2);

      function Xu() {
        _classCallCheck(this, Xu);

        return _possibleConstructorReturn(this, _getPrototypeOf(Xu).apply(this, arguments));
      }

      _createClass(Xu, [{
        key: "execute",
        value: function execute() {
          var _this177 = this;

          var e = this._stack.pop(),
              t = this.editor.model.createBatch("transparent");

          this.editor.model.enqueueChange(t, function () {
            var i = e.batch.operations[e.batch.operations.length - 1].baseVersion + 1,
                n = _this177.editor.model.document.history.getOperations(i);

            _this177._restoreSelection(e.selection.ranges, e.selection.isBackward, n), _this177._undo(e.batch, t);
          }), this.refresh();
        }
      }]);

      return Xu;
    }(Ku);

    var eg =
    /*#__PURE__*/
    function (_Qe17) {
      _inherits(eg, _Qe17);

      _createClass(eg, null, [{
        key: "pluginName",
        get: function get() {
          return "UndoEditing";
        }
      }]);

      function eg(e) {
        var _this178;

        _classCallCheck(this, eg);

        _this178 = _possibleConstructorReturn(this, _getPrototypeOf(eg).call(this, e)), _this178._batchRegistry = new WeakSet();
        return _this178;
      }

      _createClass(eg, [{
        key: "init",
        value: function init() {
          var _this179 = this;

          var e = this.editor;
          this._undoCommand = new Zu(e), this._redoCommand = new Xu(e), e.commands.add("undo", this._undoCommand), e.commands.add("redo", this._redoCommand), this.listenTo(e.model, "applyOperation", function (e, t) {
            var i = t[0];
            if (!i.isDocumentOperation) return;

            var n = i.batch,
                o = _this179._redoCommand._createdBatches.has(n),
                r = _this179._undoCommand._createdBatches.has(n);

            _this179._batchRegistry.has(n) || "transparent" == n.type && !o && !r || (o ? _this179._undoCommand.addBatch(n) : r || (_this179._undoCommand.addBatch(n), _this179._redoCommand.clearStack()), _this179._batchRegistry.add(n));
          }, {
            priority: "highest"
          }), this.listenTo(this._undoCommand, "revert", function (e, t, i) {
            _this179._redoCommand.addBatch(i);
          }), e.keystrokes.set("CTRL+Z", "undo"), e.keystrokes.set("CTRL+Y", "redo"), e.keystrokes.set("CTRL+SHIFT+Z", "redo");
        }
      }]);

      return eg;
    }(Qe);

    var tg = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m5.042 9.367 2.189 1.837a.75.75 0 0 1-.965 1.149l-3.788-3.18a.747.747 0 0 1-.21-.284.75.75 0 0 1 .17-.945L6.23 4.762a.75.75 0 1 1 .964 1.15L4.863 7.866h8.917A.75.75 0 0 1 14 7.9a4 4 0 1 1-1.477 7.718l.344-1.489a2.5 2.5 0 1 0 1.094-4.73l.008-.032H5.042z"/></svg>',
        ig = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m14.958 9.367-2.189 1.837a.75.75 0 0 0 .965 1.149l3.788-3.18a.747.747 0 0 0 .21-.284.75.75 0 0 0-.17-.945L13.77 4.762a.75.75 0 1 0-.964 1.15l2.331 1.955H6.22A.75.75 0 0 0 6 7.9a4 4 0 1 0 1.477 7.718l-.344-1.489A2.5 2.5 0 1 1 6.039 9.4l-.008-.032h8.927z"/></svg>';

    var ng =
    /*#__PURE__*/
    function (_Qe18) {
      _inherits(ng, _Qe18);

      function ng() {
        _classCallCheck(this, ng);

        return _possibleConstructorReturn(this, _getPrototypeOf(ng).apply(this, arguments));
      }

      _createClass(ng, [{
        key: "init",
        value: function init() {
          var e = this.editor,
              t = e.locale,
              i = e.t,
              n = "ltr" == t.uiLanguageDirection ? tg : ig,
              o = "ltr" == t.uiLanguageDirection ? ig : tg;
          this._addButton("undo", i("Undo"), "CTRL+Z", n), this._addButton("redo", i("Redo"), "CTRL+Y", o);
        }
      }, {
        key: "_addButton",
        value: function _addButton(e, t, i, n) {
          var _this180 = this;

          var o = this.editor;
          o.ui.componentFactory.add(e, function (r) {
            var s = o.commands.get(e),
                a = new id(r);
            return a.set({
              label: t,
              icon: n,
              keystroke: i,
              tooltip: !0
            }), a.bind("isEnabled").to(s, "isEnabled"), _this180.listenTo(a, "execute", function () {
              o.execute(e), o.editing.view.focus();
            }), a;
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "UndoUI";
        }
      }]);

      return ng;
    }(Qe);

    var og =
    /*#__PURE__*/
    function (_Qe19) {
      _inherits(og, _Qe19);

      function og() {
        _classCallCheck(this, og);

        return _possibleConstructorReturn(this, _getPrototypeOf(og).apply(this, arguments));
      }

      _createClass(og, null, [{
        key: "requires",
        get: function get() {
          return [eg, ng];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "Undo";
        }
      }]);

      return og;
    }(Qe);

    var rg =
    /*#__PURE__*/
    function () {
      function rg() {
        var _this181 = this;

        _classCallCheck(this, rg);

        var e = new window.FileReader();
        this._reader = e, this._data = void 0, this.set("loaded", 0), e.onprogress = function (e) {
          _this181.loaded = e.loaded;
        };
      }

      _createClass(rg, [{
        key: "read",
        value: function read(e) {
          var _this182 = this;

          var t = this._reader;
          return this.total = e.size, new Promise(function (i, n) {
            t.onload = function () {
              var e = t.result;
              _this182._data = e, i(e);
            }, t.onerror = function () {
              n("error");
            }, t.onabort = function () {
              n("aborted");
            }, _this182._reader.readAsDataURL(e);
          });
        }
      }, {
        key: "abort",
        value: function abort() {
          this._reader.abort();
        }
      }, {
        key: "error",
        get: function get() {
          return this._reader.error;
        }
      }, {
        key: "data",
        get: function get() {
          return this._data;
        }
      }]);

      return rg;
    }();

    Ke(rg, Ue);

    var sg =
    /*#__PURE__*/
    function (_Qe20) {
      _inherits(sg, _Qe20);

      function sg() {
        _classCallCheck(this, sg);

        return _possibleConstructorReturn(this, _getPrototypeOf(sg).apply(this, arguments));
      }

      _createClass(sg, [{
        key: "init",
        value: function init() {
          var _this183 = this;

          this.loaders = new Zi(), this.loaders.on("add", function () {
            return _this183._updatePendingAction();
          }), this.loaders.on("remove", function () {
            return _this183._updatePendingAction();
          }), this._loadersMap = new Map(), this._pendingAction = null, this.set("uploaded", 0), this.set("uploadTotal", null), this.bind("uploadedPercent").to(this, "uploaded", this, "uploadTotal", function (e, t) {
            return t ? e / t * 100 : 0;
          });
        }
      }, {
        key: "getLoader",
        value: function getLoader(e) {
          return this._loadersMap.get(e) || null;
        }
      }, {
        key: "createLoader",
        value: function createLoader(e) {
          var _this184 = this;

          if (!this.createUploadAdapter) return Object(c.b)("filerepository-no-upload-adapter"), null;
          var t = new ag(Promise.resolve(e), this.createUploadAdapter);
          return this.loaders.add(t), this._loadersMap.set(e, t), e instanceof Promise && t.file.then(function (e) {
            _this184._loadersMap.set(e, t);
          }).catch(function () {}), t.on("change:uploaded", function () {
            var e = 0;
            var _iteratorNormalCompletion325 = true;
            var _didIteratorError325 = false;
            var _iteratorError325 = undefined;

            try {
              for (var _iterator325 = _this184.loaders[Symbol.iterator](), _step325; !(_iteratorNormalCompletion325 = (_step325 = _iterator325.next()).done); _iteratorNormalCompletion325 = true) {
                var _t226 = _step325.value;
                e += _t226.uploaded;
              }
            } catch (err) {
              _didIteratorError325 = true;
              _iteratorError325 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion325 && _iterator325.return != null) {
                  _iterator325.return();
                }
              } finally {
                if (_didIteratorError325) {
                  throw _iteratorError325;
                }
              }
            }

            _this184.uploaded = e;
          }), t.on("change:uploadTotal", function () {
            var e = 0;
            var _iteratorNormalCompletion326 = true;
            var _didIteratorError326 = false;
            var _iteratorError326 = undefined;

            try {
              for (var _iterator326 = _this184.loaders[Symbol.iterator](), _step326; !(_iteratorNormalCompletion326 = (_step326 = _iterator326.next()).done); _iteratorNormalCompletion326 = true) {
                var _t227 = _step326.value;
                _t227.uploadTotal && (e += _t227.uploadTotal);
              }
            } catch (err) {
              _didIteratorError326 = true;
              _iteratorError326 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion326 && _iterator326.return != null) {
                  _iterator326.return();
                }
              } finally {
                if (_didIteratorError326) {
                  throw _iteratorError326;
                }
              }
            }

            _this184.uploadTotal = e;
          }), t;
        }
      }, {
        key: "destroyLoader",
        value: function destroyLoader(e) {
          var _this185 = this;

          var t = e instanceof ag ? e : this.getLoader(e);
          t._destroy(), this.loaders.remove(t), this._loadersMap.forEach(function (e, i) {
            e === t && _this185._loadersMap.delete(i);
          });
        }
      }, {
        key: "_updatePendingAction",
        value: function _updatePendingAction() {
          var e = this.editor.plugins.get(El);

          if (this.loaders.length) {
            if (!this._pendingAction) {
              var _t228 = this.editor.t,
                  _i249 = function _i249(e) {
                return "".concat(_t228("Upload in progress"), " ").concat(parseInt(e), "%.");
              };

              this._pendingAction = e.add(_i249(this.uploadedPercent)), this._pendingAction.bind("message").to(this, "uploadedPercent", _i249);
            }
          } else e.remove(this._pendingAction), this._pendingAction = null;
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "FileRepository";
        }
      }, {
        key: "requires",
        get: function get() {
          return [El];
        }
      }]);

      return sg;
    }(Qe);

    Ke(sg, Ue);

    var ag =
    /*#__PURE__*/
    function () {
      function ag(e, t) {
        _classCallCheck(this, ag);

        this.id = s(), this._filePromiseWrapper = this._createFilePromiseWrapper(e), this._adapter = t(this), this._reader = new rg(), this.set("status", "idle"), this.set("uploaded", 0), this.set("uploadTotal", null), this.bind("uploadedPercent").to(this, "uploaded", this, "uploadTotal", function (e, t) {
          return t ? e / t * 100 : 0;
        }), this.set("uploadResponse", null);
      }

      _createClass(ag, [{
        key: "read",
        value: function read() {
          var _this186 = this;

          if ("idle" != this.status) throw new c.a("filerepository-read-wrong-status", this);
          return this.status = "reading", this.file.then(function (e) {
            return _this186._reader.read(e);
          }).then(function (e) {
            if ("reading" !== _this186.status) throw _this186.status;
            return _this186.status = "idle", e;
          }).catch(function (e) {
            if ("aborted" === e) throw _this186.status = "aborted", "aborted";
            throw _this186.status = "error", _this186._reader.error ? _this186._reader.error : e;
          });
        }
      }, {
        key: "upload",
        value: function upload() {
          var _this187 = this;

          if ("idle" != this.status) throw new c.a("filerepository-upload-wrong-status", this);
          return this.status = "uploading", this.file.then(function () {
            return _this187._adapter.upload();
          }).then(function (e) {
            return _this187.uploadResponse = e, _this187.status = "idle", e;
          }).catch(function (e) {
            if ("aborted" === _this187.status) throw "aborted";
            throw _this187.status = "error", e;
          });
        }
      }, {
        key: "abort",
        value: function abort() {
          var e = this.status;
          this.status = "aborted", this._filePromiseWrapper.isFulfilled ? "reading" == e ? this._reader.abort() : "uploading" == e && this._adapter.abort && this._adapter.abort() : (this._filePromiseWrapper.promise.catch(function () {}), this._filePromiseWrapper.rejecter("aborted")), this._destroy();
        }
      }, {
        key: "_destroy",
        value: function _destroy() {
          this._filePromiseWrapper = void 0, this._reader = void 0, this._adapter = void 0, this.uploadResponse = void 0;
        }
      }, {
        key: "_createFilePromiseWrapper",
        value: function _createFilePromiseWrapper(e) {
          var t = {};
          return t.promise = new Promise(function (i, n) {
            t.rejecter = n, t.isFulfilled = !1, e.then(function (e) {
              t.isFulfilled = !0, i(e);
            }).catch(function (e) {
              t.isFulfilled = !0, n(e);
            });
          }), t;
        }
      }, {
        key: "file",
        get: function get() {
          var _this188 = this;

          return this._filePromiseWrapper ? this._filePromiseWrapper.promise.then(function (e) {
            return _this188._filePromiseWrapper ? e : null;
          }) : Promise.resolve(null);
        }
      }, {
        key: "data",
        get: function get() {
          return this._reader.data;
        }
      }]);

      return ag;
    }();

    Ke(ag, Ue);

    var cg =
    /*#__PURE__*/
    function (_Rl23) {
      _inherits(cg, _Rl23);

      function cg(e) {
        var _this189;

        _classCallCheck(this, cg);

        _this189 = _possibleConstructorReturn(this, _getPrototypeOf(cg).call(this, e)), _this189.buttonView = new id(e), _this189._fileInputView = new lg(e), _this189._fileInputView.bind("acceptedType").to(_assertThisInitialized(_this189)), _this189._fileInputView.bind("allowMultipleFiles").to(_assertThisInitialized(_this189)), _this189._fileInputView.delegate("done").to(_assertThisInitialized(_this189)), _this189.setTemplate({
          tag: "span",
          attributes: {
            class: "ck-file-dialog-button"
          },
          children: [_this189.buttonView, _this189._fileInputView]
        }), _this189.buttonView.on("execute", function () {
          _this189._fileInputView.open();
        });
        return _this189;
      }

      _createClass(cg, [{
        key: "focus",
        value: function focus() {
          this.buttonView.focus();
        }
      }]);

      return cg;
    }(Rl);

    var lg =
    /*#__PURE__*/
    function (_Rl24) {
      _inherits(lg, _Rl24);

      function lg(e) {
        var _this190;

        _classCallCheck(this, lg);

        _this190 = _possibleConstructorReturn(this, _getPrototypeOf(lg).call(this, e)), _this190.set("acceptedType"), _this190.set("allowMultipleFiles", !1);
        var t = _this190.bindTemplate;

        _this190.setTemplate({
          tag: "input",
          attributes: {
            class: ["ck-hidden"],
            type: "file",
            tabindex: "-1",
            accept: t.to("acceptedType"),
            multiple: t.to("allowMultipleFiles")
          },
          on: {
            change: t.to(function () {
              _this190.element && _this190.element.files && _this190.element.files.length && _this190.fire("done", _this190.element.files), _this190.element.value = "";
            })
          }
        });

        return _this190;
      }

      _createClass(lg, [{
        key: "open",
        value: function open() {
          this.element.click();
        }
      }]);

      return lg;
    }(Rl);

    function dg() {
      var e = function (e) {
        e = e.toLowerCase();
        var t = document.cookie.split(";");
        var _iteratorNormalCompletion327 = true;
        var _didIteratorError327 = false;
        var _iteratorError327 = undefined;

        try {
          for (var _iterator327 = t[Symbol.iterator](), _step327; !(_iteratorNormalCompletion327 = (_step327 = _iterator327.next()).done); _iteratorNormalCompletion327 = true) {
            var _i250 = _step327.value;

            var _t229 = _i250.split("=");

            if (decodeURIComponent(_t229[0].trim().toLowerCase()) === e) return decodeURIComponent(_t229[1]);
          }
        } catch (err) {
          _didIteratorError327 = true;
          _iteratorError327 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion327 && _iterator327.return != null) {
              _iterator327.return();
            }
          } finally {
            if (_didIteratorError327) {
              throw _iteratorError327;
            }
          }
        }

        return null;
      }("ckCsrfToken");

      var t, i;
      return e && 40 == e.length || (e = function (e) {
        var t = "";
        var i = new Uint8Array(e);
        window.crypto.getRandomValues(i);

        for (var _e248 = 0; _e248 < i.length; _e248++) {
          var _n150 = "abcdefghijklmnopqrstuvwxyz0123456789".charAt(i[_e248] % "abcdefghijklmnopqrstuvwxyz0123456789".length);

          t += Math.random() > .5 ? _n150.toUpperCase() : _n150;
        }

        return t;
      }(40), t = "ckCsrfToken", i = e, document.cookie = encodeURIComponent(t) + "=" + encodeURIComponent(i) + ";path=/"), e;
    }

    var hg =
    /*#__PURE__*/
    function () {
      function hg(e, t, i) {
        _classCallCheck(this, hg);

        this.loader = e, this.url = t, this.t = i;
      }

      _createClass(hg, [{
        key: "upload",
        value: function upload() {
          var _this191 = this;

          return this.loader.file.then(function (e) {
            return new Promise(function (t, i) {
              _this191._initRequest(), _this191._initListeners(t, i, e), _this191._sendRequest(e);
            });
          });
        }
      }, {
        key: "abort",
        value: function abort() {
          this.xhr && this.xhr.abort();
        }
      }, {
        key: "_initRequest",
        value: function _initRequest() {
          var e = this.xhr = new XMLHttpRequest();
          e.open("POST", this.url, !0), e.responseType = "json";
        }
      }, {
        key: "_initListeners",
        value: function _initListeners(e, t, i) {
          var n = this.xhr,
              o = this.loader,
              r = (0, this.t)("Cannot upload file:") + " ".concat(i.name, ".");
          n.addEventListener("error", function () {
            return t(r);
          }), n.addEventListener("abort", function () {
            return t();
          }), n.addEventListener("load", function () {
            var i = n.response;
            if (!i || !i.uploaded) return t(i && i.error && i.error.message ? i.error.message : r);
            e({
              default: i.url
            });
          }), n.upload && n.upload.addEventListener("progress", function (e) {
            e.lengthComputable && (o.uploadTotal = e.total, o.uploaded = e.loaded);
          });
        }
      }, {
        key: "_sendRequest",
        value: function _sendRequest(e) {
          var t = new FormData();
          t.append("upload", e), t.append("ckCsrfToken", dg()), this.xhr.send(t);
        }
      }]);

      return hg;
    }();

    function ug(e, t, i, n) {
      var o,
          r = null;
      "function" == typeof n ? o = n : (r = e.commands.get(n), o = function o() {
        e.execute(n);
      }), e.model.document.on("change:data", function (s, a) {
        if (r && !r.isEnabled || !t.isEnabled) return;
        var c = Os(e.model.document.selection.getRanges());
        if (!c.isCollapsed) return;
        if ("transparent" == a.type) return;
        var l = Array.from(e.model.document.differ.getChanges()),
            d = l[0];
        if (1 != l.length || "insert" !== d.type || "$text" != d.name || 1 != d.length) return;
        var h = d.position.parent;
        if (h.is("element", "codeBlock")) return;
        if (h.is("element", "listItem") && "function" != typeof n && !["numberedList", "bulletedList", "todoList"].includes(n)) return;
        if (r && !0 === r.value) return;
        var u = h.getChild(0),
            g = e.model.createRangeOn(u);
        if (!g.containsRange(c) && !c.end.isEqual(g.end)) return;
        var m = i.exec(u.data.substr(0, c.end.offset));
        m && e.model.enqueueChange(function (t) {
          var i = t.createPositionAt(h, 0),
              n = t.createPositionAt(h, m[0].length),
              r = new ka(i, n);

          if (!1 !== o({
            match: m
          })) {
            t.remove(r);

            var _i251 = e.model.document.selection.getFirstRange(),
                _n151 = t.createRangeIn(h);

            !h.isEmpty || _n151.isEqual(_i251) || _n151.containsRange(_i251, !0) || t.remove(h);
          }

          r.detach();
        });
      });
    }

    function gg(e, t, i, n) {
      var o, r;
      i instanceof RegExp ? o = i : r = i, r = r || function (e) {
        var t;
        var i = [],
            n = [];

        for (; null !== (t = o.exec(e)) && !(t && t.length < 4);) {
          var _t230 = t,
              _e249 = _t230.index,
              _o94 = _t230[1],
              _r51 = _t230[2],
              _s29 = _t230[3];

          var _a18 = _o94 + _r51 + _s29;

          _e249 += t[0].length - _a18.length;
          var _c10 = [_e249, _e249 + _o94.length],
              _l5 = [_e249 + _o94.length + _r51.length, _e249 + _o94.length + _r51.length + _s29.length];
          i.push(_c10), i.push(_l5), n.push([_e249 + _o94.length, _e249 + _o94.length + _r51.length]);
        }

        return {
          remove: i,
          format: n
        };
      }, e.model.document.on("change:data", function (i, o) {
        if ("transparent" == o.type || !t.isEnabled) return;
        var s = e.model,
            a = s.document.selection;
        if (!a.isCollapsed) return;
        var c = Array.from(s.document.differ.getChanges()),
            l = c[0];
        if (1 != c.length || "insert" !== l.type || "$text" != l.name || 1 != l.length) return;

        var d = a.focus,
            h = d.parent,
            _ref141 = function (e, t) {
          var i = e.start;
          return {
            text: Array.from(e.getItems()).reduce(function (e, n) {
              return !n.is("$text") && !n.is("$textProxy") || n.getAttribute("code") ? (i = t.createPositionAfter(n), "") : e + n.data;
            }, ""),
            range: t.createRange(i, e.end)
          };
        }(s.createRange(s.createPositionAt(h, 0), d), s),
            u = _ref141.text,
            g = _ref141.range,
            m = r(u),
            f = mg(g.start, m.format, s),
            p = mg(g.start, m.remove, s);

        f.length && p.length && s.enqueueChange(function (e) {
          if (!1 !== n(e, f)) {
            var _iteratorNormalCompletion328 = true;
            var _didIteratorError328 = false;
            var _iteratorError328 = undefined;

            try {
              for (var _iterator328 = p.reverse()[Symbol.iterator](), _step328; !(_iteratorNormalCompletion328 = (_step328 = _iterator328.next()).done); _iteratorNormalCompletion328 = true) {
                var _t231 = _step328.value;
                e.remove(_t231);
              }
            } catch (err) {
              _didIteratorError328 = true;
              _iteratorError328 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion328 && _iterator328.return != null) {
                  _iterator328.return();
                }
              } finally {
                if (_didIteratorError328) {
                  throw _iteratorError328;
                }
              }
            }
          }
        });
      });
    }

    function mg(e, t, i) {
      return t.filter(function (e) {
        return void 0 !== e[0] && void 0 !== e[1];
      }).map(function (t) {
        return i.createRange(e.getShiftedBy(t[0]), e.getShiftedBy(t[1]));
      });
    }

    function fg(e, t) {
      return function (i, n) {
        if (!e.commands.get(t).isEnabled) return !1;
        var o = e.model.schema.getValidRanges(n, t);
        var _iteratorNormalCompletion329 = true;
        var _didIteratorError329 = false;
        var _iteratorError329 = undefined;

        try {
          for (var _iterator329 = o[Symbol.iterator](), _step329; !(_iteratorNormalCompletion329 = (_step329 = _iterator329.next()).done); _iteratorNormalCompletion329 = true) {
            var _e250 = _step329.value;
            i.setAttribute(t, !0, _e250);
          }
        } catch (err) {
          _didIteratorError329 = true;
          _iteratorError329 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion329 && _iterator329.return != null) {
              _iterator329.return();
            }
          } finally {
            if (_didIteratorError329) {
              throw _iteratorError329;
            }
          }
        }

        i.removeSelectionAttribute(t);
      };
    }

    var pg =
    /*#__PURE__*/
    function (_Ze8) {
      _inherits(pg, _Ze8);

      function pg(e, t) {
        var _this192;

        _classCallCheck(this, pg);

        _this192 = _possibleConstructorReturn(this, _getPrototypeOf(pg).call(this, e)), _this192.attributeKey = t;
        return _this192;
      }

      _createClass(pg, [{
        key: "refresh",
        value: function refresh() {
          var e = this.editor.model,
              t = e.document;
          this.value = this._getValueFromFirstAllowedNode(), this.isEnabled = e.schema.checkAttributeInSelection(t.selection, this.attributeKey);
        }
      }, {
        key: "execute",
        value: function execute() {
          var _this193 = this;

          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var t = this.editor.model,
              i = t.document.selection,
              n = void 0 === e.forceValue ? !this.value : e.forceValue;
          t.change(function (e) {
            if (i.isCollapsed) n ? e.setSelectionAttribute(_this193.attributeKey, !0) : e.removeSelectionAttribute(_this193.attributeKey);else {
              var _o95 = t.schema.getValidRanges(i.getRanges(), _this193.attributeKey);

              var _iteratorNormalCompletion330 = true;
              var _didIteratorError330 = false;
              var _iteratorError330 = undefined;

              try {
                for (var _iterator330 = _o95[Symbol.iterator](), _step330; !(_iteratorNormalCompletion330 = (_step330 = _iterator330.next()).done); _iteratorNormalCompletion330 = true) {
                  var _t232 = _step330.value;
                  n ? e.setAttribute(_this193.attributeKey, n, _t232) : e.removeAttribute(_this193.attributeKey, _t232);
                }
              } catch (err) {
                _didIteratorError330 = true;
                _iteratorError330 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion330 && _iterator330.return != null) {
                    _iterator330.return();
                  }
                } finally {
                  if (_didIteratorError330) {
                    throw _iteratorError330;
                  }
                }
              }
            }
          });
        }
      }, {
        key: "_getValueFromFirstAllowedNode",
        value: function _getValueFromFirstAllowedNode() {
          var e = this.editor.model,
              t = e.schema,
              i = e.document.selection;
          if (i.isCollapsed) return i.hasAttribute(this.attributeKey);
          var _iteratorNormalCompletion331 = true;
          var _didIteratorError331 = false;
          var _iteratorError331 = undefined;

          try {
            for (var _iterator331 = i.getRanges()[Symbol.iterator](), _step331; !(_iteratorNormalCompletion331 = (_step331 = _iterator331.next()).done); _iteratorNormalCompletion331 = true) {
              var _e251 = _step331.value;
              var _iteratorNormalCompletion332 = true;
              var _didIteratorError332 = false;
              var _iteratorError332 = undefined;

              try {
                for (var _iterator332 = _e251.getItems()[Symbol.iterator](), _step332; !(_iteratorNormalCompletion332 = (_step332 = _iterator332.next()).done); _iteratorNormalCompletion332 = true) {
                  var _i252 = _step332.value;
                  if (t.checkAttribute(_i252, this.attributeKey)) return _i252.hasAttribute(this.attributeKey);
                }
              } catch (err) {
                _didIteratorError332 = true;
                _iteratorError332 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion332 && _iterator332.return != null) {
                    _iterator332.return();
                  }
                } finally {
                  if (_didIteratorError332) {
                    throw _iteratorError332;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError331 = true;
            _iteratorError331 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion331 && _iterator331.return != null) {
                _iterator331.return();
              }
            } finally {
              if (_didIteratorError331) {
                throw _iteratorError331;
              }
            }
          }

          return !1;
        }
      }]);

      return pg;
    }(Ze);

    var bg =
    /*#__PURE__*/
    function (_Qe21) {
      _inherits(bg, _Qe21);

      function bg() {
        _classCallCheck(this, bg);

        return _possibleConstructorReturn(this, _getPrototypeOf(bg).apply(this, arguments));
      }

      _createClass(bg, [{
        key: "init",
        value: function init() {
          var e = this.editor;
          e.model.schema.extend("$text", {
            allowAttributes: "bold"
          }), e.model.schema.setAttributeProperties("bold", {
            isFormatting: !0,
            copyOnEnter: !0
          }), e.conversion.attributeToElement({
            model: "bold",
            view: "strong",
            upcastAlso: ["b", function (e) {
              var t = e.getStyle("font-weight");
              return t ? "bold" == t || Number(t) >= 600 ? {
                name: !0,
                styles: ["font-weight"]
              } : void 0 : null;
            }]
          }), e.commands.add("bold", new pg(e, "bold")), e.keystrokes.set("CTRL+B", "bold");
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "BoldEditing";
        }
      }]);

      return bg;
    }(Qe);

    var wg =
    /*#__PURE__*/
    function (_Qe22) {
      _inherits(wg, _Qe22);

      function wg() {
        _classCallCheck(this, wg);

        return _possibleConstructorReturn(this, _getPrototypeOf(wg).apply(this, arguments));
      }

      _createClass(wg, [{
        key: "init",
        value: function init() {
          var _this194 = this;

          var e = this.editor,
              t = e.t;
          e.ui.componentFactory.add("bold", function (i) {
            var n = e.commands.get("bold"),
                o = new id(i);
            return o.set({
              label: t("Bold"),
              icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10.187 17H5.773c-.637 0-1.092-.138-1.364-.415-.273-.277-.409-.718-.409-1.323V4.738c0-.617.14-1.062.419-1.332.279-.27.73-.406 1.354-.406h4.68c.69 0 1.288.041 1.793.124.506.083.96.242 1.36.478.341.197.644.447.906.75a3.262 3.262 0 0 1 .808 2.162c0 1.401-.722 2.426-2.167 3.075C15.05 10.175 16 11.315 16 13.01a3.756 3.756 0 0 1-2.296 3.504 6.1 6.1 0 0 1-1.517.377c-.571.073-1.238.11-2 .11zm-.217-6.217H7v4.087h3.069c1.977 0 2.965-.69 2.965-2.072 0-.707-.256-1.22-.768-1.537-.512-.319-1.277-.478-2.296-.478zM7 5.13v3.619h2.606c.729 0 1.292-.067 1.69-.2a1.6 1.6 0 0 0 .91-.765c.165-.267.247-.566.247-.897 0-.707-.26-1.176-.778-1.409-.519-.232-1.31-.348-2.375-.348H7z"/></svg>',
              keystroke: "CTRL+B",
              tooltip: !0,
              isToggleable: !0
            }), o.bind("isOn", "isEnabled").to(n, "value", "isEnabled"), _this194.listenTo(o, "execute", function () {
              e.execute("bold"), e.editing.view.focus();
            }), o;
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "BoldUI";
        }
      }]);

      return wg;
    }(Qe);

    var kg =
    /*#__PURE__*/
    function (_Qe23) {
      _inherits(kg, _Qe23);

      function kg() {
        _classCallCheck(this, kg);

        return _possibleConstructorReturn(this, _getPrototypeOf(kg).apply(this, arguments));
      }

      _createClass(kg, [{
        key: "init",
        value: function init() {
          var e = this.editor;
          e.model.schema.extend("$text", {
            allowAttributes: "italic"
          }), e.model.schema.setAttributeProperties("italic", {
            isFormatting: !0,
            copyOnEnter: !0
          }), e.conversion.attributeToElement({
            model: "italic",
            view: "i",
            upcastAlso: ["em", {
              styles: {
                "font-style": "italic"
              }
            }]
          }), e.commands.add("italic", new pg(e, "italic")), e.keystrokes.set("CTRL+I", "italic");
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "ItalicEditing";
        }
      }]);

      return kg;
    }(Qe);

    var _g =
    /*#__PURE__*/
    function (_Qe24) {
      _inherits(_g, _Qe24);

      function _g() {
        _classCallCheck(this, _g);

        return _possibleConstructorReturn(this, _getPrototypeOf(_g).apply(this, arguments));
      }

      _createClass(_g, [{
        key: "init",
        value: function init() {
          var _this195 = this;

          var e = this.editor,
              t = e.t;
          e.ui.componentFactory.add("italic", function (i) {
            var n = e.commands.get("italic"),
                o = new id(i);
            return o.set({
              label: t("Italic"),
              icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m9.586 14.633.021.004c-.036.335.095.655.393.962.082.083.173.15.274.201h1.474a.6.6 0 1 1 0 1.2H5.304a.6.6 0 0 1 0-1.2h1.15c.474-.07.809-.182 1.005-.334.157-.122.291-.32.404-.597l2.416-9.55a1.053 1.053 0 0 0-.281-.823 1.12 1.12 0 0 0-.442-.296H8.15a.6.6 0 0 1 0-1.2h6.443a.6.6 0 1 1 0 1.2h-1.195c-.376.056-.65.155-.823.296-.215.175-.423.439-.623.79l-2.366 9.347z"/></svg>',
              keystroke: "CTRL+I",
              tooltip: !0,
              isToggleable: !0
            }), o.bind("isOn", "isEnabled").to(n, "value", "isEnabled"), _this195.listenTo(o, "execute", function () {
              e.execute("italic"), e.editing.view.focus();
            }), o;
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "ItalicUI";
        }
      }]);

      return _g;
    }(Qe);

    var vg =
    /*#__PURE__*/
    function (_Ze9) {
      _inherits(vg, _Ze9);

      function vg() {
        _classCallCheck(this, vg);

        return _possibleConstructorReturn(this, _getPrototypeOf(vg).apply(this, arguments));
      }

      _createClass(vg, [{
        key: "refresh",
        value: function refresh() {
          this.value = this._getValue(), this.isEnabled = this._checkEnabled();
        }
      }, {
        key: "execute",
        value: function execute() {
          var _this196 = this;

          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var t = this.editor.model,
              i = t.schema,
              n = t.document.selection,
              o = Array.from(n.getSelectedBlocks()),
              r = void 0 === e.forceValue ? !this.value : e.forceValue;
          t.change(function (e) {
            if (r) {
              var _t233 = o.filter(function (e) {
                return yg(e) || Ag(i, e);
              });

              _this196._applyQuote(e, _t233);
            } else _this196._removeQuote(e, o.filter(yg));
          });
        }
      }, {
        key: "_getValue",
        value: function _getValue() {
          var e = Os(this.editor.model.document.selection.getSelectedBlocks());
          return !(!e || !yg(e));
        }
      }, {
        key: "_checkEnabled",
        value: function _checkEnabled() {
          if (this.value) return !0;
          var e = this.editor.model.document.selection,
              t = this.editor.model.schema,
              i = Os(e.getSelectedBlocks());
          return !!i && Ag(t, i);
        }
      }, {
        key: "_removeQuote",
        value: function _removeQuote(e, t) {
          xg(e, t).reverse().forEach(function (t) {
            if (t.start.isAtStart && t.end.isAtEnd) return void e.unwrap(t.start.parent);

            if (t.start.isAtStart) {
              var _i253 = e.createPositionBefore(t.start.parent);

              return void e.move(t, _i253);
            }

            t.end.isAtEnd || e.split(t.end);
            var i = e.createPositionAfter(t.end.parent);
            e.move(t, i);
          });
        }
      }, {
        key: "_applyQuote",
        value: function _applyQuote(e, t) {
          var i = [];
          xg(e, t).reverse().forEach(function (t) {
            var n = yg(t.start);
            n || (n = e.createElement("blockQuote"), e.wrap(t, n)), i.push(n);
          }), i.reverse().reduce(function (t, i) {
            return t.nextSibling == i ? (e.merge(e.createPositionAfter(t)), t) : i;
          });
        }
      }]);

      return vg;
    }(Ze);

    function yg(e) {
      return "blockQuote" == e.parent.name ? e.parent : null;
    }

    function xg(e, t) {
      var i,
          n = 0;
      var o = [];

      for (; n < t.length;) {
        var _r52 = t[n],
            _s30 = t[n + 1];
        i || (i = e.createPositionBefore(_r52)), _s30 && _r52.nextSibling == _s30 || (o.push(e.createRange(i, e.createPositionAfter(_r52))), i = null), n++;
      }

      return o;
    }

    function Ag(e, t) {
      var i = e.checkChild(t.parent, "blockQuote"),
          n = e.checkChild(["$root", "blockQuote"], t);
      return i && n;
    }

    var Cg =
    /*#__PURE__*/
    function (_Qe25) {
      _inherits(Cg, _Qe25);

      function Cg() {
        _classCallCheck(this, Cg);

        return _possibleConstructorReturn(this, _getPrototypeOf(Cg).apply(this, arguments));
      }

      _createClass(Cg, [{
        key: "init",
        value: function init() {
          var e = this.editor,
              t = e.model.schema;
          e.commands.add("blockQuote", new vg(e)), t.register("blockQuote", {
            allowWhere: "$block",
            allowContentOf: "$root"
          }), e.conversion.elementToElement({
            model: "blockQuote",
            view: "blockquote"
          }), e.model.document.registerPostFixer(function (i) {
            var n = e.model.document.differ.getChanges();
            var _iteratorNormalCompletion333 = true;
            var _didIteratorError333 = false;
            var _iteratorError333 = undefined;

            try {
              for (var _iterator333 = n[Symbol.iterator](), _step333; !(_iteratorNormalCompletion333 = (_step333 = _iterator333.next()).done); _iteratorNormalCompletion333 = true) {
                var _e252 = _step333.value;

                if ("insert" == _e252.type) {
                  var _n152 = _e252.position.nodeAfter;
                  if (!_n152) continue;
                  if (_n152.is("element", "blockQuote") && _n152.isEmpty) return i.remove(_n152), !0;
                  if (_n152.is("element", "blockQuote") && !t.checkChild(_e252.position, _n152)) return i.unwrap(_n152), !0;

                  if (_n152.is("element")) {
                    var _e253 = i.createRangeIn(_n152);

                    var _iteratorNormalCompletion334 = true;
                    var _didIteratorError334 = false;
                    var _iteratorError334 = undefined;

                    try {
                      for (var _iterator334 = _e253.getItems()[Symbol.iterator](), _step334; !(_iteratorNormalCompletion334 = (_step334 = _iterator334.next()).done); _iteratorNormalCompletion334 = true) {
                        var _n153 = _step334.value;
                        if (_n153.is("element", "blockQuote") && !t.checkChild(i.createPositionBefore(_n153), _n153)) return i.unwrap(_n153), !0;
                      }
                    } catch (err) {
                      _didIteratorError334 = true;
                      _iteratorError334 = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion334 && _iterator334.return != null) {
                          _iterator334.return();
                        }
                      } finally {
                        if (_didIteratorError334) {
                          throw _iteratorError334;
                        }
                      }
                    }
                  }
                } else if ("remove" == _e252.type) {
                  var _t234 = _e252.position.parent;
                  if (_t234.is("element", "blockQuote") && _t234.isEmpty) return i.remove(_t234), !0;
                }
              }
            } catch (err) {
              _didIteratorError333 = true;
              _iteratorError333 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion333 && _iterator333.return != null) {
                  _iterator333.return();
                }
              } finally {
                if (_didIteratorError333) {
                  throw _iteratorError333;
                }
              }
            }

            return !1;
          });
          var i = this.editor.editing.view.document,
              n = e.model.document.selection,
              o = e.commands.get("blockQuote");
          this.listenTo(i, "enter", function (t, i) {
            if (!n.isCollapsed || !o.value) return;
            n.getLastPosition().parent.isEmpty && (e.execute("blockQuote"), e.editing.view.scrollToTheSelection(), i.preventDefault(), t.stop());
          }, {
            context: "blockquote"
          }), this.listenTo(i, "delete", function (t, i) {
            if ("backward" != i.direction || !n.isCollapsed || !o.value) return;
            var r = n.getLastPosition().parent;
            r.isEmpty && !r.previousSibling && (e.execute("blockQuote"), e.editing.view.scrollToTheSelection(), i.preventDefault(), t.stop());
          }, {
            context: "blockquote"
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "BlockQuoteEditing";
        }
      }, {
        key: "requires",
        get: function get() {
          return [Eh, Mh];
        }
      }]);

      return Cg;
    }(Qe);

    i(69);

    var Tg =
    /*#__PURE__*/
    function (_Qe26) {
      _inherits(Tg, _Qe26);

      function Tg() {
        _classCallCheck(this, Tg);

        return _possibleConstructorReturn(this, _getPrototypeOf(Tg).apply(this, arguments));
      }

      _createClass(Tg, [{
        key: "init",
        value: function init() {
          var _this197 = this;

          var e = this.editor,
              t = e.t;
          e.ui.componentFactory.add("blockQuote", function (i) {
            var n = e.commands.get("blockQuote"),
                o = new id(i);
            return o.set({
              label: t("Block quote"),
              icon: Sl.quote,
              tooltip: !0,
              isToggleable: !0
            }), o.bind("isOn", "isEnabled").to(n, "value", "isEnabled"), _this197.listenTo(o, "execute", function () {
              e.execute("blockQuote"), e.editing.view.focus();
            }), o;
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "BlockQuoteUI";
        }
      }]);

      return Tg;
    }(Qe);

    var Eg =
    /*#__PURE__*/
    function (_Qe27) {
      _inherits(Eg, _Qe27);

      function Eg() {
        _classCallCheck(this, Eg);

        return _possibleConstructorReturn(this, _getPrototypeOf(Eg).apply(this, arguments));
      }

      _createClass(Eg, [{
        key: "init",
        value: function init() {
          var e = this.editor,
              t = e.ui.componentFactory,
              i = e.t;
          t.add("ckfinder", function (t) {
            var n = e.commands.get("ckfinder"),
                o = new id(t);
            return o.set({
              label: i("Insert image or file"),
              icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11.627 16.5zm5.873-.196zm0-7.001V8h-13v8.5h4.341c.191.54.457 1.044.785 1.5H2a1.5 1.5 0 0 1-1.5-1.5v-13A1.5 1.5 0 0 1 2 2h4.5a1.5 1.5 0 0 1 1.06.44L9.122 4H16a1.5 1.5 0 0 1 1.5 1.5v1A1.5 1.5 0 0 1 19 8v2.531a6.027 6.027 0 0 0-1.5-1.228zM16 6.5v-1H8.5l-2-2H2v13h1V8a1.5 1.5 0 0 1 1.5-1.5H16z"/><path d="M14.5 19.5a5 5 0 1 1 0-10 5 5 0 0 1 0 10zM15 14v-2h-1v2h-2v1h2v2h1v-2h2v-1h-2z"/></svg>',
              tooltip: !0
            }), o.bind("isEnabled").to(n), o.on("execute", function () {
              e.execute("ckfinder"), e.editing.view.focus();
            }), o;
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "CKFinderUI";
        }
      }]);

      return Eg;
    }(Qe);

    var Sg =
    /*#__PURE__*/
    function (_Ze10) {
      _inherits(Sg, _Ze10);

      function Sg(e) {
        var _this198;

        _classCallCheck(this, Sg);

        _this198 = _possibleConstructorReturn(this, _getPrototypeOf(Sg).call(this, e)), _this198.stopListening(_this198.editor.model.document, "change"), _this198.listenTo(_this198.editor.model.document, "change", function () {
          return _this198.refresh();
        }, {
          priority: "low"
        });
        return _this198;
      }

      _createClass(Sg, [{
        key: "refresh",
        value: function refresh() {
          var e = this.editor.commands.get("insertImage"),
              t = this.editor.commands.get("link");
          this.isEnabled = e.isEnabled || t.isEnabled;
        }
      }, {
        key: "execute",
        value: function execute() {
          var e = this.editor,
              t = this.editor.config.get("ckfinder.openerMethod") || "modal";
          if ("popup" != t && "modal" != t) throw new c.a("ckfinder-unknown-openermethod", e);
          var i = this.editor.config.get("ckfinder.options") || {};
          i.chooseFiles = !0;
          var n = i.onInit;
          i.language || (i.language = e.locale.uiLanguage), i.onInit = function (t) {
            n && n(t), t.on("files:choose", function (i) {
              var n = i.data.files.toArray(),
                  o = n.filter(function (e) {
                return !e.isImage();
              }),
                  r = n.filter(function (e) {
                return e.isImage();
              });
              var _iteratorNormalCompletion335 = true;
              var _didIteratorError335 = false;
              var _iteratorError335 = undefined;

              try {
                for (var _iterator335 = o[Symbol.iterator](), _step335; !(_iteratorNormalCompletion335 = (_step335 = _iterator335.next()).done); _iteratorNormalCompletion335 = true) {
                  var _t235 = _step335.value;
                  e.execute("link", _t235.getUrl());
                }
              } catch (err) {
                _didIteratorError335 = true;
                _iteratorError335 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion335 && _iterator335.return != null) {
                    _iterator335.return();
                  }
                } finally {
                  if (_didIteratorError335) {
                    throw _iteratorError335;
                  }
                }
              }

              var s = [];
              var _iteratorNormalCompletion336 = true;
              var _didIteratorError336 = false;
              var _iteratorError336 = undefined;

              try {
                for (var _iterator336 = r[Symbol.iterator](), _step336; !(_iteratorNormalCompletion336 = (_step336 = _iterator336.next()).done); _iteratorNormalCompletion336 = true) {
                  var _e254 = _step336.value;

                  var _i254 = _e254.getUrl();

                  s.push(_i254 || t.request("file:getProxyUrl", {
                    file: _e254
                  }));
                }
              } catch (err) {
                _didIteratorError336 = true;
                _iteratorError336 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion336 && _iterator336.return != null) {
                    _iterator336.return();
                  }
                } finally {
                  if (_didIteratorError336) {
                    throw _iteratorError336;
                  }
                }
              }

              s.length && Ig(e, s);
            }), t.on("file:choose:resizedImage", function (t) {
              var i = t.data.resizedUrl;
              if (i) Ig(e, [i]);else {
                var _t236 = e.plugins.get("Notification"),
                    _i255 = e.locale.t;

                _t236.showWarning(_i255("Could not obtain resized image URL."), {
                  title: _i255("Selecting resized image failed"),
                  namespace: "ckfinder"
                });
              }
            });
          }, window.CKFinder[t](i);
        }
      }]);

      return Sg;
    }(Ze);

    function Ig(e, t) {
      if (e.commands.get("insertImage").isEnabled) e.execute("insertImage", {
        source: t
      });else {
        var _t237 = e.plugins.get("Notification"),
            _i256 = e.locale.t;

        _t237.showWarning(_i256("Could not insert image at the current position."), {
          title: _i256("Inserting image failed"),
          namespace: "ckfinder"
        });
      }
    }

    var Pg =
    /*#__PURE__*/
    function (_Qe28) {
      _inherits(Pg, _Qe28);

      function Pg() {
        _classCallCheck(this, Pg);

        return _possibleConstructorReturn(this, _getPrototypeOf(Pg).apply(this, arguments));
      }

      _createClass(Pg, [{
        key: "init",
        value: function init() {
          var e = this.editor;
          if (!e.plugins.has("ImageBlockEditing") && !e.plugins.has("ImageInlineEditing")) throw new c.a("ckfinder-missing-image-plugin", e);
          e.commands.add("ckfinder", new Sg(e));
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "CKFinderEditing";
        }
      }, {
        key: "requires",
        get: function get() {
          return [Dd, "LinkEditing"];
        }
      }]);

      return Pg;
    }(Qe);

    var Mg =
    /*#__PURE__*/
    function (_Qe29) {
      _inherits(Mg, _Qe29);

      function Mg() {
        _classCallCheck(this, Mg);

        return _possibleConstructorReturn(this, _getPrototypeOf(Mg).apply(this, arguments));
      }

      _createClass(Mg, [{
        key: "init",
        value: function init() {
          var _this199 = this;

          var e = this.editor,
              t = e.plugins.get("CloudServices"),
              i = t.token,
              n = t.uploadUrl;
          i && (this._uploadGateway = e.plugins.get("CloudServicesCore").createUploadGateway(i, n), e.plugins.get(sg).createUploadAdapter = function (e) {
            return new Ng(_this199._uploadGateway, e);
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "CloudServicesUploadAdapter";
        }
      }, {
        key: "requires",
        get: function get() {
          return ["CloudServices", sg];
        }
      }]);

      return Mg;
    }(Qe);

    var Ng =
    /*#__PURE__*/
    function () {
      function Ng(e, t) {
        _classCallCheck(this, Ng);

        this.uploadGateway = e, this.loader = t;
      }

      _createClass(Ng, [{
        key: "upload",
        value: function upload() {
          var _this200 = this;

          return this.loader.file.then(function (e) {
            return _this200.fileUploader = _this200.uploadGateway.upload(e), _this200.fileUploader.on("progress", function (e, t) {
              _this200.loader.uploadTotal = t.total, _this200.loader.uploaded = t.uploaded;
            }), _this200.fileUploader.send();
          });
        }
      }, {
        key: "abort",
        value: function abort() {
          this.fileUploader.abort();
        }
      }]);

      return Ng;
    }();

    var Rg =
    /*#__PURE__*/
    function (_Ze11) {
      _inherits(Rg, _Ze11);

      function Rg() {
        _classCallCheck(this, Rg);

        return _possibleConstructorReturn(this, _getPrototypeOf(Rg).apply(this, arguments));
      }

      _createClass(Rg, [{
        key: "refresh",
        value: function refresh() {
          var e = this.editor.model,
              t = Os(e.document.selection.getSelectedBlocks());
          this.value = !!t && t.is("element", "paragraph"), this.isEnabled = !!t && Og(t, e.schema);
        }
      }, {
        key: "execute",
        value: function execute() {
          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var t = this.editor.model,
              i = t.document;
          t.change(function (n) {
            var o = (e.selection || i.selection).getSelectedBlocks();
            var _iteratorNormalCompletion337 = true;
            var _didIteratorError337 = false;
            var _iteratorError337 = undefined;

            try {
              for (var _iterator337 = o[Symbol.iterator](), _step337; !(_iteratorNormalCompletion337 = (_step337 = _iterator337.next()).done); _iteratorNormalCompletion337 = true) {
                var _e255 = _step337.value;
                !_e255.is("element", "paragraph") && Og(_e255, t.schema) && n.rename(_e255, "paragraph");
              }
            } catch (err) {
              _didIteratorError337 = true;
              _iteratorError337 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion337 && _iterator337.return != null) {
                  _iterator337.return();
                }
              } finally {
                if (_didIteratorError337) {
                  throw _iteratorError337;
                }
              }
            }
          });
        }
      }]);

      return Rg;
    }(Ze);

    function Og(e, t) {
      return t.checkChild(e.parent, "paragraph") && !t.isObject(e);
    }

    var zg =
    /*#__PURE__*/
    function (_Ze12) {
      _inherits(zg, _Ze12);

      function zg() {
        _classCallCheck(this, zg);

        return _possibleConstructorReturn(this, _getPrototypeOf(zg).apply(this, arguments));
      }

      _createClass(zg, [{
        key: "execute",
        value: function execute(e) {
          var t = this.editor.model;
          var i = e.position;
          t.change(function (e) {
            var n = e.createElement("paragraph");

            if (!t.schema.checkChild(i.parent, n)) {
              var _o96 = t.schema.findAllowedParent(i, n);

              if (!_o96) return;
              i = e.split(i, _o96).position;
            }

            t.insertContent(n, i), e.setSelection(n, "in");
          });
        }
      }]);

      return zg;
    }(Ze);

    var Dg =
    /*#__PURE__*/
    function (_Qe30) {
      _inherits(Dg, _Qe30);

      function Dg() {
        _classCallCheck(this, Dg);

        return _possibleConstructorReturn(this, _getPrototypeOf(Dg).apply(this, arguments));
      }

      _createClass(Dg, [{
        key: "init",
        value: function init() {
          var e = this.editor,
              t = e.model;
          e.commands.add("paragraph", new Rg(e)), e.commands.add("insertParagraph", new zg(e)), t.schema.register("paragraph", {
            inheritAllFrom: "$block"
          }), e.conversion.elementToElement({
            model: "paragraph",
            view: "p"
          }), e.conversion.for("upcast").elementToElement({
            model: function model(e, _ref142) {
              var t = _ref142.writer;
              return Dg.paragraphLikeElements.has(e.name) ? e.isEmpty ? null : t.createElement("paragraph") : null;
            },
            view: /.+/,
            converterPriority: "low"
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "Paragraph";
        }
      }]);

      return Dg;
    }(Qe);

    Dg.paragraphLikeElements = new Set(["blockquote", "dd", "div", "dt", "h1", "h2", "h3", "h4", "h5", "h6", "li", "p", "td", "th"]);

    var Lg =
    /*#__PURE__*/
    function (_Ze13) {
      _inherits(Lg, _Ze13);

      function Lg(e, t) {
        var _this201;

        _classCallCheck(this, Lg);

        _this201 = _possibleConstructorReturn(this, _getPrototypeOf(Lg).call(this, e)), _this201.modelElements = t;
        return _this201;
      }

      _createClass(Lg, [{
        key: "refresh",
        value: function refresh() {
          var _this202 = this;

          var e = Os(this.editor.model.document.selection.getSelectedBlocks());
          this.value = !!e && this.modelElements.includes(e.name) && e.name, this.isEnabled = !!e && this.modelElements.some(function (t) {
            return Vg(e, t, _this202.editor.model.schema);
          });
        }
      }, {
        key: "execute",
        value: function execute(e) {
          var t = this.editor.model,
              i = t.document,
              n = e.value;
          t.change(function (e) {
            var o = Array.from(i.selection.getSelectedBlocks()).filter(function (e) {
              return Vg(e, n, t.schema);
            });
            var _iteratorNormalCompletion338 = true;
            var _didIteratorError338 = false;
            var _iteratorError338 = undefined;

            try {
              for (var _iterator338 = o[Symbol.iterator](), _step338; !(_iteratorNormalCompletion338 = (_step338 = _iterator338.next()).done); _iteratorNormalCompletion338 = true) {
                var _t238 = _step338.value;
                _t238.is("element", n) || e.rename(_t238, n);
              }
            } catch (err) {
              _didIteratorError338 = true;
              _iteratorError338 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion338 && _iterator338.return != null) {
                  _iterator338.return();
                }
              } finally {
                if (_didIteratorError338) {
                  throw _iteratorError338;
                }
              }
            }
          });
        }
      }]);

      return Lg;
    }(Ze);

    function Vg(e, t, i) {
      return i.checkChild(e.parent, t) && !i.isObject(e);
    }

    var jg =
    /*#__PURE__*/
    function (_Qe31) {
      _inherits(jg, _Qe31);

      _createClass(jg, null, [{
        key: "pluginName",
        get: function get() {
          return "HeadingEditing";
        }
      }]);

      function jg(e) {
        var _this203;

        _classCallCheck(this, jg);

        _this203 = _possibleConstructorReturn(this, _getPrototypeOf(jg).call(this, e)), e.config.define("heading", {
          options: [{
            model: "paragraph",
            title: "Paragraph",
            class: "ck-heading_paragraph"
          }, {
            model: "heading1",
            view: "h2",
            title: "Heading 1",
            class: "ck-heading_heading1"
          }, {
            model: "heading2",
            view: "h3",
            title: "Heading 2",
            class: "ck-heading_heading2"
          }, {
            model: "heading3",
            view: "h4",
            title: "Heading 3",
            class: "ck-heading_heading3"
          }]
        });
        return _this203;
      }

      _createClass(jg, [{
        key: "init",
        value: function init() {
          var e = this.editor,
              t = e.config.get("heading.options"),
              i = [];
          var _iteratorNormalCompletion339 = true;
          var _didIteratorError339 = false;
          var _iteratorError339 = undefined;

          try {
            for (var _iterator339 = t[Symbol.iterator](), _step339; !(_iteratorNormalCompletion339 = (_step339 = _iterator339.next()).done); _iteratorNormalCompletion339 = true) {
              var _n154 = _step339.value;
              "paragraph" !== _n154.model && (e.model.schema.register(_n154.model, {
                inheritAllFrom: "$block"
              }), e.conversion.elementToElement(_n154), i.push(_n154.model));
            }
          } catch (err) {
            _didIteratorError339 = true;
            _iteratorError339 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion339 && _iterator339.return != null) {
                _iterator339.return();
              }
            } finally {
              if (_didIteratorError339) {
                throw _iteratorError339;
              }
            }
          }

          this._addDefaultH1Conversion(e), e.commands.add("heading", new Lg(e, i));
        }
      }, {
        key: "afterInit",
        value: function afterInit() {
          var e = this.editor,
              t = e.commands.get("enter"),
              i = e.config.get("heading.options");
          t && this.listenTo(t, "afterExecute", function (t, n) {
            var o = e.model.document.selection.getFirstPosition().parent;
            i.some(function (e) {
              return o.is("element", e.model);
            }) && !o.is("element", "paragraph") && 0 === o.childCount && n.writer.rename(o, "paragraph");
          });
        }
      }, {
        key: "_addDefaultH1Conversion",
        value: function _addDefaultH1Conversion(e) {
          e.conversion.for("upcast").elementToElement({
            model: "heading1",
            view: "h1",
            converterPriority: a.get("low") + 1
          });
        }
      }], [{
        key: "requires",
        get: function get() {
          return [Dg];
        }
      }]);

      return jg;
    }(Qe);

    i(13);

    var Bg =
    /*#__PURE__*/
    function (_Qe32) {
      _inherits(Bg, _Qe32);

      function Bg() {
        _classCallCheck(this, Bg);

        return _possibleConstructorReturn(this, _getPrototypeOf(Bg).apply(this, arguments));
      }

      _createClass(Bg, [{
        key: "init",
        value: function init() {
          var _this204 = this;

          var e = this.editor,
              t = e.t,
              i = function (e) {
            var t = e.t,
                i = {
              Paragraph: t("Paragraph"),
              "Heading 1": t("Heading 1"),
              "Heading 2": t("Heading 2"),
              "Heading 3": t("Heading 3"),
              "Heading 4": t("Heading 4"),
              "Heading 5": t("Heading 5"),
              "Heading 6": t("Heading 6")
            };
            return e.config.get("heading.options").map(function (e) {
              var t = i[e.title];
              return t && t != e.title && (e.title = t), e;
            });
          }(e),
              n = t("Choose heading"),
              o = t("Heading");

          e.ui.componentFactory.add("heading", function (t) {
            var r = {},
                s = new Zi(),
                a = e.commands.get("heading"),
                c = e.commands.get("paragraph"),
                l = [a];
            var _iteratorNormalCompletion340 = true;
            var _didIteratorError340 = false;
            var _iteratorError340 = undefined;

            try {
              var _loop6 = function _loop6() {
                var e = _step340.value;
                var t = {
                  type: "button",
                  model: new Ld({
                    label: e.title,
                    class: e.class,
                    withText: !0
                  })
                };
                "paragraph" === e.model ? (t.model.bind("isOn").to(c, "value"), t.model.set("commandName", "paragraph"), l.push(c)) : (t.model.bind("isOn").to(a, "value", function (t) {
                  return t === e.model;
                }), t.model.set({
                  commandName: "heading",
                  commandValue: e.model
                })), s.add(t), r[e.model] = e.title;
              };

              for (var _iterator340 = i[Symbol.iterator](), _step340; !(_iteratorNormalCompletion340 = (_step340 = _iterator340.next()).done); _iteratorNormalCompletion340 = true) {
                _loop6();
              }
            } catch (err) {
              _didIteratorError340 = true;
              _iteratorError340 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion340 && _iterator340.return != null) {
                  _iterator340.return();
                }
              } finally {
                if (_didIteratorError340) {
                  throw _iteratorError340;
                }
              }
            }

            var d = Cd(t);
            return Ed(d, s), d.buttonView.set({
              isOn: !1,
              withText: !0,
              tooltip: o
            }), d.extendTemplate({
              attributes: {
                class: ["ck-heading-dropdown"]
              }
            }), d.bind("isEnabled").toMany(l, "isEnabled", function () {
              for (var _len22 = arguments.length, e = new Array(_len22), _key22 = 0; _key22 < _len22; _key22++) {
                e[_key22] = arguments[_key22];
              }

              return e.some(function (e) {
                return e;
              });
            }), d.buttonView.bind("label").to(a, "value", c, "value", function (e, t) {
              var i = e || t && "paragraph";
              return r[i] ? r[i] : n;
            }), _this204.listenTo(d, "execute", function (t) {
              e.execute(t.source.commandName, t.source.commandValue ? {
                value: t.source.commandValue
              } : void 0), e.editing.view.focus();
            }), d;
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "HeadingUI";
        }
      }]);

      return Bg;
    }(Qe);

    var Fg =
    /*#__PURE__*/
    function (_Qe33) {
      _inherits(Fg, _Qe33);

      function Fg() {
        _classCallCheck(this, Fg);

        return _possibleConstructorReturn(this, _getPrototypeOf(Fg).apply(this, arguments));
      }

      _createClass(Fg, [{
        key: "init",
        value: function init() {
          var _this205 = this;

          var e = this.editor;

          if (e.plugins.has("BalloonToolbar")) {
            var _t239 = e.plugins.get("BalloonToolbar");

            this.listenTo(_t239, "show", function (t) {
              (function (e) {
                var t = e.getSelectedElement();
                return !(!t || !Dh(t));
              })(e.editing.view.document.selection) && t.stop();
            }, {
              priority: "high"
            });
          }

          this._toolbarDefinitions = new Map(), this._balloon = this.editor.plugins.get("ContextualBalloon"), this.on("change:isEnabled", function () {
            _this205._updateToolbarsVisibility();
          }), this.listenTo(e.ui, "update", function () {
            _this205._updateToolbarsVisibility();
          }), this.listenTo(e.ui.focusTracker, "change:isFocused", function () {
            _this205._updateToolbarsVisibility();
          }, {
            priority: "low"
          });
        }
      }, {
        key: "destroy",
        value: function destroy() {
          _get(_getPrototypeOf(Fg.prototype), "destroy", this).call(this);

          var _iteratorNormalCompletion341 = true;
          var _didIteratorError341 = false;
          var _iteratorError341 = undefined;

          try {
            for (var _iterator341 = this._toolbarDefinitions.values()[Symbol.iterator](), _step341; !(_iteratorNormalCompletion341 = (_step341 = _iterator341.next()).done); _iteratorNormalCompletion341 = true) {
              var _e256 = _step341.value;

              _e256.view.destroy();
            }
          } catch (err) {
            _didIteratorError341 = true;
            _iteratorError341 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion341 && _iterator341.return != null) {
                _iterator341.return();
              }
            } finally {
              if (_didIteratorError341) {
                throw _iteratorError341;
              }
            }
          }
        }
      }, {
        key: "register",
        value: function register(e, _ref143) {
          var t = _ref143.ariaLabel,
              i = _ref143.items,
              n = _ref143.getRelatedElement,
              _ref143$balloonClassN = _ref143.balloonClassName,
              o = _ref143$balloonClassN === void 0 ? "ck-toolbar-container" : _ref143$balloonClassN;
          if (!i.length) return void Object(c.b)("widget-toolbar-no-items", {
            toolbarId: e
          });
          var r = this.editor,
              s = r.t,
              a = new wd(r.locale);
          if (a.ariaLabel = t || s("Widget toolbar"), this._toolbarDefinitions.has(e)) throw new c.a("widget-toolbar-duplicated", this, {
            toolbarId: e
          });
          a.fillFromConfig(i, r.ui.componentFactory), this._toolbarDefinitions.set(e, {
            view: a,
            getRelatedElement: n,
            balloonClassName: o
          });
        }
      }, {
        key: "_updateToolbarsVisibility",
        value: function _updateToolbarsVisibility() {
          var e = 0,
              t = null,
              i = null;
          var _iteratorNormalCompletion342 = true;
          var _didIteratorError342 = false;
          var _iteratorError342 = undefined;

          try {
            for (var _iterator342 = this._toolbarDefinitions.values()[Symbol.iterator](), _step342; !(_iteratorNormalCompletion342 = (_step342 = _iterator342.next()).done); _iteratorNormalCompletion342 = true) {
              var _n155 = _step342.value;

              var _o97 = _n155.getRelatedElement(this.editor.editing.view.document.selection);

              if (this.isEnabled && _o97) {
                if (this.editor.ui.focusTracker.isFocused) {
                  var _r53 = _o97.getAncestors().length;

                  _r53 > e && (e = _r53, t = _o97, i = _n155);
                } else this._isToolbarVisible(_n155) && this._hideToolbar(_n155);
              } else this._isToolbarInBalloon(_n155) && this._hideToolbar(_n155);
            }
          } catch (err) {
            _didIteratorError342 = true;
            _iteratorError342 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion342 && _iterator342.return != null) {
                _iterator342.return();
              }
            } finally {
              if (_didIteratorError342) {
                throw _iteratorError342;
              }
            }
          }

          i && this._showToolbar(i, t);
        }
      }, {
        key: "_hideToolbar",
        value: function _hideToolbar(e) {
          this._balloon.remove(e.view), this.stopListening(this._balloon, "change:visibleView");
        }
      }, {
        key: "_showToolbar",
        value: function _showToolbar(e, t) {
          var _this206 = this;

          this._isToolbarVisible(e) ? Hg(this.editor, t) : this._isToolbarInBalloon(e) || (this._balloon.add({
            view: e.view,
            position: Ug(this.editor, t),
            balloonClassName: e.balloonClassName
          }), this.listenTo(this._balloon, "change:visibleView", function () {
            var _iteratorNormalCompletion343 = true;
            var _didIteratorError343 = false;
            var _iteratorError343 = undefined;

            try {
              for (var _iterator343 = _this206._toolbarDefinitions.values()[Symbol.iterator](), _step343; !(_iteratorNormalCompletion343 = (_step343 = _iterator343.next()).done); _iteratorNormalCompletion343 = true) {
                var _e257 = _step343.value;

                if (_this206._isToolbarVisible(_e257)) {
                  var _t240 = _e257.getRelatedElement(_this206.editor.editing.view.document.selection);

                  Hg(_this206.editor, _t240);
                }
              }
            } catch (err) {
              _didIteratorError343 = true;
              _iteratorError343 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion343 && _iterator343.return != null) {
                  _iterator343.return();
                }
              } finally {
                if (_didIteratorError343) {
                  throw _iteratorError343;
                }
              }
            }
          }));
        }
      }, {
        key: "_isToolbarVisible",
        value: function _isToolbarVisible(e) {
          return this._balloon.visibleView === e.view;
        }
      }, {
        key: "_isToolbarInBalloon",
        value: function _isToolbarInBalloon(e) {
          return this._balloon.hasView(e.view);
        }
      }], [{
        key: "requires",
        get: function get() {
          return [qd];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "WidgetToolbarRepository";
        }
      }]);

      return Fg;
    }(Qe);

    function Hg(e, t) {
      var i = e.plugins.get("ContextualBalloon"),
          n = Ug(e, t);
      i.updatePosition(n);
    }

    function Ug(e, t) {
      var i = e.editing.view,
          n = Bd.defaultPositions;
      return {
        target: i.domConverter.mapViewToDom(t),
        positions: [n.northArrowSouth, n.northArrowSouthWest, n.northArrowSouthEast, n.southArrowNorth, n.southArrowNorthWest, n.southArrowNorthEast, Wh]
      };
    }

    var Wg =
    /*#__PURE__*/
    function () {
      function Wg(e) {
        _classCallCheck(this, Wg);

        this.set("activeHandlePosition", null), this.set("proposedWidthPercents", null), this.set("proposedWidth", null), this.set("proposedHeight", null), this.set("proposedHandleHostWidth", null), this.set("proposedHandleHostHeight", null), this._options = e, this._referenceCoordinates = null;
      }

      _createClass(Wg, [{
        key: "begin",
        value: function begin(e, t, i) {
          var n = new Ss(t);
          this.activeHandlePosition = function (e) {
            var t = ["top-left", "top-right", "bottom-right", "bottom-left"];

            for (var _i257 = 0, _t241 = t; _i257 < _t241.length; _i257++) {
              var _i258 = _t241[_i257];
              if (e.classList.contains("ck-widget__resizer__handle-" + _i258)) return _i258;
            }
          }(e), this._referenceCoordinates = function (e, t) {
            var i = new Ss(e),
                n = t.split("-"),
                o = {
              x: "right" == n[1] ? i.right : i.left,
              y: "bottom" == n[0] ? i.bottom : i.top
            };
            return o.x += e.ownerDocument.defaultView.scrollX, o.y += e.ownerDocument.defaultView.scrollY, o;
          }(t, function (e) {
            var t = e.split("-"),
                i = {
              top: "bottom",
              bottom: "top",
              left: "right",
              right: "left"
            };
            return "".concat(i[t[0]], "-").concat(i[t[1]]);
          }(this.activeHandlePosition)), this.originalWidth = n.width, this.originalHeight = n.height, this.aspectRatio = n.width / n.height;
          var o = i.style.width;
          o && o.match(/^\d+(\.\d*)?%$/) ? this.originalWidthPercents = parseFloat(o) : this.originalWidthPercents = function (e, t) {
            var i = e.parentElement,
                n = parseFloat(i.ownerDocument.defaultView.getComputedStyle(i).width);
            return t.width / n * 100;
          }(i, n);
        }
      }, {
        key: "update",
        value: function update(e) {
          this.proposedWidth = e.width, this.proposedHeight = e.height, this.proposedWidthPercents = e.widthPercents, this.proposedHandleHostWidth = e.handleHostWidth, this.proposedHandleHostHeight = e.handleHostHeight;
        }
      }]);

      return Wg;
    }();

    Ke(Wg, Ue);

    var qg =
    /*#__PURE__*/
    function (_Rl25) {
      _inherits(qg, _Rl25);

      function qg() {
        var _this207;

        _classCallCheck(this, qg);

        _this207 = _possibleConstructorReturn(this, _getPrototypeOf(qg).call(this));
        var e = _this207.bindTemplate;

        _this207.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-size-view", e.to("_viewPosition", function (e) {
              return e ? "ck-orientation-" + e : "";
            })],
            style: {
              display: e.if("_isVisible", "none", function (e) {
                return !e;
              })
            }
          },
          children: [{
            text: e.to("_label")
          }]
        });

        return _this207;
      }

      _createClass(qg, [{
        key: "_bindToState",
        value: function _bindToState(e, t) {
          this.bind("_isVisible").to(t, "proposedWidth", t, "proposedHeight", function (e, t) {
            return null !== e && null !== t;
          }), this.bind("_label").to(t, "proposedHandleHostWidth", t, "proposedHandleHostHeight", t, "proposedWidthPercents", function (t, i, n) {
            return "px" === e.unit ? "".concat(t, "\xD7").concat(i) : n + "%";
          }), this.bind("_viewPosition").to(t, "activeHandlePosition", t, "proposedHandleHostWidth", t, "proposedHandleHostHeight", function (e, t, i) {
            return t < 50 || i < 50 ? "above-center" : e;
          });
        }
      }, {
        key: "_dismiss",
        value: function _dismiss() {
          this.unbind(), this._isVisible = !1;
        }
      }]);

      return qg;
    }(Rl);

    var $g =
    /*#__PURE__*/
    function () {
      function $g(e) {
        var _this208 = this;

        _classCallCheck(this, $g);

        this._options = e, this._domResizerWrapper = null, this._viewResizerWrapper = null, this.set("isEnabled", !0), this.decorate("begin"), this.decorate("cancel"), this.decorate("commit"), this.decorate("updateSize"), this.on("commit", function (e) {
          _this208.state.proposedWidth || _this208.state.proposedWidthPercents || (_this208._cleanup(), e.stop());
        }, {
          priority: "high"
        }), this.on("change:isEnabled", function () {
          _this208.isEnabled && _this208.redraw();
        });
      }

      _createClass($g, [{
        key: "attach",
        value: function attach() {
          var _this209 = this;

          var e = this,
              t = this._options.viewElement;

          this._options.editor.editing.view.change(function (i) {
            var n = i.createUIElement("div", {
              class: "ck ck-reset_all ck-widget__resizer"
            }, function (t) {
              var i = this.toDomElement(t);
              return e._appendHandles(i), e._appendSizeUI(i), e._domResizerWrapper = i, e.on("change:isEnabled", function (e, t, n) {
                i.style.display = n ? "" : "none";
              }), i.style.display = e.isEnabled ? "" : "none", i;
            });
            i.insert(i.createPositionAt(t, "end"), n), i.addClass("ck-widget_with-resizer", t), _this209._viewResizerWrapper = n;
          });
        }
      }, {
        key: "begin",
        value: function begin(e) {
          this.state = new Wg(this._options), this._sizeView._bindToState(this._options, this.state), this._initialViewWidth = this._options.viewElement.getStyle("width"), this.state.begin(e, this._getHandleHost(), this._getResizeHost());
        }
      }, {
        key: "updateSize",
        value: function updateSize(e) {
          var _this210 = this;

          var t = this._proposeNewSize(e);

          this._options.editor.editing.view.change(function (e) {
            var i = _this210._options.unit || "%",
                n = ("%" === i ? t.widthPercents : t.width) + i;
            e.setStyle("width", n, _this210._options.viewElement);
          });

          var i = this._getHandleHost(),
              n = new Ss(i);

          t.handleHostWidth = Math.round(n.width), t.handleHostHeight = Math.round(n.height);
          var o = new Ss(i);
          t.width = Math.round(o.width), t.height = Math.round(o.height), this.redraw(n), this.state.update(t);
        }
      }, {
        key: "commit",
        value: function commit() {
          var _this211 = this;

          var e = this._options.unit || "%",
              t = ("%" === e ? this.state.proposedWidthPercents : this.state.proposedWidth) + e;

          this._options.editor.editing.view.change(function () {
            _this211._cleanup(), _this211._options.onCommit(t);
          });
        }
      }, {
        key: "cancel",
        value: function cancel() {
          this._cleanup();
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.cancel();
        }
      }, {
        key: "redraw",
        value: function redraw(e) {
          var t = this._domResizerWrapper;
          if (!((i = t) && i.ownerDocument && i.ownerDocument.contains(i))) return;
          var i;

          var n = t.parentElement,
              o = this._getHandleHost(),
              r = this._viewResizerWrapper,
              s = [r.getStyle("width"), r.getStyle("height"), r.getStyle("left"), r.getStyle("top")];

          var a;

          if (n.isSameNode(o)) {
            var _t242 = e || new Ss(o);

            a = [_t242.width + "px", _t242.height + "px", void 0, void 0];
          } else a = [o.offsetWidth + "px", o.offsetHeight + "px", o.offsetLeft + "px", o.offsetTop + "px"];

          "same" !== cn(s, a) && this._options.editor.editing.view.change(function (e) {
            e.setStyle({
              width: a[0],
              height: a[1],
              left: a[2],
              top: a[3]
            }, r);
          });
        }
      }, {
        key: "containsHandle",
        value: function containsHandle(e) {
          return this._domResizerWrapper.contains(e);
        }
      }, {
        key: "_cleanup",
        value: function _cleanup() {
          var _this212 = this;

          this._sizeView._dismiss();

          this._options.editor.editing.view.change(function (e) {
            e.setStyle("width", _this212._initialViewWidth, _this212._options.viewElement);
          });
        }
      }, {
        key: "_proposeNewSize",
        value: function _proposeNewSize(e) {
          var t = this.state,
              i = {
            x: (n = e).pageX,
            y: n.pageY
          };
          var n;

          var o = !this._options.isCentered || this._options.isCentered(this),
              r = {
            x: t._referenceCoordinates.x - (i.x + t.originalWidth),
            y: i.y - t.originalHeight - t._referenceCoordinates.y
          };

          o && t.activeHandlePosition.endsWith("-right") && (r.x = i.x - (t._referenceCoordinates.x + t.originalWidth)), o && (r.x *= 2);
          var s = {
            width: Math.abs(t.originalWidth + r.x),
            height: Math.abs(t.originalHeight + r.y)
          };
          s.dominant = s.width / t.aspectRatio > s.height ? "width" : "height", s.max = s[s.dominant];
          var a = {
            width: s.width,
            height: s.height
          };
          return "width" == s.dominant ? a.height = a.width / t.aspectRatio : a.width = a.height * t.aspectRatio, {
            width: Math.round(a.width),
            height: Math.round(a.height),
            widthPercents: Math.min(Math.round(t.originalWidthPercents / t.originalWidth * a.width * 100) / 100, 100)
          };
        }
      }, {
        key: "_getResizeHost",
        value: function _getResizeHost() {
          var e = this._domResizerWrapper.parentElement;
          return this._options.getResizeHost(e);
        }
      }, {
        key: "_getHandleHost",
        value: function _getHandleHost() {
          var e = this._domResizerWrapper.parentElement;
          return this._options.getHandleHost(e);
        }
      }, {
        key: "_appendHandles",
        value: function _appendHandles(e) {
          var t = ["top-left", "top-right", "bottom-right", "bottom-left"];

          for (var _i259 = 0, _t243 = t; _i259 < _t243.length; _i259++) {
            var _n156 = _t243[_i259];
            e.appendChild(new Ol({
              tag: "div",
              attributes: {
                class: "ck-widget__resizer__handle " + (i = _n156, "ck-widget__resizer__handle-" + i)
              }
            }).render());
          }

          var i;
        }
      }, {
        key: "_appendSizeUI",
        value: function _appendSizeUI(e) {
          this._sizeView = new qg(), this._sizeView.render(), e.appendChild(this._sizeView.element);
        }
      }], [{
        key: "isResizeHandle",
        value: function isResizeHandle(e) {
          return e.classList.contains("ck-widget__resizer__handle");
        }
      }]);

      return $g;
    }();

    Ke($g, Ue);
    i(72);
    Ke(
    /*#__PURE__*/
    function (_Qe34) {
      _inherits(_class2, _Qe34);

      function _class2() {
        _classCallCheck(this, _class2);

        return _possibleConstructorReturn(this, _getPrototypeOf(_class2).apply(this, arguments));
      }

      _createClass(_class2, [{
        key: "init",
        value: function init() {
          var _this213 = this;

          this.set("visibleResizer", null), this.set("_activeResizer", null), this._resizers = new Map();
          var e = vr.window.document;
          this.editor.editing.view.addObserver(mh), this._observer = Object.create(Nr), this.listenTo(this.editor.editing.view.document, "mousedown", this._mouseDownListener.bind(this), {
            priority: "high"
          }), this._observer.listenTo(e, "mousemove", this._mouseMoveListener.bind(this)), this._observer.listenTo(e, "mouseup", this._mouseUpListener.bind(this));

          var t = function t() {
            _this213.visibleResizer && _this213.visibleResizer.redraw();
          };

          this._redrawFocusedResizerThrottled = ou(t, 200), this.on("change:visibleResizer", t), this.editor.ui.on("update", this._redrawFocusedResizerThrottled), this._observer.listenTo(vr.window, "resize", this._redrawFocusedResizerThrottled);
          var i = this.editor.editing.view.document.selection;
          i.on("change", function () {
            var e = i.getSelectedElement();
            _this213.visibleResizer = _this213.getResizerByViewElement(e) || null;
          });
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this._observer.stopListening();

          var _iteratorNormalCompletion344 = true;
          var _didIteratorError344 = false;
          var _iteratorError344 = undefined;

          try {
            for (var _iterator344 = this._resizers.values()[Symbol.iterator](), _step344; !(_iteratorNormalCompletion344 = (_step344 = _iterator344.next()).done); _iteratorNormalCompletion344 = true) {
              var _e258 = _step344.value;

              _e258.destroy();
            }
          } catch (err) {
            _didIteratorError344 = true;
            _iteratorError344 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion344 && _iterator344.return != null) {
                _iterator344.return();
              }
            } finally {
              if (_didIteratorError344) {
                throw _iteratorError344;
              }
            }
          }

          this._redrawFocusedResizerThrottled.cancel();
        }
      }, {
        key: "attachTo",
        value: function attachTo(e) {
          var t = new $g(e),
              i = this.editor.plugins;

          if (t.attach(), i.has("WidgetToolbarRepository")) {
            var _e259 = i.get("WidgetToolbarRepository");

            t.on("begin", function () {
              _e259.forceDisabled("resize");
            }, {
              priority: "lowest"
            }), t.on("cancel", function () {
              _e259.clearForceDisabled("resize");
            }, {
              priority: "highest"
            }), t.on("commit", function () {
              _e259.clearForceDisabled("resize");
            }, {
              priority: "highest"
            });
          }

          this._resizers.set(e.viewElement, t);

          var n = this.editor.editing.view.document.selection.getSelectedElement();
          return this.getResizerByViewElement(n) == t && (this.visibleResizer = t), t;
        }
      }, {
        key: "getResizerByViewElement",
        value: function getResizerByViewElement(e) {
          return this._resizers.get(e);
        }
      }, {
        key: "_getResizerByHandle",
        value: function _getResizerByHandle(e) {
          var _iteratorNormalCompletion345 = true;
          var _didIteratorError345 = false;
          var _iteratorError345 = undefined;

          try {
            for (var _iterator345 = this._resizers.values()[Symbol.iterator](), _step345; !(_iteratorNormalCompletion345 = (_step345 = _iterator345.next()).done); _iteratorNormalCompletion345 = true) {
              var _t244 = _step345.value;
              if (_t244.containsHandle(e)) return _t244;
            }
          } catch (err) {
            _didIteratorError345 = true;
            _iteratorError345 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion345 && _iterator345.return != null) {
                _iterator345.return();
              }
            } finally {
              if (_didIteratorError345) {
                throw _iteratorError345;
              }
            }
          }
        }
      }, {
        key: "_mouseDownListener",
        value: function _mouseDownListener(e, t) {
          var i = t.domTarget;
          $g.isResizeHandle(i) && (this._activeResizer = this._getResizerByHandle(i), this._activeResizer && (this._activeResizer.begin(i), e.stop(), t.preventDefault()));
        }
      }, {
        key: "_mouseMoveListener",
        value: function _mouseMoveListener(e, t) {
          this._activeResizer && this._activeResizer.updateSize(t);
        }
      }, {
        key: "_mouseUpListener",
        value: function _mouseUpListener() {
          this._activeResizer && (this._activeResizer.commit(), this._activeResizer = null);
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "WidgetResize";
        }
      }]);

      return _class2;
    }(Qe), Ue);

    var Yg =
    /*#__PURE__*/
    function (_Ze14) {
      _inherits(Yg, _Ze14);

      function Yg() {
        _classCallCheck(this, Yg);

        return _possibleConstructorReturn(this, _getPrototypeOf(Yg).apply(this, arguments));
      }

      _createClass(Yg, [{
        key: "refresh",
        value: function refresh() {
          var e = this.editor.plugins.get("ImageUtils").getClosestSelectedImageElement(this.editor.model.document.selection);
          this.isEnabled = !!e, this.isEnabled && e.hasAttribute("alt") ? this.value = e.getAttribute("alt") : this.value = !1;
        }
      }, {
        key: "execute",
        value: function execute(e) {
          var t = this.editor,
              i = t.plugins.get("ImageUtils"),
              n = t.model,
              o = i.getClosestSelectedImageElement(n.document.selection);
          n.change(function (t) {
            t.setAttribute("alt", e.newValue, o);
          });
        }
      }]);

      return Yg;
    }(Ze);

    function Gg(e, t) {
      var i = e.createEmptyElement("img"),
          n = "imageBlock" === t ? e.createContainerElement("figure", {
        class: "image"
      }) : e.createContainerElement("span", {
        class: "image-inline"
      }, {
        isAllowedInsideAttributeElement: !0
      });
      return e.insert(e.createPositionAt(n, 0), i), n;
    }

    function Kg(e, t) {
      if (e.plugins.has("ImageInlineEditing") !== e.plugins.has("ImageBlockEditing")) return {
        name: "img",
        attributes: {
          src: !0
        }
      };
      var i = e.plugins.get("ImageUtils");
      return function (e) {
        if (!i.isInlineImageView(e) || !e.hasAttribute("src")) return null;
        return (e.findAncestor(i.isBlockImageView) ? "imageBlock" : "imageInline") !== t ? null : {
          name: !0,
          attributes: ["src"]
        };
      };
    }

    function Qg(e, t) {
      var i = Os(t.getSelectedBlocks());
      return !i || e.isObject(i) || i.isEmpty && "listItem" != i.name ? "imageBlock" : "imageInline";
    }

    var Jg =
    /*#__PURE__*/
    function (_Qe35) {
      _inherits(Jg, _Qe35);

      function Jg() {
        _classCallCheck(this, Jg);

        return _possibleConstructorReturn(this, _getPrototypeOf(Jg).apply(this, arguments));
      }

      _createClass(Jg, [{
        key: "isImage",
        value: function isImage(e) {
          return this.isInlineImage(e) || this.isBlockImage(e);
        }
      }, {
        key: "isInlineImageView",
        value: function isInlineImageView(e) {
          return !!e && e.is("element", "img");
        }
      }, {
        key: "isBlockImageView",
        value: function isBlockImageView(e) {
          return !!e && e.is("element", "figure") && e.hasClass("image");
        }
      }, {
        key: "insertImage",
        value: function insertImage() {
          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
          var n = this.editor,
              o = n.model,
              r = o.document.selection;
          i = Zg(n, t || r, i), e = _objectSpread({}, Object.fromEntries(r.getAttributes()), {}, e);

          for (var _t245 in e) {
            o.schema.checkAttribute(i, _t245) || delete e[_t245];
          }

          return o.change(function (n) {
            var s = n.createElement(i, e);
            return t || "imageInline" == i || (t = Uh(r, o)), o.insertContent(s, t), s.parent ? (n.setSelection(s, "on"), s) : null;
          });
        }
      }, {
        key: "getClosestSelectedImageWidget",
        value: function getClosestSelectedImageWidget(e) {
          var t = e.getSelectedElement();
          if (t && this.isImageWidget(t)) return t;
          var i = e.getFirstPosition().parent;

          for (; i;) {
            if (i.is("element") && this.isImageWidget(i)) return i;
            i = i.parent;
          }

          return null;
        }
      }, {
        key: "getClosestSelectedImageElement",
        value: function getClosestSelectedImageElement(e) {
          var t = e.getSelectedElement();
          return this.isImage(t) ? t : e.getFirstPosition().findAncestor("imageBlock");
        }
      }, {
        key: "isImageAllowed",
        value: function isImageAllowed() {
          var e = this.editor.model.document.selection;
          return function (e, t) {
            if ("imageBlock" == Zg(e, t)) {
              var _i260 = function (e, t) {
                var i = Uh(e, t).start.parent;
                if (i.isEmpty && !i.is("element", "$root")) return i.parent;
                return i;
              }(t, e.model);

              if (e.model.schema.checkChild(_i260, "imageBlock")) return !0;
            } else if (e.model.schema.checkChild(t.focus, "imageInline")) return !0;

            return !1;
          }(this.editor, e) && function (e) {
            return _toConsumableArray(e.focus.getAncestors()).every(function (e) {
              return !e.is("element", "imageBlock");
            });
          }(e);
        }
      }, {
        key: "toImageWidget",
        value: function toImageWidget(e, t, i) {
          var _this214 = this;

          t.setCustomProperty("image", !0, e);
          return Lh(e, t, {
            label: function label() {
              var t = _this214.getViewImageFromWidget(e).getAttribute("alt");

              return t ? "".concat(t, " ").concat(i) : i;
            }
          });
        }
      }, {
        key: "isImageWidget",
        value: function isImageWidget(e) {
          return !!e.getCustomProperty("image") && Dh(e);
        }
      }, {
        key: "isBlockImage",
        value: function isBlockImage(e) {
          return !!e && e.is("element", "imageBlock");
        }
      }, {
        key: "isInlineImage",
        value: function isInlineImage(e) {
          return !!e && e.is("element", "imageInline");
        }
      }, {
        key: "getViewImageFromWidget",
        value: function getViewImageFromWidget(e) {
          if (this.isInlineImageView(e)) return e;
          var t = [];
          var _iteratorNormalCompletion346 = true;
          var _didIteratorError346 = false;
          var _iteratorError346 = undefined;

          try {
            for (var _iterator346 = e.getChildren()[Symbol.iterator](), _step346; !(_iteratorNormalCompletion346 = (_step346 = _iterator346.next()).done); _iteratorNormalCompletion346 = true) {
              var _i261 = _step346.value;
              t.push(_i261), _i261.is("element") && t.push.apply(t, _toConsumableArray(_i261.getChildren()));
            }
          } catch (err) {
            _didIteratorError346 = true;
            _iteratorError346 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion346 && _iterator346.return != null) {
                _iterator346.return();
              }
            } finally {
              if (_didIteratorError346) {
                throw _iteratorError346;
              }
            }
          }

          return t.find(this.isInlineImageView);
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "ImageUtils";
        }
      }]);

      return Jg;
    }(Qe);

    function Zg(e, t, i) {
      var n = e.model.schema,
          o = e.config.get("image.insert.type");
      return e.plugins.has("ImageBlockEditing") ? e.plugins.has("ImageInlineEditing") ? i || ("inline" === o ? "imageInline" : "block" === o ? "imageBlock" : t.is("selection") ? Qg(n, t) : n.checkChild(t, "imageInline") ? "imageInline" : "imageBlock") : "imageBlock" : "imageInline";
    }

    var Xg =
    /*#__PURE__*/
    function (_Qe36) {
      _inherits(Xg, _Qe36);

      function Xg() {
        _classCallCheck(this, Xg);

        return _possibleConstructorReturn(this, _getPrototypeOf(Xg).apply(this, arguments));
      }

      _createClass(Xg, [{
        key: "init",
        value: function init() {
          this.editor.commands.add("imageTextAlternative", new Yg(this.editor));
        }
      }], [{
        key: "requires",
        get: function get() {
          return [Jg];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "ImageTextAlternativeEditing";
        }
      }]);

      return Xg;
    }(Qe);

    i(74), i(7);

    var em =
    /*#__PURE__*/
    function (_Rl26) {
      _inherits(em, _Rl26);

      function em(e) {
        var _this215;

        _classCallCheck(this, em);

        _this215 = _possibleConstructorReturn(this, _getPrototypeOf(em).call(this, e));
        var t = _this215.locale.t;
        _this215.focusTracker = new zs(), _this215.keystrokes = new Ds(), _this215.labeledInput = _this215._createLabeledInputView(), _this215.saveButtonView = _this215._createButton(t("Save"), Sl.check, "ck-button-save"), _this215.saveButtonView.type = "submit", _this215.cancelButtonView = _this215._createButton(t("Cancel"), Sl.cancel, "ck-button-cancel", "cancel"), _this215._focusables = new Nl(), _this215._focusCycler = new od({
          focusables: _this215._focusables,
          focusTracker: _this215.focusTracker,
          keystrokeHandler: _this215.keystrokes,
          actions: {
            focusPrevious: "shift + tab",
            focusNext: "tab"
          }
        }), _this215.setTemplate({
          tag: "form",
          attributes: {
            class: ["ck", "ck-text-alternative-form", "ck-responsive-form"],
            tabindex: "-1"
          },
          children: [_this215.labeledInput, _this215.saveButtonView, _this215.cancelButtonView]
        }), Pl(_assertThisInitialized(_this215));
        return _this215;
      }

      _createClass(em, [{
        key: "render",
        value: function render() {
          var _this216 = this;

          _get(_getPrototypeOf(em.prototype), "render", this).call(this), this.keystrokes.listenTo(this.element), Ml({
            view: this
          }), [this.labeledInput, this.saveButtonView, this.cancelButtonView].forEach(function (e) {
            _this216._focusables.add(e), _this216.focusTracker.add(e.element);
          });
        }
      }, {
        key: "_createButton",
        value: function _createButton(e, t, i, n) {
          var o = new id(this.locale);
          return o.set({
            label: e,
            icon: t,
            tooltip: !0
          }), o.extendTemplate({
            attributes: {
              class: i
            }
          }), n && o.delegate("execute").to(this, n), o;
        }
      }, {
        key: "_createLabeledInputView",
        value: function _createLabeledInputView() {
          var e = this.locale.t,
              t = new Od(this.locale, zd);
          return t.label = e("Text alternative"), t;
        }
      }]);

      return em;
    }(Rl);

    function tm(e) {
      var t = e.editing.view,
          i = Bd.defaultPositions,
          n = e.plugins.get("ImageUtils");
      return {
        target: t.domConverter.viewToDom(n.getClosestSelectedImageWidget(t.document.selection)),
        positions: [i.northArrowSouth, i.northArrowSouthWest, i.northArrowSouthEast, i.southArrowNorth, i.southArrowNorthWest, i.southArrowNorthEast]
      };
    }

    var im =
    /*#__PURE__*/
    function (_Qe37) {
      _inherits(im, _Qe37);

      function im() {
        _classCallCheck(this, im);

        return _possibleConstructorReturn(this, _getPrototypeOf(im).apply(this, arguments));
      }

      _createClass(im, [{
        key: "init",
        value: function init() {
          this._createButton(), this._createForm();
        }
      }, {
        key: "destroy",
        value: function destroy() {
          _get(_getPrototypeOf(im.prototype), "destroy", this).call(this), this._form.destroy();
        }
      }, {
        key: "_createButton",
        value: function _createButton() {
          var _this217 = this;

          var e = this.editor,
              t = e.t;
          e.ui.componentFactory.add("imageTextAlternative", function (i) {
            var n = e.commands.get("imageTextAlternative"),
                o = new id(i);
            return o.set({
              label: t("Change image text alternative"),
              icon: Sl.lowVision,
              tooltip: !0
            }), o.bind("isEnabled").to(n, "isEnabled"), _this217.listenTo(o, "execute", function () {
              _this217._showForm();
            }), o;
          });
        }
      }, {
        key: "_createForm",
        value: function _createForm() {
          var _this218 = this;

          var e = this.editor,
              t = e.editing.view.document,
              i = e.plugins.get("ImageUtils");
          this._balloon = this.editor.plugins.get("ContextualBalloon"), this._form = new em(e.locale), this._form.render(), this.listenTo(this._form, "submit", function () {
            e.execute("imageTextAlternative", {
              newValue: _this218._form.labeledInput.fieldView.element.value
            }), _this218._hideForm(!0);
          }), this.listenTo(this._form, "cancel", function () {
            _this218._hideForm(!0);
          }), this._form.keystrokes.set("Esc", function (e, t) {
            _this218._hideForm(!0), t();
          }), this.listenTo(e.ui, "update", function () {
            i.getClosestSelectedImageWidget(t.selection) ? _this218._isVisible && function (e) {
              var t = e.plugins.get("ContextualBalloon");

              if (e.plugins.get("ImageUtils").getClosestSelectedImageWidget(e.editing.view.document.selection)) {
                var _i262 = tm(e);

                t.updatePosition(_i262);
              }
            }(e) : _this218._hideForm(!0);
          }), Il({
            emitter: this._form,
            activator: function activator() {
              return _this218._isVisible;
            },
            contextElements: [this._balloon.view.element],
            callback: function callback() {
              return _this218._hideForm();
            }
          });
        }
      }, {
        key: "_showForm",
        value: function _showForm() {
          if (this._isVisible) return;
          var e = this.editor,
              t = e.commands.get("imageTextAlternative"),
              i = this._form.labeledInput;
          this._form.disableCssTransitions(), this._isInBalloon || this._balloon.add({
            view: this._form,
            position: tm(e)
          }), i.fieldView.value = i.fieldView.element.value = t.value || "", this._form.labeledInput.fieldView.select(), this._form.enableCssTransitions();
        }
      }, {
        key: "_hideForm",
        value: function _hideForm(e) {
          this._isInBalloon && (this._form.focusTracker.isFocused && this._form.saveButtonView.focus(), this._balloon.remove(this._form), e && this.editor.editing.view.focus());
        }
      }, {
        key: "_isVisible",
        get: function get() {
          return this._balloon.visibleView === this._form;
        }
      }, {
        key: "_isInBalloon",
        get: function get() {
          return this._balloon.hasView(this._form);
        }
      }], [{
        key: "requires",
        get: function get() {
          return [qd];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "ImageTextAlternativeUI";
        }
      }]);

      return im;
    }(Qe);

    var nm =
    /*#__PURE__*/
    function (_Qe38) {
      _inherits(nm, _Qe38);

      function nm() {
        _classCallCheck(this, nm);

        return _possibleConstructorReturn(this, _getPrototypeOf(nm).apply(this, arguments));
      }

      _createClass(nm, null, [{
        key: "requires",
        get: function get() {
          return [Xg, im];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "ImageTextAlternative";
        }
      }]);

      return nm;
    }(Qe);

    function om(e, t) {
      return function (e) {
        e.on("attribute:srcset:" + t, i);
      };

      function i(t, i, n) {
        if (!n.consumable.consume(i.item, t.name)) return;
        var o = n.writer,
            r = n.mapper.toViewElement(i.item),
            s = e.getViewImageFromWidget(r);

        if (null === i.attributeNewValue) {
          var _e260 = i.attributeOldValue;
          _e260.data && (o.removeAttribute("srcset", s), o.removeAttribute("sizes", s), _e260.width && o.removeAttribute("width", s));
        } else {
          var _e261 = i.attributeNewValue;
          _e261.data && (o.setAttribute("srcset", _e261.data, s), o.setAttribute("sizes", "100vw", s), _e261.width && o.setAttribute("width", _e261.width, s));
        }
      }
    }

    function rm(e, t, i) {
      return function (e) {
        e.on("attribute:".concat(i, ":").concat(t), n);
      };

      function n(t, i, n) {
        if (!n.consumable.consume(i.item, t.name)) return;
        var o = n.writer,
            r = n.mapper.toViewElement(i.item),
            s = e.getViewImageFromWidget(r);
        o.setAttribute(i.attributeKey, i.attributeNewValue || "", s);
      }
    }

    var sm =
    /*#__PURE__*/
    function (_zr8) {
      _inherits(sm, _zr8);

      function sm() {
        _classCallCheck(this, sm);

        return _possibleConstructorReturn(this, _getPrototypeOf(sm).apply(this, arguments));
      }

      _createClass(sm, [{
        key: "observe",
        value: function observe(e) {
          var _this219 = this;

          this.listenTo(e, "load", function (e, t) {
            var i = t.target;
            _this219.checkShouldIgnoreEventFromTarget(i) || "IMG" == i.tagName && _this219._fireEvents(t);
          }, {
            useCapture: !0
          });
        }
      }, {
        key: "_fireEvents",
        value: function _fireEvents(e) {
          this.isEnabled && (this.document.fire("layoutChanged"), this.document.fire("imageLoaded", e));
        }
      }]);

      return sm;
    }(zr);

    var am =
    /*#__PURE__*/
    function (_Ze15) {
      _inherits(am, _Ze15);

      function am(e) {
        var _this220;

        _classCallCheck(this, am);

        _this220 = _possibleConstructorReturn(this, _getPrototypeOf(am).call(this, e));
        var t = e.config.get("image.insert.type");
        e.plugins.has("ImageBlockEditing") || "block" === t && Object(c.b)("image-block-plugin-required"), e.plugins.has("ImageInlineEditing") || "inline" === t && Object(c.b)("image-inline-plugin-required");
        return _this220;
      }

      _createClass(am, [{
        key: "refresh",
        value: function refresh() {
          this.isEnabled = this.editor.plugins.get("ImageUtils").isImageAllowed();
        }
      }, {
        key: "execute",
        value: function execute(e) {
          var _this221 = this;

          var t = en(e.source),
              i = this.editor.model.document.selection,
              n = this.editor.plugins.get("ImageUtils"),
              o = Object.fromEntries(i.getAttributes());
          t.forEach(function (e, t) {
            var r = i.getSelectedElement();

            if (t && r && n.isImage(r)) {
              var _t246 = _this221.editor.model.createPositionAfter(r);

              n.insertImage(_objectSpread({
                src: e
              }, o), _t246);
            } else n.insertImage(_objectSpread({
              src: e
            }, o));
          });
        }
      }]);

      return am;
    }(Ze);

    var cm =
    /*#__PURE__*/
    function (_Qe39) {
      _inherits(cm, _Qe39);

      function cm() {
        _classCallCheck(this, cm);

        return _possibleConstructorReturn(this, _getPrototypeOf(cm).apply(this, arguments));
      }

      _createClass(cm, [{
        key: "init",
        value: function init() {
          var e = this.editor,
              t = e.conversion;
          e.editing.view.addObserver(sm), t.for("upcast").attributeToAttribute({
            view: {
              name: "img",
              key: "alt"
            },
            model: "alt"
          }).attributeToAttribute({
            view: {
              name: "img",
              key: "srcset"
            },
            model: {
              key: "srcset",
              value: function value(e) {
                var t = {
                  data: e.getAttribute("srcset")
                };
                return e.hasAttribute("width") && (t.width = e.getAttribute("width")), t;
              }
            }
          });
          var i = new am(e);
          e.commands.add("insertImage", i), e.commands.add("imageInsert", i);
        }
      }], [{
        key: "requires",
        get: function get() {
          return [Jg];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "ImageEditing";
        }
      }]);

      return cm;
    }(Qe);

    var lm =
    /*#__PURE__*/
    function (_Ze16) {
      _inherits(lm, _Ze16);

      function lm(e, t) {
        var _this222;

        _classCallCheck(this, lm);

        _this222 = _possibleConstructorReturn(this, _getPrototypeOf(lm).call(this, e)), _this222._modelElementName = t;
        return _this222;
      }

      _createClass(lm, [{
        key: "refresh",
        value: function refresh() {
          var e = this.editor.plugins.get("ImageUtils"),
              t = e.getClosestSelectedImageElement(this.editor.model.document.selection);
          "imageBlock" === this._modelElementName ? this.isEnabled = e.isInlineImage(t) : this.isEnabled = e.isBlockImage(t);
        }
      }, {
        key: "execute",
        value: function execute() {
          var _this223 = this;

          var e = this.editor,
              t = this.editor.model,
              i = e.plugins.get("ImageUtils"),
              n = i.getClosestSelectedImageElement(t.document.selection),
              o = Object.fromEntries(n.getAttributes());
          return o.src || o.uploadId ? t.change(function (e) {
            var r = Array.from(t.markers).filter(function (e) {
              return e.getRange().containsItem(n);
            }),
                s = i.insertImage(o, t.createSelection(n, "on"), _this223._modelElementName);
            if (!s) return null;
            var a = e.createRangeOn(s);
            var _iteratorNormalCompletion347 = true;
            var _didIteratorError347 = false;
            var _iteratorError347 = undefined;

            try {
              for (var _iterator347 = r[Symbol.iterator](), _step347; !(_iteratorNormalCompletion347 = (_step347 = _iterator347.next()).done); _iteratorNormalCompletion347 = true) {
                var _t247 = _step347.value;

                var _i263 = _t247.getRange(),
                    _n157 = "$graveyard" != _i263.root.rootName ? _i263.getJoined(a, !0) : a;

                e.updateMarker(_t247, {
                  range: _n157
                });
              }
            } catch (err) {
              _didIteratorError347 = true;
              _iteratorError347 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion347 && _iterator347.return != null) {
                  _iterator347.return();
                }
              } finally {
                if (_didIteratorError347) {
                  throw _iteratorError347;
                }
              }
            }

            return {
              oldElement: n,
              newElement: s
            };
          }) : null;
        }
      }]);

      return lm;
    }(Ze);

    var dm =
    /*#__PURE__*/
    function (_Qe40) {
      _inherits(dm, _Qe40);

      function dm() {
        _classCallCheck(this, dm);

        return _possibleConstructorReturn(this, _getPrototypeOf(dm).apply(this, arguments));
      }

      _createClass(dm, [{
        key: "init",
        value: function init() {
          var e = this.editor;
          e.model.schema.register("imageBlock", {
            isObject: !0,
            isBlock: !0,
            allowWhere: "$block",
            allowAttributes: ["alt", "src", "srcset"]
          }), this._setupConversion(), e.plugins.has("ImageInlineEditing") && (e.commands.add("imageTypeBlock", new lm(this.editor, "imageBlock")), this._setupClipboardIntegration());
        }
      }, {
        key: "_setupConversion",
        value: function _setupConversion() {
          var e = this.editor,
              t = e.t,
              i = e.conversion,
              n = e.plugins.get("ImageUtils");
          i.for("dataDowncast").elementToElement({
            model: "imageBlock",
            view: function view(e, _ref144) {
              var t = _ref144.writer;
              return Gg(t, "imageBlock");
            }
          }), i.for("editingDowncast").elementToElement({
            model: "imageBlock",
            view: function view(e, _ref145) {
              var i = _ref145.writer;
              return n.toImageWidget(Gg(i, "imageBlock"), i, t("image widget"));
            }
          }), i.for("downcast").add(rm(n, "imageBlock", "src")).add(rm(n, "imageBlock", "alt")).add(om(n, "imageBlock")), i.for("upcast").elementToElement({
            view: Kg(e, "imageBlock"),
            model: function model(e, _ref146) {
              var t = _ref146.writer;
              return t.createElement("imageBlock", {
                src: e.getAttribute("src")
              });
            }
          }).add(function (e) {
            return function (e) {
              e.on("element:figure", t);
            };

            function t(t, i, n) {
              if (!n.consumable.test(i.viewItem, {
                name: !0,
                classes: "image"
              })) return;
              var o = e.getViewImageFromWidget(i.viewItem);
              if (!o || !o.hasAttribute("src") || !n.consumable.test(o, {
                name: !0
              })) return;
              var r = Os(n.convertItem(o, i.modelCursor).modelRange.getItems());
              r && (n.convertChildren(i.viewItem, r), n.updateConversionResult(r, i));
            }
          }(n));
        }
      }, {
        key: "_setupClipboardIntegration",
        value: function _setupClipboardIntegration() {
          var e = this.editor,
              t = e.model,
              i = e.editing.view,
              n = e.plugins.get("ImageUtils");
          this.listenTo(e.plugins.get("ClipboardPipeline"), "inputTransformation", function (o, r) {
            var s = Array.from(r.content.getChildren());
            var a;
            if (!s.every(n.isInlineImageView)) return;
            a = r.targetRanges ? e.editing.mapper.toModelRange(r.targetRanges[0]) : t.document.selection.getFirstRange();
            var c = t.createSelection(a);

            if ("imageBlock" === Qg(t.schema, c)) {
              var _e262 = new fh(i.document),
                  _t248 = s.map(function (t) {
                return _e262.createElement("figure", {
                  class: "image"
                }, t);
              });

              r.content = _e262.createDocumentFragment(_t248);
            }
          });
        }
      }], [{
        key: "requires",
        get: function get() {
          return [cm, Jg, yh];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "ImageBlockEditing";
        }
      }]);

      return dm;
    }(Qe);

    i(11);

    var hm =
    /*#__PURE__*/
    function (_Qe41) {
      _inherits(hm, _Qe41);

      function hm() {
        _classCallCheck(this, hm);

        return _possibleConstructorReturn(this, _getPrototypeOf(hm).apply(this, arguments));
      }

      _createClass(hm, null, [{
        key: "requires",
        get: function get() {
          return [dm, iu, nm];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "ImageBlock";
        }
      }]);

      return hm;
    }(Qe);

    var um =
    /*#__PURE__*/
    function (_Qe42) {
      _inherits(um, _Qe42);

      function um() {
        _classCallCheck(this, um);

        return _possibleConstructorReturn(this, _getPrototypeOf(um).apply(this, arguments));
      }

      _createClass(um, [{
        key: "init",
        value: function init() {
          var e = this.editor,
              t = e.model.schema;
          t.register("imageInline", {
            isObject: !0,
            isInline: !0,
            allowWhere: "$text",
            allowAttributes: ["alt", "src", "srcset"]
          }), t.addChildCheck(function (e, t) {
            if (e.endsWith("caption") && "imageInline" === t.name) return !1;
          }), this._setupConversion(), e.plugins.has("ImageBlockEditing") && (e.commands.add("imageTypeInline", new lm(this.editor, "imageInline")), this._setupClipboardIntegration());
        }
      }, {
        key: "_setupConversion",
        value: function _setupConversion() {
          var e = this.editor,
              t = e.t,
              i = e.conversion,
              n = e.plugins.get("ImageUtils");
          i.for("dataDowncast").elementToElement({
            model: "imageInline",
            view: function view(e, _ref147) {
              var t = _ref147.writer;
              return t.createEmptyElement("img");
            }
          }), i.for("editingDowncast").elementToElement({
            model: "imageInline",
            view: function view(e, _ref148) {
              var i = _ref148.writer;
              return n.toImageWidget(Gg(i, "imageInline"), i, t("image widget"));
            }
          }), i.for("downcast").add(rm(n, "imageInline", "src")).add(rm(n, "imageInline", "alt")).add(om(n, "imageInline")), i.for("upcast").elementToElement({
            view: Kg(e, "imageInline"),
            model: function model(e, _ref149) {
              var t = _ref149.writer;
              return t.createElement("imageInline", {
                src: e.getAttribute("src")
              });
            }
          });
        }
      }, {
        key: "_setupClipboardIntegration",
        value: function _setupClipboardIntegration() {
          var e = this.editor,
              t = e.model,
              i = e.editing.view,
              n = e.plugins.get("ImageUtils");
          this.listenTo(e.plugins.get("ClipboardPipeline"), "inputTransformation", function (o, r) {
            var s = Array.from(r.content.getChildren());
            var a;
            if (!s.every(n.isBlockImageView)) return;
            a = r.targetRanges ? e.editing.mapper.toModelRange(r.targetRanges[0]) : t.document.selection.getFirstRange();
            var c = t.createSelection(a);

            if ("imageInline" === Qg(t.schema, c)) {
              var _e263 = new fh(i.document),
                  _t249 = s.map(function (t) {
                return 1 === t.childCount ? (Array.from(t.getAttributes()).forEach(function (i) {
                  return _e263.setAttribute.apply(_e263, _toConsumableArray(i).concat([n.getViewImageFromWidget(t)]));
                }), t.getChild(0)) : t;
              });

              r.content = _e263.createDocumentFragment(_t249);
            }
          });
        }
      }], [{
        key: "requires",
        get: function get() {
          return [cm, Jg, yh];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "ImageInlineEditing";
        }
      }]);

      return um;
    }(Qe);

    var gm =
    /*#__PURE__*/
    function (_Qe43) {
      _inherits(gm, _Qe43);

      function gm() {
        _classCallCheck(this, gm);

        return _possibleConstructorReturn(this, _getPrototypeOf(gm).apply(this, arguments));
      }

      _createClass(gm, null, [{
        key: "requires",
        get: function get() {
          return [um, iu, nm];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "ImageInline";
        }
      }]);

      return gm;
    }(Qe);

    function mm(e) {
      var _iteratorNormalCompletion348 = true;
      var _didIteratorError348 = false;
      var _iteratorError348 = undefined;

      try {
        for (var _iterator348 = e.getChildren()[Symbol.iterator](), _step348; !(_iteratorNormalCompletion348 = (_step348 = _iterator348.next()).done); _iteratorNormalCompletion348 = true) {
          var _t250 = _step348.value;
          if (_t250 && _t250.is("element", "caption")) return _t250;
        }
      } catch (err) {
        _didIteratorError348 = true;
        _iteratorError348 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion348 && _iterator348.return != null) {
            _iterator348.return();
          }
        } finally {
          if (_didIteratorError348) {
            throw _iteratorError348;
          }
        }
      }

      return null;
    }

    function fm(e, t) {
      var i = t.getFirstPosition().findAncestor("caption");
      return i && e.isBlockImage(i.parent) ? i : null;
    }

    var pm =
    /*#__PURE__*/
    function (_Ze17) {
      _inherits(pm, _Ze17);

      function pm() {
        _classCallCheck(this, pm);

        return _possibleConstructorReturn(this, _getPrototypeOf(pm).apply(this, arguments));
      }

      _createClass(pm, [{
        key: "refresh",
        value: function refresh() {
          var e = this.editor,
              t = e.plugins.get("ImageUtils");
          if (!e.plugins.has(dm)) return this.isEnabled = !1, void (this.value = !1);
          var i = e.model.document.selection,
              n = i.getSelectedElement();

          if (!n) {
            var _e264 = fm(t, i);

            return this.isEnabled = !!_e264, void (this.value = !!_e264);
          }

          this.isEnabled = this.editor.plugins.get("ImageUtils").isImage(n), this.isEnabled ? this.value = !!mm(n) : this.value = !1;
        }
      }, {
        key: "execute",
        value: function execute() {
          var _this224 = this;

          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var t = e.focusCaptionOnShow;
          this.editor.model.change(function (e) {
            _this224.value ? _this224._hideImageCaption(e) : _this224._showImageCaption(e, t);
          });
        }
      }, {
        key: "_showImageCaption",
        value: function _showImageCaption(e, t) {
          var i = this.editor.model.document.selection,
              n = this.editor.plugins.get("ImageCaptionEditing");
          var o = i.getSelectedElement();

          var r = n._getSavedCaption(o);

          this.editor.plugins.get("ImageUtils").isInlineImage(o) && (this.editor.execute("imageTypeBlock"), o = i.getSelectedElement());
          var s = r || e.createElement("caption");
          e.append(s, o), t && e.setSelection(s, "in");
        }
      }, {
        key: "_hideImageCaption",
        value: function _hideImageCaption(e) {
          var t = this.editor,
              i = t.model.document.selection,
              n = t.plugins.get("ImageCaptionEditing"),
              o = t.plugins.get("ImageUtils");
          var r,
              s = i.getSelectedElement();
          s ? r = mm(s) : (r = fm(o, i), s = r.parent), n._saveCaption(s, r), e.setSelection(s, "on"), e.remove(r);
        }
      }]);

      return pm;
    }(Ze);

    var bm =
    /*#__PURE__*/
    function (_Qe44) {
      _inherits(bm, _Qe44);

      _createClass(bm, null, [{
        key: "requires",
        get: function get() {
          return [Jg];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "ImageCaptionEditing";
        }
      }]);

      function bm(e) {
        var _this225;

        _classCallCheck(this, bm);

        _this225 = _possibleConstructorReturn(this, _getPrototypeOf(bm).call(this, e)), _this225._savedCaptionsMap = new WeakMap();
        return _this225;
      }

      _createClass(bm, [{
        key: "init",
        value: function init() {
          var e = this.editor,
              t = e.model.schema;
          t.isRegistered("caption") ? t.extend("caption", {
            allowIn: "imageBlock"
          }) : t.register("caption", {
            allowIn: "imageBlock",
            allowContentOf: "$block",
            isLimit: !0
          }), e.commands.add("toggleImageCaption", new pm(this.editor)), this._setupConversion(), this._setupImageTypeCommandsIntegration();
        }
      }, {
        key: "_setupConversion",
        value: function _setupConversion() {
          var e = this.editor,
              t = e.editing.view,
              i = e.plugins.get("ImageUtils"),
              n = e.t;
          e.conversion.for("upcast").elementToElement({
            view: function view(e) {
              return function (e, t) {
                return "figcaption" == t.name && e.isBlockImageView(t.parent) ? {
                  name: !0
                } : null;
              }(i, e);
            },
            model: "caption"
          }), e.conversion.for("dataDowncast").elementToElement({
            model: "caption",
            view: function view(e, _ref150) {
              var t = _ref150.writer;
              return i.isBlockImage(e.parent) ? t.createContainerElement("figcaption") : null;
            }
          }), e.conversion.for("editingDowncast").elementToElement({
            model: "caption",
            view: function view(e, _ref151) {
              var o = _ref151.writer;
              if (!i.isBlockImage(e.parent)) return null;
              var r = o.createEditableElement("figcaption");
              o.setCustomProperty("imageCaption", !0, r), Jd({
                view: t,
                element: r,
                text: n("Enter image caption"),
                keepOnFocus: !0
              });
              var s = Hh(r, o);
              return Bh(s, o, function (e, t, i) {
                return i.addClass(en(t.classes), e);
              }, function (e, t, i) {
                return i.removeClass(en(t.classes), e);
              }), s;
            }
          }), e.editing.mapper.on("modelToViewPosition", wm(t)), e.data.mapper.on("modelToViewPosition", wm(t));
        }
      }, {
        key: "_setupImageTypeCommandsIntegration",
        value: function _setupImageTypeCommandsIntegration() {
          var _this226 = this;

          var e = this.editor,
              t = e.plugins.get("ImageUtils"),
              i = e.commands.get("imageTypeInline"),
              n = e.commands.get("imageTypeBlock"),
              o = function o(e) {
            if (!e.return) return;
            var _e$return = e.return,
                i = _e$return.oldElement,
                n = _e$return.newElement;
            if (!i) return;

            if (t.isBlockImage(i)) {
              var _e265 = mm(i);

              if (_e265) return void _this226._saveCaption(n, _e265);
            }

            var o = _this226._getSavedCaption(i);

            o && _this226._saveCaption(n, o);
          };

          i && this.listenTo(i, "execute", o, {
            priority: "low"
          }), n && this.listenTo(n, "execute", o, {
            priority: "low"
          });
        }
      }, {
        key: "_getSavedCaption",
        value: function _getSavedCaption(e) {
          var t = this._savedCaptionsMap.get(e);

          return t ? Xs.fromJSON(t) : null;
        }
      }, {
        key: "_saveCaption",
        value: function _saveCaption(e, t) {
          this._savedCaptionsMap.set(e, t.toJSON());
        }
      }]);

      return bm;
    }(Qe);

    function wm(e) {
      return function (t, i) {
        var n = i.modelPosition,
            o = n.parent;
        if (!o.is("element", "imageBlock")) return;
        var r = i.mapper.toViewElement(o);
        i.viewPosition = e.createPositionAt(r, n.offset + 1);
      };
    }

    var km =
    /*#__PURE__*/
    function (_Qe45) {
      _inherits(km, _Qe45);

      function km() {
        _classCallCheck(this, km);

        return _possibleConstructorReturn(this, _getPrototypeOf(km).apply(this, arguments));
      }

      _createClass(km, [{
        key: "init",
        value: function init() {
          var _this227 = this;

          var e = this.editor,
              t = e.editing.view,
              i = e.plugins.get("ImageUtils"),
              n = e.t;
          e.ui.componentFactory.add("toggleImageCaption", function (o) {
            var r = e.commands.get("toggleImageCaption"),
                s = new id(o);
            return s.set({
              icon: Sl.caption,
              tooltip: !0,
              isToggleable: !0
            }), s.bind("isOn", "isEnabled").to(r, "value", "isEnabled"), s.bind("label").to(r, "value", function (e) {
              return n(e ? "Toggle caption off" : "Toggle caption on");
            }), _this227.listenTo(s, "execute", function () {
              e.execute("toggleImageCaption", {
                focusCaptionOnShow: !0
              });
              var n = fm(i, e.model.document.selection);

              if (n) {
                var _i264 = e.editing.mapper.toViewElement(n);

                t.scrollToTheSelection(), t.change(function (e) {
                  e.addClass("image__caption_highlighted", _i264);
                });
              }
            }), s;
          });
        }
      }], [{
        key: "requires",
        get: function get() {
          return [Jg];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "ImageCaptionUI";
        }
      }]);

      return km;
    }(Qe);

    i(78);

    var _m =
    /*#__PURE__*/
    function (_Ze18) {
      _inherits(_m, _Ze18);

      function _m(e, t) {
        var _this228;

        _classCallCheck(this, _m);

        _this228 = _possibleConstructorReturn(this, _getPrototypeOf(_m).call(this, e)), _this228._defaultStyles = {
          imageBlock: !1,
          imageInline: !1
        }, _this228._styles = new Map(t.map(function (e) {
          if (e.isDefault) {
            var _iteratorNormalCompletion349 = true;
            var _didIteratorError349 = false;
            var _iteratorError349 = undefined;

            try {
              for (var _iterator349 = e.modelElements[Symbol.iterator](), _step349; !(_iteratorNormalCompletion349 = (_step349 = _iterator349.next()).done); _iteratorNormalCompletion349 = true) {
                var _t251 = _step349.value;
                _this228._defaultStyles[_t251] = e.name;
              }
            } catch (err) {
              _didIteratorError349 = true;
              _iteratorError349 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion349 && _iterator349.return != null) {
                  _iterator349.return();
                }
              } finally {
                if (_didIteratorError349) {
                  throw _iteratorError349;
                }
              }
            }
          }

          return [e.name, e];
        }));
        return _this228;
      }

      _createClass(_m, [{
        key: "refresh",
        value: function refresh() {
          var e = this.editor.plugins.get("ImageUtils").getClosestSelectedImageElement(this.editor.model.document.selection);
          this.isEnabled = !!e, this.isEnabled ? e.hasAttribute("imageStyle") ? this.value = e.getAttribute("imageStyle") : this.value = this._defaultStyles[e.name] : this.value = !1;
        }
      }, {
        key: "execute",
        value: function execute() {
          var _this229 = this;

          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var t = this.editor,
              i = t.model,
              n = t.plugins.get("ImageUtils");
          i.change(function (t) {
            var o = e.value;
            var r = n.getClosestSelectedImageElement(i.document.selection);
            o && _this229.shouldConvertImageType(o, r) && (_this229.editor.execute(n.isBlockImage(r) ? "imageTypeInline" : "imageTypeBlock"), r = n.getClosestSelectedImageElement(i.document.selection)), !o || _this229._styles.get(o).isDefault ? t.removeAttribute("imageStyle", r) : t.setAttribute("imageStyle", o, r);
          });
        }
      }, {
        key: "shouldConvertImageType",
        value: function shouldConvertImageType(e, t) {
          return !this._styles.get(e).modelElements.includes(t.name);
        }
      }]);

      return _m;
    }(Ze);

    var vm = Sl.objectFullWidth,
        ym = Sl.objectInline,
        xm = Sl.objectLeft,
        Am = Sl.objectRight,
        Cm = Sl.objectCenter,
        Tm = Sl.objectBlockLeft,
        Em = Sl.objectBlockRight,
        Sm = {
      inline: {
        name: "inline",
        title: "In line",
        icon: ym,
        modelElements: ["imageInline"],
        isDefault: !0
      },
      alignLeft: {
        name: "alignLeft",
        title: "Left aligned image",
        icon: xm,
        modelElements: ["imageBlock", "imageInline"],
        className: "image-style-align-left"
      },
      alignBlockLeft: {
        name: "alignBlockLeft",
        title: "Left aligned image",
        icon: Tm,
        modelElements: ["imageBlock"],
        className: "image-style-block-align-left"
      },
      alignCenter: {
        name: "alignCenter",
        title: "Centered image",
        icon: Cm,
        modelElements: ["imageBlock"],
        className: "image-style-align-center"
      },
      alignRight: {
        name: "alignRight",
        title: "Right aligned image",
        icon: Am,
        modelElements: ["imageBlock", "imageInline"],
        className: "image-style-align-right"
      },
      alignBlockRight: {
        name: "alignBlockRight",
        title: "Right aligned image",
        icon: Em,
        modelElements: ["imageBlock"],
        className: "image-style-block-align-right"
      },
      block: {
        name: "block",
        title: "Centered image",
        icon: Cm,
        modelElements: ["imageBlock"],
        isDefault: !0
      },
      side: {
        name: "side",
        title: "Side image",
        icon: Am,
        modelElements: ["imageBlock"],
        className: "image-style-side"
      }
    },
        Im = {
      full: vm,
      left: Tm,
      right: Em,
      center: Cm,
      inlineLeft: xm,
      inlineRight: Am,
      inline: ym
    },
        Pm = [{
      name: "imageStyle:wrapText",
      title: "Wrap text",
      defaultItem: "imageStyle:alignLeft",
      items: ["imageStyle:alignLeft", "imageStyle:alignRight"]
    }, {
      name: "imageStyle:breakText",
      title: "Break text",
      defaultItem: "imageStyle:block",
      items: ["imageStyle:alignBlockLeft", "imageStyle:block", "imageStyle:alignBlockRight"]
    }];

    function Mm(e) {
      Object(c.b)("image-style-configuration-definition-invalid", e);
    }

    var Nm = {
      normalizeStyles: function normalizeStyles(e) {
        return (e.configuredStyles.options || []).map(function (e) {
          return function (e) {
            e = "string" == typeof e ? Sm[e] ? _objectSpread({}, Sm[e]) : {
              name: e
            } : function (e, t) {
              var i = _objectSpread({}, t);

              for (var _n158 in e) {
                Object.prototype.hasOwnProperty.call(t, _n158) || (i[_n158] = e[_n158]);
              }

              return i;
            }(Sm[e.name], e);
            "string" == typeof e.icon && (e.icon = Im[e.icon] || e.icon);
            return e;
          }(e);
        }).filter(function (t) {
          return function (e, _ref152) {
            var t = _ref152.isBlockPluginLoaded,
                i = _ref152.isInlinePluginLoaded;
            var n = e.modelElements,
                o = e.name;
            if (!(n && n.length && o)) return Mm({
              style: e
            }), !1;
            {
              var _o98 = [t ? "imageBlock" : null, i ? "imageInline" : null];
              if (!n.some(function (e) {
                return _o98.includes(e);
              })) return Object(c.b)("image-style-missing-dependency", {
                style: e,
                missingPlugins: n.map(function (e) {
                  return "imageBlock" === e ? "ImageBlockEditing" : "ImageInlineEditing";
                })
              }), !1;
            }
            return !0;
          }(t, e);
        });
      },
      getDefaultStylesConfiguration: function getDefaultStylesConfiguration(e, t) {
        return e && t ? {
          options: ["inline", "alignLeft", "alignRight", "alignCenter", "alignBlockLeft", "alignBlockRight", "block", "side"]
        } : e ? {
          options: ["block", "side"]
        } : t ? {
          options: ["inline", "alignLeft", "alignRight"]
        } : {};
      },
      getDefaultDropdownDefinitions: function getDefaultDropdownDefinitions(e) {
        return e.has("ImageBlockEditing") && e.has("ImageInlineEditing") ? [].concat(Pm) : [];
      },
      warnInvalidStyle: Mm,
      DEFAULT_OPTIONS: Sm,
      DEFAULT_ICONS: Im,
      DEFAULT_DROPDOWN_DEFINITIONS: Pm
    };

    function Rm(e, t) {
      var _iteratorNormalCompletion350 = true;
      var _didIteratorError350 = false;
      var _iteratorError350 = undefined;

      try {
        for (var _iterator350 = t[Symbol.iterator](), _step350; !(_iteratorNormalCompletion350 = (_step350 = _iterator350.next()).done); _iteratorNormalCompletion350 = true) {
          var _i265 = _step350.value;
          if (_i265.name === e) return _i265;
        }
      } catch (err) {
        _didIteratorError350 = true;
        _iteratorError350 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion350 && _iterator350.return != null) {
            _iterator350.return();
          }
        } finally {
          if (_didIteratorError350) {
            throw _iteratorError350;
          }
        }
      }
    }

    var Om =
    /*#__PURE__*/
    function (_Qe46) {
      _inherits(Om, _Qe46);

      function Om() {
        _classCallCheck(this, Om);

        return _possibleConstructorReturn(this, _getPrototypeOf(Om).apply(this, arguments));
      }

      _createClass(Om, [{
        key: "init",
        value: function init() {
          var e = Nm.normalizeStyles,
              t = Nm.getDefaultStylesConfiguration,
              i = this.editor,
              n = i.plugins.has("ImageBlockEditing"),
              o = i.plugins.has("ImageInlineEditing");
          i.config.define("image.styles", t(n, o)), this.normalizedStyles = e({
            configuredStyles: i.config.get("image.styles"),
            isBlockPluginLoaded: n,
            isInlinePluginLoaded: o
          }), this._setupConversion(n, o), this._setupPostFixer(), i.commands.add("imageStyle", new _m(i, this.normalizedStyles));
        }
      }, {
        key: "_setupConversion",
        value: function _setupConversion(e, t) {
          var i = this.editor,
              n = i.model.schema,
              o = (r = this.normalizedStyles, function (e, t, i) {
            if (!i.consumable.consume(t.item, e.name)) return;
            var n = Rm(t.attributeNewValue, r),
                o = Rm(t.attributeOldValue, r),
                s = i.mapper.toViewElement(t.item),
                a = i.writer;
            o && a.removeClass(o.className, s), n && a.addClass(n.className, s);
          });
          var r;

          var s = function (e) {
            var t = {
              imageInline: e.filter(function (e) {
                return !e.isDefault && e.modelElements.includes("imageInline");
              }),
              imageBlock: e.filter(function (e) {
                return !e.isDefault && e.modelElements.includes("imageBlock");
              })
            };
            return function (e, i, n) {
              if (!i.modelRange) return;
              var o = i.viewItem,
                  r = Os(i.modelRange.getItems());

              if (r && n.schema.checkAttribute(r, "imageStyle")) {
                var _iteratorNormalCompletion351 = true;
                var _didIteratorError351 = false;
                var _iteratorError351 = undefined;

                try {
                  for (var _iterator351 = t[r.name][Symbol.iterator](), _step351; !(_iteratorNormalCompletion351 = (_step351 = _iterator351.next()).done); _iteratorNormalCompletion351 = true) {
                    var _e266 = _step351.value;
                    n.consumable.consume(o, {
                      classes: _e266.className
                    }) && n.writer.setAttribute("imageStyle", _e266.name, r);
                  }
                } catch (err) {
                  _didIteratorError351 = true;
                  _iteratorError351 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion351 && _iterator351.return != null) {
                      _iterator351.return();
                    }
                  } finally {
                    if (_didIteratorError351) {
                      throw _iteratorError351;
                    }
                  }
                }
              }
            };
          }(this.normalizedStyles);

          i.editing.downcastDispatcher.on("attribute:imageStyle", o), i.data.downcastDispatcher.on("attribute:imageStyle", o), e && (n.extend("imageBlock", {
            allowAttributes: "imageStyle"
          }), i.data.upcastDispatcher.on("element:figure", s, {
            priority: "low"
          })), t && (n.extend("imageInline", {
            allowAttributes: "imageStyle"
          }), i.data.upcastDispatcher.on("element:img", s, {
            priority: "low"
          }));
        }
      }, {
        key: "_setupPostFixer",
        value: function _setupPostFixer() {
          var e = this.editor,
              t = e.model.document,
              i = e.plugins.get(Jg),
              n = new Map(this.normalizedStyles.map(function (e) {
            return [e.name, e];
          }));
          t.registerPostFixer(function (e) {
            var o = !1;
            var _iteratorNormalCompletion352 = true;
            var _didIteratorError352 = false;
            var _iteratorError352 = undefined;

            try {
              for (var _iterator352 = t.differ.getChanges()[Symbol.iterator](), _step352; !(_iteratorNormalCompletion352 = (_step352 = _iterator352.next()).done); _iteratorNormalCompletion352 = true) {
                var _r54 = _step352.value;

                if ("insert" == _r54.type || "attribute" == _r54.type && "imageStyle" == _r54.attributeKey) {
                  var _t252 = "insert" == _r54.type ? _r54.position.nodeAfter : _r54.range.start.nodeAfter;

                  if (_t252 && _t252.is("element", "paragraph") && _t252.childCount > 0 && (_t252 = _t252.getChild(0)), !i.isImage(_t252)) continue;

                  var _s31 = _t252.getAttribute("imageStyle");

                  if (!_s31) continue;

                  var _a19 = n.get(_s31);

                  _a19 && _a19.modelElements.includes(_t252.name) || (e.removeAttribute("imageStyle", _t252), o = !0);
                }
              }
            } catch (err) {
              _didIteratorError352 = true;
              _iteratorError352 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion352 && _iterator352.return != null) {
                  _iterator352.return();
                }
              } finally {
                if (_didIteratorError352) {
                  throw _iteratorError352;
                }
              }
            }

            return o;
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "ImageStyleEditing";
        }
      }, {
        key: "requires",
        get: function get() {
          return [Jg];
        }
      }]);

      return Om;
    }(Qe);

    i(80);

    var zm =
    /*#__PURE__*/
    function (_Qe47) {
      _inherits(zm, _Qe47);

      function zm() {
        _classCallCheck(this, zm);

        return _possibleConstructorReturn(this, _getPrototypeOf(zm).apply(this, arguments));
      }

      _createClass(zm, [{
        key: "init",
        value: function init() {
          var e = this.editor.plugins,
              t = this.editor.config.get("image.toolbar") || [],
              i = Dm(e.get("ImageStyleEditing").normalizedStyles, this.localizedDefaultStylesTitles);
          var _iteratorNormalCompletion353 = true;
          var _didIteratorError353 = false;
          var _iteratorError353 = undefined;

          try {
            for (var _iterator353 = i[Symbol.iterator](), _step353; !(_iteratorNormalCompletion353 = (_step353 = _iterator353.next()).done); _iteratorNormalCompletion353 = true) {
              var _e267 = _step353.value;

              this._createButton(_e267);
            }
          } catch (err) {
            _didIteratorError353 = true;
            _iteratorError353 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion353 && _iterator353.return != null) {
                _iterator353.return();
              }
            } finally {
              if (_didIteratorError353) {
                throw _iteratorError353;
              }
            }
          }

          var n = Dm([].concat(_toConsumableArray(t.filter(w)), _toConsumableArray(Nm.getDefaultDropdownDefinitions(e))), this.localizedDefaultStylesTitles);
          var _iteratorNormalCompletion354 = true;
          var _didIteratorError354 = false;
          var _iteratorError354 = undefined;

          try {
            for (var _iterator354 = n[Symbol.iterator](), _step354; !(_iteratorNormalCompletion354 = (_step354 = _iterator354.next()).done); _iteratorNormalCompletion354 = true) {
              var _e268 = _step354.value;

              this._createDropdown(_e268, i);
            }
          } catch (err) {
            _didIteratorError354 = true;
            _iteratorError354 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion354 && _iterator354.return != null) {
                _iterator354.return();
              }
            } finally {
              if (_didIteratorError354) {
                throw _iteratorError354;
              }
            }
          }
        }
      }, {
        key: "_createDropdown",
        value: function _createDropdown(e, t) {
          var i = this.editor.ui.componentFactory;
          i.add(e.name, function (n) {
            var o;
            var r = e.defaultItem,
                s = e.items,
                a = e.title,
                c = s.filter(function (e) {
              return t.find(function (_ref153) {
                var t = _ref153.name;
                return Lm(t) === e;
              });
            }).map(function (e) {
              var t = i.create(e);
              return e === r && (o = t), t;
            });
            s.length !== c.length && Nm.warnInvalidStyle({
              dropdown: e
            });
            var l = Cd(n, cd),
                d = l.buttonView;
            return Td(l, c), d.set({
              label: Vm(a, o.label),
              class: null,
              tooltip: !0
            }), d.bind("icon").toMany(c, "isOn", function () {
              for (var _len23 = arguments.length, e = new Array(_len23), _key23 = 0; _key23 < _len23; _key23++) {
                e[_key23] = arguments[_key23];
              }

              var t = e.findIndex(Z);
              return t < 0 ? o.icon : c[t].icon;
            }), d.bind("label").toMany(c, "isOn", function () {
              for (var _len24 = arguments.length, e = new Array(_len24), _key24 = 0; _key24 < _len24; _key24++) {
                e[_key24] = arguments[_key24];
              }

              var t = e.findIndex(Z);
              return Vm(a, t < 0 ? o.label : c[t].label);
            }), d.bind("isOn").toMany(c, "isOn", function () {
              for (var _len25 = arguments.length, e = new Array(_len25), _key25 = 0; _key25 < _len25; _key25++) {
                e[_key25] = arguments[_key25];
              }

              return e.some(Z);
            }), d.bind("class").toMany(c, "isOn", function () {
              for (var _len26 = arguments.length, e = new Array(_len26), _key26 = 0; _key26 < _len26; _key26++) {
                e[_key26] = arguments[_key26];
              }

              return e.some(Z) ? "ck-splitbutton_flatten" : null;
            }), d.on("execute", function () {
              c.some(function (_ref154) {
                var e = _ref154.isOn;
                return e;
              }) ? l.isOpen = !l.isOpen : o.fire("execute");
            }), l.bind("isEnabled").toMany(c, "isEnabled", function () {
              for (var _len27 = arguments.length, e = new Array(_len27), _key27 = 0; _key27 < _len27; _key27++) {
                e[_key27] = arguments[_key27];
              }

              return e.some(Z);
            }), l;
          });
        }
      }, {
        key: "_createButton",
        value: function _createButton(e) {
          var _this230 = this;

          var t = e.name;
          this.editor.ui.componentFactory.add(Lm(t), function (i) {
            var n = _this230.editor.commands.get("imageStyle"),
                o = new id(i);

            return o.set({
              label: e.title,
              icon: e.icon,
              tooltip: !0,
              isToggleable: !0
            }), o.bind("isEnabled").to(n, "isEnabled"), o.bind("isOn").to(n, "value", function (e) {
              return e === t;
            }), o.on("execute", _this230._executeCommand.bind(_this230, t)), o;
          });
        }
      }, {
        key: "_executeCommand",
        value: function _executeCommand(e) {
          this.editor.execute("imageStyle", {
            value: e
          }), this.editor.editing.view.focus();
        }
      }, {
        key: "localizedDefaultStylesTitles",
        get: function get() {
          var e = this.editor.t;
          return {
            "Wrap text": e("Wrap text"),
            "Break text": e("Break text"),
            "In line": e("In line"),
            "Full size image": e("Full size image"),
            "Side image": e("Side image"),
            "Left aligned image": e("Left aligned image"),
            "Centered image": e("Centered image"),
            "Right aligned image": e("Right aligned image")
          };
        }
      }], [{
        key: "requires",
        get: function get() {
          return [Om];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "ImageStyleUI";
        }
      }]);

      return zm;
    }(Qe);

    function Dm(e, t) {
      var _iteratorNormalCompletion355 = true;
      var _didIteratorError355 = false;
      var _iteratorError355 = undefined;

      try {
        for (var _iterator355 = e[Symbol.iterator](), _step355; !(_iteratorNormalCompletion355 = (_step355 = _iterator355.next()).done); _iteratorNormalCompletion355 = true) {
          var _i266 = _step355.value;
          t[_i266.title] && (_i266.title = t[_i266.title]);
        }
      } catch (err) {
        _didIteratorError355 = true;
        _iteratorError355 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion355 && _iterator355.return != null) {
            _iterator355.return();
          }
        } finally {
          if (_didIteratorError355) {
            throw _iteratorError355;
          }
        }
      }

      return e;
    }

    function Lm(e) {
      return "imageStyle:" + e;
    }

    function Vm(e, t) {
      return (e ? e + ": " : "") + t;
    }

    function jm(e) {
      var t = e.map(function (e) {
        return e.replace("+", "\\+");
      });
      return new RegExp("^image\\/(".concat(t.join("|"), ")$"));
    }

    function Bm(e) {
      return new Promise(function (t, i) {
        var n = e.getAttribute("src");
        fetch(n).then(function (e) {
          return e.blob();
        }).then(function (e) {
          var i = Fm(e, n),
              o = i.replace("image/", ""),
              r = new File([e], "image." + o, {
            type: i
          });
          t(r);
        }).catch(function (e) {
          return e && "TypeError" === e.name ? function (e) {
            return function (e) {
              return new Promise(function (t, i) {
                var n = vr.document.createElement("img");
                n.addEventListener("load", function () {
                  var e = vr.document.createElement("canvas");
                  e.width = n.width, e.height = n.height;
                  e.getContext("2d").drawImage(n, 0, 0), e.toBlob(function (e) {
                    return e ? t(e) : i();
                  });
                }), n.addEventListener("error", function () {
                  return i();
                }), n.src = e;
              });
            }(e).then(function (t) {
              var i = Fm(t, e),
                  n = i.replace("image/", "");
              return new File([t], "image." + n, {
                type: i
              });
            });
          }(n).then(t).catch(i) : i(e);
        });
      });
    }

    function Fm(e, t) {
      return e.type ? e.type : t.match(/data:(image\/\w+);base64/) ? t.match(/data:(image\/\w+);base64/)[1].toLowerCase() : "image/jpeg";
    }

    var Hm =
    /*#__PURE__*/
    function (_Qe48) {
      _inherits(Hm, _Qe48);

      function Hm() {
        _classCallCheck(this, Hm);

        return _possibleConstructorReturn(this, _getPrototypeOf(Hm).apply(this, arguments));
      }

      _createClass(Hm, [{
        key: "init",
        value: function init() {
          var e = this.editor,
              t = e.t,
              i = function i(_i267) {
            var n = new cg(_i267),
                o = e.commands.get("uploadImage"),
                r = e.config.get("image.upload.types"),
                s = jm(r);
            return n.set({
              acceptedType: r.map(function (e) {
                return "image/" + e;
              }).join(","),
              allowMultipleFiles: !0
            }), n.buttonView.set({
              label: t("Insert image"),
              icon: Sl.image,
              tooltip: !0
            }), n.buttonView.bind("isEnabled").to(o), n.on("done", function (t, i) {
              var n = Array.from(i).filter(function (e) {
                return s.test(e.type);
              });
              n.length && e.execute("uploadImage", {
                file: n
              });
            }), n;
          };

          e.ui.componentFactory.add("uploadImage", i), e.ui.componentFactory.add("imageUpload", i);
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "ImageUploadUI";
        }
      }]);

      return Hm;
    }(Qe);

    i(82), i(84), i(86);

    var Um =
    /*#__PURE__*/
    function (_Qe49) {
      _inherits(Um, _Qe49);

      _createClass(Um, null, [{
        key: "pluginName",
        get: function get() {
          return "ImageUploadProgress";
        }
      }]);

      function Um(e) {
        var _this231;

        _classCallCheck(this, Um);

        _this231 = _possibleConstructorReturn(this, _getPrototypeOf(Um).call(this, e)), _this231.placeholder = "data:image/svg+xml;utf8," + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 700 250"><rect rx="4"/></svg>');
        return _this231;
      }

      _createClass(Um, [{
        key: "init",
        value: function init() {
          var _this232 = this;

          var e = this.editor;
          e.plugins.has("ImageBlockEditing") && e.editing.downcastDispatcher.on("attribute:uploadStatus:imageBlock", function () {
            return _this232.uploadStatusChange.apply(_this232, arguments);
          }), e.plugins.has("ImageInlineEditing") && e.editing.downcastDispatcher.on("attribute:uploadStatus:imageInline", function () {
            return _this232.uploadStatusChange.apply(_this232, arguments);
          });
        }
      }, {
        key: "uploadStatusChange",
        value: function uploadStatusChange(e, t, i) {
          var n = this.editor,
              o = t.item,
              r = o.getAttribute("uploadId");
          if (!i.consumable.consume(t.item, e.name)) return;
          var s = n.plugins.get("ImageUtils"),
              a = n.plugins.get(sg),
              c = r ? t.attributeNewValue : null,
              l = this.placeholder,
              d = n.editing.mapper.toViewElement(o),
              h = i.writer;
          if ("reading" == c) return Wm(d, h), void qm(s, l, d, h);

          if ("uploading" == c) {
            var _e269 = a.loaders.get(r);

            return Wm(d, h), void (_e269 ? ($m(d, h), function (e, t, i, n) {
              var o = function (e) {
                var t = e.createUIElement("div", {
                  class: "ck-progress-bar"
                });
                return e.setCustomProperty("progressBar", !0, t), t;
              }(t);

              t.insert(t.createPositionAt(e, "end"), o), i.on("change:uploadedPercent", function (e, t, i) {
                n.change(function (e) {
                  e.setStyle("width", i + "%", o);
                });
              });
            }(d, h, _e269, n.editing.view), function (e, t, i, n) {
              if (n.data) {
                var _o99 = e.getViewImageFromWidget(t);

                i.setAttribute("src", n.data, _o99);
              }
            }(s, d, h, _e269)) : qm(s, l, d, h));
          }

          "complete" == c && a.loaders.get(r) && function (e, t, i) {
            var n = t.createUIElement("div", {
              class: "ck-image-upload-complete-icon"
            });
            t.insert(t.createPositionAt(e, "end"), n), setTimeout(function () {
              i.change(function (e) {
                return e.remove(e.createRangeOn(n));
              });
            }, 3e3);
          }(d, h, n.editing.view), function (e, t) {
            Gm(e, t, "progressBar");
          }(d, h), $m(d, h), function (e, t) {
            t.removeClass("ck-appear", e);
          }(d, h);
        }
      }]);

      return Um;
    }(Qe);

    function Wm(e, t) {
      e.hasClass("ck-appear") || t.addClass("ck-appear", e);
    }

    function qm(e, t, i, n) {
      i.hasClass("ck-image-upload-placeholder") || n.addClass("ck-image-upload-placeholder", i);
      var o = e.getViewImageFromWidget(i);
      o.getAttribute("src") !== t && n.setAttribute("src", t, o), Ym(i, "placeholder") || n.insert(n.createPositionAfter(o), function (e) {
        var t = e.createUIElement("div", {
          class: "ck-upload-placeholder-loader"
        });
        return e.setCustomProperty("placeholder", !0, t), t;
      }(n));
    }

    function $m(e, t) {
      e.hasClass("ck-image-upload-placeholder") && t.removeClass("ck-image-upload-placeholder", e), Gm(e, t, "placeholder");
    }

    function Ym(e, t) {
      var _iteratorNormalCompletion356 = true;
      var _didIteratorError356 = false;
      var _iteratorError356 = undefined;

      try {
        for (var _iterator356 = e.getChildren()[Symbol.iterator](), _step356; !(_iteratorNormalCompletion356 = (_step356 = _iterator356.next()).done); _iteratorNormalCompletion356 = true) {
          var _i268 = _step356.value;
          if (_i268.getCustomProperty(t)) return _i268;
        }
      } catch (err) {
        _didIteratorError356 = true;
        _iteratorError356 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion356 && _iterator356.return != null) {
            _iterator356.return();
          }
        } finally {
          if (_didIteratorError356) {
            throw _iteratorError356;
          }
        }
      }
    }

    function Gm(e, t, i) {
      var n = Ym(e, i);
      n && t.remove(t.createRangeOn(n));
    }

    var Km =
    /*#__PURE__*/
    function (_Ze19) {
      _inherits(Km, _Ze19);

      function Km() {
        _classCallCheck(this, Km);

        return _possibleConstructorReturn(this, _getPrototypeOf(Km).apply(this, arguments));
      }

      _createClass(Km, [{
        key: "refresh",
        value: function refresh() {
          var e = this.editor,
              t = e.plugins.get("ImageUtils"),
              i = e.model.document.selection.getSelectedElement();
          this.isEnabled = t.isImageAllowed() || t.isImage(i);
        }
      }, {
        key: "execute",
        value: function execute(e) {
          var _this233 = this;

          var t = en(e.file),
              i = this.editor.model.document.selection,
              n = this.editor.plugins.get("ImageUtils"),
              o = Object.fromEntries(i.getAttributes());
          t.forEach(function (e, t) {
            var r = i.getSelectedElement();

            if (t && r && n.isImage(r)) {
              var _t253 = _this233.editor.model.createPositionAfter(r);

              _this233._uploadImage(e, o, _t253);
            } else _this233._uploadImage(e, o);
          });
        }
      }, {
        key: "_uploadImage",
        value: function _uploadImage(e, t, i) {
          var n = this.editor,
              o = n.plugins.get(sg).createLoader(e),
              r = n.plugins.get("ImageUtils");
          o && r.insertImage(_objectSpread({}, t, {
            uploadId: o.id
          }), i);
        }
      }]);

      return Km;
    }(Ze);

    var Qm =
    /*#__PURE__*/
    function (_Qe50) {
      _inherits(Qm, _Qe50);

      _createClass(Qm, null, [{
        key: "requires",
        get: function get() {
          return [sg, Dd, yh, Jg];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "ImageUploadEditing";
        }
      }]);

      function Qm(e) {
        var _this234;

        _classCallCheck(this, Qm);

        _this234 = _possibleConstructorReturn(this, _getPrototypeOf(Qm).call(this, e)), e.config.define("image", {
          upload: {
            types: ["jpeg", "png", "gif", "bmp", "webp", "tiff"]
          }
        }), _this234._uploadImageElements = new Map();
        return _this234;
      }

      _createClass(Qm, [{
        key: "init",
        value: function init() {
          var _this235 = this;

          var e = this.editor,
              t = e.model.document,
              i = e.conversion,
              n = e.plugins.get(sg),
              o = e.plugins.get("ImageUtils"),
              r = jm(e.config.get("image.upload.types")),
              s = new Km(e);
          e.commands.add("uploadImage", s), e.commands.add("imageUpload", s), i.for("upcast").attributeToAttribute({
            view: {
              name: "img",
              key: "uploadId"
            },
            model: "uploadId"
          }), this.listenTo(e.editing.view.document, "clipboardInput", function (t, i) {
            if (n = i.dataTransfer, Array.from(n.types).includes("text/html") && "" !== n.getData("text/html")) return;
            var n;
            var o = Array.from(i.dataTransfer.files).filter(function (e) {
              return !!e && r.test(e.type);
            });
            o.length && (t.stop(), e.model.change(function (t) {
              i.targetRanges && t.setSelection(i.targetRanges.map(function (t) {
                return e.editing.mapper.toModelRange(t);
              })), e.model.enqueueChange("default", function () {
                e.execute("uploadImage", {
                  file: o
                });
              });
            }));
          }), this.listenTo(e.plugins.get("ClipboardPipeline"), "inputTransformation", function (t, i) {
            var r = Array.from(e.editing.view.createRangeIn(i.content)).filter(function (e) {
              return function (e, t) {
                return !(!e.isInlineImageView(t) || !t.getAttribute("src")) && (t.getAttribute("src").match(/^data:image\/\w+;base64,/g) || t.getAttribute("src").match(/^blob:/g));
              }(o, e.item) && !e.item.getAttribute("uploadProcessed");
            }).map(function (e) {
              return {
                promise: Bm(e.item),
                imageElement: e.item
              };
            });
            if (!r.length) return;
            var s = new fh(e.editing.view.document);
            var _iteratorNormalCompletion357 = true;
            var _didIteratorError357 = false;
            var _iteratorError357 = undefined;

            try {
              for (var _iterator357 = r[Symbol.iterator](), _step357; !(_iteratorNormalCompletion357 = (_step357 = _iterator357.next()).done); _iteratorNormalCompletion357 = true) {
                var _e270 = _step357.value;
                s.setAttribute("uploadProcessed", !0, _e270.imageElement);

                var _t254 = n.createLoader(_e270.promise);

                _t254 && (s.setAttribute("src", "", _e270.imageElement), s.setAttribute("uploadId", _t254.id, _e270.imageElement));
              }
            } catch (err) {
              _didIteratorError357 = true;
              _iteratorError357 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion357 && _iterator357.return != null) {
                  _iterator357.return();
                }
              } finally {
                if (_didIteratorError357) {
                  throw _iteratorError357;
                }
              }
            }
          }), e.editing.view.document.on("dragover", function (e, t) {
            t.preventDefault();
          }), t.on("change", function () {
            var i = t.differ.getChanges({
              includeChangesInGraveyard: !0
            }).reverse(),
                o = new Set();
            var _iteratorNormalCompletion358 = true;
            var _didIteratorError358 = false;
            var _iteratorError358 = undefined;

            try {
              for (var _iterator358 = i[Symbol.iterator](), _step358; !(_iteratorNormalCompletion358 = (_step358 = _iterator358.next()).done); _iteratorNormalCompletion358 = true) {
                var _t255 = _step358.value;

                if ("insert" == _t255.type && "$text" != _t255.name) {
                  var _i269 = _t255.position.nodeAfter,
                      _r55 = "$graveyard" == _t255.position.root.rootName;

                  var _iteratorNormalCompletion359 = true;
                  var _didIteratorError359 = false;
                  var _iteratorError359 = undefined;

                  try {
                    for (var _iterator359 = Jm(e, _i269)[Symbol.iterator](), _step359; !(_iteratorNormalCompletion359 = (_step359 = _iterator359.next()).done); _iteratorNormalCompletion359 = true) {
                      var _t256 = _step359.value;

                      var _e271 = _t256.getAttribute("uploadId");

                      if (!_e271) continue;

                      var _i270 = n.loaders.get(_e271);

                      _i270 && (_r55 ? o.has(_e271) || _i270.abort() : (o.add(_e271), _this235._uploadImageElements.set(_e271, _t256), "idle" == _i270.status && _this235._readAndUpload(_i270)));
                    }
                  } catch (err) {
                    _didIteratorError359 = true;
                    _iteratorError359 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion359 && _iterator359.return != null) {
                        _iterator359.return();
                      }
                    } finally {
                      if (_didIteratorError359) {
                        throw _iteratorError359;
                      }
                    }
                  }
                }
              }
            } catch (err) {
              _didIteratorError358 = true;
              _iteratorError358 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion358 && _iterator358.return != null) {
                  _iterator358.return();
                }
              } finally {
                if (_didIteratorError358) {
                  throw _iteratorError358;
                }
              }
            }
          }), this.on("uploadComplete", function (e, _ref155) {
            var t = _ref155.imageElement,
                i = _ref155.data;
            var n = i.urls ? i.urls : i;

            _this235.editor.model.change(function (e) {
              e.setAttribute("src", n.default, t), _this235._parseAndSetSrcsetAttributeOnImage(n, t, e);
            });
          }, {
            priority: "low"
          });
        }
      }, {
        key: "afterInit",
        value: function afterInit() {
          var e = this.editor.model.schema;
          this.editor.plugins.has("ImageBlockEditing") && e.extend("imageBlock", {
            allowAttributes: ["uploadId", "uploadStatus"]
          }), this.editor.plugins.has("ImageInlineEditing") && e.extend("imageInline", {
            allowAttributes: ["uploadId", "uploadStatus"]
          });
        }
      }, {
        key: "_readAndUpload",
        value: function _readAndUpload(e) {
          var _this236 = this;

          var t = this.editor,
              i = t.model,
              n = t.locale.t,
              o = t.plugins.get(sg),
              r = t.plugins.get(Dd),
              s = t.plugins.get("ImageUtils"),
              a = this._uploadImageElements;
          return i.enqueueChange("transparent", function (t) {
            t.setAttribute("uploadStatus", "reading", a.get(e.id));
          }), e.read().then(function () {
            var n = e.upload(),
                o = a.get(e.id);

            if (Io.isSafari) {
              var _e272 = t.editing.mapper.toViewElement(o),
                  _i271 = s.getViewImageFromWidget(_e272);

              t.editing.view.once("render", function () {
                if (!_i271.parent) return;
                var e = t.editing.view.domConverter.mapViewToDom(_i271.parent);
                if (!e) return;
                var n = e.style.display;
                e.style.display = "none", e._ckHack = e.offsetHeight, e.style.display = n;
              });
            }

            return i.enqueueChange("transparent", function (e) {
              e.setAttribute("uploadStatus", "uploading", o);
            }), n;
          }).then(function (t) {
            i.enqueueChange("transparent", function (i) {
              var n = a.get(e.id);
              i.setAttribute("uploadStatus", "complete", n), _this236.fire("uploadComplete", {
                data: t,
                imageElement: n
              });
            }), c();
          }).catch(function (t) {
            if ("error" !== e.status && "aborted" !== e.status) throw t;
            "error" == e.status && t && r.showWarning(t, {
              title: n("Upload failed"),
              namespace: "upload"
            }), i.enqueueChange("transparent", function (t) {
              t.remove(a.get(e.id));
            }), c();
          });

          function c() {
            i.enqueueChange("transparent", function (t) {
              var i = a.get(e.id);
              t.removeAttribute("uploadId", i), t.removeAttribute("uploadStatus", i), a.delete(e.id);
            }), o.destroyLoader(e);
          }
        }
      }, {
        key: "_parseAndSetSrcsetAttributeOnImage",
        value: function _parseAndSetSrcsetAttributeOnImage(e, t, i) {
          var n = 0;
          var o = Object.keys(e).filter(function (e) {
            var t = parseInt(e, 10);
            if (!isNaN(t)) return n = Math.max(n, t), !0;
          }).map(function (t) {
            return "".concat(e[t], " ").concat(t, "w");
          }).join(", ");
          "" != o && i.setAttribute("srcset", {
            data: o,
            width: n
          }, t);
        }
      }]);

      return Qm;
    }(Qe);

    function Jm(e, t) {
      var i = e.plugins.get("ImageUtils");
      return Array.from(e.model.createRangeOn(t)).filter(function (e) {
        return i.isImage(e.item);
      }).map(function (e) {
        return e.item;
      });
    }

    var Zm =
    /*#__PURE__*/
    function (_Qe51) {
      _inherits(Zm, _Qe51);

      function Zm() {
        _classCallCheck(this, Zm);

        return _possibleConstructorReturn(this, _getPrototypeOf(Zm).apply(this, arguments));
      }

      _createClass(Zm, [{
        key: "init",
        value: function init() {
          var e = this.editor;
          e.commands.add("indent", new et(e)), e.commands.add("outdent", new et(e));
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "IndentEditing";
        }
      }]);

      return Zm;
    }(Qe);

    var Xm = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm5 6c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zM2.75 16.5h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 1 0 0 1.5zM1.632 6.95 5.02 9.358a.4.4 0 0 1-.013.661l-3.39 2.207A.4.4 0 0 1 1 11.892V7.275a.4.4 0 0 1 .632-.326z"/></svg>',
        ef = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm5 6c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zM2.75 16.5h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 1 0 0 1.5zm1.618-9.55L.98 9.358a.4.4 0 0 0 .013.661l3.39 2.207A.4.4 0 0 0 5 11.892V7.275a.4.4 0 0 0-.632-.326z"/></svg>';

    var tf =
    /*#__PURE__*/
    function (_Qe52) {
      _inherits(tf, _Qe52);

      function tf() {
        _classCallCheck(this, tf);

        return _possibleConstructorReturn(this, _getPrototypeOf(tf).apply(this, arguments));
      }

      _createClass(tf, [{
        key: "init",
        value: function init() {
          var e = this.editor,
              t = e.locale,
              i = e.t,
              n = "ltr" == t.uiLanguageDirection ? Xm : ef,
              o = "ltr" == t.uiLanguageDirection ? ef : Xm;
          this._defineButton("indent", i("Increase indent"), n), this._defineButton("outdent", i("Decrease indent"), o);
        }
      }, {
        key: "_defineButton",
        value: function _defineButton(e, t, i) {
          var _this237 = this;

          var n = this.editor;
          n.ui.componentFactory.add(e, function (o) {
            var r = n.commands.get(e),
                s = new id(o);
            return s.set({
              label: t,
              icon: i,
              tooltip: !0
            }), s.bind("isOn", "isEnabled").to(r, "value", "isEnabled"), _this237.listenTo(s, "execute", function () {
              n.execute(e), n.editing.view.focus();
            }), s;
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "IndentUI";
        }
      }]);

      return tf;
    }(Qe);

    var nf =
    /*#__PURE__*/
    function () {
      function nf() {
        _classCallCheck(this, nf);

        this._definitions = new Set();
      }

      _createClass(nf, [{
        key: "add",
        value: function add(e) {
          var _this238 = this;

          Array.isArray(e) ? e.forEach(function (e) {
            return _this238._definitions.add(e);
          }) : this._definitions.add(e);
        }
      }, {
        key: "getDispatcher",
        value: function getDispatcher() {
          var _this239 = this;

          return function (e) {
            e.on("attribute:linkHref", function (e, t, i) {
              if (!i.consumable.test(t.item, "attribute:linkHref")) return;
              var n = i.writer,
                  o = n.document.selection;
              var _iteratorNormalCompletion360 = true;
              var _didIteratorError360 = false;
              var _iteratorError360 = undefined;

              try {
                for (var _iterator360 = _this239._definitions[Symbol.iterator](), _step360; !(_iteratorNormalCompletion360 = (_step360 = _iterator360.next()).done); _iteratorNormalCompletion360 = true) {
                  var _e273 = _step360.value;

                  var _r56 = n.createAttributeElement("a", _e273.attributes, {
                    priority: 5
                  });

                  n.setCustomProperty("link", !0, _r56), _e273.callback(t.attributeNewValue) ? t.item.is("selection") ? n.wrap(o.getFirstRange(), _r56) : n.wrap(i.mapper.toViewRange(t.range), _r56) : n.unwrap(i.mapper.toViewRange(t.range), _r56);
                }
              } catch (err) {
                _didIteratorError360 = true;
                _iteratorError360 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion360 && _iterator360.return != null) {
                    _iterator360.return();
                  }
                } finally {
                  if (_didIteratorError360) {
                    throw _iteratorError360;
                  }
                }
              }
            }, {
              priority: "high"
            });
          };
        }
      }, {
        key: "getDispatcherForLinkedImage",
        value: function getDispatcherForLinkedImage() {
          var _this240 = this;

          return function (e) {
            e.on("attribute:linkHref:imageBlock", function (e, t, i) {
              var n = i.mapper.toViewElement(t.item),
                  o = Array.from(n.getChildren()).find(function (e) {
                return "a" === e.name;
              });
              var _iteratorNormalCompletion361 = true;
              var _didIteratorError361 = false;
              var _iteratorError361 = undefined;

              try {
                for (var _iterator361 = _this240._definitions[Symbol.iterator](), _step361; !(_iteratorNormalCompletion361 = (_step361 = _iterator361.next()).done); _iteratorNormalCompletion361 = true) {
                  var _e274 = _step361.value;

                  var _n159 = gn(_e274.attributes);

                  if (_e274.callback(t.attributeNewValue)) {
                    var _iteratorNormalCompletion362 = true;
                    var _didIteratorError362 = false;
                    var _iteratorError362 = undefined;

                    try {
                      for (var _iterator362 = _n159[Symbol.iterator](), _step362; !(_iteratorNormalCompletion362 = (_step362 = _iterator362.next()).done); _iteratorNormalCompletion362 = true) {
                        var _ref158 = _step362.value;

                        var _ref157 = _slicedToArray(_ref158, 2);

                        var _e275 = _ref157[0];
                        var _t257 = _ref157[1];
                        "class" === _e275 ? i.writer.addClass(_t257, o) : i.writer.setAttribute(_e275, _t257, o);
                      }
                    } catch (err) {
                      _didIteratorError362 = true;
                      _iteratorError362 = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion362 && _iterator362.return != null) {
                          _iterator362.return();
                        }
                      } finally {
                        if (_didIteratorError362) {
                          throw _iteratorError362;
                        }
                      }
                    }
                  } else {
                    var _iteratorNormalCompletion363 = true;
                    var _didIteratorError363 = false;
                    var _iteratorError363 = undefined;

                    try {
                      for (var _iterator363 = _n159[Symbol.iterator](), _step363; !(_iteratorNormalCompletion363 = (_step363 = _iterator363.next()).done); _iteratorNormalCompletion363 = true) {
                        var _ref161 = _step363.value;

                        var _ref160 = _slicedToArray(_ref161, 2);

                        var _e276 = _ref160[0];
                        var _t258 = _ref160[1];
                        "class" === _e276 ? i.writer.removeClass(_t258, o) : i.writer.removeAttribute(_e276, o);
                      }
                    } catch (err) {
                      _didIteratorError363 = true;
                      _iteratorError363 = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion363 && _iterator363.return != null) {
                          _iterator363.return();
                        }
                      } finally {
                        if (_didIteratorError363) {
                          throw _iteratorError363;
                        }
                      }
                    }
                  }
                }
              } catch (err) {
                _didIteratorError361 = true;
                _iteratorError361 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion361 && _iterator361.return != null) {
                    _iterator361.return();
                  }
                } finally {
                  if (_didIteratorError361) {
                    throw _iteratorError361;
                  }
                }
              }
            });
          };
        }
      }, {
        key: "length",
        get: function get() {
          return this._definitions.size;
        }
      }]);

      return nf;
    }();

    var of = function of(e, t, i) {
      var n = e.length;
      return i = void 0 === i ? n : i, !t && i >= n ? e : zn(e, t, i);
    },
        rf = RegExp("[\\u200d\\ud800-\\udfff\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff\\ufe0e\\ufe0f]");

    var sf = function sf(e) {
      return rf.test(e);
    };

    var af = function af(e) {
      return e.split("");
    },
        cf = "[\\ud800-\\udfff]",
        lf = "[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]",
        df = "\\ud83c[\\udffb-\\udfff]",
        hf = "[^\\ud800-\\udfff]",
        uf = "(?:\\ud83c[\\udde6-\\uddff]){2}",
        gf = "[\\ud800-\\udbff][\\udc00-\\udfff]",
        mf = "(?:" + lf + "|" + df + ")" + "?",
        ff = "[\\ufe0e\\ufe0f]?" + mf + ("(?:\\u200d(?:" + [hf, uf, gf].join("|") + ")[\\ufe0e\\ufe0f]?" + mf + ")*"),
        pf = "(?:" + [hf + lf + "?", lf, uf, gf, cf].join("|") + ")",
        bf = RegExp(df + "(?=" + df + ")|" + pf + ff, "g");

    var wf = function wf(e) {
      return e.match(bf) || [];
    };

    var kf = function kf(e) {
      return sf(e) ? wf(e) : af(e);
    };

    var _f = function (e) {
      return function (t) {
        t = Pn(t);
        var i = sf(t) ? kf(t) : void 0,
            n = i ? i[0] : t.charAt(0),
            o = i ? of(i, 1).join("") : t.slice(1);
        return n[e]() + o;
      };
    }("toUpperCase");

    var vf = /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205f\u3000]/g,
        yf = /^(?:(?:https?|ftps?|mailto):|[^a-z]|[a-z+.-]+(?:[^a-z+.:-]|$))/i,
        xf = /^[\S]+@((?![-_])(?:[-\w\u00a1-\uffff]{0,63}[^-_]\.))+(?:[a-z\u00a1-\uffff]{2,})$/i,
        Af = /^((\w+:(\/{2,})?)|(\W))/i;

    function Cf(e, _ref162) {
      var t = _ref162.writer;
      var i = t.createAttributeElement("a", {
        href: e
      }, {
        priority: 5
      });
      return t.setCustomProperty("link", !0, i), i;
    }

    function Tf(e) {
      return function (e) {
        return e.replace(vf, "").match(yf);
      }(e = String(e)) ? e : "#";
    }

    function Ef(e, t) {
      return !!e && t.checkAttribute(e.name, "linkHref");
    }

    function Sf(e, t) {
      var i = (n = e, xf.test(n) ? "mailto:" : t);
      var n;
      var o = !!i && !Af.test(e);
      return e && o ? i + e : e;
    }

    var If =
    /*#__PURE__*/
    function (_Ze20) {
      _inherits(If, _Ze20);

      function If(e) {
        var _this241;

        _classCallCheck(this, If);

        _this241 = _possibleConstructorReturn(this, _getPrototypeOf(If).call(this, e)), _this241.manualDecorators = new Zi(), _this241.automaticDecorators = new nf();
        return _this241;
      }

      _createClass(If, [{
        key: "restoreManualDecoratorStates",
        value: function restoreManualDecoratorStates() {
          var _iteratorNormalCompletion364 = true;
          var _didIteratorError364 = false;
          var _iteratorError364 = undefined;

          try {
            for (var _iterator364 = this.manualDecorators[Symbol.iterator](), _step364; !(_iteratorNormalCompletion364 = (_step364 = _iterator364.next()).done); _iteratorNormalCompletion364 = true) {
              var _e277 = _step364.value;
              _e277.value = this._getDecoratorStateFromModel(_e277.id);
            }
          } catch (err) {
            _didIteratorError364 = true;
            _iteratorError364 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion364 && _iterator364.return != null) {
                _iterator364.return();
              }
            } finally {
              if (_didIteratorError364) {
                throw _iteratorError364;
              }
            }
          }
        }
      }, {
        key: "refresh",
        value: function refresh() {
          var e = this.editor.model,
              t = e.document.selection,
              i = t.getSelectedElement() || Os(t.getSelectedBlocks());
          Ef(i, e.schema) ? (this.value = i.getAttribute("linkHref"), this.isEnabled = e.schema.checkAttribute(i, "linkHref")) : (this.value = t.getAttribute("linkHref"), this.isEnabled = e.schema.checkAttributeInSelection(t, "linkHref"));
          var _iteratorNormalCompletion365 = true;
          var _didIteratorError365 = false;
          var _iteratorError365 = undefined;

          try {
            for (var _iterator365 = this.manualDecorators[Symbol.iterator](), _step365; !(_iteratorNormalCompletion365 = (_step365 = _iterator365.next()).done); _iteratorNormalCompletion365 = true) {
              var _e278 = _step365.value;
              _e278.value = this._getDecoratorStateFromModel(_e278.id);
            }
          } catch (err) {
            _didIteratorError365 = true;
            _iteratorError365 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion365 && _iterator365.return != null) {
                _iterator365.return();
              }
            } finally {
              if (_didIteratorError365) {
                throw _iteratorError365;
              }
            }
          }
        }
      }, {
        key: "execute",
        value: function execute(e) {
          var _this242 = this;

          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var i = this.editor.model,
              n = i.document.selection,
              o = [],
              r = [];

          for (var _e279 in t) {
            t[_e279] ? o.push(_e279) : r.push(_e279);
          }

          i.change(function (t) {
            if (n.isCollapsed) {
              var _s32 = n.getFirstPosition();

              if (n.hasAttribute("linkHref")) {
                var _a20 = Yu(_s32, "linkHref", n.getAttribute("linkHref"), i);

                t.setAttribute("linkHref", e, _a20), o.forEach(function (e) {
                  t.setAttribute(e, !0, _a20);
                }), r.forEach(function (e) {
                  t.removeAttribute(e, _a20);
                }), t.setSelection(t.createPositionAfter(_a20.end.nodeBefore));
              } else if ("" !== e) {
                var _r57 = gn(n.getAttributes());

                _r57.set("linkHref", e), o.forEach(function (e) {
                  _r57.set(e, !0);
                });

                var _i$insertContent = i.insertContent(t.createText(e, _r57), _s32),
                    _a21 = _i$insertContent.end;

                t.setSelection(_a21);
              }

              ["linkHref"].concat(o, r).forEach(function (e) {
                t.removeSelectionAttribute(e);
              });
            } else {
              var _s33 = i.schema.getValidRanges(n.getRanges(), "linkHref"),
                  _a22 = [];

              var _iteratorNormalCompletion366 = true;
              var _didIteratorError366 = false;
              var _iteratorError366 = undefined;

              try {
                for (var _iterator366 = n.getSelectedBlocks()[Symbol.iterator](), _step366; !(_iteratorNormalCompletion366 = (_step366 = _iterator366.next()).done); _iteratorNormalCompletion366 = true) {
                  var _e280 = _step366.value;
                  i.schema.checkAttribute(_e280, "linkHref") && _a22.push(t.createRangeOn(_e280));
                }
              } catch (err) {
                _didIteratorError366 = true;
                _iteratorError366 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion366 && _iterator366.return != null) {
                    _iterator366.return();
                  }
                } finally {
                  if (_didIteratorError366) {
                    throw _iteratorError366;
                  }
                }
              }

              var _c11 = _a22.slice();

              var _iteratorNormalCompletion367 = true;
              var _didIteratorError367 = false;
              var _iteratorError367 = undefined;

              try {
                for (var _iterator367 = _s33[Symbol.iterator](), _step367; !(_iteratorNormalCompletion367 = (_step367 = _iterator367.next()).done); _iteratorNormalCompletion367 = true) {
                  var _e281 = _step367.value;
                  _this242._isRangeToUpdate(_e281, _a22) && _c11.push(_e281);
                }
              } catch (err) {
                _didIteratorError367 = true;
                _iteratorError367 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion367 && _iterator367.return != null) {
                    _iterator367.return();
                  }
                } finally {
                  if (_didIteratorError367) {
                    throw _iteratorError367;
                  }
                }
              }

              var _iteratorNormalCompletion368 = true;
              var _didIteratorError368 = false;
              var _iteratorError368 = undefined;

              try {
                var _loop7 = function _loop7() {
                  var i = _step368.value;
                  t.setAttribute("linkHref", e, i), o.forEach(function (e) {
                    t.setAttribute(e, !0, i);
                  }), r.forEach(function (e) {
                    t.removeAttribute(e, i);
                  });
                };

                for (var _iterator368 = _c11[Symbol.iterator](), _step368; !(_iteratorNormalCompletion368 = (_step368 = _iterator368.next()).done); _iteratorNormalCompletion368 = true) {
                  _loop7();
                }
              } catch (err) {
                _didIteratorError368 = true;
                _iteratorError368 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion368 && _iterator368.return != null) {
                    _iterator368.return();
                  }
                } finally {
                  if (_didIteratorError368) {
                    throw _iteratorError368;
                  }
                }
              }
            }
          });
        }
      }, {
        key: "_getDecoratorStateFromModel",
        value: function _getDecoratorStateFromModel(e) {
          var t = this.editor.model,
              i = t.document.selection,
              n = i.getSelectedElement();
          return Ef(n, t.schema) ? n.getAttribute(e) : i.getAttribute(e);
        }
      }, {
        key: "_isRangeToUpdate",
        value: function _isRangeToUpdate(e, t) {
          var _iteratorNormalCompletion369 = true;
          var _didIteratorError369 = false;
          var _iteratorError369 = undefined;

          try {
            for (var _iterator369 = t[Symbol.iterator](), _step369; !(_iteratorNormalCompletion369 = (_step369 = _iterator369.next()).done); _iteratorNormalCompletion369 = true) {
              var _i272 = _step369.value;
              if (_i272.containsRange(e)) return !1;
            }
          } catch (err) {
            _didIteratorError369 = true;
            _iteratorError369 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion369 && _iterator369.return != null) {
                _iterator369.return();
              }
            } finally {
              if (_didIteratorError369) {
                throw _iteratorError369;
              }
            }
          }

          return !0;
        }
      }]);

      return If;
    }(Ze);

    var Pf =
    /*#__PURE__*/
    function (_Ze21) {
      _inherits(Pf, _Ze21);

      function Pf() {
        _classCallCheck(this, Pf);

        return _possibleConstructorReturn(this, _getPrototypeOf(Pf).apply(this, arguments));
      }

      _createClass(Pf, [{
        key: "refresh",
        value: function refresh() {
          var e = this.editor.model,
              t = e.document.selection,
              i = t.getSelectedElement();
          Ef(i, e.schema) ? this.isEnabled = e.schema.checkAttribute(i, "linkHref") : this.isEnabled = e.schema.checkAttributeInSelection(t, "linkHref");
        }
      }, {
        key: "execute",
        value: function execute() {
          var e = this.editor,
              t = this.editor.model,
              i = t.document.selection,
              n = e.commands.get("link");
          t.change(function (e) {
            var o = i.isCollapsed ? [Yu(i.getFirstPosition(), "linkHref", i.getAttribute("linkHref"), t)] : t.schema.getValidRanges(i.getRanges(), "linkHref");
            var _iteratorNormalCompletion370 = true;
            var _didIteratorError370 = false;
            var _iteratorError370 = undefined;

            try {
              for (var _iterator370 = o[Symbol.iterator](), _step370; !(_iteratorNormalCompletion370 = (_step370 = _iterator370.next()).done); _iteratorNormalCompletion370 = true) {
                var _t259 = _step370.value;

                if (e.removeAttribute("linkHref", _t259), n) {
                  var _iteratorNormalCompletion371 = true;
                  var _didIteratorError371 = false;
                  var _iteratorError371 = undefined;

                  try {
                    for (var _iterator371 = n.manualDecorators[Symbol.iterator](), _step371; !(_iteratorNormalCompletion371 = (_step371 = _iterator371.next()).done); _iteratorNormalCompletion371 = true) {
                      var _i273 = _step371.value;
                      e.removeAttribute(_i273.id, _t259);
                    }
                  } catch (err) {
                    _didIteratorError371 = true;
                    _iteratorError371 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion371 && _iterator371.return != null) {
                        _iterator371.return();
                      }
                    } finally {
                      if (_didIteratorError371) {
                        throw _iteratorError371;
                      }
                    }
                  }
                }
              }
            } catch (err) {
              _didIteratorError370 = true;
              _iteratorError370 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion370 && _iterator370.return != null) {
                  _iterator370.return();
                }
              } finally {
                if (_didIteratorError370) {
                  throw _iteratorError370;
                }
              }
            }
          });
        }
      }]);

      return Pf;
    }(Ze);

    var Mf = function Mf(_ref163) {
      var e = _ref163.id,
          t = _ref163.label,
          i = _ref163.attributes,
          n = _ref163.defaultValue;

      _classCallCheck(this, Mf);

      this.id = e, this.set("value"), this.defaultValue = n, this.label = t, this.attributes = i;
    };

    Ke(Mf, Ue);
    i(88);
    var Nf = /^(https?:)?\/\//;

    var Rf =
    /*#__PURE__*/
    function (_Qe53) {
      _inherits(Rf, _Qe53);

      _createClass(Rf, null, [{
        key: "pluginName",
        get: function get() {
          return "LinkEditing";
        }
      }, {
        key: "requires",
        get: function get() {
          return [Nu, Su, yh];
        }
      }]);

      function Rf(e) {
        var _this243;

        _classCallCheck(this, Rf);

        _this243 = _possibleConstructorReturn(this, _getPrototypeOf(Rf).call(this, e)), e.config.define("link", {
          addTargetToExternalLinks: !1
        });
        return _this243;
      }

      _createClass(Rf, [{
        key: "init",
        value: function init() {
          var e = this.editor;
          e.model.schema.extend("$text", {
            allowAttributes: "linkHref"
          }), e.conversion.for("dataDowncast").attributeToElement({
            model: "linkHref",
            view: Cf
          }), e.conversion.for("editingDowncast").attributeToElement({
            model: "linkHref",
            view: function view(e, t) {
              return Cf(Tf(e), t);
            }
          }), e.conversion.for("upcast").elementToAttribute({
            view: {
              name: "a",
              attributes: {
                href: !0
              }
            },
            model: {
              key: "linkHref",
              value: function value(e) {
                return e.getAttribute("href");
              }
            }
          }), e.commands.add("link", new If(e)), e.commands.add("unlink", new Pf(e));

          var t = function (e, t) {
            var i = {
              "Open in a new tab": e("Open in a new tab"),
              Downloadable: e("Downloadable")
            };
            return t.forEach(function (e) {
              return e.label && i[e.label] && (e.label = i[e.label]), e;
            }), t;
          }(e.t, function (e) {
            var t = [];

            if (e) {
              for (var _i274 = 0, _Object$entries2 = Object.entries(e); _i274 < _Object$entries2.length; _i274++) {
                var _ref166 = _Object$entries2[_i274];

                var _ref165 = _slicedToArray(_ref166, 2);

                var _i275 = _ref165[0];
                var _n160 = _ref165[1];

                var _e282 = Object.assign({}, _n160, {
                  id: "link" + _f(_i275)
                });

                t.push(_e282);
              }
            }

            return t;
          }(e.config.get("link.decorators")));

          this._enableAutomaticDecorators(t.filter(function (e) {
            return "automatic" === e.mode;
          })), this._enableManualDecorators(t.filter(function (e) {
            return "manual" === e.mode;
          }));
          e.plugins.get(Nu).registerAttribute("linkHref"), function (e, t, i, n) {
            var o = e.editing.view,
                r = new Set();
            o.document.registerPostFixer(function (o) {
              var s = e.model.document.selection;
              var a = !1;

              if (s.hasAttribute(t)) {
                var _c12 = Yu(s.getFirstPosition(), t, s.getAttribute(t), e.model),
                    _l6 = e.editing.mapper.toViewRange(_c12);

                var _iteratorNormalCompletion372 = true;
                var _didIteratorError372 = false;
                var _iteratorError372 = undefined;

                try {
                  for (var _iterator372 = _l6.getItems()[Symbol.iterator](), _step372; !(_iteratorNormalCompletion372 = (_step372 = _iterator372.next()).done); _iteratorNormalCompletion372 = true) {
                    var _e283 = _step372.value;
                    _e283.is("element", i) && !_e283.hasClass(n) && (o.addClass(n, _e283), r.add(_e283), a = !0);
                  }
                } catch (err) {
                  _didIteratorError372 = true;
                  _iteratorError372 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion372 && _iterator372.return != null) {
                      _iterator372.return();
                    }
                  } finally {
                    if (_didIteratorError372) {
                      throw _iteratorError372;
                    }
                  }
                }
              }

              return a;
            }), e.conversion.for("editingDowncast").add(function (e) {
              function t() {
                o.change(function (e) {
                  var _iteratorNormalCompletion373 = true;
                  var _didIteratorError373 = false;
                  var _iteratorError373 = undefined;

                  try {
                    for (var _iterator373 = r.values()[Symbol.iterator](), _step373; !(_iteratorNormalCompletion373 = (_step373 = _iterator373.next()).done); _iteratorNormalCompletion373 = true) {
                      var _t260 = _step373.value;
                      e.removeClass(n, _t260), r.delete(_t260);
                    }
                  } catch (err) {
                    _didIteratorError373 = true;
                    _iteratorError373 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion373 && _iterator373.return != null) {
                        _iterator373.return();
                      }
                    } finally {
                      if (_didIteratorError373) {
                        throw _iteratorError373;
                      }
                    }
                  }
                });
              }

              e.on("insert", t, {
                priority: "highest"
              }), e.on("remove", t, {
                priority: "highest"
              }), e.on("attribute", t, {
                priority: "highest"
              }), e.on("selection", t, {
                priority: "highest"
              });
            });
          }(e, "linkHref", "a", "ck-link_selected"), this._enableInsertContentSelectionAttributesFixer(), this._enableClickingAfterLink(), this._enableTypingOverLink(), this._handleDeleteContentAfterLink();
        }
      }, {
        key: "_enableAutomaticDecorators",
        value: function _enableAutomaticDecorators(e) {
          var t = this.editor,
              i = t.commands.get("link").automaticDecorators;
          t.config.get("link.addTargetToExternalLinks") && i.add({
            id: "linkIsExternal",
            mode: "automatic",
            callback: function callback(e) {
              return Nf.test(e);
            },
            attributes: {
              target: "_blank",
              rel: "noopener noreferrer"
            }
          }), i.add(e), i.length && t.conversion.for("downcast").add(i.getDispatcher());
        }
      }, {
        key: "_enableManualDecorators",
        value: function _enableManualDecorators(e) {
          if (!e.length) return;
          var t = this.editor,
              i = t.commands.get("link").manualDecorators;
          e.forEach(function (e) {
            t.model.schema.extend("$text", {
              allowAttributes: e.id
            }), i.add(new Mf(e)), t.conversion.for("downcast").attributeToElement({
              model: e.id,
              view: function view(t, _ref167) {
                var n = _ref167.writer;

                if (t) {
                  var _t261 = i.get(e.id).attributes,
                      _o100 = n.createAttributeElement("a", _t261, {
                    priority: 5
                  });

                  return n.setCustomProperty("link", !0, _o100), _o100;
                }
              }
            }), t.conversion.for("upcast").elementToAttribute({
              view: {
                name: "a",
                attributes: i.get(e.id).attributes
              },
              model: {
                key: e.id
              }
            });
          });
        }
      }, {
        key: "_enableInsertContentSelectionAttributesFixer",
        value: function _enableInsertContentSelectionAttributesFixer() {
          var e = this.editor.model,
              t = e.document.selection;
          this.listenTo(e, "insertContent", function () {
            var i = t.anchor.nodeBefore,
                n = t.anchor.nodeAfter;
            t.hasAttribute("linkHref") && i && i.hasAttribute("linkHref") && (n && n.hasAttribute("linkHref") || e.change(function (t) {
              Of(t, Df(e.schema));
            }));
          }, {
            priority: "low"
          });
        }
      }, {
        key: "_enableClickingAfterLink",
        value: function _enableClickingAfterLink() {
          var e = this.editor,
              t = e.model;
          e.editing.view.addObserver(mh);
          var i = !1;
          this.listenTo(e.editing.view.document, "mousedown", function () {
            i = !0;
          }), this.listenTo(e.editing.view.document, "selectionChange", function () {
            if (!i) return;
            i = !1;
            var e = t.document.selection;
            if (!e.isCollapsed) return;
            if (!e.hasAttribute("linkHref")) return;
            var n = e.getFirstPosition(),
                o = Yu(n, "linkHref", e.getAttribute("linkHref"), t);
            (n.isTouching(o.start) || n.isTouching(o.end)) && t.change(function (e) {
              Of(e, Df(t.schema));
            });
          });
        }
      }, {
        key: "_enableTypingOverLink",
        value: function _enableTypingOverLink() {
          var e = this.editor,
              t = e.editing.view;
          var i, n;
          this.listenTo(t.document, "delete", function () {
            n = !0;
          }, {
            priority: "high"
          }), this.listenTo(e.model, "deleteContent", function () {
            var t = e.model.document.selection;
            t.isCollapsed || (n ? n = !1 : zf(e) && function (e) {
              var t = e.document.selection,
                  i = t.getFirstPosition(),
                  n = t.getLastPosition(),
                  o = i.nodeAfter;
              if (!o) return !1;
              if (!o.is("$text")) return !1;
              if (!o.hasAttribute("linkHref")) return !1;
              var r = n.textNode || n.nodeBefore;
              if (o === r) return !0;
              return Yu(i, "linkHref", o.getAttribute("linkHref"), e).containsRange(e.createRange(i, n), !0);
            }(e.model) && (i = t.getAttributes()));
          }, {
            priority: "high"
          }), this.listenTo(e.model, "insertContent", function (t, _ref168) {
            var _ref169 = _slicedToArray(_ref168, 1),
                o = _ref169[0];

            n = !1, zf(e) && i && (e.model.change(function (e) {
              var _iteratorNormalCompletion374 = true;
              var _didIteratorError374 = false;
              var _iteratorError374 = undefined;

              try {
                for (var _iterator374 = i[Symbol.iterator](), _step374; !(_iteratorNormalCompletion374 = (_step374 = _iterator374.next()).done); _iteratorNormalCompletion374 = true) {
                  var _ref172 = _step374.value;

                  var _ref171 = _slicedToArray(_ref172, 2);

                  var _t262 = _ref171[0];
                  var _n161 = _ref171[1];
                  e.setAttribute(_t262, _n161, o);
                }
              } catch (err) {
                _didIteratorError374 = true;
                _iteratorError374 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion374 && _iterator374.return != null) {
                    _iterator374.return();
                  }
                } finally {
                  if (_didIteratorError374) {
                    throw _iteratorError374;
                  }
                }
              }
            }), i = null);
          }, {
            priority: "high"
          });
        }
      }, {
        key: "_handleDeleteContentAfterLink",
        value: function _handleDeleteContentAfterLink() {
          var e = this.editor,
              t = e.model,
              i = t.document.selection,
              n = e.editing.view;
          var o = !1,
              r = !1;
          this.listenTo(n.document, "delete", function (e, t) {
            r = t.domEvent.keyCode === No.backspace;
          }, {
            priority: "high"
          }), this.listenTo(t, "deleteContent", function () {
            o = !1;
            var e = i.getFirstPosition(),
                n = i.getAttribute("linkHref");
            if (!n) return;
            var r = Yu(e, "linkHref", n, t);
            o = r.containsPosition(e) || r.end.isEqual(e);
          }, {
            priority: "high"
          }), this.listenTo(t, "deleteContent", function () {
            r && (r = !1, o || e.model.enqueueChange(function (e) {
              Of(e, Df(t.schema));
            }));
          }, {
            priority: "low"
          });
        }
      }]);

      return Rf;
    }(Qe);

    function Of(e, t) {
      e.removeSelectionAttribute("linkHref");
      var _iteratorNormalCompletion375 = true;
      var _didIteratorError375 = false;
      var _iteratorError375 = undefined;

      try {
        for (var _iterator375 = t[Symbol.iterator](), _step375; !(_iteratorNormalCompletion375 = (_step375 = _iterator375.next()).done); _iteratorNormalCompletion375 = true) {
          var _i276 = _step375.value;
          e.removeSelectionAttribute(_i276);
        }
      } catch (err) {
        _didIteratorError375 = true;
        _iteratorError375 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion375 && _iterator375.return != null) {
            _iterator375.return();
          }
        } finally {
          if (_didIteratorError375) {
            throw _iteratorError375;
          }
        }
      }
    }

    function zf(e) {
      return e.plugins.get("Input").isInput(e.model.change(function (e) {
        return e.batch;
      }));
    }

    function Df(e) {
      return e.getDefinition("$text").allowAttributes.filter(function (e) {
        return e.startsWith("link");
      });
    }

    i(90);

    var Lf =
    /*#__PURE__*/
    function (_Rl27) {
      _inherits(Lf, _Rl27);

      function Lf(e, t) {
        var _this244;

        _classCallCheck(this, Lf);

        _this244 = _possibleConstructorReturn(this, _getPrototypeOf(Lf).call(this, e));
        var i = e.t;
        _this244.focusTracker = new zs(), _this244.keystrokes = new Ds(), _this244.urlInputView = _this244._createUrlInput(), _this244.saveButtonView = _this244._createButton(i("Save"), Sl.check, "ck-button-save"), _this244.saveButtonView.type = "submit", _this244.cancelButtonView = _this244._createButton(i("Cancel"), Sl.cancel, "ck-button-cancel", "cancel"), _this244._manualDecoratorSwitches = _this244._createManualDecoratorSwitches(t), _this244.children = _this244._createFormChildren(t.manualDecorators), _this244._focusables = new Nl(), _this244._focusCycler = new od({
          focusables: _this244._focusables,
          focusTracker: _this244.focusTracker,
          keystrokeHandler: _this244.keystrokes,
          actions: {
            focusPrevious: "shift + tab",
            focusNext: "tab"
          }
        });
        var n = ["ck", "ck-link-form", "ck-responsive-form"];
        t.manualDecorators.length && n.push("ck-link-form_layout-vertical", "ck-vertical-form"), _this244.setTemplate({
          tag: "form",
          attributes: {
            class: n,
            tabindex: "-1"
          },
          children: _this244.children
        }), Pl(_assertThisInitialized(_this244));
        return _this244;
      }

      _createClass(Lf, [{
        key: "getDecoratorSwitchesState",
        value: function getDecoratorSwitchesState() {
          return Array.from(this._manualDecoratorSwitches).reduce(function (e, t) {
            return e[t.name] = t.isOn, e;
          }, {});
        }
      }, {
        key: "render",
        value: function render() {
          var _this245 = this;

          _get(_getPrototypeOf(Lf.prototype), "render", this).call(this), Ml({
            view: this
          });
          [this.urlInputView].concat(_toConsumableArray(this._manualDecoratorSwitches), [this.saveButtonView, this.cancelButtonView]).forEach(function (e) {
            _this245._focusables.add(e), _this245.focusTracker.add(e.element);
          }), this.keystrokes.listenTo(this.element);
        }
      }, {
        key: "focus",
        value: function focus() {
          this._focusCycler.focusFirst();
        }
      }, {
        key: "_createUrlInput",
        value: function _createUrlInput() {
          var e = this.locale.t,
              t = new Od(this.locale, zd);
          return t.label = e("Link URL"), t;
        }
      }, {
        key: "_createButton",
        value: function _createButton(e, t, i, n) {
          var o = new id(this.locale);
          return o.set({
            label: e,
            icon: t,
            tooltip: !0
          }), o.extendTemplate({
            attributes: {
              class: i
            }
          }), n && o.delegate("execute").to(this, n), o;
        }
      }, {
        key: "_createManualDecoratorSwitches",
        value: function _createManualDecoratorSwitches(e) {
          var _this246 = this;

          var t = this.createCollection();
          var _iteratorNormalCompletion376 = true;
          var _didIteratorError376 = false;
          var _iteratorError376 = undefined;

          try {
            var _loop8 = function _loop8() {
              var i = _step376.value;
              var n = new nd(_this246.locale);
              n.set({
                name: i.id,
                label: i.label,
                withText: !0
              }), n.bind("isOn").toMany([i, e], "value", function (e, t) {
                return void 0 === t && void 0 === e ? i.defaultValue : e;
              }), n.on("execute", function () {
                i.set("value", !n.isOn);
              }), t.add(n);
            };

            for (var _iterator376 = e.manualDecorators[Symbol.iterator](), _step376; !(_iteratorNormalCompletion376 = (_step376 = _iterator376.next()).done); _iteratorNormalCompletion376 = true) {
              _loop8();
            }
          } catch (err) {
            _didIteratorError376 = true;
            _iteratorError376 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion376 && _iterator376.return != null) {
                _iterator376.return();
              }
            } finally {
              if (_didIteratorError376) {
                throw _iteratorError376;
              }
            }
          }

          return t;
        }
      }, {
        key: "_createFormChildren",
        value: function _createFormChildren(e) {
          var t = this.createCollection();

          if (t.add(this.urlInputView), e.length) {
            var _e284 = new Rl();

            _e284.setTemplate({
              tag: "ul",
              children: this._manualDecoratorSwitches.map(function (e) {
                return {
                  tag: "li",
                  children: [e],
                  attributes: {
                    class: ["ck", "ck-list__item"]
                  }
                };
              }),
              attributes: {
                class: ["ck", "ck-reset", "ck-list"]
              }
            }), t.add(_e284);
          }

          return t.add(this.saveButtonView), t.add(this.cancelButtonView), t;
        }
      }]);

      return Lf;
    }(Rl);

    i(92);

    var Vf =
    /*#__PURE__*/
    function (_Rl28) {
      _inherits(Vf, _Rl28);

      function Vf(e) {
        var _this247;

        _classCallCheck(this, Vf);

        _this247 = _possibleConstructorReturn(this, _getPrototypeOf(Vf).call(this, e));
        var t = e.t;
        _this247.focusTracker = new zs(), _this247.keystrokes = new Ds(), _this247.previewButtonView = _this247._createPreviewButton(), _this247.unlinkButtonView = _this247._createButton(t("Unlink"), '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m11.077 15 .991-1.416a.75.75 0 1 1 1.229.86l-1.148 1.64a.748.748 0 0 1-.217.206 5.251 5.251 0 0 1-8.503-5.955.741.741 0 0 1 .12-.274l1.147-1.639a.75.75 0 1 1 1.228.86L4.933 10.7l.006.003a3.75 3.75 0 0 0 6.132 4.294l.006.004zm5.494-5.335a.748.748 0 0 1-.12.274l-1.147 1.639a.75.75 0 1 1-1.228-.86l.86-1.23a3.75 3.75 0 0 0-6.144-4.301l-.86 1.229a.75.75 0 0 1-1.229-.86l1.148-1.64a.748.748 0 0 1 .217-.206 5.251 5.251 0 0 1 8.503 5.955zm-4.563-2.532a.75.75 0 0 1 .184 1.045l-3.155 4.505a.75.75 0 1 1-1.229-.86l3.155-4.506a.75.75 0 0 1 1.045-.184zm4.919 10.562-1.414 1.414a.75.75 0 1 1-1.06-1.06l1.414-1.415-1.415-1.414a.75.75 0 0 1 1.061-1.06l1.414 1.414 1.414-1.415a.75.75 0 0 1 1.061 1.061l-1.414 1.414 1.414 1.415a.75.75 0 0 1-1.06 1.06l-1.415-1.414z"/></svg>', "unlink"), _this247.editButtonView = _this247._createButton(t("Edit link"), Sl.pencil, "edit"), _this247.set("href"), _this247._focusables = new Nl(), _this247._focusCycler = new od({
          focusables: _this247._focusables,
          focusTracker: _this247.focusTracker,
          keystrokeHandler: _this247.keystrokes,
          actions: {
            focusPrevious: "shift + tab",
            focusNext: "tab"
          }
        }), _this247.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-link-actions", "ck-responsive-form"],
            tabindex: "-1"
          },
          children: [_this247.previewButtonView, _this247.editButtonView, _this247.unlinkButtonView]
        });
        return _this247;
      }

      _createClass(Vf, [{
        key: "render",
        value: function render() {
          var _this248 = this;

          _get(_getPrototypeOf(Vf.prototype), "render", this).call(this);

          [this.previewButtonView, this.editButtonView, this.unlinkButtonView].forEach(function (e) {
            _this248._focusables.add(e), _this248.focusTracker.add(e.element);
          }), this.keystrokes.listenTo(this.element);
        }
      }, {
        key: "focus",
        value: function focus() {
          this._focusCycler.focusFirst();
        }
      }, {
        key: "_createButton",
        value: function _createButton(e, t, i) {
          var n = new id(this.locale);
          return n.set({
            label: e,
            icon: t,
            tooltip: !0
          }), n.delegate("execute").to(this, i), n;
        }
      }, {
        key: "_createPreviewButton",
        value: function _createPreviewButton() {
          var e = new id(this.locale),
              t = this.bindTemplate,
              i = this.t;
          return e.set({
            withText: !0,
            tooltip: i("Open link in new tab")
          }), e.extendTemplate({
            attributes: {
              class: ["ck", "ck-link-actions__preview"],
              href: t.to("href", function (e) {
                return e && Tf(e);
              }),
              target: "_blank",
              rel: "noopener noreferrer"
            }
          }), e.bind("label").to(this, "href", function (e) {
            return e || i("This link has no URL");
          }), e.bind("isEnabled").to(this, "href", function (e) {
            return !!e;
          }), e.template.tag = "a", e.template.eventListeners = {}, e;
        }
      }]);

      return Vf;
    }(Rl);

    var jf =
    /*#__PURE__*/
    function (_Qe54) {
      _inherits(jf, _Qe54);

      function jf() {
        _classCallCheck(this, jf);

        return _possibleConstructorReturn(this, _getPrototypeOf(jf).apply(this, arguments));
      }

      _createClass(jf, [{
        key: "init",
        value: function init() {
          var e = this.editor;
          e.editing.view.addObserver(gh), this.actionsView = this._createActionsView(), this.formView = this._createFormView(), this._balloon = e.plugins.get(qd), this._createToolbarLinkButton(), this._enableUserBalloonInteractions(), e.conversion.for("editingDowncast").markerToHighlight({
            model: "link-ui",
            view: {
              classes: ["ck-fake-link-selection"]
            }
          }), e.conversion.for("editingDowncast").markerToElement({
            model: "link-ui",
            view: {
              name: "span",
              classes: ["ck-fake-link-selection", "ck-fake-link-selection_collapsed"]
            }
          });
        }
      }, {
        key: "destroy",
        value: function destroy() {
          _get(_getPrototypeOf(jf.prototype), "destroy", this).call(this), this.formView.destroy();
        }
      }, {
        key: "_createActionsView",
        value: function _createActionsView() {
          var _this249 = this;

          var e = this.editor,
              t = new Vf(e.locale),
              i = e.commands.get("link"),
              n = e.commands.get("unlink");
          return t.bind("href").to(i, "value"), t.editButtonView.bind("isEnabled").to(i), t.unlinkButtonView.bind("isEnabled").to(n), this.listenTo(t, "edit", function () {
            _this249._addFormView();
          }), this.listenTo(t, "unlink", function () {
            e.execute("unlink"), _this249._hideUI();
          }), t.keystrokes.set("Esc", function (e, t) {
            _this249._hideUI(), t();
          }), t.keystrokes.set("Ctrl+K", function (e, t) {
            _this249._addFormView(), t();
          }), t;
        }
      }, {
        key: "_createFormView",
        value: function _createFormView() {
          var _this250 = this;

          var e = this.editor,
              t = e.commands.get("link"),
              i = e.config.get("link.defaultProtocol"),
              n = new Lf(e.locale, t);
          return n.urlInputView.fieldView.bind("value").to(t, "value"), n.urlInputView.bind("isReadOnly").to(t, "isEnabled", function (e) {
            return !e;
          }), n.saveButtonView.bind("isEnabled").to(t), this.listenTo(n, "submit", function () {
            var t = n.urlInputView.fieldView.element.value,
                o = Sf(t, i);
            e.execute("link", o, n.getDecoratorSwitchesState()), _this250._closeFormView();
          }), this.listenTo(n, "cancel", function () {
            _this250._closeFormView();
          }), n.keystrokes.set("Esc", function (e, t) {
            _this250._closeFormView(), t();
          }), n;
        }
      }, {
        key: "_createToolbarLinkButton",
        value: function _createToolbarLinkButton() {
          var _this251 = this;

          var e = this.editor,
              t = e.commands.get("link"),
              i = e.t;
          e.keystrokes.set("Ctrl+K", function (e, i) {
            i(), t.isEnabled && _this251._showUI(!0);
          }), e.ui.componentFactory.add("link", function (e) {
            var n = new id(e);
            return n.isEnabled = !0, n.label = i("Link"), n.icon = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m11.077 15 .991-1.416a.75.75 0 1 1 1.229.86l-1.148 1.64a.748.748 0 0 1-.217.206 5.251 5.251 0 0 1-8.503-5.955.741.741 0 0 1 .12-.274l1.147-1.639a.75.75 0 1 1 1.228.86L4.933 10.7l.006.003a3.75 3.75 0 0 0 6.132 4.294l.006.004zm5.494-5.335a.748.748 0 0 1-.12.274l-1.147 1.639a.75.75 0 1 1-1.228-.86l.86-1.23a3.75 3.75 0 0 0-6.144-4.301l-.86 1.229a.75.75 0 0 1-1.229-.86l1.148-1.64a.748.748 0 0 1 .217-.206 5.251 5.251 0 0 1 8.503 5.955zm-4.563-2.532a.75.75 0 0 1 .184 1.045l-3.155 4.505a.75.75 0 1 1-1.229-.86l3.155-4.506a.75.75 0 0 1 1.045-.184z"/></svg>', n.keystroke = "Ctrl+K", n.tooltip = !0, n.isToggleable = !0, n.bind("isEnabled").to(t, "isEnabled"), n.bind("isOn").to(t, "value", function (e) {
              return !!e;
            }), _this251.listenTo(n, "execute", function () {
              return _this251._showUI(!0);
            }), n;
          });
        }
      }, {
        key: "_enableUserBalloonInteractions",
        value: function _enableUserBalloonInteractions() {
          var _this252 = this;

          var e = this.editor.editing.view.document;
          this.listenTo(e, "click", function () {
            _this252._getSelectedLinkElement() && _this252._showUI();
          }), this.editor.keystrokes.set("Tab", function (e, t) {
            _this252._areActionsVisible && !_this252.actionsView.focusTracker.isFocused && (_this252.actionsView.focus(), t());
          }, {
            priority: "high"
          }), this.editor.keystrokes.set("Esc", function (e, t) {
            _this252._isUIVisible && (_this252._hideUI(), t());
          }), Il({
            emitter: this.formView,
            activator: function activator() {
              return _this252._isUIInPanel;
            },
            contextElements: [this._balloon.view.element],
            callback: function callback() {
              return _this252._hideUI();
            }
          });
        }
      }, {
        key: "_addActionsView",
        value: function _addActionsView() {
          this._areActionsInPanel || this._balloon.add({
            view: this.actionsView,
            position: this._getBalloonPositionData()
          });
        }
      }, {
        key: "_addFormView",
        value: function _addFormView() {
          if (this._isFormInPanel) return;
          var e = this.editor.commands.get("link");
          this.formView.disableCssTransitions(), this._balloon.add({
            view: this.formView,
            position: this._getBalloonPositionData()
          }), this._balloon.visibleView === this.formView && this.formView.urlInputView.fieldView.select(), this.formView.enableCssTransitions(), this.formView.urlInputView.fieldView.element.value = e.value || "";
        }
      }, {
        key: "_closeFormView",
        value: function _closeFormView() {
          var e = this.editor.commands.get("link");
          e.restoreManualDecoratorStates(), void 0 !== e.value ? this._removeFormView() : this._hideUI();
        }
      }, {
        key: "_removeFormView",
        value: function _removeFormView() {
          this._isFormInPanel && (this.formView.saveButtonView.focus(), this._balloon.remove(this.formView), this.editor.editing.view.focus(), this._hideFakeVisualSelection());
        }
      }, {
        key: "_showUI",
        value: function _showUI() {
          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
          this._getSelectedLinkElement() ? (this._areActionsVisible ? this._addFormView() : this._addActionsView(), e && this._balloon.showStack("main")) : (this._showFakeVisualSelection(), this._addActionsView(), e && this._balloon.showStack("main"), this._addFormView()), this._startUpdatingUI();
        }
      }, {
        key: "_hideUI",
        value: function _hideUI() {
          if (!this._isUIInPanel) return;
          var e = this.editor;
          this.stopListening(e.ui, "update"), this.stopListening(this._balloon, "change:visibleView"), e.editing.view.focus(), this._removeFormView(), this._balloon.remove(this.actionsView), this._hideFakeVisualSelection();
        }
      }, {
        key: "_startUpdatingUI",
        value: function _startUpdatingUI() {
          var _this253 = this;

          var e = this.editor,
              t = e.editing.view.document;

          var i = this._getSelectedLinkElement(),
              n = r();

          var o = function o() {
            var e = _this253._getSelectedLinkElement(),
                t = r();

            i && !e || !i && t !== n ? _this253._hideUI() : _this253._isUIVisible && _this253._balloon.updatePosition(_this253._getBalloonPositionData()), i = e, n = t;
          };

          function r() {
            return t.selection.focus.getAncestors().reverse().find(function (e) {
              return e.is("element");
            });
          }

          this.listenTo(e.ui, "update", o), this.listenTo(this._balloon, "change:visibleView", o);
        }
      }, {
        key: "_getBalloonPositionData",
        value: function _getBalloonPositionData() {
          var _this254 = this;

          var e = this.editor.editing.view,
              t = this.editor.model,
              i = e.document;
          var n = null;

          if (t.markers.has("link-ui")) {
            var _t263 = Array.from(this.editor.editing.mapper.markerNameToElements("link-ui")),
                _i277 = e.createRange(e.createPositionBefore(_t263[0]), e.createPositionAfter(_t263[_t263.length - 1]));

            n = e.domConverter.viewRangeToDom(_i277);
          } else n = function n() {
            var t = _this254._getSelectedLinkElement();

            return t ? e.domConverter.mapViewToDom(t) : e.domConverter.viewRangeToDom(i.selection.getFirstRange());
          };

          return {
            target: n
          };
        }
      }, {
        key: "_getSelectedLinkElement",
        value: function _getSelectedLinkElement() {
          var e = this.editor.editing.view,
              t = e.document.selection,
              i = t.getSelectedElement();
          if (t.isCollapsed || i && Dh(i)) return Bf(t.getFirstPosition());
          {
            var _i278 = t.getFirstRange().getTrimmed(),
                _n162 = Bf(_i278.start),
                _o101 = Bf(_i278.end);

            return _n162 && _n162 == _o101 && e.createRangeIn(_n162).getTrimmed().isEqual(_i278) ? _n162 : null;
          }
        }
      }, {
        key: "_showFakeVisualSelection",
        value: function _showFakeVisualSelection() {
          var e = this.editor.model;
          e.change(function (t) {
            var i = e.document.selection.getFirstRange();
            if (e.markers.has("link-ui")) t.updateMarker("link-ui", {
              range: i
            });else if (i.start.isAtEnd) {
              var _n163 = i.start.getLastMatchingPosition(function (_ref173) {
                var t = _ref173.item;
                return !e.schema.isContent(t);
              }, {
                boundaries: i
              });

              t.addMarker("link-ui", {
                usingOperation: !1,
                affectsData: !1,
                range: t.createRange(_n163, i.end)
              });
            } else t.addMarker("link-ui", {
              usingOperation: !1,
              affectsData: !1,
              range: i
            });
          });
        }
      }, {
        key: "_hideFakeVisualSelection",
        value: function _hideFakeVisualSelection() {
          var e = this.editor.model;
          e.markers.has("link-ui") && e.change(function (e) {
            e.removeMarker("link-ui");
          });
        }
      }, {
        key: "_isFormInPanel",
        get: function get() {
          return this._balloon.hasView(this.formView);
        }
      }, {
        key: "_areActionsInPanel",
        get: function get() {
          return this._balloon.hasView(this.actionsView);
        }
      }, {
        key: "_areActionsVisible",
        get: function get() {
          return this._balloon.visibleView === this.actionsView;
        }
      }, {
        key: "_isUIInPanel",
        get: function get() {
          return this._isFormInPanel || this._areActionsInPanel;
        }
      }, {
        key: "_isUIVisible",
        get: function get() {
          return this._balloon.visibleView == this.formView || this._areActionsVisible;
        }
      }], [{
        key: "requires",
        get: function get() {
          return [qd];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "LinkUI";
        }
      }]);

      return jf;
    }(Qe);

    function Bf(e) {
      return e.getAncestors().find(function (e) {
        return (t = e).is("attributeElement") && !!t.getCustomProperty("link");
        var t;
      });
    }

    var Ff = new RegExp("(^|\\s)(((?:(?:(?:https?|ftp):)?\\/\\/)(?:\\S+(?::\\S*)?@)?(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(((?!www\\.)|(www\\.))(?![-_])(?:[-_a-z0-9\\u00a1-\\uffff]{1,63}\\.)+(?:[a-z\\u00a1-\\uffff]{2,63})))(?::\\d{2,5})?(?:[/?#]\\S*)?)|((www.|(\\S+@))((?![-_])(?:[-_a-z0-9\\u00a1-\\uffff]{1,63}\\.))+(?:[a-z\\u00a1-\\uffff]{2,63})))$", "i");

    var Hf =
    /*#__PURE__*/
    function (_Qe55) {
      _inherits(Hf, _Qe55);

      function Hf() {
        _classCallCheck(this, Hf);

        return _possibleConstructorReturn(this, _getPrototypeOf(Hf).apply(this, arguments));
      }

      _createClass(Hf, [{
        key: "init",
        value: function init() {
          var _this255 = this;

          var e = this.editor.model.document.selection;
          e.on("change:range", function () {
            _this255.isEnabled = !e.anchor.parent.is("element", "codeBlock");
          }), this._enableTypingHandling();
        }
      }, {
        key: "afterInit",
        value: function afterInit() {
          this._enableEnterHandling(), this._enableShiftEnterHandling();
        }
      }, {
        key: "_enableTypingHandling",
        value: function _enableTypingHandling() {
          var _this256 = this;

          var e = this.editor,
              t = new Mu(e.model, function (e) {
            if (!function (e) {
              return e.length > 4 && " " === e[e.length - 1] && " " !== e[e.length - 2];
            }(e)) return;
            var t = Uf(e.substr(0, e.length - 1));
            return t ? {
              url: t
            } : void 0;
          }),
              i = e.plugins.get("Input");
          t.on("matched:data", function (t, n) {
            var o = n.batch,
                r = n.range,
                s = n.url;
            if (!i.isInput(o)) return;
            var a = r.end.getShiftedBy(-1),
                c = a.getShiftedBy(-s.length),
                l = e.model.createRange(c, a);

            _this256._applyAutoLink(s, l);
          }), t.bind("isEnabled").to(this);
        }
      }, {
        key: "_enableEnterHandling",
        value: function _enableEnterHandling() {
          var _this257 = this;

          var e = this.editor,
              t = e.model,
              i = e.commands.get("enter");
          i && i.on("execute", function () {
            var e = t.document.selection.getFirstPosition();
            if (!e.parent.previousSibling) return;
            var i = t.createRangeIn(e.parent.previousSibling);

            _this257._checkAndApplyAutoLinkOnRange(i);
          });
        }
      }, {
        key: "_enableShiftEnterHandling",
        value: function _enableShiftEnterHandling() {
          var _this258 = this;

          var e = this.editor,
              t = e.model,
              i = e.commands.get("shiftEnter");
          i && i.on("execute", function () {
            var e = t.document.selection.getFirstPosition(),
                i = t.createRange(t.createPositionAt(e.parent, 0), e.getShiftedBy(-1));

            _this258._checkAndApplyAutoLinkOnRange(i);
          });
        }
      }, {
        key: "_checkAndApplyAutoLinkOnRange",
        value: function _checkAndApplyAutoLinkOnRange(e) {
          var t = this.editor.model,
              _Pu2 = Pu(e, t),
              i = _Pu2.text,
              n = _Pu2.range,
              o = Uf(i);

          if (o) {
            var _e285 = t.createRange(n.end.getShiftedBy(-o.length), n.end);

            this._applyAutoLink(o, _e285);
          }
        }
      }, {
        key: "_applyAutoLink",
        value: function _applyAutoLink(e, t) {
          var _this259 = this;

          var i = this.editor.model;
          this.isEnabled && function (e, t) {
            return t.schema.checkAttributeInSelection(t.createSelection(e), "linkHref");
          }(t, i) && i.enqueueChange(function (i) {
            var n = _this259.editor.config.get("link.defaultProtocol"),
                o = Sf(e, n);

            i.setAttribute("linkHref", o, t);
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "AutoLink";
        }
      }]);

      return Hf;
    }(Qe);

    function Uf(e) {
      var t = Ff.exec(e);
      return t ? t[2] : null;
    }

    var Wf =
    /*#__PURE__*/
    function (_Ze22) {
      _inherits(Wf, _Ze22);

      function Wf(e, t) {
        var _this260;

        _classCallCheck(this, Wf);

        _this260 = _possibleConstructorReturn(this, _getPrototypeOf(Wf).call(this, e)), _this260.type = t;
        return _this260;
      }

      _createClass(Wf, [{
        key: "refresh",
        value: function refresh() {
          this.value = this._getValue(), this.isEnabled = this._checkEnabled();
        }
      }, {
        key: "execute",
        value: function execute() {
          var _this261 = this;

          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var t = this.editor.model,
              i = t.document,
              n = Array.from(i.selection.getSelectedBlocks()).filter(function (e) {
            return $f(e, t.schema);
          }),
              o = void 0 !== e.forceValue ? !e.forceValue : this.value;
          t.change(function (e) {
            if (o) {
              var _t264 = n[n.length - 1].nextSibling,
                  _i279 = Number.POSITIVE_INFINITY,
                  _o102 = [];

              for (; _t264 && "listItem" == _t264.name && 0 !== _t264.getAttribute("listIndent");) {
                var _e286 = _t264.getAttribute("listIndent");

                _e286 < _i279 && (_i279 = _e286);

                var _n164 = _e286 - _i279;

                _o102.push({
                  element: _t264,
                  listIndent: _n164
                }), _t264 = _t264.nextSibling;
              }

              _o102 = _o102.reverse();
              var _iteratorNormalCompletion377 = true;
              var _didIteratorError377 = false;
              var _iteratorError377 = undefined;

              try {
                for (var _iterator377 = _o102[Symbol.iterator](), _step377; !(_iteratorNormalCompletion377 = (_step377 = _iterator377.next()).done); _iteratorNormalCompletion377 = true) {
                  var _t265 = _step377.value;
                  e.setAttribute("listIndent", _t265.listIndent, _t265.element);
                }
              } catch (err) {
                _didIteratorError377 = true;
                _iteratorError377 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion377 && _iterator377.return != null) {
                    _iterator377.return();
                  }
                } finally {
                  if (_didIteratorError377) {
                    throw _iteratorError377;
                  }
                }
              }
            }

            if (!o) {
              var _e287 = Number.POSITIVE_INFINITY;
              var _iteratorNormalCompletion378 = true;
              var _didIteratorError378 = false;
              var _iteratorError378 = undefined;

              try {
                for (var _iterator378 = n[Symbol.iterator](), _step378; !(_iteratorNormalCompletion378 = (_step378 = _iterator378.next()).done); _iteratorNormalCompletion378 = true) {
                  var _t266 = _step378.value;
                  _t266.is("element", "listItem") && _t266.getAttribute("listIndent") < _e287 && (_e287 = _t266.getAttribute("listIndent"));
                }
              } catch (err) {
                _didIteratorError378 = true;
                _iteratorError378 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion378 && _iterator378.return != null) {
                    _iterator378.return();
                  }
                } finally {
                  if (_didIteratorError378) {
                    throw _iteratorError378;
                  }
                }
              }

              _e287 = 0 === _e287 ? 1 : _e287, qf(n, !0, _e287), qf(n, !1, _e287);
            }

            var _iteratorNormalCompletion379 = true;
            var _didIteratorError379 = false;
            var _iteratorError379 = undefined;

            try {
              for (var _iterator379 = n.reverse()[Symbol.iterator](), _step379; !(_iteratorNormalCompletion379 = (_step379 = _iterator379.next()).done); _iteratorNormalCompletion379 = true) {
                var _t267 = _step379.value;
                o && "listItem" == _t267.name ? e.rename(_t267, "paragraph") : o || "listItem" == _t267.name ? o || "listItem" != _t267.name || _t267.getAttribute("listType") == _this261.type || e.setAttribute("listType", _this261.type, _t267) : (e.setAttributes({
                  listType: _this261.type,
                  listIndent: 0
                }, _t267), e.rename(_t267, "listItem"));
              }
            } catch (err) {
              _didIteratorError379 = true;
              _iteratorError379 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion379 && _iterator379.return != null) {
                  _iterator379.return();
                }
              } finally {
                if (_didIteratorError379) {
                  throw _iteratorError379;
                }
              }
            }

            _this261.fire("_executeCleanup", n);
          });
        }
      }, {
        key: "_getValue",
        value: function _getValue() {
          var e = Os(this.editor.model.document.selection.getSelectedBlocks());
          return !!e && e.is("element", "listItem") && e.getAttribute("listType") == this.type;
        }
      }, {
        key: "_checkEnabled",
        value: function _checkEnabled() {
          if (this.value) return !0;
          var e = this.editor.model.document.selection,
              t = this.editor.model.schema,
              i = Os(e.getSelectedBlocks());
          return !!i && $f(i, t);
        }
      }]);

      return Wf;
    }(Ze);

    function qf(e, t, i) {
      var n = t ? e[0] : e[e.length - 1];

      if (n.is("element", "listItem")) {
        var _o103 = n[t ? "previousSibling" : "nextSibling"],
            _r58 = n.getAttribute("listIndent");

        for (; _o103 && _o103.is("element", "listItem") && _o103.getAttribute("listIndent") >= i;) {
          _r58 > _o103.getAttribute("listIndent") && (_r58 = _o103.getAttribute("listIndent")), _o103.getAttribute("listIndent") == _r58 && e[t ? "unshift" : "push"](_o103), _o103 = _o103[t ? "previousSibling" : "nextSibling"];
        }
      }
    }

    function $f(e, t) {
      return t.checkChild(e.parent, "listItem") && !t.isObject(e);
    }

    var Yf =
    /*#__PURE__*/
    function (_Ze23) {
      _inherits(Yf, _Ze23);

      function Yf(e, t) {
        var _this262;

        _classCallCheck(this, Yf);

        _this262 = _possibleConstructorReturn(this, _getPrototypeOf(Yf).call(this, e)), _this262._indentBy = "forward" == t ? 1 : -1;
        return _this262;
      }

      _createClass(Yf, [{
        key: "refresh",
        value: function refresh() {
          this.isEnabled = this._checkEnabled();
        }
      }, {
        key: "execute",
        value: function execute() {
          var _this263 = this;

          var e = this.editor.model,
              t = e.document;
          var i = Array.from(t.selection.getSelectedBlocks());
          e.change(function (e) {
            var t = i[i.length - 1];
            var n = t.nextSibling;

            for (; n && "listItem" == n.name && n.getAttribute("listIndent") > t.getAttribute("listIndent");) {
              i.push(n), n = n.nextSibling;
            }

            _this263._indentBy < 0 && (i = i.reverse());
            var _iteratorNormalCompletion380 = true;
            var _didIteratorError380 = false;
            var _iteratorError380 = undefined;

            try {
              for (var _iterator380 = i[Symbol.iterator](), _step380; !(_iteratorNormalCompletion380 = (_step380 = _iterator380.next()).done); _iteratorNormalCompletion380 = true) {
                var _t268 = _step380.value;

                var _i280 = _t268.getAttribute("listIndent") + _this263._indentBy;

                _i280 < 0 ? e.rename(_t268, "paragraph") : e.setAttribute("listIndent", _i280, _t268);
              }
            } catch (err) {
              _didIteratorError380 = true;
              _iteratorError380 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion380 && _iterator380.return != null) {
                  _iterator380.return();
                }
              } finally {
                if (_didIteratorError380) {
                  throw _iteratorError380;
                }
              }
            }

            _this263.fire("_executeCleanup", i);
          });
        }
      }, {
        key: "_checkEnabled",
        value: function _checkEnabled() {
          var e = Os(this.editor.model.document.selection.getSelectedBlocks());
          if (!e || !e.is("element", "listItem")) return !1;

          if (this._indentBy > 0) {
            var _t269 = e.getAttribute("listIndent"),
                _i281 = e.getAttribute("listType");

            var _n165 = e.previousSibling;

            for (; _n165 && _n165.is("element", "listItem") && _n165.getAttribute("listIndent") >= _t269;) {
              if (_n165.getAttribute("listIndent") == _t269) return _n165.getAttribute("listType") == _i281;
              _n165 = _n165.previousSibling;
            }

            return !1;
          }

          return !0;
        }
      }]);

      return Yf;
    }(Ze);

    function Gf(e, t) {
      var i = t.mapper,
          n = t.writer,
          o = "numbered" == e.getAttribute("listType") ? "ol" : "ul",
          r = function (e) {
        var t = e.createContainerElement("li");
        return t.getFillerOffset = ep, t;
      }(n),
          s = n.createContainerElement(o, null);

      return n.insert(n.createPositionAt(s, 0), r), i.bindElements(e, r), r;
    }

    function Kf(e, t, i, n) {
      var o = t.parent,
          r = i.mapper,
          s = i.writer;
      var a = r.toViewPosition(n.createPositionBefore(e));
      var c = Zf(e.previousSibling, {
        sameIndent: !0,
        smallerIndent: !0,
        listIndent: e.getAttribute("listIndent")
      }),
          l = e.previousSibling;

      if (c && c.getAttribute("listIndent") == e.getAttribute("listIndent")) {
        var _e288 = r.toViewElement(c);

        a = s.breakContainer(s.createPositionAfter(_e288));
      } else if (l && "listItem" == l.name) {
        a = r.toViewPosition(n.createPositionAt(l, "end"));

        var _e289 = r.findMappedViewAncestor(a),
            _t270 = function (e) {
          var _iteratorNormalCompletion381 = true;
          var _didIteratorError381 = false;
          var _iteratorError381 = undefined;

          try {
            for (var _iterator381 = e.getChildren()[Symbol.iterator](), _step381; !(_iteratorNormalCompletion381 = (_step381 = _iterator381.next()).done); _iteratorNormalCompletion381 = true) {
              var _t271 = _step381.value;
              if ("ul" == _t271.name || "ol" == _t271.name) return _t271;
            }
          } catch (err) {
            _didIteratorError381 = true;
            _iteratorError381 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion381 && _iterator381.return != null) {
                _iterator381.return();
              }
            } finally {
              if (_didIteratorError381) {
                throw _iteratorError381;
              }
            }
          }

          return null;
        }(_e289);

        a = _t270 ? s.createPositionBefore(_t270) : s.createPositionAt(_e289, "end");
      } else a = r.toViewPosition(n.createPositionBefore(e));

      if (a = Jf(a), s.insert(a, o), l && "listItem" == l.name) {
        var _e290 = r.toViewElement(l),
            _i282 = s.createRange(s.createPositionAt(_e290, 0), a).getWalker({
          ignoreElementEnd: !0
        });

        var _iteratorNormalCompletion382 = true;
        var _didIteratorError382 = false;
        var _iteratorError382 = undefined;

        try {
          for (var _iterator382 = _i282[Symbol.iterator](), _step382; !(_iteratorNormalCompletion382 = (_step382 = _iterator382.next()).done); _iteratorNormalCompletion382 = true) {
            var _e291 = _step382.value;

            if (_e291.item.is("element", "li")) {
              var _n166 = s.breakContainer(s.createPositionBefore(_e291.item)),
                  _o104 = _e291.item.parent,
                  _r59 = s.createPositionAt(t, "end");

              Qf(s, _r59.nodeBefore, _r59.nodeAfter), s.move(s.createRangeOn(_o104), _r59), _i282.position = _n166;
            }
          }
        } catch (err) {
          _didIteratorError382 = true;
          _iteratorError382 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion382 && _iterator382.return != null) {
              _iterator382.return();
            }
          } finally {
            if (_didIteratorError382) {
              throw _iteratorError382;
            }
          }
        }
      } else {
        var _i283 = o.nextSibling;

        if (_i283 && (_i283.is("element", "ul") || _i283.is("element", "ol"))) {
          var _n167 = null;
          var _iteratorNormalCompletion383 = true;
          var _didIteratorError383 = false;
          var _iteratorError383 = undefined;

          try {
            for (var _iterator383 = _i283.getChildren()[Symbol.iterator](), _step383; !(_iteratorNormalCompletion383 = (_step383 = _iterator383.next()).done); _iteratorNormalCompletion383 = true) {
              var _t272 = _step383.value;

              var _i284 = r.toModelElement(_t272);

              if (!(_i284 && _i284.getAttribute("listIndent") > e.getAttribute("listIndent"))) break;
              _n167 = _t272;
            }
          } catch (err) {
            _didIteratorError383 = true;
            _iteratorError383 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion383 && _iterator383.return != null) {
                _iterator383.return();
              }
            } finally {
              if (_didIteratorError383) {
                throw _iteratorError383;
              }
            }
          }

          _n167 && (s.breakContainer(s.createPositionAfter(_n167)), s.move(s.createRangeOn(_n167.parent), s.createPositionAt(t, "end")));
        }
      }

      Qf(s, o, o.nextSibling), Qf(s, o.previousSibling, o);
    }

    function Qf(e, t, i) {
      return !t || !i || "ul" != t.name && "ol" != t.name || t.name != i.name || t.getAttribute("class") !== i.getAttribute("class") ? null : e.mergeContainers(e.createPositionAfter(t));
    }

    function Jf(e) {
      return e.getLastMatchingPosition(function (e) {
        return e.item.is("uiElement");
      });
    }

    function Zf(e, t) {
      var i = !!t.sameIndent,
          n = !!t.smallerIndent,
          o = t.listIndent;
      var r = e;

      for (; r && "listItem" == r.name;) {
        var _e292 = r.getAttribute("listIndent");

        if (i && o == _e292 || n && o > _e292) return r;
        r = "forward" === t.direction ? r.nextSibling : r.previousSibling;
      }

      return null;
    }

    function Xf(e, t, i, n) {
      e.ui.componentFactory.add(t, function (o) {
        var r = e.commands.get(t),
            s = new id(o);
        return s.set({
          label: i,
          icon: n,
          tooltip: !0,
          isToggleable: !0
        }), s.bind("isOn", "isEnabled").to(r, "value", "isEnabled"), s.on("execute", function () {
          e.execute(t), e.editing.view.focus();
        }), s;
      });
    }

    function ep() {
      var e = !this.isEmpty && ("ul" == this.getChild(0).name || "ol" == this.getChild(0).name);
      return this.isEmpty || e ? 0 : no.call(this);
    }

    function tp(e) {
      return function (t, i, n) {
        var o = n.consumable;
        if (!o.test(i.item, "insert") || !o.test(i.item, "attribute:listType") || !o.test(i.item, "attribute:listIndent")) return;
        o.consume(i.item, "insert"), o.consume(i.item, "attribute:listType"), o.consume(i.item, "attribute:listIndent");
        var r = i.item;
        Kf(r, Gf(r, n), n, e);
      };
    }

    function ip(e, t, i) {
      if (!i.consumable.consume(t.item, "attribute:listType")) return;
      var n = i.mapper.toViewElement(t.item),
          o = i.writer;
      o.breakContainer(o.createPositionBefore(n)), o.breakContainer(o.createPositionAfter(n));
      var r = n.parent,
          s = "numbered" == t.attributeNewValue ? "ol" : "ul";
      o.rename(s, r);
    }

    function np(e, t, i) {
      var n = i.mapper.toViewElement(t.item).parent,
          o = i.writer;
      Qf(o, n, n.nextSibling), Qf(o, n.previousSibling, n);
      var _iteratorNormalCompletion384 = true;
      var _didIteratorError384 = false;
      var _iteratorError384 = undefined;

      try {
        for (var _iterator384 = t.item.getChildren()[Symbol.iterator](), _step384; !(_iteratorNormalCompletion384 = (_step384 = _iterator384.next()).done); _iteratorNormalCompletion384 = true) {
          var _e293 = _step384.value;
          i.consumable.consume(_e293, "insert");
        }
      } catch (err) {
        _didIteratorError384 = true;
        _iteratorError384 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion384 && _iterator384.return != null) {
            _iterator384.return();
          }
        } finally {
          if (_didIteratorError384) {
            throw _iteratorError384;
          }
        }
      }
    }

    function op(e, t, i) {
      if ("listItem" != t.item.name) {
        var _e294 = i.mapper.toViewPosition(t.range.start);

        var _n168 = i.writer,
            _o105 = [];

        for (; ("ul" == _e294.parent.name || "ol" == _e294.parent.name) && (_e294 = _n168.breakContainer(_e294), "li" == _e294.parent.name);) {
          var _t273 = _e294,
              _i285 = _n168.createPositionAt(_e294.parent, "end");

          if (!_t273.isEqual(_i285)) {
            var _e295 = _n168.remove(_n168.createRange(_t273, _i285));

            _o105.push(_e295);
          }

          _e294 = _n168.createPositionAfter(_e294.parent);
        }

        if (_o105.length > 0) {
          for (var _t274 = 0; _t274 < _o105.length; _t274++) {
            var _i286 = _e294.nodeBefore;

            if (_e294 = _n168.insert(_e294, _o105[_t274]).end, _t274 > 0) {
              var _t275 = Qf(_n168, _i286, _i286.nextSibling);

              _t275 && _t275.parent == _i286 && _e294.offset--;
            }
          }

          Qf(_n168, _e294.nodeBefore, _e294.nodeAfter);
        }
      }
    }

    function rp(e, t, i) {
      var n = i.mapper.toViewPosition(t.position),
          o = n.nodeBefore,
          r = n.nodeAfter;
      Qf(i.writer, o, r);
    }

    function sp(e, t, i) {
      if (i.consumable.consume(t.viewItem, {
        name: !0
      })) {
        var _e296 = i.writer,
            _n169 = _e296.createElement("listItem"),
            _o106 = function (e) {
          var t = 0,
              i = e.parent;

          for (; i;) {
            if (i.is("element", "li")) t++;else {
              var _e297 = i.previousSibling;
              _e297 && _e297.is("element", "li") && t++;
            }
            i = i.parent;
          }

          return t;
        }(t.viewItem);

        _e296.setAttribute("listIndent", _o106, _n169);

        var _r60 = t.viewItem.parent && "ol" == t.viewItem.parent.name ? "numbered" : "bulleted";

        if (_e296.setAttribute("listType", _r60, _n169), !i.safeInsert(_n169, t.modelCursor)) return;

        var _s34 = function (e, t, i) {
          var n = i.writer,
              o = i.schema;
          var r = n.createPositionAfter(e);
          var _iteratorNormalCompletion385 = true;
          var _didIteratorError385 = false;
          var _iteratorError385 = undefined;

          try {
            for (var _iterator385 = t[Symbol.iterator](), _step385; !(_iteratorNormalCompletion385 = (_step385 = _iterator385.next()).done); _iteratorNormalCompletion385 = true) {
              var _s35 = _step385.value;
              if ("ul" == _s35.name || "ol" == _s35.name) r = i.convertItem(_s35, r).modelCursor;else {
                var _t276 = i.convertItem(_s35, n.createPositionAt(e, "end")),
                    _a23 = _t276.modelRange.start.nodeAfter;

                _a23 && _a23.is("element") && !o.checkChild(e, _a23.name) && (e = _t276.modelCursor.parent.is("element", "listItem") ? _t276.modelCursor.parent : hp(_t276.modelCursor), r = n.createPositionAfter(e));
              }
            }
          } catch (err) {
            _didIteratorError385 = true;
            _iteratorError385 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion385 && _iterator385.return != null) {
                _iterator385.return();
              }
            } finally {
              if (_didIteratorError385) {
                throw _iteratorError385;
              }
            }
          }

          return r;
        }(_n169, t.viewItem.getChildren(), i);

        t.modelRange = _e296.createRange(t.modelCursor, _s34), i.updateConversionResult(_n169, t);
      }
    }

    function ap(e, t, i) {
      if (i.consumable.test(t.viewItem, {
        name: !0
      })) {
        var _e298 = Array.from(t.viewItem.getChildren());

        for (var _i287 = 0, _e299 = _e298; _i287 < _e299.length; _i287++) {
          var _t277 = _e299[_i287];
          !(_t277.is("element", "li") || gp(_t277)) && _t277._remove();
        }
      }
    }

    function cp(e, t, i) {
      if (i.consumable.test(t.viewItem, {
        name: !0
      })) {
        if (0 === t.viewItem.childCount) return;

        var _e300 = _toConsumableArray(t.viewItem.getChildren());

        var _i288 = !1,
            _n170 = !0;

        var _iteratorNormalCompletion386 = true;
        var _didIteratorError386 = false;
        var _iteratorError386 = undefined;

        try {
          for (var _iterator386 = _e300[Symbol.iterator](), _step386; !(_iteratorNormalCompletion386 = (_step386 = _iterator386.next()).done); _iteratorNormalCompletion386 = true) {
            var _t278 = _step386.value;
            _i288 && !gp(_t278) && _t278._remove(), _t278.is("$text") ? (_n170 && (_t278._data = _t278.data.trimStart()), _t278.nextSibling && !gp(_t278.nextSibling) || (_t278._data = _t278.data.trimEnd())) : gp(_t278) && (_i288 = !0), _n170 = !1;
          }
        } catch (err) {
          _didIteratorError386 = true;
          _iteratorError386 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion386 && _iterator386.return != null) {
              _iterator386.return();
            }
          } finally {
            if (_didIteratorError386) {
              throw _iteratorError386;
            }
          }
        }
      }
    }

    function lp(e) {
      return function (t, i) {
        if (i.isPhantom) return;
        var n = i.modelPosition.nodeBefore;

        if (n && n.is("element", "listItem")) {
          var _t279 = i.mapper.toViewElement(n),
              _o107 = _t279.getAncestors().find(gp),
              _r61 = e.createPositionAt(_t279, 0).getWalker();

          var _iteratorNormalCompletion387 = true;
          var _didIteratorError387 = false;
          var _iteratorError387 = undefined;

          try {
            for (var _iterator387 = _r61[Symbol.iterator](), _step387; !(_iteratorNormalCompletion387 = (_step387 = _iterator387.next()).done); _iteratorNormalCompletion387 = true) {
              var _e301 = _step387.value;

              if ("elementStart" == _e301.type && _e301.item.is("element", "li")) {
                i.viewPosition = _e301.previousPosition;
                break;
              }

              if ("elementEnd" == _e301.type && _e301.item == _o107) {
                i.viewPosition = _e301.nextPosition;
                break;
              }
            }
          } catch (err) {
            _didIteratorError387 = true;
            _iteratorError387 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion387 && _iterator387.return != null) {
                _iterator387.return();
              }
            } finally {
              if (_didIteratorError387) {
                throw _iteratorError387;
              }
            }
          }
        }
      };
    }

    function dp(e, _ref174) {
      var _ref175 = _slicedToArray(_ref174, 2),
          t = _ref175[0],
          i = _ref175[1];

      var n,
          o = t.is("documentFragment") ? t.getChild(0) : t;

      if (n = i ? this.createSelection(i) : this.document.selection, o && o.is("element", "listItem")) {
        var _e302 = n.getFirstPosition();

        var _t280 = null;

        if (_e302.parent.is("element", "listItem") ? _t280 = _e302.parent : _e302.nodeBefore && _e302.nodeBefore.is("element", "listItem") && (_t280 = _e302.nodeBefore), _t280) {
          var _e303 = _t280.getAttribute("listIndent");

          if (_e303 > 0) for (; o && o.is("element", "listItem");) {
            o._setAttribute("listIndent", o.getAttribute("listIndent") + _e303), o = o.nextSibling;
          }
        }
      }
    }

    function hp(e) {
      var t = new ea({
        startPosition: e
      });
      var i;

      do {
        i = t.next();
      } while (!i.value.item.is("element", "listItem"));

      return i.value.item;
    }

    function up(e, t, i, n, o, r) {
      var s = Zf(t.nodeBefore, {
        sameIndent: !0,
        smallerIndent: !0,
        listIndent: e,
        foo: "b"
      }),
          a = o.mapper,
          c = o.writer,
          l = s ? s.getAttribute("listIndent") : null;
      var d;
      if (s) {
        if (l == e) {
          var _e304 = a.toViewElement(s).parent;
          d = c.createPositionAfter(_e304);
        } else {
          var _e305 = r.createPositionAt(s, "end");

          d = a.toViewPosition(_e305);
        }
      } else d = i;
      d = Jf(d);

      for (var _i289 = 0, _arr = _toConsumableArray(n.getChildren()); _i289 < _arr.length; _i289++) {
        var _e306 = _arr[_i289];
        gp(_e306) && (d = c.move(c.createRangeOn(_e306), d).end, Qf(c, _e306, _e306.nextSibling), Qf(c, _e306.previousSibling, _e306));
      }
    }

    function gp(e) {
      return e.is("element", "ol") || e.is("element", "ul");
    }

    var mp =
    /*#__PURE__*/
    function (_Qe56) {
      _inherits(mp, _Qe56);

      function mp() {
        _classCallCheck(this, mp);

        return _possibleConstructorReturn(this, _getPrototypeOf(mp).apply(this, arguments));
      }

      _createClass(mp, [{
        key: "init",
        value: function init() {
          var _this264 = this;

          var e = this.editor;
          e.model.schema.register("listItem", {
            inheritAllFrom: "$block",
            allowAttributes: ["listType", "listIndent"]
          });
          var t = e.data,
              i = e.editing;
          var n;
          e.model.document.registerPostFixer(function (t) {
            return function (e, t) {
              var i = e.document.differ.getChanges(),
                  n = new Map();
              var o = !1;
              var _iteratorNormalCompletion388 = true;
              var _didIteratorError388 = false;
              var _iteratorError388 = undefined;

              try {
                for (var _iterator388 = i[Symbol.iterator](), _step388; !(_iteratorNormalCompletion388 = (_step388 = _iterator388.next()).done); _iteratorNormalCompletion388 = true) {
                  var _n172 = _step388.value;
                  if ("insert" == _n172.type && "listItem" == _n172.name) r(_n172.position);else if ("insert" == _n172.type && "listItem" != _n172.name) {
                    if ("$text" != _n172.name) {
                      var _i290 = _n172.position.nodeAfter;
                      _i290.hasAttribute("listIndent") && (t.removeAttribute("listIndent", _i290), o = !0), _i290.hasAttribute("listType") && (t.removeAttribute("listType", _i290), o = !0), _i290.hasAttribute("listStyle") && (t.removeAttribute("listStyle", _i290), o = !0);
                      var _iteratorNormalCompletion390 = true;
                      var _didIteratorError390 = false;
                      var _iteratorError390 = undefined;

                      try {
                        for (var _iterator390 = Array.from(e.createRangeIn(_i290)).filter(function (e) {
                          return e.item.is("element", "listItem");
                        })[Symbol.iterator](), _step390; !(_iteratorNormalCompletion390 = (_step390 = _iterator390.next()).done); _iteratorNormalCompletion390 = true) {
                          var _t283 = _step390.value;
                          r(_t283.previousPosition);
                        }
                      } catch (err) {
                        _didIteratorError390 = true;
                        _iteratorError390 = err;
                      } finally {
                        try {
                          if (!_iteratorNormalCompletion390 && _iterator390.return != null) {
                            _iterator390.return();
                          }
                        } finally {
                          if (_didIteratorError390) {
                            throw _iteratorError390;
                          }
                        }
                      }
                    }

                    r(_n172.position.getShiftedBy(_n172.length));
                  } else "remove" == _n172.type && "listItem" == _n172.name ? r(_n172.position) : ("attribute" == _n172.type && "listIndent" == _n172.attributeKey || "attribute" == _n172.type && "listType" == _n172.attributeKey) && r(_n172.range.start);
                }
              } catch (err) {
                _didIteratorError388 = true;
                _iteratorError388 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion388 && _iterator388.return != null) {
                    _iterator388.return();
                  }
                } finally {
                  if (_didIteratorError388) {
                    throw _iteratorError388;
                  }
                }
              }

              var _iteratorNormalCompletion389 = true;
              var _didIteratorError389 = false;
              var _iteratorError389 = undefined;

              try {
                for (var _iterator389 = n.values()[Symbol.iterator](), _step389; !(_iteratorNormalCompletion389 = (_step389 = _iterator389.next()).done); _iteratorNormalCompletion389 = true) {
                  var _e308 = _step389.value;
                  s(_e308), a(_e308);
                }
              } catch (err) {
                _didIteratorError389 = true;
                _iteratorError389 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion389 && _iterator389.return != null) {
                    _iterator389.return();
                  }
                } finally {
                  if (_didIteratorError389) {
                    throw _iteratorError389;
                  }
                }
              }

              return o;

              function r(e) {
                var t = e.nodeBefore;

                if (t && t.is("element", "listItem")) {
                  var _e307 = t;
                  if (n.has(_e307)) return;

                  for (var _t281 = _e307.previousSibling; _t281 && _t281.is("element", "listItem"); _t281 = _e307.previousSibling) {
                    if (_e307 = _t281, n.has(_e307)) return;
                  }

                  n.set(t, _e307);
                } else {
                  var _t282 = e.nodeAfter;
                  _t282 && _t282.is("element", "listItem") && n.set(_t282, _t282);
                }
              }

              function s(e) {
                var i = 0,
                    n = null;

                for (; e && e.is("element", "listItem");) {
                  var _r62 = e.getAttribute("listIndent");

                  if (_r62 > i) {
                    var _s36 = void 0;

                    null === n ? (n = _r62 - i, _s36 = i) : (n > _r62 && (n = _r62), _s36 = _r62 - n), t.setAttribute("listIndent", _s36, e), o = !0;
                  } else n = null, i = e.getAttribute("listIndent") + 1;

                  e = e.nextSibling;
                }
              }

              function a(e) {
                var i = [],
                    n = null;

                for (; e && e.is("element", "listItem");) {
                  var _r63 = e.getAttribute("listIndent");

                  if (n && n.getAttribute("listIndent") > _r63 && (i = i.slice(0, _r63 + 1)), 0 != _r63) if (i[_r63]) {
                    var _n171 = i[_r63];
                    e.getAttribute("listType") != _n171 && (t.setAttribute("listType", _n171, e), o = !0);
                  } else i[_r63] = e.getAttribute("listType");
                  n = e, e = e.nextSibling;
                }
              }
            }(e.model, t);
          }), i.mapper.registerViewToModelLength("li", fp), t.mapper.registerViewToModelLength("li", fp), i.mapper.on("modelToViewPosition", lp(i.view)), i.mapper.on("viewToModelPosition", (n = e.model, function (e, t) {
            var i = t.viewPosition,
                o = i.parent,
                r = t.mapper;

            if ("ul" == o.name || "ol" == o.name) {
              if (i.isAtEnd) {
                var _e309 = r.toModelElement(i.nodeBefore),
                    _o108 = r.getModelLength(i.nodeBefore);

                t.modelPosition = n.createPositionBefore(_e309).getShiftedBy(_o108);
              } else {
                var _e310 = r.toModelElement(i.nodeAfter);

                t.modelPosition = n.createPositionBefore(_e310);
              }

              e.stop();
            } else if ("li" == o.name && i.nodeBefore && ("ul" == i.nodeBefore.name || "ol" == i.nodeBefore.name)) {
              var _s37 = r.toModelElement(o);

              var _a24 = 1,
                  _c13 = i.nodeBefore;

              for (; _c13 && gp(_c13);) {
                _a24 += r.getModelLength(_c13), _c13 = _c13.previousSibling;
              }

              t.modelPosition = n.createPositionBefore(_s37).getShiftedBy(_a24), e.stop();
            }
          })), t.mapper.on("modelToViewPosition", lp(i.view)), e.conversion.for("editingDowncast").add(function (t) {
            t.on("insert", op, {
              priority: "high"
            }), t.on("insert:listItem", tp(e.model)), t.on("attribute:listType:listItem", ip, {
              priority: "high"
            }), t.on("attribute:listType:listItem", np, {
              priority: "low"
            }), t.on("attribute:listIndent:listItem", function (e) {
              return function (t, i, n) {
                if (!n.consumable.consume(i.item, "attribute:listIndent")) return;
                var o = n.mapper.toViewElement(i.item),
                    r = n.writer;
                r.breakContainer(r.createPositionBefore(o)), r.breakContainer(r.createPositionAfter(o));
                var s = o.parent,
                    a = s.previousSibling,
                    c = r.createRangeOn(s);
                r.remove(c), a && a.nextSibling && Qf(r, a, a.nextSibling), up(i.attributeOldValue + 1, i.range.start, c.start, o, n, e), Kf(i.item, o, n, e);
                var _iteratorNormalCompletion391 = true;
                var _didIteratorError391 = false;
                var _iteratorError391 = undefined;

                try {
                  for (var _iterator391 = i.item.getChildren()[Symbol.iterator](), _step391; !(_iteratorNormalCompletion391 = (_step391 = _iterator391.next()).done); _iteratorNormalCompletion391 = true) {
                    var _e311 = _step391.value;
                    n.consumable.consume(_e311, "insert");
                  }
                } catch (err) {
                  _didIteratorError391 = true;
                  _iteratorError391 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion391 && _iterator391.return != null) {
                      _iterator391.return();
                    }
                  } finally {
                    if (_didIteratorError391) {
                      throw _iteratorError391;
                    }
                  }
                }
              };
            }(e.model)), t.on("remove:listItem", function (e) {
              return function (t, i, n) {
                var o = n.mapper.toViewPosition(i.position).getLastMatchingPosition(function (e) {
                  return !e.item.is("element", "li");
                }).nodeAfter,
                    r = n.writer;
                r.breakContainer(r.createPositionBefore(o)), r.breakContainer(r.createPositionAfter(o));
                var s = o.parent,
                    a = s.previousSibling,
                    c = r.createRangeOn(s),
                    l = r.remove(c);
                a && a.nextSibling && Qf(r, a, a.nextSibling);
                up(n.mapper.toModelElement(o).getAttribute("listIndent") + 1, i.position, c.start, o, n, e);
                var _iteratorNormalCompletion392 = true;
                var _didIteratorError392 = false;
                var _iteratorError392 = undefined;

                try {
                  for (var _iterator392 = r.createRangeIn(l).getItems()[Symbol.iterator](), _step392; !(_iteratorNormalCompletion392 = (_step392 = _iterator392.next()).done); _iteratorNormalCompletion392 = true) {
                    var _e312 = _step392.value;
                    n.mapper.unbindViewElement(_e312);
                  }
                } catch (err) {
                  _didIteratorError392 = true;
                  _iteratorError392 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion392 && _iterator392.return != null) {
                      _iterator392.return();
                    }
                  } finally {
                    if (_didIteratorError392) {
                      throw _iteratorError392;
                    }
                  }
                }

                t.stop();
              };
            }(e.model)), t.on("remove", rp, {
              priority: "low"
            });
          }), e.conversion.for("dataDowncast").add(function (t) {
            t.on("insert", op, {
              priority: "high"
            }), t.on("insert:listItem", tp(e.model));
          }), e.conversion.for("upcast").add(function (e) {
            e.on("element:ul", ap, {
              priority: "high"
            }), e.on("element:ol", ap, {
              priority: "high"
            }), e.on("element:li", cp, {
              priority: "high"
            }), e.on("element:li", sp);
          }), e.model.on("insertContent", dp, {
            priority: "high"
          }), e.commands.add("numberedList", new Wf(e, "numbered")), e.commands.add("bulletedList", new Wf(e, "bulleted")), e.commands.add("indentList", new Yf(e, "forward")), e.commands.add("outdentList", new Yf(e, "backward"));
          var o = i.view.document;
          this.listenTo(o, "enter", function (e, t) {
            var i = _this264.editor.model.document,
                n = i.selection.getLastPosition().parent;
            i.selection.isCollapsed && "listItem" == n.name && n.isEmpty && (_this264.editor.execute("outdentList"), t.preventDefault(), e.stop());
          }, {
            context: "li"
          }), this.listenTo(o, "delete", function (e, t) {
            if ("backward" !== t.direction) return;
            var i = _this264.editor.model.document.selection;
            if (!i.isCollapsed) return;
            var n = i.getFirstPosition();
            if (!n.isAtStart) return;
            var o = n.parent;
            if ("listItem" !== o.name) return;
            o.previousSibling && "listItem" === o.previousSibling.name || (_this264.editor.execute("outdentList"), t.preventDefault(), e.stop());
          }, {
            context: "li"
          });

          var r = function r(e) {
            return function (t, i) {
              _this264.editor.commands.get(e).isEnabled && (_this264.editor.execute(e), i());
            };
          };

          e.keystrokes.set("Tab", r("indentList")), e.keystrokes.set("Shift+Tab", r("outdentList"));
        }
      }, {
        key: "afterInit",
        value: function afterInit() {
          var e = this.editor.commands,
              t = e.get("indent"),
              i = e.get("outdent");
          t && t.registerChildCommand(e.get("indentList")), i && i.registerChildCommand(e.get("outdentList"));
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "ListEditing";
        }
      }, {
        key: "requires",
        get: function get() {
          return [Eh, Mh];
        }
      }]);

      return mp;
    }(Qe);

    function fp(e) {
      var t = 1;
      var _iteratorNormalCompletion393 = true;
      var _didIteratorError393 = false;
      var _iteratorError393 = undefined;

      try {
        for (var _iterator393 = e.getChildren()[Symbol.iterator](), _step393; !(_iteratorNormalCompletion393 = (_step393 = _iterator393.next()).done); _iteratorNormalCompletion393 = true) {
          var _i291 = _step393.value;

          if ("ul" == _i291.name || "ol" == _i291.name) {
            var _iteratorNormalCompletion394 = true;
            var _didIteratorError394 = false;
            var _iteratorError394 = undefined;

            try {
              for (var _iterator394 = _i291.getChildren()[Symbol.iterator](), _step394; !(_iteratorNormalCompletion394 = (_step394 = _iterator394.next()).done); _iteratorNormalCompletion394 = true) {
                var _e313 = _step394.value;
                t += fp(_e313);
              }
            } catch (err) {
              _didIteratorError394 = true;
              _iteratorError394 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion394 && _iterator394.return != null) {
                  _iterator394.return();
                }
              } finally {
                if (_didIteratorError394) {
                  throw _iteratorError394;
                }
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError393 = true;
        _iteratorError393 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion393 && _iterator393.return != null) {
            _iterator393.return();
          }
        } finally {
          if (_didIteratorError393) {
            throw _iteratorError393;
          }
        }
      }

      return t;
    }

    var pp =
    /*#__PURE__*/
    function (_Qe57) {
      _inherits(pp, _Qe57);

      function pp() {
        _classCallCheck(this, pp);

        return _possibleConstructorReturn(this, _getPrototypeOf(pp).apply(this, arguments));
      }

      _createClass(pp, [{
        key: "init",
        value: function init() {
          var e = this.editor.t;
          Xf(this.editor, "numberedList", e("Numbered List"), '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M7 5.75c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zM3.5 3v5H2V3.7H1v-1h2.5V3zM.343 17.857l2.59-3.257H2.92a.6.6 0 1 0-1.04 0H.302a2 2 0 1 1 3.995 0h-.001c-.048.405-.16.734-.333.988-.175.254-.59.692-1.244 1.312H4.3v1h-4l.043-.043zM7 14.75a.75.75 0 0 1 .75-.75h9.5a.75.75 0 1 1 0 1.5h-9.5a.75.75 0 0 1-.75-.75z"/></svg>'), Xf(this.editor, "bulletedList", e("Bulleted List"), '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M7 5.75c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zm-6 0C1 4.784 1.777 4 2.75 4c.966 0 1.75.777 1.75 1.75 0 .966-.777 1.75-1.75 1.75C1.784 7.5 1 6.723 1 5.75zm6 9c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zm-6 0c0-.966.777-1.75 1.75-1.75.966 0 1.75.777 1.75 1.75 0 .966-.777 1.75-1.75 1.75-.966 0-1.75-.777-1.75-1.75z"/></svg>');
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "ListUI";
        }
      }]);

      return pp;
    }(Qe);

    function bp(e, t) {
      return function (e) {
        e.on("attribute:url:media", i);
      };

      function i(i, n, o) {
        if (!o.consumable.consume(n.item, i.name)) return;

        var r = n.attributeNewValue,
            s = o.writer,
            a = o.mapper.toViewElement(n.item),
            c = _toConsumableArray(a.getChildren()).find(function (e) {
          return e.getCustomProperty("media-content");
        });

        s.remove(c);
        var l = e.getMediaViewElement(s, r, t);
        s.insert(s.createPositionAt(a, 0), l);
      }
    }

    function wp(e, t, i, n) {
      var o = e.createContainerElement("figure", {
        class: "media"
      });
      return e.insert(e.createPositionAt(o, 0), t.getMediaViewElement(e, i, n)), o;
    }

    function kp(e) {
      var t = e.getSelectedElement();
      return t && t.is("element", "media") ? t : null;
    }

    function _p(e, t, i) {
      e.change(function (n) {
        var o = n.createElement("media", {
          url: t
        });
        e.insertContent(o, i), n.setSelection(o, "on");
      });
    }

    var vp =
    /*#__PURE__*/
    function (_Ze24) {
      _inherits(vp, _Ze24);

      function vp() {
        _classCallCheck(this, vp);

        return _possibleConstructorReturn(this, _getPrototypeOf(vp).apply(this, arguments));
      }

      _createClass(vp, [{
        key: "refresh",
        value: function refresh() {
          var e = this.editor.model,
              t = e.document.selection,
              i = kp(t);
          this.value = i ? i.getAttribute("url") : null, this.isEnabled = function (e) {
            var t = e.getSelectedElement();
            return !!t && "media" === t.name;
          }(t) || function (e, t) {
            var i = Uh(e, t).start.parent;
            i.isEmpty && !t.schema.isLimit(i) && (i = i.parent);
            return t.schema.checkChild(i, "media");
          }(t, e);
        }
      }, {
        key: "execute",
        value: function execute(e) {
          var t = this.editor.model,
              i = t.document.selection,
              n = kp(i);
          n ? t.change(function (t) {
            t.setAttribute("url", e, n);
          }) : _p(t, e, Uh(i, t));
        }
      }]);

      return vp;
    }(Ze);

    var yp =
    /*#__PURE__*/
    function () {
      function yp(e, t) {
        _classCallCheck(this, yp);

        var i = t.providers,
            n = t.extraProviders || [],
            o = new Set(t.removeProviders),
            r = i.concat(n).filter(function (e) {
          var t = e.name;
          return t ? !o.has(t) : (Object(c.b)("media-embed-no-provider-name", {
            provider: e
          }), !1);
        });
        this.locale = e, this.providerDefinitions = r;
      }

      _createClass(yp, [{
        key: "hasMedia",
        value: function hasMedia(e) {
          return !!this._getMedia(e);
        }
      }, {
        key: "getMediaViewElement",
        value: function getMediaViewElement(e, t, i) {
          return this._getMedia(t).getViewElement(e, i);
        }
      }, {
        key: "_getMedia",
        value: function _getMedia(e) {
          if (!e) return new xp(this.locale);
          e = e.trim();
          var _iteratorNormalCompletion395 = true;
          var _didIteratorError395 = false;
          var _iteratorError395 = undefined;

          try {
            for (var _iterator395 = this.providerDefinitions[Symbol.iterator](), _step395; !(_iteratorNormalCompletion395 = (_step395 = _iterator395.next()).done); _iteratorNormalCompletion395 = true) {
              var _t284 = _step395.value;

              var _i292 = _t284.html,
                  _n173 = en(_t284.url);

              var _iteratorNormalCompletion396 = true;
              var _didIteratorError396 = false;
              var _iteratorError396 = undefined;

              try {
                for (var _iterator396 = _n173[Symbol.iterator](), _step396; !(_iteratorNormalCompletion396 = (_step396 = _iterator396.next()).done); _iteratorNormalCompletion396 = true) {
                  var _t285 = _step396.value;

                  var _n174 = this._getUrlMatches(e, _t285);

                  if (_n174) return new xp(this.locale, e, _n174, _i292);
                }
              } catch (err) {
                _didIteratorError396 = true;
                _iteratorError396 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion396 && _iterator396.return != null) {
                    _iterator396.return();
                  }
                } finally {
                  if (_didIteratorError396) {
                    throw _iteratorError396;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError395 = true;
            _iteratorError395 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion395 && _iterator395.return != null) {
                _iterator395.return();
              }
            } finally {
              if (_didIteratorError395) {
                throw _iteratorError395;
              }
            }
          }

          return null;
        }
      }, {
        key: "_getUrlMatches",
        value: function _getUrlMatches(e, t) {
          var i = e.match(t);
          if (i) return i;
          var n = e.replace(/^https?:\/\//, "");
          return i = n.match(t), i || (n = n.replace(/^www\./, ""), i = n.match(t), i || null);
        }
      }]);

      return yp;
    }();

    var xp =
    /*#__PURE__*/
    function () {
      function xp(e, t, i, n) {
        _classCallCheck(this, xp);

        this.url = this._getValidUrl(t), this._t = e.t, this._match = i, this._previewRenderer = n;
      }

      _createClass(xp, [{
        key: "getViewElement",
        value: function getViewElement(e, t) {
          var i = {};
          var n;

          if (t.renderForEditingView || t.renderMediaPreview && this.url && this._previewRenderer) {
            this.url && (i["data-oembed-url"] = this.url), t.renderForEditingView && (i.class = "ck-media__wrapper");

            var _o109 = this._getPreviewHtml(t);

            n = e.createRawElement("div", i, function (e) {
              e.innerHTML = _o109;
            });
          } else this.url && (i.url = this.url), n = e.createEmptyElement(t.elementName, i);

          return e.setCustomProperty("media-content", !0, n), n;
        }
      }, {
        key: "_getPreviewHtml",
        value: function _getPreviewHtml(e) {
          return this._previewRenderer ? this._previewRenderer(this._match) : this.url && e.renderForEditingView ? this._getPlaceholderHtml() : "";
        }
      }, {
        key: "_getPlaceholderHtml",
        value: function _getPlaceholderHtml() {
          var e = new td(),
              t = new ed();
          e.text = this._t("Open media in new tab"), t.content = '<svg viewBox="0 0 64 42" xmlns="http://www.w3.org/2000/svg"><path d="M47.426 17V3.713L63.102 0v19.389h-.001l.001.272c0 1.595-2.032 3.43-4.538 4.098-2.506.668-4.538-.083-4.538-1.678 0-1.594 2.032-3.43 4.538-4.098.914-.244 2.032-.565 2.888-.603V4.516L49.076 7.447v9.556A1.014 1.014 0 0 0 49 17h-1.574zM29.5 17h-8.343a7.073 7.073 0 1 0-4.657 4.06v3.781H3.3a2.803 2.803 0 0 1-2.8-2.804V8.63a2.803 2.803 0 0 1 2.8-2.805h4.082L8.58 2.768A1.994 1.994 0 0 1 10.435 1.5h8.985c.773 0 1.477.448 1.805 1.149l1.488 3.177H26.7c1.546 0 2.8 1.256 2.8 2.805V17zm-11.637 0H17.5a1 1 0 0 0-1 1v.05A4.244 4.244 0 1 1 17.863 17zm29.684 2c.97 0 .953-.048.953.889v20.743c0 .953.016.905-.953.905H19.453c-.97 0-.953.048-.953-.905V19.89c0-.937-.016-.889.97-.889h28.077zm-4.701 19.338V22.183H24.154v16.155h18.692zM20.6 21.375v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616V37.53H20.6zm24.233-16.155v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615V37.53h-1.615zM29.485 25.283a.4.4 0 0 1 .593-.35l9.05 4.977a.4.4 0 0 1 0 .701l-9.05 4.978a.4.4 0 0 1-.593-.35v-9.956z"/></svg>', t.viewBox = "0 0 64 42";
          return new Ol({
            tag: "div",
            attributes: {
              class: "ck ck-reset_all ck-media__placeholder"
            },
            children: [{
              tag: "div",
              attributes: {
                class: "ck-media__placeholder__icon"
              },
              children: [t]
            }, {
              tag: "a",
              attributes: {
                class: "ck-media__placeholder__url",
                target: "_blank",
                rel: "noopener noreferrer",
                href: this.url
              },
              children: [{
                tag: "span",
                attributes: {
                  class: "ck-media__placeholder__url__text"
                },
                children: [this.url]
              }, e]
            }]
          }).render().outerHTML;
        }
      }, {
        key: "_getValidUrl",
        value: function _getValidUrl(e) {
          return e ? e.match(/^https?/) ? e : "https://" + e : null;
        }
      }]);

      return xp;
    }();

    i(94);

    var Ap =
    /*#__PURE__*/
    function (_Qe58) {
      _inherits(Ap, _Qe58);

      _createClass(Ap, null, [{
        key: "pluginName",
        get: function get() {
          return "MediaEmbedEditing";
        }
      }]);

      function Ap(e) {
        var _this265;

        _classCallCheck(this, Ap);

        _this265 = _possibleConstructorReturn(this, _getPrototypeOf(Ap).call(this, e)), e.config.define("mediaEmbed", {
          elementName: "oembed",
          providers: [{
            name: "dailymotion",
            url: /^dailymotion\.com\/video\/(\w+)/,
            html: function html(e) {
              return "<div style=\"position: relative; padding-bottom: 100%; height: 0; \"><iframe src=\"https://www.dailymotion.com/embed/video/".concat(e[1], "\" style=\"position: absolute; width: 100%; height: 100%; top: 0; left: 0;\" frameborder=\"0\" width=\"480\" height=\"270\" allowfullscreen allow=\"autoplay\"></iframe></div>");
            }
          }, {
            name: "spotify",
            url: [/^open\.spotify\.com\/(artist\/\w+)/, /^open\.spotify\.com\/(album\/\w+)/, /^open\.spotify\.com\/(track\/\w+)/],
            html: function html(e) {
              return "<div style=\"position: relative; padding-bottom: 100%; height: 0; padding-bottom: 126%;\"><iframe src=\"https://open.spotify.com/embed/".concat(e[1], "\" style=\"position: absolute; width: 100%; height: 100%; top: 0; left: 0;\" frameborder=\"0\" allowtransparency=\"true\" allow=\"encrypted-media\"></iframe></div>");
            }
          }, {
            name: "youtube",
            url: [/^(?:m\.)?youtube\.com\/watch\?v=([\w-]+)/, /^(?:m\.)?youtube\.com\/v\/([\w-]+)/, /^youtube\.com\/embed\/([\w-]+)/, /^youtu\.be\/([\w-]+)/],
            html: function html(e) {
              return "<div style=\"position: relative; padding-bottom: 100%; height: 0; padding-bottom: 56.2493%;\"><iframe src=\"https://www.youtube.com/embed/".concat(e[1], "\" style=\"position: absolute; width: 100%; height: 100%; top: 0; left: 0;\" frameborder=\"0\" allow=\"autoplay; encrypted-media\" allowfullscreen></iframe></div>");
            }
          }, {
            name: "vimeo",
            url: [/^vimeo\.com\/(\d+)/, /^vimeo\.com\/[^/]+\/[^/]+\/video\/(\d+)/, /^vimeo\.com\/album\/[^/]+\/video\/(\d+)/, /^vimeo\.com\/channels\/[^/]+\/(\d+)/, /^vimeo\.com\/groups\/[^/]+\/videos\/(\d+)/, /^vimeo\.com\/ondemand\/[^/]+\/(\d+)/, /^player\.vimeo\.com\/video\/(\d+)/],
            html: function html(e) {
              return "<div style=\"position: relative; padding-bottom: 100%; height: 0; padding-bottom: 56.2493%;\"><iframe src=\"https://player.vimeo.com/video/".concat(e[1], "\" style=\"position: absolute; width: 100%; height: 100%; top: 0; left: 0;\" frameborder=\"0\" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe></div>");
            }
          }, {
            name: "instagram",
            url: /^instagram\.com\/p\/(\w+)/
          }, {
            name: "twitter",
            url: /^twitter\.com/
          }, {
            name: "googleMaps",
            url: [/^google\.com\/maps/, /^goo\.gl\/maps/, /^maps\.google\.com/, /^maps\.app\.goo\.gl/]
          }, {
            name: "flickr",
            url: /^flickr\.com/
          }, {
            name: "facebook",
            url: /^facebook\.com/
          }]
        }), _this265.registry = new yp(e.locale, e.config.get("mediaEmbed"));
        return _this265;
      }

      _createClass(Ap, [{
        key: "init",
        value: function init() {
          var e = this.editor,
              t = e.model.schema,
              i = e.t,
              n = e.conversion,
              o = e.config.get("mediaEmbed.previewsInData"),
              r = e.config.get("mediaEmbed.elementName"),
              s = this.registry;
          e.commands.add("mediaEmbed", new vp(e)), t.register("media", {
            isObject: !0,
            isBlock: !0,
            allowWhere: "$block",
            allowAttributes: ["url"]
          }), n.for("dataDowncast").elementToElement({
            model: "media",
            view: function view(e, _ref176) {
              var t = _ref176.writer;
              var i = e.getAttribute("url");
              return wp(t, s, i, {
                elementName: r,
                renderMediaPreview: i && o
              });
            }
          }), n.for("dataDowncast").add(bp(s, {
            elementName: r,
            renderMediaPreview: o
          })), n.for("editingDowncast").elementToElement({
            model: "media",
            view: function view(e, _ref177) {
              var t = _ref177.writer;
              var n = e.getAttribute("url");
              return function (e, t, i) {
                return t.setCustomProperty("media", !0, e), Lh(e, t, {
                  label: i
                });
              }(wp(t, s, n, {
                elementName: r,
                renderForEditingView: !0
              }), t, i("media widget"));
            }
          }), n.for("editingDowncast").add(bp(s, {
            elementName: r,
            renderForEditingView: !0
          })), n.for("upcast").elementToElement({
            view: function view(e) {
              return ["oembed", r].includes(e.name) && e.getAttribute("url") ? {
                name: !0
              } : null;
            },
            model: function model(e, _ref178) {
              var t = _ref178.writer;
              var i = e.getAttribute("url");
              if (s.hasMedia(i)) return t.createElement("media", {
                url: i
              });
            }
          }).elementToElement({
            view: {
              name: "div",
              attributes: {
                "data-oembed-url": !0
              }
            },
            model: function model(e, _ref179) {
              var t = _ref179.writer;
              var i = e.getAttribute("data-oembed-url");
              if (s.hasMedia(i)) return t.createElement("media", {
                url: i
              });
            }
          });
        }
      }]);

      return Ap;
    }(Qe);

    var Cp = /^(?:http(s)?:\/\/)?[\w-]+\.[\w-.~:/?#[\]@!$&'()*+,;=%]+$/;

    var Tp =
    /*#__PURE__*/
    function (_Qe59) {
      _inherits(Tp, _Qe59);

      _createClass(Tp, null, [{
        key: "requires",
        get: function get() {
          return [hu, og];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "AutoMediaEmbed";
        }
      }]);

      function Tp(e) {
        var _this266;

        _classCallCheck(this, Tp);

        _this266 = _possibleConstructorReturn(this, _getPrototypeOf(Tp).call(this, e)), _this266._timeoutId = null, _this266._positionToInsert = null;
        return _this266;
      }

      _createClass(Tp, [{
        key: "init",
        value: function init() {
          var _this267 = this;

          var e = this.editor,
              t = e.model.document;
          this.listenTo(e.plugins.get("ClipboardPipeline"), "inputTransformation", function () {
            var e = t.selection.getFirstRange(),
                i = il.fromPosition(e.start);
            i.stickiness = "toPrevious";
            var n = il.fromPosition(e.end);
            n.stickiness = "toNext", t.once("change:data", function () {
              _this267._embedMediaBetweenPositions(i, n), i.detach(), n.detach();
            }, {
              priority: "high"
            });
          }), e.commands.get("undo").on("execute", function () {
            _this267._timeoutId && (vr.window.clearTimeout(_this267._timeoutId), _this267._positionToInsert.detach(), _this267._timeoutId = null, _this267._positionToInsert = null);
          }, {
            priority: "high"
          });
        }
      }, {
        key: "_embedMediaBetweenPositions",
        value: function _embedMediaBetweenPositions(e, t) {
          var _this268 = this;

          var i = this.editor,
              n = i.plugins.get(Ap).registry,
              o = new ka(e, t),
              r = o.getWalker({
            ignoreElementEnd: !0
          });
          var s = "";
          var _iteratorNormalCompletion397 = true;
          var _didIteratorError397 = false;
          var _iteratorError397 = undefined;

          try {
            for (var _iterator397 = r[Symbol.iterator](), _step397; !(_iteratorNormalCompletion397 = (_step397 = _iterator397.next()).done); _iteratorNormalCompletion397 = true) {
              var _e314 = _step397.value;
              _e314.item.is("$textProxy") && (s += _e314.item.data);
            }
          } catch (err) {
            _didIteratorError397 = true;
            _iteratorError397 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion397 && _iterator397.return != null) {
                _iterator397.return();
              }
            } finally {
              if (_didIteratorError397) {
                throw _iteratorError397;
              }
            }
          }

          if (s = s.trim(), !s.match(Cp)) return void o.detach();
          if (!n.hasMedia(s)) return void o.detach();
          i.commands.get("mediaEmbed").isEnabled ? (this._positionToInsert = il.fromPosition(e), this._timeoutId = vr.window.setTimeout(function () {
            i.model.change(function (e) {
              var t;
              _this268._timeoutId = null, e.remove(o), o.detach(), "$graveyard" !== _this268._positionToInsert.root.rootName && (t = _this268._positionToInsert), _p(i.model, s, t), _this268._positionToInsert.detach(), _this268._positionToInsert = null;
            });
          }, 100)) : o.detach();
        }
      }]);

      return Tp;
    }(Qe);

    i(96);

    var Ep =
    /*#__PURE__*/
    function (_Rl29) {
      _inherits(Ep, _Rl29);

      function Ep(e, t) {
        var _this269;

        _classCallCheck(this, Ep);

        _this269 = _possibleConstructorReturn(this, _getPrototypeOf(Ep).call(this, t));
        var i = t.t;
        _this269.focusTracker = new zs(), _this269.keystrokes = new Ds(), _this269.set("mediaURLInputValue", ""), _this269.urlInputView = _this269._createUrlInput(), _this269.saveButtonView = _this269._createButton(i("Save"), Sl.check, "ck-button-save"), _this269.saveButtonView.type = "submit", _this269.saveButtonView.bind("isEnabled").to(_assertThisInitialized(_this269), "mediaURLInputValue", function (e) {
          return !!e;
        }), _this269.cancelButtonView = _this269._createButton(i("Cancel"), Sl.cancel, "ck-button-cancel", "cancel"), _this269._focusables = new Nl(), _this269._focusCycler = new od({
          focusables: _this269._focusables,
          focusTracker: _this269.focusTracker,
          keystrokeHandler: _this269.keystrokes,
          actions: {
            focusPrevious: "shift + tab",
            focusNext: "tab"
          }
        }), _this269._validators = e, _this269.setTemplate({
          tag: "form",
          attributes: {
            class: ["ck", "ck-media-form", "ck-responsive-form"],
            tabindex: "-1"
          },
          children: [_this269.urlInputView, _this269.saveButtonView, _this269.cancelButtonView]
        }), Pl(_assertThisInitialized(_this269));
        return _this269;
      }

      _createClass(Ep, [{
        key: "render",
        value: function render() {
          var _this270 = this;

          _get(_getPrototypeOf(Ep.prototype), "render", this).call(this), Ml({
            view: this
          });
          [this.urlInputView, this.saveButtonView, this.cancelButtonView].forEach(function (e) {
            _this270._focusables.add(e), _this270.focusTracker.add(e.element);
          }), this.keystrokes.listenTo(this.element);

          var e = function e(_e315) {
            return _e315.stopPropagation();
          };

          this.keystrokes.set("arrowright", e), this.keystrokes.set("arrowleft", e), this.keystrokes.set("arrowup", e), this.keystrokes.set("arrowdown", e), this.listenTo(this.urlInputView.element, "selectstart", function (e, t) {
            t.stopPropagation();
          }, {
            priority: "high"
          });
        }
      }, {
        key: "focus",
        value: function focus() {
          this._focusCycler.focusFirst();
        }
      }, {
        key: "isValid",
        value: function isValid() {
          this.resetFormStatus();
          var _iteratorNormalCompletion398 = true;
          var _didIteratorError398 = false;
          var _iteratorError398 = undefined;

          try {
            for (var _iterator398 = this._validators[Symbol.iterator](), _step398; !(_iteratorNormalCompletion398 = (_step398 = _iterator398.next()).done); _iteratorNormalCompletion398 = true) {
              var _e316 = _step398.value;

              var _t286 = _e316(this);

              if (_t286) return this.urlInputView.errorText = _t286, !1;
            }
          } catch (err) {
            _didIteratorError398 = true;
            _iteratorError398 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion398 && _iterator398.return != null) {
                _iterator398.return();
              }
            } finally {
              if (_didIteratorError398) {
                throw _iteratorError398;
              }
            }
          }

          return !0;
        }
      }, {
        key: "resetFormStatus",
        value: function resetFormStatus() {
          this.urlInputView.errorText = null, this.urlInputView.infoText = this._urlInputViewInfoDefault;
        }
      }, {
        key: "_createUrlInput",
        value: function _createUrlInput() {
          var _this271 = this;

          var e = this.locale.t,
              t = new Od(this.locale, zd),
              i = t.fieldView;
          return this._urlInputViewInfoDefault = e("Paste the media URL in the input."), this._urlInputViewInfoTip = e("Tip: Paste the URL into the content to embed faster."), t.label = e("Media URL"), t.infoText = this._urlInputViewInfoDefault, i.on("input", function () {
            t.infoText = i.element.value ? _this271._urlInputViewInfoTip : _this271._urlInputViewInfoDefault, _this271.mediaURLInputValue = i.element.value.trim();
          }), t;
        }
      }, {
        key: "_createButton",
        value: function _createButton(e, t, i, n) {
          var o = new id(this.locale);
          return o.set({
            label: e,
            icon: t,
            tooltip: !0
          }), o.extendTemplate({
            attributes: {
              class: i
            }
          }), n && o.delegate("execute").to(this, n), o;
        }
      }, {
        key: "url",
        get: function get() {
          return this.urlInputView.fieldView.element.value.trim();
        },
        set: function set(e) {
          this.urlInputView.fieldView.element.value = e.trim();
        }
      }]);

      return Ep;
    }(Rl);

    var Sp =
    /*#__PURE__*/
    function (_Qe60) {
      _inherits(Sp, _Qe60);

      function Sp() {
        _classCallCheck(this, Sp);

        return _possibleConstructorReturn(this, _getPrototypeOf(Sp).apply(this, arguments));
      }

      _createClass(Sp, [{
        key: "init",
        value: function init() {
          var _this272 = this;

          var e = this.editor,
              t = e.commands.get("mediaEmbed"),
              i = e.plugins.get(Ap).registry;
          e.ui.componentFactory.add("mediaEmbed", function (n) {
            var o = Cd(n),
                r = new Ep(function (e, t) {
              return [function (t) {
                if (!t.url.length) return e("The URL must not be empty.");
              }, function (i) {
                if (!t.hasMedia(i.url)) return e("This media URL is not supported.");
              }];
            }(e.t, i), e.locale);
            return _this272._setUpDropdown(o, r, t, e), _this272._setUpForm(o, r, t), o;
          });
        }
      }, {
        key: "_setUpDropdown",
        value: function _setUpDropdown(e, t, i) {
          var n = this.editor,
              o = n.t,
              r = e.buttonView;

          function s() {
            n.editing.view.focus(), e.isOpen = !1;
          }

          e.bind("isEnabled").to(i), e.panelView.children.add(t), r.set({
            label: o("Insert media"),
            icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M18.68 3.03c.6 0 .59-.03.59.55v12.84c0 .59.01.56-.59.56H1.29c-.6 0-.59.03-.59-.56V3.58c0-.58-.01-.55.6-.55h17.38zM15.77 15V5H4.2v10h11.57zM2 4v1h1V4H2zm0 2v1h1V6H2zm0 2v1h1V8H2zm0 2v1h1v-1H2zm0 2v1h1v-1H2zm0 2v1h1v-1H2zM17 4v1h1V4h-1zm0 2v1h1V6h-1zm0 2v1h1V8h-1zm0 2v1h1v-1h-1zm0 2v1h1v-1h-1zm0 2v1h1v-1h-1zM7.5 7.177a.4.4 0 0 1 .593-.351l5.133 2.824a.4.4 0 0 1 0 .7l-5.133 2.824a.4.4 0 0 1-.593-.35V7.176v.001z"/></svg>',
            tooltip: !0
          }), r.on("open", function () {
            t.disableCssTransitions(), t.url = i.value || "", t.urlInputView.fieldView.select(), t.focus(), t.enableCssTransitions();
          }, {
            priority: "low"
          }), e.on("submit", function () {
            t.isValid() && (n.execute("mediaEmbed", t.url), s());
          }), e.on("change:isOpen", function () {
            return t.resetFormStatus();
          }), e.on("cancel", function () {
            return s();
          });
        }
      }, {
        key: "_setUpForm",
        value: function _setUpForm(e, t, i) {
          t.delegate("submit", "cancel").to(e), t.urlInputView.bind("value").to(i, "value"), t.urlInputView.bind("isReadOnly").to(i, "isEnabled", function (e) {
            return !e;
          });
        }
      }], [{
        key: "requires",
        get: function get() {
          return [Ap];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "MediaEmbedUI";
        }
      }]);

      return Sp;
    }(Qe);

    i(98);

    function Ip(e, t) {
      if (!e.childCount) return;

      var i = new fh(e.document),
          n = function (e, t) {
        var i = t.createRangeIn(e),
            n = new mn({
          name: /^p|h\d+$/,
          styles: {
            "mso-list": /.*/
          }
        }),
            o = [];
        var _iteratorNormalCompletion399 = true;
        var _didIteratorError399 = false;
        var _iteratorError399 = undefined;

        try {
          for (var _iterator399 = i[Symbol.iterator](), _step399; !(_iteratorNormalCompletion399 = (_step399 = _iterator399.next()).done); _iteratorNormalCompletion399 = true) {
            var _e317 = _step399.value;

            if ("elementStart" === _e317.type && n.match(_e317.item)) {
              var _t287 = Np(_e317.item);

              o.push({
                element: _e317.item,
                id: _t287.id,
                order: _t287.order,
                indent: _t287.indent
              });
            }
          }
        } catch (err) {
          _didIteratorError399 = true;
          _iteratorError399 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion399 && _iterator399.return != null) {
              _iterator399.return();
            }
          } finally {
            if (_didIteratorError399) {
              throw _iteratorError399;
            }
          }
        }

        return o;
      }(e, i);

      if (!n.length) return;
      var o = null,
          r = 1;
      n.forEach(function (e, s) {
        var a = function (e, t) {
          if (!e) return !0;
          if (e.id !== t.id) return t.indent - e.indent != 1;
          var i = t.element.previousSibling;
          if (!i) return !0;
          return n = i, !(n.is("element", "ol") || n.is("element", "ul"));
          var n;
        }(n[s - 1], e),
            c = a ? null : n[s - 1],
            l = (h = e, (d = c) ? h.indent - d.indent : h.indent - 1);

        var d, h;

        if (a && (o = null, r = 1), !o || 0 !== l) {
          var _n175 = function (e, t) {
            var i = new RegExp("@list l".concat(e.id, ":level").concat(e.indent, "\\s*({[^}]*)"), "gi"),
                n = /mso-level-number-format:([^;]{0,100});/gi,
                o = i.exec(t);
            var r = "decimal",
                s = "ol";

            if (o && o[1]) {
              var _t288 = n.exec(o[1]);

              if (_t288 && _t288[1] && (r = _t288[1].trim(), s = "bullet" !== r && "image" !== r ? "ol" : "ul"), "bullet" === r) {
                var _t289 = function (e) {
                  var t = function (e) {
                    if (e.getChild(0).is("$text")) return null;
                    var t = e.getChild(0).getChild(0);
                    if (t.is("$text")) return t;
                    return t.getChild(0);
                  }(e);

                  if (!t) return null;
                  var i = t._data;
                  if ("o" === i) return "circle";
                  if ("·" === i) return "disc";
                  if ("§" === i) return "square";
                  return null;
                }(e.element);

                _t289 && (r = _t289);
              }
            }

            return {
              type: s,
              style: Pp(r)
            };
          }(e, t);

          if (o) {
            if (e.indent > r) {
              var _e318 = o.getChild(o.childCount - 1),
                  _t290 = _e318.getChild(_e318.childCount - 1);

              o = Mp(_n175, _t290, i), r += 1;
            } else if (e.indent < r) {
              var _t291 = r - e.indent;

              o = function (e, t) {
                var i = e.getAncestors({
                  parentFirst: !0
                });
                var n = null,
                    o = 0;
                var _iteratorNormalCompletion400 = true;
                var _didIteratorError400 = false;
                var _iteratorError400 = undefined;

                try {
                  for (var _iterator400 = i[Symbol.iterator](), _step400; !(_iteratorNormalCompletion400 = (_step400 = _iterator400.next()).done); _iteratorNormalCompletion400 = true) {
                    var _e319 = _step400.value;

                    if ("ul" !== _e319.name && "ol" !== _e319.name || o++, o === t) {
                      n = _e319;
                      break;
                    }
                  }
                } catch (err) {
                  _didIteratorError400 = true;
                  _iteratorError400 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion400 && _iterator400.return != null) {
                      _iterator400.return();
                    }
                  } finally {
                    if (_didIteratorError400) {
                      throw _iteratorError400;
                    }
                  }
                }

                return n;
              }(o, _t291), r = parseInt(e.indent);
            }
          } else o = Mp(_n175, e.element, i);

          e.indent <= r && (o.is("element", _n175.type) || (o = i.rename(_n175.type, o)));
        }

        var u = function (e, t) {
          return function (e, t) {
            var i = new mn({
              name: "span",
              styles: {
                "mso-list": "Ignore"
              }
            }),
                n = t.createRangeIn(e);
            var _iteratorNormalCompletion401 = true;
            var _didIteratorError401 = false;
            var _iteratorError401 = undefined;

            try {
              for (var _iterator401 = n[Symbol.iterator](), _step401; !(_iteratorNormalCompletion401 = (_step401 = _iterator401.next()).done); _iteratorNormalCompletion401 = true) {
                var _e320 = _step401.value;
                "elementStart" === _e320.type && i.match(_e320.item) && t.remove(_e320.item);
              }
            } catch (err) {
              _didIteratorError401 = true;
              _iteratorError401 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion401 && _iterator401.return != null) {
                  _iterator401.return();
                }
              } finally {
                if (_didIteratorError401) {
                  throw _iteratorError401;
                }
              }
            }
          }(e, t), t.rename("li", e);
        }(e.element, i);

        i.appendChild(u, o);
      });
    }

    function Pp(e) {
      switch (e) {
        case "arabic-leading-zero":
          return "decimal-leading-zero";

        case "alpha-upper":
          return "upper-alpha";

        case "alpha-lower":
          return "lower-alpha";

        case "roman-upper":
          return "upper-roman";

        case "roman-lower":
          return "lower-roman";

        case "circle":
        case "disc":
        case "square":
          return e;

        default:
          return null;
      }
    }

    function Mp(e, t, i) {
      var n = t.parent,
          o = i.createElement(e.type),
          r = n.getChildIndex(t) + 1;
      return i.insertChild(r, o, n), e.style && i.setStyle("list-style-type", e.style, o), o;
    }

    function Np(e) {
      var t = {},
          i = e.getStyle("mso-list");

      if (i) {
        var _e321 = i.match(/(^|\s{1,100})l(\d+)/i),
            _n176 = i.match(/\s{0,100}lfo(\d+)/i),
            _o110 = i.match(/\s{0,100}level(\d+)/i);

        _e321 && _n176 && _o110 && (t.id = _e321[2], t.order = _n176[1], t.indent = _o110[1]);
      }

      return t;
    }

    var Rp = /id=("|')docs-internal-guid-[-0-9a-f]+("|')/i;

    var Op =
    /*#__PURE__*/
    function () {
      function Op(e) {
        _classCallCheck(this, Op);

        this.document = e;
      }

      _createClass(Op, [{
        key: "isActive",
        value: function isActive(e) {
          return Rp.test(e);
        }
      }, {
        key: "execute",
        value: function execute(e) {
          var t = new fh(this.document);
          !function (e, t) {
            var _iteratorNormalCompletion402 = true;
            var _didIteratorError402 = false;
            var _iteratorError402 = undefined;

            try {
              for (var _iterator402 = e.getChildren()[Symbol.iterator](), _step402; !(_iteratorNormalCompletion402 = (_step402 = _iterator402.next()).done); _iteratorNormalCompletion402 = true) {
                var _i293 = _step402.value;

                if (_i293.is("element", "b") && "normal" === _i293.getStyle("font-weight")) {
                  var _n177 = e.getChildIndex(_i293);

                  t.remove(_i293), t.insertChild(_n177, _i293.getChildren(), e);
                }
              }
            } catch (err) {
              _didIteratorError402 = true;
              _iteratorError402 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion402 && _iterator402.return != null) {
                  _iterator402.return();
                }
              } finally {
                if (_didIteratorError402) {
                  throw _iteratorError402;
                }
              }
            }
          }(e.content, t), function (e, t) {
            var _iteratorNormalCompletion403 = true;
            var _didIteratorError403 = false;
            var _iteratorError403 = undefined;

            try {
              for (var _iterator403 = t.createRangeIn(e)[Symbol.iterator](), _step403; !(_iteratorNormalCompletion403 = (_step403 = _iterator403.next()).done); _iteratorNormalCompletion403 = true) {
                var _i294 = _step403.value;
                var _e322 = _i294.item;

                if (_e322.is("element", "li")) {
                  var _i295 = _e322.getChild(0);

                  _i295 && _i295.is("element", "p") && t.unwrapElement(_i295);
                }
              }
            } catch (err) {
              _didIteratorError403 = true;
              _iteratorError403 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion403 && _iterator403.return != null) {
                  _iterator403.return();
                }
              } finally {
                if (_didIteratorError403) {
                  throw _iteratorError403;
                }
              }
            }
          }(e.content, t);
        }
      }]);

      return Op;
    }();

    function zp(e) {
      return e.replace(/<span(?: class="Apple-converted-space"|)>(\s+)<\/span>/g, function (e, t) {
        return 1 === t.length ? " " : Array(t.length + 1).join("  ").substr(0, t.length);
      });
    }

    function Dp(e, t) {
      var i = new DOMParser(),
          n = function (e) {
        return zp(zp(e)).replace(/(<span\s+style=['"]mso-spacerun:yes['"]>[^\S\r\n]*?)[\r\n]+([^\S\r\n]*<\/span>)/g, "$1$2").replace(/<span\s+style=['"]mso-spacerun:yes['"]><\/span>/g, "").replace(/ <\//g, " </").replace(/ <o:p><\/o:p>/g, " <o:p></o:p>").replace(/<o:p>(&nbsp;|\u00A0)<\/o:p>/g, "").replace(/>([^\S\r\n]*[\r\n]\s*)</g, "><");
      }(function (e) {
        var t = e.indexOf("</body>");
        if (t < 0) return e;
        var i = e.indexOf("</html>", t + "</body>".length);
        return e.substring(0, t + "</body>".length) + (i >= 0 ? e.substring(i) : "");
      }(e = e.replace(/<!--\[if gte vml 1]>/g, ""))),
          o = i.parseFromString(n, "text/html");

      !function (e) {
        e.querySelectorAll("span[style*=spacerun]").forEach(function (e) {
          var t = e.innerText.length || 0;
          e.innerHTML = Array(t + 1).join("  ").substr(0, t);
        });
      }(o);

      var r = o.body.innerHTML,
          s = function (e, t) {
        var i = new yo(t),
            n = new Er(i, {
          blockFillerMode: "nbsp"
        }),
            o = e.createDocumentFragment(),
            r = e.body.childNodes;

        for (; r.length > 0;) {
          o.appendChild(r[0]);
        }

        return n.domToView(o);
      }(o, t),
          a = function (e) {
        var t = [],
            i = [],
            n = Array.from(e.getElementsByTagName("style"));

        for (var _i296 = 0, _n178 = n; _i296 < _n178.length; _i296++) {
          var _e323 = _n178[_i296];
          _e323.sheet && _e323.sheet.cssRules && _e323.sheet.cssRules.length && (t.push(_e323.sheet), i.push(_e323.innerHTML));
        }

        return {
          styles: t,
          stylesString: i.join(" ")
        };
      }(o);

      return {
        body: s,
        bodyString: r,
        styles: a.styles,
        stylesString: a.stylesString
      };
    }

    function Lp(e, t) {
      if (!e.childCount) return;
      var i = new fh();
      !function (e, t, i) {
        var n = i.createRangeIn(t),
            o = new mn({
          name: "img"
        }),
            r = [];
        var _iteratorNormalCompletion404 = true;
        var _didIteratorError404 = false;
        var _iteratorError404 = undefined;

        try {
          for (var _iterator404 = n[Symbol.iterator](), _step404; !(_iteratorNormalCompletion404 = (_step404 = _iterator404.next()).done); _iteratorNormalCompletion404 = true) {
            var _t292 = _step404.value;

            if (o.match(_t292.item)) {
              var _i298 = _t292.item,
                  _n179 = _i298.getAttribute("v:shapes") ? _i298.getAttribute("v:shapes").split(" ") : [];

              _n179.length && _n179.every(function (t) {
                return e.indexOf(t) > -1;
              }) ? r.push(_i298) : _i298.getAttribute("src") || r.push(_i298);
            }
          }
        } catch (err) {
          _didIteratorError404 = true;
          _iteratorError404 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion404 && _iterator404.return != null) {
              _iterator404.return();
            }
          } finally {
            if (_didIteratorError404) {
              throw _iteratorError404;
            }
          }
        }

        for (var _i297 = 0, _r64 = r; _i297 < _r64.length; _i297++) {
          var _e324 = _r64[_i297];
          i.remove(_e324);
        }
      }(function (e, t) {
        var i = t.createRangeIn(e),
            n = new mn({
          name: /v:(.+)/
        }),
            o = [];
        var _iteratorNormalCompletion405 = true;
        var _didIteratorError405 = false;
        var _iteratorError405 = undefined;

        try {
          for (var _iterator405 = i[Symbol.iterator](), _step405; !(_iteratorNormalCompletion405 = (_step405 = _iterator405.next()).done); _iteratorNormalCompletion405 = true) {
            var _e325 = _step405.value;

            var _t293 = _e325.item,
                _i299 = _t293.previousSibling && _t293.previousSibling.name || null;

            n.match(_t293) && _t293.getAttribute("o:gfxdata") && "v:shapetype" !== _i299 && o.push(_e325.item.getAttribute("id"));
          }
        } catch (err) {
          _didIteratorError405 = true;
          _iteratorError405 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion405 && _iterator405.return != null) {
              _iterator405.return();
            }
          } finally {
            if (_didIteratorError405) {
              throw _iteratorError405;
            }
          }
        }

        return o;
      }(e, i), e, i), function (e, t) {
        var i = t.createRangeIn(e),
            n = new mn({
          name: /v:(.+)/
        }),
            o = [];
        var _iteratorNormalCompletion406 = true;
        var _didIteratorError406 = false;
        var _iteratorError406 = undefined;

        try {
          for (var _iterator406 = i[Symbol.iterator](), _step406; !(_iteratorNormalCompletion406 = (_step406 = _iterator406.next()).done); _iteratorNormalCompletion406 = true) {
            var _e326 = _step406.value;
            n.match(_e326.item) && o.push(_e326.item);
          }
        } catch (err) {
          _didIteratorError406 = true;
          _iteratorError406 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion406 && _iterator406.return != null) {
              _iterator406.return();
            }
          } finally {
            if (_didIteratorError406) {
              throw _iteratorError406;
            }
          }
        }

        for (var _i300 = 0, _o111 = o; _i300 < _o111.length; _i300++) {
          var _e327 = _o111[_i300];
          t.remove(_e327);
        }
      }(e, i);

      var n = function (e, t) {
        var i = t.createRangeIn(e),
            n = new mn({
          name: "img"
        }),
            o = [];
        var _iteratorNormalCompletion407 = true;
        var _didIteratorError407 = false;
        var _iteratorError407 = undefined;

        try {
          for (var _iterator407 = i[Symbol.iterator](), _step407; !(_iteratorNormalCompletion407 = (_step407 = _iterator407.next()).done); _iteratorNormalCompletion407 = true) {
            var _e328 = _step407.value;
            n.match(_e328.item) && _e328.item.getAttribute("src").startsWith("file://") && o.push(_e328.item);
          }
        } catch (err) {
          _didIteratorError407 = true;
          _iteratorError407 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion407 && _iterator407.return != null) {
              _iterator407.return();
            }
          } finally {
            if (_didIteratorError407) {
              throw _iteratorError407;
            }
          }
        }

        return o;
      }(e, i);

      n.length && function (e, t, i) {
        if (e.length === t.length) for (var _o112 = 0; _o112 < e.length; _o112++) {
          var _r65 = "data:".concat(t[_o112].type, ";base64,").concat((n = t[_o112].hex, btoa(n.match(/\w{2}/g).map(function (e) {
            return String.fromCharCode(parseInt(e, 16));
          }).join(""))));

          i.setAttribute("src", _r65, e[_o112]);
        }
        var n;
      }(n, function (e) {
        if (!e) return [];
        var t = /{\\pict[\s\S]+?\\bliptag-?\d+(\\blipupi-?\d+)?({\\\*\\blipuid\s?[\da-fA-F]+)?[\s}]*?/,
            i = new RegExp("(?:(" + t.source + "))([\\da-fA-F\\s]+)\\}", "g"),
            n = e.match(i),
            o = [];

        if (n) {
          var _iteratorNormalCompletion408 = true;
          var _didIteratorError408 = false;
          var _iteratorError408 = undefined;

          try {
            for (var _iterator408 = n[Symbol.iterator](), _step408; !(_iteratorNormalCompletion408 = (_step408 = _iterator408.next()).done); _iteratorNormalCompletion408 = true) {
              var _e329 = _step408.value;

              var _i301 = !1;

              _e329.includes("\\pngblip") ? _i301 = "image/png" : _e329.includes("\\jpegblip") && (_i301 = "image/jpeg"), _i301 && o.push({
                hex: _e329.replace(t, "").replace(/[^\da-fA-F]/g, ""),
                type: _i301
              });
            }
          } catch (err) {
            _didIteratorError408 = true;
            _iteratorError408 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion408 && _iterator408.return != null) {
                _iterator408.return();
              }
            } finally {
              if (_didIteratorError408) {
                throw _iteratorError408;
              }
            }
          }
        }

        return o;
      }(t), i);
    }

    var Vp = /<meta\s*name="?generator"?\s*content="?microsoft\s*word\s*\d+"?\/?>/i,
        jp = /xmlns:o="urn:schemas-microsoft-com/i;

    var Bp =
    /*#__PURE__*/
    function () {
      function Bp(e) {
        _classCallCheck(this, Bp);

        this.document = e;
      }

      _createClass(Bp, [{
        key: "isActive",
        value: function isActive(e) {
          return Vp.test(e) || jp.test(e);
        }
      }, {
        key: "execute",
        value: function execute(e) {
          var _Dp = Dp(e.dataTransfer.getData("text/html"), this.document.stylesProcessor),
              t = _Dp.body,
              i = _Dp.stylesString;

          Ip(t, i), Lp(t, e.dataTransfer.getData("text/rtf")), e.content = t;
        }
      }]);

      return Bp;
    }();

    function Fp(e, t, i, n) {
      var o = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
      t > o ? n.setAttribute(e, t, i) : n.removeAttribute(e, i);
    }

    function Hp(e, t) {
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var n = e.createElement("tableCell", i);
      return e.insertElement("paragraph", n), e.insert(n, t), n;
    }

    function Up(e, t) {
      var i = t.parent.parent,
          n = parseInt(i.getAttribute("headingColumns") || 0),
          _e$getCellLocation = e.getCellLocation(t),
          o = _e$getCellLocation.column;

      return !!n && o < n;
    }

    function Wp() {
      return function (e) {
        e.on("element:table", function (e, t, i) {
          var n = t.viewItem;
          if (!i.consumable.test(n, {
            name: !0
          })) return;

          var _ref180 = function (e) {
            var t = {
              headingRows: 0,
              headingColumns: 0
            },
                i = [],
                n = [];
            var o;

            for (var _i302 = 0, _Array$from7 = Array.from(e.getChildren()); _i302 < _Array$from7.length; _i302++) {
              var _r66 = _Array$from7[_i302];

              if ("tbody" === _r66.name || "thead" === _r66.name || "tfoot" === _r66.name) {
                "thead" !== _r66.name || o || (o = _r66);

                var _e330 = Array.from(_r66.getChildren()).filter(function (e) {
                  return e.is("element", "tr");
                });

                var _iteratorNormalCompletion409 = true;
                var _didIteratorError409 = false;
                var _iteratorError409 = undefined;

                try {
                  for (var _iterator409 = _e330[Symbol.iterator](), _step409; !(_iteratorNormalCompletion409 = (_step409 = _iterator409.next()).done); _iteratorNormalCompletion409 = true) {
                    var _r67 = _step409.value;
                    if ("thead" === _r67.parent.name && _r67.parent === o) t.headingRows++, i.push(_r67);else {
                      n.push(_r67);

                      var _e331 = $p(_r67);

                      _e331 > t.headingColumns && (t.headingColumns = _e331);
                    }
                  }
                } catch (err) {
                  _didIteratorError409 = true;
                  _iteratorError409 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion409 && _iterator409.return != null) {
                      _iterator409.return();
                    }
                  } finally {
                    if (_didIteratorError409) {
                      throw _iteratorError409;
                    }
                  }
                }
              }
            }

            return t.rows = [].concat(i, n), t;
          }(n),
              o = _ref180.rows,
              r = _ref180.headingRows,
              s = _ref180.headingColumns,
              a = {};

          s && (a.headingColumns = s), r && (a.headingRows = r);
          var c = i.writer.createElement("table", a);

          if (i.safeInsert(c, t.modelCursor)) {
            if (i.consumable.consume(n, {
              name: !0
            }), o.forEach(function (e) {
              return i.convertItem(e, i.writer.createPositionAt(c, "end"));
            }), i.convertChildren(n, i.writer.createPositionAt(c, "end")), c.isEmpty) {
              var _e332 = i.writer.createElement("tableRow");

              i.writer.insert(_e332, i.writer.createPositionAt(c, "end")), Hp(i.writer, i.writer.createPositionAt(_e332, "end"));
            }

            i.updateConversionResult(c, t);
          }
        });
      };
    }

    function qp(e) {
      return function (t) {
        t.on("element:" + e, function (e, t, i) {
          if (t.modelRange && t.viewItem.isEmpty) {
            var _e333 = t.modelRange.start.nodeAfter,
                _n180 = i.writer.createPositionAt(_e333, 0);

            i.writer.insertElement("paragraph", _n180);
          }
        }, {
          priority: "low"
        });
      };
    }

    function $p(e) {
      var t = 0,
          i = 0;
      var n = Array.from(e.getChildren()).filter(function (e) {
        return "th" === e.name || "td" === e.name;
      });

      for (; i < n.length && "th" === n[i].name;) {
        var _e334 = n[i];
        t += parseInt(_e334.getAttribute("colspan") || 1), i++;
      }

      return t;
    }

    var Yp =
    /*#__PURE__*/
    function () {
      function Yp(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        _classCallCheck(this, Yp);

        this._table = e, this._startRow = void 0 !== t.row ? t.row : t.startRow || 0, this._endRow = void 0 !== t.row ? t.row : t.endRow, this._startColumn = void 0 !== t.column ? t.column : t.startColumn || 0, this._endColumn = void 0 !== t.column ? t.column : t.endColumn, this._includeAllSlots = !!t.includeAllSlots, this._skipRows = new Set(), this._row = 0, this._rowIndex = 0, this._column = 0, this._cellIndex = 0, this._spannedCells = new Map(), this._nextCellAtColumn = -1;
      }

      _createClass(Yp, [{
        key: Symbol.iterator,
        value: function value() {
          return this;
        }
      }, {
        key: "next",
        value: function next() {
          var e = this._table.getChild(this._rowIndex);

          if (!e || this._isOverEndRow()) return {
            done: !0
          };
          if (!e.is("element", "tableRow")) return this._rowIndex++, this.next();
          if (this._isOverEndColumn()) return this._advanceToNextRow();
          var t = null;

          var i = this._getSpanned();

          if (i) this._includeAllSlots && !this._shouldSkipSlot() && (t = this._formatOutValue(i.cell, i.row, i.column));else {
            var _i303 = e.getChild(this._cellIndex);

            if (!_i303) return this._advanceToNextRow();

            var _n181 = parseInt(_i303.getAttribute("colspan") || 1),
                _o113 = parseInt(_i303.getAttribute("rowspan") || 1);

            (_n181 > 1 || _o113 > 1) && this._recordSpans(_i303, _o113, _n181), this._shouldSkipSlot() || (t = this._formatOutValue(_i303)), this._nextCellAtColumn = this._column + _n181;
          }
          return this._column++, this._column == this._nextCellAtColumn && this._cellIndex++, t || this.next();
        }
      }, {
        key: "skipRow",
        value: function skipRow(e) {
          this._skipRows.add(e);
        }
      }, {
        key: "_advanceToNextRow",
        value: function _advanceToNextRow() {
          return this._row++, this._rowIndex++, this._column = 0, this._cellIndex = 0, this._nextCellAtColumn = -1, this.next();
        }
      }, {
        key: "_isOverEndRow",
        value: function _isOverEndRow() {
          return void 0 !== this._endRow && this._row > this._endRow;
        }
      }, {
        key: "_isOverEndColumn",
        value: function _isOverEndColumn() {
          return void 0 !== this._endColumn && this._column > this._endColumn;
        }
      }, {
        key: "_formatOutValue",
        value: function _formatOutValue(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._row;
          var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this._column;
          return {
            done: !1,
            value: new Gp(this, e, t, i)
          };
        }
      }, {
        key: "_shouldSkipSlot",
        value: function _shouldSkipSlot() {
          var e = this._skipRows.has(this._row),
              t = this._row < this._startRow,
              i = this._column < this._startColumn,
              n = void 0 !== this._endColumn && this._column > this._endColumn;

          return e || t || i || n;
        }
      }, {
        key: "_getSpanned",
        value: function _getSpanned() {
          var e = this._spannedCells.get(this._row);

          return e && e.get(this._column) || null;
        }
      }, {
        key: "_recordSpans",
        value: function _recordSpans(e, t, i) {
          var n = {
            cell: e,
            row: this._row,
            column: this._column
          };

          for (var _e335 = this._row; _e335 < this._row + t; _e335++) {
            for (var _t294 = this._column; _t294 < this._column + i; _t294++) {
              _e335 == this._row && _t294 == this._column || this._markSpannedCell(_e335, _t294, n);
            }
          }
        }
      }, {
        key: "_markSpannedCell",
        value: function _markSpannedCell(e, t, i) {
          this._spannedCells.has(e) || this._spannedCells.set(e, new Map());

          this._spannedCells.get(e).set(t, i);
        }
      }]);

      return Yp;
    }();

    var Gp =
    /*#__PURE__*/
    function () {
      function Gp(e, t, i, n) {
        _classCallCheck(this, Gp);

        this.cell = t, this.row = e._row, this.column = e._column, this.cellAnchorRow = i, this.cellAnchorColumn = n, this._cellIndex = e._cellIndex, this._rowIndex = e._rowIndex, this._table = e._table;
      }

      _createClass(Gp, [{
        key: "getPositionBefore",
        value: function getPositionBefore() {
          return this._table.root.document.model.createPositionAt(this._table.getChild(this.row), this._cellIndex);
        }
      }, {
        key: "isAnchor",
        get: function get() {
          return this.row === this.cellAnchorRow && this.column === this.cellAnchorColumn;
        }
      }, {
        key: "cellWidth",
        get: function get() {
          return parseInt(this.cell.getAttribute("colspan") || 1);
        }
      }, {
        key: "cellHeight",
        get: function get() {
          return parseInt(this.cell.getAttribute("rowspan") || 1);
        }
      }, {
        key: "rowIndex",
        get: function get() {
          return this._rowIndex;
        }
      }]);

      return Gp;
    }();

    function Kp() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return function (t) {
        return t.on("insert:table", function (t, i, n) {
          var o = i.item;
          if (!n.consumable.consume(o, "insert")) return;
          n.consumable.consume(o, "attribute:headingRows:table"), n.consumable.consume(o, "attribute:headingColumns:table");
          var r = e && e.asWidget,
              s = n.writer.createContainerElement("figure", {
            class: "table"
          }),
              a = n.writer.createContainerElement("table");
          var c;
          var l, d;
          n.writer.insert(n.writer.createPositionAt(s, 0), a), r && (l = s, (d = n.writer).setCustomProperty("table", !0, l), c = Lh(l, d, {
            hasSelectionHandle: !0
          }));
          var h = new Yp(o),
              u = {
            headingRows: o.getAttribute("headingRows") || 0,
            headingColumns: o.getAttribute("headingColumns") || 0
          },
              g = new Map();
          var _iteratorNormalCompletion410 = true;
          var _didIteratorError410 = false;
          var _iteratorError410 = undefined;

          try {
            for (var _iterator410 = h[Symbol.iterator](), _step410; !(_iteratorNormalCompletion410 = (_step410 = _iterator410.next()).done); _iteratorNormalCompletion410 = true) {
              var _t295 = _step410.value;

              var _i304 = _t295.row,
                  _r68 = _t295.cell,
                  _s38 = o.getChild(_i304),
                  _c14 = g.get(_i304) || eb(a, _s38, _i304, u, n);

              g.set(_i304, _c14), n.consumable.consume(_r68, "insert");
              Xp(_t295, u, n.writer.createPositionAt(_c14, "end"), n, e);
            }
          } catch (err) {
            _didIteratorError410 = true;
            _iteratorError410 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion410 && _iterator410.return != null) {
                _iterator410.return();
              }
            } finally {
              if (_didIteratorError410) {
                throw _iteratorError410;
              }
            }
          }

          var _iteratorNormalCompletion411 = true;
          var _didIteratorError411 = false;
          var _iteratorError411 = undefined;

          try {
            for (var _iterator411 = o.getChildren()[Symbol.iterator](), _step411; !(_iteratorNormalCompletion411 = (_step411 = _iterator411.next()).done); _iteratorNormalCompletion411 = true) {
              var _e336 = _step411.value;
              var _t296 = _e336.index;
              _e336.is("element", "tableRow") && !g.has(_t296) && g.set(_t296, eb(a, _e336, _t296, u, n));
            }
          } catch (err) {
            _didIteratorError411 = true;
            _iteratorError411 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion411 && _iterator411.return != null) {
                _iterator411.return();
              }
            } finally {
              if (_didIteratorError411) {
                throw _iteratorError411;
              }
            }
          }

          var m = n.mapper.toViewPosition(i.range.start);
          n.mapper.bindElements(o, r ? c : s), n.writer.insert(m, r ? c : s);
        });
      };
    }

    function Qp(e, t) {
      var i = t.writer;
      if (e.parent.is("element", "tableCell")) return Jp(e) ? i.createContainerElement("span", {
        class: "ck-table-bogus-paragraph"
      }) : i.createContainerElement("p");
    }

    function Jp(e) {
      return 1 === e.parent.childCount && !ob(e);
    }

    function Zp(e, t, i) {
      var n = e.cell,
          o = tb(e, t),
          r = i.mapper.toViewElement(n);
      r && r.name !== o && function (e, t, i) {
        var n = i.writer,
            o = i.mapper.toViewElement(e),
            r = Hh(n.createEditableElement(t, o.getAttributes()), n);
        Bh(r, n, function (e, t, i) {
          return i.addClass(en(t.classes), e);
        }, function (e, t, i) {
          return i.removeClass(en(t.classes), e);
        }), n.insert(n.createPositionAfter(o), r), n.move(n.createRangeIn(o), n.createPositionAt(r, 0)), n.remove(n.createRangeOn(o)), i.mapper.unbindViewElement(o), i.mapper.bindElements(e, r);
      }(n, o, i);
    }

    function Xp(e, t, i, n, o) {
      var r = o && o.asWidget,
          s = tb(e, t),
          a = r ? Hh(n.writer.createEditableElement(s), n.writer) : n.writer.createContainerElement(s);
      r && Bh(a, n.writer, function (e, t, i) {
        return i.addClass(en(t.classes), e);
      }, function (e, t, i) {
        return i.removeClass(en(t.classes), e);
      });
      var c = e.cell,
          l = c.getChild(0),
          d = 1 === c.childCount && "paragraph" === l.name;

      if (n.writer.insert(i, a), n.mapper.bindElements(c, a), !r && d && !ob(l)) {
        var _e337 = c.getChild(0);

        n.consumable.consume(_e337, "insert"), n.mapper.bindElements(_e337, a);
      }
    }

    function eb(e, t, i, n, o) {
      o.consumable.consume(t, "insert");
      var r = t.isEmpty ? o.writer.createEmptyElement("tr") : o.writer.createContainerElement("tr");
      o.mapper.bindElements(t, r);

      var s = n.headingRows,
          a = function (e, t, i) {
        var n = ib(e, t);
        return n || function (e, t, i) {
          var n = i.writer.createContainerElement(e),
              o = i.writer.createPositionAt(t, "tbody" == e ? "end" : 0);
          return i.writer.insert(o, n), n;
        }(e, t, i);
      }(function (e, t) {
        return e < t.headingRows ? "thead" : "tbody";
      }(i, n), e, o),
          c = s > 0 && i >= s ? i - s : i,
          l = o.writer.createPositionAt(a, c);

      return o.writer.insert(l, r), r;
    }

    function tb(e, t) {
      var i = e.row,
          n = e.column,
          o = t.headingColumns,
          r = t.headingRows;
      if (r && r > i) return "th";
      return o && o > n ? "th" : "td";
    }

    function ib(e, t) {
      var _iteratorNormalCompletion412 = true;
      var _didIteratorError412 = false;
      var _iteratorError412 = undefined;

      try {
        for (var _iterator412 = t.getChildren()[Symbol.iterator](), _step412; !(_iteratorNormalCompletion412 = (_step412 = _iterator412.next()).done); _iteratorNormalCompletion412 = true) {
          var _i305 = _step412.value;
          if (_i305.name == e) return _i305;
        }
      } catch (err) {
        _didIteratorError412 = true;
        _iteratorError412 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion412 && _iterator412.return != null) {
            _iterator412.return();
          }
        } finally {
          if (_didIteratorError412) {
            throw _iteratorError412;
          }
        }
      }
    }

    function nb(e, t, i) {
      var n = ib(e, t);
      n && 0 === n.childCount && i.writer.remove(i.writer.createRangeOn(n));
    }

    function ob(e) {
      return !!_toConsumableArray(e.getAttributeKeys()).length;
    }

    var rb =
    /*#__PURE__*/
    function (_Ze25) {
      _inherits(rb, _Ze25);

      function rb() {
        _classCallCheck(this, rb);

        return _possibleConstructorReturn(this, _getPrototypeOf(rb).apply(this, arguments));
      }

      _createClass(rb, [{
        key: "refresh",
        value: function refresh() {
          var e = this.editor.model,
              t = e.document.selection,
              i = e.schema;

          this.isEnabled = function (e, t) {
            var i = e.getFirstPosition().parent,
                n = i === i.root ? i : i.parent;
            return t.checkChild(n, "table");
          }(t, i);
        }
      }, {
        key: "execute",
        value: function execute() {
          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var t = this.editor.model,
              i = t.document.selection,
              n = this.editor.plugins.get("TableUtils"),
              o = Uh(i, t);
          t.change(function (i) {
            var r = n.createTable(i, e);
            t.insertContent(r, o), i.setSelection(i.createPositionAt(r.getNodeByPath([0, 0, 0]), 0));
          });
        }
      }]);

      return rb;
    }(Ze);

    function sb(e) {
      var t = [];
      var _iteratorNormalCompletion413 = true;
      var _didIteratorError413 = false;
      var _iteratorError413 = undefined;

      try {
        for (var _iterator413 = ub(e.getRanges())[Symbol.iterator](), _step413; !(_iteratorNormalCompletion413 = (_step413 = _iterator413.next()).done); _iteratorNormalCompletion413 = true) {
          var _i306 = _step413.value;

          var _e338 = _i306.getContainedElement();

          _e338 && _e338.is("element", "tableCell") && t.push(_e338);
        }
      } catch (err) {
        _didIteratorError413 = true;
        _iteratorError413 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion413 && _iterator413.return != null) {
            _iterator413.return();
          }
        } finally {
          if (_didIteratorError413) {
            throw _iteratorError413;
          }
        }
      }

      return t;
    }

    function ab(e) {
      var t = [];
      var _iteratorNormalCompletion414 = true;
      var _didIteratorError414 = false;
      var _iteratorError414 = undefined;

      try {
        for (var _iterator414 = e.getRanges()[Symbol.iterator](), _step414; !(_iteratorNormalCompletion414 = (_step414 = _iterator414.next()).done); _iteratorNormalCompletion414 = true) {
          var _i307 = _step414.value;

          var _e339 = _i307.start.findAncestor("tableCell");

          _e339 && t.push(_e339);
        }
      } catch (err) {
        _didIteratorError414 = true;
        _iteratorError414 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion414 && _iterator414.return != null) {
            _iterator414.return();
          }
        } finally {
          if (_didIteratorError414) {
            throw _iteratorError414;
          }
        }
      }

      return t;
    }

    function cb(e) {
      var t = sb(e);
      return t.length ? t : ab(e);
    }

    function lb(e) {
      return gb(e.map(function (e) {
        return e.parent.index;
      }));
    }

    function db(e) {
      var t = e[0].findAncestor("table");
      return gb(_toConsumableArray(new Yp(t)).filter(function (t) {
        return e.includes(t.cell);
      }).map(function (e) {
        return e.column;
      }));
    }

    function hb(e, t) {
      if (e.length < 2 || !function (e) {
        var t = e[0].findAncestor("table"),
            i = lb(e),
            n = parseInt(t.getAttribute("headingRows") || 0);
        if (!fb(i, n)) return !1;
        var o = parseInt(t.getAttribute("headingColumns") || 0);
        return fb(db(e), o);
      }(e)) return !1;
      var i = new Set(),
          n = new Set();
      var o = 0;
      var _iteratorNormalCompletion415 = true;
      var _didIteratorError415 = false;
      var _iteratorError415 = undefined;

      try {
        for (var _iterator415 = e[Symbol.iterator](), _step415; !(_iteratorNormalCompletion415 = (_step415 = _iterator415.next()).done); _iteratorNormalCompletion415 = true) {
          var _r69 = _step415.value;

          var _t$getCellLocation = t.getCellLocation(_r69),
              _e340 = _t$getCellLocation.row,
              _s39 = _t$getCellLocation.column,
              _a25 = parseInt(_r69.getAttribute("rowspan") || 1),
              _c15 = parseInt(_r69.getAttribute("colspan") || 1);

          i.add(_e340), n.add(_s39), _a25 > 1 && i.add(_e340 + _a25 - 1), _c15 > 1 && n.add(_s39 + _c15 - 1), o += _a25 * _c15;
        }
      } catch (err) {
        _didIteratorError415 = true;
        _iteratorError415 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion415 && _iterator415.return != null) {
            _iterator415.return();
          }
        } finally {
          if (_didIteratorError415) {
            throw _iteratorError415;
          }
        }
      }

      return function (e, t) {
        var i = Array.from(e.values()),
            n = Array.from(t.values()),
            o = Math.max.apply(Math, _toConsumableArray(i)),
            r = Math.min.apply(Math, _toConsumableArray(i)),
            s = Math.max.apply(Math, _toConsumableArray(n)),
            a = Math.min.apply(Math, _toConsumableArray(n));
        return (o - r + 1) * (s - a + 1);
      }(i, n) == o;
    }

    function ub(e) {
      return Array.from(e).sort(mb);
    }

    function gb(e) {
      var t = e.sort(function (e, t) {
        return e - t;
      });
      return {
        first: t[0],
        last: t[t.length - 1]
      };
    }

    function mb(e, t) {
      var i = e.start,
          n = t.start;
      return i.isBefore(n) ? -1 : 1;
    }

    function fb(_ref181, i) {
      var e = _ref181.first,
          t = _ref181.last;
      return e < i === t < i;
    }

    var pb =
    /*#__PURE__*/
    function (_Ze26) {
      _inherits(pb, _Ze26);

      function pb(e) {
        var _this273;

        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        _classCallCheck(this, pb);

        _this273 = _possibleConstructorReturn(this, _getPrototypeOf(pb).call(this, e)), _this273.order = t.order || "below";
        return _this273;
      }

      _createClass(pb, [{
        key: "refresh",
        value: function refresh() {
          var e = !!cb(this.editor.model.document.selection).length;
          this.isEnabled = e;
        }
      }, {
        key: "execute",
        value: function execute() {
          var e = this.editor,
              t = e.model.document.selection,
              i = e.plugins.get("TableUtils"),
              n = "above" === this.order,
              o = cb(t),
              r = lb(o),
              s = n ? r.first : r.last,
              a = o[0].findAncestor("table");
          i.insertRows(a, {
            at: n ? s : s + 1,
            copyStructureFromAbove: !n
          });
        }
      }]);

      return pb;
    }(Ze);

    var bb =
    /*#__PURE__*/
    function (_Ze27) {
      _inherits(bb, _Ze27);

      function bb(e) {
        var _this274;

        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        _classCallCheck(this, bb);

        _this274 = _possibleConstructorReturn(this, _getPrototypeOf(bb).call(this, e)), _this274.order = t.order || "right";
        return _this274;
      }

      _createClass(bb, [{
        key: "refresh",
        value: function refresh() {
          var e = !!cb(this.editor.model.document.selection).length;
          this.isEnabled = e;
        }
      }, {
        key: "execute",
        value: function execute() {
          var e = this.editor,
              t = e.model.document.selection,
              i = e.plugins.get("TableUtils"),
              n = "left" === this.order,
              o = cb(t),
              r = db(o),
              s = n ? r.first : r.last,
              a = o[0].findAncestor("table");
          i.insertColumns(a, {
            columns: 1,
            at: n ? s : s + 1
          });
        }
      }]);

      return bb;
    }(Ze);

    var wb =
    /*#__PURE__*/
    function (_Ze28) {
      _inherits(wb, _Ze28);

      function wb(e) {
        var _this275;

        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        _classCallCheck(this, wb);

        _this275 = _possibleConstructorReturn(this, _getPrototypeOf(wb).call(this, e)), _this275.direction = t.direction || "horizontally";
        return _this275;
      }

      _createClass(wb, [{
        key: "refresh",
        value: function refresh() {
          var e = cb(this.editor.model.document.selection);
          this.isEnabled = 1 === e.length;
        }
      }, {
        key: "execute",
        value: function execute() {
          var e = cb(this.editor.model.document.selection)[0],
              t = "horizontally" === this.direction,
              i = this.editor.plugins.get("TableUtils");
          t ? i.splitCellHorizontally(e, 2) : i.splitCellVertically(e, 2);
        }
      }]);

      return wb;
    }(Ze);

    function kb(e, t, i) {
      var n = t.startRow,
          o = t.startColumn,
          r = t.endRow,
          s = t.endColumn,
          a = i.createElement("table"),
          c = r - n + 1;

      for (var _e341 = 0; _e341 < c; _e341++) {
        i.insertElement("tableRow", a, "end");
      }

      var l = _toConsumableArray(new Yp(e, {
        startRow: n,
        endRow: r,
        startColumn: o,
        endColumn: s,
        includeAllSlots: !0
      }));

      var _iteratorNormalCompletion416 = true;
      var _didIteratorError416 = false;
      var _iteratorError416 = undefined;

      try {
        for (var _iterator416 = l[Symbol.iterator](), _step416; !(_iteratorNormalCompletion416 = (_step416 = _iterator416.next()).done); _iteratorNormalCompletion416 = true) {
          var _ref183 = _step416.value;
          var _e342 = _ref183.row;
          var _t297 = _ref183.column;
          var _c16 = _ref183.cell;
          var _d4 = _ref183.isAnchor;
          var _h4 = _ref183.cellAnchorRow;
          var _u3 = _ref183.cellAnchorColumn;

          var _l7 = _e342 - n,
              _g2 = a.getChild(_l7);

          if (_d4) {
            var _n182 = i.cloneElement(_c16);

            i.append(_n182, _g2), Ab(_n182, _e342, _t297, r, s, i);
          } else (_h4 < n || _u3 < o) && Hp(i, i.createPositionAt(_g2, "end"));
        }
      } catch (err) {
        _didIteratorError416 = true;
        _iteratorError416 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion416 && _iterator416.return != null) {
            _iterator416.return();
          }
        } finally {
          if (_didIteratorError416) {
            throw _iteratorError416;
          }
        }
      }

      return function (e, t, i, n, o) {
        var r = parseInt(t.getAttribute("headingRows") || 0);

        if (r > 0) {
          Fp("headingRows", r - i, e, o, 0);
        }

        var s = parseInt(t.getAttribute("headingColumns") || 0);

        if (s > 0) {
          Fp("headingColumns", s - n, e, o, 0);
        }
      }(a, e, n, o, i), a;
    }

    function _b(e, t) {
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var n = [],
          o = new Yp(e, {
        startRow: i,
        endRow: t - 1
      });
      var _iteratorNormalCompletion417 = true;
      var _didIteratorError417 = false;
      var _iteratorError417 = undefined;

      try {
        for (var _iterator417 = o[Symbol.iterator](), _step417; !(_iteratorNormalCompletion417 = (_step417 = _iterator417.next()).done); _iteratorNormalCompletion417 = true) {
          var _e343 = _step417.value;

          var _i308 = _e343.row,
              _o114 = _e343.cellHeight,
              _r70 = _i308 + _o114 - 1;

          _i308 < t && t <= _r70 && n.push(_e343);
        }
      } catch (err) {
        _didIteratorError417 = true;
        _iteratorError417 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion417 && _iterator417.return != null) {
            _iterator417.return();
          }
        } finally {
          if (_didIteratorError417) {
            throw _iteratorError417;
          }
        }
      }

      return n;
    }

    function vb(e, t, i) {
      var n = e.parent,
          o = n.parent,
          r = n.index,
          s = t - r,
          a = {},
          c = parseInt(e.getAttribute("rowspan")) - s;
      c > 1 && (a.rowspan = c);
      var l = parseInt(e.getAttribute("colspan") || 1);
      l > 1 && (a.colspan = l);

      var d = r + s,
          h = _toConsumableArray(new Yp(o, {
        startRow: r,
        endRow: d,
        includeAllSlots: !0
      }));

      var u,
          g = null;
      var _iteratorNormalCompletion418 = true;
      var _didIteratorError418 = false;
      var _iteratorError418 = undefined;

      try {
        for (var _iterator418 = h[Symbol.iterator](), _step418; !(_iteratorNormalCompletion418 = (_step418 = _iterator418.next()).done); _iteratorNormalCompletion418 = true) {
          var _t298 = _step418.value;
          var _n183 = _t298.row,
              _o115 = _t298.column,
              _r71 = _t298.cell;
          _r71 === e && void 0 === u && (u = _o115), void 0 !== u && u === _o115 && _n183 === d && (g = Hp(i, _t298.getPositionBefore(), a));
        }
      } catch (err) {
        _didIteratorError418 = true;
        _iteratorError418 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion418 && _iterator418.return != null) {
            _iterator418.return();
          }
        } finally {
          if (_didIteratorError418) {
            throw _iteratorError418;
          }
        }
      }

      return Fp("rowspan", s, e, i), g;
    }

    function yb(e, t) {
      var i = [],
          n = new Yp(e);
      var _iteratorNormalCompletion419 = true;
      var _didIteratorError419 = false;
      var _iteratorError419 = undefined;

      try {
        for (var _iterator419 = n[Symbol.iterator](), _step419; !(_iteratorNormalCompletion419 = (_step419 = _iterator419.next()).done); _iteratorNormalCompletion419 = true) {
          var _e344 = _step419.value;

          var _n184 = _e344.column,
              _o116 = _e344.cellWidth,
              _r72 = _n184 + _o116 - 1;

          _n184 < t && t <= _r72 && i.push(_e344);
        }
      } catch (err) {
        _didIteratorError419 = true;
        _iteratorError419 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion419 && _iterator419.return != null) {
            _iterator419.return();
          }
        } finally {
          if (_didIteratorError419) {
            throw _iteratorError419;
          }
        }
      }

      return i;
    }

    function xb(e, t, i, n) {
      var o = i - t,
          r = {},
          s = parseInt(e.getAttribute("colspan")) - o;
      s > 1 && (r.colspan = s);
      var a = parseInt(e.getAttribute("rowspan") || 1);
      a > 1 && (r.rowspan = a);
      var c = Hp(n, n.createPositionAfter(e), r);
      return Fp("colspan", o, e, n), c;
    }

    function Ab(e, t, i, n, o, r) {
      var s = parseInt(e.getAttribute("colspan") || 1),
          a = parseInt(e.getAttribute("rowspan") || 1);

      if (i + s - 1 > o) {
        Fp("colspan", o - i + 1, e, r, 1);
      }

      if (t + a - 1 > n) {
        Fp("rowspan", n - t + 1, e, r, 1);
      }
    }

    function Cb(e, t) {
      var i = t.getColumns(e),
          n = new Array(i).fill(0);
      var _iteratorNormalCompletion420 = true;
      var _didIteratorError420 = false;
      var _iteratorError420 = undefined;

      try {
        for (var _iterator420 = new Yp(e)[Symbol.iterator](), _step420; !(_iteratorNormalCompletion420 = (_step420 = _iterator420.next()).done); _iteratorNormalCompletion420 = true) {
          var _ref185 = _step420.value;
          var _t299 = _ref185.column;
          n[_t299]++;
        }
      } catch (err) {
        _didIteratorError420 = true;
        _iteratorError420 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion420 && _iterator420.return != null) {
            _iterator420.return();
          }
        } finally {
          if (_didIteratorError420) {
            throw _iteratorError420;
          }
        }
      }

      var o = n.reduce(function (e, t, i) {
        return t ? e : [].concat(_toConsumableArray(e), [i]);
      }, []);

      if (o.length > 0) {
        var _i309 = o[o.length - 1];
        return t.removeColumns(e, {
          at: _i309
        }), !0;
      }

      return !1;
    }

    function Tb(e, t) {
      var i = [],
          n = t.getRows(e);

      for (var _t300 = 0; _t300 < n; _t300++) {
        e.getChild(_t300).isEmpty && i.push(_t300);
      }

      if (i.length > 0) {
        var _n185 = i[i.length - 1];
        return t.removeRows(e, {
          at: _n185
        }), !0;
      }

      return !1;
    }

    function Eb(e, t) {
      Cb(e, t) || Tb(e, t);
    }

    function Sb(e, t) {
      var i = Array.from(new Yp(e, {
        startColumn: t.firstColumn,
        endColumn: t.lastColumn,
        row: t.lastRow
      }));
      if (i.every(function (_ref186) {
        var e = _ref186.cellHeight;
        return 1 === e;
      })) return t.lastRow;
      var n = i[0].cellHeight - 1;
      return t.lastRow + n;
    }

    function Ib(e, t) {
      var i = Array.from(new Yp(e, {
        startRow: t.firstRow,
        endRow: t.lastRow,
        column: t.lastColumn
      }));
      if (i.every(function (_ref187) {
        var e = _ref187.cellWidth;
        return 1 === e;
      })) return t.lastColumn;
      var n = i[0].cellWidth - 1;
      return t.lastColumn + n;
    }

    var Pb =
    /*#__PURE__*/
    function (_Ze29) {
      _inherits(Pb, _Ze29);

      function Pb(e, t) {
        var _this276;

        _classCallCheck(this, Pb);

        _this276 = _possibleConstructorReturn(this, _getPrototypeOf(Pb).call(this, e)), _this276.direction = t.direction, _this276.isHorizontal = "right" == _this276.direction || "left" == _this276.direction;
        return _this276;
      }

      _createClass(Pb, [{
        key: "refresh",
        value: function refresh() {
          var e = this._getMergeableCell();

          this.value = e, this.isEnabled = !!e;
        }
      }, {
        key: "execute",
        value: function execute() {
          var _this277 = this;

          var e = this.editor.model,
              t = ab(e.document.selection)[0],
              i = this.value,
              n = this.direction;
          e.change(function (e) {
            var o = "right" == n || "down" == n,
                r = o ? t : i,
                s = o ? i : t,
                a = s.parent;
            !function (e, t, i) {
              Mb(e) || (Mb(t) && i.remove(i.createRangeIn(t)), i.move(i.createRangeIn(e), i.createPositionAt(t, "end")));
              i.remove(e);
            }(s, r, e);
            var c = _this277.isHorizontal ? "colspan" : "rowspan",
                l = parseInt(t.getAttribute(c) || 1),
                d = parseInt(i.getAttribute(c) || 1);
            e.setAttribute(c, l + d, r), e.setSelection(e.createRangeIn(r));

            var h = _this277.editor.plugins.get("TableUtils");

            Eb(a.findAncestor("table"), h);
          });
        }
      }, {
        key: "_getMergeableCell",
        value: function _getMergeableCell() {
          var e = ab(this.editor.model.document.selection)[0];
          if (!e) return;
          var t = this.editor.plugins.get("TableUtils"),
              i = this.isHorizontal ? function (e, t, i) {
            var n = e.parent.parent,
                o = "right" == t ? e.nextSibling : e.previousSibling,
                r = (n.getAttribute("headingColumns") || 0) > 0;
            if (!o) return;

            var s = "right" == t ? e : o,
                a = "right" == t ? o : e,
                _i$getCellLocation = i.getCellLocation(s),
                c = _i$getCellLocation.column,
                _i$getCellLocation2 = i.getCellLocation(a),
                l = _i$getCellLocation2.column,
                d = parseInt(s.getAttribute("colspan") || 1),
                h = Up(i, s),
                u = Up(i, a);

            if (r && h != u) return;
            return c + d === l ? o : void 0;
          }(e, this.direction, t) : function (e, t, i) {
            var n = e.parent,
                o = n.parent,
                r = o.getChildIndex(n);
            if ("down" == t && r === i.getRows(o) - 1 || "up" == t && 0 === r) return;
            var s = parseInt(e.getAttribute("rowspan") || 1),
                a = o.getAttribute("headingRows") || 0,
                c = "down" == t && r + s === a,
                l = "up" == t && r === a;
            if (a && (c || l)) return;

            var d = parseInt(e.getAttribute("rowspan") || 1),
                h = "down" == t ? r + d : r,
                u = _toConsumableArray(new Yp(o, {
              endRow: h
            })),
                g = u.find(function (t) {
              return t.cell === e;
            }).column,
                m = u.find(function (_ref188) {
              var e = _ref188.row,
                  i = _ref188.cellHeight,
                  n = _ref188.column;
              return n === g && ("down" == t ? e === h : h === e + i);
            });

            return m && m.cell;
          }(e, this.direction, t);
          if (!i) return;
          var n = this.isHorizontal ? "rowspan" : "colspan",
              o = parseInt(e.getAttribute(n) || 1);
          return parseInt(i.getAttribute(n) || 1) === o ? i : void 0;
        }
      }]);

      return Pb;
    }(Ze);

    function Mb(e) {
      return 1 == e.childCount && e.getChild(0).is("element", "paragraph") && e.getChild(0).isEmpty;
    }

    var Nb =
    /*#__PURE__*/
    function (_Ze30) {
      _inherits(Nb, _Ze30);

      function Nb() {
        _classCallCheck(this, Nb);

        return _possibleConstructorReturn(this, _getPrototypeOf(Nb).apply(this, arguments));
      }

      _createClass(Nb, [{
        key: "refresh",
        value: function refresh() {
          var e = cb(this.editor.model.document.selection),
              t = e[0];

          if (t) {
            var _i310 = t.findAncestor("table"),
                _n186 = this.editor.plugins.get("TableUtils").getRows(_i310) - 1,
                _o117 = lb(e),
                _r73 = 0 === _o117.first && _o117.last === _n186;

            this.isEnabled = !_r73;
          } else this.isEnabled = !1;
        }
      }, {
        key: "execute",
        value: function execute() {
          var e = this.editor.model,
              t = this.editor.plugins.get("TableUtils"),
              i = cb(e.document.selection),
              n = lb(i),
              o = i[0],
              r = o.findAncestor("table"),
              s = t.getCellLocation(o).column;
          e.change(function (e) {
            var i = n.last - n.first + 1;
            t.removeRows(r, {
              at: n.first,
              rows: i
            });

            var o = function (e, t, i, n) {
              var o = e.getChild(Math.min(t, n - 1));
              var r = o.getChild(0),
                  s = 0;
              var _iteratorNormalCompletion421 = true;
              var _didIteratorError421 = false;
              var _iteratorError421 = undefined;

              try {
                for (var _iterator421 = o.getChildren()[Symbol.iterator](), _step421; !(_iteratorNormalCompletion421 = (_step421 = _iterator421.next()).done); _iteratorNormalCompletion421 = true) {
                  var _e345 = _step421.value;
                  if (s > i) return r;
                  r = _e345, s += parseInt(_e345.getAttribute("colspan") || 1);
                }
              } catch (err) {
                _didIteratorError421 = true;
                _iteratorError421 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion421 && _iterator421.return != null) {
                    _iterator421.return();
                  }
                } finally {
                  if (_didIteratorError421) {
                    throw _iteratorError421;
                  }
                }
              }

              return r;
            }(r, n.first, s, t.getRows(r));

            e.setSelection(e.createPositionAt(o, 0));
          });
        }
      }]);

      return Nb;
    }(Ze);

    var Rb =
    /*#__PURE__*/
    function (_Ze31) {
      _inherits(Rb, _Ze31);

      function Rb() {
        _classCallCheck(this, Rb);

        return _possibleConstructorReturn(this, _getPrototypeOf(Rb).apply(this, arguments));
      }

      _createClass(Rb, [{
        key: "refresh",
        value: function refresh() {
          var e = cb(this.editor.model.document.selection),
              t = e[0];

          if (t) {
            var _i311 = t.findAncestor("table"),
                _n187 = this.editor.plugins.get("TableUtils").getColumns(_i311),
                _db = db(e),
                _o118 = _db.first,
                _r74 = _db.last;

            this.isEnabled = _r74 - _o118 < _n187 - 1;
          } else this.isEnabled = !1;
        }
      }, {
        key: "execute",
        value: function execute() {
          var _this278 = this;

          var _ref189 = function (e) {
            var t = cb(e),
                i = t[0],
                n = t.pop(),
                o = [i, n];
            return i.isBefore(n) ? o : o.reverse();
          }(this.editor.model.document.selection),
              _ref190 = _slicedToArray(_ref189, 2),
              e = _ref190[0],
              t = _ref190[1],
              i = e.parent.parent,
              n = _toConsumableArray(new Yp(i)),
              o = {
            first: n.find(function (t) {
              return t.cell === e;
            }).column,
            last: n.find(function (e) {
              return e.cell === t;
            }).column
          },
              r = function (e, t, i, n) {
            return parseInt(i.getAttribute("colspan") || 1) > 1 ? i : t.previousSibling || i.nextSibling ? i.nextSibling || t.previousSibling : n.first ? e.reverse().find(function (_ref191) {
              var e = _ref191.column;
              return e < n.first;
            }).cell : e.reverse().find(function (_ref192) {
              var e = _ref192.column;
              return e > n.last;
            }).cell;
          }(n, e, t, o);

          this.editor.model.change(function (e) {
            var t = o.last - o.first + 1;
            _this278.editor.plugins.get("TableUtils").removeColumns(i, {
              at: o.first,
              columns: t
            }), e.setSelection(e.createPositionAt(r, 0));
          });
        }
      }]);

      return Rb;
    }(Ze);

    var Ob =
    /*#__PURE__*/
    function (_Ze32) {
      _inherits(Ob, _Ze32);

      function Ob() {
        _classCallCheck(this, Ob);

        return _possibleConstructorReturn(this, _getPrototypeOf(Ob).apply(this, arguments));
      }

      _createClass(Ob, [{
        key: "refresh",
        value: function refresh() {
          var _this279 = this;

          var e = cb(this.editor.model.document.selection),
              t = e.length > 0;
          this.isEnabled = t, this.value = t && e.every(function (e) {
            return _this279._isInHeading(e, e.parent.parent);
          });
        }
      }, {
        key: "execute",
        value: function execute() {
          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          if (e.forceValue === this.value) return;

          var t = this.editor.model,
              i = cb(t.document.selection),
              n = i[0].findAncestor("table"),
              _lb = lb(i),
              o = _lb.first,
              r = _lb.last,
              s = this.value ? o : r + 1,
              a = n.getAttribute("headingRows") || 0;

          t.change(function (e) {
            if (s) {
              var _t301 = _b(n, s, s > a ? a : 0);

              var _iteratorNormalCompletion422 = true;
              var _didIteratorError422 = false;
              var _iteratorError422 = undefined;

              try {
                for (var _iterator422 = _t301[Symbol.iterator](), _step422; !(_iteratorNormalCompletion422 = (_step422 = _iterator422.next()).done); _iteratorNormalCompletion422 = true) {
                  var _ref194 = _step422.value;
                  var _i312 = _ref194.cell;
                  vb(_i312, s, e);
                }
              } catch (err) {
                _didIteratorError422 = true;
                _iteratorError422 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion422 && _iterator422.return != null) {
                    _iterator422.return();
                  }
                } finally {
                  if (_didIteratorError422) {
                    throw _iteratorError422;
                  }
                }
              }
            }

            Fp("headingRows", s, n, e, 0);
          });
        }
      }, {
        key: "_isInHeading",
        value: function _isInHeading(e, t) {
          var i = parseInt(t.getAttribute("headingRows") || 0);
          return !!i && e.parent.index < i;
        }
      }]);

      return Ob;
    }(Ze);

    var zb =
    /*#__PURE__*/
    function (_Ze33) {
      _inherits(zb, _Ze33);

      function zb() {
        _classCallCheck(this, zb);

        return _possibleConstructorReturn(this, _getPrototypeOf(zb).apply(this, arguments));
      }

      _createClass(zb, [{
        key: "refresh",
        value: function refresh() {
          var e = cb(this.editor.model.document.selection),
              t = this.editor.plugins.get("TableUtils"),
              i = e.length > 0;
          this.isEnabled = i, this.value = i && e.every(function (e) {
            return Up(t, e);
          });
        }
      }, {
        key: "execute",
        value: function execute() {
          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          if (e.forceValue === this.value) return;

          var t = this.editor.model,
              i = cb(t.document.selection),
              n = i[0].findAncestor("table"),
              _db2 = db(i),
              o = _db2.first,
              r = _db2.last,
              s = this.value ? o : r + 1;

          t.change(function (e) {
            if (s) {
              var _t302 = yb(n, s);

              var _iteratorNormalCompletion423 = true;
              var _didIteratorError423 = false;
              var _iteratorError423 = undefined;

              try {
                for (var _iterator423 = _t302[Symbol.iterator](), _step423; !(_iteratorNormalCompletion423 = (_step423 = _iterator423.next()).done); _iteratorNormalCompletion423 = true) {
                  var _ref196 = _step423.value;
                  var _i313 = _ref196.cell;
                  var _n188 = _ref196.column;
                  xb(_i313, _n188, s, e);
                }
              } catch (err) {
                _didIteratorError423 = true;
                _iteratorError423 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion423 && _iterator423.return != null) {
                    _iterator423.return();
                  }
                } finally {
                  if (_didIteratorError423) {
                    throw _iteratorError423;
                  }
                }
              }
            }

            Fp("headingColumns", s, n, e, 0);
          });
        }
      }]);

      return zb;
    }(Ze);

    var Db =
    /*#__PURE__*/
    function (_Qe61) {
      _inherits(Db, _Qe61);

      function Db() {
        _classCallCheck(this, Db);

        return _possibleConstructorReturn(this, _getPrototypeOf(Db).apply(this, arguments));
      }

      _createClass(Db, [{
        key: "init",
        value: function init() {
          this.decorate("insertColumns"), this.decorate("insertRows");
        }
      }, {
        key: "getCellLocation",
        value: function getCellLocation(e) {
          var t = e.parent,
              i = t.parent,
              n = i.getChildIndex(t),
              o = new Yp(i, {
            row: n
          });
          var _iteratorNormalCompletion424 = true;
          var _didIteratorError424 = false;
          var _iteratorError424 = undefined;

          try {
            for (var _iterator424 = o[Symbol.iterator](), _step424; !(_iteratorNormalCompletion424 = (_step424 = _iterator424.next()).done); _iteratorNormalCompletion424 = true) {
              var _ref198 = _step424.value;
              var _t303 = _ref198.cell;
              var _i314 = _ref198.row;
              var _n189 = _ref198.column;
              if (_t303 === e) return {
                row: _i314,
                column: _n189
              };
            }
          } catch (err) {
            _didIteratorError424 = true;
            _iteratorError424 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion424 && _iterator424.return != null) {
                _iterator424.return();
              }
            } finally {
              if (_didIteratorError424) {
                throw _iteratorError424;
              }
            }
          }
        }
      }, {
        key: "createTable",
        value: function createTable(e, t) {
          var i = e.createElement("table");
          return Lb(e, i, 0, parseInt(t.rows) || 2, parseInt(t.columns) || 2), t.headingRows && Fp("headingRows", t.headingRows, i, e, 0), t.headingColumns && Fp("headingColumns", t.headingColumns, i, e, 0), i;
        }
      }, {
        key: "insertRows",
        value: function insertRows(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var i = this.editor.model,
              n = t.at || 0,
              o = t.rows || 1,
              r = void 0 !== t.copyStructureFromAbove,
              s = t.copyStructureFromAbove ? n - 1 : n,
              a = this.getRows(e),
              l = this.getColumns(e);
          if (n > a) throw new c.a("tableutils-insertrows-insert-out-of-range", this, {
            options: t
          });
          i.change(function (t) {
            var i = e.getAttribute("headingRows") || 0;
            if (i > n && Fp("headingRows", i + o, e, t, 0), !r && (0 === n || n === a)) return void Lb(t, e, n, o, l);
            var c = r ? Math.max(n, s) : n,
                d = new Yp(e, {
              endRow: c
            }),
                h = new Array(l).fill(1);
            var _iteratorNormalCompletion425 = true;
            var _didIteratorError425 = false;
            var _iteratorError425 = undefined;

            try {
              for (var _iterator425 = d[Symbol.iterator](), _step425; !(_iteratorNormalCompletion425 = (_step425 = _iterator425.next()).done); _iteratorNormalCompletion425 = true) {
                var _ref200 = _step425.value;
                var _e347 = _ref200.row;
                var _i317 = _ref200.column;
                var _a26 = _ref200.cellHeight;
                var _c17 = _ref200.cellWidth;
                var _l8 = _ref200.cell;

                var _d5 = _e347 + _a26 - 1,
                    _u4 = _e347 <= s && s <= _d5;

                _e347 < n && n <= _d5 ? (t.setAttribute("rowspan", _a26 + o, _l8), h[_i317] = -_c17) : r && _u4 && (h[_i317] = _c17);
              }
            } catch (err) {
              _didIteratorError425 = true;
              _iteratorError425 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion425 && _iterator425.return != null) {
                  _iterator425.return();
                }
              } finally {
                if (_didIteratorError425) {
                  throw _iteratorError425;
                }
              }
            }

            for (var _i315 = 0; _i315 < o; _i315++) {
              var _i316 = t.createElement("tableRow");

              t.insert(_i316, e, n);

              for (var _e346 = 0; _e346 < h.length; _e346++) {
                var _n190 = h[_e346],
                    _o119 = t.createPositionAt(_i316, "end");

                _n190 > 0 && Hp(t, _o119, _n190 > 1 ? {
                  colspan: _n190
                } : null), _e346 += Math.abs(_n190) - 1;
              }
            }
          });
        }
      }, {
        key: "insertColumns",
        value: function insertColumns(e) {
          var _this280 = this;

          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var i = this.editor.model,
              n = t.at || 0,
              o = t.columns || 1;
          i.change(function (t) {
            var i = e.getAttribute("headingColumns");
            n < i && t.setAttribute("headingColumns", i + o, e);

            var r = _this280.getColumns(e);

            if (0 === n || r === n) {
              var _iteratorNormalCompletion426 = true;
              var _didIteratorError426 = false;
              var _iteratorError426 = undefined;

              try {
                for (var _iterator426 = e.getChildren()[Symbol.iterator](), _step426; !(_iteratorNormalCompletion426 = (_step426 = _iterator426.next()).done); _iteratorNormalCompletion426 = true) {
                  var _i318 = _step426.value;
                  _i318.is("element", "tableRow") && Vb(o, t, t.createPositionAt(_i318, n ? "end" : 0));
                }
              } catch (err) {
                _didIteratorError426 = true;
                _iteratorError426 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion426 && _iterator426.return != null) {
                    _iterator426.return();
                  }
                } finally {
                  if (_didIteratorError426) {
                    throw _iteratorError426;
                  }
                }
              }

              return;
            }

            var s = new Yp(e, {
              column: n,
              includeAllSlots: !0
            });
            var _iteratorNormalCompletion427 = true;
            var _didIteratorError427 = false;
            var _iteratorError427 = undefined;

            try {
              for (var _iterator427 = s[Symbol.iterator](), _step427; !(_iteratorNormalCompletion427 = (_step427 = _iterator427.next()).done); _iteratorNormalCompletion427 = true) {
                var _e348 = _step427.value;
                var _i319 = _e348.row,
                    _r75 = _e348.cell,
                    _a27 = _e348.cellAnchorColumn,
                    _c18 = _e348.cellAnchorRow,
                    _l9 = _e348.cellWidth,
                    _d6 = _e348.cellHeight;

                if (_a27 < n) {
                  t.setAttribute("colspan", _l9 + o, _r75);

                  var _e349 = _c18 + _d6 - 1;

                  for (var _t304 = _i319; _t304 <= _e349; _t304++) {
                    s.skipRow(_t304);
                  }
                } else Vb(o, t, _e348.getPositionBefore());
              }
            } catch (err) {
              _didIteratorError427 = true;
              _iteratorError427 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion427 && _iterator427.return != null) {
                  _iterator427.return();
                }
              } finally {
                if (_didIteratorError427) {
                  throw _iteratorError427;
                }
              }
            }
          });
        }
      }, {
        key: "removeRows",
        value: function removeRows(e, t) {
          var _this281 = this;

          var i = this.editor.model,
              n = t.rows || 1,
              o = this.getRows(e),
              r = t.at,
              s = r + n - 1;
          if (s > o - 1) throw new c.a("tableutils-removerows-row-index-out-of-range", this, {
            table: e,
            options: t
          });
          i.change(function (t) {
            var _ref201 = function (e, t, i) {
              var n = new Map(),
                  o = [];
              var _iteratorNormalCompletion428 = true;
              var _didIteratorError428 = false;
              var _iteratorError428 = undefined;

              try {
                for (var _iterator428 = new Yp(e, {
                  endRow: i
                })[Symbol.iterator](), _step428; !(_iteratorNormalCompletion428 = (_step428 = _iterator428.next()).done); _iteratorNormalCompletion428 = true) {
                  var _ref203 = _step428.value;
                  var _r76 = _ref203.row;
                  var _s40 = _ref203.column;
                  var _a28 = _ref203.cellHeight;
                  var _c19 = _ref203.cell;

                  var _e350 = _r76 + _a28 - 1;

                  if (_r76 >= t && _r76 <= i && _e350 > i) {
                    var _e351 = _a28 - (i - _r76 + 1);

                    n.set(_s40, {
                      cell: _c19,
                      rowspan: _e351
                    });
                  }

                  if (_r76 < t && _e350 >= t) {
                    var _n191 = void 0;

                    _n191 = _e350 >= i ? i - t + 1 : _e350 - t + 1, o.push({
                      cell: _c19,
                      rowspan: _a28 - _n191
                    });
                  }
                }
              } catch (err) {
                _didIteratorError428 = true;
                _iteratorError428 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion428 && _iterator428.return != null) {
                    _iterator428.return();
                  }
                } finally {
                  if (_didIteratorError428) {
                    throw _iteratorError428;
                  }
                }
              }

              return {
                cellsToMove: n,
                cellsToTrim: o
              };
            }(e, r, s),
                i = _ref201.cellsToMove,
                n = _ref201.cellsToTrim;

            if (i.size) {
              !function (e, t, i, n) {
                var o = _toConsumableArray(new Yp(e, {
                  includeAllSlots: !0,
                  row: t
                })),
                    r = e.getChild(t);

                var s;
                var _iteratorNormalCompletion429 = true;
                var _didIteratorError429 = false;
                var _iteratorError429 = undefined;

                try {
                  for (var _iterator429 = o[Symbol.iterator](), _step429; !(_iteratorNormalCompletion429 = (_step429 = _iterator429.next()).done); _iteratorNormalCompletion429 = true) {
                    var _ref205 = _step429.value;
                    var _e352 = _ref205.column;
                    var _t305 = _ref205.cell;
                    var _a29 = _ref205.isAnchor;

                    if (i.has(_e352)) {
                      var _i$get = i.get(_e352),
                          _t306 = _i$get.cell,
                          _o120 = _i$get.rowspan,
                          _a30 = s ? n.createPositionAfter(s) : n.createPositionAt(r, 0);

                      n.move(n.createRangeOn(_t306), _a30), Fp("rowspan", _o120, _t306, n), s = _t306;
                    } else _a29 && (s = _t305);
                  }
                } catch (err) {
                  _didIteratorError429 = true;
                  _iteratorError429 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion429 && _iterator429.return != null) {
                      _iterator429.return();
                    }
                  } finally {
                    if (_didIteratorError429) {
                      throw _iteratorError429;
                    }
                  }
                }
              }(e, s + 1, i, t);
            }

            for (var _i320 = s; _i320 >= r; _i320--) {
              t.remove(e.getChild(_i320));
            }

            var _iteratorNormalCompletion430 = true;
            var _didIteratorError430 = false;
            var _iteratorError430 = undefined;

            try {
              for (var _iterator430 = n[Symbol.iterator](), _step430; !(_iteratorNormalCompletion430 = (_step430 = _iterator430.next()).done); _iteratorNormalCompletion430 = true) {
                var _ref207 = _step430.value;
                var _e353 = _ref207.rowspan;
                var _i321 = _ref207.cell;
                Fp("rowspan", _e353, _i321, t);
              }
            } catch (err) {
              _didIteratorError430 = true;
              _iteratorError430 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion430 && _iterator430.return != null) {
                  _iterator430.return();
                }
              } finally {
                if (_didIteratorError430) {
                  throw _iteratorError430;
                }
              }
            }

            !function (e, t, i, n) {
              var o = e.getAttribute("headingRows") || 0;

              if (t < o) {
                Fp("headingRows", i < o ? o - (i - t + 1) : t, e, n, 0);
              }
            }(e, r, s, t), Cb(e, _this281) || Tb(e, _this281);
          });
        }
      }, {
        key: "removeColumns",
        value: function removeColumns(e, t) {
          var _this282 = this;

          var i = this.editor.model,
              n = t.at,
              o = t.columns || 1,
              r = t.at + o - 1;
          i.change(function (t) {
            !function (e, t, i) {
              var n = e.getAttribute("headingColumns") || 0;

              if (n && t.first < n) {
                var _o121 = Math.min(n - 1, t.last) - t.first + 1;

                i.setAttribute("headingColumns", n - _o121, e);
              }
            }(e, {
              first: n,
              last: r
            }, t);

            for (var _i322 = r; _i322 >= n; _i322--) {
              for (var _i323 = 0, _arr2 = _toConsumableArray(new Yp(e)); _i323 < _arr2.length; _i323++) {
                var _ref209 = _arr2[_i323];
                var _n192 = _ref209.cell;
                var _o122 = _ref209.column;
                var _r77 = _ref209.cellWidth;
                _o122 <= _i322 && _r77 > 1 && _o122 + _r77 > _i322 ? Fp("colspan", _r77 - 1, _n192, t) : _o122 === _i322 && t.remove(_n192);
              }
            }

            Tb(e, _this282) || Cb(e, _this282);
          });
        }
      }, {
        key: "splitCellVertically",
        value: function splitCellVertically(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
          var i = this.editor.model,
              n = e.parent.parent,
              o = parseInt(e.getAttribute("rowspan") || 1),
              r = parseInt(e.getAttribute("colspan") || 1);
          i.change(function (i) {
            if (r > 1) {
              var _jb = jb(r, t),
                  _n193 = _jb.newCellsSpan,
                  _s41 = _jb.updatedSpan;

              Fp("colspan", _s41, e, i);
              var _a31 = {};
              _n193 > 1 && (_a31.colspan = _n193), o > 1 && (_a31.rowspan = o);
              Vb(r > t ? t - 1 : r - 1, i, i.createPositionAfter(e), _a31);
            }

            if (r < t) {
              var _s42 = t - r,
                  _a32 = _toConsumableArray(new Yp(n)),
                  _a32$find = _a32.find(function (_ref210) {
                var t = _ref210.cell;
                return t === e;
              }),
                  _c20 = _a32$find.column,
                  _l10 = _a32.filter(function (_ref211) {
                var t = _ref211.cell,
                    i = _ref211.cellWidth,
                    n = _ref211.column;
                return t !== e && n === _c20 || n < _c20 && n + i > _c20;
              });

              var _iteratorNormalCompletion431 = true;
              var _didIteratorError431 = false;
              var _iteratorError431 = undefined;

              try {
                for (var _iterator431 = _l10[Symbol.iterator](), _step431; !(_iteratorNormalCompletion431 = (_step431 = _iterator431.next()).done); _iteratorNormalCompletion431 = true) {
                  var _ref213 = _step431.value;
                  var _e354 = _ref213.cell;
                  var _t307 = _ref213.cellWidth;
                  i.setAttribute("colspan", _t307 + _s42, _e354);
                }
              } catch (err) {
                _didIteratorError431 = true;
                _iteratorError431 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion431 && _iterator431.return != null) {
                    _iterator431.return();
                  }
                } finally {
                  if (_didIteratorError431) {
                    throw _iteratorError431;
                  }
                }
              }

              var _d7 = {};
              o > 1 && (_d7.rowspan = o), Vb(_s42, i, i.createPositionAfter(e), _d7);

              var _h5 = n.getAttribute("headingColumns") || 0;

              _h5 > _c20 && Fp("headingColumns", _h5 + _s42, n, i);
            }
          });
        }
      }, {
        key: "splitCellHorizontally",
        value: function splitCellHorizontally(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
          var i = this.editor.model,
              n = e.parent,
              o = n.parent,
              r = o.getChildIndex(n),
              s = parseInt(e.getAttribute("rowspan") || 1),
              a = parseInt(e.getAttribute("colspan") || 1);
          i.change(function (i) {
            if (s > 1) {
              var _n194 = _toConsumableArray(new Yp(o, {
                startRow: r,
                endRow: r + s - 1,
                includeAllSlots: !0
              })),
                  _jb2 = jb(s, t),
                  _c21 = _jb2.newCellsSpan,
                  _l11 = _jb2.updatedSpan;

              Fp("rowspan", _l11, e, i);

              var _n194$find = _n194.find(function (_ref214) {
                var t = _ref214.cell;
                return t === e;
              }),
                  _d8 = _n194$find.column,
                  _h6 = {};

              _c21 > 1 && (_h6.rowspan = _c21), a > 1 && (_h6.colspan = a);

              for (var _i324 = 0, _n195 = _n194; _i324 < _n195.length; _i324++) {
                var _e355 = _n195[_i324];

                var _t308 = _e355.column,
                    _n196 = _e355.row,
                    _o123 = _t308 === _d8,
                    _s43 = (_n196 + r + _l11) % _c21 == 0;

                _n196 >= r + _l11 && _o123 && _s43 && Vb(1, i, _e355.getPositionBefore(), _h6);
              }
            }

            if (s < t) {
              var _n197 = t - s,
                  _c22 = _toConsumableArray(new Yp(o, {
                startRow: 0,
                endRow: r
              }));

              var _iteratorNormalCompletion432 = true;
              var _didIteratorError432 = false;
              var _iteratorError432 = undefined;

              try {
                for (var _iterator432 = _c22[Symbol.iterator](), _step432; !(_iteratorNormalCompletion432 = (_step432 = _iterator432.next()).done); _iteratorNormalCompletion432 = true) {
                  var _ref216 = _step432.value;
                  var _t309 = _ref216.cell;
                  var _o124 = _ref216.cellHeight;
                  var _s44 = _ref216.row;

                  if (_t309 !== e && _s44 + _o124 > r) {
                    var _e356 = _o124 + _n197;

                    i.setAttribute("rowspan", _e356, _t309);
                  }
                }
              } catch (err) {
                _didIteratorError432 = true;
                _iteratorError432 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion432 && _iterator432.return != null) {
                    _iterator432.return();
                  }
                } finally {
                  if (_didIteratorError432) {
                    throw _iteratorError432;
                  }
                }
              }

              var _l12 = {};
              a > 1 && (_l12.colspan = a), Lb(i, o, r + 1, _n197, 1, _l12);

              var _d9 = o.getAttribute("headingRows") || 0;

              _d9 > r && Fp("headingRows", _d9 + _n197, o, i);
            }
          });
        }
      }, {
        key: "getColumns",
        value: function getColumns(e) {
          return _toConsumableArray(e.getChild(0).getChildren()).reduce(function (e, t) {
            return e + parseInt(t.getAttribute("colspan") || 1);
          }, 0);
        }
      }, {
        key: "getRows",
        value: function getRows(e) {
          return Array.from(e.getChildren()).reduce(function (e, t) {
            return t.is("element", "tableRow") ? e + 1 : e;
          }, 0);
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "TableUtils";
        }
      }]);

      return Db;
    }(Qe);

    function Lb(e, t, i, n, o) {
      var r = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

      for (var _s45 = 0; _s45 < n; _s45++) {
        var _n198 = e.createElement("tableRow");

        e.insert(_n198, t, i), Vb(o, e, e.createPositionAt(_n198, "end"), r);
      }
    }

    function Vb(e, t, i) {
      var n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

      for (var _o125 = 0; _o125 < e; _o125++) {
        Hp(t, i, n);
      }
    }

    function jb(e, t) {
      if (e < t) return {
        newCellsSpan: 1,
        updatedSpan: 1
      };
      var i = Math.floor(e / t);
      return {
        newCellsSpan: i,
        updatedSpan: e - i * t + i
      };
    }

    var Bb =
    /*#__PURE__*/
    function (_Ze34) {
      _inherits(Bb, _Ze34);

      function Bb() {
        _classCallCheck(this, Bb);

        return _possibleConstructorReturn(this, _getPrototypeOf(Bb).apply(this, arguments));
      }

      _createClass(Bb, [{
        key: "refresh",
        value: function refresh() {
          var e = sb(this.editor.model.document.selection);
          this.isEnabled = hb(e, this.editor.plugins.get(Db));
        }
      }, {
        key: "execute",
        value: function execute() {
          var e = this.editor.model,
              t = this.editor.plugins.get(Db);
          e.change(function (i) {
            var n = sb(e.document.selection),
                o = n.shift(),
                _ref217 = function (e, t, i) {
              var n = 0,
                  o = 0;
              var _iteratorNormalCompletion433 = true;
              var _didIteratorError433 = false;
              var _iteratorError433 = undefined;

              try {
                for (var _iterator433 = t[Symbol.iterator](), _step433; !(_iteratorNormalCompletion433 = (_step433 = _iterator433.next()).done); _iteratorNormalCompletion433 = true) {
                  var _e357 = _step433.value;

                  var _i$getCellLocation4 = i.getCellLocation(_e357),
                      _t310 = _i$getCellLocation4.row,
                      _r78 = _i$getCellLocation4.column;

                  n = Ub(_e357, _r78, n, "colspan"), o = Ub(_e357, _t310, o, "rowspan");
                }
              } catch (err) {
                _didIteratorError433 = true;
                _iteratorError433 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion433 && _iterator433.return != null) {
                    _iterator433.return();
                  }
                } finally {
                  if (_didIteratorError433) {
                    throw _iteratorError433;
                  }
                }
              }

              var _i$getCellLocation3 = i.getCellLocation(e),
                  r = _i$getCellLocation3.row,
                  s = _i$getCellLocation3.column;

              return {
                mergeWidth: n - s,
                mergeHeight: o - r
              };
            }(o, n, t),
                r = _ref217.mergeWidth,
                s = _ref217.mergeHeight;

            Fp("colspan", r, o, i), Fp("rowspan", s, o, i);
            var _iteratorNormalCompletion434 = true;
            var _didIteratorError434 = false;
            var _iteratorError434 = undefined;

            try {
              for (var _iterator434 = n[Symbol.iterator](), _step434; !(_iteratorNormalCompletion434 = (_step434 = _iterator434.next()).done); _iteratorNormalCompletion434 = true) {
                var _e358 = _step434.value;
                Fb(_e358, o, i);
              }
            } catch (err) {
              _didIteratorError434 = true;
              _iteratorError434 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion434 && _iterator434.return != null) {
                  _iterator434.return();
                }
              } finally {
                if (_didIteratorError434) {
                  throw _iteratorError434;
                }
              }
            }

            Eb(o.findAncestor("table"), t), i.setSelection(o, "in");
          });
        }
      }]);

      return Bb;
    }(Ze);

    function Fb(e, t, i) {
      Hb(e) || (Hb(t) && i.remove(i.createRangeIn(t)), i.move(i.createRangeIn(e), i.createPositionAt(t, "end"))), i.remove(e);
    }

    function Hb(e) {
      return 1 == e.childCount && e.getChild(0).is("element", "paragraph") && e.getChild(0).isEmpty;
    }

    function Ub(e, t, i, n) {
      var o = parseInt(e.getAttribute(n) || 1);
      return Math.max(i, t + o);
    }

    var Wb =
    /*#__PURE__*/
    function (_Ze35) {
      _inherits(Wb, _Ze35);

      function Wb() {
        _classCallCheck(this, Wb);

        return _possibleConstructorReturn(this, _getPrototypeOf(Wb).apply(this, arguments));
      }

      _createClass(Wb, [{
        key: "refresh",
        value: function refresh() {
          var e = cb(this.editor.model.document.selection);
          this.isEnabled = e.length > 0;
        }
      }, {
        key: "execute",
        value: function execute() {
          var e = this.editor.model,
              t = cb(e.document.selection),
              i = lb(t),
              n = t[0].findAncestor("table"),
              o = [];

          for (var _t311 = i.first; _t311 <= i.last; _t311++) {
            var _iteratorNormalCompletion435 = true;
            var _didIteratorError435 = false;
            var _iteratorError435 = undefined;

            try {
              for (var _iterator435 = n.getChild(_t311).getChildren()[Symbol.iterator](), _step435; !(_iteratorNormalCompletion435 = (_step435 = _iterator435.next()).done); _iteratorNormalCompletion435 = true) {
                var _i325 = _step435.value;
                o.push(e.createRangeOn(_i325));
              }
            } catch (err) {
              _didIteratorError435 = true;
              _iteratorError435 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion435 && _iterator435.return != null) {
                  _iterator435.return();
                }
              } finally {
                if (_didIteratorError435) {
                  throw _iteratorError435;
                }
              }
            }
          }

          e.change(function (e) {
            e.setSelection(o);
          });
        }
      }]);

      return Wb;
    }(Ze);

    var qb =
    /*#__PURE__*/
    function (_Ze36) {
      _inherits(qb, _Ze36);

      function qb() {
        _classCallCheck(this, qb);

        return _possibleConstructorReturn(this, _getPrototypeOf(qb).apply(this, arguments));
      }

      _createClass(qb, [{
        key: "refresh",
        value: function refresh() {
          var e = cb(this.editor.model.document.selection);
          this.isEnabled = e.length > 0;
        }
      }, {
        key: "execute",
        value: function execute() {
          var e = this.editor.model,
              t = cb(e.document.selection),
              i = t[0],
              n = t.pop(),
              o = i.findAncestor("table"),
              r = this.editor.plugins.get("TableUtils"),
              s = r.getCellLocation(i),
              a = r.getCellLocation(n),
              c = Math.min(s.column, a.column),
              l = Math.max(s.column, a.column),
              d = [];
          var _iteratorNormalCompletion436 = true;
          var _didIteratorError436 = false;
          var _iteratorError436 = undefined;

          try {
            for (var _iterator436 = new Yp(o, {
              startColumn: c,
              endColumn: l
            })[Symbol.iterator](), _step436; !(_iteratorNormalCompletion436 = (_step436 = _iterator436.next()).done); _iteratorNormalCompletion436 = true) {
              var _t312 = _step436.value;
              d.push(e.createRangeOn(_t312.cell));
            }
          } catch (err) {
            _didIteratorError436 = true;
            _iteratorError436 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion436 && _iterator436.return != null) {
                _iterator436.return();
              }
            } finally {
              if (_didIteratorError436) {
                throw _iteratorError436;
              }
            }
          }

          e.change(function (e) {
            e.setSelection(d);
          });
        }
      }]);

      return qb;
    }(Ze);

    function $b(e) {
      e.document.registerPostFixer(function (t) {
        return function (e, t) {
          var i = t.document.differ.getChanges();
          var n = !1;
          var o = new Set();
          var _iteratorNormalCompletion437 = true;
          var _didIteratorError437 = false;
          var _iteratorError437 = undefined;

          try {
            for (var _iterator437 = i[Symbol.iterator](), _step437; !(_iteratorNormalCompletion437 = (_step437 = _iterator437.next()).done); _iteratorNormalCompletion437 = true) {
              var _t313 = _step437.value;

              var _i326 = void 0;

              "table" == _t313.name && "insert" == _t313.type && (_i326 = _t313.position.nodeAfter), "tableRow" != _t313.name && "tableCell" != _t313.name || (_i326 = _t313.position.findAncestor("table")), Kb(_t313) && (_i326 = _t313.range.start.findAncestor("table")), _i326 && !o.has(_i326) && (n = Yb(_i326, e) || n, n = Gb(_i326, e) || n, o.add(_i326));
            }
          } catch (err) {
            _didIteratorError437 = true;
            _iteratorError437 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion437 && _iterator437.return != null) {
                _iterator437.return();
              }
            } finally {
              if (_didIteratorError437) {
                throw _iteratorError437;
              }
            }
          }

          return n;
        }(t, e);
      });
    }

    function Yb(e, t) {
      var i = !1;

      var n = function (e) {
        var t = parseInt(e.getAttribute("headingRows") || 0),
            i = Array.from(e.getChildren()).reduce(function (e, t) {
          return t.is("element", "tableRow") ? e + 1 : e;
        }, 0),
            n = [];
        var _iteratorNormalCompletion438 = true;
        var _didIteratorError438 = false;
        var _iteratorError438 = undefined;

        try {
          for (var _iterator438 = new Yp(e)[Symbol.iterator](), _step438; !(_iteratorNormalCompletion438 = (_step438 = _iterator438.next()).done); _iteratorNormalCompletion438 = true) {
            var _ref219 = _step438.value;
            var _o126 = _ref219.row;
            var _r79 = _ref219.cell;
            var _s46 = _ref219.cellHeight;
            if (_s46 < 2) continue;

            var _e359 = _o126 < t ? t : i;

            if (_o126 + _s46 > _e359) {
              var _t314 = _e359 - _o126;

              n.push({
                cell: _r79,
                rowspan: _t314
              });
            }
          }
        } catch (err) {
          _didIteratorError438 = true;
          _iteratorError438 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion438 && _iterator438.return != null) {
              _iterator438.return();
            }
          } finally {
            if (_didIteratorError438) {
              throw _iteratorError438;
            }
          }
        }

        return n;
      }(e);

      if (n.length) {
        i = !0;
        var _iteratorNormalCompletion439 = true;
        var _didIteratorError439 = false;
        var _iteratorError439 = undefined;

        try {
          for (var _iterator439 = n[Symbol.iterator](), _step439; !(_iteratorNormalCompletion439 = (_step439 = _iterator439.next()).done); _iteratorNormalCompletion439 = true) {
            var _e360 = _step439.value;
            Fp("rowspan", _e360.rowspan, _e360.cell, t, 1);
          }
        } catch (err) {
          _didIteratorError439 = true;
          _iteratorError439 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion439 && _iterator439.return != null) {
              _iterator439.return();
            }
          } finally {
            if (_didIteratorError439) {
              throw _iteratorError439;
            }
          }
        }
      }

      return i;
    }

    function Gb(e, t) {
      var i = !1;

      var n = function (e) {
        var t = new Array(e.childCount).fill(0);
        var _iteratorNormalCompletion440 = true;
        var _didIteratorError440 = false;
        var _iteratorError440 = undefined;

        try {
          for (var _iterator440 = new Yp(e, {
            includeAllSlots: !0
          })[Symbol.iterator](), _step440; !(_iteratorNormalCompletion440 = (_step440 = _iterator440.next()).done); _iteratorNormalCompletion440 = true) {
            var _ref221 = _step440.value;
            var _i327 = _ref221.rowIndex;
            t[_i327]++;
          }
        } catch (err) {
          _didIteratorError440 = true;
          _iteratorError440 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion440 && _iterator440.return != null) {
              _iterator440.return();
            }
          } finally {
            if (_didIteratorError440) {
              throw _iteratorError440;
            }
          }
        }

        return t;
      }(e),
          o = [];

      var _iteratorNormalCompletion441 = true;
      var _didIteratorError441 = false;
      var _iteratorError441 = undefined;

      try {
        for (var _iterator441 = n.entries()[Symbol.iterator](), _step441; !(_iteratorNormalCompletion441 = (_step441 = _iterator441.next()).done); _iteratorNormalCompletion441 = true) {
          var _ref227 = _step441.value;

          var _ref223 = _slicedToArray(_ref227, 2);

          var _t315 = _ref223[0];
          var _i330 = _ref223[1];
          !_i330 && e.getChild(_t315).is("element", "tableRow") && o.push(_t315);
        }
      } catch (err) {
        _didIteratorError441 = true;
        _iteratorError441 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion441 && _iterator441.return != null) {
            _iterator441.return();
          }
        } finally {
          if (_didIteratorError441) {
            throw _iteratorError441;
          }
        }
      }

      if (o.length) {
        i = !0;
        var _iteratorNormalCompletion442 = true;
        var _didIteratorError442 = false;
        var _iteratorError442 = undefined;

        try {
          for (var _iterator442 = o.reverse()[Symbol.iterator](), _step442; !(_iteratorNormalCompletion442 = (_step442 = _iterator442.next()).done); _iteratorNormalCompletion442 = true) {
            var _i328 = _step442.value;
            t.remove(e.getChild(_i328)), n.splice(_i328, 1);
          }
        } catch (err) {
          _didIteratorError442 = true;
          _iteratorError442 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion442 && _iterator442.return != null) {
              _iterator442.return();
            }
          } finally {
            if (_didIteratorError442) {
              throw _iteratorError442;
            }
          }
        }
      }

      var r = n.filter(function (t, i) {
        return e.getChild(i).is("element", "tableRow");
      }),
          s = r[0];

      if (!r.every(function (e) {
        return e === s;
      })) {
        var _n199 = r.reduce(function (e, t) {
          return t > e ? t : e;
        }, 0);

        var _iteratorNormalCompletion443 = true;
        var _didIteratorError443 = false;
        var _iteratorError443 = undefined;

        try {
          for (var _iterator443 = r.entries()[Symbol.iterator](), _step443; !(_iteratorNormalCompletion443 = (_step443 = _iterator443.next()).done); _iteratorNormalCompletion443 = true) {
            var _ref226 = _step443.value;

            var _ref225 = _slicedToArray(_ref226, 2);

            var _o127 = _ref225[0];
            var _s47 = _ref225[1];

            var _r80 = _n199 - _s47;

            if (_r80) {
              for (var _i329 = 0; _i329 < _r80; _i329++) {
                Hp(t, t.createPositionAt(e.getChild(_o127), "end"));
              }

              i = !0;
            }
          }
        } catch (err) {
          _didIteratorError443 = true;
          _iteratorError443 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion443 && _iterator443.return != null) {
              _iterator443.return();
            }
          } finally {
            if (_didIteratorError443) {
              throw _iteratorError443;
            }
          }
        }
      }

      return i;
    }

    function Kb(e) {
      var t = "attribute" === e.type,
          i = e.attributeKey;
      return t && ("headingRows" === i || "colspan" === i || "rowspan" === i);
    }

    function Qb(e) {
      e.document.registerPostFixer(function (t) {
        return function (e, t) {
          var i = t.document.differ.getChanges();
          var n = !1;
          var _iteratorNormalCompletion444 = true;
          var _didIteratorError444 = false;
          var _iteratorError444 = undefined;

          try {
            for (var _iterator444 = i[Symbol.iterator](), _step444; !(_iteratorNormalCompletion444 = (_step444 = _iterator444.next()).done); _iteratorNormalCompletion444 = true) {
              var _t316 = _step444.value;
              "insert" == _t316.type && "table" == _t316.name && (n = Jb(_t316.position.nodeAfter, e) || n), "insert" == _t316.type && "tableRow" == _t316.name && (n = Zb(_t316.position.nodeAfter, e) || n), "insert" == _t316.type && "tableCell" == _t316.name && (n = Xb(_t316.position.nodeAfter, e) || n), ew(_t316) && (n = Xb(_t316.position.parent, e) || n);
            }
          } catch (err) {
            _didIteratorError444 = true;
            _iteratorError444 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion444 && _iterator444.return != null) {
                _iterator444.return();
              }
            } finally {
              if (_didIteratorError444) {
                throw _iteratorError444;
              }
            }
          }

          return n;
        }(t, e);
      });
    }

    function Jb(e, t) {
      var i = !1;
      var _iteratorNormalCompletion445 = true;
      var _didIteratorError445 = false;
      var _iteratorError445 = undefined;

      try {
        for (var _iterator445 = e.getChildren()[Symbol.iterator](), _step445; !(_iteratorNormalCompletion445 = (_step445 = _iterator445.next()).done); _iteratorNormalCompletion445 = true) {
          var _n200 = _step445.value;
          _n200.is("element", "tableRow") && (i = Zb(_n200, t) || i);
        }
      } catch (err) {
        _didIteratorError445 = true;
        _iteratorError445 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion445 && _iterator445.return != null) {
            _iterator445.return();
          }
        } finally {
          if (_didIteratorError445) {
            throw _iteratorError445;
          }
        }
      }

      return i;
    }

    function Zb(e, t) {
      var i = !1;
      var _iteratorNormalCompletion446 = true;
      var _didIteratorError446 = false;
      var _iteratorError446 = undefined;

      try {
        for (var _iterator446 = e.getChildren()[Symbol.iterator](), _step446; !(_iteratorNormalCompletion446 = (_step446 = _iterator446.next()).done); _iteratorNormalCompletion446 = true) {
          var _n201 = _step446.value;
          i = Xb(_n201, t) || i;
        }
      } catch (err) {
        _didIteratorError446 = true;
        _iteratorError446 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion446 && _iterator446.return != null) {
            _iterator446.return();
          }
        } finally {
          if (_didIteratorError446) {
            throw _iteratorError446;
          }
        }
      }

      return i;
    }

    function Xb(e, t) {
      if (0 == e.childCount) return t.insertElement("paragraph", e), !0;
      var i = Array.from(e.getChildren()).filter(function (e) {
        return e.is("$text");
      });
      var _iteratorNormalCompletion447 = true;
      var _didIteratorError447 = false;
      var _iteratorError447 = undefined;

      try {
        for (var _iterator447 = i[Symbol.iterator](), _step447; !(_iteratorNormalCompletion447 = (_step447 = _iterator447.next()).done); _iteratorNormalCompletion447 = true) {
          var _e361 = _step447.value;
          t.wrap(t.createRangeOn(_e361), "paragraph");
        }
      } catch (err) {
        _didIteratorError447 = true;
        _iteratorError447 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion447 && _iterator447.return != null) {
            _iterator447.return();
          }
        } finally {
          if (_didIteratorError447) {
            throw _iteratorError447;
          }
        }
      }

      return !!i.length;
    }

    function ew(e) {
      return !(!e.position || !e.position.parent.is("element", "tableCell")) && ("insert" == e.type && "$text" == e.name || "remove" == e.type);
    }

    function tw(e, t) {
      e.document.registerPostFixer(function () {
        return function (e, t) {
          var i = new Set();
          var _iteratorNormalCompletion448 = true;
          var _didIteratorError448 = false;
          var _iteratorError448 = undefined;

          try {
            for (var _iterator448 = e.getChanges()[Symbol.iterator](), _step448; !(_iteratorNormalCompletion448 = (_step448 = _iterator448.next()).done); _iteratorNormalCompletion448 = true) {
              var _t317 = _step448.value;

              var _e362 = "attribute" == _t317.type ? _t317.range.start.parent : _t317.position.parent;

              _e362.is("element", "tableCell") && i.add(_e362);
            }
          } catch (err) {
            _didIteratorError448 = true;
            _iteratorError448 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion448 && _iterator448.return != null) {
                _iterator448.return();
              }
            } finally {
              if (_didIteratorError448) {
                throw _iteratorError448;
              }
            }
          }

          var _iteratorNormalCompletion449 = true;
          var _didIteratorError449 = false;
          var _iteratorError449 = undefined;

          try {
            for (var _iterator449 = i.values()[Symbol.iterator](), _step449; !(_iteratorNormalCompletion449 = (_step449 = _iterator449.next()).done); _iteratorNormalCompletion449 = true) {
              var _n202 = _step449.value;
              var _iteratorNormalCompletion450 = true;
              var _didIteratorError450 = false;
              var _iteratorError450 = undefined;

              try {
                for (var _iterator450 = _toConsumableArray(_n202.getChildren()).filter(function (e) {
                  return iw(e, t);
                })[Symbol.iterator](), _step450; !(_iteratorNormalCompletion450 = (_step450 = _iterator450.next()).done); _iteratorNormalCompletion450 = true) {
                  var _i331 = _step450.value;
                  e.refreshItem(_i331);
                }
              } catch (err) {
                _didIteratorError450 = true;
                _iteratorError450 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion450 && _iterator450.return != null) {
                    _iterator450.return();
                  }
                } finally {
                  if (_didIteratorError450) {
                    throw _iteratorError450;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError449 = true;
            _iteratorError449 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion449 && _iterator449.return != null) {
                _iterator449.return();
              }
            } finally {
              if (_didIteratorError449) {
                throw _iteratorError449;
              }
            }
          }

          return !1;
        }(e.document.differ, t);
      });
    }

    function iw(e, t) {
      if (!e.is("element", "paragraph")) return !1;
      var i = t.toViewElement(e);
      return !!i && Jp(e) !== i.is("element", "span");
    }

    function nw(e) {
      e.document.registerPostFixer(function () {
        return function (e) {
          var t = e.document.differ,
              i = new Set();
          var _iteratorNormalCompletion451 = true;
          var _didIteratorError451 = false;
          var _iteratorError451 = undefined;

          try {
            for (var _iterator451 = t.getChanges()[Symbol.iterator](), _step451; !(_iteratorNormalCompletion451 = (_step451 = _iterator451.next()).done); _iteratorNormalCompletion451 = true) {
              var _e364 = _step451.value;
              if ("attribute" != _e364.type) continue;
              var _t318 = _e364.range.start.nodeAfter;
              _t318 && _t318.is("element", "table") && "headingRows" == _e364.attributeKey && i.add(_t318);
            }
          } catch (err) {
            _didIteratorError451 = true;
            _iteratorError451 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion451 && _iterator451.return != null) {
                _iterator451.return();
              }
            } finally {
              if (_didIteratorError451) {
                throw _iteratorError451;
              }
            }
          }

          if (i.size) {
            var _iteratorNormalCompletion452 = true;
            var _didIteratorError452 = false;
            var _iteratorError452 = undefined;

            try {
              for (var _iterator452 = i.values()[Symbol.iterator](), _step452; !(_iteratorNormalCompletion452 = (_step452 = _iterator452.next()).done); _iteratorNormalCompletion452 = true) {
                var _e363 = _step452.value;
                t.refreshItem(_e363);
              }
            } catch (err) {
              _didIteratorError452 = true;
              _iteratorError452 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion452 && _iterator452.return != null) {
                  _iterator452.return();
                }
              } finally {
                if (_didIteratorError452) {
                  throw _iteratorError452;
                }
              }
            }

            return !0;
          }

          return !1;
        }(e);
      });
    }

    i(100);

    var ow =
    /*#__PURE__*/
    function (_Qe62) {
      _inherits(ow, _Qe62);

      function ow() {
        _classCallCheck(this, ow);

        return _possibleConstructorReturn(this, _getPrototypeOf(ow).apply(this, arguments));
      }

      _createClass(ow, [{
        key: "init",
        value: function init() {
          var e = this.editor,
              t = e.model,
              i = t.schema,
              n = e.conversion;
          i.register("table", {
            allowWhere: "$block",
            allowAttributes: ["headingRows", "headingColumns"],
            isObject: !0,
            isBlock: !0
          }), i.register("tableRow", {
            allowIn: "table",
            isLimit: !0
          }), i.register("tableCell", {
            allowIn: "tableRow",
            allowChildren: "$block",
            allowAttributes: ["colspan", "rowspan"],
            isLimit: !0,
            isSelectable: !0
          }), n.for("upcast").add(function (e) {
            e.on("element:figure", function (e, t, i) {
              if (!i.consumable.test(t.viewItem, {
                name: !0,
                classes: "table"
              })) return;

              var n = function (e) {
                var _iteratorNormalCompletion453 = true;
                var _didIteratorError453 = false;
                var _iteratorError453 = undefined;

                try {
                  for (var _iterator453 = e.getChildren()[Symbol.iterator](), _step453; !(_iteratorNormalCompletion453 = (_step453 = _iterator453.next()).done); _iteratorNormalCompletion453 = true) {
                    var _t319 = _step453.value;
                    if (_t319.is("element", "table")) return _t319;
                  }
                } catch (err) {
                  _didIteratorError453 = true;
                  _iteratorError453 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion453 && _iterator453.return != null) {
                      _iterator453.return();
                    }
                  } finally {
                    if (_didIteratorError453) {
                      throw _iteratorError453;
                    }
                  }
                }
              }(t.viewItem);

              if (!n || !i.consumable.test(n, {
                name: !0
              })) return;
              var o = Os(i.convertItem(n, t.modelCursor).modelRange.getItems());
              o && (i.convertChildren(t.viewItem, i.writer.createPositionAt(o, "end")), i.updateConversionResult(o, t));
            });
          }), n.for("upcast").add(Wp()), n.for("editingDowncast").add(Kp({
            asWidget: !0
          })), n.for("dataDowncast").add(Kp()), n.for("upcast").elementToElement({
            model: "tableRow",
            view: "tr"
          }), n.for("upcast").add(function (e) {
            e.on("element:tr", function (e, t) {
              t.viewItem.isEmpty && 0 == t.modelCursor.index && e.stop();
            }, {
              priority: "high"
            });
          }), n.for("editingDowncast").add(function (e) {
            return e.on("insert:tableRow", function (e, t, i) {
              var n = t.item;
              if (!i.consumable.consume(n, "insert")) return;

              var o = n.parent,
                  r = function (e) {
                var _iteratorNormalCompletion454 = true;
                var _didIteratorError454 = false;
                var _iteratorError454 = undefined;

                try {
                  for (var _iterator454 = e.getChildren()[Symbol.iterator](), _step454; !(_iteratorNormalCompletion454 = (_step454 = _iterator454.next()).done); _iteratorNormalCompletion454 = true) {
                    var _t320 = _step454.value;
                    if ("table" === _t320.name) return _t320;
                  }
                } catch (err) {
                  _didIteratorError454 = true;
                  _iteratorError454 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion454 && _iterator454.return != null) {
                      _iterator454.return();
                    }
                  } finally {
                    if (_didIteratorError454) {
                      throw _iteratorError454;
                    }
                  }
                }
              }(i.mapper.toViewElement(o)),
                  s = o.getChildIndex(n),
                  a = new Yp(o, {
                row: s
              }),
                  c = {
                headingRows: o.getAttribute("headingRows") || 0,
                headingColumns: o.getAttribute("headingColumns") || 0
              },
                  l = new Map();

              var _iteratorNormalCompletion455 = true;
              var _didIteratorError455 = false;
              var _iteratorError455 = undefined;

              try {
                for (var _iterator455 = a[Symbol.iterator](), _step455; !(_iteratorNormalCompletion455 = (_step455 = _iterator455.next()).done); _iteratorNormalCompletion455 = true) {
                  var _e365 = _step455.value;

                  var _t321 = l.get(s) || eb(r, n, s, c, i);

                  l.set(s, _t321), i.consumable.consume(_e365.cell, "insert"), Xp(_e365, c, i.writer.createPositionAt(_t321, "end"), i, {
                    asWidget: !0
                  });
                }
              } catch (err) {
                _didIteratorError455 = true;
                _iteratorError455 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion455 && _iterator455.return != null) {
                    _iterator455.return();
                  }
                } finally {
                  if (_didIteratorError455) {
                    throw _iteratorError455;
                  }
                }
              }
            });
          }), n.for("editingDowncast").add(function (e) {
            return e.on("remove:tableRow", function (e, t, i) {
              e.stop();
              var n = i.writer,
                  o = i.mapper,
                  r = o.toViewPosition(t.position).getLastMatchingPosition(function (e) {
                return !e.item.is("element", "tr");
              }).nodeAfter,
                  s = r.parent.parent,
                  a = n.createRangeOn(r),
                  c = n.remove(a);
              var _iteratorNormalCompletion456 = true;
              var _didIteratorError456 = false;
              var _iteratorError456 = undefined;

              try {
                for (var _iterator456 = n.createRangeIn(c).getItems()[Symbol.iterator](), _step456; !(_iteratorNormalCompletion456 = (_step456 = _iterator456.next()).done); _iteratorNormalCompletion456 = true) {
                  var _e366 = _step456.value;
                  o.unbindViewElement(_e366);
                }
              } catch (err) {
                _didIteratorError456 = true;
                _iteratorError456 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion456 && _iterator456.return != null) {
                    _iterator456.return();
                  }
                } finally {
                  if (_didIteratorError456) {
                    throw _iteratorError456;
                  }
                }
              }

              nb("thead", s, i), nb("tbody", s, i);
            }, {
              priority: "higher"
            });
          }), n.for("upcast").elementToElement({
            model: "tableCell",
            view: "td"
          }), n.for("upcast").elementToElement({
            model: "tableCell",
            view: "th"
          }), n.for("upcast").add(qp("td")), n.for("upcast").add(qp("th")), n.for("editingDowncast").add(function (e) {
            return e.on("insert:tableCell", function (e, t, i) {
              var n = t.item;
              if (!i.consumable.consume(n, "insert")) return;
              var o = n.parent,
                  r = o.parent,
                  s = r.getChildIndex(o),
                  a = new Yp(r, {
                row: s
              }),
                  c = {
                headingRows: r.getAttribute("headingRows") || 0,
                headingColumns: r.getAttribute("headingColumns") || 0
              };
              var _iteratorNormalCompletion457 = true;
              var _didIteratorError457 = false;
              var _iteratorError457 = undefined;

              try {
                for (var _iterator457 = a[Symbol.iterator](), _step457; !(_iteratorNormalCompletion457 = (_step457 = _iterator457.next()).done); _iteratorNormalCompletion457 = true) {
                  var _e367 = _step457.value;

                  if (_e367.cell === n) {
                    var _t322 = i.mapper.toViewElement(o);

                    return void Xp(_e367, c, i.writer.createPositionAt(_t322, o.getChildIndex(n)), i, {
                      asWidget: !0
                    });
                  }
                }
              } catch (err) {
                _didIteratorError457 = true;
                _iteratorError457 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion457 && _iterator457.return != null) {
                    _iterator457.return();
                  }
                } finally {
                  if (_didIteratorError457) {
                    throw _iteratorError457;
                  }
                }
              }
            });
          }), n.for("editingDowncast").elementToElement({
            model: "paragraph",
            view: Qp,
            converterPriority: "high"
          }), n.attributeToAttribute({
            model: "colspan",
            view: "colspan"
          }), n.attributeToAttribute({
            model: "rowspan",
            view: "rowspan"
          }), n.for("editingDowncast").add(function (e) {
            return e.on("attribute:headingColumns:table", function (e, t, i) {
              var n = t.item;
              if (!i.consumable.consume(t.item, e.name)) return;
              var o = {
                headingRows: n.getAttribute("headingRows") || 0,
                headingColumns: n.getAttribute("headingColumns") || 0
              },
                  r = t.attributeOldValue,
                  s = t.attributeNewValue,
                  a = (r > s ? r : s) - 1;
              var _iteratorNormalCompletion458 = true;
              var _didIteratorError458 = false;
              var _iteratorError458 = undefined;

              try {
                for (var _iterator458 = new Yp(n, {
                  endColumn: a
                })[Symbol.iterator](), _step458; !(_iteratorNormalCompletion458 = (_step458 = _iterator458.next()).done); _iteratorNormalCompletion458 = true) {
                  var _e368 = _step458.value;
                  Zp(_e368, o, i);
                }
              } catch (err) {
                _didIteratorError458 = true;
                _iteratorError458 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion458 && _iterator458.return != null) {
                    _iterator458.return();
                  }
                } finally {
                  if (_didIteratorError458) {
                    throw _iteratorError458;
                  }
                }
              }
            });
          }), e.commands.add("insertTable", new rb(e)), e.commands.add("insertTableRowAbove", new pb(e, {
            order: "above"
          })), e.commands.add("insertTableRowBelow", new pb(e, {
            order: "below"
          })), e.commands.add("insertTableColumnLeft", new bb(e, {
            order: "left"
          })), e.commands.add("insertTableColumnRight", new bb(e, {
            order: "right"
          })), e.commands.add("removeTableRow", new Nb(e)), e.commands.add("removeTableColumn", new Rb(e)), e.commands.add("splitTableCellVertically", new wb(e, {
            direction: "vertically"
          })), e.commands.add("splitTableCellHorizontally", new wb(e, {
            direction: "horizontally"
          })), e.commands.add("mergeTableCells", new Bb(e)), e.commands.add("mergeTableCellRight", new Pb(e, {
            direction: "right"
          })), e.commands.add("mergeTableCellLeft", new Pb(e, {
            direction: "left"
          })), e.commands.add("mergeTableCellDown", new Pb(e, {
            direction: "down"
          })), e.commands.add("mergeTableCellUp", new Pb(e, {
            direction: "up"
          })), e.commands.add("setTableColumnHeader", new zb(e)), e.commands.add("setTableRowHeader", new Ob(e)), e.commands.add("selectTableRow", new Wb(e)), e.commands.add("selectTableColumn", new qb(e)), nw(t), $b(t), tw(t, e.editing.mapper), Qb(t);
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "TableEditing";
        }
      }, {
        key: "requires",
        get: function get() {
          return [Db];
        }
      }]);

      return ow;
    }(Qe);

    i(102);

    var rw =
    /*#__PURE__*/
    function (_Rl30) {
      _inherits(rw, _Rl30);

      function rw(e) {
        var _this283;

        _classCallCheck(this, rw);

        _this283 = _possibleConstructorReturn(this, _getPrototypeOf(rw).call(this, e));
        var t = _this283.bindTemplate;
        _this283.items = _this283._createGridCollection(), _this283.set("rows", 0), _this283.set("columns", 0), _this283.bind("label").to(_assertThisInitialized(_this283), "columns", _assertThisInitialized(_this283), "rows", function (e, t) {
          return "".concat(t, " \xD7 ").concat(e);
        }), _this283.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck"]
          },
          children: [{
            tag: "div",
            attributes: {
              class: ["ck-insert-table-dropdown__grid"]
            },
            on: {
              "mouseover@.ck-insert-table-dropdown-grid-box": t.to("boxover")
            },
            children: _this283.items
          }, {
            tag: "div",
            attributes: {
              class: ["ck-insert-table-dropdown__label"]
            },
            children: [{
              text: t.to("label")
            }]
          }],
          on: {
            mousedown: t.to(function (e) {
              e.preventDefault();
            }),
            click: t.to(function () {
              _this283.fire("execute");
            })
          }
        }), _this283.on("boxover", function (e, t) {
          var _t$target$dataset = t.target.dataset,
              i = _t$target$dataset.row,
              n = _t$target$dataset.column;

          _this283.set({
            rows: parseInt(i),
            columns: parseInt(n)
          });
        }), _this283.on("change:columns", function () {
          _this283._highlightGridBoxes();
        }), _this283.on("change:rows", function () {
          _this283._highlightGridBoxes();
        });
        return _this283;
      }

      _createClass(rw, [{
        key: "focus",
        value: function focus() {}
      }, {
        key: "focusLast",
        value: function focusLast() {}
      }, {
        key: "_highlightGridBoxes",
        value: function _highlightGridBoxes() {
          var e = this.rows,
              t = this.columns;
          this.items.map(function (i, n) {
            var o = Math.floor(n / 10) < e && n % 10 < t;
            i.set("isOn", o);
          });
        }
      }, {
        key: "_createGridCollection",
        value: function _createGridCollection() {
          var e = [];

          for (var _t323 = 0; _t323 < 100; _t323++) {
            var _i332 = Math.floor(_t323 / 10),
                _n203 = _t323 % 10;

            e.push(new sw(this.locale, _i332 + 1, _n203 + 1));
          }

          return this.createCollection(e);
        }
      }]);

      return rw;
    }(Rl);

    var sw =
    /*#__PURE__*/
    function (_Rl31) {
      _inherits(sw, _Rl31);

      function sw(e, t, i) {
        var _this284;

        _classCallCheck(this, sw);

        _this284 = _possibleConstructorReturn(this, _getPrototypeOf(sw).call(this, e));
        var n = _this284.bindTemplate;
        _this284.set("isOn", !1), _this284.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck-insert-table-dropdown-grid-box", n.if("isOn", "ck-on")],
            "data-row": t,
            "data-column": i
          }
        });
        return _this284;
      }

      return sw;
    }(Rl);

    var aw =
    /*#__PURE__*/
    function (_Qe63) {
      _inherits(aw, _Qe63);

      function aw() {
        _classCallCheck(this, aw);

        return _possibleConstructorReturn(this, _getPrototypeOf(aw).apply(this, arguments));
      }

      _createClass(aw, [{
        key: "init",
        value: function init() {
          var _this285 = this;

          var e = this.editor,
              t = this.editor.t,
              i = "ltr" === e.locale.contentLanguageDirection;
          e.ui.componentFactory.add("insertTable", function (i) {
            var n = e.commands.get("insertTable"),
                o = Cd(i);
            var r;
            return o.bind("isEnabled").to(n), o.buttonView.set({
              icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3 6v3h4V6H3zm0 4v3h4v-3H3zm0 4v3h4v-3H3zm5 3h4v-3H8v3zm5 0h4v-3h-4v3zm4-4v-3h-4v3h4zm0-4V6h-4v3h4zm1.5 8a1.5 1.5 0 0 1-1.5 1.5H3A1.5 1.5 0 0 1 1.5 17V4c.222-.863 1.068-1.5 2-1.5h13c.932 0 1.778.637 2 1.5v13zM12 13v-3H8v3h4zm0-4V6H8v3h4z"/></svg>',
              label: t("Insert table"),
              tooltip: !0
            }), o.on("change:isOpen", function () {
              r || (r = new rw(i), o.panelView.children.add(r), r.delegate("execute").to(o), o.buttonView.on("open", function () {
                r.rows = 0, r.columns = 0;
              }), o.on("execute", function () {
                e.execute("insertTable", {
                  rows: r.rows,
                  columns: r.columns
                }), e.editing.view.focus();
              }));
            }), o;
          }), e.ui.componentFactory.add("tableColumn", function (e) {
            var n = [{
              type: "switchbutton",
              model: {
                commandName: "setTableColumnHeader",
                label: t("Header column"),
                bindIsOn: !0
              }
            }, {
              type: "separator"
            }, {
              type: "button",
              model: {
                commandName: i ? "insertTableColumnLeft" : "insertTableColumnRight",
                label: t("Insert column left")
              }
            }, {
              type: "button",
              model: {
                commandName: i ? "insertTableColumnRight" : "insertTableColumnLeft",
                label: t("Insert column right")
              }
            }, {
              type: "button",
              model: {
                commandName: "removeTableColumn",
                label: t("Delete column")
              }
            }, {
              type: "button",
              model: {
                commandName: "selectTableColumn",
                label: t("Select column")
              }
            }];
            return _this285._prepareDropdown(t("Column"), '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 1h15A1.5 1.5 0 0 1 19 2.5v15a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 1 17.5v-15A1.5 1.5 0 0 1 2.5 1zM2 2v16h16V2H2z" opacity=".6"/><path d="M18 7v1H2V7h16zm0 5v1H2v-1h16z" opacity=".6"/><path d="M14 1v18a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1zm-2 1H8v4h4V2zm0 6H8v4h4V8zm0 6H8v4h4v-4z"/></svg>', n, e);
          }), e.ui.componentFactory.add("tableRow", function (e) {
            var i = [{
              type: "switchbutton",
              model: {
                commandName: "setTableRowHeader",
                label: t("Header row"),
                bindIsOn: !0
              }
            }, {
              type: "separator"
            }, {
              type: "button",
              model: {
                commandName: "insertTableRowAbove",
                label: t("Insert row above")
              }
            }, {
              type: "button",
              model: {
                commandName: "insertTableRowBelow",
                label: t("Insert row below")
              }
            }, {
              type: "button",
              model: {
                commandName: "removeTableRow",
                label: t("Delete row")
              }
            }, {
              type: "button",
              model: {
                commandName: "selectTableRow",
                label: t("Select row")
              }
            }];
            return _this285._prepareDropdown(t("Row"), '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 1h15A1.5 1.5 0 0 1 19 2.5v15a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 1 17.5v-15A1.5 1.5 0 0 1 2.5 1zM2 2v16h16V2H2z" opacity=".6"/><path d="M7 2h1v16H7V2zm5 0h1v16h-1V2z" opacity=".6"/><path d="M1 6h18a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1zm1 2v4h4V8H2zm6 0v4h4V8H8zm6 0v4h4V8h-4z"/></svg>', i, e);
          }), e.ui.componentFactory.add("mergeTableCells", function (e) {
            var n = [{
              type: "button",
              model: {
                commandName: "mergeTableCellUp",
                label: t("Merge cell up")
              }
            }, {
              type: "button",
              model: {
                commandName: i ? "mergeTableCellRight" : "mergeTableCellLeft",
                label: t("Merge cell right")
              }
            }, {
              type: "button",
              model: {
                commandName: "mergeTableCellDown",
                label: t("Merge cell down")
              }
            }, {
              type: "button",
              model: {
                commandName: i ? "mergeTableCellLeft" : "mergeTableCellRight",
                label: t("Merge cell left")
              }
            }, {
              type: "separator"
            }, {
              type: "button",
              model: {
                commandName: "splitTableCellVertically",
                label: t("Split cell vertically")
              }
            }, {
              type: "button",
              model: {
                commandName: "splitTableCellHorizontally",
                label: t("Split cell horizontally")
              }
            }];
            return _this285._prepareMergeSplitButtonDropdown(t("Merge cells"), '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 1h15A1.5 1.5 0 0 1 19 2.5v15a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 1 17.5v-15A1.5 1.5 0 0 1 2.5 1zM2 2v16h16V2H2z" opacity=".6"/><path d="M7 2h1v16H7V2zm5 0h1v7h-1V2zm6 5v1H2V7h16zM8 12v1H2v-1h6z" opacity=".6"/><path d="M7 7h12a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1zm1 2v9h10V9H8z"/></svg>', n, e);
          });
        }
      }, {
        key: "_prepareDropdown",
        value: function _prepareDropdown(e, t, i, n) {
          var o = this.editor,
              r = Cd(n),
              s = this._fillDropdownWithListOptions(r, i);

          return r.buttonView.set({
            label: e,
            icon: t,
            tooltip: !0
          }), r.bind("isEnabled").toMany(s, "isEnabled", function () {
            for (var _len28 = arguments.length, e = new Array(_len28), _key28 = 0; _key28 < _len28; _key28++) {
              e[_key28] = arguments[_key28];
            }

            return e.some(function (e) {
              return e;
            });
          }), this.listenTo(r, "execute", function (e) {
            o.execute(e.source.commandName), o.editing.view.focus();
          }), r;
        }
      }, {
        key: "_prepareMergeSplitButtonDropdown",
        value: function _prepareMergeSplitButtonDropdown(e, t, i, n) {
          var o = this.editor,
              r = Cd(n, cd),
              s = o.commands.get("mergeTableCells"),
              a = this._fillDropdownWithListOptions(r, i);

          return r.buttonView.set({
            label: e,
            icon: t,
            tooltip: !0,
            isEnabled: !0
          }), r.bind("isEnabled").toMany([s].concat(_toConsumableArray(a)), "isEnabled", function () {
            for (var _len29 = arguments.length, e = new Array(_len29), _key29 = 0; _key29 < _len29; _key29++) {
              e[_key29] = arguments[_key29];
            }

            return e.some(function (e) {
              return e;
            });
          }), this.listenTo(r.buttonView, "execute", function () {
            o.execute("mergeTableCells"), o.editing.view.focus();
          }), this.listenTo(r, "execute", function (e) {
            o.execute(e.source.commandName), o.editing.view.focus();
          }), r;
        }
      }, {
        key: "_fillDropdownWithListOptions",
        value: function _fillDropdownWithListOptions(e, t) {
          var i = this.editor,
              n = [],
              o = new Zi();
          var _iteratorNormalCompletion459 = true;
          var _didIteratorError459 = false;
          var _iteratorError459 = undefined;

          try {
            for (var _iterator459 = t[Symbol.iterator](), _step459; !(_iteratorNormalCompletion459 = (_step459 = _iterator459.next()).done); _iteratorNormalCompletion459 = true) {
              var _e369 = _step459.value;
              cw(_e369, i, n, o);
            }
          } catch (err) {
            _didIteratorError459 = true;
            _iteratorError459 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion459 && _iterator459.return != null) {
                _iterator459.return();
              }
            } finally {
              if (_didIteratorError459) {
                throw _iteratorError459;
              }
            }
          }

          return Ed(e, o, i.ui.componentFactory), n;
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "TableUI";
        }
      }]);

      return aw;
    }(Qe);

    function cw(e, t, i, n) {
      var o = e.model = new Ld(e.model),
          _e$model2 = e.model,
          r = _e$model2.commandName,
          s = _e$model2.bindIsOn;

      if ("button" === e.type || "switchbutton" === e.type) {
        var _e370 = t.commands.get(r);

        i.push(_e370), o.set({
          commandName: r
        }), o.bind("isEnabled").to(_e370), s && o.bind("isOn").to(_e370, "value");
      }

      o.set({
        withText: !0
      }), n.add(e);
    }

    i(104);

    var lw =
    /*#__PURE__*/
    function (_Qe64) {
      _inherits(lw, _Qe64);

      function lw() {
        _classCallCheck(this, lw);

        return _possibleConstructorReturn(this, _getPrototypeOf(lw).apply(this, arguments));
      }

      _createClass(lw, [{
        key: "init",
        value: function init() {
          var _this286 = this;

          var e = this.editor.model;
          this.listenTo(e, "deleteContent", function (e, t) {
            return _this286._handleDeleteContent(e, t);
          }, {
            priority: "high"
          }), this._defineSelectionConverter(), this._enablePluginDisabling();
        }
      }, {
        key: "getSelectedTableCells",
        value: function getSelectedTableCells() {
          var e = sb(this.editor.model.document.selection);
          return 0 == e.length ? null : e;
        }
      }, {
        key: "getSelectionAsFragment",
        value: function getSelectionAsFragment() {
          var _this287 = this;

          var e = this.getSelectedTableCells();
          return e ? this.editor.model.change(function (t) {
            var i = t.createDocumentFragment(),
                n = _this287.editor.plugins.get("TableUtils"),
                _db3 = db(e),
                o = _db3.first,
                r = _db3.last,
                _lb2 = lb(e),
                s = _lb2.first,
                a = _lb2.last,
                c = e[0].findAncestor("table");

            var l = a,
                d = r;

            if (hb(e, n)) {
              var _e371 = {
                firstColumn: o,
                lastColumn: r,
                firstRow: s,
                lastRow: a
              };
              l = Sb(c, _e371), d = Ib(c, _e371);
            }

            var h = kb(c, {
              startRow: s,
              startColumn: o,
              endRow: l,
              endColumn: d
            }, t);
            return t.insert(h, i, 0), i;
          }) : null;
        }
      }, {
        key: "setCellSelection",
        value: function setCellSelection(e, t) {
          var i = this._getCellsToSelect(e, t);

          this.editor.model.change(function (e) {
            e.setSelection(i.cells.map(function (t) {
              return e.createRangeOn(t);
            }), {
              backward: i.backward
            });
          });
        }
      }, {
        key: "getFocusCell",
        value: function getFocusCell() {
          var e = _toConsumableArray(this.editor.model.document.selection.getRanges()).pop().getContainedElement();

          return e && e.is("element", "tableCell") ? e : null;
        }
      }, {
        key: "getAnchorCell",
        value: function getAnchorCell() {
          var e = Os(this.editor.model.document.selection.getRanges()).getContainedElement();
          return e && e.is("element", "tableCell") ? e : null;
        }
      }, {
        key: "_defineSelectionConverter",
        value: function _defineSelectionConverter() {
          var _this288 = this;

          var e = this.editor,
              t = new Set();
          e.conversion.for("editingDowncast").add(function (e) {
            return e.on("selection", function (e, i, n) {
              var o = n.writer;
              !function (e) {
                var _iteratorNormalCompletion460 = true;
                var _didIteratorError460 = false;
                var _iteratorError460 = undefined;

                try {
                  for (var _iterator460 = t[Symbol.iterator](), _step460; !(_iteratorNormalCompletion460 = (_step460 = _iterator460.next()).done); _iteratorNormalCompletion460 = true) {
                    var _i333 = _step460.value;
                    e.removeClass("ck-editor__editable_selected", _i333);
                  }
                } catch (err) {
                  _didIteratorError460 = true;
                  _iteratorError460 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion460 && _iterator460.return != null) {
                      _iterator460.return();
                    }
                  } finally {
                    if (_didIteratorError460) {
                      throw _iteratorError460;
                    }
                  }
                }

                t.clear();
              }(o);

              var r = _this288.getSelectedTableCells();

              if (!r) return;
              var _iteratorNormalCompletion461 = true;
              var _didIteratorError461 = false;
              var _iteratorError461 = undefined;

              try {
                for (var _iterator461 = r[Symbol.iterator](), _step461; !(_iteratorNormalCompletion461 = (_step461 = _iterator461.next()).done); _iteratorNormalCompletion461 = true) {
                  var _e372 = _step461.value;

                  var _i334 = n.mapper.toViewElement(_e372);

                  o.addClass("ck-editor__editable_selected", _i334), t.add(_i334);
                }
              } catch (err) {
                _didIteratorError461 = true;
                _iteratorError461 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion461 && _iterator461.return != null) {
                    _iterator461.return();
                  }
                } finally {
                  if (_didIteratorError461) {
                    throw _iteratorError461;
                  }
                }
              }

              var s = n.mapper.toViewElement(r[r.length - 1]);
              o.setSelection(s, 0);
            }, {
              priority: "lowest"
            });
          });
        }
      }, {
        key: "_enablePluginDisabling",
        value: function _enablePluginDisabling() {
          var _this289 = this;

          var e = this.editor;
          this.on("change:isEnabled", function () {
            if (!_this289.isEnabled) {
              var _t324 = _this289.getSelectedTableCells();

              if (!_t324) return;
              e.model.change(function (i) {
                var n = i.createPositionAt(_t324[0], 0),
                    o = e.model.schema.getNearestSelectionRange(n);
                i.setSelection(o);
              });
            }
          });
        }
      }, {
        key: "_handleDeleteContent",
        value: function _handleDeleteContent(e, t) {
          var _t325 = _slicedToArray(t, 2),
              i = _t325[0],
              n = _t325[1],
              o = this.editor.model,
              r = !n || "backward" == n.direction,
              s = sb(i);

          s.length && (e.stop(), o.change(function (e) {
            var t = s[r ? s.length - 1 : 0];
            o.change(function (e) {
              var _iteratorNormalCompletion462 = true;
              var _didIteratorError462 = false;
              var _iteratorError462 = undefined;

              try {
                for (var _iterator462 = s[Symbol.iterator](), _step462; !(_iteratorNormalCompletion462 = (_step462 = _iterator462.next()).done); _iteratorNormalCompletion462 = true) {
                  var _t326 = _step462.value;
                  o.deleteContent(e.createSelection(_t326, "in"));
                }
              } catch (err) {
                _didIteratorError462 = true;
                _iteratorError462 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion462 && _iterator462.return != null) {
                    _iterator462.return();
                  }
                } finally {
                  if (_didIteratorError462) {
                    throw _iteratorError462;
                  }
                }
              }
            });
            var n = o.schema.getNearestSelectionRange(e.createPositionAt(t, 0));
            i.is("documentSelection") ? e.setSelection(n) : i.setTo(n);
          }));
        }
      }, {
        key: "_getCellsToSelect",
        value: function _getCellsToSelect(e, t) {
          var i = this.editor.plugins.get("TableUtils"),
              n = i.getCellLocation(e),
              o = i.getCellLocation(t),
              r = Math.min(n.row, o.row),
              s = Math.max(n.row, o.row),
              a = Math.min(n.column, o.column),
              c = Math.max(n.column, o.column),
              l = new Array(s - r + 1).fill(null).map(function () {
            return [];
          }),
              d = {
            startRow: r,
            endRow: s,
            startColumn: a,
            endColumn: c
          };
          var _iteratorNormalCompletion463 = true;
          var _didIteratorError463 = false;
          var _iteratorError463 = undefined;

          try {
            for (var _iterator463 = new Yp(e.findAncestor("table"), d)[Symbol.iterator](), _step463; !(_iteratorNormalCompletion463 = (_step463 = _iterator463.next()).done); _iteratorNormalCompletion463 = true) {
              var _ref229 = _step463.value;
              var _t327 = _ref229.row;
              var _i335 = _ref229.cell;

              l[_t327 - r].push(_i335);
            }
          } catch (err) {
            _didIteratorError463 = true;
            _iteratorError463 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion463 && _iterator463.return != null) {
                _iterator463.return();
              }
            } finally {
              if (_didIteratorError463) {
                throw _iteratorError463;
              }
            }
          }

          var h = o.row < n.row,
              u = o.column < n.column;
          return h && l.reverse(), u && l.forEach(function (e) {
            return e.reverse();
          }), {
            cells: l.flat(),
            backward: h || u
          };
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "TableSelection";
        }
      }, {
        key: "requires",
        get: function get() {
          return [Db];
        }
      }]);

      return lw;
    }(Qe);

    var dw =
    /*#__PURE__*/
    function (_Qe65) {
      _inherits(dw, _Qe65);

      function dw() {
        _classCallCheck(this, dw);

        return _possibleConstructorReturn(this, _getPrototypeOf(dw).apply(this, arguments));
      }

      _createClass(dw, [{
        key: "init",
        value: function init() {
          var _this290 = this;

          var e = this.editor,
              t = e.editing.view.document;
          this.listenTo(t, "copy", function (e, t) {
            return _this290._onCopyCut(e, t);
          }), this.listenTo(t, "cut", function (e, t) {
            return _this290._onCopyCut(e, t);
          }), this.listenTo(e.model, "insertContent", function (e, t) {
            return _this290._onInsertContent.apply(_this290, [e].concat(_toConsumableArray(t)));
          }, {
            priority: "high"
          }), this.decorate("_replaceTableSlotCell");
        }
      }, {
        key: "_onCopyCut",
        value: function _onCopyCut(e, t) {
          var i = this.editor.plugins.get(lw);
          if (!i.getSelectedTableCells()) return;
          if ("cut" == e.name && this.editor.isReadOnly) return;
          t.preventDefault(), e.stop();
          var n = this.editor.data,
              o = this.editor.editing.view.document,
              r = n.toView(i.getSelectionAsFragment());
          o.fire("clipboardOutput", {
            dataTransfer: t.dataTransfer,
            content: r,
            method: e.name
          });
        }
      }, {
        key: "_onInsertContent",
        value: function _onInsertContent(e, t, i) {
          var _this291 = this;

          if (i && !i.is("documentSelection")) return;
          var n = this.editor.model,
              o = this.editor.plugins.get(Db);

          var r = function (e, t) {
            if (!e.is("documentFragment") && !e.is("element")) return null;
            if (e.is("element", "table")) return e;
            if (1 == e.childCount && e.getChild(0).is("element", "table")) return e.getChild(0);
            var i = t.createRangeIn(e);
            var _iteratorNormalCompletion464 = true;
            var _didIteratorError464 = false;
            var _iteratorError464 = undefined;

            try {
              for (var _iterator464 = i.getItems()[Symbol.iterator](), _step464; !(_iteratorNormalCompletion464 = (_step464 = _iterator464.next()).done); _iteratorNormalCompletion464 = true) {
                var _e373 = _step464.value;

                if (_e373.is("element", "table")) {
                  var _n204 = t.createRange(i.start, t.createPositionBefore(_e373));

                  if (t.hasContent(_n204, {
                    ignoreWhitespaces: !0
                  })) return null;

                  var _o128 = t.createRange(t.createPositionAfter(_e373), i.end);

                  return t.hasContent(_o128, {
                    ignoreWhitespaces: !0
                  }) ? null : _e373;
                }
              }
            } catch (err) {
              _didIteratorError464 = true;
              _iteratorError464 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion464 && _iterator464.return != null) {
                  _iterator464.return();
                }
              } finally {
                if (_didIteratorError464) {
                  throw _iteratorError464;
                }
              }
            }

            return null;
          }(t, n);

          if (!r) return;
          var s = cb(n.document.selection);
          s.length ? (e.stop(), n.change(function (e) {
            var t = {
              width: o.getColumns(r),
              height: o.getRows(r)
            },
                i = function (e, t, i, n) {
              var o = e[0].findAncestor("table"),
                  r = db(e),
                  s = lb(e),
                  a = {
                firstColumn: r.first,
                lastColumn: r.last,
                firstRow: s.first,
                lastRow: s.last
              },
                  c = 1 === e.length;
              c && (a.lastRow += t.height - 1, a.lastColumn += t.width - 1, function (e, t, i, n) {
                var o = n.getColumns(e),
                    r = n.getRows(e);
                i > o && n.insertColumns(e, {
                  at: o,
                  columns: i - o
                });
                t > r && n.insertRows(e, {
                  at: r,
                  rows: t - r
                });
              }(o, a.lastRow + 1, a.lastColumn + 1, n));
              c || !hb(e, n) ? function (e, t, i) {
                var n = t.firstRow,
                    o = t.lastRow,
                    r = t.firstColumn,
                    s = t.lastColumn,
                    a = {
                  first: n,
                  last: o
                },
                    c = {
                  first: r,
                  last: s
                };
                uw(e, r, a, i), uw(e, s + 1, a, i), hw(e, n, c, i), hw(e, o + 1, c, i, n);
              }(o, a, i) : (a.lastRow = Sb(o, a), a.lastColumn = Ib(o, a));
              return a;
            }(s, t, e, o),
                n = i.lastRow - i.firstRow + 1,
                a = i.lastColumn - i.firstColumn + 1,
                c = {
              startRow: 0,
              startColumn: 0,
              endRow: Math.min(n, t.height) - 1,
              endColumn: Math.min(a, t.width) - 1
            };

            r = kb(r, c, e);

            var l = s[0].findAncestor("table"),
                d = _this291._replaceSelectedCellsWithPasted(r, t, l, i, e);

            if (_this291.editor.plugins.get("TableSelection").isEnabled) {
              var _t328 = ub(d.map(function (t) {
                return e.createRangeOn(t);
              }));

              e.setSelection(_t328);
            } else e.setSelection(d[0], 0);
          })) : Eb(r, o);
        }
      }, {
        key: "_replaceSelectedCellsWithPasted",
        value: function _replaceSelectedCellsWithPasted(e, t, i, n, o) {
          var r = t.width,
              s = t.height,
              a = function (e, t, i) {
            var n = new Array(i).fill(null).map(function () {
              return new Array(t).fill(null);
            });
            var _iteratorNormalCompletion465 = true;
            var _didIteratorError465 = false;
            var _iteratorError465 = undefined;

            try {
              for (var _iterator465 = new Yp(e)[Symbol.iterator](), _step465; !(_iteratorNormalCompletion465 = (_step465 = _iterator465.next()).done); _iteratorNormalCompletion465 = true) {
                var _ref231 = _step465.value;
                var _t329 = _ref231.column;
                var _i336 = _ref231.row;
                var _o129 = _ref231.cell;
                n[_i336][_t329] = _o129;
              }
            } catch (err) {
              _didIteratorError465 = true;
              _iteratorError465 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion465 && _iterator465.return != null) {
                  _iterator465.return();
                }
              } finally {
                if (_didIteratorError465) {
                  throw _iteratorError465;
                }
              }
            }

            return n;
          }(e, r, s),
              c = _toConsumableArray(new Yp(i, {
            startRow: n.firstRow,
            endRow: n.lastRow,
            startColumn: n.firstColumn,
            endColumn: n.lastColumn,
            includeAllSlots: !0
          })),
              l = [];

          var d;

          for (var _i337 = 0, _c23 = c; _i337 < _c23.length; _i337++) {
            var _e376 = _c23[_i337];
            var _t330 = _e376.row,
                _i338 = _e376.column;
            _i338 === n.firstColumn && (d = _e376.getPositionBefore());

            var _c24 = _t330 - n.firstRow,
                _h7 = _i338 - n.firstColumn,
                _u5 = a[_c24 % s][_h7 % r],
                _g3 = _u5 ? o.cloneElement(_u5) : null,
                _m2 = this._replaceTableSlotCell(_e376, _g3, d, o);

            _m2 && (Ab(_m2, _t330, _i338, n.lastRow, n.lastColumn, o), l.push(_m2), d = o.createPositionAfter(_m2));
          }

          var h = parseInt(i.getAttribute("headingRows") || 0),
              u = parseInt(i.getAttribute("headingColumns") || 0),
              g = n.firstRow < h && h <= n.lastRow,
              m = n.firstColumn < u && u <= n.lastColumn;

          if (g) {
            var _e374 = hw(i, h, {
              first: n.firstColumn,
              last: n.lastColumn
            }, o, n.firstRow);

            l.push.apply(l, _toConsumableArray(_e374));
          }

          if (m) {
            var _e375 = uw(i, u, {
              first: n.firstRow,
              last: n.lastRow
            }, o);

            l.push.apply(l, _toConsumableArray(_e375));
          }

          return l;
        }
      }, {
        key: "_replaceTableSlotCell",
        value: function _replaceTableSlotCell(e, t, i, n) {
          var o = e.cell,
              r = e.isAnchor;
          return r && n.remove(o), t ? (n.insert(t, i), t) : null;
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "TableClipboard";
        }
      }, {
        key: "requires",
        get: function get() {
          return [lw, Db];
        }
      }]);

      return dw;
    }(Qe);

    function hw(e, t, i, n) {
      var o = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
      if (t < 1) return;
      return _b(e, t, o).filter(function (_ref232) {
        var e = _ref232.column,
            t = _ref232.cellWidth;
        return gw(e, t, i);
      }).map(function (_ref233) {
        var e = _ref233.cell;
        return vb(e, t, n);
      });
    }

    function uw(e, t, i, n) {
      if (t < 1) return;
      return yb(e, t).filter(function (_ref234) {
        var e = _ref234.row,
            t = _ref234.cellHeight;
        return gw(e, t, i);
      }).map(function (_ref235) {
        var e = _ref235.cell,
            i = _ref235.column;
        return xb(e, i, t, n);
      });
    }

    function gw(e, t, i) {
      var n = e + t - 1,
          o = i.first,
          r = i.last;
      return e >= o && e <= r || e < o && n >= o;
    }

    var mw =
    /*#__PURE__*/
    function (_Qe66) {
      _inherits(mw, _Qe66);

      function mw() {
        _classCallCheck(this, mw);

        return _possibleConstructorReturn(this, _getPrototypeOf(mw).apply(this, arguments));
      }

      _createClass(mw, [{
        key: "init",
        value: function init() {
          var _this292 = this;

          var e = this.editor.editing.view.document;
          this.editor.keystrokes.set("Tab", function () {
            return _this292._handleTabOnSelectedTable.apply(_this292, arguments);
          }, {
            priority: "low"
          }), this.editor.keystrokes.set("Tab", this._getTabHandler(!0), {
            priority: "low"
          }), this.editor.keystrokes.set("Shift+Tab", this._getTabHandler(!1), {
            priority: "low"
          }), this.listenTo(e, "arrowKey", function () {
            return _this292._onArrowKey.apply(_this292, arguments);
          }, {
            context: "table"
          });
        }
      }, {
        key: "_handleTabOnSelectedTable",
        value: function _handleTabOnSelectedTable(e, t) {
          var i = this.editor,
              n = i.model.document.selection.getSelectedElement();
          n && n.is("element", "table") && (t(), i.model.change(function (e) {
            e.setSelection(e.createRangeIn(n.getChild(0).getChild(0)));
          }));
        }
      }, {
        key: "_getTabHandler",
        value: function _getTabHandler(e) {
          var _this293 = this;

          var t = this.editor;
          return function (i, n) {
            var o = ab(t.model.document.selection)[0];
            if (o || (o = _this293.editor.plugins.get("TableSelection").getFocusCell()), !o) return;
            n();
            var r = o.parent,
                s = r.parent,
                a = s.getChildIndex(r),
                c = r.getChildIndex(o),
                l = 0 === c;
            if (!e && l && 0 === a) return void t.model.change(function (e) {
              e.setSelection(e.createRangeOn(s));
            });

            var d = _this293.editor.plugins.get("TableUtils"),
                h = c === r.childCount - 1,
                u = a === d.getRows(s) - 1;

            if (e && u && h && (t.execute("insertTableRowBelow"), a === d.getRows(s) - 1)) return void t.model.change(function (e) {
              e.setSelection(e.createRangeOn(s));
            });
            var g;

            if (e && h) {
              var _e377 = s.getChild(a + 1);

              g = _e377.getChild(0);
            } else if (!e && l) {
              var _e378 = s.getChild(a - 1);

              g = _e378.getChild(_e378.childCount - 1);
            } else g = r.getChild(c + (e ? 1 : -1));

            t.model.change(function (e) {
              e.setSelection(e.createRangeIn(g));
            });
          };
        }
      }, {
        key: "_onArrowKey",
        value: function _onArrowKey(e, t) {
          var i = this.editor,
              n = Lo(t.keyCode, i.locale.contentLanguageDirection);
          this._handleArrowKeys(n, t.shiftKey) && (t.preventDefault(), t.stopPropagation(), e.stop());
        }
      }, {
        key: "_handleArrowKeys",
        value: function _handleArrowKeys(e, t) {
          var i = this.editor.model.document.selection,
              n = ["right", "down"].includes(e),
              o = sb(i);

          if (o.length) {
            var _i339;

            return _i339 = t ? this.editor.plugins.get("TableSelection").getFocusCell() : n ? o[o.length - 1] : o[0], this._navigateFromCellInDirection(_i339, e, t), !0;
          }

          var r = i.focus.findAncestor("tableCell");
          return !!r && !(t && !i.isCollapsed && i.isBackward == n) && !!this._isSelectionAtCellEdge(i, r, n) && (this._navigateFromCellInDirection(r, e, t), !0);
        }
      }, {
        key: "_isSelectionAtCellEdge",
        value: function _isSelectionAtCellEdge(e, t, i) {
          var n = this.editor.model,
              o = this.editor.model.schema,
              r = i ? e.getLastPosition() : e.getFirstPosition();

          if (!o.getLimitElement(r).is("element", "tableCell")) {
            return n.createPositionAt(t, i ? "end" : 0).isTouching(r);
          }

          var s = n.createSelection(r);
          return n.modifySelection(s, {
            direction: i ? "forward" : "backward"
          }), r.isEqual(s.focus);
        }
      }, {
        key: "_navigateFromCellInDirection",
        value: function _navigateFromCellInDirection(e, t) {
          var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;

          var n = this.editor.model,
              o = e.findAncestor("table"),
              r = _toConsumableArray(new Yp(o, {
            includeAllSlots: !0
          })),
              _r81 = r[r.length - 1],
              s = _r81.row,
              a = _r81.column,
              c = r.find(function (_ref236) {
            var t = _ref236.cell;
            return t == e;
          });

          var l = c.row,
              d = c.column;

          switch (t) {
            case "left":
              d--;
              break;

            case "up":
              l--;
              break;

            case "right":
              d += c.cellWidth;
              break;

            case "down":
              l += c.cellHeight;
          }

          if (l < 0 || l > s || d < 0 && l <= 0 || d > a && l >= s) return void n.change(function (e) {
            e.setSelection(e.createRangeOn(o));
          });
          d < 0 ? (d = i ? 0 : a, l--) : d > a && (d = i ? a : 0, l++);
          var h = r.find(function (e) {
            return e.row == l && e.column == d;
          }).cell,
              u = ["right", "down"].includes(t),
              g = this.editor.plugins.get("TableSelection");

          if (i && g.isEnabled) {
            var _t331 = g.getAnchorCell() || e;

            g.setCellSelection(_t331, h);
          } else {
            var _e379 = n.createPositionAt(h, u ? 0 : "end");

            n.change(function (t) {
              t.setSelection(_e379);
            });
          }
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "TableKeyboard";
        }
      }, {
        key: "requires",
        get: function get() {
          return [lw];
        }
      }]);

      return mw;
    }(Qe);

    var fw =
    /*#__PURE__*/
    function (_is8) {
      _inherits(fw, _is8);

      function fw(e) {
        var _this294;

        _classCallCheck(this, fw);

        _this294 = _possibleConstructorReturn(this, _getPrototypeOf(fw).call(this, e)), _this294.domEventType = ["mousemove", "mouseleave"];
        return _this294;
      }

      _createClass(fw, [{
        key: "onDomEvent",
        value: function onDomEvent(e) {
          this.fire(e.type, e);
        }
      }]);

      return fw;
    }(is);

    var pw =
    /*#__PURE__*/
    function (_Qe67) {
      _inherits(pw, _Qe67);

      function pw() {
        _classCallCheck(this, pw);

        return _possibleConstructorReturn(this, _getPrototypeOf(pw).apply(this, arguments));
      }

      _createClass(pw, [{
        key: "init",
        value: function init() {
          this.editor.editing.view.addObserver(fw), this._enableShiftClickSelection(), this._enableMouseDragSelection();
        }
      }, {
        key: "_enableShiftClickSelection",
        value: function _enableShiftClickSelection() {
          var _this295 = this;

          var e = this.editor;
          var t = !1;
          var i = e.plugins.get(lw);
          this.listenTo(e.editing.view.document, "mousedown", function (n, o) {
            if (!_this295.isEnabled || !i.isEnabled) return;
            if (!o.domEvent.shiftKey) return;
            var r = i.getAnchorCell() || ab(e.model.document.selection)[0];
            if (!r) return;

            var s = _this295._getModelTableCellFromDomEvent(o);

            s && bw(r, s) && (t = !0, i.setCellSelection(r, s), o.preventDefault());
          }), this.listenTo(e.editing.view.document, "mouseup", function () {
            t = !1;
          }), this.listenTo(e.editing.view.document, "selectionChange", function (e) {
            t && e.stop();
          }, {
            priority: "highest"
          });
        }
      }, {
        key: "_enableMouseDragSelection",
        value: function _enableMouseDragSelection() {
          var _this296 = this;

          var e = this.editor;
          var t,
              i,
              n = !1,
              o = !1;
          var r = e.plugins.get(lw);
          this.listenTo(e.editing.view.document, "mousedown", function (e, i) {
            _this296.isEnabled && r.isEnabled && (i.domEvent.shiftKey || i.domEvent.ctrlKey || i.domEvent.altKey || (t = _this296._getModelTableCellFromDomEvent(i)));
          }), this.listenTo(e.editing.view.document, "mousemove", function (e, s) {
            if (!s.domEvent.buttons) return;
            if (!t) return;

            var a = _this296._getModelTableCellFromDomEvent(s);

            a && bw(t, a) && (i = a, n || i == t || (n = !0)), n && (o = !0, r.setCellSelection(t, i), s.preventDefault());
          }), this.listenTo(e.editing.view.document, "mouseup", function () {
            n = !1, o = !1, t = null, i = null;
          }), this.listenTo(e.editing.view.document, "selectionChange", function (e) {
            o && e.stop();
          }, {
            priority: "highest"
          });
        }
      }, {
        key: "_getModelTableCellFromDomEvent",
        value: function _getModelTableCellFromDomEvent(e) {
          var t = e.target,
              i = this.editor.editing.view.createPositionAt(t, 0);
          return this.editor.editing.mapper.toModelPosition(i).parent.findAncestor("tableCell", {
            includeSelf: !0
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "TableMouse";
        }
      }, {
        key: "requires",
        get: function get() {
          return [lw];
        }
      }]);

      return pw;
    }(Qe);

    function bw(e, t) {
      return e.parent.parent == t.parent.parent;
    }

    i(106);

    function ww(e) {
      var t = e.getSelectedElement();
      return t && _w(t) ? t : null;
    }

    function kw(e) {
      var t = e.getFirstPosition().parent;

      for (; t;) {
        if (t.is("element") && _w(t)) return t;
        t = t.parent;
      }

      return null;
    }

    function _w(e) {
      return !!e.getCustomProperty("table") && Dh(e);
    }

    var vw = {
      autoRefresh: !0
    };

    var yw =
    /*#__PURE__*/
    function () {
      function yw(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : vw;

        _classCallCheck(this, yw);

        if (!e) throw new c.a("token-missing-token-url", this);
        t.initValue && this._validateTokenValue(t.initValue), this.set("value", t.initValue), this._refresh = "function" == typeof e ? e : function () {
          return t = e, new Promise(function (e, i) {
            var n = new XMLHttpRequest();
            n.open("GET", t), n.addEventListener("load", function () {
              var t = n.status,
                  o = n.response;
              return t < 200 || t > 299 ? i(new c.a("token-cannot-download-new-token", null)) : e(o);
            }), n.addEventListener("error", function () {
              return i(new Error("Network Error"));
            }), n.addEventListener("abort", function () {
              return i(new Error("Abort"));
            }), n.send();
          });
          var t;
        }, this._options = Object.assign({}, vw, t);
      }

      _createClass(yw, [{
        key: "init",
        value: function init() {
          var _this297 = this;

          return new Promise(function (e, t) {
            _this297.value ? (_this297._options.autoRefresh && _this297._registerRefreshTokenTimeout(), e(_this297)) : _this297.refreshToken().then(e).catch(t);
          });
        }
      }, {
        key: "refreshToken",
        value: function refreshToken() {
          var _this298 = this;

          return this._refresh().then(function (e) {
            _this298._validateTokenValue(e), _this298.set("value", e), _this298._options.autoRefresh && _this298._registerRefreshTokenTimeout();
          }).then(function () {
            return _this298;
          });
        }
      }, {
        key: "destroy",
        value: function destroy() {
          clearTimeout(this._tokenRefreshTimeout);
        }
      }, {
        key: "_validateTokenValue",
        value: function _validateTokenValue(e) {
          var t = "string" == typeof e,
              i = !/^".*"$/.test(e),
              n = t && 3 === e.split(".").length;
          if (!i || !n) throw new c.a("token-not-in-jwt-format", this);
        }
      }, {
        key: "_registerRefreshTokenTimeout",
        value: function _registerRefreshTokenTimeout() {
          var _this299 = this;

          var e = this._getTokenRefreshTimeoutTime();

          clearTimeout(this._tokenRefreshTimeout), this._tokenRefreshTimeout = setTimeout(function () {
            _this299.refreshToken();
          }, e);
        }
      }, {
        key: "_getTokenRefreshTimeoutTime",
        value: function _getTokenRefreshTimeoutTime() {
          try {
            var _this$value$split = this.value.split("."),
                _this$value$split2 = _slicedToArray(_this$value$split, 2),
                _e380 = _this$value$split2[1],
                _JSON$parse = JSON.parse(atob(_e380)),
                _t332 = _JSON$parse.exp;

            if (!_t332) return 36e5;
            return Math.floor((1e3 * _t332 - Date.now()) / 2);
          } catch (e) {
            return 36e5;
          }
        }
      }], [{
        key: "create",
        value: function create(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : vw;
          return new yw(e, t).init();
        }
      }]);

      return yw;
    }();

    Ke(yw, Ue);
    var xw = yw;
    var Aw = /^data:(\S*?);base64,/;

    var Cw =
    /*#__PURE__*/
    function () {
      function Cw(e, t, i) {
        _classCallCheck(this, Cw);

        if (!e) throw new c.a("fileuploader-missing-file", null);
        if (!t) throw new c.a("fileuploader-missing-token", null);
        if (!i) throw new c.a("fileuploader-missing-api-address", null);
        this.file = function (e) {
          if ("string" != typeof e) return !1;
          var t = e.match(Aw);
          return !(!t || !t.length);
        }(e) ? function (e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 512;

          try {
            var _i340 = e.match(Aw)[1],
                _n205 = atob(e.replace(Aw, "")),
                _o130 = [];

            for (var _e381 = 0; _e381 < _n205.length; _e381 += t) {
              var _i341 = _n205.slice(_e381, _e381 + t),
                  _r82 = new Array(_i341.length);

              for (var _e382 = 0; _e382 < _i341.length; _e382++) {
                _r82[_e382] = _i341.charCodeAt(_e382);
              }

              _o130.push(new Uint8Array(_r82));
            }

            return new Blob(_o130, {
              type: _i340
            });
          } catch (e) {
            throw new c.a("fileuploader-decoding-image-data-error", null);
          }
        }(e) : e, this._token = t, this._apiAddress = i;
      }

      _createClass(Cw, [{
        key: "onProgress",
        value: function onProgress(e) {
          return this.on("progress", function (t, i) {
            return e(i);
          }), this;
        }
      }, {
        key: "onError",
        value: function onError(e) {
          return this.once("error", function (t, i) {
            return e(i);
          }), this;
        }
      }, {
        key: "abort",
        value: function abort() {
          this.xhr.abort();
        }
      }, {
        key: "send",
        value: function send() {
          return this._prepareRequest(), this._attachXHRListeners(), this._sendRequest();
        }
      }, {
        key: "_prepareRequest",
        value: function _prepareRequest() {
          var e = new XMLHttpRequest();
          e.open("POST", this._apiAddress), e.setRequestHeader("Authorization", this._token.value), e.responseType = "json", this.xhr = e;
        }
      }, {
        key: "_attachXHRListeners",
        value: function _attachXHRListeners() {
          var _this300 = this;

          var e = this,
              t = this.xhr;

          function i(t) {
            return function () {
              return e.fire("error", t);
            };
          }

          t.addEventListener("error", i("Network Error")), t.addEventListener("abort", i("Abort")), t.upload && t.upload.addEventListener("progress", function (e) {
            e.lengthComputable && _this300.fire("progress", {
              total: e.total,
              uploaded: e.loaded
            });
          }), t.addEventListener("load", function () {
            var e = t.status,
                i = t.response;
            if (e < 200 || e > 299) return _this300.fire("error", i.message || i.error);
          });
        }
      }, {
        key: "_sendRequest",
        value: function _sendRequest() {
          var _this301 = this;

          var e = new FormData(),
              t = this.xhr;
          return e.append("file", this.file), new Promise(function (i, n) {
            t.addEventListener("load", function () {
              var e = t.status,
                  o = t.response;
              return e < 200 || e > 299 ? o.message ? n(new c.a("fileuploader-uploading-data-failed", _this301, {
                message: o.message
              })) : n(o.error) : i(o);
            }), t.addEventListener("error", function () {
              return n(new Error("Network Error"));
            }), t.addEventListener("abort", function () {
              return n(new Error("Abort"));
            }), t.send(e);
          });
        }
      }]);

      return Cw;
    }();

    Ke(Cw, h);

    var Tw =
    /*#__PURE__*/
    function () {
      function Tw(e, t) {
        _classCallCheck(this, Tw);

        if (!e) throw new c.a("uploadgateway-missing-token", null);
        if (!t) throw new c.a("uploadgateway-missing-api-address", null);
        this._token = e, this._apiAddress = t;
      }

      _createClass(Tw, [{
        key: "upload",
        value: function upload(e) {
          return new Cw(e, this._token, this._apiAddress);
        }
      }]);

      return Tw;
    }();

    var Ew =
    /*#__PURE__*/
    function (_an3) {
      _inherits(Ew, _an3);

      function Ew() {
        _classCallCheck(this, Ew);

        return _possibleConstructorReturn(this, _getPrototypeOf(Ew).apply(this, arguments));
      }

      _createClass(Ew, [{
        key: "createToken",
        value: function createToken(e, t) {
          return new xw(e, t);
        }
      }, {
        key: "createUploadGateway",
        value: function createUploadGateway(e, t) {
          return new Tw(e, t);
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "CloudServicesCore";
        }
      }]);

      return Ew;
    }(an);

    function Sw(e) {
      var t = [{
        name: "address",
        isVoid: !1
      }, {
        name: "article",
        isVoid: !1
      }, {
        name: "aside",
        isVoid: !1
      }, {
        name: "blockquote",
        isVoid: !1
      }, {
        name: "br",
        isVoid: !0
      }, {
        name: "details",
        isVoid: !1
      }, {
        name: "dialog",
        isVoid: !1
      }, {
        name: "dd",
        isVoid: !1
      }, {
        name: "div",
        isVoid: !1
      }, {
        name: "dl",
        isVoid: !1
      }, {
        name: "dt",
        isVoid: !1
      }, {
        name: "fieldset",
        isVoid: !1
      }, {
        name: "figcaption",
        isVoid: !1
      }, {
        name: "figure",
        isVoid: !1
      }, {
        name: "footer",
        isVoid: !1
      }, {
        name: "form",
        isVoid: !1
      }, {
        name: "h1",
        isVoid: !1
      }, {
        name: "h2",
        isVoid: !1
      }, {
        name: "h3",
        isVoid: !1
      }, {
        name: "h4",
        isVoid: !1
      }, {
        name: "h5",
        isVoid: !1
      }, {
        name: "h6",
        isVoid: !1
      }, {
        name: "header",
        isVoid: !1
      }, {
        name: "hgroup",
        isVoid: !1
      }, {
        name: "hr",
        isVoid: !0
      }, {
        name: "input",
        isVoid: !0
      }, {
        name: "li",
        isVoid: !1
      }, {
        name: "main",
        isVoid: !1
      }, {
        name: "nav",
        isVoid: !1
      }, {
        name: "ol",
        isVoid: !1
      }, {
        name: "p",
        isVoid: !1
      }, {
        name: "pre",
        isVoid: !1
      }, {
        name: "section",
        isVoid: !1
      }, {
        name: "table",
        isVoid: !1
      }, {
        name: "tbody",
        isVoid: !1
      }, {
        name: "td",
        isVoid: !1
      }, {
        name: "textarea",
        isVoid: !1
      }, {
        name: "th",
        isVoid: !1
      }, {
        name: "thead",
        isVoid: !1
      }, {
        name: "tr",
        isVoid: !1
      }, {
        name: "ul",
        isVoid: !1
      }],
          i = t.map(function (e) {
        return e.name;
      }).join("|"),
          n = e.replace(new RegExp("</?(".concat(i, ")( .*?)?>"), "g"), "\n$&\n").split("\n");
      var o = 0;
      return n.filter(function (e) {
        return e.length;
      }).map(function (e) {
        return function (e, t) {
          return t.some(function (t) {
            return !t.isVoid && !!new RegExp("<".concat(t.name, "( .*?)?>")).test(e);
          });
        }(e, t) ? Iw(e, o++) : function (e, t) {
          return t.some(function (t) {
            return new RegExp("</".concat(t.name, ">")).test(e);
          });
        }(e, t) ? Iw(e, --o) : Iw(e, o);
      }).join("\n");
    }

    function Iw(e, t) {
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "    ";
      return "".concat(i.repeat(t)).concat(e);
    }

    i(108);

    function Pw(e) {
      return function (e) {
        return e.startsWith("<");
      }(e) ? Sw(e) : e;
    }

    var Mw =
    /*#__PURE__*/
    function (_wh) {
      _inherits(Mw, _wh);

      function Mw() {
        _classCallCheck(this, Mw);

        return _possibleConstructorReturn(this, _getPrototypeOf(Mw).apply(this, arguments));
      }

      return Mw;
    }(wh);

    Mw.builtinPlugins = [
    /*#__PURE__*/
    function (_Qe68) {
      _inherits(_class3, _Qe68);

      function _class3() {
        _classCallCheck(this, _class3);

        return _possibleConstructorReturn(this, _getPrototypeOf(_class3).apply(this, arguments));
      }

      _createClass(_class3, null, [{
        key: "requires",
        get: function get() {
          return [hu, Eh, vu, fu, Iu, og];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "Essentials";
        }
      }]);

      return _class3;
    }(Qe),
    /*#__PURE__*/
    function (_Qe69) {
      _inherits(_class4, _Qe69);

      function _class4() {
        _classCallCheck(this, _class4);

        return _possibleConstructorReturn(this, _getPrototypeOf(_class4).apply(this, arguments));
      }

      _createClass(_class4, [{
        key: "init",
        value: function init() {
          var _this302 = this;

          var e = this.editor.config.get("ckfinder.uploadUrl");
          e && (this.editor.plugins.get(sg).createUploadAdapter = function (t) {
            return new hg(t, e, _this302.editor.t);
          });
        }
      }], [{
        key: "requires",
        get: function get() {
          return [sg];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "CKFinderUploadAdapter";
        }
      }]);

      return _class4;
    }(Qe),
    /*#__PURE__*/
    function (_Qe70) {
      _inherits(_class5, _Qe70);

      function _class5() {
        _classCallCheck(this, _class5);

        return _possibleConstructorReturn(this, _getPrototypeOf(_class5).apply(this, arguments));
      }

      _createClass(_class5, [{
        key: "afterInit",
        value: function afterInit() {
          this._addListAutoformats(), this._addBasicStylesAutoformats(), this._addHeadingAutoformats(), this._addBlockQuoteAutoformats(), this._addCodeBlockAutoformats(), this._addHorizontalLineAutoformats();
        }
      }, {
        key: "_addListAutoformats",
        value: function _addListAutoformats() {
          var _this303 = this;

          var e = this.editor.commands;
          e.get("bulletedList") && ug(this.editor, this, /^[*-]\s$/, "bulletedList"), e.get("numberedList") && ug(this.editor, this, /^1[.|)]\s$/, "numberedList"), e.get("todoList") && ug(this.editor, this, /^\[\s?\]\s$/, "todoList"), e.get("checkTodoList") && ug(this.editor, this, /^\[\s?x\s?\]\s$/, function () {
            _this303.editor.execute("todoList"), _this303.editor.execute("checkTodoList");
          });
        }
      }, {
        key: "_addBasicStylesAutoformats",
        value: function _addBasicStylesAutoformats() {
          var e = this.editor.commands;

          if (e.get("bold")) {
            var _e383 = fg(this.editor, "bold");

            gg(this.editor, this, /(?:^|\s)(\*\*)([^*]+)(\*\*)$/g, _e383), gg(this.editor, this, /(?:^|\s)(__)([^_]+)(__)$/g, _e383);
          }

          if (e.get("italic")) {
            var _e384 = fg(this.editor, "italic");

            gg(this.editor, this, /(?:^|\s)(\*)([^*_]+)(\*)$/g, _e384), gg(this.editor, this, /(?:^|\s)(_)([^_]+)(_)$/g, _e384);
          }

          if (e.get("code")) {
            var _e385 = fg(this.editor, "code");

            gg(this.editor, this, /(`)([^`]+)(`)$/g, _e385);
          }

          if (e.get("strikethrough")) {
            var _e386 = fg(this.editor, "strikethrough");

            gg(this.editor, this, /(~~)([^~]+)(~~)$/g, _e386);
          }
        }
      }, {
        key: "_addHeadingAutoformats",
        value: function _addHeadingAutoformats() {
          var _this304 = this;

          var e = this.editor.commands.get("heading");
          e && e.modelElements.filter(function (e) {
            return e.match(/^heading[1-6]$/);
          }).forEach(function (t) {
            var i = t[7],
                n = new RegExp("^(#{".concat(i, "})\\s$"));
            ug(_this304.editor, _this304, n, function () {
              if (!e.isEnabled || e.value === t) return !1;

              _this304.editor.execute("heading", {
                value: t
              });
            });
          });
        }
      }, {
        key: "_addBlockQuoteAutoformats",
        value: function _addBlockQuoteAutoformats() {
          this.editor.commands.get("blockQuote") && ug(this.editor, this, /^>\s$/, "blockQuote");
        }
      }, {
        key: "_addCodeBlockAutoformats",
        value: function _addCodeBlockAutoformats() {
          this.editor.commands.get("codeBlock") && ug(this.editor, this, /^```$/, "codeBlock");
        }
      }, {
        key: "_addHorizontalLineAutoformats",
        value: function _addHorizontalLineAutoformats() {
          this.editor.commands.get("horizontalLine") && ug(this.editor, this, /^---$/, "horizontalLine");
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "Autoformat";
        }
      }]);

      return _class5;
    }(Qe),
    /*#__PURE__*/
    function (_Qe71) {
      _inherits(_class6, _Qe71);

      function _class6() {
        _classCallCheck(this, _class6);

        return _possibleConstructorReturn(this, _getPrototypeOf(_class6).apply(this, arguments));
      }

      _createClass(_class6, null, [{
        key: "requires",
        get: function get() {
          return [bg, wg];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "Bold";
        }
      }]);

      return _class6;
    }(Qe),
    /*#__PURE__*/
    function (_Qe72) {
      _inherits(_class7, _Qe72);

      function _class7() {
        _classCallCheck(this, _class7);

        return _possibleConstructorReturn(this, _getPrototypeOf(_class7).apply(this, arguments));
      }

      _createClass(_class7, null, [{
        key: "requires",
        get: function get() {
          return [kg, _g];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "Italic";
        }
      }]);

      return _class7;
    }(Qe),
    /*#__PURE__*/
    function (_Qe73) {
      _inherits(_class8, _Qe73);

      function _class8() {
        _classCallCheck(this, _class8);

        return _possibleConstructorReturn(this, _getPrototypeOf(_class8).apply(this, arguments));
      }

      _createClass(_class8, null, [{
        key: "requires",
        get: function get() {
          return [Cg, Tg];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "BlockQuote";
        }
      }]);

      return _class8;
    }(Qe),
    /*#__PURE__*/
    function (_Qe74) {
      _inherits(_class9, _Qe74);

      function _class9() {
        _classCallCheck(this, _class9);

        return _possibleConstructorReturn(this, _getPrototypeOf(_class9).apply(this, arguments));
      }

      _createClass(_class9, null, [{
        key: "pluginName",
        get: function get() {
          return "CKFinder";
        }
      }, {
        key: "requires",
        get: function get() {
          return ["Link", "CKFinderUploadAdapter", Pg, Eg];
        }
      }]);

      return _class9;
    }(Qe),
    /*#__PURE__*/
    function (_an4) {
      _inherits(_class10, _an4);

      function _class10() {
        _classCallCheck(this, _class10);

        return _possibleConstructorReturn(this, _getPrototypeOf(_class10).apply(this, arguments));
      }

      _createClass(_class10, [{
        key: "init",
        value: function init() {
          var e = this.context.config.get("cloudServices") || {};

          for (var _t333 in e) {
            this[_t333] = e[_t333];
          }

          if (this._tokens = new Map(), this.tokenUrl) return this.token = this.context.plugins.get("CloudServicesCore").createToken(this.tokenUrl), this._tokens.set(this.tokenUrl, this.token), this.token.init();
          this.token = null;
        }
      }, {
        key: "registerTokenUrl",
        value: function registerTokenUrl(e) {
          if (this._tokens.has(e)) return Promise.resolve(this.getTokenFor(e));
          var t = this.context.plugins.get("CloudServicesCore").createToken(e);
          return this._tokens.set(e, t), t.init();
        }
      }, {
        key: "getTokenFor",
        value: function getTokenFor(e) {
          var t = this._tokens.get(e);

          if (!t) throw new c.a("cloudservices-token-not-registered", this);
          return t;
        }
      }, {
        key: "destroy",
        value: function destroy() {
          _get(_getPrototypeOf(_class10.prototype), "destroy", this).call(this);

          var _iteratorNormalCompletion466 = true;
          var _didIteratorError466 = false;
          var _iteratorError466 = undefined;

          try {
            for (var _iterator466 = this._tokens.values()[Symbol.iterator](), _step466; !(_iteratorNormalCompletion466 = (_step466 = _iterator466.next()).done); _iteratorNormalCompletion466 = true) {
              var _e387 = _step466.value;

              _e387.destroy();
            }
          } catch (err) {
            _didIteratorError466 = true;
            _iteratorError466 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion466 && _iterator466.return != null) {
                _iterator466.return();
              }
            } finally {
              if (_didIteratorError466) {
                throw _iteratorError466;
              }
            }
          }
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "CloudServices";
        }
      }, {
        key: "requires",
        get: function get() {
          return [Ew];
        }
      }]);

      return _class10;
    }(an),
    /*#__PURE__*/
    function (_Qe75) {
      _inherits(_class11, _Qe75);

      function _class11() {
        _classCallCheck(this, _class11);

        return _possibleConstructorReturn(this, _getPrototypeOf(_class11).apply(this, arguments));
      }

      _createClass(_class11, [{
        key: "init",
        value: function init() {
          var e = this.editor;
          e.plugins.has("ImageBlockEditing") || e.plugins.has("ImageInlineEditing") || Object(c.b)("easy-image-image-feature-missing", e);
        }
      }], [{
        key: "requires",
        get: function get() {
          return [Mg, "ImageUpload"];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "EasyImage";
        }
      }]);

      return _class11;
    }(Qe),
    /*#__PURE__*/
    function (_Qe76) {
      _inherits(_class12, _Qe76);

      function _class12() {
        _classCallCheck(this, _class12);

        return _possibleConstructorReturn(this, _getPrototypeOf(_class12).apply(this, arguments));
      }

      _createClass(_class12, null, [{
        key: "requires",
        get: function get() {
          return [jg, Bg];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "Heading";
        }
      }]);

      return _class12;
    }(Qe),
    /*#__PURE__*/
    function (_Qe77) {
      _inherits(_class13, _Qe77);

      function _class13() {
        _classCallCheck(this, _class13);

        return _possibleConstructorReturn(this, _getPrototypeOf(_class13).apply(this, arguments));
      }

      _createClass(_class13, null, [{
        key: "requires",
        get: function get() {
          return [hm, gm];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "Image";
        }
      }]);

      return _class13;
    }(Qe),
    /*#__PURE__*/
    function (_Qe78) {
      _inherits(_class14, _Qe78);

      function _class14() {
        _classCallCheck(this, _class14);

        return _possibleConstructorReturn(this, _getPrototypeOf(_class14).apply(this, arguments));
      }

      _createClass(_class14, null, [{
        key: "requires",
        get: function get() {
          return [bm, km];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "ImageCaption";
        }
      }]);

      return _class14;
    }(Qe),
    /*#__PURE__*/
    function (_Qe79) {
      _inherits(_class15, _Qe79);

      function _class15() {
        _classCallCheck(this, _class15);

        return _possibleConstructorReturn(this, _getPrototypeOf(_class15).apply(this, arguments));
      }

      _createClass(_class15, null, [{
        key: "requires",
        get: function get() {
          return [Om, zm];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "ImageStyle";
        }
      }]);

      return _class15;
    }(Qe),
    /*#__PURE__*/
    function (_Qe80) {
      _inherits(_class16, _Qe80);

      function _class16() {
        _classCallCheck(this, _class16);

        return _possibleConstructorReturn(this, _getPrototypeOf(_class16).apply(this, arguments));
      }

      _createClass(_class16, [{
        key: "afterInit",
        value: function afterInit() {
          var e = this.editor,
              t = e.t,
              i = e.plugins.get(Fg),
              n = e.plugins.get("ImageUtils");
          var o;
          i.register("image", {
            ariaLabel: t("Image toolbar"),
            items: (o = e.config.get("image.toolbar") || [], o.map(function (e) {
              return w(e) ? e.name : e;
            })),
            getRelatedElement: function getRelatedElement(e) {
              return n.getClosestSelectedImageWidget(e);
            }
          });
        }
      }], [{
        key: "requires",
        get: function get() {
          return [Fg, Jg];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "ImageToolbar";
        }
      }]);

      return _class16;
    }(Qe),
    /*#__PURE__*/
    function (_Qe81) {
      _inherits(_class17, _Qe81);

      function _class17() {
        _classCallCheck(this, _class17);

        return _possibleConstructorReturn(this, _getPrototypeOf(_class17).apply(this, arguments));
      }

      _createClass(_class17, null, [{
        key: "pluginName",
        get: function get() {
          return "ImageUpload";
        }
      }, {
        key: "requires",
        get: function get() {
          return [Qm, Hm, Um];
        }
      }]);

      return _class17;
    }(Qe),
    /*#__PURE__*/
    function (_Qe82) {
      _inherits(_class18, _Qe82);

      function _class18() {
        _classCallCheck(this, _class18);

        return _possibleConstructorReturn(this, _getPrototypeOf(_class18).apply(this, arguments));
      }

      _createClass(_class18, null, [{
        key: "pluginName",
        get: function get() {
          return "Indent";
        }
      }, {
        key: "requires",
        get: function get() {
          return [Zm, tf];
        }
      }]);

      return _class18;
    }(Qe),
    /*#__PURE__*/
    function (_Qe83) {
      _inherits(_class19, _Qe83);

      function _class19() {
        _classCallCheck(this, _class19);

        return _possibleConstructorReturn(this, _getPrototypeOf(_class19).apply(this, arguments));
      }

      _createClass(_class19, null, [{
        key: "requires",
        get: function get() {
          return [Rf, jf, Hf];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "Link";
        }
      }]);

      return _class19;
    }(Qe),
    /*#__PURE__*/
    function (_Qe84) {
      _inherits(_class20, _Qe84);

      function _class20() {
        _classCallCheck(this, _class20);

        return _possibleConstructorReturn(this, _getPrototypeOf(_class20).apply(this, arguments));
      }

      _createClass(_class20, null, [{
        key: "requires",
        get: function get() {
          return [mp, pp];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "List";
        }
      }]);

      return _class20;
    }(Qe),
    /*#__PURE__*/
    function (_Qe85) {
      _inherits(_class21, _Qe85);

      function _class21() {
        _classCallCheck(this, _class21);

        return _possibleConstructorReturn(this, _getPrototypeOf(_class21).apply(this, arguments));
      }

      _createClass(_class21, null, [{
        key: "requires",
        get: function get() {
          return [Ap, Sp, Tp, iu];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "MediaEmbed";
        }
      }]);

      return _class21;
    }(Qe), Dg,
    /*#__PURE__*/
    function (_Qe86) {
      _inherits(_class22, _Qe86);

      function _class22() {
        _classCallCheck(this, _class22);

        return _possibleConstructorReturn(this, _getPrototypeOf(_class22).apply(this, arguments));
      }

      _createClass(_class22, [{
        key: "init",
        value: function init() {
          var e = this.editor,
              t = e.editing.view.document,
              i = [];
          i.push(new Bp(t)), i.push(new Op(t)), e.plugins.get("ClipboardPipeline").on("inputTransformation", function (e, t) {
            if (t.isTransformedWithPasteFromOffice) return;
            var n = t.dataTransfer.getData("text/html"),
                o = i.find(function (e) {
              return e.isActive(n);
            });
            o && (o.execute(t), t.isTransformedWithPasteFromOffice = !0);
          }, {
            priority: "high"
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "PasteFromOffice";
        }
      }, {
        key: "requires",
        get: function get() {
          return [yh];
        }
      }]);

      return _class22;
    }(Qe),
    /*#__PURE__*/
    function (_Qe87) {
      _inherits(_class23, _Qe87);

      function _class23() {
        _classCallCheck(this, _class23);

        return _possibleConstructorReturn(this, _getPrototypeOf(_class23).apply(this, arguments));
      }

      _createClass(_class23, null, [{
        key: "requires",
        get: function get() {
          return [ow, aw, lw, pw, mw, dw, iu];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "Table";
        }
      }]);

      return _class23;
    }(Qe),
    /*#__PURE__*/
    function (_Qe88) {
      _inherits(_class24, _Qe88);

      function _class24() {
        _classCallCheck(this, _class24);

        return _possibleConstructorReturn(this, _getPrototypeOf(_class24).apply(this, arguments));
      }

      _createClass(_class24, [{
        key: "afterInit",
        value: function afterInit() {
          var e = this.editor,
              t = e.t,
              i = e.plugins.get(Fg),
              n = e.config.get("table.contentToolbar"),
              o = e.config.get("table.tableToolbar");
          n && i.register("tableContent", {
            ariaLabel: t("Table toolbar"),
            items: n,
            getRelatedElement: kw
          }), o && i.register("table", {
            ariaLabel: t("Table toolbar"),
            items: o,
            getRelatedElement: ww
          });
        }
      }], [{
        key: "requires",
        get: function get() {
          return [Fg];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "TableToolbar";
        }
      }]);

      return _class24;
    }(Qe),
    /*#__PURE__*/
    function (_Qe89) {
      _inherits(_class25, _Qe89);

      _createClass(_class25, null, [{
        key: "pluginName",
        get: function get() {
          return "TextTransformation";
        }
      }]);

      function _class25(e) {
        var _this305;

        _classCallCheck(this, _class25);

        _this305 = _possibleConstructorReturn(this, _getPrototypeOf(_class25).call(this, e)), e.config.define("typing", {
          transformations: {
            include: Hu
          }
        });
        return _this305;
      }

      _createClass(_class25, [{
        key: "init",
        value: function init() {
          var _this306 = this;

          var e = this.editor.model.document.selection;
          e.on("change:range", function () {
            _this306.isEnabled = !e.anchor.parent.is("element", "codeBlock");
          }), this._enableTransformationWatchers();
        }
      }, {
        key: "_enableTransformationWatchers",
        value: function _enableTransformationWatchers() {
          var e = this.editor,
              t = e.model,
              i = e.plugins.get("Input"),
              n = function (e) {
            var t = e.extra || [],
                i = e.remove || [],
                n = function n(e) {
              return !i.includes(e);
            };

            return function (e) {
              var t = new Set();
              var _iteratorNormalCompletion467 = true;
              var _didIteratorError467 = false;
              var _iteratorError467 = undefined;

              try {
                for (var _iterator467 = e[Symbol.iterator](), _step467; !(_iteratorNormalCompletion467 = (_step467 = _iterator467.next()).done); _iteratorNormalCompletion467 = true) {
                  var _i342 = _step467.value;

                  if (Fu[_i342]) {
                    var _iteratorNormalCompletion468 = true;
                    var _didIteratorError468 = false;
                    var _iteratorError468 = undefined;

                    try {
                      for (var _iterator468 = Fu[_i342][Symbol.iterator](), _step468; !(_iteratorNormalCompletion468 = (_step468 = _iterator468.next()).done); _iteratorNormalCompletion468 = true) {
                        var _e388 = _step468.value;
                        t.add(_e388);
                      }
                    } catch (err) {
                      _didIteratorError468 = true;
                      _iteratorError468 = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion468 && _iterator468.return != null) {
                          _iterator468.return();
                        }
                      } finally {
                        if (_didIteratorError468) {
                          throw _iteratorError468;
                        }
                      }
                    }
                  } else t.add(_i342);
                }
              } catch (err) {
                _didIteratorError467 = true;
                _iteratorError467 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion467 && _iterator467.return != null) {
                    _iterator467.return();
                  }
                } finally {
                  if (_didIteratorError467) {
                    throw _iteratorError467;
                  }
                }
              }

              return Array.from(t);
            }(e.include.concat(t).filter(n)).filter(n).map(function (e) {
              return Bu[e] || e;
            }).map(function (e) {
              return {
                from: Uu(e.from),
                to: Wu(e.to)
              };
            });
          }(e.config.get("typing.transformations")),
              o = new Mu(e.model, function (e) {
            var _iteratorNormalCompletion469 = true;
            var _didIteratorError469 = false;
            var _iteratorError469 = undefined;

            try {
              for (var _iterator469 = n[Symbol.iterator](), _step469; !(_iteratorNormalCompletion469 = (_step469 = _iterator469.next()).done); _iteratorNormalCompletion469 = true) {
                var _t334 = _step469.value;
                if (_t334.from.test(e)) return {
                  normalizedTransformation: _t334
                };
              }
            } catch (err) {
              _didIteratorError469 = true;
              _iteratorError469 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion469 && _iterator469.return != null) {
                  _iterator469.return();
                }
              } finally {
                if (_didIteratorError469) {
                  throw _iteratorError469;
                }
              }
            }
          });

          o.on("matched:data", function (e, n) {
            if (!i.isInput(n.batch)) return;
            var _n$normalizedTransfor = n.normalizedTransformation,
                o = _n$normalizedTransfor.from,
                r = _n$normalizedTransfor.to,
                s = o.exec(n.text),
                a = r(s.slice(1)),
                c = n.range;
            var l = s.index;
            t.enqueueChange(function (e) {
              for (var _i343 = 1; _i343 < s.length; _i343++) {
                var _n206 = s[_i343],
                    _o131 = a[_i343 - 1];

                if (null == _o131) {
                  l += _n206.length;
                  continue;
                }

                var _r83 = c.start.getShiftedBy(l),
                    _d10 = t.createRange(_r83, _r83.getShiftedBy(_n206.length)),
                    _h8 = qu(_r83);

                t.insertContent(e.createText(_o131, _h8), _d10), l += _o131.length;
              }
            });
          }), o.bind("isEnabled").to(this);
        }
      }]);

      return _class25;
    }(Qe),
    /*#__PURE__*/
    function (_Qe90) {
      _inherits(_class26, _Qe90);

      _createClass(_class26, null, [{
        key: "pluginName",
        get: function get() {
          return "SourceEditing";
        }
      }, {
        key: "requires",
        get: function get() {
          return [El];
        }
      }]);

      function _class26(e) {
        var _this307;

        _classCallCheck(this, _class26);

        _this307 = _possibleConstructorReturn(this, _getPrototypeOf(_class26).call(this, e)), _this307.set("isSourceEditingMode", !1), _this307._elementReplacer = new ys(), _this307._replacedRoots = new Map(), _this307._dataFromRoots = new Map();
        return _this307;
      }

      _createClass(_class26, [{
        key: "init",
        value: function init() {
          var _this308 = this;

          var e = this.editor,
              t = e.t;
          e.ui.componentFactory.add("sourceEditing", function (i) {
            var n = new id(i);
            return n.set({
              label: t("Source"),
              icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m12.5 0 5 4.5v15.003h-16V0h11zM3 1.5v3.25l-1.497 1-.003 8 1.5 1v3.254L7.685 18l-.001 1.504H17.5V8.002L16 9.428l-.004-4.22-4.222-3.692L3 1.5z"/><path d="M4.06 6.64a.75.75 0 0 1 .958 1.15l-.085.07L2.29 9.75l2.646 1.89c.302.216.4.62.232.951l-.058.095a.75.75 0 0 1-.951.232l-.095-.058-3.5-2.5V9.14l3.496-2.5zm4.194 6.22a.75.75 0 0 1-.958-1.149l.085-.07 2.643-1.89-2.646-1.89a.75.75 0 0 1-.232-.952l.058-.095a.75.75 0 0 1 .95-.232l.096.058 3.5 2.5v1.22l-3.496 2.5zm7.644-.836 2.122 2.122-5.825 5.809-2.125-.005.003-2.116zm2.539-1.847 1.414 1.414a.5.5 0 0 1 0 .707l-1.06 1.06-2.122-2.12 1.061-1.061a.5.5 0 0 1 .707 0z"/></svg>',
              tooltip: !0,
              withText: !0,
              class: "ck-source-editing-button"
            }), n.bind("isOn").to(_this308, "isSourceEditingMode"), n.bind("isEnabled").to(_this308, "isEnabled", e, "isReadOnly", e.plugins.get(El), "hasAny", function (e, t, i) {
              return !!e && !t && !i;
            }), _this308.listenTo(n, "execute", function () {
              _this308.isSourceEditingMode = !_this308.isSourceEditingMode;
            }), n;
          }), this._isAllowedToHandleSourceEditingMode() && (this.on("change:isSourceEditingMode", function (e, t, i) {
            i ? (_this308._showSourceEditing(), _this308._disableCommands()) : (_this308._hideSourceEditing(), _this308._enableCommands());
          }), this.on("change:isEnabled", function (e, t, i) {
            return _this308._handleReadOnlyMode(!i);
          }), this.listenTo(e, "change:isReadOnly", function (e, t, i) {
            return _this308._handleReadOnlyMode(i);
          }));
        }
      }, {
        key: "afterInit",
        value: function afterInit() {
          var e = this.editor;
          ["RealTimeCollaborativeEditing", "CommentsEditing", "TrackChangesEditing", "RevisionHistory"].some(function (t) {
            return e.plugins.has(t);
          }) && console.warn("You initialized the editor with the source editing feature and at least one of the collaboration features. Please be advised that the source editing feature may not work, and be careful when editing document source that contains markers created by the collaboration features.");
        }
      }, {
        key: "_showSourceEditing",
        value: function _showSourceEditing() {
          var _this309 = this;

          var e = this.editor,
              t = e.editing.view,
              i = e.model;
          i.change(function (e) {
            e.setSelection(null), e.removeSelectionAttribute(i.document.selection.getAttributeKeys());
          });
          var _iteratorNormalCompletion470 = true;
          var _didIteratorError470 = false;
          var _iteratorError470 = undefined;

          try {
            var _loop9 = function _loop9() {
              var _ref237 = _step470.value;
              _ref238 = _slicedToArray(_ref237, 2);
              var i = _ref238[0];
              var n = _ref238[1];
              var o = Pw(e.data.get({
                rootName: i
              })),
                  r = As(n.ownerDocument, "textarea", {
                rows: "1"
              }),
                  s = As(n.ownerDocument, "div", {
                class: "ck-source-editing-area",
                "data-value": o
              }, [r]);
              r.value = o, r.addEventListener("input", function () {
                s.dataset.value = r.value;
              }), t.change(function (e) {
                var n = t.document.getRoot(i);
                e.addClass("ck-hidden", n);
              }), _this309._replacedRoots.set(i, s), _this309._elementReplacer.replace(n, s), _this309._dataFromRoots.set(i, o);
            };

            for (var _iterator470 = t.domRoots[Symbol.iterator](), _step470; !(_iteratorNormalCompletion470 = (_step470 = _iterator470.next()).done); _iteratorNormalCompletion470 = true) {
              var _ref238;

              _loop9();
            }
          } catch (err) {
            _didIteratorError470 = true;
            _iteratorError470 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion470 && _iterator470.return != null) {
                _iterator470.return();
              }
            } finally {
              if (_didIteratorError470) {
                throw _iteratorError470;
              }
            }
          }

          this._focusSourceEditing();
        }
      }, {
        key: "_hideSourceEditing",
        value: function _hideSourceEditing() {
          var _this310 = this;

          var e = this.editor,
              t = e.editing.view,
              i = {};
          var _iteratorNormalCompletion471 = true;
          var _didIteratorError471 = false;
          var _iteratorError471 = undefined;

          try {
            var _loop10 = function _loop10() {
              var _ref239 = _step471.value;
              _ref240 = _slicedToArray(_ref239, 2);
              var e = _ref240[0];
              var n = _ref240[1];

              var o = _this310._dataFromRoots.get(e),
                  r = n.dataset.value;

              o !== r && (i[e] = r), t.change(function (i) {
                var n = t.document.getRoot(e);
                i.removeClass("ck-hidden", n);
              });
            };

            for (var _iterator471 = this._replacedRoots[Symbol.iterator](), _step471; !(_iteratorNormalCompletion471 = (_step471 = _iterator471.next()).done); _iteratorNormalCompletion471 = true) {
              var _ref240;

              _loop10();
            }
          } catch (err) {
            _didIteratorError471 = true;
            _iteratorError471 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion471 && _iterator471.return != null) {
                _iterator471.return();
              }
            } finally {
              if (_didIteratorError471) {
                throw _iteratorError471;
              }
            }
          }

          this._elementReplacer.restore(), this._replacedRoots.clear(), this._dataFromRoots.clear(), Object.keys(i).length && e.data.set(i, {
            batchType: "default"
          }), e.editing.view.focus();
        }
      }, {
        key: "_focusSourceEditing",
        value: function _focusSourceEditing() {
          var _this$_replacedRoots$ = this._replacedRoots.values(),
              _this$_replacedRoots$2 = _slicedToArray(_this$_replacedRoots$, 1),
              e = _this$_replacedRoots$2[0];

          e.querySelector("textarea").focus();
        }
      }, {
        key: "_disableCommands",
        value: function _disableCommands() {
          var e = this.editor;
          var _iteratorNormalCompletion472 = true;
          var _didIteratorError472 = false;
          var _iteratorError472 = undefined;

          try {
            for (var _iterator472 = e.commands.commands()[Symbol.iterator](), _step472; !(_iteratorNormalCompletion472 = (_step472 = _iterator472.next()).done); _iteratorNormalCompletion472 = true) {
              var _t335 = _step472.value;

              _t335.forceDisabled("SourceEditingMode");
            }
          } catch (err) {
            _didIteratorError472 = true;
            _iteratorError472 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion472 && _iterator472.return != null) {
                _iterator472.return();
              }
            } finally {
              if (_didIteratorError472) {
                throw _iteratorError472;
              }
            }
          }
        }
      }, {
        key: "_enableCommands",
        value: function _enableCommands() {
          var e = this.editor;
          var _iteratorNormalCompletion473 = true;
          var _didIteratorError473 = false;
          var _iteratorError473 = undefined;

          try {
            for (var _iterator473 = e.commands.commands()[Symbol.iterator](), _step473; !(_iteratorNormalCompletion473 = (_step473 = _iterator473.next()).done); _iteratorNormalCompletion473 = true) {
              var _t336 = _step473.value;

              _t336.clearForceDisabled("SourceEditingMode");
            }
          } catch (err) {
            _didIteratorError473 = true;
            _iteratorError473 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion473 && _iterator473.return != null) {
                _iterator473.return();
              }
            } finally {
              if (_didIteratorError473) {
                throw _iteratorError473;
              }
            }
          }
        }
      }, {
        key: "_handleReadOnlyMode",
        value: function _handleReadOnlyMode(e) {
          if (this.isSourceEditingMode) {
            var _iteratorNormalCompletion474 = true;
            var _didIteratorError474 = false;
            var _iteratorError474 = undefined;

            try {
              for (var _iterator474 = this._replacedRoots[Symbol.iterator](), _step474; !(_iteratorNormalCompletion474 = (_step474 = _iterator474.next()).done); _iteratorNormalCompletion474 = true) {
                var _ref243 = _step474.value;

                var _ref242 = _slicedToArray(_ref243, 2);

                var _t337 = _ref242[1];
                _t337.querySelector("textarea").readOnly = e;
              }
            } catch (err) {
              _didIteratorError474 = true;
              _iteratorError474 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion474 && _iterator474.return != null) {
                  _iterator474.return();
                }
              } finally {
                if (_didIteratorError474) {
                  throw _iteratorError474;
                }
              }
            }
          }
        }
      }, {
        key: "_isAllowedToHandleSourceEditingMode",
        value: function _isAllowedToHandleSourceEditingMode() {
          var e = this.editor.ui.view.editable;
          return e && !e._hasExternalElement;
        }
      }]);

      return _class26;
    }(Qe)], Mw.defaultConfig = {
      toolbar: {
        items: ["heading", "|", "bold", "italic", "link", "bulletedList", "numberedList", "|", "outdent", "indent", "|", "uploadImage", "blockQuote", "insertTable", "mediaEmbed", "undo", "redo", "sourceEditing"]
      },
      image: {
        toolbar: ["imageStyle:inline", "imageStyle:block", "imageStyle:side", "|", "toggleImageCaption", "imageTextAlternative"]
      },
      table: {
        contentToolbar: ["tableColumn", "tableRow", "mergeTableCells"]
      },
      language: "en"
    };
  }]).default;
});